(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire12de"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire12de"] = parcelRequire;
}
parcelRequire.register("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRequire.register("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRequire.register("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("d2lNW", function(module, exports) {
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

module.exports = (parcelRequire("h8vP0"));

});
parcelRequire.register("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c79bde28d689cb05$var$Mg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Ng = null, $c79bde28d689cb05$var$Og = null, $c79bde28d689cb05$var$Pg = null;
function $c79bde28d689cb05$var$Qg() {
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Ng = null;
}
function $c79bde28d689cb05$var$Rg(a) {
    var b = $c79bde28d689cb05$var$Mg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Mg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$Tg(a, b) {
    $c79bde28d689cb05$var$Ng = a;
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$Ug = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$Vg(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Og) {
            if (null === $c79bde28d689cb05$var$Ng) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Og = a;
            $c79bde28d689cb05$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Og.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$Wg = null;
function $c79bde28d689cb05$var$Xg(a) {
    null === $c79bde28d689cb05$var$Wg ? $c79bde28d689cb05$var$Wg = [
        a
    ] : $c79bde28d689cb05$var$Wg.push(a);
}
function $c79bde28d689cb05$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$Zg(a, d);
}
function $c79bde28d689cb05$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$$g = !1;
function $c79bde28d689cb05$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$Zg(a, c);
}
function $c79bde28d689cb05$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$jh = (new $exYeM.Component).refs;
function $c79bde28d689cb05$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$L(), d = $c79bde28d689cb05$var$lh(a), e = $c79bde28d689cb05$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$dh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, d, c), $c79bde28d689cb05$var$eh(b, a, d));
    }
};
function $c79bde28d689cb05$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$ph(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$Vg(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c79bde28d689cb05$var$jh;
    $c79bde28d689cb05$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$Vg(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$nh.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $c79bde28d689cb05$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$sh(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$sh(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$zh(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Bh = $c79bde28d689cb05$var$vh(!0), $c79bde28d689cb05$var$Ch = $c79bde28d689cb05$var$vh(!1), $c79bde28d689cb05$var$Dh = {}, $c79bde28d689cb05$var$Eh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh);
function $c79bde28d689cb05$var$Hh(a) {
    if (a === $c79bde28d689cb05$var$Dh) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$Ih(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Gh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, $c79bde28d689cb05$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, b);
}
function $c79bde28d689cb05$var$Jh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Gh);
}
function $c79bde28d689cb05$var$Kh(a) {
    $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
    var b = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, c));
}
function $c79bde28d689cb05$var$Lh(a) {
    $c79bde28d689cb05$var$Fh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh));
}
var $c79bde28d689cb05$var$M = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nh = [];
function $c79bde28d689cb05$var$Oh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Nh.length; a++)$c79bde28d689cb05$var$Nh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Nh.length = 0;
}
var $c79bde28d689cb05$var$Ph = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Qh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Rh = 0, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$P = null, $c79bde28d689cb05$var$Sh = !1, $c79bde28d689cb05$var$Th = !1, $c79bde28d689cb05$var$Uh = 0, $c79bde28d689cb05$var$Vh = 0;
function $c79bde28d689cb05$var$Q() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Xh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Rh = f;
    $c79bde28d689cb05$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Ph.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Yh : $c79bde28d689cb05$var$Zh;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Th) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$$h;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Th);
    }
    $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
    b = null !== $c79bde28d689cb05$var$O && null !== $c79bde28d689cb05$var$O.next;
    $c79bde28d689cb05$var$Rh = 0;
    $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
    $c79bde28d689cb05$var$Sh = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$bi() {
    var a = 0 !== $c79bde28d689cb05$var$Uh;
    $c79bde28d689cb05$var$Uh = 0;
    return a;
}
function $c79bde28d689cb05$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$di() {
    if (null === $c79bde28d689cb05$var$O) {
        var a = $c79bde28d689cb05$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$O.next;
    var b = null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState : $c79bde28d689cb05$var$P.next;
    if (null !== b) $c79bde28d689cb05$var$P = b, $c79bde28d689cb05$var$O = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$O = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$O.memoizedState,
            baseState: $c79bde28d689cb05$var$O.baseState,
            baseQueue: $c79bde28d689cb05$var$O.baseQueue,
            queue: $c79bde28d689cb05$var$O.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    }
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$N.lanes |= m;
                $c79bde28d689cb05$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$N.lanes |= f, $c79bde28d689cb05$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$gi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$hi() {}
function $c79bde28d689cb05$var$ii(a, b) {
    var c = $c79bde28d689cb05$var$N, d = $c79bde28d689cb05$var$di(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$Ug = !0);
    d = d.queue;
    $c79bde28d689cb05$var$ji($c79bde28d689cb05$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$P && $c79bde28d689cb05$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
}
function $c79bde28d689cb05$var$ki(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
    });
}
function $c79bde28d689cb05$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$pi(a) {
    var b = $c79bde28d689cb05$var$Zg(a, 1);
    null !== b && $c79bde28d689cb05$var$mh(b, a, 1, -1);
}
function $c79bde28d689cb05$var$qi(a) {
    var b = $c79bde28d689cb05$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ri.bind(null, $c79bde28d689cb05$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$si() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$ti(a, b, c, d) {
    var e = $c79bde28d689cb05$var$ci();
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$ui(a, b, c, d) {
    var e = $c79bde28d689cb05$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$O) {
        var g = $c79bde28d689cb05$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Wh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$li(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$vi(a, b) {
    return $c79bde28d689cb05$var$ti(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$ji(a, b) {
    return $c79bde28d689cb05$var$ui(2048, 8, a, b);
}
function $c79bde28d689cb05$var$wi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 2, a, b);
}
function $c79bde28d689cb05$var$xi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 4, a, b);
}
function $c79bde28d689cb05$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$ui(4, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$Ai() {}
function $c79bde28d689cb05$var$Bi(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Ci(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Di(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$Ug = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$N.lanes |= c, $c79bde28d689cb05$var$hh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$Ei(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Qh.transition;
    $c79bde28d689cb05$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Qh.transition = d;
    }
}
function $c79bde28d689cb05$var$Fi() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, c);
    else if (c = $c79bde28d689cb05$var$Yg(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$L();
        $c79bde28d689cb05$var$mh(c, a, d, e);
        $c79bde28d689cb05$var$Ji(c, b, d);
    }
}
function $c79bde28d689cb05$var$ri(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$Yg(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$L(), $c79bde28d689cb05$var$mh(c, a, d, e), $c79bde28d689cb05$var$Ji(c, b, d));
    }
}
function $c79bde28d689cb05$var$Hi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$N || null !== b && b === $c79bde28d689cb05$var$N;
}
function $c79bde28d689cb05$var$Ii(a, b) {
    $c79bde28d689cb05$var$Th = $c79bde28d689cb05$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$ai = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Q,
    useContext: $c79bde28d689cb05$var$Q,
    useEffect: $c79bde28d689cb05$var$Q,
    useImperativeHandle: $c79bde28d689cb05$var$Q,
    useInsertionEffect: $c79bde28d689cb05$var$Q,
    useLayoutEffect: $c79bde28d689cb05$var$Q,
    useMemo: $c79bde28d689cb05$var$Q,
    useReducer: $c79bde28d689cb05$var$Q,
    useRef: $c79bde28d689cb05$var$Q,
    useState: $c79bde28d689cb05$var$Q,
    useDebugValue: $c79bde28d689cb05$var$Q,
    useDeferredValue: $c79bde28d689cb05$var$Q,
    useTransition: $c79bde28d689cb05$var$Q,
    useMutableSource: $c79bde28d689cb05$var$Q,
    useSyncExternalStore: $c79bde28d689cb05$var$Q,
    useId: $c79bde28d689cb05$var$Q,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Yh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ti(4194308, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$Gi.bind(null, $c79bde28d689cb05$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$qi,
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$qi(!1), b = a[0];
        a = $c79bde28d689cb05$var$Ei.bind(null, a[1]);
        $c79bde28d689cb05$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$N, e = $c79bde28d689cb05$var$ci();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$vi($c79bde28d689cb05$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$ci(), b = $c79bde28d689cb05$var$R.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Zh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$fi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$$h = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$gi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return null === $c79bde28d689cb05$var$O ? b.memoizedState = a : $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Oi(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Pi || ($c79bde28d689cb05$var$Pi = !0, $c79bde28d689cb05$var$Qi = d);
        $c79bde28d689cb05$var$Mi(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Ri(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Mi(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Si ? $c79bde28d689cb05$var$Si = new Set([
            this
        ]) : $c79bde28d689cb05$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$ch(-1, 1), b.tag = 2, $c79bde28d689cb05$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Xi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$Ug = !1;
function $c79bde28d689cb05$var$Yi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Ch(b, null, c, d) : $c79bde28d689cb05$var$Bh(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$Tg(b, e);
    d = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$cj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$Ug = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$$i(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$dj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj);
            $c79bde28d689cb05$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= d;
    $c79bde28d689cb05$var$Yi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$dj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$Tg(b, e);
    c = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$Tg(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$jj(a, b), $c79bde28d689cb05$var$ph(b, c, d), $c79bde28d689cb05$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$Vg(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$qh(b, g, d, l);
        $c79bde28d689cb05$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof m && ($c79bde28d689cb05$var$kh(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$Vg(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$qh(b, g, d, k);
        $c79bde28d689cb05$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof y && ($c79bde28d689cb05$var$kh(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$kj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$kj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$$i(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Bh(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Bh(b, null, h, f)) : $c79bde28d689cb05$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$Ih(a, b.containerInfo);
}
function $c79bde28d689cb05$var$mj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Yi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$qj(g, d, 0, null), a = $c79bde28d689cb05$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$oj(c), b.memoizedState = $c79bde28d689cb05$var$nj, a) : $c79bde28d689cb05$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$wh(h, f) : (f = $c79bde28d689cb05$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$rj(a, b) {
    b = $c79bde28d689cb05$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$tj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Bh(b, a.child, null, c);
    a = $c79bde28d689cb05$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$oj(g);
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Li(f, d, void 0);
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$Ug || h) {
        d = $c79bde28d689cb05$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$Zg(a, e), $c79bde28d689cb05$var$mh(d, a, e, -1));
        }
        $c79bde28d689cb05$var$uj();
        d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$Sg(a.return, b, c);
}
function $c79bde28d689cb05$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Yi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$wj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$lj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Kh(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$pj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
                a = $c79bde28d689cb05$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$ej(a, b, c);
    }
    return $c79bde28d689cb05$var$$i(a, b, c);
}
var $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj, $c79bde28d689cb05$var$Dj;
$c79bde28d689cb05$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Bj = function() {};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Ej(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$Jh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Bj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Lh(b);
            var e = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
                $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$M.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$Bj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Ej(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Hj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$M.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$gj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Jj(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Lh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M), null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Kj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Oj = !1;
function $c79bde28d689cb05$var$Pj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Oj;
    $c79bde28d689cb05$var$Oj = !1;
    return n;
}
function $c79bde28d689cb05$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Yj = !1;
function $c79bde28d689cb05$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$ak(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$ak(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Mj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Yj = !0;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Nj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Zj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Zj(a, b, c);
    }
}
function $c79bde28d689cb05$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Lj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Yj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$ak(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$ek(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Qj(3, a, a.return), $c79bde28d689cb05$var$Rj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Qj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            break;
        case 13:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$gk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$fk(a);
    }
}
function $c79bde28d689cb05$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$jk(a, b, c);
}
function $c79bde28d689cb05$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Kj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Kj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$kk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$kk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$jk(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Kj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$lk(a, b, c);
    }
}
function $c79bde28d689cb05$var$lk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Sj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$hk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$mk = Math.ceil, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$pk = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$gj = 0, $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$qk = null, $c79bde28d689cb05$var$hh = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = 0, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$gk = 0, $c79bde28d689cb05$var$Hj = Infinity, $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Pi = !1, $c79bde28d689cb05$var$Qi = null, $c79bde28d689cb05$var$Si = null, $c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = null, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, $c79bde28d689cb05$var$Bk = -1, $c79bde28d689cb05$var$Ck = 0;
function $c79bde28d689cb05$var$L() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Bk ? $c79bde28d689cb05$var$Bk : $c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Ck && ($c79bde28d689cb05$var$Ck = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Ck;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$mh(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$zk) throw $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$R) a === $c79bde28d689cb05$var$R && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$rk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Ek(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Ek(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Fk.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Fk.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Gk(c, $c79bde28d689cb05$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Hk(a, b) {
    $c79bde28d689cb05$var$Bk = -1;
    $c79bde28d689cb05$var$Ck = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Ik() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Jk(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Kk();
        if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Lk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Mk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Nk(a, h);
        }
        $c79bde28d689cb05$var$Qg();
        $c79bde28d689cb05$var$nk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Ok(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Pk(e) && (b = $c79bde28d689cb05$var$Jk(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Ok(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$gk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Hk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Ok(a, b) {
    var c = $c79bde28d689cb05$var$tk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Lk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Jk(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$uk = c, null !== b && $c79bde28d689cb05$var$Gj(b));
    return a;
}
function $c79bde28d689cb05$var$Gj(a) {
    null === $c79bde28d689cb05$var$uk ? $c79bde28d689cb05$var$uk = a : $c79bde28d689cb05$var$uk.push.apply($c79bde28d689cb05$var$uk, a);
}
function $c79bde28d689cb05$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Dk(a, b) {
    b &= ~$c79bde28d689cb05$var$sk;
    b &= ~$c79bde28d689cb05$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Fk(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Ok(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, b), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Rk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Sk(a) {
    null !== $c79bde28d689cb05$var$xk && 0 === $c79bde28d689cb05$var$xk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$pk.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$pk.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Ij() {
    $c79bde28d689cb05$var$gj = $c79bde28d689cb05$var$fj.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$fj);
}
function $c79bde28d689cb05$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$Jh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Oh();
                break;
            case 5:
                $c79bde28d689cb05$var$Lh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$Jh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 10:
                $c79bde28d689cb05$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Ij();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$R = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$wh(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$gj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$qk = null;
    $c79bde28d689cb05$var$sk = $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$hh = 0;
    $c79bde28d689cb05$var$uk = $c79bde28d689cb05$var$tk = null;
    if (null !== $c79bde28d689cb05$var$Wg) {
        for(b = 0; b < $c79bde28d689cb05$var$Wg.length; b++)if (c = $c79bde28d689cb05$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$Wg = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$Qg();
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
            if ($c79bde28d689cb05$var$Sh) {
                for(var d = $c79bde28d689cb05$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Sh = !1;
            }
            $c79bde28d689cb05$var$Rh = 0;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            $c79bde28d689cb05$var$ok.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$qk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Ti(f, l, b);
                            $c79bde28d689cb05$var$uj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Wi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ki(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = [
                    f
                ] : $c79bde28d689cb05$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Oi(f, k, b);
                            $c79bde28d689cb05$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Ri(f, h, b);
                                $c79bde28d689cb05$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Tk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Kk() {
    var a = $c79bde28d689cb05$var$nk.current;
    $c79bde28d689cb05$var$nk.current = $c79bde28d689cb05$var$ai;
    return null === a ? $c79bde28d689cb05$var$ai : a;
}
function $c79bde28d689cb05$var$uj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$R || 0 === ($c79bde28d689cb05$var$hh & 268435455) && 0 === ($c79bde28d689cb05$var$rk & 268435455) || $c79bde28d689cb05$var$Dk($c79bde28d689cb05$var$R, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Jk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Kk();
    if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Lk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Uk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Nk(a, e);
    }
    $c79bde28d689cb05$var$Qg();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$nk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$R = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Uk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Mk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Vk(a) {
    var b = $c79bde28d689cb05$var$Wk(a.alternate, a, $c79bde28d689cb05$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Tk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$ok.current = null;
}
function $c79bde28d689cb05$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Fj(c, b, $c79bde28d689cb05$var$gj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Qk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$pk.transition;
    try {
        $c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Xk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$pk.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Xk(a, b, c, d) {
    do $c79bde28d689cb05$var$Ik();
    while (null !== $c79bde28d689cb05$var$xk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$R && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$wk || ($c79bde28d689cb05$var$wk = !0, $c79bde28d689cb05$var$Gk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$pk.transition;
        $c79bde28d689cb05$var$pk.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$ok.current = null;
        $c79bde28d689cb05$var$Pj(a, c);
        $c79bde28d689cb05$var$ek(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$ik(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$pk.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$wk && ($c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = a, $c79bde28d689cb05$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Si = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Pi) throw $c79bde28d689cb05$var$Pi = !1, a = $c79bde28d689cb05$var$Qi, $c79bde28d689cb05$var$Qi = null, a;
    0 !== ($c79bde28d689cb05$var$yk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$zk++ : ($c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = a) : $c79bde28d689cb05$var$zk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Ik() {
    if (null !== $c79bde28d689cb05$var$xk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$yk), b = $c79bde28d689cb05$var$pk.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$pk.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$xk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$xk;
                $c79bde28d689cb05$var$xk = null;
                $c79bde28d689cb05$var$yk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Tj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$pk.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Yk(a, b, c) {
    b = $c79bde28d689cb05$var$Ki(c, b);
    b = $c79bde28d689cb05$var$Oi(a, b, 1);
    a = $c79bde28d689cb05$var$dh(a, b, 1);
    b = $c79bde28d689cb05$var$L();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Ek(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(d))) {
                a = $c79bde28d689cb05$var$Ki(c, a);
                a = $c79bde28d689cb05$var$Ri(b, a, 1);
                b = $c79bde28d689cb05$var$dh(b, a, 1);
                a = $c79bde28d689cb05$var$L();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$R === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$gk ? $c79bde28d689cb05$var$Lk(a, 0) : $c79bde28d689cb05$var$sk |= c);
    $c79bde28d689cb05$var$Ek(a, b);
}
function $c79bde28d689cb05$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$L();
    a = $c79bde28d689cb05$var$Zg(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Ek(a, c));
}
function $c79bde28d689cb05$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Zk(a, c);
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Zk(a, c);
}
var $c79bde28d689cb05$var$Wk;
$c79bde28d689cb05$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$zj(a, b, c);
            $c79bde28d689cb05$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$jj(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$Tg(b, c);
            e = $c79bde28d689cb05$var$Xh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$ah(b), e.updater = $c79bde28d689cb05$var$nh, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$rh(b, d, a, c), b = $c79bde28d689cb05$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$$k(d);
                a = $c79bde28d689cb05$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$aj(null, b, d, $c79bde28d689cb05$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$lj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$bh(a, b);
                $c79bde28d689cb05$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$$i(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Kh(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$hj(a, b), $c79bde28d689cb05$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$pj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Bh(b, null, d, c) : $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$Zi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$Tg(b, c), e = $c79bde28d689cb05$var$Vg(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Lg(d, b.pendingProps), e = $c79bde28d689cb05$var$Lg(d.type, e), $c79bde28d689cb05$var$aj(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$jj(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$Tg(b, c), $c79bde28d689cb05$var$ph(b, d, e), $c79bde28d689cb05$var$rh(b, d, e, c), $c79bde28d689cb05$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$yj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$ej(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Gk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$al(a, b, c, d);
}
function $c79bde28d689cb05$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$$k(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Ah(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Ah(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$qj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$xh(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$zh(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$ah(f);
    return a;
}
function $c79bde28d689cb05$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$el(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$el(null);
    c = a.current;
    d = $c79bde28d689cb05$var$L();
    e = $c79bde28d689cb05$var$lh(c);
    f = $c79bde28d689cb05$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$dh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Ek(a, d);
    return a;
}
function $c79bde28d689cb05$var$gl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$L(), g = $c79bde28d689cb05$var$lh(e);
    c = $c79bde28d689cb05$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$dh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$mh(a, e, g, f), $c79bde28d689cb05$var$eh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$jl(a, b) {
    $c79bde28d689cb05$var$il(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$il(a, b);
}
function $c79bde28d689cb05$var$kl() {
    return null;
}
var $c79bde28d689cb05$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.render = $c79bde28d689cb05$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$gl(a, b, null, null);
};
$c79bde28d689cb05$var$nl.prototype.unmount = $c79bde28d689cb05$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Sk(function() {
            $c79bde28d689cb05$var$gl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$nl(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$ql() {}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$fl(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$ql);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$hl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$cl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$ql);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$gl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$gl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$rl(c, b, a, e, d);
    return $c79bde28d689cb05$var$hl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Ek(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Sk(function() {
                var b = $c79bde28d689cb05$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$L();
                    $c79bde28d689cb05$var$mh(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$jl(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$jl(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$lh(a), c = $c79bde28d689cb05$var$Zg(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(c, a, b, d);
        }
        $c79bde28d689cb05$var$jl(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Sk;
var $c79bde28d689cb05$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Rk
    ]
}, $c79bde28d689cb05$var$ul = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$vl = {
    bundleType: $c79bde28d689cb05$var$ul.bundleType,
    version: $c79bde28d689cb05$var$ul.version,
    rendererPackageName: $c79bde28d689cb05$var$ul.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$ul.findFiberByHostInstance || $c79bde28d689cb05$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$wl.isDisabled && $c79bde28d689cb05$var$wl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$wl.inject($c79bde28d689cb05$var$vl), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$wl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$tl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$dl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Sk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$nl(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$pl(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$pl(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$sl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRequire.register("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});




parcelRequire.register("beWdq", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $82ee28eaccf33045$export$2b8d127b894957b9; }, function (v) { return $82ee28eaccf33045$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $82ee28eaccf33045$export$cea3a54a6425200c; }, function (v) { return $82ee28eaccf33045$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $82ee28eaccf33045$export$a7c73072b1a182ae; }, function (v) { return $82ee28eaccf33045$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $82ee28eaccf33045$export$9f27bc3417b4524d; }, function (v) { return $82ee28eaccf33045$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $82ee28eaccf33045$export$db77ccec0bb4ccac; }, function (v) { return $82ee28eaccf33045$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $82ee28eaccf33045$export$8392c0c9d3dcbd35; }, function (v) { return $82ee28eaccf33045$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $82ee28eaccf33045$export$ffb0004e005737fa; }, function (v) { return $82ee28eaccf33045$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $82ee28eaccf33045$export$b624eff549462981; }, function (v) { return $82ee28eaccf33045$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $82ee28eaccf33045$export$7897aa7841a5380c; }, function (v) { return $82ee28eaccf33045$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $82ee28eaccf33045$export$602eac185826482c; }, function (v) { return $82ee28eaccf33045$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $82ee28eaccf33045$export$e2c29f18771995cb; }, function (v) { return $82ee28eaccf33045$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $82ee28eaccf33045$export$5f8d39834fd61797; }, function (v) { return $82ee28eaccf33045$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $82ee28eaccf33045$export$74bf444e3cd11ea5; }, function (v) { return $82ee28eaccf33045$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $82ee28eaccf33045$export$92387174baf9b227; }, function (v) { return $82ee28eaccf33045$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $82ee28eaccf33045$export$ec112efeb987d9c6; }, function (v) { return $82ee28eaccf33045$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $82ee28eaccf33045$export$b706b080d889d2c9; }, function (v) { return $82ee28eaccf33045$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $82ee28eaccf33045$export$5be5a87408f70ddc; }, function (v) { return $82ee28eaccf33045$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $82ee28eaccf33045$export$45a5e7f76e0caa8d; }, function (v) { return $82ee28eaccf33045$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $82ee28eaccf33045$export$455c2e768291efa6; }, function (v) { return $82ee28eaccf33045$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $82ee28eaccf33045$export$9522e17588c12572; }, function (v) { return $82ee28eaccf33045$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $82ee28eaccf33045$export$2110ac352bb060b9; }, function (v) { return $82ee28eaccf33045$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $82ee28eaccf33045$export$56885ab8b9c456ab; }, function (v) { return $82ee28eaccf33045$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $82ee28eaccf33045$export$d927fcb6adf8f9de; }, function (v) { return $82ee28eaccf33045$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $82ee28eaccf33045$export$b82d16f27459e05a; }, function (v) { return $82ee28eaccf33045$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $82ee28eaccf33045$export$522c17b4f5e123e8; }, function (v) { return $82ee28eaccf33045$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $82ee28eaccf33045$export$1aabd8a0274ecfd6; }, function (v) { return $82ee28eaccf33045$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $82ee28eaccf33045$export$9b621391a187a31a; }, function (v) { return $82ee28eaccf33045$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $82ee28eaccf33045$export$f5bbd400c2f4426f; }, function (v) { return $82ee28eaccf33045$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $82ee28eaccf33045$export$2b8d127b894957b9;
var $82ee28eaccf33045$export$cea3a54a6425200c;
var $82ee28eaccf33045$export$a7c73072b1a182ae;
var $82ee28eaccf33045$export$9f27bc3417b4524d;
var $82ee28eaccf33045$export$db77ccec0bb4ccac;
var $82ee28eaccf33045$export$8392c0c9d3dcbd35;
var $82ee28eaccf33045$export$ffb0004e005737fa;
var $82ee28eaccf33045$export$b624eff549462981;
var $82ee28eaccf33045$export$7897aa7841a5380c;
var $82ee28eaccf33045$export$602eac185826482c;
var $82ee28eaccf33045$export$e2c29f18771995cb;
var $82ee28eaccf33045$export$5f8d39834fd61797;
var $82ee28eaccf33045$export$74bf444e3cd11ea5;
var $82ee28eaccf33045$export$92387174baf9b227;
var $82ee28eaccf33045$export$ec112efeb987d9c6;
var $82ee28eaccf33045$export$b706b080d889d2c9;
var $82ee28eaccf33045$export$5be5a87408f70ddc;
var $82ee28eaccf33045$export$45a5e7f76e0caa8d;
var $82ee28eaccf33045$export$455c2e768291efa6;
var $82ee28eaccf33045$export$9522e17588c12572;
var $82ee28eaccf33045$export$2110ac352bb060b9;
var $82ee28eaccf33045$export$56885ab8b9c456ab;
var $82ee28eaccf33045$export$d927fcb6adf8f9de;
var $82ee28eaccf33045$export$b82d16f27459e05a;
var $82ee28eaccf33045$export$522c17b4f5e123e8;
var $82ee28eaccf33045$export$1aabd8a0274ecfd6;
var $82ee28eaccf33045$export$9b621391a187a31a;
var $82ee28eaccf33045$export$f5bbd400c2f4426f;
"use strict";
var $82ee28eaccf33045$var$b = "function" === typeof Symbol && Symbol.for, $82ee28eaccf33045$var$c = $82ee28eaccf33045$var$b ? Symbol.for("react.element") : 60103, $82ee28eaccf33045$var$d = $82ee28eaccf33045$var$b ? Symbol.for("react.portal") : 60106, $82ee28eaccf33045$var$e = $82ee28eaccf33045$var$b ? Symbol.for("react.fragment") : 60107, $82ee28eaccf33045$var$f = $82ee28eaccf33045$var$b ? Symbol.for("react.strict_mode") : 60108, $82ee28eaccf33045$var$g = $82ee28eaccf33045$var$b ? Symbol.for("react.profiler") : 60114, $82ee28eaccf33045$var$h = $82ee28eaccf33045$var$b ? Symbol.for("react.provider") : 60109, $82ee28eaccf33045$var$k = $82ee28eaccf33045$var$b ? Symbol.for("react.context") : 60110, $82ee28eaccf33045$var$l = $82ee28eaccf33045$var$b ? Symbol.for("react.async_mode") : 60111, $82ee28eaccf33045$var$m = $82ee28eaccf33045$var$b ? Symbol.for("react.concurrent_mode") : 60111, $82ee28eaccf33045$var$n = $82ee28eaccf33045$var$b ? Symbol.for("react.forward_ref") : 60112, $82ee28eaccf33045$var$p = $82ee28eaccf33045$var$b ? Symbol.for("react.suspense") : 60113, $82ee28eaccf33045$var$q = $82ee28eaccf33045$var$b ? Symbol.for("react.suspense_list") : 60120, $82ee28eaccf33045$var$r = $82ee28eaccf33045$var$b ? Symbol.for("react.memo") : 60115, $82ee28eaccf33045$var$t = $82ee28eaccf33045$var$b ? Symbol.for("react.lazy") : 60116, $82ee28eaccf33045$var$v = $82ee28eaccf33045$var$b ? Symbol.for("react.block") : 60121, $82ee28eaccf33045$var$w = $82ee28eaccf33045$var$b ? Symbol.for("react.fundamental") : 60117, $82ee28eaccf33045$var$x = $82ee28eaccf33045$var$b ? Symbol.for("react.responder") : 60118, $82ee28eaccf33045$var$y = $82ee28eaccf33045$var$b ? Symbol.for("react.scope") : 60119;
function $82ee28eaccf33045$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $82ee28eaccf33045$var$c:
                switch(a = a.type, a){
                    case $82ee28eaccf33045$var$l:
                    case $82ee28eaccf33045$var$m:
                    case $82ee28eaccf33045$var$e:
                    case $82ee28eaccf33045$var$g:
                    case $82ee28eaccf33045$var$f:
                    case $82ee28eaccf33045$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $82ee28eaccf33045$var$k:
                            case $82ee28eaccf33045$var$n:
                            case $82ee28eaccf33045$var$t:
                            case $82ee28eaccf33045$var$r:
                            case $82ee28eaccf33045$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $82ee28eaccf33045$var$d:
                return u;
        }
    }
}
function $82ee28eaccf33045$var$A(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$m;
}
$82ee28eaccf33045$export$2b8d127b894957b9 = $82ee28eaccf33045$var$l;
$82ee28eaccf33045$export$cea3a54a6425200c = $82ee28eaccf33045$var$m;
$82ee28eaccf33045$export$a7c73072b1a182ae = $82ee28eaccf33045$var$k;
$82ee28eaccf33045$export$9f27bc3417b4524d = $82ee28eaccf33045$var$h;
$82ee28eaccf33045$export$db77ccec0bb4ccac = $82ee28eaccf33045$var$c;
$82ee28eaccf33045$export$8392c0c9d3dcbd35 = $82ee28eaccf33045$var$n;
$82ee28eaccf33045$export$ffb0004e005737fa = $82ee28eaccf33045$var$e;
$82ee28eaccf33045$export$b624eff549462981 = $82ee28eaccf33045$var$t;
$82ee28eaccf33045$export$7897aa7841a5380c = $82ee28eaccf33045$var$r;
$82ee28eaccf33045$export$602eac185826482c = $82ee28eaccf33045$var$d;
$82ee28eaccf33045$export$e2c29f18771995cb = $82ee28eaccf33045$var$g;
$82ee28eaccf33045$export$5f8d39834fd61797 = $82ee28eaccf33045$var$f;
$82ee28eaccf33045$export$74bf444e3cd11ea5 = $82ee28eaccf33045$var$p;
$82ee28eaccf33045$export$92387174baf9b227 = function(a) {
    return $82ee28eaccf33045$var$A(a) || $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$l;
};
$82ee28eaccf33045$export$ec112efeb987d9c6 = $82ee28eaccf33045$var$A;
$82ee28eaccf33045$export$b706b080d889d2c9 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$k;
};
$82ee28eaccf33045$export$5be5a87408f70ddc = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$h;
};
$82ee28eaccf33045$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $82ee28eaccf33045$var$c;
};
$82ee28eaccf33045$export$455c2e768291efa6 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$n;
};
$82ee28eaccf33045$export$9522e17588c12572 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$e;
};
$82ee28eaccf33045$export$2110ac352bb060b9 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$t;
};
$82ee28eaccf33045$export$56885ab8b9c456ab = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$r;
};
$82ee28eaccf33045$export$d927fcb6adf8f9de = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$d;
};
$82ee28eaccf33045$export$b82d16f27459e05a = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$g;
};
$82ee28eaccf33045$export$522c17b4f5e123e8 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$f;
};
$82ee28eaccf33045$export$1aabd8a0274ecfd6 = function(a) {
    return $82ee28eaccf33045$var$z(a) === $82ee28eaccf33045$var$p;
};
$82ee28eaccf33045$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $82ee28eaccf33045$var$e || a === $82ee28eaccf33045$var$m || a === $82ee28eaccf33045$var$g || a === $82ee28eaccf33045$var$f || a === $82ee28eaccf33045$var$p || a === $82ee28eaccf33045$var$q || "object" === typeof a && null !== a && (a.$$typeof === $82ee28eaccf33045$var$t || a.$$typeof === $82ee28eaccf33045$var$r || a.$$typeof === $82ee28eaccf33045$var$h || a.$$typeof === $82ee28eaccf33045$var$k || a.$$typeof === $82ee28eaccf33045$var$n || a.$$typeof === $82ee28eaccf33045$var$w || a.$$typeof === $82ee28eaccf33045$var$x || a.$$typeof === $82ee28eaccf33045$var$y || a.$$typeof === $82ee28eaccf33045$var$v);
};
$82ee28eaccf33045$export$f5bbd400c2f4426f = $82ee28eaccf33045$var$z;

});

parcelRequire.register("956g0", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $69c96f35f081f277$export$a7c73072b1a182ae; }, function (v) { return $69c96f35f081f277$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $69c96f35f081f277$export$9f27bc3417b4524d; }, function (v) { return $69c96f35f081f277$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $69c96f35f081f277$export$db77ccec0bb4ccac; }, function (v) { return $69c96f35f081f277$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $69c96f35f081f277$export$8392c0c9d3dcbd35; }, function (v) { return $69c96f35f081f277$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $69c96f35f081f277$export$ffb0004e005737fa; }, function (v) { return $69c96f35f081f277$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $69c96f35f081f277$export$b624eff549462981; }, function (v) { return $69c96f35f081f277$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $69c96f35f081f277$export$7897aa7841a5380c; }, function (v) { return $69c96f35f081f277$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $69c96f35f081f277$export$602eac185826482c; }, function (v) { return $69c96f35f081f277$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $69c96f35f081f277$export$e2c29f18771995cb; }, function (v) { return $69c96f35f081f277$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $69c96f35f081f277$export$5f8d39834fd61797; }, function (v) { return $69c96f35f081f277$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $69c96f35f081f277$export$74bf444e3cd11ea5; }, function (v) { return $69c96f35f081f277$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $69c96f35f081f277$export$92387174baf9b227; }, function (v) { return $69c96f35f081f277$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $69c96f35f081f277$export$ec112efeb987d9c6; }, function (v) { return $69c96f35f081f277$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $69c96f35f081f277$export$b706b080d889d2c9; }, function (v) { return $69c96f35f081f277$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $69c96f35f081f277$export$5be5a87408f70ddc; }, function (v) { return $69c96f35f081f277$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $69c96f35f081f277$export$45a5e7f76e0caa8d; }, function (v) { return $69c96f35f081f277$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $69c96f35f081f277$export$455c2e768291efa6; }, function (v) { return $69c96f35f081f277$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $69c96f35f081f277$export$9522e17588c12572; }, function (v) { return $69c96f35f081f277$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $69c96f35f081f277$export$2110ac352bb060b9; }, function (v) { return $69c96f35f081f277$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $69c96f35f081f277$export$56885ab8b9c456ab; }, function (v) { return $69c96f35f081f277$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $69c96f35f081f277$export$d927fcb6adf8f9de; }, function (v) { return $69c96f35f081f277$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $69c96f35f081f277$export$b82d16f27459e05a; }, function (v) { return $69c96f35f081f277$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $69c96f35f081f277$export$522c17b4f5e123e8; }, function (v) { return $69c96f35f081f277$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $69c96f35f081f277$export$1aabd8a0274ecfd6; }, function (v) { return $69c96f35f081f277$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $69c96f35f081f277$export$9b621391a187a31a; }, function (v) { return $69c96f35f081f277$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $69c96f35f081f277$export$f5bbd400c2f4426f; }, function (v) { return $69c96f35f081f277$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $69c96f35f081f277$export$a7c73072b1a182ae;
var $69c96f35f081f277$export$9f27bc3417b4524d;
var $69c96f35f081f277$export$db77ccec0bb4ccac;
var $69c96f35f081f277$export$8392c0c9d3dcbd35;
var $69c96f35f081f277$export$ffb0004e005737fa;
var $69c96f35f081f277$export$b624eff549462981;
var $69c96f35f081f277$export$7897aa7841a5380c;
var $69c96f35f081f277$export$602eac185826482c;
var $69c96f35f081f277$export$e2c29f18771995cb;
var $69c96f35f081f277$export$5f8d39834fd61797;
var $69c96f35f081f277$export$74bf444e3cd11ea5;
var $69c96f35f081f277$export$92387174baf9b227;
var $69c96f35f081f277$export$ec112efeb987d9c6;
var $69c96f35f081f277$export$b706b080d889d2c9;
var $69c96f35f081f277$export$5be5a87408f70ddc;
var $69c96f35f081f277$export$45a5e7f76e0caa8d;
var $69c96f35f081f277$export$455c2e768291efa6;
var $69c96f35f081f277$export$9522e17588c12572;
var $69c96f35f081f277$export$2110ac352bb060b9;
var $69c96f35f081f277$export$56885ab8b9c456ab;
var $69c96f35f081f277$export$d927fcb6adf8f9de;
var $69c96f35f081f277$export$b82d16f27459e05a;
var $69c96f35f081f277$export$522c17b4f5e123e8;
var $69c96f35f081f277$export$1aabd8a0274ecfd6;
var $69c96f35f081f277$export$9b621391a187a31a;
var $69c96f35f081f277$export$f5bbd400c2f4426f;
"use strict";
var $69c96f35f081f277$var$b = 60103, $69c96f35f081f277$var$c = 60106, $69c96f35f081f277$var$d = 60107, $69c96f35f081f277$var$e = 60108, $69c96f35f081f277$var$f = 60114, $69c96f35f081f277$var$g = 60109, $69c96f35f081f277$var$h = 60110, $69c96f35f081f277$var$k = 60112, $69c96f35f081f277$var$l = 60113, $69c96f35f081f277$var$m = 60120, $69c96f35f081f277$var$n = 60115, $69c96f35f081f277$var$p = 60116, $69c96f35f081f277$var$q = 60121, $69c96f35f081f277$var$r = 60122, $69c96f35f081f277$var$u = 60117, $69c96f35f081f277$var$v = 60129, $69c96f35f081f277$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $69c96f35f081f277$var$x = Symbol.for;
    $69c96f35f081f277$var$b = $69c96f35f081f277$var$x("react.element");
    $69c96f35f081f277$var$c = $69c96f35f081f277$var$x("react.portal");
    $69c96f35f081f277$var$d = $69c96f35f081f277$var$x("react.fragment");
    $69c96f35f081f277$var$e = $69c96f35f081f277$var$x("react.strict_mode");
    $69c96f35f081f277$var$f = $69c96f35f081f277$var$x("react.profiler");
    $69c96f35f081f277$var$g = $69c96f35f081f277$var$x("react.provider");
    $69c96f35f081f277$var$h = $69c96f35f081f277$var$x("react.context");
    $69c96f35f081f277$var$k = $69c96f35f081f277$var$x("react.forward_ref");
    $69c96f35f081f277$var$l = $69c96f35f081f277$var$x("react.suspense");
    $69c96f35f081f277$var$m = $69c96f35f081f277$var$x("react.suspense_list");
    $69c96f35f081f277$var$n = $69c96f35f081f277$var$x("react.memo");
    $69c96f35f081f277$var$p = $69c96f35f081f277$var$x("react.lazy");
    $69c96f35f081f277$var$q = $69c96f35f081f277$var$x("react.block");
    $69c96f35f081f277$var$r = $69c96f35f081f277$var$x("react.server.block");
    $69c96f35f081f277$var$u = $69c96f35f081f277$var$x("react.fundamental");
    $69c96f35f081f277$var$v = $69c96f35f081f277$var$x("react.debug_trace_mode");
    $69c96f35f081f277$var$w = $69c96f35f081f277$var$x("react.legacy_hidden");
}
function $69c96f35f081f277$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $69c96f35f081f277$var$b:
                switch(a = a.type, a){
                    case $69c96f35f081f277$var$d:
                    case $69c96f35f081f277$var$f:
                    case $69c96f35f081f277$var$e:
                    case $69c96f35f081f277$var$l:
                    case $69c96f35f081f277$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $69c96f35f081f277$var$h:
                            case $69c96f35f081f277$var$k:
                            case $69c96f35f081f277$var$p:
                            case $69c96f35f081f277$var$n:
                            case $69c96f35f081f277$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $69c96f35f081f277$var$c:
                return t;
        }
    }
}
var $69c96f35f081f277$var$z = $69c96f35f081f277$var$g, $69c96f35f081f277$var$A = $69c96f35f081f277$var$b, $69c96f35f081f277$var$B = $69c96f35f081f277$var$k, $69c96f35f081f277$var$C = $69c96f35f081f277$var$d, $69c96f35f081f277$var$D = $69c96f35f081f277$var$p, $69c96f35f081f277$var$E = $69c96f35f081f277$var$n, $69c96f35f081f277$var$F = $69c96f35f081f277$var$c, $69c96f35f081f277$var$G = $69c96f35f081f277$var$f, $69c96f35f081f277$var$H = $69c96f35f081f277$var$e, $69c96f35f081f277$var$I = $69c96f35f081f277$var$l;
$69c96f35f081f277$export$a7c73072b1a182ae = $69c96f35f081f277$var$h;
$69c96f35f081f277$export$9f27bc3417b4524d = $69c96f35f081f277$var$z;
$69c96f35f081f277$export$db77ccec0bb4ccac = $69c96f35f081f277$var$A;
$69c96f35f081f277$export$8392c0c9d3dcbd35 = $69c96f35f081f277$var$B;
$69c96f35f081f277$export$ffb0004e005737fa = $69c96f35f081f277$var$C;
$69c96f35f081f277$export$b624eff549462981 = $69c96f35f081f277$var$D;
$69c96f35f081f277$export$7897aa7841a5380c = $69c96f35f081f277$var$E;
$69c96f35f081f277$export$602eac185826482c = $69c96f35f081f277$var$F;
$69c96f35f081f277$export$e2c29f18771995cb = $69c96f35f081f277$var$G;
$69c96f35f081f277$export$5f8d39834fd61797 = $69c96f35f081f277$var$H;
$69c96f35f081f277$export$74bf444e3cd11ea5 = $69c96f35f081f277$var$I;
$69c96f35f081f277$export$92387174baf9b227 = function() {
    return !1;
};
$69c96f35f081f277$export$ec112efeb987d9c6 = function() {
    return !1;
};
$69c96f35f081f277$export$b706b080d889d2c9 = function(a) {
    return $69c96f35f081f277$var$y(a) === $69c96f35f081f277$var$h;
};
$69c96f35f081f277$export$5be5a87408f70ddc = function(a) {
    return $69c96f35f081f277$var$y(a) === $69c96f35f081f277$var$g;
};
$69c96f35f081f277$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $69c96f35f081f277$var$b;
};
$69c96f35f081f277$export$455c2e768291efa6 = function(a) {
    return $69c96f35f081f277$var$y(a) === $69c96f35f081f277$var$k;
};
$69c96f35f081f277$export$9522e17588c12572 = function(a) {
    return $69c96f35f081f277$var$y(a) === $69c96f35f081f277$var$d;
};
$69c96f35f081f277$export$2110ac352bb060b9 = function(a) {
    return $69c96f35f081f277$var$y(a) === $69c96f35f081f277$var$p;
};
$69c96f35f081f277$export$56885ab8b9c456ab = function(a) {
    return $69c96f35f081f277$var$y(a) === $69c96f35f081f277$var$n;
};
$69c96f35f081f277$export$d927fcb6adf8f9de = function(a) {
    return $69c96f35f081f277$var$y(a) === $69c96f35f081f277$var$c;
};
$69c96f35f081f277$export$b82d16f27459e05a = function(a) {
    return $69c96f35f081f277$var$y(a) === $69c96f35f081f277$var$f;
};
$69c96f35f081f277$export$522c17b4f5e123e8 = function(a) {
    return $69c96f35f081f277$var$y(a) === $69c96f35f081f277$var$e;
};
$69c96f35f081f277$export$1aabd8a0274ecfd6 = function(a) {
    return $69c96f35f081f277$var$y(a) === $69c96f35f081f277$var$l;
};
$69c96f35f081f277$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $69c96f35f081f277$var$d || a === $69c96f35f081f277$var$f || a === $69c96f35f081f277$var$v || a === $69c96f35f081f277$var$e || a === $69c96f35f081f277$var$l || a === $69c96f35f081f277$var$m || a === $69c96f35f081f277$var$w || "object" === typeof a && null !== a && (a.$$typeof === $69c96f35f081f277$var$p || a.$$typeof === $69c96f35f081f277$var$n || a.$$typeof === $69c96f35f081f277$var$g || a.$$typeof === $69c96f35f081f277$var$h || a.$$typeof === $69c96f35f081f277$var$k || a.$$typeof === $69c96f35f081f277$var$u || a.$$typeof === $69c96f35f081f277$var$q || a[0] === $69c96f35f081f277$var$r) ? !0 : !1;
};
$69c96f35f081f277$export$f5bbd400c2f4426f = $69c96f35f081f277$var$y;

});

parcelRequire.register("8SHLH", function(module, exports) {

});

parcelRequire.register("9wlqC", function(module, exports) {

$parcel$export(module.exports, "addDays", function () { return $6ee7b97316012b39$export$dd412b56f1e4d8aa; }, function (v) { return $6ee7b97316012b39$export$dd412b56f1e4d8aa = v; });
var $6ee7b97316012b39$export$dd412b56f1e4d8aa;
"use strict";
$6ee7b97316012b39$export$dd412b56f1e4d8aa = $6ee7b97316012b39$var$addDays;

var $hC8hz = parcelRequire("hC8hz");

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $6ee7b97316012b39$var$addDays(date, amount) {
    const _date = (0, $hC8hz.toDate)(date);
    if (isNaN(amount)) return (0, $cHwnM.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}

});
parcelRequire.register("hC8hz", function(module, exports) {

$parcel$export(module.exports, "toDate", function () { return $cd2c68f6baa5d92c$export$e67a095c620b86fe; }, function (v) { return $cd2c68f6baa5d92c$export$e67a095c620b86fe = v; });
var $cd2c68f6baa5d92c$export$e67a095c620b86fe;
"use strict";
$cd2c68f6baa5d92c$export$e67a095c620b86fe = $cd2c68f6baa5d92c$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $cd2c68f6baa5d92c$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}

});

parcelRequire.register("cHwnM", function(module, exports) {

$parcel$export(module.exports, "constructFrom", function () { return $93f29eacc1b02f39$export$ead8a1812b171991; }, function (v) { return $93f29eacc1b02f39$export$ead8a1812b171991 = v; });
var $93f29eacc1b02f39$export$ead8a1812b171991;
"use strict";
$93f29eacc1b02f39$export$ead8a1812b171991 = $93f29eacc1b02f39$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $93f29eacc1b02f39$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}

});


parcelRequire.register("eTI3m", function(module, exports) {

$parcel$export(module.exports, "addMonths", function () { return $ad885fc6633487ea$export$17c93e242b2d3a22; }, function (v) { return $ad885fc6633487ea$export$17c93e242b2d3a22 = v; });
var $ad885fc6633487ea$export$17c93e242b2d3a22;
"use strict";
$ad885fc6633487ea$export$17c93e242b2d3a22 = $ad885fc6633487ea$var$addMonths;

var $hC8hz = parcelRequire("hC8hz");

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $ad885fc6633487ea$var$addMonths(date, amount) {
    const _date = (0, $hC8hz.toDate)(date);
    if (isNaN(amount)) return (0, $cHwnM.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $cHwnM.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}

});

parcelRequire.register("1Q0sb", function(module, exports) {

$parcel$export(module.exports, "addHours", function () { return $156affd72b7c3d35$export$4a4306ad4fa0e5e6; }, function (v) { return $156affd72b7c3d35$export$4a4306ad4fa0e5e6 = v; });
var $156affd72b7c3d35$export$4a4306ad4fa0e5e6;
"use strict";
$156affd72b7c3d35$export$4a4306ad4fa0e5e6 = $156affd72b7c3d35$var$addHours;

var $be89H = parcelRequire("be89H");

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */ function $156affd72b7c3d35$var$addHours(date, amount) {
    return (0, $be89H.addMilliseconds)(date, amount * $5K4u1.millisecondsInHour);
}

});
parcelRequire.register("be89H", function(module, exports) {

$parcel$export(module.exports, "addMilliseconds", function () { return $82c753fef6159bda$export$baf757aaf0c95c94; }, function (v) { return $82c753fef6159bda$export$baf757aaf0c95c94 = v; });
var $82c753fef6159bda$export$baf757aaf0c95c94;
"use strict";
$82c753fef6159bda$export$baf757aaf0c95c94 = $82c753fef6159bda$var$addMilliseconds;

var $hC8hz = parcelRequire("hC8hz");

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $82c753fef6159bda$var$addMilliseconds(date, amount) {
    const timestamp = +(0, $hC8hz.toDate)(date);
    return (0, $cHwnM.constructFrom)(date, timestamp + amount);
}

});

parcelRequire.register("5K4u1", function(module, exports) {

$parcel$export(module.exports, "secondsInYear", function () { return $42e4b9e88737f63c$export$7271e9e3478110d1; }, function (v) { return $42e4b9e88737f63c$export$7271e9e3478110d1 = v; });
$parcel$export(module.exports, "secondsInWeek", function () { return $42e4b9e88737f63c$export$34804a017b31e2fe; }, function (v) { return $42e4b9e88737f63c$export$34804a017b31e2fe = v; });
$parcel$export(module.exports, "secondsInQuarter", function () { return $42e4b9e88737f63c$export$be1dccf2de902d31; }, function (v) { return $42e4b9e88737f63c$export$be1dccf2de902d31 = v; });
$parcel$export(module.exports, "secondsInMonth", function () { return $42e4b9e88737f63c$export$8e6600bbdee7dabb; }, function (v) { return $42e4b9e88737f63c$export$8e6600bbdee7dabb = v; });
$parcel$export(module.exports, "secondsInMinute", function () { return $42e4b9e88737f63c$export$a77c1a7ebebe2a5a; }, function (v) { return $42e4b9e88737f63c$export$a77c1a7ebebe2a5a = v; });
$parcel$export(module.exports, "secondsInHour", function () { return $42e4b9e88737f63c$export$698aec755e92c695; }, function (v) { return $42e4b9e88737f63c$export$698aec755e92c695 = v; });
$parcel$export(module.exports, "secondsInDay", function () { return $42e4b9e88737f63c$export$815a9362476d2fe3; }, function (v) { return $42e4b9e88737f63c$export$815a9362476d2fe3 = v; });
$parcel$export(module.exports, "quartersInYear", function () { return $42e4b9e88737f63c$export$4db7641526e3241f; }, function (v) { return $42e4b9e88737f63c$export$4db7641526e3241f = v; });
$parcel$export(module.exports, "monthsInYear", function () { return $42e4b9e88737f63c$export$80d7e435f744f319; }, function (v) { return $42e4b9e88737f63c$export$80d7e435f744f319 = v; });
$parcel$export(module.exports, "monthsInQuarter", function () { return $42e4b9e88737f63c$export$3c58128db900d44e; }, function (v) { return $42e4b9e88737f63c$export$3c58128db900d44e = v; });
$parcel$export(module.exports, "minutesInYear", function () { return $42e4b9e88737f63c$export$3633035e63cee86a; }, function (v) { return $42e4b9e88737f63c$export$3633035e63cee86a = v; });
$parcel$export(module.exports, "minutesInMonth", function () { return $42e4b9e88737f63c$export$ab7da2ccd1075c38; }, function (v) { return $42e4b9e88737f63c$export$ab7da2ccd1075c38 = v; });
$parcel$export(module.exports, "minutesInHour", function () { return $42e4b9e88737f63c$export$f2f5ae5a8e2d8f9f; }, function (v) { return $42e4b9e88737f63c$export$f2f5ae5a8e2d8f9f = v; });
$parcel$export(module.exports, "minutesInDay", function () { return $42e4b9e88737f63c$export$2423174df8cd3cd2; }, function (v) { return $42e4b9e88737f63c$export$2423174df8cd3cd2 = v; });
$parcel$export(module.exports, "millisecondsInWeek", function () { return $42e4b9e88737f63c$export$4fad13613e88edc8; }, function (v) { return $42e4b9e88737f63c$export$4fad13613e88edc8 = v; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $42e4b9e88737f63c$export$397c2d5776aa9055; }, function (v) { return $42e4b9e88737f63c$export$397c2d5776aa9055 = v; });
$parcel$export(module.exports, "millisecondsInMinute", function () { return $42e4b9e88737f63c$export$91246f0b9bd9beff; }, function (v) { return $42e4b9e88737f63c$export$91246f0b9bd9beff = v; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $42e4b9e88737f63c$export$7f72910d6dfd237a; }, function (v) { return $42e4b9e88737f63c$export$7f72910d6dfd237a = v; });
$parcel$export(module.exports, "millisecondsInDay", function () { return $42e4b9e88737f63c$export$b76b1809a2898f9a; }, function (v) { return $42e4b9e88737f63c$export$b76b1809a2898f9a = v; });
$parcel$export(module.exports, "daysInYear", function () { return $42e4b9e88737f63c$export$3913210603d8e9ae; }, function (v) { return $42e4b9e88737f63c$export$3913210603d8e9ae = v; });
$parcel$export(module.exports, "daysInWeek", function () { return $42e4b9e88737f63c$export$dfd9b671c89acc8e; }, function (v) { return $42e4b9e88737f63c$export$dfd9b671c89acc8e = v; });
var $42e4b9e88737f63c$export$7271e9e3478110d1;
var $42e4b9e88737f63c$export$34804a017b31e2fe;
var $42e4b9e88737f63c$export$be1dccf2de902d31;
var $42e4b9e88737f63c$export$8e6600bbdee7dabb;
var $42e4b9e88737f63c$export$a77c1a7ebebe2a5a;
var $42e4b9e88737f63c$export$698aec755e92c695;
var $42e4b9e88737f63c$export$815a9362476d2fe3;
var $42e4b9e88737f63c$export$4db7641526e3241f;
var $42e4b9e88737f63c$export$80d7e435f744f319;
var $42e4b9e88737f63c$export$3c58128db900d44e;
var $42e4b9e88737f63c$export$3633035e63cee86a;
var $42e4b9e88737f63c$export$ab7da2ccd1075c38;
var $42e4b9e88737f63c$export$f2f5ae5a8e2d8f9f;
var $42e4b9e88737f63c$export$2423174df8cd3cd2;
var $42e4b9e88737f63c$export$4dec998e48f9c246;
var $42e4b9e88737f63c$export$4fad13613e88edc8;
var $42e4b9e88737f63c$export$397c2d5776aa9055;
var $42e4b9e88737f63c$export$91246f0b9bd9beff;
var $42e4b9e88737f63c$export$7f72910d6dfd237a;
var $42e4b9e88737f63c$export$b76b1809a2898f9a;
var $42e4b9e88737f63c$export$81caae6e1cc7a622;
var $42e4b9e88737f63c$export$3913210603d8e9ae;
var $42e4b9e88737f63c$export$dfd9b671c89acc8e;
"use strict";
$42e4b9e88737f63c$export$7271e9e3478110d1 = $42e4b9e88737f63c$export$34804a017b31e2fe = $42e4b9e88737f63c$export$be1dccf2de902d31 = $42e4b9e88737f63c$export$8e6600bbdee7dabb = $42e4b9e88737f63c$export$a77c1a7ebebe2a5a = $42e4b9e88737f63c$export$698aec755e92c695 = $42e4b9e88737f63c$export$815a9362476d2fe3 = $42e4b9e88737f63c$export$4db7641526e3241f = $42e4b9e88737f63c$export$80d7e435f744f319 = $42e4b9e88737f63c$export$3c58128db900d44e = $42e4b9e88737f63c$export$3633035e63cee86a = $42e4b9e88737f63c$export$ab7da2ccd1075c38 = $42e4b9e88737f63c$export$f2f5ae5a8e2d8f9f = $42e4b9e88737f63c$export$2423174df8cd3cd2 = $42e4b9e88737f63c$export$4dec998e48f9c246 = $42e4b9e88737f63c$export$4fad13613e88edc8 = $42e4b9e88737f63c$export$397c2d5776aa9055 = $42e4b9e88737f63c$export$91246f0b9bd9beff = $42e4b9e88737f63c$export$7f72910d6dfd237a = $42e4b9e88737f63c$export$b76b1809a2898f9a = $42e4b9e88737f63c$export$81caae6e1cc7a622 = $42e4b9e88737f63c$export$3913210603d8e9ae = $42e4b9e88737f63c$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $42e4b9e88737f63c$var$daysInWeek = $42e4b9e88737f63c$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $42e4b9e88737f63c$var$daysInYear = $42e4b9e88737f63c$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $42e4b9e88737f63c$var$maxTime = $42e4b9e88737f63c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $42e4b9e88737f63c$var$minTime = $42e4b9e88737f63c$export$4dec998e48f9c246 = -$42e4b9e88737f63c$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $42e4b9e88737f63c$var$millisecondsInWeek = $42e4b9e88737f63c$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $42e4b9e88737f63c$var$millisecondsInDay = $42e4b9e88737f63c$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $42e4b9e88737f63c$var$millisecondsInMinute = $42e4b9e88737f63c$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $42e4b9e88737f63c$var$millisecondsInHour = $42e4b9e88737f63c$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $42e4b9e88737f63c$var$millisecondsInSecond = $42e4b9e88737f63c$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $42e4b9e88737f63c$var$minutesInYear = $42e4b9e88737f63c$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $42e4b9e88737f63c$var$minutesInMonth = $42e4b9e88737f63c$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $42e4b9e88737f63c$var$minutesInDay = $42e4b9e88737f63c$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $42e4b9e88737f63c$var$minutesInHour = $42e4b9e88737f63c$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $42e4b9e88737f63c$var$monthsInQuarter = $42e4b9e88737f63c$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $42e4b9e88737f63c$var$monthsInYear = $42e4b9e88737f63c$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $42e4b9e88737f63c$var$quartersInYear = $42e4b9e88737f63c$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $42e4b9e88737f63c$var$secondsInHour = $42e4b9e88737f63c$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $42e4b9e88737f63c$var$secondsInMinute = $42e4b9e88737f63c$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $42e4b9e88737f63c$var$secondsInDay = $42e4b9e88737f63c$export$815a9362476d2fe3 = $42e4b9e88737f63c$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $42e4b9e88737f63c$var$secondsInWeek = $42e4b9e88737f63c$export$34804a017b31e2fe = $42e4b9e88737f63c$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $42e4b9e88737f63c$var$secondsInYear = $42e4b9e88737f63c$export$7271e9e3478110d1 = $42e4b9e88737f63c$var$secondsInDay * $42e4b9e88737f63c$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $42e4b9e88737f63c$var$secondsInMonth = $42e4b9e88737f63c$export$8e6600bbdee7dabb = $42e4b9e88737f63c$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $42e4b9e88737f63c$var$secondsInQuarter = $42e4b9e88737f63c$export$be1dccf2de902d31 = $42e4b9e88737f63c$var$secondsInMonth * 3;

});


parcelRequire.register("5Wrs3", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", function () { return $4537a9d664912680$export$42c81a444fbfb5d4; }, function (v) { return $4537a9d664912680$export$42c81a444fbfb5d4 = v; });
var $4537a9d664912680$export$42c81a444fbfb5d4;
"use strict";
$4537a9d664912680$export$42c81a444fbfb5d4 = $4537a9d664912680$var$startOfWeek;

var $hC8hz = parcelRequire("hC8hz");

var $3Om6B = parcelRequire("3Om6B");
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $4537a9d664912680$var$startOfWeek(date, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $hC8hz.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});
parcelRequire.register("3Om6B", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $2c67305054e292bb$export$430a3269e24b912e; }, function (v) { return $2c67305054e292bb$export$430a3269e24b912e = v; });
$parcel$export(module.exports, "setDefaultOptions", function () { return $2c67305054e292bb$export$95365be1b0704abc; }, function (v) { return $2c67305054e292bb$export$95365be1b0704abc = v; });
var $2c67305054e292bb$export$430a3269e24b912e;
var $2c67305054e292bb$export$95365be1b0704abc;
"use strict";
$2c67305054e292bb$export$430a3269e24b912e = $2c67305054e292bb$var$getDefaultOptions;
$2c67305054e292bb$export$95365be1b0704abc = $2c67305054e292bb$var$setDefaultOptions;
let $2c67305054e292bb$var$defaultOptions = {};
function $2c67305054e292bb$var$getDefaultOptions() {
    return $2c67305054e292bb$var$defaultOptions;
}
function $2c67305054e292bb$var$setDefaultOptions(newOptions) {
    $2c67305054e292bb$var$defaultOptions = newOptions;
}

});


parcelRequire.register("doy2h", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", function () { return $9c07eb0e83eb2dcb$export$4a02e9c37dab4871; }, function (v) { return $9c07eb0e83eb2dcb$export$4a02e9c37dab4871 = v; });
var $9c07eb0e83eb2dcb$export$4a02e9c37dab4871;
"use strict";
$9c07eb0e83eb2dcb$export$4a02e9c37dab4871 = $9c07eb0e83eb2dcb$var$differenceInCalendarDays;

var $5K4u1 = parcelRequire("5K4u1");

var $kVRe5 = parcelRequire("kVRe5");

var $gORYf = parcelRequire("gORYf");
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $9c07eb0e83eb2dcb$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $kVRe5.startOfDay)(dateLeft);
    const startOfDayRight = (0, $kVRe5.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $gORYf.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $gORYf.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $5K4u1.millisecondsInDay);
}

});
parcelRequire.register("kVRe5", function(module, exports) {

$parcel$export(module.exports, "startOfDay", function () { return $f3d26b1f966c91ac$export$63fa379ae8a9ba2; }, function (v) { return $f3d26b1f966c91ac$export$63fa379ae8a9ba2 = v; });
var $f3d26b1f966c91ac$export$63fa379ae8a9ba2;
"use strict";
$f3d26b1f966c91ac$export$63fa379ae8a9ba2 = $f3d26b1f966c91ac$var$startOfDay;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $f3d26b1f966c91ac$var$startOfDay(date) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRequire.register("gORYf", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", function () { return $c3eb2e4b4c31930d$export$113002b5eff6e430; }, function (v) { return $c3eb2e4b4c31930d$export$113002b5eff6e430 = v; });
var $c3eb2e4b4c31930d$export$113002b5eff6e430;
"use strict";
$c3eb2e4b4c31930d$export$113002b5eff6e430 = $c3eb2e4b4c31930d$var$getTimezoneOffsetInMilliseconds;

var $hC8hz = parcelRequire("hC8hz");
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $c3eb2e4b4c31930d$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});


parcelRequire.register("lmA75", function(module, exports) {

$parcel$export(module.exports, "addMinutes", function () { return $f8d7aa5f14652bae$export$2287e3d29250119e; }, function (v) { return $f8d7aa5f14652bae$export$2287e3d29250119e = v; });
var $f8d7aa5f14652bae$export$2287e3d29250119e;
"use strict";
$f8d7aa5f14652bae$export$2287e3d29250119e = $f8d7aa5f14652bae$var$addMinutes;

var $be89H = parcelRequire("be89H");

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ function $f8d7aa5f14652bae$var$addMinutes(date, amount) {
    return (0, $be89H.addMilliseconds)(date, amount * $5K4u1.millisecondsInMinute);
}

});

parcelRequire.register("9S1sJ", function(module, exports) {

$parcel$export(module.exports, "addQuarters", function () { return $72fa4a995f77cdc4$export$c252a41d0fbed2ce; }, function (v) { return $72fa4a995f77cdc4$export$c252a41d0fbed2ce = v; });
var $72fa4a995f77cdc4$export$c252a41d0fbed2ce;
"use strict";
$72fa4a995f77cdc4$export$c252a41d0fbed2ce = $72fa4a995f77cdc4$var$addQuarters;

var $eTI3m = parcelRequire("eTI3m");
/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */ function $72fa4a995f77cdc4$var$addQuarters(date, amount) {
    const months = amount * 3;
    return (0, $eTI3m.addMonths)(date, months);
}

});

parcelRequire.register("cqvn6", function(module, exports) {

$parcel$export(module.exports, "addSeconds", function () { return $90c03f790a0efcff$export$3cb31b0df13be68; }, function (v) { return $90c03f790a0efcff$export$3cb31b0df13be68 = v; });
var $90c03f790a0efcff$export$3cb31b0df13be68;
"use strict";
$90c03f790a0efcff$export$3cb31b0df13be68 = $90c03f790a0efcff$var$addSeconds;

var $be89H = parcelRequire("be89H");
/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */ function $90c03f790a0efcff$var$addSeconds(date, amount) {
    return (0, $be89H.addMilliseconds)(date, amount * 1000);
}

});

parcelRequire.register("zLu4w", function(module, exports) {

$parcel$export(module.exports, "addWeeks", function () { return $06b81a56a9868c54$export$ef501a2bb4f3ee6b; }, function (v) { return $06b81a56a9868c54$export$ef501a2bb4f3ee6b = v; });
var $06b81a56a9868c54$export$ef501a2bb4f3ee6b;
"use strict";
$06b81a56a9868c54$export$ef501a2bb4f3ee6b = $06b81a56a9868c54$var$addWeeks;

var $9wlqC = parcelRequire("9wlqC");
/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */ function $06b81a56a9868c54$var$addWeeks(date, amount) {
    const days = amount * 7;
    return (0, $9wlqC.addDays)(date, days);
}

});

parcelRequire.register("l1Mmy", function(module, exports) {

$parcel$export(module.exports, "addYears", function () { return $f4ef34cc43201cdb$export$3d83eec43f4ea476; }, function (v) { return $f4ef34cc43201cdb$export$3d83eec43f4ea476 = v; });
var $f4ef34cc43201cdb$export$3d83eec43f4ea476;
"use strict";
$f4ef34cc43201cdb$export$3d83eec43f4ea476 = $f4ef34cc43201cdb$var$addYears;

var $eTI3m = parcelRequire("eTI3m");
/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $f4ef34cc43201cdb$var$addYears(date, amount) {
    return (0, $eTI3m.addMonths)(date, amount * 12);
}

});

parcelRequire.register("7DYAE", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $590b2ce093c9f5fc$export$8960430cfd85939f; }, function (v) { return $590b2ce093c9f5fc$export$8960430cfd85939f = v; });
var $590b2ce093c9f5fc$export$8960430cfd85939f;
"use strict";
$590b2ce093c9f5fc$export$8960430cfd85939f = $590b2ce093c9f5fc$var$max;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */ function $590b2ce093c9f5fc$var$max(dates) {
    let result;
    dates.forEach(function(dirtyDate) {
        const currentDate = (0, $hC8hz.toDate)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRequire.register("3al5W", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $24e2ab4901fd0031$export$96ec731ed4dcb222; }, function (v) { return $24e2ab4901fd0031$export$96ec731ed4dcb222 = v; });
var $24e2ab4901fd0031$export$96ec731ed4dcb222;
"use strict";
$24e2ab4901fd0031$export$96ec731ed4dcb222 = $24e2ab4901fd0031$var$min;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */ function $24e2ab4901fd0031$var$min(dates) {
    let result;
    dates.forEach((dirtyDate)=>{
        const date = (0, $hC8hz.toDate)(dirtyDate);
        if (!result || result > date || isNaN(+date)) result = date;
    });
    return result || new Date(NaN);
}

});

parcelRequire.register("hVwiy", function(module, exports) {

$parcel$export(module.exports, "isSameDay", function () { return $d0d0d04bb0ec535d$export$ea39ec197993aef0; }, function (v) { return $d0d0d04bb0ec535d$export$ea39ec197993aef0 = v; });
var $d0d0d04bb0ec535d$export$ea39ec197993aef0;
"use strict";
$d0d0d04bb0ec535d$export$ea39ec197993aef0 = $d0d0d04bb0ec535d$var$isSameDay;

var $kVRe5 = parcelRequire("kVRe5");
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ function $d0d0d04bb0ec535d$var$isSameDay(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $kVRe5.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $kVRe5.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}

});

parcelRequire.register("bJrOu", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $88a978d446ab8d9b$export$1ea939691cdc45b8; }, function (v) { return $88a978d446ab8d9b$export$1ea939691cdc45b8 = v; });
var $88a978d446ab8d9b$export$1ea939691cdc45b8;
"use strict";
$88a978d446ab8d9b$export$1ea939691cdc45b8 = $88a978d446ab8d9b$var$isValid;

var $c2iD1 = parcelRequire("c2iD1");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $88a978d446ab8d9b$var$isValid(date) {
    if (!(0, $c2iD1.isDate)(date) && typeof date !== "number") return false;
    const _date = (0, $hC8hz.toDate)(date);
    return !isNaN(Number(_date));
}

});
parcelRequire.register("c2iD1", function(module, exports) {

$parcel$export(module.exports, "isDate", function () { return $8c341f27f7c6163b$export$871608497c498473; }, function (v) { return $8c341f27f7c6163b$export$871608497c498473 = v; });
var $8c341f27f7c6163b$export$871608497c498473;
"use strict";
$8c341f27f7c6163b$export$871608497c498473 = $8c341f27f7c6163b$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $8c341f27f7c6163b$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});


parcelRequire.register("dPrzz", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarMonths", function () { return $a1156d2239c4a44b$export$489984ac7c996389; }, function (v) { return $a1156d2239c4a44b$export$489984ac7c996389 = v; });
var $a1156d2239c4a44b$export$489984ac7c996389;
"use strict";
$a1156d2239c4a44b$export$489984ac7c996389 = $a1156d2239c4a44b$var$differenceInCalendarMonths;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ function $a1156d2239c4a44b$var$differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRequire.register("lTSPY", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarQuarters", function () { return $ff19458e84db8749$export$f62ae9fb13958c7a; }, function (v) { return $ff19458e84db8749$export$f62ae9fb13958c7a = v; });
var $ff19458e84db8749$export$f62ae9fb13958c7a;
"use strict";
$ff19458e84db8749$export$f62ae9fb13958c7a = $ff19458e84db8749$var$differenceInCalendarQuarters;

var $bqOt8 = parcelRequire("bqOt8");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ function $ff19458e84db8749$var$differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, $bqOt8.getQuarter)(_dateLeft) - (0, $bqOt8.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}

});
parcelRequire.register("bqOt8", function(module, exports) {

$parcel$export(module.exports, "getQuarter", function () { return $85294582c5c202df$export$de90a4bb31c25221; }, function (v) { return $85294582c5c202df$export$de90a4bb31c25221 = v; });
var $85294582c5c202df$export$de90a4bb31c25221;
"use strict";
$85294582c5c202df$export$de90a4bb31c25221 = $85294582c5c202df$var$getQuarter;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ function $85294582c5c202df$var$getQuarter(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}

});


parcelRequire.register("9LexO", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarYears", function () { return $71b3c90f063f409d$export$c06dce8b38891685; }, function (v) { return $71b3c90f063f409d$export$c06dce8b38891685 = v; });
var $71b3c90f063f409d$export$c06dce8b38891685;
"use strict";
$71b3c90f063f409d$export$c06dce8b38891685 = $71b3c90f063f409d$var$differenceInCalendarYears;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ function $71b3c90f063f409d$var$differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

});

parcelRequire.register("6i4iy", function(module, exports) {

$parcel$export(module.exports, "endOfDay", function () { return $4947c20a69174463$export$eb9a03f0e9aa6cea; }, function (v) { return $4947c20a69174463$export$eb9a03f0e9aa6cea = v; });
var $4947c20a69174463$export$eb9a03f0e9aa6cea;
"use strict";
$4947c20a69174463$export$eb9a03f0e9aa6cea = $4947c20a69174463$var$endOfDay;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */ function $4947c20a69174463$var$endOfDay(date) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRequire.register("6VZPY", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", function () { return $50c80891b8cb744c$export$a2258d9c4118825c; }, function (v) { return $50c80891b8cb744c$export$a2258d9c4118825c = v; });
var $50c80891b8cb744c$export$a2258d9c4118825c;
"use strict";
$50c80891b8cb744c$export$a2258d9c4118825c = $50c80891b8cb744c$var$endOfMonth;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $50c80891b8cb744c$var$endOfMonth(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRequire.register("iNa3w", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", function () { return $dae49a79d23040c6$export$69be7267a042ecb3; }, function (v) { return $dae49a79d23040c6$export$69be7267a042ecb3 = v; });
var $dae49a79d23040c6$export$69be7267a042ecb3;
"use strict";
$dae49a79d23040c6$export$69be7267a042ecb3 = $dae49a79d23040c6$var$startOfQuarter;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */ function $dae49a79d23040c6$var$startOfQuarter(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRequire.register("laco2", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", function () { return $f68423dd77054039$export$a5a3b454ada2268e; }, function (v) { return $f68423dd77054039$export$a5a3b454ada2268e = v; });
var $f68423dd77054039$export$a5a3b454ada2268e;
"use strict";
$f68423dd77054039$export$a5a3b454ada2268e = $f68423dd77054039$var$startOfMonth;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $f68423dd77054039$var$startOfMonth(date) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRequire.register("bAgeX", function(module, exports) {

$parcel$export(module.exports, "endOfYear", function () { return $86efa7798a943e38$export$8b7aa55c66d5569e; }, function (v) { return $86efa7798a943e38$export$8b7aa55c66d5569e = v; });
var $86efa7798a943e38$export$8b7aa55c66d5569e;
"use strict";
$86efa7798a943e38$export$8b7aa55c66d5569e = $86efa7798a943e38$var$endOfYear;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */ function $86efa7798a943e38$var$endOfYear(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRequire.register("4Gfnp", function(module, exports) {

$parcel$export(module.exports, "startOfYear", function () { return $3687031f0b40d083$export$f91e89d3d0406102; }, function (v) { return $3687031f0b40d083$export$f91e89d3d0406102 = v; });
var $3687031f0b40d083$export$f91e89d3d0406102;
"use strict";
$3687031f0b40d083$export$f91e89d3d0406102 = $3687031f0b40d083$var$startOfYear;

var $hC8hz = parcelRequire("hC8hz");

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $3687031f0b40d083$var$startOfYear(date) {
    const cleanDate = (0, $hC8hz.toDate)(date);
    const _date = (0, $cHwnM.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}

});

parcelRequire.register("dSpZL", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", function () { return $a1a47b9fcbb1de99$export$ef8b6d9133084f4e; }, function (v) { return $a1a47b9fcbb1de99$export$ef8b6d9133084f4e = v; });
var $a1a47b9fcbb1de99$export$ef8b6d9133084f4e;
"use strict";
$a1a47b9fcbb1de99$export$ef8b6d9133084f4e = $a1a47b9fcbb1de99$var$endOfWeek;

var $hC8hz = parcelRequire("hC8hz");

var $3Om6B = parcelRequire("3Om6B");
/**
 * The {@link endOfWeek} function options.
 */ /**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $a1a47b9fcbb1de99$var$endOfWeek(date, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $hC8hz.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}

});

parcelRequire.register("kutcQ", function(module, exports) {
"use strict";
module.exports.format = module.exports.formatDate = $eead43bc530ca1ee$var$format;
Object.defineProperty(module.exports, "formatters", {
    enumerable: true,
    get: function() {
        return $i8n62.formatters;
    }
});
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $eLb1F.longFormatters;
    }
});

var $eEdOT = parcelRequire("eEdOT");

var $3Om6B = parcelRequire("3Om6B");

var $i8n62 = parcelRequire("i8n62");

var $eLb1F = parcelRequire("eLb1F");

var $l6LL5 = parcelRequire("l6LL5");

var $bJrOu = parcelRequire("bJrOu");

var $hC8hz = parcelRequire("hC8hz");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $eead43bc530ca1ee$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $eead43bc530ca1ee$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $eead43bc530ca1ee$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $eead43bc530ca1ee$var$doubleQuoteRegExp = /''/g;
const $eead43bc530ca1ee$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $eead43bc530ca1ee$var$format(date, formatStr, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $eEdOT.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $hC8hz.toDate)(date);
    if (!(0, $bJrOu.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($eead43bc530ca1ee$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $eLb1F.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($eead43bc530ca1ee$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $eead43bc530ca1ee$var$cleanEscapedString(substring)
        };
        if ($i8n62.formatters[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($eead43bc530ca1ee$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $l6LL5.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $l6LL5.isProtectedDayOfYearToken)(token)) (0, $l6LL5.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = $i8n62.formatters[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $eead43bc530ca1ee$var$cleanEscapedString(input) {
    const matched = input.match($eead43bc530ca1ee$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($eead43bc530ca1ee$var$doubleQuoteRegExp, "'");
}

});
parcelRequire.register("eEdOT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $9dlfV.enUS;
    }
});

var $9dlfV = parcelRequire("9dlfV");

});
parcelRequire.register("9dlfV", function(module, exports) {

$parcel$export(module.exports, "enUS", function () { return $6b55d0ee37fba6cb$export$137380d9ce54f7f; }, function (v) { return $6b55d0ee37fba6cb$export$137380d9ce54f7f = v; });
var $6b55d0ee37fba6cb$export$137380d9ce54f7f;
"use strict";
$6b55d0ee37fba6cb$export$137380d9ce54f7f = void 0;

var $9aAkV = parcelRequire("9aAkV");

var $9ZTMq = parcelRequire("9ZTMq");

var $cfHJJ = parcelRequire("cfHJJ");

var $8joI8 = parcelRequire("8joI8");

var $3zLqi = parcelRequire("3zLqi");
/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $6b55d0ee37fba6cb$var$enUS = $6b55d0ee37fba6cb$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $9aAkV.formatDistance,
    formatLong: $9ZTMq.formatLong,
    formatRelative: $cfHJJ.formatRelative,
    localize: $8joI8.localize,
    match: $3zLqi.match,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};

});
parcelRequire.register("9aAkV", function(module, exports) {

$parcel$export(module.exports, "formatDistance", function () { return $6ad13bec916a0c04$export$2c14ff85d6318973; }, function (v) { return $6ad13bec916a0c04$export$2c14ff85d6318973 = v; });
var $6ad13bec916a0c04$export$2c14ff85d6318973;
"use strict";
$6ad13bec916a0c04$export$2c14ff85d6318973 = void 0;
const $6ad13bec916a0c04$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $6ad13bec916a0c04$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $6ad13bec916a0c04$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$6ad13bec916a0c04$export$2c14ff85d6318973 = $6ad13bec916a0c04$var$formatDistance;

});

parcelRequire.register("9ZTMq", function(module, exports) {

$parcel$export(module.exports, "formatLong", function () { return $7475144e240208b7$export$cbf60ecb96cbb82f; }, function (v) { return $7475144e240208b7$export$cbf60ecb96cbb82f = v; });
var $7475144e240208b7$export$cbf60ecb96cbb82f;
"use strict";
$7475144e240208b7$export$cbf60ecb96cbb82f = void 0;

var $lKCL3 = parcelRequire("lKCL3");
const $7475144e240208b7$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $7475144e240208b7$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $7475144e240208b7$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $7475144e240208b7$var$formatLong = $7475144e240208b7$export$cbf60ecb96cbb82f = {
    date: (0, $lKCL3.buildFormatLongFn)({
        formats: $7475144e240208b7$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $lKCL3.buildFormatLongFn)({
        formats: $7475144e240208b7$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $lKCL3.buildFormatLongFn)({
        formats: $7475144e240208b7$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRequire.register("lKCL3", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", function () { return $fd5bf55c7f6aa37e$export$38e44e97ce4dbb7d; }, function (v) { return $fd5bf55c7f6aa37e$export$38e44e97ce4dbb7d = v; });
var $fd5bf55c7f6aa37e$export$38e44e97ce4dbb7d;
"use strict";
$fd5bf55c7f6aa37e$export$38e44e97ce4dbb7d = $fd5bf55c7f6aa37e$var$buildFormatLongFn;
function $fd5bf55c7f6aa37e$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRequire.register("cfHJJ", function(module, exports) {

$parcel$export(module.exports, "formatRelative", function () { return $8eb8cfeb287e570c$export$8fbbfd65594f46a0; }, function (v) { return $8eb8cfeb287e570c$export$8fbbfd65594f46a0 = v; });
var $8eb8cfeb287e570c$export$8fbbfd65594f46a0;
"use strict";
$8eb8cfeb287e570c$export$8fbbfd65594f46a0 = void 0;
const $8eb8cfeb287e570c$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $8eb8cfeb287e570c$var$formatRelative = (token, _date, _baseDate, _options)=>$8eb8cfeb287e570c$var$formatRelativeLocale[token];
$8eb8cfeb287e570c$export$8fbbfd65594f46a0 = $8eb8cfeb287e570c$var$formatRelative;

});

parcelRequire.register("8joI8", function(module, exports) {

$parcel$export(module.exports, "localize", function () { return $60d34424f10b4ec1$export$b3bd0bc58e36cd63; }, function (v) { return $60d34424f10b4ec1$export$b3bd0bc58e36cd63 = v; });
var $60d34424f10b4ec1$export$b3bd0bc58e36cd63;
"use strict";
$60d34424f10b4ec1$export$b3bd0bc58e36cd63 = void 0;

var $aqgIU = parcelRequire("aqgIU");
const $60d34424f10b4ec1$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $60d34424f10b4ec1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $60d34424f10b4ec1$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $60d34424f10b4ec1$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $60d34424f10b4ec1$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $60d34424f10b4ec1$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $60d34424f10b4ec1$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $60d34424f10b4ec1$var$localize = $60d34424f10b4ec1$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $60d34424f10b4ec1$var$ordinalNumber,
    era: (0, $aqgIU.buildLocalizeFn)({
        values: $60d34424f10b4ec1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $aqgIU.buildLocalizeFn)({
        values: $60d34424f10b4ec1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $aqgIU.buildLocalizeFn)({
        values: $60d34424f10b4ec1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $aqgIU.buildLocalizeFn)({
        values: $60d34424f10b4ec1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $aqgIU.buildLocalizeFn)({
        values: $60d34424f10b4ec1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $60d34424f10b4ec1$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRequire.register("aqgIU", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", function () { return $79694dfe64b36155$export$63596d6ee8878b25; }, function (v) { return $79694dfe64b36155$export$63596d6ee8878b25 = v; });
var $79694dfe64b36155$export$63596d6ee8878b25;
"use strict";
$79694dfe64b36155$export$63596d6ee8878b25 = $79694dfe64b36155$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $79694dfe64b36155$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRequire.register("3zLqi", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $29a96d3433dbe5d2$export$4659b591c19bdf3d; }, function (v) { return $29a96d3433dbe5d2$export$4659b591c19bdf3d = v; });
var $29a96d3433dbe5d2$export$4659b591c19bdf3d;
"use strict";
$29a96d3433dbe5d2$export$4659b591c19bdf3d = void 0;

var $9Sy75 = parcelRequire("9Sy75");

var $chFVg = parcelRequire("chFVg");
const $29a96d3433dbe5d2$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $29a96d3433dbe5d2$var$parseOrdinalNumberPattern = /\d+/i;
const $29a96d3433dbe5d2$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $29a96d3433dbe5d2$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $29a96d3433dbe5d2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $29a96d3433dbe5d2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $29a96d3433dbe5d2$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $29a96d3433dbe5d2$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $29a96d3433dbe5d2$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $29a96d3433dbe5d2$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $29a96d3433dbe5d2$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $29a96d3433dbe5d2$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $29a96d3433dbe5d2$var$match = $29a96d3433dbe5d2$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $chFVg.buildMatchPatternFn)({
        matchPattern: $29a96d3433dbe5d2$var$matchOrdinalNumberPattern,
        parsePattern: $29a96d3433dbe5d2$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $9Sy75.buildMatchFn)({
        matchPatterns: $29a96d3433dbe5d2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29a96d3433dbe5d2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $9Sy75.buildMatchFn)({
        matchPatterns: $29a96d3433dbe5d2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29a96d3433dbe5d2$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $9Sy75.buildMatchFn)({
        matchPatterns: $29a96d3433dbe5d2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29a96d3433dbe5d2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $9Sy75.buildMatchFn)({
        matchPatterns: $29a96d3433dbe5d2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29a96d3433dbe5d2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $9Sy75.buildMatchFn)({
        matchPatterns: $29a96d3433dbe5d2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $29a96d3433dbe5d2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRequire.register("9Sy75", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", function () { return $73139e64e60d1792$export$1430a0f35710914d; }, function (v) { return $73139e64e60d1792$export$1430a0f35710914d = v; });
var $73139e64e60d1792$export$1430a0f35710914d;
"use strict";
$73139e64e60d1792$export$1430a0f35710914d = $73139e64e60d1792$var$buildMatchFn;
function $73139e64e60d1792$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $73139e64e60d1792$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $73139e64e60d1792$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $73139e64e60d1792$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $73139e64e60d1792$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRequire.register("chFVg", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", function () { return $8f1797898a6aebfc$export$fdaf2fd6d7edde95; }, function (v) { return $8f1797898a6aebfc$export$fdaf2fd6d7edde95 = v; });
var $8f1797898a6aebfc$export$fdaf2fd6d7edde95;
"use strict";
$8f1797898a6aebfc$export$fdaf2fd6d7edde95 = $8f1797898a6aebfc$var$buildMatchPatternFn;
function $8f1797898a6aebfc$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});




parcelRequire.register("i8n62", function(module, exports) {

$parcel$export(module.exports, "formatters", function () { return $d33ae3d5a0e02bce$export$fe98a034cfb96d55; }, function (v) { return $d33ae3d5a0e02bce$export$fe98a034cfb96d55 = v; });
var $d33ae3d5a0e02bce$export$fe98a034cfb96d55;
"use strict";
$d33ae3d5a0e02bce$export$fe98a034cfb96d55 = void 0;

var $jnaCb = parcelRequire("jnaCb");

var $4Csci = parcelRequire("4Csci");

var $ctBkT = parcelRequire("ctBkT");

var $8qqRl = parcelRequire("8qqRl");

var $jvZLi = parcelRequire("jvZLi");

var $iR4RJ = parcelRequire("iR4RJ");

var $gdN1B = parcelRequire("gdN1B");
const $d33ae3d5a0e02bce$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $d33ae3d5a0e02bce$var$formatters = $d33ae3d5a0e02bce$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $gdN1B.lightFormatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $jvZLi.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $iR4RJ.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $iR4RJ.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $ctBkT.getISOWeekYear)(date);
        // Padding
        return (0, $iR4RJ.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $iR4RJ.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $iR4RJ.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $iR4RJ.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $gdN1B.lightFormatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $iR4RJ.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $8qqRl.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $iR4RJ.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $4Csci.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $iR4RJ.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $gdN1B.lightFormatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $jnaCb.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $iR4RJ.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $iR4RJ.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $iR4RJ.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $iR4RJ.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d33ae3d5a0e02bce$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d33ae3d5a0e02bce$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d33ae3d5a0e02bce$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d33ae3d5a0e02bce$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d33ae3d5a0e02bce$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d33ae3d5a0e02bce$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $gdN1B.lightFormatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $gdN1B.lightFormatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $iR4RJ.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $iR4RJ.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $gdN1B.lightFormatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $gdN1B.lightFormatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $gdN1B.lightFormatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $d33ae3d5a0e02bce$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $d33ae3d5a0e02bce$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $d33ae3d5a0e02bce$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $d33ae3d5a0e02bce$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $d33ae3d5a0e02bce$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $d33ae3d5a0e02bce$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $d33ae3d5a0e02bce$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $d33ae3d5a0e02bce$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $d33ae3d5a0e02bce$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $d33ae3d5a0e02bce$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $iR4RJ.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $iR4RJ.addLeadingZeros)(timestamp, token.length);
    }
};
function $d33ae3d5a0e02bce$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $iR4RJ.addLeadingZeros)(minutes, 2);
}
function $d33ae3d5a0e02bce$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $iR4RJ.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $d33ae3d5a0e02bce$var$formatTimezone(offset, delimiter);
}
function $d33ae3d5a0e02bce$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $iR4RJ.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $iR4RJ.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRequire.register("jnaCb", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", function () { return $e1a866371dce8642$export$d3b42cd8452deec; }, function (v) { return $e1a866371dce8642$export$d3b42cd8452deec = v; });
var $e1a866371dce8642$export$d3b42cd8452deec;
"use strict";
$e1a866371dce8642$export$d3b42cd8452deec = $e1a866371dce8642$var$getDayOfYear;

var $doy2h = parcelRequire("doy2h");

var $4Gfnp = parcelRequire("4Gfnp");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $e1a866371dce8642$var$getDayOfYear(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const diff = (0, $doy2h.differenceInCalendarDays)(_date, (0, $4Gfnp.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}

});

parcelRequire.register("4Csci", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", function () { return $35d0956db4436da0$export$7cabdc5698b63e2f; }, function (v) { return $35d0956db4436da0$export$7cabdc5698b63e2f = v; });
var $35d0956db4436da0$export$7cabdc5698b63e2f;
"use strict";
$35d0956db4436da0$export$7cabdc5698b63e2f = $35d0956db4436da0$var$getISOWeek;

var $5K4u1 = parcelRequire("5K4u1");

var $6nmfz = parcelRequire("6nmfz");

var $gIGHk = parcelRequire("gIGHk");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $35d0956db4436da0$var$getISOWeek(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const diff = +(0, $6nmfz.startOfISOWeek)(_date) - +(0, $gIGHk.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $5K4u1.millisecondsInWeek) + 1;
}

});
parcelRequire.register("6nmfz", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", function () { return $4a462678717980ec$export$6173213f95a4431e; }, function (v) { return $4a462678717980ec$export$6173213f95a4431e = v; });
var $4a462678717980ec$export$6173213f95a4431e;
"use strict";
$4a462678717980ec$export$6173213f95a4431e = $4a462678717980ec$var$startOfISOWeek;

var $5Wrs3 = parcelRequire("5Wrs3");
/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $4a462678717980ec$var$startOfISOWeek(date) {
    return (0, $5Wrs3.startOfWeek)(date, {
        weekStartsOn: 1
    });
}

});

parcelRequire.register("gIGHk", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", function () { return $c2c1e053903daed1$export$236bdfa374eb69a9; }, function (v) { return $c2c1e053903daed1$export$236bdfa374eb69a9 = v; });
var $c2c1e053903daed1$export$236bdfa374eb69a9;
"use strict";
$c2c1e053903daed1$export$236bdfa374eb69a9 = $c2c1e053903daed1$var$startOfISOWeekYear;

var $ctBkT = parcelRequire("ctBkT");

var $6nmfz = parcelRequire("6nmfz");

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $c2c1e053903daed1$var$startOfISOWeekYear(date) {
    const year = (0, $ctBkT.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $cHwnM.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $6nmfz.startOfISOWeek)(fourthOfJanuary);
}

});
parcelRequire.register("ctBkT", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", function () { return $915527a46aee9bae$export$3dbc52535f6f8fcc; }, function (v) { return $915527a46aee9bae$export$3dbc52535f6f8fcc = v; });
var $915527a46aee9bae$export$3dbc52535f6f8fcc;
"use strict";
$915527a46aee9bae$export$3dbc52535f6f8fcc = $915527a46aee9bae$var$getISOWeekYear;

var $cHwnM = parcelRequire("cHwnM");

var $6nmfz = parcelRequire("6nmfz");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $915527a46aee9bae$var$getISOWeekYear(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $cHwnM.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $6nmfz.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $cHwnM.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $6nmfz.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRequire.register("8qqRl", function(module, exports) {

$parcel$export(module.exports, "getWeek", function () { return $62259626aeae5942$export$efe19b760242b2fc; }, function (v) { return $62259626aeae5942$export$efe19b760242b2fc = v; });
var $62259626aeae5942$export$efe19b760242b2fc;
"use strict";
$62259626aeae5942$export$efe19b760242b2fc = $62259626aeae5942$var$getWeek;

var $5K4u1 = parcelRequire("5K4u1");

var $5Wrs3 = parcelRequire("5Wrs3");

var $9pItP = parcelRequire("9pItP");

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $62259626aeae5942$var$getWeek(date, options) {
    const _date = (0, $hC8hz.toDate)(date);
    const diff = +(0, $5Wrs3.startOfWeek)(_date, options) - +(0, $9pItP.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $5K4u1.millisecondsInWeek) + 1;
}

});
parcelRequire.register("9pItP", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", function () { return $6da8f3b18a1754aa$export$bb7b45bb8e74da0f; }, function (v) { return $6da8f3b18a1754aa$export$bb7b45bb8e74da0f = v; });
var $6da8f3b18a1754aa$export$bb7b45bb8e74da0f;
"use strict";
$6da8f3b18a1754aa$export$bb7b45bb8e74da0f = $6da8f3b18a1754aa$var$startOfWeekYear;

var $cHwnM = parcelRequire("cHwnM");

var $jvZLi = parcelRequire("jvZLi");

var $5Wrs3 = parcelRequire("5Wrs3");

var $3Om6B = parcelRequire("3Om6B");
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $6da8f3b18a1754aa$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $jvZLi.getWeekYear)(date, options);
    const firstWeek = (0, $cHwnM.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $5Wrs3.startOfWeek)(firstWeek, options);
    return _date;
}

});
parcelRequire.register("jvZLi", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", function () { return $e350d22bdfd44611$export$12d572480ceb6e58; }, function (v) { return $e350d22bdfd44611$export$12d572480ceb6e58 = v; });
var $e350d22bdfd44611$export$12d572480ceb6e58;
"use strict";
$e350d22bdfd44611$export$12d572480ceb6e58 = $e350d22bdfd44611$var$getWeekYear;

var $cHwnM = parcelRequire("cHwnM");

var $5Wrs3 = parcelRequire("5Wrs3");

var $hC8hz = parcelRequire("hC8hz");

var $3Om6B = parcelRequire("3Om6B");
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $e350d22bdfd44611$var$getWeekYear(date, options) {
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $cHwnM.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $5Wrs3.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $cHwnM.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $5Wrs3.startOfWeek)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRequire.register("iR4RJ", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", function () { return $dba0f370f8f325ad$export$c8306e720e213c0f; }, function (v) { return $dba0f370f8f325ad$export$c8306e720e213c0f = v; });
var $dba0f370f8f325ad$export$c8306e720e213c0f;
"use strict";
$dba0f370f8f325ad$export$c8306e720e213c0f = $dba0f370f8f325ad$var$addLeadingZeros;
function $dba0f370f8f325ad$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRequire.register("gdN1B", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", function () { return $bcf3e393e56d8c94$export$b0d4b338e1516f13; }, function (v) { return $bcf3e393e56d8c94$export$b0d4b338e1516f13 = v; });
var $bcf3e393e56d8c94$export$b0d4b338e1516f13;
"use strict";
$bcf3e393e56d8c94$export$b0d4b338e1516f13 = void 0;

var $iR4RJ = parcelRequire("iR4RJ");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $bcf3e393e56d8c94$var$lightFormatters = $bcf3e393e56d8c94$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $iR4RJ.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $iR4RJ.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $iR4RJ.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $iR4RJ.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $iR4RJ.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $iR4RJ.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $iR4RJ.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $iR4RJ.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRequire.register("eLb1F", function(module, exports) {

$parcel$export(module.exports, "longFormatters", function () { return $abee01fa703d9197$export$70cc8fd02856fd58; }, function (v) { return $abee01fa703d9197$export$70cc8fd02856fd58 = v; });
var $abee01fa703d9197$export$70cc8fd02856fd58;
"use strict";
$abee01fa703d9197$export$70cc8fd02856fd58 = void 0;
const $abee01fa703d9197$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $abee01fa703d9197$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $abee01fa703d9197$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $abee01fa703d9197$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $abee01fa703d9197$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $abee01fa703d9197$var$timeLongFormatter(timePattern, formatLong));
};
const $abee01fa703d9197$var$longFormatters = $abee01fa703d9197$export$70cc8fd02856fd58 = {
    p: $abee01fa703d9197$var$timeLongFormatter,
    P: $abee01fa703d9197$var$dateTimeLongFormatter
};

});

parcelRequire.register("l6LL5", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $f5df34552fef7e29$export$c6cc36aa33304772; }, function (v) { return $f5df34552fef7e29$export$c6cc36aa33304772 = v; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $f5df34552fef7e29$export$c6b49d6dceb604a1; }, function (v) { return $f5df34552fef7e29$export$c6b49d6dceb604a1 = v; });
$parcel$export(module.exports, "warnOrThrowProtectedError", function () { return $f5df34552fef7e29$export$f5f38f90ecaaf879; }, function (v) { return $f5df34552fef7e29$export$f5f38f90ecaaf879 = v; });
var $f5df34552fef7e29$export$c6cc36aa33304772;
var $f5df34552fef7e29$export$c6b49d6dceb604a1;
var $f5df34552fef7e29$export$f5f38f90ecaaf879;
"use strict";
$f5df34552fef7e29$export$c6cc36aa33304772 = $f5df34552fef7e29$var$isProtectedDayOfYearToken;
$f5df34552fef7e29$export$c6b49d6dceb604a1 = $f5df34552fef7e29$var$isProtectedWeekYearToken;
$f5df34552fef7e29$export$f5f38f90ecaaf879 = $f5df34552fef7e29$var$warnOrThrowProtectedError;
const $f5df34552fef7e29$var$dayOfYearTokenRE = /^D+$/;
const $f5df34552fef7e29$var$weekYearTokenRE = /^Y+$/;
const $f5df34552fef7e29$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $f5df34552fef7e29$var$isProtectedDayOfYearToken(token) {
    return $f5df34552fef7e29$var$dayOfYearTokenRE.test(token);
}
function $f5df34552fef7e29$var$isProtectedWeekYearToken(token) {
    return $f5df34552fef7e29$var$weekYearTokenRE.test(token);
}
function $f5df34552fef7e29$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $f5df34552fef7e29$var$message(token, format, input);
    console.warn(_message);
    if ($f5df34552fef7e29$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $f5df34552fef7e29$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});


parcelRequire.register("i8QYr", function(module, exports) {

$parcel$export(module.exports, "getDate", function () { return $d35210d9308510d2$export$aa350b96d91cd94; }, function (v) { return $d35210d9308510d2$export$aa350b96d91cd94 = v; });
var $d35210d9308510d2$export$aa350b96d91cd94;
"use strict";
$d35210d9308510d2$export$aa350b96d91cd94 = $d35210d9308510d2$var$getDate;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */ function $d35210d9308510d2$var$getDate(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}

});

parcelRequire.register("6UKPj", function(module, exports) {

$parcel$export(module.exports, "getDay", function () { return $508c4bd9d484c3fb$export$1b64bc9c5306ed54; }, function (v) { return $508c4bd9d484c3fb$export$1b64bc9c5306ed54 = v; });
var $508c4bd9d484c3fb$export$1b64bc9c5306ed54;
"use strict";
$508c4bd9d484c3fb$export$1b64bc9c5306ed54 = $508c4bd9d484c3fb$var$getDay;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */ function $508c4bd9d484c3fb$var$getDay(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const day = _date.getDay();
    return day;
}

});

parcelRequire.register("cGh60", function(module, exports) {

$parcel$export(module.exports, "getHours", function () { return $93b6ab2505a04dcc$export$257b40f71c07d58f; }, function (v) { return $93b6ab2505a04dcc$export$257b40f71c07d58f = v; });
var $93b6ab2505a04dcc$export$257b40f71c07d58f;
"use strict";
$93b6ab2505a04dcc$export$257b40f71c07d58f = $93b6ab2505a04dcc$var$getHours;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */ function $93b6ab2505a04dcc$var$getHours(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const hours = _date.getHours();
    return hours;
}

});

parcelRequire.register("eoANb", function(module, exports) {

$parcel$export(module.exports, "getMinutes", function () { return $a7afd8c47ca2fb5f$export$b7f1bc3ea3ac4145; }, function (v) { return $a7afd8c47ca2fb5f$export$b7f1bc3ea3ac4145 = v; });
var $a7afd8c47ca2fb5f$export$b7f1bc3ea3ac4145;
"use strict";
$a7afd8c47ca2fb5f$export$b7f1bc3ea3ac4145 = $a7afd8c47ca2fb5f$var$getMinutes;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */ function $a7afd8c47ca2fb5f$var$getMinutes(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}

});

parcelRequire.register("4O1bq", function(module, exports) {

$parcel$export(module.exports, "getMonth", function () { return $37fcbfed1dd26cdd$export$6ce1b5acc29cb53b; }, function (v) { return $37fcbfed1dd26cdd$export$6ce1b5acc29cb53b = v; });
var $37fcbfed1dd26cdd$export$6ce1b5acc29cb53b;
"use strict";
$37fcbfed1dd26cdd$export$6ce1b5acc29cb53b = $37fcbfed1dd26cdd$var$getMonth;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */ function $37fcbfed1dd26cdd$var$getMonth(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const month = _date.getMonth();
    return month;
}

});

parcelRequire.register("olqzY", function(module, exports) {

$parcel$export(module.exports, "getSeconds", function () { return $0492dd19834b13e3$export$5e9417507ff28427; }, function (v) { return $0492dd19834b13e3$export$5e9417507ff28427 = v; });
var $0492dd19834b13e3$export$5e9417507ff28427;
"use strict";
$0492dd19834b13e3$export$5e9417507ff28427 = $0492dd19834b13e3$var$getSeconds;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */ function $0492dd19834b13e3$var$getSeconds(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}

});

parcelRequire.register("rRcG9", function(module, exports) {

$parcel$export(module.exports, "getTime", function () { return $053bcad667bc0e8a$export$1428f42a7de81803; }, function (v) { return $053bcad667bc0e8a$export$1428f42a7de81803 = v; });
var $053bcad667bc0e8a$export$1428f42a7de81803;
"use strict";
$053bcad667bc0e8a$export$1428f42a7de81803 = $053bcad667bc0e8a$var$getTime;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */ function $053bcad667bc0e8a$var$getTime(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const timestamp = _date.getTime();
    return timestamp;
}

});

parcelRequire.register("54r2S", function(module, exports) {

$parcel$export(module.exports, "getYear", function () { return $3b124e25c87b74c4$export$5846dc2d57a5c860; }, function (v) { return $3b124e25c87b74c4$export$5846dc2d57a5c860 = v; });
var $3b124e25c87b74c4$export$5846dc2d57a5c860;
"use strict";
$3b124e25c87b74c4$export$5846dc2d57a5c860 = $3b124e25c87b74c4$var$getYear;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */ function $3b124e25c87b74c4$var$getYear(date) {
    return (0, $hC8hz.toDate)(date).getFullYear();
}

});

parcelRequire.register("ar9gY", function(module, exports) {

$parcel$export(module.exports, "isAfter", function () { return $79939e5c441fc3db$export$e4de839670987035; }, function (v) { return $79939e5c441fc3db$export$e4de839670987035 = v; });
var $79939e5c441fc3db$export$e4de839670987035;
"use strict";
$79939e5c441fc3db$export$e4de839670987035 = $79939e5c441fc3db$var$isAfter;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */ function $79939e5c441fc3db$var$isAfter(date, dateToCompare) {
    const _date = (0, $hC8hz.toDate)(date);
    const _dateToCompare = (0, $hC8hz.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}

});

parcelRequire.register("i4Id9", function(module, exports) {

$parcel$export(module.exports, "isBefore", function () { return $d28ae5256d29a07c$export$5c007e10c6929c95; }, function (v) { return $d28ae5256d29a07c$export$5c007e10c6929c95 = v; });
var $d28ae5256d29a07c$export$5c007e10c6929c95;
"use strict";
$d28ae5256d29a07c$export$5c007e10c6929c95 = $d28ae5256d29a07c$var$isBefore;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $d28ae5256d29a07c$var$isBefore(date, dateToCompare) {
    const _date = (0, $hC8hz.toDate)(date);
    const _dateToCompare = (0, $hC8hz.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}

});

parcelRequire.register("cl3rs", function(module, exports) {

$parcel$export(module.exports, "isEqual", function () { return $8fba1dacaaadff34$export$248d38f6296296c5; }, function (v) { return $8fba1dacaaadff34$export$248d38f6296296c5 = v; });
var $8fba1dacaaadff34$export$248d38f6296296c5;
"use strict";
$8fba1dacaaadff34$export$248d38f6296296c5 = $8fba1dacaaadff34$var$isEqual;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */ function $8fba1dacaaadff34$var$isEqual(leftDate, rightDate) {
    const _dateLeft = (0, $hC8hz.toDate)(leftDate);
    const _dateRight = (0, $hC8hz.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}

});

parcelRequire.register("56yXI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $eLb1F.longFormatters;
    }
});
module.exports.parse = $3b78a209abb71b31$var$parse;
Object.defineProperty(module.exports, "parsers", {
    enumerable: true,
    get: function() {
        return $5QpUZ.parsers;
    }
});

var $cHwnM = parcelRequire("cHwnM");

var $76zm5 = parcelRequire("76zm5");

var $eEdOT = parcelRequire("eEdOT");

var $hC8hz = parcelRequire("hC8hz");

var $eLb1F = parcelRequire("eLb1F");

var $l6LL5 = parcelRequire("l6LL5");

var $5QpUZ = parcelRequire("5QpUZ");

var $jDYAP = parcelRequire("jDYAP");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $3b78a209abb71b31$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $3b78a209abb71b31$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $3b78a209abb71b31$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $3b78a209abb71b31$var$doubleQuoteRegExp = /''/g;
const $3b78a209abb71b31$var$notWhitespaceRegExp = /\S/;
const $3b78a209abb71b31$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $3b78a209abb71b31$var$parse(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $76zm5.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $eEdOT.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $hC8hz.toDate)(referenceDate);
        else return (0, $cHwnM.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new $jDYAP.DateToSystemTimezoneSetter()
    ];
    const tokens = formatStr.match($3b78a209abb71b31$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in $eLb1F.longFormatters) {
            const longFormatter = $eLb1F.longFormatters[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($3b78a209abb71b31$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $l6LL5.isProtectedWeekYearToken)(token)) (0, $l6LL5.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $l6LL5.isProtectedDayOfYearToken)(token)) (0, $l6LL5.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = $5QpUZ.parsers[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens  } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $cHwnM.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($3b78a209abb71b31$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $3b78a209abb71b31$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $cHwnM.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $3b78a209abb71b31$var$notWhitespaceRegExp.test(dateStr)) return (0, $cHwnM.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $hC8hz.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $cHwnM.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $cHwnM.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $cHwnM.constructFrom)(referenceDate, date);
}
function $3b78a209abb71b31$var$cleanEscapedString(input) {
    return input.match($3b78a209abb71b31$var$escapedStringRegExp)[1].replace($3b78a209abb71b31$var$doubleQuoteRegExp, "'");
}

});
parcelRequire.register("76zm5", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $52c484c1a92e7b44$export$430a3269e24b912e; }, function (v) { return $52c484c1a92e7b44$export$430a3269e24b912e = v; });
var $52c484c1a92e7b44$export$430a3269e24b912e;
"use strict";
$52c484c1a92e7b44$export$430a3269e24b912e = $52c484c1a92e7b44$var$getDefaultOptions;

var $3Om6B = parcelRequire("3Om6B");
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ function $52c484c1a92e7b44$var$getDefaultOptions() {
    return Object.assign({}, (0, $3Om6B.getDefaultOptions)());
}

});

parcelRequire.register("5QpUZ", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $4415e9e648913bcc$export$19131010e7fd8373; }, function (v) { return $4415e9e648913bcc$export$19131010e7fd8373 = v; });
var $4415e9e648913bcc$export$19131010e7fd8373;
"use strict";
$4415e9e648913bcc$export$19131010e7fd8373 = void 0;

var $4NFqH = parcelRequire("4NFqH");

var $YCrl1 = parcelRequire("YCrl1");

var $3b3Ll = parcelRequire("3b3Ll");

var $1wfBW = parcelRequire("1wfBW");

var $kX6x1 = parcelRequire("kX6x1");

var $5OeAn = parcelRequire("5OeAn");

var $6u03E = parcelRequire("6u03E");

var $3Nn2I = parcelRequire("3Nn2I");

var $ldVKn = parcelRequire("ldVKn");

var $fR8v3 = parcelRequire("fR8v3");

var $bpW6O = parcelRequire("bpW6O");

var $he4mB = parcelRequire("he4mB");

var $5z5ya = parcelRequire("5z5ya");

var $UTDfL = parcelRequire("UTDfL");

var $iCSb3 = parcelRequire("iCSb3");

var $keEEp = parcelRequire("keEEp");

var $ctDRs = parcelRequire("ctDRs");

var $Ayzh5 = parcelRequire("Ayzh5");

var $e2u5q = parcelRequire("e2u5q");

var $18aPG = parcelRequire("18aPG");

var $axs1G = parcelRequire("axs1G");

var $alDwg = parcelRequire("alDwg");

var $iqFxr = parcelRequire("iqFxr");

var $eJt2U = parcelRequire("eJt2U");

var $djrh4 = parcelRequire("djrh4");

var $ck0Zd = parcelRequire("ck0Zd");

var $hbSOX = parcelRequire("hbSOX");

var $cUKN2 = parcelRequire("cUKN2");

var $1epbt = parcelRequire("1epbt");

var $e9ABM = parcelRequire("e9ABM");

var $gGTf4 = parcelRequire("gGTf4");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
const $4415e9e648913bcc$var$parsers = $4415e9e648913bcc$export$19131010e7fd8373 = {
    G: new $4NFqH.EraParser(),
    y: new $YCrl1.YearParser(),
    Y: new $3b3Ll.LocalWeekYearParser(),
    R: new $1wfBW.ISOWeekYearParser(),
    u: new $kX6x1.ExtendedYearParser(),
    Q: new $5OeAn.QuarterParser(),
    q: new $6u03E.StandAloneQuarterParser(),
    M: new $3Nn2I.MonthParser(),
    L: new $ldVKn.StandAloneMonthParser(),
    w: new $fR8v3.LocalWeekParser(),
    I: new $bpW6O.ISOWeekParser(),
    d: new $he4mB.DateParser(),
    D: new $5z5ya.DayOfYearParser(),
    E: new $UTDfL.DayParser(),
    e: new $iCSb3.LocalDayParser(),
    c: new $keEEp.StandAloneLocalDayParser(),
    i: new $ctDRs.ISODayParser(),
    a: new $Ayzh5.AMPMParser(),
    b: new $e2u5q.AMPMMidnightParser(),
    B: new $18aPG.DayPeriodParser(),
    h: new $axs1G.Hour1to12Parser(),
    H: new $alDwg.Hour0to23Parser(),
    K: new $iqFxr.Hour0To11Parser(),
    k: new $eJt2U.Hour1To24Parser(),
    m: new $djrh4.MinuteParser(),
    s: new $ck0Zd.SecondParser(),
    S: new $hbSOX.FractionOfSecondParser(),
    X: new $cUKN2.ISOTimezoneWithZParser(),
    x: new $1epbt.ISOTimezoneParser(),
    t: new $e9ABM.TimestampSecondsParser(),
    T: new $gGTf4.TimestampMillisecondsParser()
};

});
parcelRequire.register("4NFqH", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $37ebe01604c06522$export$8e5a1d3f85a9688; }, function (v) { return $37ebe01604c06522$export$8e5a1d3f85a9688 = v; });
var $37ebe01604c06522$export$8e5a1d3f85a9688;
"use strict";
$37ebe01604c06522$export$8e5a1d3f85a9688 = void 0;

var $4zD61 = parcelRequire("4zD61");
class $37ebe01604c06522$var$EraParser extends $4zD61.Parser {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}
$37ebe01604c06522$export$8e5a1d3f85a9688 = $37ebe01604c06522$var$EraParser;

});
parcelRequire.register("4zD61", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $3548c1fa52804fc5$export$7acfa6ed01010e37; }, function (v) { return $3548c1fa52804fc5$export$7acfa6ed01010e37 = v; });
var $3548c1fa52804fc5$export$7acfa6ed01010e37;
"use strict";
$3548c1fa52804fc5$export$7acfa6ed01010e37 = void 0;

var $jDYAP = parcelRequire("jDYAP");
class $3548c1fa52804fc5$var$Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new $jDYAP.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}
$3548c1fa52804fc5$export$7acfa6ed01010e37 = $3548c1fa52804fc5$var$Parser;

});
parcelRequire.register("jDYAP", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $e4d0a95e00409c5e$export$9a09e32dd4990fd5; }, function (v) { return $e4d0a95e00409c5e$export$9a09e32dd4990fd5 = v; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $e4d0a95e00409c5e$export$5aaf7ff7f09ea4ee; }, function (v) { return $e4d0a95e00409c5e$export$5aaf7ff7f09ea4ee = v; });
var $e4d0a95e00409c5e$export$9a09e32dd4990fd5;
var $e4d0a95e00409c5e$export$81d53e3678089a6;
var $e4d0a95e00409c5e$export$5aaf7ff7f09ea4ee;
"use strict";
$e4d0a95e00409c5e$export$9a09e32dd4990fd5 = $e4d0a95e00409c5e$export$81d53e3678089a6 = $e4d0a95e00409c5e$export$5aaf7ff7f09ea4ee = void 0;

var $b1Lww = parcelRequire("b1Lww");

var $cHwnM = parcelRequire("cHwnM");
const $e4d0a95e00409c5e$var$TIMEZONE_UNIT_PRIORITY = 10;
class $e4d0a95e00409c5e$var$Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
$e4d0a95e00409c5e$export$81d53e3678089a6 = $e4d0a95e00409c5e$var$Setter;
class $e4d0a95e00409c5e$var$ValueSetter extends $e4d0a95e00409c5e$var$Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
$e4d0a95e00409c5e$export$9a09e32dd4990fd5 = $e4d0a95e00409c5e$var$ValueSetter;
class $e4d0a95e00409c5e$var$DateToSystemTimezoneSetter extends $e4d0a95e00409c5e$var$Setter {
    priority = $e4d0a95e00409c5e$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $cHwnM.constructFrom)(date, (0, $b1Lww.transpose)(date, Date));
    }
}
$e4d0a95e00409c5e$export$5aaf7ff7f09ea4ee = $e4d0a95e00409c5e$var$DateToSystemTimezoneSetter;

});
parcelRequire.register("b1Lww", function(module, exports) {

$parcel$export(module.exports, "transpose", function () { return $8074a6e79a90b236$export$9cb09a71b7d66923; }, function (v) { return $8074a6e79a90b236$export$9cb09a71b7d66923 = v; });
var $8074a6e79a90b236$export$9cb09a71b7d66923;
"use strict";
$8074a6e79a90b236$export$9cb09a71b7d66923 = $8074a6e79a90b236$var$transpose;

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ function $8074a6e79a90b236$var$transpose(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $cHwnM.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}

});




parcelRequire.register("YCrl1", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $0b636c14e92becfc$export$48d352de7cd4a988; }, function (v) { return $0b636c14e92becfc$export$48d352de7cd4a988 = v; });
var $0b636c14e92becfc$export$48d352de7cd4a988;
"use strict";
$0b636c14e92becfc$export$48d352de7cd4a988 = void 0;

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class $0b636c14e92becfc$var$YearParser extends $4zD61.Parser {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $1wyy9.mapValue)((0, $1wyy9.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, $1wyy9.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $1wyy9.mapValue)((0, $1wyy9.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $1wyy9.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$0b636c14e92becfc$export$48d352de7cd4a988 = $0b636c14e92becfc$var$YearParser;

});
parcelRequire.register("1wyy9", function(module, exports) {

$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $11c3947c2150be60$export$fb506d2676e7f207; }, function (v) { return $11c3947c2150be60$export$fb506d2676e7f207 = v; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $11c3947c2150be60$export$3d50627710b84d75; }, function (v) { return $11c3947c2150be60$export$3d50627710b84d75 = v; });
$parcel$export(module.exports, "mapValue", function () { return $11c3947c2150be60$export$4f84e3a82c7b538; }, function (v) { return $11c3947c2150be60$export$4f84e3a82c7b538 = v; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $11c3947c2150be60$export$29126f735cbf69f7; }, function (v) { return $11c3947c2150be60$export$29126f735cbf69f7 = v; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $11c3947c2150be60$export$d931c43c4608a164; }, function (v) { return $11c3947c2150be60$export$d931c43c4608a164 = v; });
$parcel$export(module.exports, "parseNDigits", function () { return $11c3947c2150be60$export$513bb01536146ab6; }, function (v) { return $11c3947c2150be60$export$513bb01536146ab6 = v; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $11c3947c2150be60$export$2c9307b2e29c533c; }, function (v) { return $11c3947c2150be60$export$2c9307b2e29c533c = v; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $11c3947c2150be60$export$cc7cc9e2a3ff9388; }, function (v) { return $11c3947c2150be60$export$cc7cc9e2a3ff9388 = v; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $11c3947c2150be60$export$6497f4c0ecdfba8e; }, function (v) { return $11c3947c2150be60$export$6497f4c0ecdfba8e = v; });
var $11c3947c2150be60$export$fb506d2676e7f207;
var $11c3947c2150be60$export$3d50627710b84d75;
var $11c3947c2150be60$export$4f84e3a82c7b538;
var $11c3947c2150be60$export$29126f735cbf69f7;
var $11c3947c2150be60$export$d931c43c4608a164;
var $11c3947c2150be60$export$513bb01536146ab6;
var $11c3947c2150be60$export$2c9307b2e29c533c;
var $11c3947c2150be60$export$cc7cc9e2a3ff9388;
var $11c3947c2150be60$export$6497f4c0ecdfba8e;
"use strict";
$11c3947c2150be60$export$fb506d2676e7f207 = $11c3947c2150be60$var$dayPeriodEnumToHours;
$11c3947c2150be60$export$3d50627710b84d75 = $11c3947c2150be60$var$isLeapYearIndex;
$11c3947c2150be60$export$4f84e3a82c7b538 = $11c3947c2150be60$var$mapValue;
$11c3947c2150be60$export$29126f735cbf69f7 = $11c3947c2150be60$var$normalizeTwoDigitYear;
$11c3947c2150be60$export$d931c43c4608a164 = $11c3947c2150be60$var$parseAnyDigitsSigned;
$11c3947c2150be60$export$513bb01536146ab6 = $11c3947c2150be60$var$parseNDigits;
$11c3947c2150be60$export$2c9307b2e29c533c = $11c3947c2150be60$var$parseNDigitsSigned;
$11c3947c2150be60$export$cc7cc9e2a3ff9388 = $11c3947c2150be60$var$parseNumericPattern;
$11c3947c2150be60$export$6497f4c0ecdfba8e = $11c3947c2150be60$var$parseTimezonePattern;

var $5K4u1 = parcelRequire("5K4u1");

var $d4bpz = parcelRequire("d4bpz");
function $11c3947c2150be60$var$mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $11c3947c2150be60$var$parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $11c3947c2150be60$var$parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $5K4u1.millisecondsInHour + minutes * $5K4u1.millisecondsInMinute + seconds * $5K4u1.millisecondsInSecond),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $11c3947c2150be60$var$parseAnyDigitsSigned(dateString) {
    return $11c3947c2150be60$var$parseNumericPattern($d4bpz.numericPatterns.anyDigitsSigned, dateString);
}
function $11c3947c2150be60$var$parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return $11c3947c2150be60$var$parseNumericPattern($d4bpz.numericPatterns.singleDigit, dateString);
        case 2:
            return $11c3947c2150be60$var$parseNumericPattern($d4bpz.numericPatterns.twoDigits, dateString);
        case 3:
            return $11c3947c2150be60$var$parseNumericPattern($d4bpz.numericPatterns.threeDigits, dateString);
        case 4:
            return $11c3947c2150be60$var$parseNumericPattern($d4bpz.numericPatterns.fourDigits, dateString);
        default:
            return $11c3947c2150be60$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $11c3947c2150be60$var$parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return $11c3947c2150be60$var$parseNumericPattern($d4bpz.numericPatterns.singleDigitSigned, dateString);
        case 2:
            return $11c3947c2150be60$var$parseNumericPattern($d4bpz.numericPatterns.twoDigitsSigned, dateString);
        case 3:
            return $11c3947c2150be60$var$parseNumericPattern($d4bpz.numericPatterns.threeDigitsSigned, dateString);
        case 4:
            return $11c3947c2150be60$var$parseNumericPattern($d4bpz.numericPatterns.fourDigitsSigned, dateString);
        default:
            return $11c3947c2150be60$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $11c3947c2150be60$var$dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $11c3947c2150be60$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $11c3947c2150be60$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRequire.register("d4bpz", function(module, exports) {

$parcel$export(module.exports, "timezonePatterns", function () { return $9834802461875b90$export$a7ee192b982af9c1; }, function (v) { return $9834802461875b90$export$a7ee192b982af9c1 = v; });
$parcel$export(module.exports, "numericPatterns", function () { return $9834802461875b90$export$c123ee06d9da8480; }, function (v) { return $9834802461875b90$export$c123ee06d9da8480 = v; });
var $9834802461875b90$export$a7ee192b982af9c1;
var $9834802461875b90$export$c123ee06d9da8480;
"use strict";
$9834802461875b90$export$a7ee192b982af9c1 = $9834802461875b90$export$c123ee06d9da8480 = void 0;
const $9834802461875b90$var$numericPatterns = $9834802461875b90$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $9834802461875b90$var$timezonePatterns = $9834802461875b90$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRequire.register("3b3Ll", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $250551552cd16c23$export$b8ef38dfcf05d5db; }, function (v) { return $250551552cd16c23$export$b8ef38dfcf05d5db = v; });
var $250551552cd16c23$export$b8ef38dfcf05d5db;
"use strict";
$250551552cd16c23$export$b8ef38dfcf05d5db = void 0;

var $jvZLi = parcelRequire("jvZLi");

var $5Wrs3 = parcelRequire("5Wrs3");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// Local week-numbering year
class $250551552cd16c23$var$LocalWeekYearParser extends $4zD61.Parser {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $1wyy9.mapValue)((0, $1wyy9.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, $1wyy9.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $1wyy9.mapValue)((0, $1wyy9.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $jvZLi.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $1wyy9.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $5Wrs3.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $5Wrs3.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$250551552cd16c23$export$b8ef38dfcf05d5db = $250551552cd16c23$var$LocalWeekYearParser;

});

parcelRequire.register("1wfBW", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $11b4e39d5dfcd8be$export$951d1df011fde06f; }, function (v) { return $11b4e39d5dfcd8be$export$951d1df011fde06f = v; });
var $11b4e39d5dfcd8be$export$951d1df011fde06f;
"use strict";
$11b4e39d5dfcd8be$export$951d1df011fde06f = void 0;

var $6nmfz = parcelRequire("6nmfz");

var $cHwnM = parcelRequire("cHwnM");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// ISO week-numbering year
class $11b4e39d5dfcd8be$var$ISOWeekYearParser extends $4zD61.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $1wyy9.parseNDigitsSigned)(4, dateString);
        return (0, $1wyy9.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $cHwnM.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $6nmfz.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$11b4e39d5dfcd8be$export$951d1df011fde06f = $11b4e39d5dfcd8be$var$ISOWeekYearParser;

});

parcelRequire.register("kX6x1", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $f40e62663db88713$export$bad9d2ea38e8f1a; }, function (v) { return $f40e62663db88713$export$bad9d2ea38e8f1a = v; });
var $f40e62663db88713$export$bad9d2ea38e8f1a;
"use strict";
$f40e62663db88713$export$bad9d2ea38e8f1a = void 0;

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $f40e62663db88713$var$ExtendedYearParser extends $4zD61.Parser {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $1wyy9.parseNDigitsSigned)(4, dateString);
        return (0, $1wyy9.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f40e62663db88713$export$bad9d2ea38e8f1a = $f40e62663db88713$var$ExtendedYearParser;

});

parcelRequire.register("5OeAn", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $43acefb0595f6c37$export$5cb0f701186dde1d; }, function (v) { return $43acefb0595f6c37$export$5cb0f701186dde1d = v; });
var $43acefb0595f6c37$export$5cb0f701186dde1d;
"use strict";
$43acefb0595f6c37$export$5cb0f701186dde1d = void 0;

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $43acefb0595f6c37$var$QuarterParser extends $4zD61.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$43acefb0595f6c37$export$5cb0f701186dde1d = $43acefb0595f6c37$var$QuarterParser;

});

parcelRequire.register("6u03E", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $4b8596eb319ddd4e$export$300c0c2990e20e6d; }, function (v) { return $4b8596eb319ddd4e$export$300c0c2990e20e6d = v; });
var $4b8596eb319ddd4e$export$300c0c2990e20e6d;
"use strict";
$4b8596eb319ddd4e$export$300c0c2990e20e6d = void 0;

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $4b8596eb319ddd4e$var$StandAloneQuarterParser extends $4zD61.Parser {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$4b8596eb319ddd4e$export$300c0c2990e20e6d = $4b8596eb319ddd4e$var$StandAloneQuarterParser;

});

parcelRequire.register("3Nn2I", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $2c37d2844e26818b$export$400dd8b40ef138a3; }, function (v) { return $2c37d2844e26818b$export$400dd8b40ef138a3 = v; });
var $2c37d2844e26818b$export$400dd8b40ef138a3;
"use strict";
$2c37d2844e26818b$export$400dd8b40ef138a3 = void 0;

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $2c37d2844e26818b$var$MonthParser extends $4zD61.Parser {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $1wyy9.mapValue)((0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $1wyy9.mapValue)((0, $1wyy9.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $1wyy9.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}
$2c37d2844e26818b$export$400dd8b40ef138a3 = $2c37d2844e26818b$var$MonthParser;

});

parcelRequire.register("ldVKn", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $f7379b38244c68f8$export$1d7eaa53eaa5deba; }, function (v) { return $f7379b38244c68f8$export$1d7eaa53eaa5deba = v; });
var $f7379b38244c68f8$export$1d7eaa53eaa5deba;
"use strict";
$f7379b38244c68f8$export$1d7eaa53eaa5deba = void 0;

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $f7379b38244c68f8$var$StandAloneMonthParser extends $4zD61.Parser {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $1wyy9.mapValue)((0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $1wyy9.mapValue)((0, $1wyy9.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $1wyy9.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$f7379b38244c68f8$export$1d7eaa53eaa5deba = $f7379b38244c68f8$var$StandAloneMonthParser;

});

parcelRequire.register("fR8v3", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $b8b266206e8a5b91$export$c4005ffc174e07c0; }, function (v) { return $b8b266206e8a5b91$export$c4005ffc174e07c0 = v; });
var $b8b266206e8a5b91$export$c4005ffc174e07c0;
"use strict";
$b8b266206e8a5b91$export$c4005ffc174e07c0 = void 0;

var $i1aSz = parcelRequire("i1aSz");

var $5Wrs3 = parcelRequire("5Wrs3");

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// Local week of year
class $b8b266206e8a5b91$var$LocalWeekParser extends $4zD61.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $5Wrs3.startOfWeek)((0, $i1aSz.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}
$b8b266206e8a5b91$export$c4005ffc174e07c0 = $b8b266206e8a5b91$var$LocalWeekParser;

});
parcelRequire.register("i1aSz", function(module, exports) {

$parcel$export(module.exports, "setWeek", function () { return $d1e0c25a169bcda3$export$4b3066ce4afafd88; }, function (v) { return $d1e0c25a169bcda3$export$4b3066ce4afafd88 = v; });
var $d1e0c25a169bcda3$export$4b3066ce4afafd88;
"use strict";
$d1e0c25a169bcda3$export$4b3066ce4afafd88 = $d1e0c25a169bcda3$var$setWeek;

var $8qqRl = parcelRequire("8qqRl");

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ function $d1e0c25a169bcda3$var$setWeek(date, week, options) {
    const _date = (0, $hC8hz.toDate)(date);
    const diff = (0, $8qqRl.getWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRequire.register("bpW6O", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $84ff1ab2f4293a53$export$6fc8dbedd560a6af; }, function (v) { return $84ff1ab2f4293a53$export$6fc8dbedd560a6af = v; });
var $84ff1ab2f4293a53$export$6fc8dbedd560a6af;
"use strict";
$84ff1ab2f4293a53$export$6fc8dbedd560a6af = void 0;

var $i6h69 = parcelRequire("i6h69");

var $6nmfz = parcelRequire("6nmfz");

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// ISO week of year
class $84ff1ab2f4293a53$var$ISOWeekParser extends $4zD61.Parser {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $6nmfz.startOfISOWeek)((0, $i6h69.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}
$84ff1ab2f4293a53$export$6fc8dbedd560a6af = $84ff1ab2f4293a53$var$ISOWeekParser;

});
parcelRequire.register("i6h69", function(module, exports) {

$parcel$export(module.exports, "setISOWeek", function () { return $d2d60ce2c411d9af$export$6542bebf6be94082; }, function (v) { return $d2d60ce2c411d9af$export$6542bebf6be94082 = v; });
var $d2d60ce2c411d9af$export$6542bebf6be94082;
"use strict";
$d2d60ce2c411d9af$export$6542bebf6be94082 = $d2d60ce2c411d9af$var$setISOWeek;

var $4Csci = parcelRequire("4Csci");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ function $d2d60ce2c411d9af$var$setISOWeek(date, week) {
    const _date = (0, $hC8hz.toDate)(date);
    const diff = (0, $4Csci.getISOWeek)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}

});


parcelRequire.register("he4mB", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $c8a720fddbf6111e$export$e8d4b28a20981dd2; }, function (v) { return $c8a720fddbf6111e$export$e8d4b28a20981dd2 = v; });
var $c8a720fddbf6111e$export$e8d4b28a20981dd2;
"use strict";
$c8a720fddbf6111e$export$e8d4b28a20981dd2 = void 0;

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
const $c8a720fddbf6111e$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $c8a720fddbf6111e$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Day of the month
class $c8a720fddbf6111e$var$DateParser extends $4zD61.Parser {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $1wyy9.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $c8a720fddbf6111e$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $c8a720fddbf6111e$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$c8a720fddbf6111e$export$e8d4b28a20981dd2 = $c8a720fddbf6111e$var$DateParser;

});

parcelRequire.register("5z5ya", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $40d486ca090a6220$export$6cfe0d613455f615; }, function (v) { return $40d486ca090a6220$export$6cfe0d613455f615 = v; });
var $40d486ca090a6220$export$6cfe0d613455f615;
"use strict";
$40d486ca090a6220$export$6cfe0d613455f615 = void 0;

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $40d486ca090a6220$var$DayOfYearParser extends $4zD61.Parser {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $1wyy9.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$40d486ca090a6220$export$6cfe0d613455f615 = $40d486ca090a6220$var$DayOfYearParser;

});

parcelRequire.register("UTDfL", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $0ab06274f9150ad0$export$1b03c8b76262f7bd; }, function (v) { return $0ab06274f9150ad0$export$1b03c8b76262f7bd = v; });
var $0ab06274f9150ad0$export$1b03c8b76262f7bd;
"use strict";
$0ab06274f9150ad0$export$1b03c8b76262f7bd = void 0;

var $dU6Qg = parcelRequire("dU6Qg");

var $4zD61 = parcelRequire("4zD61");
// Day of week
class $0ab06274f9150ad0$var$DayParser extends $4zD61.Parser {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $dU6Qg.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}
$0ab06274f9150ad0$export$1b03c8b76262f7bd = $0ab06274f9150ad0$var$DayParser;

});
parcelRequire.register("dU6Qg", function(module, exports) {

$parcel$export(module.exports, "setDay", function () { return $a1f5cffca560a04b$export$b04fdcda82decc6c; }, function (v) { return $a1f5cffca560a04b$export$b04fdcda82decc6c = v; });
var $a1f5cffca560a04b$export$b04fdcda82decc6c;
"use strict";
$a1f5cffca560a04b$export$b04fdcda82decc6c = $a1f5cffca560a04b$var$setDay;

var $9wlqC = parcelRequire("9wlqC");

var $hC8hz = parcelRequire("hC8hz");

var $3Om6B = parcelRequire("3Om6B");
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $a1f5cffca560a04b$var$setDay(date, day, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $hC8hz.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $9wlqC.addDays)(_date, diff);
}

});


parcelRequire.register("iCSb3", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $d8f5cd10bcfe699b$export$44d1c127ab42c480; }, function (v) { return $d8f5cd10bcfe699b$export$44d1c127ab42c480 = v; });
var $d8f5cd10bcfe699b$export$44d1c127ab42c480;
"use strict";
$d8f5cd10bcfe699b$export$44d1c127ab42c480 = void 0;

var $dU6Qg = parcelRequire("dU6Qg");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// Local day of week
class $d8f5cd10bcfe699b$var$LocalDayParser extends $4zD61.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $1wyy9.mapValue)((0, $1wyy9.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $1wyy9.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $dU6Qg.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}
$d8f5cd10bcfe699b$export$44d1c127ab42c480 = $d8f5cd10bcfe699b$var$LocalDayParser;

});

parcelRequire.register("keEEp", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $ebb4a5dcb0397542$export$e447a647caaaec1d; }, function (v) { return $ebb4a5dcb0397542$export$e447a647caaaec1d = v; });
var $ebb4a5dcb0397542$export$e447a647caaaec1d;
"use strict";
$ebb4a5dcb0397542$export$e447a647caaaec1d = void 0;

var $dU6Qg = parcelRequire("dU6Qg");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// Stand-alone local day of week
class $ebb4a5dcb0397542$var$StandAloneLocalDayParser extends $4zD61.Parser {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $1wyy9.mapValue)((0, $1wyy9.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $1wyy9.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $dU6Qg.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}
$ebb4a5dcb0397542$export$e447a647caaaec1d = $ebb4a5dcb0397542$var$StandAloneLocalDayParser;

});

parcelRequire.register("ctDRs", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $91571d16afbceb59$export$693fb1e525095b2a; }, function (v) { return $91571d16afbceb59$export$693fb1e525095b2a = v; });
var $91571d16afbceb59$export$693fb1e525095b2a;
"use strict";
$91571d16afbceb59$export$693fb1e525095b2a = void 0;

var $2VCfD = parcelRequire("2VCfD");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// ISO day of week
class $91571d16afbceb59$var$ISODayParser extends $4zD61.Parser {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $1wyy9.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $1wyy9.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $1wyy9.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $1wyy9.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $2VCfD.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}
$91571d16afbceb59$export$693fb1e525095b2a = $91571d16afbceb59$var$ISODayParser;

});
parcelRequire.register("2VCfD", function(module, exports) {

$parcel$export(module.exports, "setISODay", function () { return $221e9382ab3ac717$export$1fd9df65adb0d1aa; }, function (v) { return $221e9382ab3ac717$export$1fd9df65adb0d1aa = v; });
var $221e9382ab3ac717$export$1fd9df65adb0d1aa;
"use strict";
$221e9382ab3ac717$export$1fd9df65adb0d1aa = $221e9382ab3ac717$var$setISODay;

var $9wlqC = parcelRequire("9wlqC");

var $6siAL = parcelRequire("6siAL");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ function $221e9382ab3ac717$var$setISODay(date, day) {
    const _date = (0, $hC8hz.toDate)(date);
    const currentDay = (0, $6siAL.getISODay)(_date);
    const diff = day - currentDay;
    return (0, $9wlqC.addDays)(_date, diff);
}

});
parcelRequire.register("6siAL", function(module, exports) {

$parcel$export(module.exports, "getISODay", function () { return $4b33c79299eece77$export$c514f4c1a8ed5e9e; }, function (v) { return $4b33c79299eece77$export$c514f4c1a8ed5e9e = v; });
var $4b33c79299eece77$export$c514f4c1a8ed5e9e;
"use strict";
$4b33c79299eece77$export$c514f4c1a8ed5e9e = $4b33c79299eece77$var$getISODay;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ function $4b33c79299eece77$var$getISODay(date) {
    const _date = (0, $hC8hz.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}

});



parcelRequire.register("Ayzh5", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $06de2d619e019e4d$export$8d1e08492351df91; }, function (v) { return $06de2d619e019e4d$export$8d1e08492351df91 = v; });
var $06de2d619e019e4d$export$8d1e08492351df91;
"use strict";
$06de2d619e019e4d$export$8d1e08492351df91 = void 0;

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $06de2d619e019e4d$var$AMPMParser extends $4zD61.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $1wyy9.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$06de2d619e019e4d$export$8d1e08492351df91 = $06de2d619e019e4d$var$AMPMParser;

});

parcelRequire.register("e2u5q", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $a388971f598c3717$export$73ca2bd0a17d273; }, function (v) { return $a388971f598c3717$export$73ca2bd0a17d273 = v; });
var $a388971f598c3717$export$73ca2bd0a17d273;
"use strict";
$a388971f598c3717$export$73ca2bd0a17d273 = void 0;

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $a388971f598c3717$var$AMPMMidnightParser extends $4zD61.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $1wyy9.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}
$a388971f598c3717$export$73ca2bd0a17d273 = $a388971f598c3717$var$AMPMMidnightParser;

});

parcelRequire.register("18aPG", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $0d2ef0e7a6210502$export$bb9212adf05373db; }, function (v) { return $0d2ef0e7a6210502$export$bb9212adf05373db = v; });
var $0d2ef0e7a6210502$export$bb9212adf05373db;
"use strict";
$0d2ef0e7a6210502$export$bb9212adf05373db = void 0;

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// in the morning, in the afternoon, in the evening, at night
class $0d2ef0e7a6210502$var$DayPeriodParser extends $4zD61.Parser {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $1wyy9.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}
$0d2ef0e7a6210502$export$bb9212adf05373db = $0d2ef0e7a6210502$var$DayPeriodParser;

});

parcelRequire.register("axs1G", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $7ac2b9d9b7209366$export$8a04050a727a1756; }, function (v) { return $7ac2b9d9b7209366$export$8a04050a727a1756 = v; });
var $7ac2b9d9b7209366$export$8a04050a727a1756;
"use strict";
$7ac2b9d9b7209366$export$8a04050a727a1756 = void 0;

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $7ac2b9d9b7209366$var$Hour1to12Parser extends $4zD61.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}
$7ac2b9d9b7209366$export$8a04050a727a1756 = $7ac2b9d9b7209366$var$Hour1to12Parser;

});

parcelRequire.register("alDwg", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $788a854715d81eb8$export$e56f4dea2c3e56dd; }, function (v) { return $788a854715d81eb8$export$e56f4dea2c3e56dd = v; });
var $788a854715d81eb8$export$e56f4dea2c3e56dd;
"use strict";
$788a854715d81eb8$export$e56f4dea2c3e56dd = void 0;

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $788a854715d81eb8$var$Hour0to23Parser extends $4zD61.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}
$788a854715d81eb8$export$e56f4dea2c3e56dd = $788a854715d81eb8$var$Hour0to23Parser;

});

parcelRequire.register("iqFxr", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $d6aae060b899fc5f$export$cbbe855312f87d77; }, function (v) { return $d6aae060b899fc5f$export$cbbe855312f87d77 = v; });
var $d6aae060b899fc5f$export$cbbe855312f87d77;
"use strict";
$d6aae060b899fc5f$export$cbbe855312f87d77 = void 0;

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $d6aae060b899fc5f$var$Hour0To11Parser extends $4zD61.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}
$d6aae060b899fc5f$export$cbbe855312f87d77 = $d6aae060b899fc5f$var$Hour0To11Parser;

});

parcelRequire.register("eJt2U", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $ab9bcc926d15357d$export$6008046d2b34b6a5; }, function (v) { return $ab9bcc926d15357d$export$6008046d2b34b6a5 = v; });
var $ab9bcc926d15357d$export$6008046d2b34b6a5;
"use strict";
$ab9bcc926d15357d$export$6008046d2b34b6a5 = void 0;

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $ab9bcc926d15357d$var$Hour1To24Parser extends $4zD61.Parser {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}
$ab9bcc926d15357d$export$6008046d2b34b6a5 = $ab9bcc926d15357d$var$Hour1To24Parser;

});

parcelRequire.register("djrh4", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $9b1234d73fce3b03$export$2b52670d9e2be53; }, function (v) { return $9b1234d73fce3b03$export$2b52670d9e2be53 = v; });
var $9b1234d73fce3b03$export$2b52670d9e2be53;
"use strict";
$9b1234d73fce3b03$export$2b52670d9e2be53 = void 0;

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $9b1234d73fce3b03$var$MinuteParser extends $4zD61.Parser {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$9b1234d73fce3b03$export$2b52670d9e2be53 = $9b1234d73fce3b03$var$MinuteParser;

});

parcelRequire.register("ck0Zd", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $8f881e2f36753533$export$94d46d540cf1366a; }, function (v) { return $8f881e2f36753533$export$94d46d540cf1366a = v; });
var $8f881e2f36753533$export$94d46d540cf1366a;
"use strict";
$8f881e2f36753533$export$94d46d540cf1366a = void 0;

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $8f881e2f36753533$var$SecondParser extends $4zD61.Parser {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $1wyy9.parseNumericPattern)($d4bpz.numericPatterns.second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $1wyy9.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$8f881e2f36753533$export$94d46d540cf1366a = $8f881e2f36753533$var$SecondParser;

});

parcelRequire.register("hbSOX", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $c83dfd04bdcf935a$export$b8e6f8b2d70893b1; }, function (v) { return $c83dfd04bdcf935a$export$b8e6f8b2d70893b1 = v; });
var $c83dfd04bdcf935a$export$b8e6f8b2d70893b1;
"use strict";
$c83dfd04bdcf935a$export$b8e6f8b2d70893b1 = void 0;

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $c83dfd04bdcf935a$var$FractionOfSecondParser extends $4zD61.Parser {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $1wyy9.mapValue)((0, $1wyy9.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}
$c83dfd04bdcf935a$export$b8e6f8b2d70893b1 = $c83dfd04bdcf935a$var$FractionOfSecondParser;

});

parcelRequire.register("cUKN2", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $966f027b0d3293c4$export$104d901d49fea29b; }, function (v) { return $966f027b0d3293c4$export$104d901d49fea29b = v; });
var $966f027b0d3293c4$export$104d901d49fea29b;
"use strict";
$966f027b0d3293c4$export$104d901d49fea29b = void 0;

var $cHwnM = parcelRequire("cHwnM");

var $gORYf = parcelRequire("gORYf");

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// Timezone (ISO-8601. +00:00 is `'Z'`)
class $966f027b0d3293c4$var$ISOTimezoneWithZParser extends $4zD61.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $1wyy9.parseTimezonePattern)($d4bpz.timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
                return (0, $1wyy9.parseTimezonePattern)($d4bpz.timezonePatterns.basic, dateString);
            case "XXXX":
                return (0, $1wyy9.parseTimezonePattern)($d4bpz.timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $1wyy9.parseTimezonePattern)($d4bpz.timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $1wyy9.parseTimezonePattern)($d4bpz.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $cHwnM.constructFrom)(date, date.getTime() - (0, $gORYf.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}
$966f027b0d3293c4$export$104d901d49fea29b = $966f027b0d3293c4$var$ISOTimezoneWithZParser;

});

parcelRequire.register("1epbt", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $0e5aa241502c7930$export$12910e5204b52b9; }, function (v) { return $0e5aa241502c7930$export$12910e5204b52b9 = v; });
var $0e5aa241502c7930$export$12910e5204b52b9;
"use strict";
$0e5aa241502c7930$export$12910e5204b52b9 = void 0;

var $cHwnM = parcelRequire("cHwnM");

var $gORYf = parcelRequire("gORYf");

var $d4bpz = parcelRequire("d4bpz");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
// Timezone (ISO-8601)
class $0e5aa241502c7930$var$ISOTimezoneParser extends $4zD61.Parser {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $1wyy9.parseTimezonePattern)($d4bpz.timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
                return (0, $1wyy9.parseTimezonePattern)($d4bpz.timezonePatterns.basic, dateString);
            case "xxxx":
                return (0, $1wyy9.parseTimezonePattern)($d4bpz.timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $1wyy9.parseTimezonePattern)($d4bpz.timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $1wyy9.parseTimezonePattern)($d4bpz.timezonePatterns.extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $cHwnM.constructFrom)(date, date.getTime() - (0, $gORYf.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}
$0e5aa241502c7930$export$12910e5204b52b9 = $0e5aa241502c7930$var$ISOTimezoneParser;

});

parcelRequire.register("e9ABM", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $a4de4da1cd2e311a$export$2cd8bf877a05e96; }, function (v) { return $a4de4da1cd2e311a$export$2cd8bf877a05e96 = v; });
var $a4de4da1cd2e311a$export$2cd8bf877a05e96;
"use strict";
$a4de4da1cd2e311a$export$2cd8bf877a05e96 = void 0;

var $cHwnM = parcelRequire("cHwnM");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $a4de4da1cd2e311a$var$TimestampSecondsParser extends $4zD61.Parser {
    priority = 40;
    parse(dateString) {
        return (0, $1wyy9.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $cHwnM.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$a4de4da1cd2e311a$export$2cd8bf877a05e96 = $a4de4da1cd2e311a$var$TimestampSecondsParser;

});

parcelRequire.register("gGTf4", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $c26b6b871c9f0823$export$6d8f69c6906d6368; }, function (v) { return $c26b6b871c9f0823$export$6d8f69c6906d6368 = v; });
var $c26b6b871c9f0823$export$6d8f69c6906d6368;
"use strict";
$c26b6b871c9f0823$export$6d8f69c6906d6368 = void 0;

var $cHwnM = parcelRequire("cHwnM");

var $4zD61 = parcelRequire("4zD61");

var $1wyy9 = parcelRequire("1wyy9");
class $c26b6b871c9f0823$var$TimestampMillisecondsParser extends $4zD61.Parser {
    priority = 20;
    parse(dateString) {
        return (0, $1wyy9.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $cHwnM.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}
$c26b6b871c9f0823$export$6d8f69c6906d6368 = $c26b6b871c9f0823$var$TimestampMillisecondsParser;

});



parcelRequire.register("jHVEe", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", function () { return $e58ec0240735f30a$export$a18c89cbd24170ff; }, function (v) { return $e58ec0240735f30a$export$a18c89cbd24170ff = v; });
var $e58ec0240735f30a$export$a18c89cbd24170ff;
"use strict";
$e58ec0240735f30a$export$a18c89cbd24170ff = $e58ec0240735f30a$var$isSameMonth;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ function $e58ec0240735f30a$var$isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}

});

parcelRequire.register("fTF2B", function(module, exports) {

$parcel$export(module.exports, "isSameQuarter", function () { return $b92bd3ee949a373c$export$5c60e4190867161c; }, function (v) { return $b92bd3ee949a373c$export$5c60e4190867161c = v; });
var $b92bd3ee949a373c$export$5c60e4190867161c;
"use strict";
$b92bd3ee949a373c$export$5c60e4190867161c = $b92bd3ee949a373c$var$isSameQuarter;

var $iNa3w = parcelRequire("iNa3w");
/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $b92bd3ee949a373c$var$isSameQuarter(dateLeft, dateRight) {
    const dateLeftStartOfQuarter = (0, $iNa3w.startOfQuarter)(dateLeft);
    const dateRightStartOfQuarter = (0, $iNa3w.startOfQuarter)(dateRight);
    return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

});

parcelRequire.register("cHSNE", function(module, exports) {

$parcel$export(module.exports, "isSameYear", function () { return $9404024f3fddd512$export$5841f9eb9773f25f; }, function (v) { return $9404024f3fddd512$export$5841f9eb9773f25f = v; });
var $9404024f3fddd512$export$5841f9eb9773f25f;
"use strict";
$9404024f3fddd512$export$5841f9eb9773f25f = $9404024f3fddd512$var$isSameYear;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */ function $9404024f3fddd512$var$isSameYear(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

});

parcelRequire.register("k7NE3", function(module, exports) {

$parcel$export(module.exports, "isWithinInterval", function () { return $ea6af88fd398ee3a$export$d7deef7a3738e19d; }, function (v) { return $ea6af88fd398ee3a$export$d7deef7a3738e19d = v; });
var $ea6af88fd398ee3a$export$d7deef7a3738e19d;
"use strict";
$ea6af88fd398ee3a$export$d7deef7a3738e19d = $ea6af88fd398ee3a$var$isWithinInterval;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */ function $ea6af88fd398ee3a$var$isWithinInterval(date, interval) {
    const time = +(0, $hC8hz.toDate)(date);
    const [startTime, endTime] = [
        +(0, $hC8hz.toDate)(interval.start),
        +(0, $hC8hz.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}

});

parcelRequire.register("6nsOA", function(module, exports) {

$parcel$export(module.exports, "subDays", function () { return $4a4b3e143f165dc4$export$70823084e2deb1ea; }, function (v) { return $4a4b3e143f165dc4$export$70823084e2deb1ea = v; });
var $4a4b3e143f165dc4$export$70823084e2deb1ea;
"use strict";
$4a4b3e143f165dc4$export$70823084e2deb1ea = $4a4b3e143f165dc4$var$subDays;

var $9wlqC = parcelRequire("9wlqC");
/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */ function $4a4b3e143f165dc4$var$subDays(date, amount) {
    return (0, $9wlqC.addDays)(date, -amount);
}

});

parcelRequire.register("lgH58", function(module, exports) {

$parcel$export(module.exports, "parseISO", function () { return $f7bc82bbd51b4f6a$export$4393d2ccbbedb219; }, function (v) { return $f7bc82bbd51b4f6a$export$4393d2ccbbedb219 = v; });
var $f7bc82bbd51b4f6a$export$4393d2ccbbedb219;
"use strict";
$f7bc82bbd51b4f6a$export$4393d2ccbbedb219 = $f7bc82bbd51b4f6a$var$parseISO;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ function $f7bc82bbd51b4f6a$var$parseISO(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $f7bc82bbd51b4f6a$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $f7bc82bbd51b4f6a$var$parseYear(dateStrings.date, additionalDigits);
        date = $f7bc82bbd51b4f6a$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $f7bc82bbd51b4f6a$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $f7bc82bbd51b4f6a$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $f7bc82bbd51b4f6a$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $f7bc82bbd51b4f6a$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $f7bc82bbd51b4f6a$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $f7bc82bbd51b4f6a$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $f7bc82bbd51b4f6a$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($f7bc82bbd51b4f6a$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($f7bc82bbd51b4f6a$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($f7bc82bbd51b4f6a$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $f7bc82bbd51b4f6a$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $f7bc82bbd51b4f6a$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $f7bc82bbd51b4f6a$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($f7bc82bbd51b4f6a$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $f7bc82bbd51b4f6a$var$parseDateUnit(captures[1]);
    const month = $f7bc82bbd51b4f6a$var$parseDateUnit(captures[2]) - 1;
    const day = $f7bc82bbd51b4f6a$var$parseDateUnit(captures[3]);
    const week = $f7bc82bbd51b4f6a$var$parseDateUnit(captures[4]);
    const dayOfWeek = $f7bc82bbd51b4f6a$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$f7bc82bbd51b4f6a$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $f7bc82bbd51b4f6a$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$f7bc82bbd51b4f6a$var$validateDate(year, month, day) || !$f7bc82bbd51b4f6a$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $f7bc82bbd51b4f6a$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $f7bc82bbd51b4f6a$var$parseTime(timeString) {
    const captures = timeString.match($f7bc82bbd51b4f6a$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $f7bc82bbd51b4f6a$var$parseTimeUnit(captures[1]);
    const minutes = $f7bc82bbd51b4f6a$var$parseTimeUnit(captures[2]);
    const seconds = $f7bc82bbd51b4f6a$var$parseTimeUnit(captures[3]);
    if (!$f7bc82bbd51b4f6a$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $5K4u1.millisecondsInHour + minutes * $5K4u1.millisecondsInMinute + seconds * 1000;
}
function $f7bc82bbd51b4f6a$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $f7bc82bbd51b4f6a$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($f7bc82bbd51b4f6a$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$f7bc82bbd51b4f6a$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $5K4u1.millisecondsInHour + minutes * $5K4u1.millisecondsInMinute);
}
function $f7bc82bbd51b4f6a$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $f7bc82bbd51b4f6a$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $f7bc82bbd51b4f6a$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $f7bc82bbd51b4f6a$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($f7bc82bbd51b4f6a$var$daysInMonths[month] || ($f7bc82bbd51b4f6a$var$isLeapYearIndex(year) ? 29 : 28));
}
function $f7bc82bbd51b4f6a$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($f7bc82bbd51b4f6a$var$isLeapYearIndex(year) ? 366 : 365);
}
function $f7bc82bbd51b4f6a$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $f7bc82bbd51b4f6a$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $f7bc82bbd51b4f6a$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRequire.register("9pNHm", function(module, exports) {

$parcel$export(module.exports, "set", function () { return $6dacffe711655d45$export$adaa4cf7ef1b65be; }, function (v) { return $6dacffe711655d45$export$adaa4cf7ef1b65be = v; });
var $6dacffe711655d45$export$adaa4cf7ef1b65be;
"use strict";
$6dacffe711655d45$export$adaa4cf7ef1b65be = $6dacffe711655d45$var$set;

var $cHwnM = parcelRequire("cHwnM");

var $1q78y = parcelRequire("1q78y");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */ function $6dacffe711655d45$var$set(date, values) {
    let _date = (0, $hC8hz.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $cHwnM.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $1q78y.setMonth)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}

});
parcelRequire.register("1q78y", function(module, exports) {

$parcel$export(module.exports, "setMonth", function () { return $108dc16282d5c8de$export$63264690f8e36790; }, function (v) { return $108dc16282d5c8de$export$63264690f8e36790 = v; });
var $108dc16282d5c8de$export$63264690f8e36790;
"use strict";
$108dc16282d5c8de$export$63264690f8e36790 = $108dc16282d5c8de$var$setMonth;

var $cHwnM = parcelRequire("cHwnM");

var $l7LG5 = parcelRequire("l7LG5");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */ function $108dc16282d5c8de$var$setMonth(date, month) {
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $cHwnM.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $l7LG5.getDaysInMonth)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}

});
parcelRequire.register("l7LG5", function(module, exports) {

$parcel$export(module.exports, "getDaysInMonth", function () { return $f60f3c3e1dc21601$export$f645ddd439eb259d; }, function (v) { return $f60f3c3e1dc21601$export$f645ddd439eb259d = v; });
var $f60f3c3e1dc21601$export$f645ddd439eb259d;
"use strict";
$f60f3c3e1dc21601$export$f645ddd439eb259d = $f60f3c3e1dc21601$var$getDaysInMonth;

var $hC8hz = parcelRequire("hC8hz");

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */ function $f60f3c3e1dc21601$var$getDaysInMonth(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $cHwnM.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});



parcelRequire.register("547sc", function(module, exports) {

$parcel$export(module.exports, "setHours", function () { return $3b031ba5d1ab6e70$export$f86b797a4659b781; }, function (v) { return $3b031ba5d1ab6e70$export$f86b797a4659b781 = v; });
var $3b031ba5d1ab6e70$export$f86b797a4659b781;
"use strict";
$3b031ba5d1ab6e70$export$f86b797a4659b781 = $3b031ba5d1ab6e70$var$setHours;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */ function $3b031ba5d1ab6e70$var$setHours(date, hours) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setHours(hours);
    return _date;
}

});

parcelRequire.register("ghUWP", function(module, exports) {

$parcel$export(module.exports, "setMinutes", function () { return $bdba688af3a7213d$export$ad569bf1c79ea89d; }, function (v) { return $bdba688af3a7213d$export$ad569bf1c79ea89d = v; });
var $bdba688af3a7213d$export$ad569bf1c79ea89d;
"use strict";
$bdba688af3a7213d$export$ad569bf1c79ea89d = $bdba688af3a7213d$var$setMinutes;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */ function $bdba688af3a7213d$var$setMinutes(date, minutes) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}

});

parcelRequire.register("cU7p8", function(module, exports) {

$parcel$export(module.exports, "setQuarter", function () { return $96507560e57d11bc$export$8924d1de7efe1755; }, function (v) { return $96507560e57d11bc$export$8924d1de7efe1755 = v; });
var $96507560e57d11bc$export$8924d1de7efe1755;
"use strict";
$96507560e57d11bc$export$8924d1de7efe1755 = $96507560e57d11bc$var$setQuarter;

var $1q78y = parcelRequire("1q78y");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */ function $96507560e57d11bc$var$setQuarter(date, quarter) {
    const _date = (0, $hC8hz.toDate)(date);
    const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $1q78y.setMonth)(_date, _date.getMonth() + diff * 3);
}

});

parcelRequire.register("uUUNl", function(module, exports) {

$parcel$export(module.exports, "setSeconds", function () { return $05cef39955b850f2$export$aec44746644cbf43; }, function (v) { return $05cef39955b850f2$export$aec44746644cbf43 = v; });
var $05cef39955b850f2$export$aec44746644cbf43;
"use strict";
$05cef39955b850f2$export$aec44746644cbf43 = $05cef39955b850f2$var$setSeconds;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */ function $05cef39955b850f2$var$setSeconds(date, seconds) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}

});

parcelRequire.register("l8aUK", function(module, exports) {

$parcel$export(module.exports, "setYear", function () { return $f622cfb43a0f40da$export$a8408b6c5639cab7; }, function (v) { return $f622cfb43a0f40da$export$a8408b6c5639cab7 = v; });
var $f622cfb43a0f40da$export$a8408b6c5639cab7;
"use strict";
$f622cfb43a0f40da$export$a8408b6c5639cab7 = $f622cfb43a0f40da$var$setYear;

var $cHwnM = parcelRequire("cHwnM");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */ function $f622cfb43a0f40da$var$setYear(date, year) {
    const _date = (0, $hC8hz.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $cHwnM.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}

});

parcelRequire.register("3Dc48", function(module, exports) {

$parcel$export(module.exports, "subMonths", function () { return $2a4e5fa29e4f5a43$export$73d1c15a21f9fae5; }, function (v) { return $2a4e5fa29e4f5a43$export$73d1c15a21f9fae5 = v; });
var $2a4e5fa29e4f5a43$export$73d1c15a21f9fae5;
"use strict";
$2a4e5fa29e4f5a43$export$73d1c15a21f9fae5 = $2a4e5fa29e4f5a43$var$subMonths;

var $eTI3m = parcelRequire("eTI3m");
/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */ function $2a4e5fa29e4f5a43$var$subMonths(date, amount) {
    return (0, $eTI3m.addMonths)(date, -amount);
}

});

parcelRequire.register("66PGz", function(module, exports) {

$parcel$export(module.exports, "subQuarters", function () { return $472b654b5016ad8c$export$a31bfeeeee80cce6; }, function (v) { return $472b654b5016ad8c$export$a31bfeeeee80cce6 = v; });
var $472b654b5016ad8c$export$a31bfeeeee80cce6;
"use strict";
$472b654b5016ad8c$export$a31bfeeeee80cce6 = $472b654b5016ad8c$var$subQuarters;

var $9S1sJ = parcelRequire("9S1sJ");
/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */ function $472b654b5016ad8c$var$subQuarters(date, amount) {
    return (0, $9S1sJ.addQuarters)(date, -amount);
}

});

parcelRequire.register("h0WZn", function(module, exports) {

$parcel$export(module.exports, "subWeeks", function () { return $c63031b515c1c276$export$b4d8ae6376193efb; }, function (v) { return $c63031b515c1c276$export$b4d8ae6376193efb = v; });
var $c63031b515c1c276$export$b4d8ae6376193efb;
"use strict";
$c63031b515c1c276$export$b4d8ae6376193efb = $c63031b515c1c276$var$subWeeks;

var $zLu4w = parcelRequire("zLu4w");
/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */ function $c63031b515c1c276$var$subWeeks(date, amount) {
    return (0, $zLu4w.addWeeks)(date, -amount);
}

});

parcelRequire.register("bPd2N", function(module, exports) {

$parcel$export(module.exports, "subYears", function () { return $89be936f9dc0a0c5$export$14867687ff6c92e2; }, function (v) { return $89be936f9dc0a0c5$export$14867687ff6c92e2 = v; });
var $89be936f9dc0a0c5$export$14867687ff6c92e2;
"use strict";
$89be936f9dc0a0c5$export$14867687ff6c92e2 = $89be936f9dc0a0c5$var$subYears;

var $l1Mmy = parcelRequire("l1Mmy");
/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */ function $89be936f9dc0a0c5$var$subYears(date, amount) {
    return (0, $l1Mmy.addYears)(date, -amount);
}

});

parcelRequire.register("4qr5a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $fecb99b999628060$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $fecb99b999628060$export$2e2bcd8739ae039; });
function $fecb99b999628060$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fecb99b999628060$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fecb99b999628060$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fecb99b999628060$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fecb99b999628060$export$2e2bcd8739ae039 = $fecb99b999628060$export$4f5d2d50c9deca37;

});

parcelRequire.register("c8yWf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", function () { return $8d61557083094be1$export$e2911fc69bd3195e; });
$parcel$export(module.exports, "default", function () { return $8d61557083094be1$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
function $8d61557083094be1$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $8d61557083094be1$var$_setPrototypeOf(subClass, superClass);
}
function $8d61557083094be1$var$_setPrototypeOf(o, p) {
    $8d61557083094be1$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8d61557083094be1$var$_setPrototypeOf(o, p);
}
function $8d61557083094be1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8d61557083094be1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $8d61557083094be1$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $8d61557083094be1$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $8d61557083094be1$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $8d61557083094be1$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $8d61557083094be1$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === "undefined" || typeof window.addEventListener !== "function") return;
    var passive = false;
    var options = Object.defineProperty({}, "passive", {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener("testPassiveEventSupport", noop, options);
    window.removeEventListener("testPassiveEventSupport", noop, options);
    return passive;
};
function $8d61557083094be1$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $8d61557083094be1$var$uid = $8d61557083094be1$var$autoInc();
var $8d61557083094be1$var$passiveEventSupport;
var $8d61557083094be1$var$handlersMap = {};
var $8d61557083094be1$var$enabledInstances = {};
var $8d61557083094be1$var$touchEvents = [
    "touchstart",
    "touchmove"
];
var $8d61557083094be1$export$e2911fc69bd3195e = "ignore-react-onclickoutside";
/**
 * Options for addEventHandler and removeEventHandler
 */ function $8d61557083094be1$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = $8d61557083094be1$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $8d61557083094be1$var$passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $8d61557083094be1$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $8d61557083094be1$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === "function") {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === "function") {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === "function") {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === "function") return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === "function") return instance.setClickOutsideRef();
                return (0, $d2lNW.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === "undefined" || $8d61557083094be1$var$enabledInstances[_this._uid]) return;
                if (typeof $8d61557083094be1$var$passiveEventSupport === "undefined") $8d61557083094be1$var$passiveEventSupport = $8d61557083094be1$var$testPassiveEventSupport();
                $8d61557083094be1$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $8d61557083094be1$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.initTimeStamp > event.timeStamp) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $8d61557083094be1$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($8d61557083094be1$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $8d61557083094be1$var$handlersMap[_this._uid], $8d61557083094be1$var$getEventHandlerOptions($8d61557083094be1$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $8d61557083094be1$var$enabledInstances[_this._uid];
                var fn = $8d61557083094be1$var$handlersMap[_this._uid];
                if (fn && typeof document !== "undefined") {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $8d61557083094be1$var$getEventHandlerOptions($8d61557083094be1$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $8d61557083094be1$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $8d61557083094be1$var$uid();
            _this.initTimeStamp = performance.now();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === "undefined" || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === "function") {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== "function") throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $8d61557083094be1$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $exYeM.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $exYeM.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            "mousedown",
            "touchstart"
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $8d61557083094be1$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $8d61557083094be1$export$2e2bcd8739ae039 = $8d61557083094be1$var$onClickOutsideHOC;

});

parcelRequire.register("gOpT7", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $c3d565af0fdd1ebc$export$74665b213cb5c4cf; });
$parcel$export(module.exports, "FloatingList", function () { return $c3d565af0fdd1ebc$export$ffe15b0e64951704; });
$parcel$export(module.exports, "useListItem", function () { return $c3d565af0fdd1ebc$export$dcdc7ff5149f7d1a; });
$parcel$export(module.exports, "Composite", function () { return $c3d565af0fdd1ebc$export$43586241d9db0c6d; });
$parcel$export(module.exports, "CompositeItem", function () { return $c3d565af0fdd1ebc$export$ef1ef7a3a43ace8e; });
$parcel$export(module.exports, "useId", function () { return $c3d565af0fdd1ebc$export$f680877a34711e37; });
$parcel$export(module.exports, "FloatingArrow", function () { return $c3d565af0fdd1ebc$export$33511391554732bc; });
$parcel$export(module.exports, "useFloatingParentNodeId", function () { return $c3d565af0fdd1ebc$export$165209eae06d3488; });
$parcel$export(module.exports, "useFloatingTree", function () { return $c3d565af0fdd1ebc$export$db0c2a7c7a2a4f69; });
$parcel$export(module.exports, "useFloatingNodeId", function () { return $c3d565af0fdd1ebc$export$9b136e0e758a42f4; });
$parcel$export(module.exports, "FloatingNode", function () { return $c3d565af0fdd1ebc$export$ca00a83b5b253862; });
$parcel$export(module.exports, "FloatingTree", function () { return $c3d565af0fdd1ebc$export$587b60129641c4c8; });
$parcel$export(module.exports, "useHover", function () { return $c3d565af0fdd1ebc$export$ae780daf29e6d456; });
$parcel$export(module.exports, "useDelayGroupContext", function () { return $c3d565af0fdd1ebc$export$e2411914b150383d; });
$parcel$export(module.exports, "FloatingDelayGroup", function () { return $c3d565af0fdd1ebc$export$718279509ff1e241; });
$parcel$export(module.exports, "useDelayGroup", function () { return $c3d565af0fdd1ebc$export$560fc8be89c8b4a8; });
$parcel$export(module.exports, "useFloatingPortalNode", function () { return $c3d565af0fdd1ebc$export$ac107512f3c5cca6; });
$parcel$export(module.exports, "FloatingPortal", function () { return $c3d565af0fdd1ebc$export$31fa5d718fa2ac09; });
$parcel$export(module.exports, "FloatingFocusManager", function () { return $c3d565af0fdd1ebc$export$8aeee49171ded61a; });
$parcel$export(module.exports, "FloatingOverlay", function () { return $c3d565af0fdd1ebc$export$a35954495955337b; });
$parcel$export(module.exports, "useClick", function () { return $c3d565af0fdd1ebc$export$98524f11226063fc; });
$parcel$export(module.exports, "useClientPoint", function () { return $c3d565af0fdd1ebc$export$7fe170a73a621816; });
$parcel$export(module.exports, "useDismiss", function () { return $c3d565af0fdd1ebc$export$fcdf1ba5fafc089b; });
$parcel$export(module.exports, "useFloatingRootContext", function () { return $c3d565af0fdd1ebc$export$1df81146f8ad8e4c; });
$parcel$export(module.exports, "useFloating", function () { return $c3d565af0fdd1ebc$export$4e02a5c1d08bac65; });
$parcel$export(module.exports, "useFocus", function () { return $c3d565af0fdd1ebc$export$f8168d8dd8fd66e6; });
$parcel$export(module.exports, "useInteractions", function () { return $c3d565af0fdd1ebc$export$a519f7794e446ddd; });
$parcel$export(module.exports, "useListNavigation", function () { return $c3d565af0fdd1ebc$export$b5d22cac4ad33f40; });
$parcel$export(module.exports, "useRole", function () { return $c3d565af0fdd1ebc$export$f66572793fa256a1; });
$parcel$export(module.exports, "useTransitionStatus", function () { return $c3d565af0fdd1ebc$export$b2ef21706733f7e5; });
$parcel$export(module.exports, "useTransitionStyles", function () { return $c3d565af0fdd1ebc$export$769fba13884bc2f4; });
$parcel$export(module.exports, "useTypeahead", function () { return $c3d565af0fdd1ebc$export$d8d674d50b73ba93; });
$parcel$export(module.exports, "inner", function () { return $c3d565af0fdd1ebc$export$4ae363f1d88fb658; });
$parcel$export(module.exports, "useInnerOffset", function () { return $c3d565af0fdd1ebc$export$3d74b0dda7cc82ff; });
$parcel$export(module.exports, "safePolygon", function () { return $c3d565af0fdd1ebc$export$7484214ab62358d2; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("jiVm5")).arrow; });
$parcel$export(module.exports, "autoPlacement", function () { return (parcelRequire("jiVm5")).autoPlacement; });
$parcel$export(module.exports, "autoUpdate", function () { return (parcelRequire("9Q6OH")).autoUpdate; });
$parcel$export(module.exports, "computePosition", function () { return (parcelRequire("9Q6OH")).computePosition; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("9Q6OH")).detectOverflow; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("jiVm5")).flip; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return (parcelRequire("5UDEU")).getOverflowAncestors; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("jiVm5")).hide; });
$parcel$export(module.exports, "inline", function () { return (parcelRequire("jiVm5")).inline; });
$parcel$export(module.exports, "limitShift", function () { return (parcelRequire("jiVm5")).limitShift; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("jiVm5")).offset; });
$parcel$export(module.exports, "platform", function () { return (parcelRequire("9Q6OH")).platform; });
$parcel$export(module.exports, "shift", function () { return (parcelRequire("jiVm5")).shift; });
$parcel$export(module.exports, "size", function () { return (parcelRequire("jiVm5")).size; });

var $exYeM = parcelRequire("exYeM");

var $7YrgS = parcelRequire("7YrgS");

var $cCxCV = parcelRequire("cCxCV");

var $5UDEU = parcelRequire("5UDEU");

var $Nbv5D = parcelRequire("Nbv5D");

var $d2lNW = parcelRequire("d2lNW");

var $jiVm5 = parcelRequire("jiVm5");
var $9Q6OH = parcelRequire("9Q6OH");parcelRequire("9Q6OH");
var $5UDEU = parcelRequire("5UDEU");
var $9Q6OH = parcelRequire("9Q6OH");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $c3d565af0fdd1ebc$export$74665b213cb5c4cf(refs) {
    return $exYeM.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $c3d565af0fdd1ebc$var$SafeReact = {
    ...$exYeM
};
const $c3d565af0fdd1ebc$var$useInsertionEffect = $c3d565af0fdd1ebc$var$SafeReact.useInsertionEffect;
const $c3d565af0fdd1ebc$var$useSafeInsertionEffect = $c3d565af0fdd1ebc$var$useInsertionEffect || ((fn)=>fn());
function $c3d565af0fdd1ebc$var$useEffectEvent(callback) {
    const ref = $exYeM.useRef(()=>{});
    $c3d565af0fdd1ebc$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $exYeM.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $c3d565af0fdd1ebc$var$ARROW_UP = "ArrowUp";
const $c3d565af0fdd1ebc$var$ARROW_DOWN = "ArrowDown";
const $c3d565af0fdd1ebc$var$ARROW_LEFT = "ArrowLeft";
const $c3d565af0fdd1ebc$var$ARROW_RIGHT = "ArrowRight";
function $c3d565af0fdd1ebc$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $c3d565af0fdd1ebc$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $c3d565af0fdd1ebc$var$getMinIndex(listRef, disabledIndices) {
    return $c3d565af0fdd1ebc$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $c3d565af0fdd1ebc$var$getMaxIndex(listRef, disabledIndices) {
    return $c3d565af0fdd1ebc$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $c3d565af0fdd1ebc$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1 , decrement: decrement = false , disabledIndices: disabledIndices , amount: amount = 1  } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $c3d565af0fdd1ebc$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $c3d565af0fdd1ebc$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event , orientation: orientation , loop: loop , cols: cols , disabledIndices: disabledIndices , minIndex: minIndex , maxIndex: maxIndex , prevIndex: prevIndex , stopEvent: stop = false  } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $c3d565af0fdd1ebc$var$ARROW_UP) {
        stop && (0, $7YrgS.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($c3d565af0fdd1ebc$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $c3d565af0fdd1ebc$var$ARROW_DOWN) {
        stop && (0, $7YrgS.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($c3d565af0fdd1ebc$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === "both") {
        const prevRow = (0, $cCxCV.floor)(prevIndex / cols);
        if (event.key === $c3d565af0fdd1ebc$var$ARROW_RIGHT) {
            stop && (0, $7YrgS.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $c3d565af0fdd1ebc$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($c3d565af0fdd1ebc$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === $c3d565af0fdd1ebc$var$ARROW_LEFT) {
            stop && (0, $7YrgS.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $c3d565af0fdd1ebc$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($c3d565af0fdd1ebc$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $cCxCV.floor)(maxIndex / cols) === prevRow;
        if ($c3d565af0fdd1ebc$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === $c3d565af0fdd1ebc$var$ARROW_LEFT ? maxIndex : $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $c3d565af0fdd1ebc$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width , height: height  } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $c3d565af0fdd1ebc$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $c3d565af0fdd1ebc$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $c3d565af0fdd1ebc$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
let $c3d565af0fdd1ebc$var$rafId = 0;
function $c3d565af0fdd1ebc$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false , cancelPrevious: cancelPrevious = true , sync: sync = false  } = options;
    cancelPrevious && cancelAnimationFrame($c3d565af0fdd1ebc$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $c3d565af0fdd1ebc$var$rafId = requestAnimationFrame(exec);
}
var $c3d565af0fdd1ebc$var$index = typeof document !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
function $c3d565af0fdd1ebc$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $c3d565af0fdd1ebc$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $c3d565af0fdd1ebc$var$FloatingListContext = /*#__PURE__*/ $exYeM.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $c3d565af0fdd1ebc$export$ffe15b0e64951704(props) {
    const { children: children , elementsRef: elementsRef , labelsRef: labelsRef  } = props;
    const [map, setMap] = $exYeM.useState(()=>new Map());
    const register = $exYeM.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $exYeM.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $c3d565af0fdd1ebc$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($c3d565af0fdd1ebc$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$c3d565af0fdd1ebc$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$FloatingListContext.Provider, {
        value: $exYeM.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $c3d565af0fdd1ebc$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label  } = props;
    const { register: register , unregister: unregister , map: map , elementsRef: elementsRef , labelsRef: labelsRef  } = $exYeM.useContext($c3d565af0fdd1ebc$var$FloatingListContext);
    const [index$1, setIndex] = $exYeM.useState(null);
    const componentRef = $exYeM.useRef(null);
    const ref = $exYeM.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $exYeM.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $c3d565af0fdd1ebc$var$renderJsx(render, computedProps) {
    if (typeof render === "function") return render(computedProps);
    if (render) return /*#__PURE__*/ $exYeM.cloneElement(render, computedProps);
    return /*#__PURE__*/ $exYeM.createElement("div", computedProps);
}
const $c3d565af0fdd1ebc$var$CompositeContext = /*#__PURE__*/ $exYeM.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $c3d565af0fdd1ebc$var$horizontalKeys = [
    $c3d565af0fdd1ebc$var$ARROW_LEFT,
    $c3d565af0fdd1ebc$var$ARROW_RIGHT
];
const $c3d565af0fdd1ebc$var$verticalKeys = [
    $c3d565af0fdd1ebc$var$ARROW_UP,
    $c3d565af0fdd1ebc$var$ARROW_DOWN
];
const $c3d565af0fdd1ebc$var$allKeys = [
    ...$c3d565af0fdd1ebc$var$horizontalKeys,
    ...$c3d565af0fdd1ebc$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $c3d565af0fdd1ebc$export$43586241d9db0c6d = /*#__PURE__*/ $exYeM.forwardRef(function Composite(props, forwardedRef) {
    const { render: render , orientation: orientation = "both" , loop: loop = true , cols: cols = 1 , disabledIndices: disabledIndices , activeIndex: externalActiveIndex , onNavigate: externalSetActiveIndex , itemSizes: itemSizes , dense: dense = false , ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $exYeM.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $c3d565af0fdd1ebc$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $exYeM.useRef([]);
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const contextValue = $exYeM.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$c3d565af0fdd1ebc$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $c3d565af0fdd1ebc$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $c3d565af0fdd1ebc$var$getMaxIndex(elementsRef, disabledIndices);
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $c3d565af0fdd1ebc$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$c3d565af0fdd1ebc$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$c3d565af0fdd1ebc$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            nextIndex = cellMap[$c3d565af0fdd1ebc$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $c3d565af0fdd1ebc$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$c3d565af0fdd1ebc$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $c3d565af0fdd1ebc$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $c3d565af0fdd1ebc$var$ARROW_DOWN ? "bl" : event.key === $c3d565af0fdd1ebc$var$ARROW_RIGHT ? "tr" : "tl")
            })]; // navigated cell will never be nullish
        }
        const toEndKeys = {
            horizontal: [
                $c3d565af0fdd1ebc$var$ARROW_RIGHT
            ],
            vertical: [
                $c3d565af0fdd1ebc$var$ARROW_DOWN
            ],
            both: [
                $c3d565af0fdd1ebc$var$ARROW_RIGHT,
                $c3d565af0fdd1ebc$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                $c3d565af0fdd1ebc$var$ARROW_LEFT
            ],
            vertical: [
                $c3d565af0fdd1ebc$var$ARROW_UP
            ],
            both: [
                $c3d565af0fdd1ebc$var$ARROW_LEFT,
                $c3d565af0fdd1ebc$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $c3d565af0fdd1ebc$var$allKeys : ({
            horizontal: $c3d565af0fdd1ebc$var$horizontalKeys,
            vertical: $c3d565af0fdd1ebc$var$verticalKeys,
            both: $c3d565af0fdd1ebc$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $c3d565af0fdd1ebc$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$c3d565af0fdd1ebc$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            // Wait for FocusManager `returnFocus` to execute.
            queueMicrotask(()=>{
                $c3d565af0fdd1ebc$var$enqueueFocus(elementsRef.current[nextIndex]);
            });
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        "aria-orientation": orientation === "both" ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $c3d565af0fdd1ebc$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $c3d565af0fdd1ebc$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $exYeM.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render , ...domProps } = props;
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const { activeIndex: activeIndex , onNavigate: onNavigate  } = $exYeM.useContext($c3d565af0fdd1ebc$var$CompositeContext);
    const { ref: ref , index: index  } = $c3d565af0fdd1ebc$export$dcdc7ff5149f7d1a();
    const mergedRef = $c3d565af0fdd1ebc$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        "data-active": isActive ? "" : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $c3d565af0fdd1ebc$var$renderJsx(render, computedProps);
});
function $c3d565af0fdd1ebc$var$_extends() {
    $c3d565af0fdd1ebc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c3d565af0fdd1ebc$var$_extends.apply(this, arguments);
}
let $c3d565af0fdd1ebc$var$serverHandoffComplete = false;
let $c3d565af0fdd1ebc$var$count = 0;
const $c3d565af0fdd1ebc$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $c3d565af0fdd1ebc$var$count++;
function $c3d565af0fdd1ebc$var$useFloatingId() {
    const [id, setId] = $exYeM.useState(()=>$c3d565af0fdd1ebc$var$serverHandoffComplete ? $c3d565af0fdd1ebc$var$genId() : undefined);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (id == null) setId($c3d565af0fdd1ebc$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $exYeM.useEffect(()=>{
        $c3d565af0fdd1ebc$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $c3d565af0fdd1ebc$var$useReactId = $c3d565af0fdd1ebc$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $c3d565af0fdd1ebc$export$f680877a34711e37 = $c3d565af0fdd1ebc$var$useReactId || $c3d565af0fdd1ebc$var$useFloatingId;
let $c3d565af0fdd1ebc$var$devMessageSet;
function $c3d565af0fdd1ebc$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet = $c3d565af0fdd1ebc$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $c3d565af0fdd1ebc$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $c3d565af0fdd1ebc$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet3 = $c3d565af0fdd1ebc$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $c3d565af0fdd1ebc$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $c3d565af0fdd1ebc$export$33511391554732bc = /*#__PURE__*/ $exYeM.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement , elements: { floating: floating  } , middlewareData: { arrow: arrow  }  } , width: width = 14 , height: height = 7 , tipRadius: tipRadius = 0 , strokeWidth: strokeWidth = 0 , staticOffset: staticOffset , stroke: stroke , d: d , style: { transform: transform , ...restStyle } = {} , ...rest } = props;
    const clipPathId = $c3d565af0fdd1ebc$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $exYeM.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $c3d565af0fdd1ebc$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $5UDEU.getComputedStyle)(floating).direction === "rtl";
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const [side, alignment] = placement.split("-");
    const isCustomShape = !!d;
    const isVerticalSide = side === "top" || side === "bottom";
    const yOffsetProp = staticOffset && alignment === "end" ? "bottom" : "top";
    let xOffsetProp = staticOffset && alignment === "end" ? "right" : "left";
    if (staticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? staticOffset || arrow.x : "";
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? staticOffset || arrow.y : "";
    const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    const rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ $exYeM.createElement("svg", $c3d565af0fdd1ebc$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: "" + rotation + (transform != null ? transform : ""),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $exYeM.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $exYeM.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : "none",
        d: dValue
    }), /*#__PURE__*/ $exYeM.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $exYeM.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $c3d565af0fdd1ebc$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $c3d565af0fdd1ebc$var$FloatingNodeContext = /*#__PURE__*/ $exYeM.createContext(null);
const $c3d565af0fdd1ebc$var$FloatingTreeContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $c3d565af0fdd1ebc$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $exYeM.useContext($c3d565af0fdd1ebc$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $c3d565af0fdd1ebc$export$db0c2a7c7a2a4f69 = ()=>$exYeM.useContext($c3d565af0fdd1ebc$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $c3d565af0fdd1ebc$export$9b136e0e758a42f4(customParentId) {
    const id = $c3d565af0fdd1ebc$export$f680877a34711e37();
    const tree = $c3d565af0fdd1ebc$export$db0c2a7c7a2a4f69();
    const reactParentId = $c3d565af0fdd1ebc$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $c3d565af0fdd1ebc$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $c3d565af0fdd1ebc$export$ca00a83b5b253862(props) {
    const { children: children , id: id  } = props;
    const parentId = $c3d565af0fdd1ebc$export$165209eae06d3488();
    return /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$FloatingNodeContext.Provider, {
        value: $exYeM.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $c3d565af0fdd1ebc$export$587b60129641c4c8(props) {
    const { children: children  } = props;
    const nodesRef = $exYeM.useRef([]);
    const addNode = $exYeM.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $exYeM.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $exYeM.useState(()=>$c3d565af0fdd1ebc$var$createPubSub())[0];
    return /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$FloatingTreeContext.Provider, {
        value: $exYeM.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $c3d565af0fdd1ebc$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $c3d565af0fdd1ebc$var$useLatestRef(value) {
    const ref = (0, $exYeM.useRef)(value);
    $c3d565af0fdd1ebc$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $c3d565af0fdd1ebc$var$safePolygonIdentifier = /*#__PURE__*/ $c3d565af0fdd1ebc$var$createAttribute("safe-polygon");
function $c3d565af0fdd1ebc$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $7YrgS.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $c3d565af0fdd1ebc$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open , onOpenChange: onOpenChange , dataRef: dataRef , events: events , elements: elements  } = context;
    const { enabled: enabled = true , delay: delay = 0 , handleClose: handleClose = null , mouseOnly: mouseOnly = false , restMs: restMs = 0 , move: move = true  } = props;
    const tree = $c3d565af0fdd1ebc$export$db0c2a7c7a2a4f69();
    const parentId = $c3d565af0fdd1ebc$export$165209eae06d3488();
    const handleCloseRef = $c3d565af0fdd1ebc$var$useLatestRef(handleClose);
    const delayRef = $c3d565af0fdd1ebc$var$useLatestRef(delay);
    const openRef = $c3d565af0fdd1ebc$var$useLatestRef(open);
    const pointerTypeRef = $exYeM.useRef();
    const timeoutRef = $exYeM.useRef(-1);
    const handlerRef = $exYeM.useRef();
    const restTimeoutRef = $exYeM.useRef(-1);
    const blockMouseMoveRef = $exYeM.useRef(true);
    const performedPointerEventsMutationRef = $exYeM.useRef(false);
    const unbindMouseMoveRef = $exYeM.useRef(()=>{});
    const isHoverOpen = $exYeM.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $exYeM.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open  } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
            }
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $exYeM.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, "hover");
        }
        const html = (0, $7YrgS.getDocument)(elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $exYeM.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = "hover";
        const closeDelay = $c3d565af0fdd1ebc$var$getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $c3d565af0fdd1ebc$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $c3d565af0fdd1ebc$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $7YrgS.getDocument)(elements.floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute($c3d565af0fdd1ebc$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $exYeM.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                "click",
                "mousedown"
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $7YrgS.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !$c3d565af0fdd1ebc$var$getDelay(delayRef.current, "open")) return;
            const openDelay = $c3d565af0fdd1ebc$var$getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, "hover");
            }, openDelay);
            else onOpenChange(true, event, "hover");
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $7YrgS.getDocument)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay(event, true, "safe-polygon");
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === "touch" ? !(0, $7YrgS.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $5UDEU.isElement)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $c3d565af0fdd1ebc$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            const body = (0, $7YrgS.getDocument)(elements.floating).body;
            body.setAttribute($c3d565af0fdd1ebc$var$safePolygonIdentifier, "");
            body.style.pointerEvents = "none";
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $5UDEU.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                ref.style.pointerEvents = "auto";
                floatingEl.style.pointerEvents = "auto";
                return ()=>{
                    ref.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $exYeM.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $exYeM.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent  } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, "hover");
                }
                if (mouseOnly && !(0, $7YrgS.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === "touch") handleMouseMove();
                else restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $exYeM.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay
    ]);
    return $exYeM.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $c3d565af0fdd1ebc$var$NOOP = ()=>{};
const $c3d565af0fdd1ebc$var$FloatingDelayGroupContext = /*#__PURE__*/ $exYeM.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $c3d565af0fdd1ebc$var$NOOP,
    setState: $c3d565af0fdd1ebc$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $c3d565af0fdd1ebc$export$e2411914b150383d = ()=>$exYeM.useContext($c3d565af0fdd1ebc$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $c3d565af0fdd1ebc$export$718279509ff1e241(props) {
    const { children: children , delay: delay , timeoutMs: timeoutMs = 0  } = props;
    const [state, setState] = $exYeM.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $exYeM.useRef(null);
    const setCurrentId = $exYeM.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$FloatingDelayGroupContext.Provider, {
        value: $exYeM.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $c3d565af0fdd1ebc$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open , onOpenChange: onOpenChange , floatingId: floatingId  } = context;
    const { id: optionId  } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $c3d565af0fdd1ebc$export$e2411914b150383d();
    const { currentId: currentId , setCurrentId: setCurrentId , initialDelay: initialDelay , setState: setState , timeoutMs: timeoutMs  } = groupContext;
    $c3d565af0fdd1ebc$var$index(()=>{
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $c3d565af0fdd1ebc$var$getDelay(initialDelay, "close")
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (setCurrentId === $c3d565af0fdd1ebc$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
function $c3d565af0fdd1ebc$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $c3d565af0fdd1ebc$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $c3d565af0fdd1ebc$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $c3d565af0fdd1ebc$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $c3d565af0fdd1ebc$var$counterMap = /*#__PURE__*/ new WeakMap();
let $c3d565af0fdd1ebc$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $c3d565af0fdd1ebc$var$markerMap = {};
let $c3d565af0fdd1ebc$var$lockCount = 0;
const $c3d565af0fdd1ebc$var$supportsInert = ()=>typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
const $c3d565af0fdd1ebc$var$unwrapHost = (node)=>node && (node.host || $c3d565af0fdd1ebc$var$unwrapHost(node.parentNode));
const $c3d565af0fdd1ebc$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $c3d565af0fdd1ebc$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $c3d565af0fdd1ebc$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = "data-floating-ui-inert";
    const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    const avoidElements = $c3d565af0fdd1ebc$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$c3d565af0fdd1ebc$var$markerMap[markerName]) $c3d565af0fdd1ebc$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $c3d565af0fdd1ebc$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $5UDEU.getNodeName)(node) === "script") return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== "false";
                const counterValue = ($c3d565af0fdd1ebc$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $c3d565af0fdd1ebc$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $c3d565af0fdd1ebc$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, "true");
            }
        });
    }
    $c3d565af0fdd1ebc$var$lockCount++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($c3d565af0fdd1ebc$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $c3d565af0fdd1ebc$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$c3d565af0fdd1ebc$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $c3d565af0fdd1ebc$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $c3d565af0fdd1ebc$var$lockCount--;
        if (!$c3d565af0fdd1ebc$var$lockCount) {
            $c3d565af0fdd1ebc$var$counterMap = new WeakMap();
            $c3d565af0fdd1ebc$var$counterMap = new WeakMap();
            $c3d565af0fdd1ebc$var$uncontrolledElementsSet = new WeakSet();
            $c3d565af0fdd1ebc$var$markerMap = {};
        }
    };
}
function $c3d565af0fdd1ebc$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $7YrgS.getDocument)(avoidElements[0]).body;
    return $c3d565af0fdd1ebc$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
const $c3d565af0fdd1ebc$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function $c3d565af0fdd1ebc$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $Nbv5D.tabbable)(container, $c3d565af0fdd1ebc$var$getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $7YrgS.activeElement)((0, $7YrgS.getDocument)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $c3d565af0fdd1ebc$var$getNextTabbable() {
    return $c3d565af0fdd1ebc$var$getTabbableIn(document.body, "next");
}
function $c3d565af0fdd1ebc$var$getPreviousTabbable() {
    return $c3d565af0fdd1ebc$var$getTabbableIn(document.body, "prev");
}
function $c3d565af0fdd1ebc$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $7YrgS.contains)(containerElement, relatedTarget);
}
function $c3d565af0fdd1ebc$var$disableFocusInside(container) {
    const tabbableElements = (0, $Nbv5D.tabbable)(container, $c3d565af0fdd1ebc$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function $c3d565af0fdd1ebc$var$enableFocusInside(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $c3d565af0fdd1ebc$var$HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
let $c3d565af0fdd1ebc$var$timeoutId;
function $c3d565af0fdd1ebc$var$setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout($c3d565af0fdd1ebc$var$timeoutId);
    }
}
const $c3d565af0fdd1ebc$var$FocusGuard = /*#__PURE__*/ $exYeM.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $exYeM.useState();
    $c3d565af0fdd1ebc$var$index(()=>{
        if ((0, $7YrgS.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", $c3d565af0fdd1ebc$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener("keydown", $c3d565af0fdd1ebc$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [$c3d565af0fdd1ebc$var$createAttribute("focus-guard")]: "",
        style: $c3d565af0fdd1ebc$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $exYeM.createElement("span", $c3d565af0fdd1ebc$var$_extends({}, props, restProps));
});
const $c3d565af0fdd1ebc$var$PortalContext = /*#__PURE__*/ $exYeM.createContext(null);
const $c3d565af0fdd1ebc$var$attr = /*#__PURE__*/ $c3d565af0fdd1ebc$var$createAttribute("portal");
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $c3d565af0fdd1ebc$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id , root: root  } = props;
    const uniqueId = $c3d565af0fdd1ebc$export$f680877a34711e37();
    const portalContext = $c3d565af0fdd1ebc$var$usePortalContext();
    const [portalNode, setPortalNode] = $exYeM.useState(null);
    const portalNodeRef = $exYeM.useRef(null);
    $c3d565af0fdd1ebc$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($c3d565af0fdd1ebc$var$attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $5UDEU.isElement)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($c3d565af0fdd1ebc$var$attr, "");
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $c3d565af0fdd1ebc$export$31fa5d718fa2ac09(props) {
    const { children: children , id: id , root: root = null , preserveTabOrder: preserveTabOrder = true  } = props;
    const portalNode = $c3d565af0fdd1ebc$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $exYeM.useState(null);
    const beforeOutsideRef = $exYeM.useRef(null);
    const afterOutsideRef = $exYeM.useRef(null);
    const beforeInsideRef = $exYeM.useRef(null);
    const afterInsideRef = $exYeM.useRef(null);
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $exYeM.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $c3d565af0fdd1ebc$var$isOutsideEvent(event)) {
                const focusing = event.type === "focusin";
                const manageFocus = focusing ? $c3d565af0fdd1ebc$var$enableFocusInside : $c3d565af0fdd1ebc$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        focusManagerState == null ? void 0 : focusManagerState.modal
    ]);
    return /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$PortalContext.Provider, {
        value: $exYeM.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($c3d565af0fdd1ebc$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $c3d565af0fdd1ebc$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $exYeM.createElement("span", {
        "aria-owns": portalNode.id,
        style: $c3d565af0fdd1ebc$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $d2lNW.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($c3d565af0fdd1ebc$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $c3d565af0fdd1ebc$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent));
            }
        }
    }));
}
const $c3d565af0fdd1ebc$var$usePortalContext = ()=>$exYeM.useContext($c3d565af0fdd1ebc$var$PortalContext);
const $c3d565af0fdd1ebc$var$LIST_LIMIT = 20;
let $c3d565af0fdd1ebc$var$previouslyFocusedElements = [];
function $c3d565af0fdd1ebc$var$addPreviouslyFocusedElement(element) {
    $c3d565af0fdd1ebc$var$previouslyFocusedElements = $c3d565af0fdd1ebc$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $5UDEU.getNodeName)(tabbableEl) === "body") return;
    if (!(0, $Nbv5D.isTabbable)(tabbableEl, $c3d565af0fdd1ebc$var$getTabbableOptions())) {
        const tabbableChild = (0, $Nbv5D.tabbable)(tabbableEl, $c3d565af0fdd1ebc$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $c3d565af0fdd1ebc$var$previouslyFocusedElements.push(tabbableEl);
    if ($c3d565af0fdd1ebc$var$previouslyFocusedElements.length > $c3d565af0fdd1ebc$var$LIST_LIMIT) $c3d565af0fdd1ebc$var$previouslyFocusedElements = $c3d565af0fdd1ebc$var$previouslyFocusedElements.slice(-$c3d565af0fdd1ebc$var$LIST_LIMIT);
}
function $c3d565af0fdd1ebc$var$getPreviouslyFocusedElement() {
    return $c3d565af0fdd1ebc$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $c3d565af0fdd1ebc$var$VisuallyHiddenDismiss = /*#__PURE__*/ $exYeM.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $exYeM.createElement("button", $c3d565af0fdd1ebc$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $c3d565af0fdd1ebc$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $c3d565af0fdd1ebc$export$8aeee49171ded61a(props) {
    const { context: context , children: children , disabled: disabled = false , order: order = [
        "content"
    ] , guards: _guards = true , initialFocus: initialFocus = 0 , returnFocus: returnFocus = true , restoreFocus: restoreFocus = false , modal: modal = true , visuallyHiddenDismiss: visuallyHiddenDismiss = false , closeOnFocusOut: closeOnFocusOut = true  } = props;
    const { open: open , refs: refs , nodeId: nodeId , onOpenChange: onOpenChange , events: events , dataRef: dataRef , floatingId: floatingId , elements: { domReference: domReference , floating: floating  }  } = context;
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $7YrgS.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $c3d565af0fdd1ebc$var$supportsInert() ? _guards : true;
    const orderRef = $c3d565af0fdd1ebc$var$useLatestRef(order);
    const initialFocusRef = $c3d565af0fdd1ebc$var$useLatestRef(initialFocus);
    const returnFocusRef = $c3d565af0fdd1ebc$var$useLatestRef(returnFocus);
    const tree = $c3d565af0fdd1ebc$export$db0c2a7c7a2a4f69();
    const portalContext = $c3d565af0fdd1ebc$var$usePortalContext();
    const startDismissButtonRef = $exYeM.useRef(null);
    const endDismissButtonRef = $exYeM.useRef(null);
    const preventReturnFocusRef = $exYeM.useRef(false);
    const isPointerDownRef = $exYeM.useRef(false);
    const tabbableIndexRef = $exYeM.useRef(-1);
    const isInsidePortal = portalContext != null;
    const firstElementChild = floating == null ? void 0 : floating.firstElementChild;
    // If the floating element is acting as a positioning wrapper rather than the
    // element that receives aria props, use it as the focus root instead.
    const floatingFocusNode = (firstElementChild == null ? void 0 : firstElementChild.id) === floatingId ? firstElementChild : floating;
    const getTabbableContent = $c3d565af0fdd1ebc$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusNode;
        return container ? (0, $Nbv5D.tabbable)(container, $c3d565af0fdd1ebc$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $c3d565af0fdd1ebc$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floatingFocusNode && type === "floating") return floatingFocusNode;
            return content;
        }).filter(Boolean).flat();
    });
    $exYeM.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $7YrgS.contains)(floatingFocusNode, (0, $7YrgS.activeElement)((0, $7YrgS.getDocument)(floatingFocusNode))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $7YrgS.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $7YrgS.getTarget)(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    (0, $7YrgS.stopEvent)(event);
                    if (event.shiftKey) $c3d565af0fdd1ebc$var$enqueueFocus(els[els.length - 1]);
                    else $c3d565af0fdd1ebc$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floatingFocusNode && event.shiftKey) {
                    (0, $7YrgS.stopEvent)(event);
                    $c3d565af0fdd1ebc$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $7YrgS.getDocument)(floatingFocusNode);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusNode,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $exYeM.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $7YrgS.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener("focusin", handleFocusIn);
        return ()=>{
            floating.removeEventListener("focusin", handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $exYeM.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $7YrgS.contains)(domReference, relatedTarget) || (0, $7YrgS.contains)(floating, relatedTarget) || (0, $7YrgS.contains)(relatedTarget, floating) || (0, $7YrgS.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($c3d565af0fdd1ebc$var$createAttribute("focus-guard")) || tree && ($c3d565af0fdd1ebc$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $7YrgS.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $7YrgS.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $c3d565af0fdd1ebc$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $7YrgS.activeElement)((0, $7YrgS.getDocument)(floatingFocusNode)) === (0, $7YrgS.getDocument)(floatingFocusNode).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $5UDEU.isHTMLElement)(floatingFocusNode)) floatingFocusNode == null || floatingFocusNode.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusNode;
                    if ((0, $5UDEU.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $c3d565af0fdd1ebc$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event);
                }
            });
        }
        if (floating && (0, $5UDEU.isHTMLElement)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusNode,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $exYeM.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $c3d565af0fdd1ebc$var$createAttribute("portal") + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $c3d565af0fdd1ebc$var$markOthers(insideElements, guards, !guards) : $c3d565af0fdd1ebc$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (disabled || !(0, $5UDEU.isHTMLElement)(floatingFocusNode)) return;
        const doc = (0, $7YrgS.getDocument)(floatingFocusNode);
        const previouslyFocusedElement = (0, $7YrgS.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusNode);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusNode;
            const focusAlreadyInsideFloatingEl = (0, $7YrgS.contains)(floatingFocusNode, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $c3d565af0fdd1ebc$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusNode
            });
        });
    }, [
        disabled,
        open,
        floatingFocusNode,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (disabled || !floatingFocusNode) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $7YrgS.getDocument)(floatingFocusNode);
        const previouslyFocusedElement = (0, $7YrgS.activeElement)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $c3d565af0fdd1ebc$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open , reason: reason , event: event , nested: nested  } = _ref;
            if (open) openEvent = event;
            if (reason === "escape-key" && refs.domReference.current) $c3d565af0fdd1ebc$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === "hover" && event.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason !== "outside-press") return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $7YrgS.isVirtualClick)(event) || (0, $7YrgS.isVirtualPointerEvent)(event));
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
            const activeEl = (0, $7YrgS.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $7YrgS.contains)(floating, activeEl) || tree && $c3d565af0fdd1ebc$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $7YrgS.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                "click",
                "mousedown"
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $c3d565af0fdd1ebc$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = $c3d565af0fdd1ebc$var$getPreviouslyFocusedElement();
            if (// eslint-disable-next-line react-hooks/exhaustive-deps
            returnFocusRef.current && !preventReturnFocusRef.current && (0, $5UDEU.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
            // since it likely entered a different element which should be
            // respected: https://github.com/floating-ui/floating-ui/issues/2607
            (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) $c3d565af0fdd1ebc$var$enqueueFocus(returnElement, {
                // When dismissing nested floating elements, by the time the rAF has
                // executed, the menus will all have been unmounted. When they try
                // to get focused, the calls get ignored — leaving the root
                // reference focused as desired.
                cancelPrevious: false,
                preventScroll: preventReturnFocusScroll
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusNode,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $c3d565af0fdd1ebc$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusNode) return;
        if (typeof MutationObserver !== "function") return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusNode.getAttribute("tabindex");
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $7YrgS.activeElement)((0, $7YrgS.getDocument)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes("floating") || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== "0") floatingFocusNode.setAttribute("tabindex", "0");
            } else if (tabIndex !== "-1") floatingFocusNode.setAttribute("tabindex", "-1");
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusNode, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusNode,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $c3d565af0fdd1ebc$var$enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($c3d565af0fdd1ebc$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $c3d565af0fdd1ebc$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /*#__PURE__*/ $exYeM.createElement($c3d565af0fdd1ebc$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $c3d565af0fdd1ebc$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($c3d565af0fdd1ebc$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $c3d565af0fdd1ebc$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
const $c3d565af0fdd1ebc$var$activeLocks = /*#__PURE__*/ new Set();
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $c3d565af0fdd1ebc$export$a35954495955337b = /*#__PURE__*/ $exYeM.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false , ...rest } = props;
    const lockId = $c3d565af0fdd1ebc$export$f680877a34711e37();
    $c3d565af0fdd1ebc$var$index(()=>{
        if (!lockScroll) return;
        $c3d565af0fdd1ebc$var$activeLocks.add(lockId);
        const isIOS = /iP(hone|ad|od)|iOS/.test((0, $7YrgS.getPlatform)());
        const bodyStyle = document.body.style;
        // RTL <body> scrollbar
        const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
        const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
        const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
        bodyStyle.overflow = "hidden";
        if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
        // Only iOS doesn't respect `overflow: hidden` on document.body, and this
        // technique has fewer side effects.
        if (isIOS) {
            var _window$visualViewpor, _window$visualViewpor2;
            // iOS 12 does not support `visualViewport`.
            const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
            const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
            Object.assign(bodyStyle, {
                position: "fixed",
                top: -(scrollY - Math.floor(offsetTop)) + "px",
                left: -(scrollX - Math.floor(offsetLeft)) + "px",
                right: "0"
            });
        }
        return ()=>{
            $c3d565af0fdd1ebc$var$activeLocks.delete(lockId);
            if ($c3d565af0fdd1ebc$var$activeLocks.size === 0) {
                Object.assign(bodyStyle, {
                    overflow: "",
                    [paddingProp]: ""
                });
                if (isIOS) {
                    Object.assign(bodyStyle, {
                        position: "",
                        top: "",
                        left: "",
                        right: ""
                    });
                    window.scrollTo(scrollX, scrollY);
                }
            }
        };
    }, [
        lockId,
        lockScroll
    ]);
    return /*#__PURE__*/ $exYeM.createElement("div", $c3d565af0fdd1ebc$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $c3d565af0fdd1ebc$var$isButtonTarget(event) {
    return (0, $5UDEU.isHTMLElement)(event.target) && event.target.tagName === "BUTTON";
}
function $c3d565af0fdd1ebc$var$isSpaceIgnored(element) {
    return (0, $7YrgS.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $c3d565af0fdd1ebc$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open , onOpenChange: onOpenChange , dataRef: dataRef , elements: { domReference: domReference  }  } = context;
    const { enabled: enabled = true , event: eventOption = "click" , toggle: toggle = true , ignoreMouse: ignoreMouse = false , keyboardHandlers: keyboardHandlers = true  } = props;
    const pointerTypeRef = $exYeM.useRef();
    const didKeyDownRef = $exYeM.useRef(false);
    const reference = $exYeM.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === "click") return;
                if ((0, $7YrgS.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent, "click");
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $7YrgS.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent, "click");
                else onOpenChange(true, event.nativeEvent, "click");
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $c3d565af0fdd1ebc$var$isButtonTarget(event)) return;
                if (event.key === " " && !$c3d565af0fdd1ebc$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === "Enter") {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $c3d565af0fdd1ebc$var$isButtonTarget(event) || $c3d565af0fdd1ebc$var$isSpaceIgnored(domReference)) return;
                if (event.key === " " && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        toggle
    ]);
    return $exYeM.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $c3d565af0fdd1ebc$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $c3d565af0fdd1ebc$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $c3d565af0fdd1ebc$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open , dataRef: dataRef , elements: { floating: floating , domReference: domReference  } , refs: refs  } = context;
    const { enabled: enabled = true , axis: axis = "both" , x: x = null , y: y = null  } = props;
    const initialRef = $exYeM.useRef(false);
    const cleanupListenerRef = $exYeM.useRef(null);
    const [pointerType, setPointerType] = $exYeM.useState();
    const [reactive, setReactive] = $exYeM.useState([]);
    const setReference = $c3d565af0fdd1ebc$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$c3d565af0fdd1ebc$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($c3d565af0fdd1ebc$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $c3d565af0fdd1ebc$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $7YrgS.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $exYeM.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $5UDEU.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $7YrgS.getTarget)(event);
            if (!(0, $7YrgS.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $c3d565af0fdd1ebc$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $exYeM.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $exYeM.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $exYeM.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $exYeM.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType  } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $exYeM.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $c3d565af0fdd1ebc$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $c3d565af0fdd1ebc$var$captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const $c3d565af0fdd1ebc$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $c3d565af0fdd1ebc$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open , onOpenChange: onOpenChange , elements: elements , dataRef: dataRef  } = context;
    const { enabled: enabled = true , escapeKey: escapeKey = true , outsidePress: unstable_outsidePress = true , outsidePressEvent: outsidePressEvent = "pointerdown" , referencePress: referencePress = false , referencePressEvent: referencePressEvent = "pointerdown" , ancestorScroll: ancestorScroll = false , bubbles: bubbles , capture: capture  } = props;
    const tree = $c3d565af0fdd1ebc$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $c3d565af0fdd1ebc$var$useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $exYeM.useRef(false);
    const endedOrStartedInsideRef = $exYeM.useRef(false);
    const { escapeKey: escapeKeyBubbles , outsidePress: outsidePressBubbles  } = $c3d565af0fdd1ebc$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture , outsidePress: outsidePressCapture  } = $c3d565af0fdd1ebc$var$normalizeProp(capture);
    const closeOnEscapeKeyDown = $c3d565af0fdd1ebc$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $c3d565af0fdd1ebc$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $7YrgS.isReactEvent)(event) ? event.nativeEvent : event, "escape-key");
    });
    const closeOnEscapeKeyDownCapture = $c3d565af0fdd1ebc$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $7YrgS.getTarget)(event)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = (0, $7YrgS.getTarget)(event)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    const closeOnPressOutside = $c3d565af0fdd1ebc$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        const target = (0, $7YrgS.getTarget)(event);
        const inertSelector = "[" + $c3d565af0fdd1ebc$var$createAttribute("inert") + "]";
        const markers = (0, $7YrgS.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $5UDEU.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $5UDEU.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $5UDEU.getParentNode)(targetRootAncestor);
            if ((0, $5UDEU.isLastTraversableNode)(nextParent) || !(0, $5UDEU.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $5UDEU.isElement)(target) && !(0, $7YrgS.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $7YrgS.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $7YrgS.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $5UDEU.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $5UDEU.getComputedStyle)(target).direction === "rtl";
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $c3d565af0fdd1ebc$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $7YrgS.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $7YrgS.isEventTargetWithin)(event, elements.floating) || (0, $7YrgS.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $c3d565af0fdd1ebc$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, "outside-press");
    });
    const closeOnPressOutsideCapture = $c3d565af0fdd1ebc$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $7YrgS.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $7YrgS.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $exYeM.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        function onScroll(event) {
            onOpenChange(false, event, "ancestor-scroll");
        }
        const doc = (0, $7YrgS.getDocument)(elements.floating);
        escapeKey && doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $5UDEU.isElement)(elements.domReference)) ancestors = (0, $5UDEU.getOverflowAncestors)(elements.domReference);
            if ((0, $5UDEU.isElement)(elements.floating)) ancestors = ancestors.concat((0, $5UDEU.getOverflowAncestors)(elements.floating));
            if (!(0, $5UDEU.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $5UDEU.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return ()=>{
            escapeKey && doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $exYeM.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $exYeM.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$c3d565af0fdd1ebc$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, "reference-press");
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $exYeM.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$c3d565af0fdd1ebc$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $exYeM.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $c3d565af0fdd1ebc$export$1df81146f8ad8e4c(options) {
    const { open: open = false , onOpenChange: onOpenChangeProp , elements: elementsProp  } = options;
    const floatingId = $c3d565af0fdd1ebc$export$f680877a34711e37();
    const dataRef = $exYeM.useRef({});
    const [events] = $exYeM.useState(()=>$c3d565af0fdd1ebc$var$createPubSub());
    const nested = $c3d565af0fdd1ebc$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $exYeM.useState(elementsProp.reference);
    const onOpenChange = $c3d565af0fdd1ebc$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit("openchange", {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $exYeM.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $exYeM.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $exYeM.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $c3d565af0fdd1ebc$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId  } = options;
    const internalRootContext = $c3d565af0fdd1ebc$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $exYeM.useState(null);
    const [positionReference, _setPositionReference] = $exYeM.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.reference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $exYeM.useRef(null);
    const tree = $c3d565af0fdd1ebc$export$db0c2a7c7a2a4f69();
    $c3d565af0fdd1ebc$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $jiVm5.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $exYeM.useCallback((node)=>{
        const computedPositionReference = (0, $5UDEU.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $exYeM.useCallback((node)=>{
        if ((0, $5UDEU.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $5UDEU.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $5UDEU.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $exYeM.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $exYeM.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $exYeM.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $exYeM.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $c3d565af0fdd1ebc$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open , onOpenChange: onOpenChange , events: events , dataRef: dataRef , elements: elements  } = context;
    const { enabled: enabled = true , visibleOnly: visibleOnly = true  } = props;
    const blockFocusRef = $exYeM.useRef(false);
    const timeoutRef = $exYeM.useRef();
    const keyboardModalityRef = $exYeM.useRef(true);
    $exYeM.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $5UDEU.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $5UDEU.isHTMLElement)(elements.domReference) && elements.domReference === (0, $7YrgS.activeElement)((0, $7YrgS.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener("blur", onBlur);
        win.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            win.removeEventListener("blur", onBlur);
            win.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $exYeM.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason  } = _ref;
            if (reason === "reference-press" || reason === "escape-key") blockFocusRef.current = true;
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $exYeM.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $exYeM.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $7YrgS.isVirtualPointerEvent)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $7YrgS.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $5UDEU.isElement)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $7YrgS.isSafari)() && (0, $7YrgS.isMac)()) throw Error();
                    if (!target.matches(":focus-visible")) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $7YrgS.isTypeableElement)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, "focus");
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $5UDEU.isElement)(relatedTarget) && relatedTarget.hasAttribute($c3d565af0fdd1ebc$var$createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $7YrgS.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $7YrgS.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $7YrgS.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, "focus");
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $exYeM.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $c3d565af0fdd1ebc$var$ACTIVE_KEY = "active";
const $c3d565af0fdd1ebc$var$SELECTED_KEY = "selected";
function $c3d565af0fdd1ebc$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === "item";
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$c3d565af0fdd1ebc$var$ACTIVE_KEY]: _ , [$c3d565af0fdd1ebc$var$SELECTED_KEY]: __ , ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === "floating" && {
            tabIndex: -1
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $c3d565af0fdd1ebc$var$ACTIVE_KEY,
                    $c3d565af0fdd1ebc$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $c3d565af0fdd1ebc$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $exYeM.useCallback((userProps)=>$c3d565af0fdd1ebc$var$mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $exYeM.useCallback((userProps)=>$c3d565af0fdd1ebc$var$mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $exYeM.useCallback((userProps)=>$c3d565af0fdd1ebc$var$mergeProps(userProps, propsList, "item"), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $exYeM.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $c3d565af0fdd1ebc$var$isPreventScrollSupported = false;
function $c3d565af0fdd1ebc$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $c3d565af0fdd1ebc$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $c3d565af0fdd1ebc$var$ARROW_UP || key === $c3d565af0fdd1ebc$var$ARROW_DOWN;
    const horizontal = key === $c3d565af0fdd1ebc$var$ARROW_LEFT || key === $c3d565af0fdd1ebc$var$ARROW_RIGHT;
    return $c3d565af0fdd1ebc$var$doSwitch(orientation, vertical, horizontal);
}
function $c3d565af0fdd1ebc$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $c3d565af0fdd1ebc$var$ARROW_DOWN;
    const horizontal = rtl ? key === $c3d565af0fdd1ebc$var$ARROW_LEFT : key === $c3d565af0fdd1ebc$var$ARROW_RIGHT;
    return $c3d565af0fdd1ebc$var$doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function $c3d565af0fdd1ebc$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $c3d565af0fdd1ebc$var$ARROW_LEFT : key === $c3d565af0fdd1ebc$var$ARROW_RIGHT;
    const horizontal = key === $c3d565af0fdd1ebc$var$ARROW_DOWN;
    return $c3d565af0fdd1ebc$var$doSwitch(orientation, vertical, horizontal);
}
function $c3d565af0fdd1ebc$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $c3d565af0fdd1ebc$var$ARROW_RIGHT : key === $c3d565af0fdd1ebc$var$ARROW_LEFT;
    const horizontal = key === $c3d565af0fdd1ebc$var$ARROW_UP;
    return $c3d565af0fdd1ebc$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $c3d565af0fdd1ebc$export$b5d22cac4ad33f40(context, props) {
    const { open: open , onOpenChange: onOpenChange , elements: elements  } = context;
    const { listRef: listRef , activeIndex: activeIndex , onNavigate: unstable_onNavigate = ()=>{} , enabled: enabled = true , selectedIndex: selectedIndex = null , allowEscape: allowEscape = false , loop: loop = false , nested: nested = false , rtl: rtl = false , virtual: virtual = false , focusItemOnOpen: focusItemOnOpen = "auto" , focusItemOnHover: focusItemOnHover = true , openOnArrowKeyDown: openOnArrowKeyDown = true , disabledIndices: disabledIndices , orientation: orientation = "vertical" , cols: cols = 1 , scrollItemIntoView: scrollItemIntoView = true , virtualItemRef: virtualItemRef , itemSizes: itemSizes , dense: dense = false  } = props;
    const parentId = $c3d565af0fdd1ebc$export$165209eae06d3488();
    const tree = $c3d565af0fdd1ebc$export$db0c2a7c7a2a4f69();
    const onNavigate = $c3d565af0fdd1ebc$var$useEffectEvent(unstable_onNavigate);
    const focusItemOnOpenRef = $exYeM.useRef(focusItemOnOpen);
    const indexRef = $exYeM.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $exYeM.useRef(null);
    const isPointerModalityRef = $exYeM.useRef(true);
    const previousOnNavigateRef = $exYeM.useRef(onNavigate);
    const previousMountedRef = $exYeM.useRef(!!elements.floating);
    const forceSyncFocus = $exYeM.useRef(false);
    const forceScrollIntoViewRef = $exYeM.useRef(false);
    const disabledIndicesRef = $c3d565af0fdd1ebc$var$useLatestRef(disabledIndices);
    const latestOpenRef = $c3d565af0fdd1ebc$var$useLatestRef(open);
    const scrollItemIntoViewRef = $c3d565af0fdd1ebc$var$useLatestRef(scrollItemIntoView);
    const floatingRef = $c3d565af0fdd1ebc$var$useLatestRef(elements.floating);
    const selectedIndexRef = $c3d565af0fdd1ebc$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $exYeM.useState();
    const [virtualId, setVirtualId] = $exYeM.useState();
    const focusItem = $c3d565af0fdd1ebc$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit("virtualfocus", item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $c3d565af0fdd1ebc$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $7YrgS.isMac)() && (0, $7YrgS.isSafari)() ? $c3d565af0fdd1ebc$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    $c3d565af0fdd1ebc$var$index(()=>{
        document.createElement("div").focus({
            get preventScroll () {
                $c3d565af0fdd1ebc$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $c3d565af0fdd1ebc$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $c3d565af0fdd1ebc$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if (!previousMountedRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $c3d565af0fdd1ebc$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $c3d565af0fdd1ebc$var$getMinIndex(listRef, disabledIndicesRef.current) : $c3d565af0fdd1ebc$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$c3d565af0fdd1ebc$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $c3d565af0fdd1ebc$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $7YrgS.activeElement)((0, $7YrgS.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $7YrgS.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on("virtualfocus", handleVirtualFocus);
        return ()=>{
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $c3d565af0fdd1ebc$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $exYeM.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget  } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget  } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget  } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType  } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === "touch") return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $c3d565af0fdd1ebc$var$enqueueFocus(floatingRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $c3d565af0fdd1ebc$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingRef.current) return;
        if (nested && $c3d565af0fdd1ebc$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $7YrgS.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, "list-navigation");
            if ((0, $5UDEU.isHTMLElement)(elements.domReference) && !virtual) elements.domReference.focus();
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $c3d565af0fdd1ebc$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $c3d565af0fdd1ebc$var$getMaxIndex(listRef, disabledIndices);
        if (event.key === "Home") {
            (0, $7YrgS.stopEvent)(event);
            indexRef.current = minIndex;
            onNavigate(indexRef.current);
        }
        if (event.key === "End") {
            (0, $7YrgS.stopEvent)(event);
            indexRef.current = maxIndex;
            onNavigate(indexRef.current);
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $c3d565af0fdd1ebc$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$c3d565af0fdd1ebc$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$c3d565af0fdd1ebc$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            indexRef.current = cellMap[$c3d565af0fdd1ebc$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $c3d565af0fdd1ebc$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$c3d565af0fdd1ebc$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $c3d565af0fdd1ebc$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $c3d565af0fdd1ebc$var$ARROW_DOWN ? "bl" : event.key === $c3d565af0fdd1ebc$var$ARROW_RIGHT ? "tr" : "tl"),
                stopEvent: true
            })]; // navigated cell will never be nullish
            onNavigate(indexRef.current);
            if (orientation === "both") return;
        }
        if ($c3d565af0fdd1ebc$var$isMainOrientationKey(event.key, orientation)) {
            (0, $7YrgS.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $7YrgS.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $c3d565af0fdd1ebc$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($c3d565af0fdd1ebc$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $c3d565af0fdd1ebc$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $c3d565af0fdd1ebc$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $c3d565af0fdd1ebc$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $c3d565af0fdd1ebc$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($c3d565af0fdd1ebc$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $exYeM.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $exYeM.useMemo(()=>{
        return {
            "aria-orientation": orientation === "both" ? undefined : orientation,
            ...!(0, $7YrgS.isTypeableCombobox)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $exYeM.useMemo(()=>{
        const disabledIndices = disabledIndicesRef.current;
        const activeItem = listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId);
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && (0, $7YrgS.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && (0, $7YrgS.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.indexOf("Arrow") === 0;
                const isCrossOpenKey = $c3d565af0fdd1ebc$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $c3d565af0fdd1ebc$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $c3d565af0fdd1ebc$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $c3d565af0fdd1ebc$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isArrowKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent("keydown", {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? activeItem : null;
                            if (dispatchItem) {
                                (0, $7YrgS.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if (isMainKey && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $7YrgS.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $7YrgS.stopEvent)(event);
                        if (open) {
                            indexRef.current = $c3d565af0fdd1ebc$var$getMinIndex(listRef, disabledIndices);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $7YrgS.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, "list-navigation");
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $exYeM.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $c3d565af0fdd1ebc$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $c3d565af0fdd1ebc$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open , floatingId: floatingId  } = context;
    const { enabled: enabled = true , role: role = "dialog"  } = props;
    const ariaRole = (_componentRoleToAriaR = $c3d565af0fdd1ebc$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $c3d565af0fdd1ebc$export$f680877a34711e37();
    const parentId = $c3d565af0fdd1ebc$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $exYeM.useMemo(()=>{
        if (ariaRole === "tooltip" || role === "label") return {
            ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : undefined
        };
        return {
            "aria-expanded": open ? "true" : "false",
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-controls": open ? floatingId : undefined,
            ...ariaRole === "listbox" && {
                role: "combobox"
            },
            ...ariaRole === "menu" && {
                id: referenceId
            },
            ...ariaRole === "menu" && isNested && {
                role: "menuitem"
            },
            ...role === "select" && {
                "aria-autocomplete": "none"
            },
            ...role === "combobox" && {
                "aria-autocomplete": "list"
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $exYeM.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === "tooltip" || role === "label") return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === "menu" && {
                "aria-labelledby": referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $exYeM.useCallback((_ref)=>{
        let { active: active , selected: selected  } = _ref;
        const commonProps = {
            role: "option",
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case "select":
                return {
                    ...commonProps,
                    "aria-selected": active && selected
                };
            case "combobox":
                return {
                    ...commonProps,
                    ...active && {
                        "aria-selected": true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $exYeM.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $c3d565af0fdd1ebc$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
function $c3d565af0fdd1ebc$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function $c3d565af0fdd1ebc$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $exYeM.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $exYeM.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $c3d565af0fdd1ebc$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open , elements: { floating: floating  }  } = context;
    const { duration: duration = 250  } = props;
    const isNumberDuration = typeof duration === "number";
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $exYeM.useState("unmounted");
    const isMounted = $c3d565af0fdd1ebc$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === "close") setStatus("unmounted");
    $c3d565af0fdd1ebc$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                setStatus("open");
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus("close");
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $c3d565af0fdd1ebc$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    } , open: unstable_open , close: unstable_close , common: unstable_common , duration: duration = 250  } = props;
    const placement = context.placement;
    const side = placement.split("-")[0];
    const fnArgs = $exYeM.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === "number";
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $exYeM.useState(()=>({
            ...$c3d565af0fdd1ebc$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$c3d565af0fdd1ebc$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted , status: status  } = $c3d565af0fdd1ebc$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $c3d565af0fdd1ebc$var$useLatestRef(unstable_initial);
    const openRef = $c3d565af0fdd1ebc$var$useLatestRef(unstable_open);
    const closeRef = $c3d565af0fdd1ebc$var$useLatestRef(unstable_close);
    const commonRef = $c3d565af0fdd1ebc$var$useLatestRef(unstable_common);
    $c3d565af0fdd1ebc$var$index(()=>{
        const initialStyles = $c3d565af0fdd1ebc$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $c3d565af0fdd1ebc$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $c3d565af0fdd1ebc$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $c3d565af0fdd1ebc$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            transitionProperty: Object.keys(openStyles).map($c3d565af0fdd1ebc$var$camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($c3d565af0fdd1ebc$var$camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $c3d565af0fdd1ebc$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open , dataRef: dataRef  } = context;
    const { listRef: listRef , activeIndex: activeIndex , onMatch: unstable_onMatch , onTypingChange: unstable_onTypingChange , enabled: enabled = true , findMatch: findMatch = null , resetMs: resetMs = 750 , ignoreKeys: ignoreKeys = [] , selectedIndex: selectedIndex = null  } = props;
    const timeoutIdRef = $exYeM.useRef();
    const stringRef = $exYeM.useRef("");
    const prevIndexRef = $exYeM.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $exYeM.useRef(null);
    const onMatch = $c3d565af0fdd1ebc$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $c3d565af0fdd1ebc$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $c3d565af0fdd1ebc$var$useLatestRef(findMatch);
    const ignoreKeysRef = $c3d565af0fdd1ebc$var$useLatestRef(ignoreKeys);
    $c3d565af0fdd1ebc$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    $c3d565af0fdd1ebc$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $c3d565af0fdd1ebc$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $c3d565af0fdd1ebc$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === " ") (0, $7YrgS.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== " ") {
            (0, $7YrgS.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== " ") {
            stringRef.current = "";
            setTypingChange(false);
        }
    });
    const reference = $exYeM.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $exYeM.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === " ") setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $exYeM.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $c3d565af0fdd1ebc$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $c3d565af0fdd1ebc$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { listRef: listRef , overflowRef: overflowRef , onFallbackChange: onFallbackChange , offset: innerOffset = 0 , index: index = 0 , minItemsVisible: minItemsVisible = 4 , referenceOverflowThreshold: referenceOverflowThreshold = 0 , scrollRef: scrollRef , ...detectOverflowOptions } = (0, $cCxCV.evaluate)(props, state);
            const { rects: rects , elements: { floating: floating  }  } = state;
            const item = listRef.current[index];
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $jiVm5.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const el = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            const overflow = await (0, $9Q6OH.detectOverflow)($c3d565af0fdd1ebc$var$getArgsWithCustomFloatingHeight(nextArgs, el.scrollHeight), detectOverflowOptions);
            const refOverflow = await (0, $9Q6OH.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = Math.max(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const maxHeight = Math.max(0, el.scrollHeight - diffY - Math.max(0, overflow.bottom));
            el.style.maxHeight = maxHeight + "px";
            el.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                if (el.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) $d2lNW.flushSync(()=>onFallbackChange(true));
                else $d2lNW.flushSync(()=>onFallbackChange(false));
            }
            if (overflowRef) overflowRef.current = await (0, $9Q6OH.detectOverflow)($c3d565af0fdd1ebc$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, el.offsetHeight), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $c3d565af0fdd1ebc$export$3d74b0dda7cc82ff(context, props) {
    const { open: open , elements: elements  } = context;
    const { enabled: enabled = true , overflowRef: overflowRef , scrollRef: scrollRef , onChange: unstable_onChange  } = props;
    const onChange = $c3d565af0fdd1ebc$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $exYeM.useRef(false);
    const prevScrollTopRef = $exYeM.useRef(null);
    const initialOverflowRef = $exYeM.useRef(null);
    $exYeM.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $d2lNW.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $7YrgS.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $exYeM.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $d2lNW.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $exYeM.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $c3d565af0fdd1ebc$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $c3d565af0fdd1ebc$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $c3d565af0fdd1ebc$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5 , blockPointerEvents: blockPointerEvents = false , requireIntent: requireIntent = true  } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x , y: y , placement: placement , elements: elements , onClose: onClose , nodeId: nodeId , tree: tree  } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX , clientY: clientY  } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $7YrgS.getTarget)(event);
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = (0, $7YrgS.contains)(elements.floating, target);
            const isOverReferenceEl = (0, $7YrgS.contains)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $c3d565af0fdd1ebc$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $5UDEU.isElement)(event.relatedTarget) && (0, $7YrgS.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $c3d565af0fdd1ebc$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context  } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($c3d565af0fdd1ebc$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$c3d565af0fdd1ebc$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRequire.register("7YrgS", function(module, exports) {

$parcel$export(module.exports, "activeElement", function () { return $5ce34a7af19980e2$export$da980962bd2147a4; });
$parcel$export(module.exports, "contains", function () { return $5ce34a7af19980e2$export$2344b14b097df817; });
$parcel$export(module.exports, "getPlatform", function () { return $5ce34a7af19980e2$export$867a782338812cb4; });
$parcel$export(module.exports, "getUserAgent", function () { return $5ce34a7af19980e2$export$7935961ef7719cb0; });
$parcel$export(module.exports, "isVirtualClick", function () { return $5ce34a7af19980e2$export$60278871457622de; });
$parcel$export(module.exports, "isVirtualPointerEvent", function () { return $5ce34a7af19980e2$export$29bf1b5f2c56cf63; });
$parcel$export(module.exports, "isSafari", function () { return $5ce34a7af19980e2$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isMac", function () { return $5ce34a7af19980e2$export$9ac100e40613ea10; });
$parcel$export(module.exports, "isMouseLikePointerType", function () { return $5ce34a7af19980e2$export$81cf264172d31e51; });
$parcel$export(module.exports, "isReactEvent", function () { return $5ce34a7af19980e2$export$94781ce41a161222; });
$parcel$export(module.exports, "isRootElement", function () { return $5ce34a7af19980e2$export$7b296c28e0fa3aed; });
$parcel$export(module.exports, "getDocument", function () { return $5ce34a7af19980e2$export$f65ca476c09acec0; });
$parcel$export(module.exports, "isEventTargetWithin", function () { return $5ce34a7af19980e2$export$43c3154d5bf2c6c2; });
$parcel$export(module.exports, "getTarget", function () { return $5ce34a7af19980e2$export$c22522a4dfa48e9c; });
$parcel$export(module.exports, "isTypeableElement", function () { return $5ce34a7af19980e2$export$42ad131c32f0fb8d; });
$parcel$export(module.exports, "stopEvent", function () { return $5ce34a7af19980e2$export$7ae4cd3a66c1e050; });
$parcel$export(module.exports, "isTypeableCombobox", function () { return $5ce34a7af19980e2$export$259ba5ae38188551; });

var $5UDEU = parcelRequire("5UDEU");
function $5ce34a7af19980e2$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $5ce34a7af19980e2$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $5UDEU.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $5ce34a7af19980e2$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $5ce34a7af19980e2$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand , version: version  } = _ref;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $5ce34a7af19980e2$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($5ce34a7af19980e2$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $5ce34a7af19980e2$export$29bf1b5f2c56cf63(event) {
    if ($5ce34a7af19980e2$export$c8f880a2d81914c4()) return false;
    return !$5ce34a7af19980e2$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $5ce34a7af19980e2$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function $5ce34a7af19980e2$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $5ce34a7af19980e2$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($5ce34a7af19980e2$export$867a782338812cb4()) || re.test($5ce34a7af19980e2$export$7935961ef7719cb0());
}
function $5ce34a7af19980e2$export$9ac100e40613ea10() {
    return $5ce34a7af19980e2$export$867a782338812cb4().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $5ce34a7af19980e2$export$c8f880a2d81914c4() {
    return $5ce34a7af19980e2$export$7935961ef7719cb0().includes("jsdom/");
}
function $5ce34a7af19980e2$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function $5ce34a7af19980e2$export$94781ce41a161222(event) {
    return "nativeEvent" in event;
}
function $5ce34a7af19980e2$export$7b296c28e0fa3aed(element) {
    return element.matches("html,body");
}
function $5ce34a7af19980e2$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $5ce34a7af19980e2$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $5ce34a7af19980e2$export$c22522a4dfa48e9c(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $5ce34a7af19980e2$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $5ce34a7af19980e2$export$42ad131c32f0fb8d(element) {
    return (0, $5UDEU.isHTMLElement)(element) && element.matches($5ce34a7af19980e2$export$78b3d091ff376bc);
}
function $5ce34a7af19980e2$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $5ce34a7af19980e2$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && $5ce34a7af19980e2$export$42ad131c32f0fb8d(element);
}

});
parcelRequire.register("5UDEU", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $44e0f21d4eb6a5a0$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $44e0f21d4eb6a5a0$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $44e0f21d4eb6a5a0$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $44e0f21d4eb6a5a0$export$af51f0f06c0f328a; });
$parcel$export(module.exports, "isOverflowElement", function () { return $44e0f21d4eb6a5a0$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $44e0f21d4eb6a5a0$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $44e0f21d4eb6a5a0$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $44e0f21d4eb6a5a0$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $44e0f21d4eb6a5a0$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $44e0f21d4eb6a5a0$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $44e0f21d4eb6a5a0$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $44e0f21d4eb6a5a0$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $44e0f21d4eb6a5a0$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $44e0f21d4eb6a5a0$export$3b57c1601291186b; });
function $44e0f21d4eb6a5a0$export$651544f548703224(node) {
    if ($44e0f21d4eb6a5a0$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $44e0f21d4eb6a5a0$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($44e0f21d4eb6a5a0$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $44e0f21d4eb6a5a0$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).Node;
}
function $44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).Element;
}
function $44e0f21d4eb6a5a0$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).HTMLElement;
}
function $44e0f21d4eb6a5a0$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $44e0f21d4eb6a5a0$export$989e911fa9af580a(element) {
    const { overflow: overflow , overflowX: overflowX , overflowY: overflowY , display: display  } = $44e0f21d4eb6a5a0$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $44e0f21d4eb6a5a0$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($44e0f21d4eb6a5a0$export$651544f548703224(element));
}
function $44e0f21d4eb6a5a0$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $44e0f21d4eb6a5a0$export$d6c4e8150c35fed1(element) {
    const webkit = $44e0f21d4eb6a5a0$export$78551043582a6a98();
    const css = $44e0f21d4eb6a5a0$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $44e0f21d4eb6a5a0$export$940d8225183e1404(element) {
    let currentNode = $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(element);
    while($44e0f21d4eb6a5a0$export$1b3bfaa9684536aa(currentNode) && !$44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51(currentNode)){
        if ($44e0f21d4eb6a5a0$export$89e651af02346cd4(currentNode)) return null;
        if ($44e0f21d4eb6a5a0$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        currentNode = $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $44e0f21d4eb6a5a0$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($44e0f21d4eb6a5a0$export$651544f548703224(node));
}
function $44e0f21d4eb6a5a0$export$3735103072e4a80(element) {
    return $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $44e0f21d4eb6a5a0$export$dc8fc79fa2800137(element) {
    if ($44e0f21d4eb6a5a0$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(node) {
    if ($44e0f21d4eb6a5a0$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $44e0f21d4eb6a5a0$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $44e0f21d4eb6a5a0$export$e495491855dc5418(node);
    return $44e0f21d4eb6a5a0$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $44e0f21d4eb6a5a0$export$7cd01a57c8ca906c(node) {
    const parentNode = $44e0f21d4eb6a5a0$export$4e12058fc4d51d56(node);
    if ($44e0f21d4eb6a5a0$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($44e0f21d4eb6a5a0$export$1b3bfaa9684536aa(parentNode) && $44e0f21d4eb6a5a0$export$989e911fa9af580a(parentNode)) return parentNode;
    return $44e0f21d4eb6a5a0$export$7cd01a57c8ca906c(parentNode);
}
function $44e0f21d4eb6a5a0$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $44e0f21d4eb6a5a0$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $44e0f21d4eb6a5a0$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $44e0f21d4eb6a5a0$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $44e0f21d4eb6a5a0$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $44e0f21d4eb6a5a0$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}

});


parcelRequire.register("cCxCV", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $93031e4206e8e991$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $93031e4206e8e991$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $93031e4206e8e991$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $93031e4206e8e991$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $93031e4206e8e991$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $93031e4206e8e991$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $93031e4206e8e991$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $93031e4206e8e991$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $93031e4206e8e991$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $93031e4206e8e991$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $93031e4206e8e991$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $93031e4206e8e991$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $93031e4206e8e991$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $93031e4206e8e991$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $93031e4206e8e991$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $93031e4206e8e991$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $93031e4206e8e991$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $93031e4206e8e991$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $93031e4206e8e991$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $93031e4206e8e991$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $93031e4206e8e991$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $93031e4206e8e991$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $93031e4206e8e991$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $93031e4206e8e991$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $93031e4206e8e991$export$803cd8101b6c182b = /*#__PURE__*/ $93031e4206e8e991$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[0], side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[1]), []);
const $93031e4206e8e991$export$96ec731ed4dcb222 = Math.min;
const $93031e4206e8e991$export$8960430cfd85939f = Math.max;
const $93031e4206e8e991$export$2077e0241d6afd3c = Math.round;
const $93031e4206e8e991$export$a3fe094919f356fd = Math.floor;
const $93031e4206e8e991$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $93031e4206e8e991$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $93031e4206e8e991$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $93031e4206e8e991$export$7d15b64cf5a3a4c4(start, value, end) {
    return $93031e4206e8e991$export$8960430cfd85939f(start, $93031e4206e8e991$export$96ec731ed4dcb222(value, end));
}
function $93031e4206e8e991$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $93031e4206e8e991$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $93031e4206e8e991$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $93031e4206e8e991$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $93031e4206e8e991$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $93031e4206e8e991$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($93031e4206e8e991$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $93031e4206e8e991$export$2b57e0052a6d6d4c(placement) {
    return $93031e4206e8e991$export$8a000a963141ac32($93031e4206e8e991$export$f28e8f882010718a(placement));
}
function $93031e4206e8e991$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    const alignmentAxis = $93031e4206e8e991$export$2b57e0052a6d6d4c(placement);
    const length = $93031e4206e8e991$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $93031e4206e8e991$export$496432a3699e50b1(placement) {
    const oppositePlacement = $93031e4206e8e991$export$9c5e28bad23365fa(placement);
    return [
        $93031e4206e8e991$export$2b182c584985588b(placement),
        oppositePlacement,
        $93031e4206e8e991$export$2b182c584985588b(oppositePlacement)
    ];
}
function $93031e4206e8e991$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$93031e4206e8e991$var$oppositeAlignmentMap[alignment]);
}
function $93031e4206e8e991$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $93031e4206e8e991$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    let list = $93031e4206e8e991$var$getSideList($93031e4206e8e991$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($93031e4206e8e991$export$2b182c584985588b));
    }
    return list;
}
function $93031e4206e8e991$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$93031e4206e8e991$var$oppositeSideMap[side]);
}
function $93031e4206e8e991$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $93031e4206e8e991$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $93031e4206e8e991$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $93031e4206e8e991$export$ee05aea0aeecbad4(rect) {
    const { x: x , y: y , width: width , height: height  } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});

parcelRequire.register("Nbv5D", function(module, exports) {

$parcel$export(module.exports, "tabbable", function () { return $093d7f77b2b159bb$export$17100aea90429aa7; });
$parcel$export(module.exports, "isTabbable", function () { return $093d7f77b2b159bb$export$bebd5a1431fec25d; });
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $093d7f77b2b159bb$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $093d7f77b2b159bb$var$candidateSelector = /* #__PURE__ */ $093d7f77b2b159bb$var$candidateSelectors.join(",");
var $093d7f77b2b159bb$var$NoElement = typeof Element === "undefined";
var $093d7f77b2b159bb$var$matches = $093d7f77b2b159bb$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $093d7f77b2b159bb$var$getRootNode = !$093d7f77b2b159bb$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $093d7f77b2b159bb$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $093d7f77b2b159bb$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $093d7f77b2b159bb$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($093d7f77b2b159bb$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($093d7f77b2b159bb$var$candidateSelector));
    if (includeContainer && $093d7f77b2b159bb$var$matches.call(el, $093d7f77b2b159bb$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $093d7f77b2b159bb$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($093d7f77b2b159bb$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $093d7f77b2b159bb$var$matches.call(element, $093d7f77b2b159bb$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$093d7f77b2b159bb$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $093d7f77b2b159bb$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $093d7f77b2b159bb$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $093d7f77b2b159bb$var$isContentEditable(node)) && !$093d7f77b2b159bb$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $093d7f77b2b159bb$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $093d7f77b2b159bb$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$093d7f77b2b159bb$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $093d7f77b2b159bb$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $093d7f77b2b159bb$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $093d7f77b2b159bb$var$isHiddenInput = function isHiddenInput(node) {
    return $093d7f77b2b159bb$var$isInput(node) && node.type === "hidden";
};
var $093d7f77b2b159bb$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $093d7f77b2b159bb$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $093d7f77b2b159bb$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $093d7f77b2b159bb$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $093d7f77b2b159bb$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $093d7f77b2b159bb$var$isRadio = function isRadio(node) {
    return $093d7f77b2b159bb$var$isInput(node) && node.type === "radio";
};
var $093d7f77b2b159bb$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $093d7f77b2b159bb$var$isRadio(node) && !$093d7f77b2b159bb$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $093d7f77b2b159bb$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $093d7f77b2b159bb$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $093d7f77b2b159bb$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $093d7f77b2b159bb$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $093d7f77b2b159bb$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $093d7f77b2b159bb$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($093d7f77b2b159bb$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $093d7f77b2b159bb$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $093d7f77b2b159bb$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($093d7f77b2b159bb$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $093d7f77b2b159bb$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $093d7f77b2b159bb$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $093d7f77b2b159bb$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $093d7f77b2b159bb$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $093d7f77b2b159bb$var$isInert(node) || $093d7f77b2b159bb$var$isHiddenInput(node) || $093d7f77b2b159bb$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $093d7f77b2b159bb$var$isDetailsWithSummary(node) || $093d7f77b2b159bb$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $093d7f77b2b159bb$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($093d7f77b2b159bb$var$isNonTabbableRadio(node) || $093d7f77b2b159bb$export$a4672efddb4181b8(node) < 0 || !$093d7f77b2b159bb$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $093d7f77b2b159bb$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $093d7f77b2b159bb$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $093d7f77b2b159bb$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($093d7f77b2b159bb$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $093d7f77b2b159bb$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $093d7f77b2b159bb$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $093d7f77b2b159bb$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $093d7f77b2b159bb$var$isValidShadowRootTabbable
    });
    else candidates = $093d7f77b2b159bb$var$getCandidates(container, options.includeContainer, $093d7f77b2b159bb$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $093d7f77b2b159bb$var$sortByOrder(candidates);
};
var $093d7f77b2b159bb$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $093d7f77b2b159bb$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $093d7f77b2b159bb$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $093d7f77b2b159bb$var$getCandidates(container, options.includeContainer, $093d7f77b2b159bb$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $093d7f77b2b159bb$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($093d7f77b2b159bb$var$matches.call(node, $093d7f77b2b159bb$var$candidateSelector) === false) return false;
    return $093d7f77b2b159bb$var$isNodeMatchingSelectorTabbable(options, node);
};
var $093d7f77b2b159bb$var$focusableCandidateSelector = /* #__PURE__ */ $093d7f77b2b159bb$var$candidateSelectors.concat("iframe").join(",");
var $093d7f77b2b159bb$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($093d7f77b2b159bb$var$matches.call(node, $093d7f77b2b159bb$var$focusableCandidateSelector) === false) return false;
    return $093d7f77b2b159bb$var$isNodeMatchingSelectorFocusable(options, node);
};

});

parcelRequire.register("jiVm5", function(module, exports) {

$parcel$export(module.exports, "useFloating", function () { return $e0dc3054c0a828de$export$4e02a5c1d08bac65; });
$parcel$export(module.exports, "offset", function () { return $e0dc3054c0a828de$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $e0dc3054c0a828de$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $e0dc3054c0a828de$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "flip", function () { return $e0dc3054c0a828de$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $e0dc3054c0a828de$export$346677f925de839c; });
$parcel$export(module.exports, "autoPlacement", function () { return $e0dc3054c0a828de$export$91fb6ecbd551914; });
$parcel$export(module.exports, "hide", function () { return $e0dc3054c0a828de$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $e0dc3054c0a828de$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "arrow", function () { return $e0dc3054c0a828de$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "computePosition", function () { return (parcelRequire("9Q6OH")).computePosition; });

var $9Q6OH = parcelRequire("9Q6OH");
var $5UDEU = parcelRequire("5UDEU");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
var $e0dc3054c0a828de$var$index = typeof document !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $e0dc3054c0a828de$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$e0dc3054c0a828de$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$e0dc3054c0a828de$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $e0dc3054c0a828de$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $e0dc3054c0a828de$var$roundByDPR(element, value) {
    const dpr = $e0dc3054c0a828de$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $e0dc3054c0a828de$var$useLatestRef(value) {
    const ref = $exYeM.useRef(value);
    $e0dc3054c0a828de$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $e0dc3054c0a828de$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform , elements: { reference: externalReference , floating: externalFloating  } = {} , transform: transform = true , whileElementsMounted: whileElementsMounted , open: open  } = options;
    const [data, setData] = $exYeM.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $exYeM.useState(middleware);
    if (!$e0dc3054c0a828de$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $exYeM.useState(null);
    const [_floating, _setFloating] = $exYeM.useState(null);
    const setReference = $exYeM.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $exYeM.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $exYeM.useRef(null);
    const floatingRef = $exYeM.useRef(null);
    const dataRef = $exYeM.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $e0dc3054c0a828de$var$useLatestRef(whileElementsMounted);
    const platformRef = $e0dc3054c0a828de$var$useLatestRef(platform);
    const update = $exYeM.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $9Q6OH.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$e0dc3054c0a828de$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $d2lNW.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $e0dc3054c0a828de$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $exYeM.useRef(false);
    $e0dc3054c0a828de$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $e0dc3054c0a828de$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $exYeM.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $exYeM.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $exYeM.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $e0dc3054c0a828de$var$roundByDPR(elements.floating, data.x);
        const y = $e0dc3054c0a828de$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$e0dc3054c0a828de$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $exYeM.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e0dc3054c0a828de$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element , padding: padding  } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $9Q6OH.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $9Q6OH.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $e0dc3054c0a828de$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $9Q6OH.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $e0dc3054c0a828de$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $9Q6OH.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $e0dc3054c0a828de$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $9Q6OH.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $e0dc3054c0a828de$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $9Q6OH.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $e0dc3054c0a828de$export$346677f925de839c = (options, deps)=>({
        ...(0, $9Q6OH.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $e0dc3054c0a828de$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $9Q6OH.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $e0dc3054c0a828de$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $9Q6OH.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $e0dc3054c0a828de$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $9Q6OH.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e0dc3054c0a828de$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$e0dc3054c0a828de$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });

});
parcelRequire.register("9Q6OH", function(module, exports) {

$parcel$export(module.exports, "platform", function () { return $729e420fd9c85e8f$export$722a64dea1b767dc; });
$parcel$export(module.exports, "autoUpdate", function () { return $729e420fd9c85e8f$export$deee3a793edee05f; });
$parcel$export(module.exports, "detectOverflow", function () { return $729e420fd9c85e8f$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "offset", function () { return $729e420fd9c85e8f$export$cc800923e997bb8; });
$parcel$export(module.exports, "autoPlacement", function () { return $729e420fd9c85e8f$export$91fb6ecbd551914; });
$parcel$export(module.exports, "shift", function () { return $729e420fd9c85e8f$export$fba63a578e423eb; });
$parcel$export(module.exports, "flip", function () { return $729e420fd9c85e8f$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "size", function () { return $729e420fd9c85e8f$export$346677f925de839c; });
$parcel$export(module.exports, "hide", function () { return $729e420fd9c85e8f$export$fe8985bb6374093c; });
$parcel$export(module.exports, "arrow", function () { return $729e420fd9c85e8f$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "inline", function () { return $729e420fd9c85e8f$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "limitShift", function () { return $729e420fd9c85e8f$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "computePosition", function () { return $729e420fd9c85e8f$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return (parcelRequire("5UDEU")).getOverflowAncestors; });
parcelRequire("3vWD9");
var $cCxCV = parcelRequire("cCxCV");
var $3vWD9 = parcelRequire("3vWD9");

var $cCxCV = parcelRequire("cCxCV");

var $5UDEU = parcelRequire("5UDEU");
function $729e420fd9c85e8f$var$getCssDimensions(element) {
    const css = (0, $5UDEU.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $5UDEU.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cCxCV.round)(width) !== offsetWidth || (0, $cCxCV.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $729e420fd9c85e8f$var$unwrapElement(element) {
    return !(0, $5UDEU.isElement)(element) ? element.contextElement : element;
}
function $729e420fd9c85e8f$var$getScale(element) {
    const domElement = $729e420fd9c85e8f$var$unwrapElement(element);
    if (!(0, $5UDEU.isHTMLElement)(domElement)) return (0, $cCxCV.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width , height: height , $: $  } = $729e420fd9c85e8f$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cCxCV.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cCxCV.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $729e420fd9c85e8f$var$noOffsets = /*#__PURE__*/ (0, $cCxCV.createCoords)(0);
function $729e420fd9c85e8f$var$getVisualOffsets(element) {
    const win = (0, $5UDEU.getWindow)(element);
    if (!(0, $5UDEU.isWebKit)() || !win.visualViewport) return $729e420fd9c85e8f$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $729e420fd9c85e8f$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $5UDEU.getWindow)(element)) return false;
    return isFixed;
}
function $729e420fd9c85e8f$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $729e420fd9c85e8f$var$unwrapElement(element);
    let scale = (0, $cCxCV.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $5UDEU.isElement)(offsetParent)) scale = $729e420fd9c85e8f$var$getScale(offsetParent);
        } else scale = $729e420fd9c85e8f$var$getScale(element);
    }
    const visualOffsets = $729e420fd9c85e8f$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $729e420fd9c85e8f$var$getVisualOffsets(domElement) : (0, $cCxCV.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $5UDEU.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $5UDEU.isElement)(offsetParent) ? (0, $5UDEU.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $729e420fd9c85e8f$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $5UDEU.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $5UDEU.getWindow)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $cCxCV.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $729e420fd9c85e8f$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements , rect: rect , offsetParent: offsetParent , strategy: strategy  } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $5UDEU.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $5UDEU.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cCxCV.createCoords)(1);
    const offsets = (0, $cCxCV.createCoords)(0);
    const isOffsetParentAnElement = (0, $5UDEU.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $5UDEU.getNodeName)(offsetParent) !== "body" || (0, $5UDEU.isOverflowElement)(documentElement)) scroll = (0, $5UDEU.getNodeScroll)(offsetParent);
        if ((0, $5UDEU.isHTMLElement)(offsetParent)) {
            const offsetRect = $729e420fd9c85e8f$var$getBoundingClientRect(offsetParent);
            scale = $729e420fd9c85e8f$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $729e420fd9c85e8f$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $729e420fd9c85e8f$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $729e420fd9c85e8f$var$getBoundingClientRect((0, $5UDEU.getDocumentElement)(element)).left + (0, $5UDEU.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $729e420fd9c85e8f$var$getDocumentRect(element) {
    const html = (0, $5UDEU.getDocumentElement)(element);
    const scroll = (0, $5UDEU.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cCxCV.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cCxCV.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $729e420fd9c85e8f$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $5UDEU.getComputedStyle)(body).direction === "rtl") x += (0, $cCxCV.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$getViewportRect(element, strategy) {
    const win = (0, $5UDEU.getWindow)(element);
    const html = (0, $5UDEU.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $5UDEU.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $729e420fd9c85e8f$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $729e420fd9c85e8f$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $5UDEU.isHTMLElement)(element) ? $729e420fd9c85e8f$var$getScale(element) : (0, $cCxCV.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $729e420fd9c85e8f$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $729e420fd9c85e8f$var$getDocumentRect((0, $5UDEU.getDocumentElement)(element));
    else if ((0, $5UDEU.isElement)(clippingAncestor)) rect = $729e420fd9c85e8f$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $729e420fd9c85e8f$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $cCxCV.rectToClientRect)(rect);
}
function $729e420fd9c85e8f$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $5UDEU.getParentNode)(element);
    if (parentNode === stopNode || !(0, $5UDEU.isElement)(parentNode) || (0, $5UDEU.isLastTraversableNode)(parentNode)) return false;
    return (0, $5UDEU.getComputedStyle)(parentNode).position === "fixed" || $729e420fd9c85e8f$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $729e420fd9c85e8f$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $5UDEU.getOverflowAncestors)(element, [], false).filter((el)=>(0, $5UDEU.isElement)(el) && (0, $5UDEU.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $5UDEU.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $5UDEU.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $5UDEU.isElement)(currentNode) && !(0, $5UDEU.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $5UDEU.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $5UDEU.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $5UDEU.isOverflowElement)(currentNode) && !currentNodeIsContaining && $729e420fd9c85e8f$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $5UDEU.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $729e420fd9c85e8f$var$getClippingRect(_ref) {
    let { element: element , boundary: boundary , rootBoundary: rootBoundary , strategy: strategy  } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $5UDEU.isTopLayer)(element) ? [] : $729e420fd9c85e8f$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cCxCV.max)(rect.top, accRect.top);
        accRect.right = (0, $cCxCV.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cCxCV.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cCxCV.max)(rect.left, accRect.left);
        return accRect;
    }, $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $729e420fd9c85e8f$var$getDimensions(element) {
    const { width: width , height: height  } = $729e420fd9c85e8f$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $729e420fd9c85e8f$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $5UDEU.isHTMLElement)(offsetParent);
    const documentElement = (0, $5UDEU.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $729e420fd9c85e8f$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cCxCV.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $5UDEU.getNodeName)(offsetParent) !== "body" || (0, $5UDEU.isOverflowElement)(documentElement)) scroll = (0, $5UDEU.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $729e420fd9c85e8f$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $729e420fd9c85e8f$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $729e420fd9c85e8f$var$isStaticPositioned(element) {
    return (0, $5UDEU.getComputedStyle)(element).position === "static";
}
function $729e420fd9c85e8f$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $5UDEU.isHTMLElement)(element) || (0, $5UDEU.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $729e420fd9c85e8f$var$getOffsetParent(element, polyfill) {
    const win = (0, $5UDEU.getWindow)(element);
    if ((0, $5UDEU.isTopLayer)(element)) return win;
    if (!(0, $5UDEU.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $5UDEU.getParentNode)(element);
        while(svgOffsetParent && !(0, $5UDEU.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $5UDEU.isElement)(svgOffsetParent) && !$729e420fd9c85e8f$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $5UDEU.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $729e420fd9c85e8f$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $5UDEU.isTableElement)(offsetParent) && $729e420fd9c85e8f$var$isStaticPositioned(offsetParent))offsetParent = $729e420fd9c85e8f$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $5UDEU.isLastTraversableNode)(offsetParent) && $729e420fd9c85e8f$var$isStaticPositioned(offsetParent) && !(0, $5UDEU.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $5UDEU.getContainingBlock)(element) || win;
}
const $729e420fd9c85e8f$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $729e420fd9c85e8f$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $729e420fd9c85e8f$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $729e420fd9c85e8f$var$isRTL(element) {
    return (0, $5UDEU.getComputedStyle)(element).direction === "rtl";
}
const $729e420fd9c85e8f$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $729e420fd9c85e8f$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $5UDEU.getDocumentElement,
    getClippingRect: $729e420fd9c85e8f$var$getClippingRect,
    getOffsetParent: $729e420fd9c85e8f$var$getOffsetParent,
    getElementRects: $729e420fd9c85e8f$var$getElementRects,
    getClientRects: $729e420fd9c85e8f$var$getClientRects,
    getDimensions: $729e420fd9c85e8f$var$getDimensions,
    getScale: $729e420fd9c85e8f$var$getScale,
    isElement: $5UDEU.isElement,
    isRTL: $729e420fd9c85e8f$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $729e420fd9c85e8f$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $5UDEU.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left , top: top , width: width , height: height  } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cCxCV.floor)(top);
        const insetRight = (0, $cCxCV.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cCxCV.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cCxCV.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cCxCV.max)(0, (0, $cCxCV.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $729e420fd9c85e8f$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true , ancestorResize: ancestorResize = true , elementResize: elementResize = typeof ResizeObserver === "function" , layoutShift: layoutShift = typeof IntersectionObserver === "function" , animationFrame: animationFrame = false  } = options;
    const referenceEl = $729e420fd9c85e8f$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $5UDEU.getOverflowAncestors)(referenceEl) : [],
        ...(0, $5UDEU.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $729e420fd9c85e8f$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $729e420fd9c85e8f$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $729e420fd9c85e8f$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $729e420fd9c85e8f$export$37b6bde19b108ecc = (0, $3vWD9.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $729e420fd9c85e8f$export$cc800923e997bb8 = (0, $3vWD9.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $729e420fd9c85e8f$export$91fb6ecbd551914 = (0, $3vWD9.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $729e420fd9c85e8f$export$fba63a578e423eb = (0, $3vWD9.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $729e420fd9c85e8f$export$8a83211c878a3f1f = (0, $3vWD9.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $729e420fd9c85e8f$export$346677f925de839c = (0, $3vWD9.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $729e420fd9c85e8f$export$fe8985bb6374093c = (0, $3vWD9.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $729e420fd9c85e8f$export$f2120bbfa5450bd2 = (0, $3vWD9.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $729e420fd9c85e8f$export$18c8ad048e32c7d5 = (0, $3vWD9.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $729e420fd9c85e8f$export$7bf07e38f3dc4b69 = (0, $3vWD9.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $729e420fd9c85e8f$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $729e420fd9c85e8f$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $3vWD9.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRequire.register("3vWD9", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $28f1bf2594995773$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $28f1bf2594995773$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $28f1bf2594995773$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $28f1bf2594995773$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $28f1bf2594995773$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $28f1bf2594995773$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $28f1bf2594995773$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $28f1bf2594995773$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $28f1bf2594995773$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $28f1bf2594995773$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $28f1bf2594995773$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("cCxCV")).rectToClientRect; });

var $cCxCV = parcelRequire("cCxCV");
function $28f1bf2594995773$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference , floating: floating  } = _ref;
    const sideAxis = (0, $cCxCV.getSideAxis)(placement);
    const alignmentAxis = (0, $cCxCV.getAlignmentAxis)(placement);
    const alignLength = (0, $cCxCV.getAxisLength)(alignmentAxis);
    const side = (0, $cCxCV.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cCxCV.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $28f1bf2594995773$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom" , strategy: strategy = "absolute" , middleware: middleware = [] , platform: platform  } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x , y: y  } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name , fn: fn  } = validMiddleware[i];
        const { x: nextX , y: nextY , data: data , reset: reset  } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x , y: y  } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $28f1bf2594995773$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x , y: y , platform: platform , rects: rects , elements: elements , strategy: strategy  } = state;
    const { boundary: boundary = "clippingAncestors" , rootBoundary: rootBoundary = "viewport" , elementContext: elementContext = "floating" , altBoundary: altBoundary = false , padding: padding = 0  } = (0, $cCxCV.evaluate)(options, state);
    const paddingObject = (0, $cCxCV.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cCxCV.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cCxCV.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $28f1bf2594995773$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , platform: platform , elements: elements , middlewareData: middlewareData  } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element , padding: padding = 0  } = (0, $cCxCV.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cCxCV.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cCxCV.getAlignmentAxis)(placement);
            const length = (0, $cCxCV.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cCxCV.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cCxCV.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cCxCV.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cCxCV.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $28f1bf2594995773$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cCxCV.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cCxCV.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cCxCV.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cCxCV.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cCxCV.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $28f1bf2594995773$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects , middlewareData: middlewareData , placement: placement , platform: platform , elements: elements  } = state;
            const { crossAxis: crossAxis = false , alignment: alignment , allowedPlacements: allowedPlacements = (0, $cCxCV.placements) , autoAlignment: autoAlignment = true , ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cCxCV.placements) ? $28f1bf2594995773$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cCxCV.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cCxCV.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cCxCV.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cCxCV.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $28f1bf2594995773$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement , middlewareData: middlewareData , rects: rects , initialPlacement: initialPlacement , platform: platform , elements: elements  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true , fallbackPlacements: specifiedFallbackPlacements , fallbackStrategy: fallbackStrategy = "bestFit" , fallbackAxisSideDirection: fallbackAxisSideDirection = "none" , flipAlignment: flipAlignment = true , ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cCxCV.getSide)(placement);
            const initialSideAxis = (0, $cCxCV.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cCxCV.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cCxCV.getOppositePlacement)(initialPlacement)
            ] : (0, $cCxCV.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cCxCV.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cCxCV.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cCxCV.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $28f1bf2594995773$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $28f1bf2594995773$var$isAnySideFullyClipped(overflow) {
    return (0, $cCxCV.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $28f1bf2594995773$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects  } = state;
            const { strategy: strategy = "referenceHidden" , ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $28f1bf2594995773$var$getBoundingRect(rects) {
    const minX = (0, $cCxCV.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cCxCV.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cCxCV.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cCxCV.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $28f1bf2594995773$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cCxCV.rectToClientRect)($28f1bf2594995773$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $28f1bf2594995773$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement , elements: elements , rects: rects , platform: platform , strategy: strategy  } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2 , x: x , y: y  } = (0, $cCxCV.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $28f1bf2594995773$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cCxCV.rectToClientRect)($28f1bf2594995773$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cCxCV.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cCxCV.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cCxCV.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cCxCV.getSide)(placement) === "left";
                    const maxRight = (0, $cCxCV.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cCxCV.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $28f1bf2594995773$var$convertValueToCoords(state, options) {
    const { placement: placement , platform: platform , elements: elements  } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cCxCV.getSide)(placement);
    const alignment = (0, $cCxCV.getAlignment)(placement);
    const isVertical = (0, $cCxCV.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cCxCV.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis , crossAxis: crossAxis , alignmentAxis: alignmentAxis  } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $28f1bf2594995773$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x , y: y , placement: placement , middlewareData: middlewareData  } = state;
            const diffCoords = await $28f1bf2594995773$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $28f1bf2594995773$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x , y: y , placement: placement  } = state;
            const { mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = false , limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x , y: y  } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } , ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cCxCV.getSideAxis)((0, $cCxCV.getSide)(placement));
            const mainAxis = (0, $cCxCV.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cCxCV.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cCxCV.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $28f1bf2594995773$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x , y: y , placement: placement , rects: rects , middlewareData: middlewareData  } = state;
            const { offset: offset = 0 , mainAxis: checkMainAxis = true , crossAxis: checkCrossAxis = true  } = (0, $cCxCV.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cCxCV.getSideAxis)(placement);
            const mainAxis = (0, $cCxCV.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cCxCV.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $cCxCV.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $28f1bf2594995773$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement , rects: rects , platform: platform , elements: elements  } = state;
            const { apply: apply = ()=>{} , ...detectOverflowOptions } = (0, $cCxCV.evaluate)(options, state);
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cCxCV.getSide)(placement);
            const alignment = (0, $cCxCV.getAlignment)(placement);
            const isYAxis = (0, $cCxCV.getSideAxis)(placement) === "y";
            const { width: width , height: height  } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cCxCV.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cCxCV.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, $cCxCV.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, $cCxCV.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cCxCV.max)(overflow.left, 0);
                const xMax = (0, $cCxCV.max)(overflow.right, 0);
                const yMin = (0, $cCxCV.max)(overflow.top, 0);
                const yMax = (0, $cCxCV.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cCxCV.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cCxCV.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});




var $7ead0b1397a835ed$exports = {};
"use strict";

$7ead0b1397a835ed$exports = (parcelRequire("6ObR8"));


parcelRequire("exYeM");
var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";

var $d2lNW = parcelRequire("d2lNW");
var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $d2lNW.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $d2lNW.hydrateRoot;





var $exYeM = parcelRequire("exYeM");
var $55016c398784f6a3$export$38e42c68cf43b5d4;
var $55016c398784f6a3$export$385906a4ef528034;
var $55016c398784f6a3$export$69d0d1846105bbd3;
var $55016c398784f6a3$export$a4e0ccd0af956942;
$55016c398784f6a3$export$38e42c68cf43b5d4 = `MqZHCq_header`;
$55016c398784f6a3$export$385906a4ef528034 = `MqZHCq_headerSuccess`;
$55016c398784f6a3$export$69d0d1846105bbd3 = `MqZHCq_invisiblePlaceholder`;
$55016c398784f6a3$export$a4e0ccd0af956942 = `MqZHCq_nothingFake1234`;




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
const $29d15a9b4d4d0d9f$export$13470c6f1642bbce = "Logging";
const $29d15a9b4d4d0d9f$export$16032fc466434892 = "x-amz-user-agent";
// Error exception code constants
const $29d15a9b4d4d0d9f$export$86d53207c3c20049 = "NoHubcallbackProvidedException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $343e229b8fad8cda$export$a0472aa3a356446c;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
    LogType["NONE"] = "NONE";
})($343e229b8fad8cda$export$a0472aa3a356446c || ($343e229b8fad8cda$export$a0472aa3a356446c = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $cda4d9e419200573$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
    NONE: 6
};
/**
 * Write logs
 * @class Logger
 */ class $cda4d9e419200573$export$ba6a9c7ac8291f7f {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, $343e229b8fad8cda$export$a0472aa3a356446c).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    _padding(n) {
        return n < 10 ? "0" + n : "" + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let loggerLevelName = this.level;
        if ($cda4d9e419200573$export$ba6a9c7ac8291f7f.LOG_LEVEL) loggerLevelName = $cda4d9e419200573$export$ba6a9c7ac8291f7f.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) loggerLevelName = window.LOG_LEVEL;
        const loggerLevel = $cda4d9e419200573$var$LOG_LEVELS[loggerLevelName];
        const typeLevel = $cda4d9e419200573$var$LOG_LEVELS[type];
        if (!(typeLevel >= loggerLevel)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, $343e229b8fad8cda$export$a0472aa3a356446c).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, $343e229b8fad8cda$export$a0472aa3a356446c).WARN && console.warn) log = console.warn.bind(console);
        if ($cda4d9e419200573$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS) {
            if (type === (0, $343e229b8fad8cda$export$a0472aa3a356446c).INFO && console.info) log = console.info.bind(console);
            if (type === (0, $343e229b8fad8cda$export$a0472aa3a356446c).DEBUG && console.debug) log = console.debug.bind(console);
        }
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message: message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, $343e229b8fad8cda$export$a0472aa3a356446c).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $29d15a9b4d4d0d9f$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
}
$cda4d9e419200573$export$ba6a9c7ac8291f7f.LOG_LEVEL = null;
$cda4d9e419200573$export$ba6a9c7ac8291f7f.BIND_ALL_LOG_LEVELS = false;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $05b2dc7abeec3af3$export$37321a6dace1881c extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message: message , name: name , recoverySuggestion: recoverySuggestion , underlyingError: underlyingError  }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $05b2dc7abeec3af3$export$37321a6dace1881c;
        Object.setPrototypeOf(this, $05b2dc7abeec3af3$export$37321a6dace1881c.prototype);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c9802061728ce106$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" ? Symbol("amplify_default") : "@@amplify_default";
const $c9802061728ce106$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("Hub");
class $c9802061728ce106$export$6b38ef2be9abbbb9 {
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            $c9802061728ce106$var$logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback: callback  })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === "string" && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === $c9802061728ce106$export$aadf71dd9875dd20;
            if (!hasAccess) $c9802061728ce106$var$logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel: channel,
            payload: {
                ...payload
            },
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $c9802061728ce106$var$logger.error(e);
        }
    }
    listen(channel, callback, listenerName = "noname") {
        let cb;
        if (typeof callback !== "function") throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
            name: (0, $29d15a9b4d4d0d9f$export$86d53207c3c20049),
            message: "No callback supplied to Hub"
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel: channel , payload: payload  } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            $c9802061728ce106$var$logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $c9802061728ce106$var$logger.error(e);
            }
        });
    }
}
/* We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events. */ const $c9802061728ce106$export$8c41bb232f1008b1 = new $c9802061728ce106$export$6b38ef2be9abbbb9("__default__");
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const $c9802061728ce106$export$45dde0743a4c8d6e = new $c9802061728ce106$export$6b38ef2be9abbbb9("internal-hub");




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3040204a38b40487$export$7e32b29e1cb162e1 = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $3040204a38b40487$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6b6ce34dcf385dec$export$35210b3191d26437 = Symbol("oauth-listener");







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9e9ebeb6d3af43c3$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("parseAWSExports");
const $9e9ebeb6d3af43c3$var$authTypeMapping = {
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AMAZON_COGNITO_USER_POOLS: "userPool",
    OPENID_CONNECT: "oidc",
    NONE: "none",
    AWS_LAMBDA: "lambda",
    // `LAMBDA` is an incorrect value that was added during the v6 rewrite.
    // Keeping it as a valid value until v7 to prevent breaking customers who might
    // be relying on it as a workaround.
    // ref: https://github.com/aws-amplify/amplify-js/pull/12922
    // TODO: @v7 remove next line
    LAMBDA: "lambda"
};
/**
 * Converts the object imported from `aws-exports.js` or `amplifyconfiguration.json` files generated by
 * the Amplify CLI into an object that conforms to the {@link ResourcesConfig}.
 *
 * @param config A configuration object imported  from `aws-exports.js` or `amplifyconfiguration.json`.
 *
 * @returns An object that conforms to the {@link ResourcesConfig} .
 */ const $9e9ebeb6d3af43c3$export$1ef2e9c2da492d = (config = {})=>{
    if (!Object.prototype.hasOwnProperty.call(config, "aws_project_region")) throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
        name: "InvalidParameterException",
        message: "Invalid config parameter.",
        recoverySuggestion: "Ensure passing the config object imported from  `amplifyconfiguration.json`."
    });
    const { aws_appsync_apiKey: aws_appsync_apiKey , aws_appsync_authenticationType: aws_appsync_authenticationType , aws_appsync_graphqlEndpoint: aws_appsync_graphqlEndpoint , aws_appsync_region: aws_appsync_region , aws_bots_config: aws_bots_config , aws_cognito_identity_pool_id: aws_cognito_identity_pool_id , aws_cognito_sign_up_verification_method: aws_cognito_sign_up_verification_method , aws_cognito_mfa_configuration: aws_cognito_mfa_configuration , aws_cognito_mfa_types: aws_cognito_mfa_types , aws_cognito_password_protection_settings: aws_cognito_password_protection_settings , aws_cognito_verification_mechanisms: aws_cognito_verification_mechanisms , aws_cognito_signup_attributes: aws_cognito_signup_attributes , aws_cognito_social_providers: aws_cognito_social_providers , aws_cognito_username_attributes: aws_cognito_username_attributes , aws_mandatory_sign_in: aws_mandatory_sign_in , aws_mobile_analytics_app_id: aws_mobile_analytics_app_id , aws_mobile_analytics_app_region: aws_mobile_analytics_app_region , aws_user_files_s3_bucket: aws_user_files_s3_bucket , aws_user_files_s3_bucket_region: aws_user_files_s3_bucket_region , aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing , aws_user_pools_id: aws_user_pools_id , aws_user_pools_web_client_id: aws_user_pools_web_client_id , geo: geo , oauth: oauth , predictions: predictions , aws_cloud_logic_custom: aws_cloud_logic_custom , Notifications: Notifications , modelIntrospection: modelIntrospection  } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging: InAppMessaging , Push: Push  } = Notifications ?? {};
    if (InAppMessaging?.AWSPinpoint || Push?.AWSPinpoint) {
        if (InAppMessaging?.AWSPinpoint) {
            const { appId: appId , region: region  } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
        if (Push?.AWSPinpoint) {
            const { appId: appId , region: region  } = Push.AWSPinpoint;
            amplifyConfig.Notifications = {
                ...amplifyConfig.Notifications,
                PushNotification: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = $9e9ebeb6d3af43c3$var$authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) $9e9ebeb6d3af43c3$var$logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode ?? "iam"
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: aws_cognito_mfa_types?.includes("TOTP") ?? false,
        smsEnabled: aws_cognito_mfa_types?.includes("SMS") ?? false
    } : undefined;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_LOWERCASE") ?? false,
        requireUppercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_UPPERCASE") ?? false,
        requireNumbers: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_NUMBERS") ?? false,
        requireSpecialCharacters: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_SYMBOLS") ?? false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms ?? [],
        ...aws_cognito_signup_attributes ?? []
    ]));
    const userAttributes = mergedUserAttributes.reduce((attributes, key)=>({
            ...attributes,
            // All user attributes generated by the CLI are required
            [key.toLowerCase()]: {
                required: true
            }
        }), {});
    const loginWithEmailEnabled = aws_cognito_username_attributes?.includes("EMAIL") ?? false;
    const loginWithPhoneEnabled = aws_cognito_username_attributes?.includes("PHONE_NUMBER") ?? false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== "enable",
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes: userAttributes,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: !(loginWithEmailEnabled || loginWithPhoneEnabled),
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = {
        ...amplifyConfig.Auth.Cognito.loginWith,
        oauth: {
            ...$9e9ebeb6d3af43c3$var$getOAuthConfig(oauth),
            ...hasSocialProviderConfig && {
                providers: $9e9ebeb6d3af43c3$var$parseSocialProviders(aws_cognito_social_providers)
            }
        }
    };
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service: amazon_location_service  } = geo;
        amplifyConfig.Geo = {
            LocationService: {
                maps: amazon_location_service.maps,
                geofenceCollections: amazon_location_service.geofenceCollections,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = {
        ...amplifyConfig.API,
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name: name , endpoint: endpoint , region: region , service: service  } = api;
            return {
                ...acc,
                [name]: {
                    endpoint: endpoint,
                    ...service ? {
                        service: service
                    } : undefined,
                    ...region ? {
                        region: region
                    } : undefined
                }
            };
        }, {})
    };
    // Predictions
    if (predictions) {
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId  } = predictions?.convert?.speechGenerator?.defaults ?? {};
        amplifyConfig.Predictions = voiceId ? {
            ...predictions,
            convert: {
                ...predictions.convert,
                speechGenerator: {
                    ...predictions.convert.speechGenerator,
                    defaults: {
                        voiceId: voiceId
                    }
                }
            }
        } : predictions;
    }
    return amplifyConfig;
};
const $9e9ebeb6d3af43c3$var$getRedirectUrl = (redirectStr)=>redirectStr?.split(",") ?? [];
const $9e9ebeb6d3af43c3$var$getOAuthConfig = ({ domain: domain , scope: scope , redirectSignIn: redirectSignIn , redirectSignOut: redirectSignOut , responseType: responseType  })=>({
        domain: domain,
        scopes: scope,
        redirectSignIn: $9e9ebeb6d3af43c3$var$getRedirectUrl(redirectSignIn),
        redirectSignOut: $9e9ebeb6d3af43c3$var$getRedirectUrl(redirectSignOut),
        responseType: responseType
    });
const $9e9ebeb6d3af43c3$var$parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $961c2883822cc512$export$99bf765e6322c00(config) {
    // version format initially will be '1' but is expected to be something like x.y where x is major and y minor version
    const { version: version  } = config;
    if (!version) return false;
    return version.startsWith("1");
}
function $961c2883822cc512$var$parseStorage(amplifyOutputsStorageProperties) {
    if (!amplifyOutputsStorageProperties) return undefined;
    const { bucket_name: bucket_name , aws_region: aws_region  } = amplifyOutputsStorageProperties;
    return {
        S3: {
            bucket: bucket_name,
            region: aws_region
        }
    };
}
function $961c2883822cc512$var$parseAuth(amplifyOutputsAuthProperties) {
    if (!amplifyOutputsAuthProperties) return undefined;
    const { user_pool_id: user_pool_id , user_pool_client_id: user_pool_client_id , identity_pool_id: identity_pool_id , password_policy: password_policy , mfa_configuration: mfa_configuration , mfa_methods: mfa_methods , unauthenticated_identities_enabled: unauthenticated_identities_enabled , oauth: oauth , username_attributes: username_attributes , standard_required_attributes: standard_required_attributes  } = amplifyOutputsAuthProperties;
    const authConfig = {
        Cognito: {
            userPoolId: user_pool_id,
            userPoolClientId: user_pool_client_id
        }
    };
    if (identity_pool_id) authConfig.Cognito = {
        ...authConfig.Cognito,
        identityPoolId: identity_pool_id
    };
    if (password_policy) authConfig.Cognito.passwordFormat = {
        requireLowercase: password_policy.require_lowercase,
        requireNumbers: password_policy.require_numbers,
        requireUppercase: password_policy.require_uppercase,
        requireSpecialCharacters: password_policy.require_symbols,
        minLength: password_policy.min_length ?? 6
    };
    if (mfa_configuration) authConfig.Cognito.mfa = {
        status: $961c2883822cc512$var$getMfaStatus(mfa_configuration),
        smsEnabled: mfa_methods?.includes("SMS"),
        totpEnabled: mfa_methods?.includes("TOTP")
    };
    if (unauthenticated_identities_enabled) authConfig.Cognito.allowGuestAccess = unauthenticated_identities_enabled;
    if (oauth) authConfig.Cognito.loginWith = {
        oauth: {
            domain: oauth.domain,
            redirectSignIn: oauth.redirect_sign_in_uri,
            redirectSignOut: oauth.redirect_sign_out_uri,
            responseType: oauth.response_type === "token" ? "token" : "code",
            scopes: oauth.scopes,
            providers: $961c2883822cc512$var$getOAuthProviders(oauth.identity_providers)
        }
    };
    if (username_attributes) authConfig.Cognito.loginWith = {
        ...authConfig.Cognito.loginWith,
        email: username_attributes.includes("email"),
        phone: username_attributes.includes("phone_number"),
        // Signing in with a username is not currently supported in Gen2, this should always evaluate to false
        username: username_attributes.includes("username")
    };
    if (standard_required_attributes) authConfig.Cognito.userAttributes = standard_required_attributes.reduce((acc, curr)=>({
            ...acc,
            [curr]: {
                required: true
            }
        }), {});
    return authConfig;
}
function $961c2883822cc512$export$fbb0a2a08db9629a(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties?.amazon_pinpoint) return undefined;
    const { amazon_pinpoint: amazon_pinpoint  } = amplifyOutputsAnalyticsProperties;
    return {
        Pinpoint: {
            appId: amazon_pinpoint.app_id,
            region: amazon_pinpoint.aws_region
        }
    };
}
function $961c2883822cc512$var$parseGeo(amplifyOutputsAnalyticsProperties) {
    if (!amplifyOutputsAnalyticsProperties) return undefined;
    const { aws_region: aws_region , geofence_collections: geofence_collections , maps: maps , search_indices: search_indices  } = amplifyOutputsAnalyticsProperties;
    return {
        LocationService: {
            region: aws_region,
            searchIndices: search_indices,
            geofenceCollections: geofence_collections,
            maps: maps
        }
    };
}
function $961c2883822cc512$var$parseData(amplifyOutputsDataProperties) {
    if (!amplifyOutputsDataProperties) return undefined;
    const { aws_region: aws_region , default_authorization_type: default_authorization_type , url: url , api_key: api_key , model_introspection: model_introspection  } = amplifyOutputsDataProperties;
    const GraphQL = {
        endpoint: url,
        defaultAuthMode: $961c2883822cc512$var$getGraphQLAuthMode(default_authorization_type),
        region: aws_region,
        apiKey: api_key,
        modelIntrospection: model_introspection
    };
    return {
        GraphQL: GraphQL
    };
}
function $961c2883822cc512$var$parseNotifications(amplifyOutputsNotificationsProperties) {
    if (!amplifyOutputsNotificationsProperties) return undefined;
    const { aws_region: aws_region , channels: channels , amazon_pinpoint_app_id: amazon_pinpoint_app_id  } = amplifyOutputsNotificationsProperties;
    const hasInAppMessaging = channels.includes("IN_APP_MESSAGING");
    const hasPushNotification = channels.includes("APNS") || channels.includes("FCM");
    if (!(hasInAppMessaging || hasPushNotification)) return undefined;
    // At this point, we know the Amplify outputs contains at least one supported channel
    const notificationsConfig = {};
    if (hasInAppMessaging) notificationsConfig.InAppMessaging = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    if (hasPushNotification) notificationsConfig.PushNotification = {
        Pinpoint: {
            appId: amazon_pinpoint_app_id,
            region: aws_region
        }
    };
    return notificationsConfig;
}
function $961c2883822cc512$export$11d0da171d17ab63(amplifyOutputs) {
    const resourcesConfig = {};
    if (amplifyOutputs.storage) resourcesConfig.Storage = $961c2883822cc512$var$parseStorage(amplifyOutputs.storage);
    if (amplifyOutputs.auth) resourcesConfig.Auth = $961c2883822cc512$var$parseAuth(amplifyOutputs.auth);
    if (amplifyOutputs.analytics) resourcesConfig.Analytics = $961c2883822cc512$export$fbb0a2a08db9629a(amplifyOutputs.analytics);
    if (amplifyOutputs.geo) resourcesConfig.Geo = $961c2883822cc512$var$parseGeo(amplifyOutputs.geo);
    if (amplifyOutputs.data) resourcesConfig.API = $961c2883822cc512$var$parseData(amplifyOutputs.data);
    if (amplifyOutputs.notifications) resourcesConfig.Notifications = $961c2883822cc512$var$parseNotifications(amplifyOutputs.notifications);
    return resourcesConfig;
}
const $961c2883822cc512$var$authModeNames = {
    AMAZON_COGNITO_USER_POOLS: "userPool",
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AWS_LAMBDA: "lambda",
    OPENID_CONNECT: "oidc"
};
function $961c2883822cc512$var$getGraphQLAuthMode(authType) {
    return $961c2883822cc512$var$authModeNames[authType];
}
const $961c2883822cc512$var$providerNames = {
    GOOGLE: "Google",
    LOGIN_WITH_AMAZON: "Amazon",
    FACEBOOK: "Facebook",
    SIGN_IN_WITH_APPLE: "Apple"
};
function $961c2883822cc512$var$getOAuthProviders(providers = []) {
    return providers.reduce((oAuthProviders, provider)=>{
        if ($961c2883822cc512$var$providerNames[provider] !== undefined) oAuthProviders.push($961c2883822cc512$var$providerNames[provider]);
        return oAuthProviders;
    }, []);
}
function $961c2883822cc512$var$getMfaStatus(mfaConfiguration) {
    if (mfaConfiguration === "OPTIONAL") return "optional";
    if (mfaConfiguration === "REQUIRED") return "on";
    return "off";
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Parses the variety of configuration shapes that Amplify can accept into a ResourcesConfig.
 *
 * @param amplifyConfig An Amplify configuration object conforming to one of the supported schemas.
 * @return A ResourcesConfig for the provided configuration object.
 */ const $c617356b2a6163e9$export$f101a69cd6dc6202 = (amplifyConfig)=>{
    if (Object.keys(amplifyConfig).some((key)=>key.startsWith("aws_"))) return (0, $9e9ebeb6d3af43c3$export$1ef2e9c2da492d)(amplifyConfig);
    else if ((0, $961c2883822cc512$export$99bf765e6322c00)(amplifyConfig)) return (0, $961c2883822cc512$export$11d0da171d17ab63)(amplifyConfig);
    else return amplifyConfig;
};





function $2a776d17fcab286a$export$b007d77a962aa175({ expiresAt: expiresAt , clockDrift: clockDrift  }) {
    const currentTime = Date.now();
    return currentTime + clockDrift > expiresAt;
}
class $2a776d17fcab286a$export$eeff9d1a8b8c057b {
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
    }
    /**
     * Fetch the auth tokens, and the temporary AWS credentials and identity if they are configured. By default it
     * does not refresh the auth tokens or credentials if they are loaded in storage already. You can force a refresh
     * with `{ forceRefresh: true }` input.
     *
     * @param options - Options configuring the fetch behavior.
     *
     * @returns Promise of current auth session {@link AuthSession}.
     */ async fetchAuthSession(options = {}) {
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        const tokens = await this.getTokens(options);
        if (tokens) {
            userSub = tokens.accessToken?.payload?.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens: tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            });
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        });
        return {
            tokens: tokens,
            credentials: credentialsAndIdentityId?.credentials,
            identityId: credentialsAndIdentityId?.identityId,
            userSub: userSub
        };
    }
    async clearCredentials() {
        await this.authOptions?.credentialsProvider?.clearCredentialsAndIdentityId();
    }
    async getTokens(options) {
        return await this.authOptions?.tokenProvider?.getTokens(options) ?? undefined;
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3433e5a3eb89c040$var$extendStatics = function(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92
};


/**
 * @internal
 */ var $d9144f7f7c3aa451$export$b2e3d6d444266a5c = 64;
var $d9144f7f7c3aa451$export$d7bd469488748c5f = 32;
var $d9144f7f7c3aa451$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $d9144f7f7c3aa451$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $d9144f7f7c3aa451$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $7828a6c727c01d6d$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $d9144f7f7c3aa451$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $d9144f7f7c3aa451$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c) >= (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $d9144f7f7c3aa451$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $d9144f7f7c3aa451$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f5bb4d6da7c611e5$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $2c7ea32d3382c998$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $f5bb4d6da7c611e5$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $0277c7bea634f036$export$b4b216764bb846eb = (input)=>new TextDecoder("utf-8").decode(input);




/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3caef5c332c7293f$export$6100ba28696e12de(buf);
    else return $3caef5c332c7293f$export$6100ba28696e12de(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$24f87a6f86a8996f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $3caef5c332c7293f$export$d622b2ad8d90c771($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $e3285af2e8ff8ec8$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
// Quick polyfill
var $e3285af2e8ff8ec8$var$fromUtf8 = typeof $e3285af2e8ff8ec8$require$Buffer !== "undefined" && $e3285af2e8ff8ec8$require$Buffer.from ? function(input) {
    return $e3285af2e8ff8ec8$require$Buffer.from(input, "utf8");
} : (0, $f5bb4d6da7c611e5$export$c7c5cef950a4d2fc);
function $e3285af2e8ff8ec8$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $e3285af2e8ff8ec8$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $ec17c84f9779bd2d$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $8eb81ef908238557$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $5d5f2e4933e14701$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




var $475efd9fa7b1a9cc$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $7828a6c727c01d6d$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $ec17c84f9779bd2d$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $e3285af2e8ff8ec8$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $3433e5a3eb89c040$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $3433e5a3eb89c040$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $7828a6c727c01d6d$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $7828a6c727c01d6d$export$aab6bc1ad3c77a42)();
            var inner = $475efd9fa7b1a9cc$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $475efd9fa7b1a9cc$var$bufferFromSecret(secret) {
    var input = (0, $e3285af2e8ff8ec8$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $7828a6c727c01d6d$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $d9144f7f7c3aa451$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}




const $dbfeacb0e3f6e6ba$var$SHORT_TO_HEX = {};
const $dbfeacb0e3f6e6ba$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $dbfeacb0e3f6e6ba$var$SHORT_TO_HEX[i] = encodedByte;
    $dbfeacb0e3f6e6ba$var$HEX_TO_SHORT[encodedByte] = i;
}
function $dbfeacb0e3f6e6ba$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $dbfeacb0e3f6e6ba$var$HEX_TO_SHORT) out[i / 2] = $dbfeacb0e3f6e6ba$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $dbfeacb0e3f6e6ba$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $dbfeacb0e3f6e6ba$var$SHORT_TO_HEX[bytes[i]];
    return out;
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $d9009b35813b573c$export$b412d755cfa0136 {
    constructor(){
        this.oAuthListener = undefined;
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, $2a776d17fcab286a$export$eeff9d1a8b8c057b)();
    }
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $c617356b2a6163e9$export$f101a69cd6dc6202)(resourcesConfig);
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, $3040204a38b40487$export$7e32b29e1cb162e1)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("core", {
            event: "configure",
            data: this.resourcesConfig
        }, "Configure", (0, $c9802061728ce106$export$aadf71dd9875dd20));
        this.notifyOAuthListener();
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        return this.resourcesConfig;
    }
    /** @internal */ [(0, $6b6ce34dcf385dec$export$35210b3191d26437)](listener) {
        if (this.resourcesConfig.Auth?.Cognito.loginWith?.oauth) // when Amplify has been configured with a valid OAuth config while adding the listener, run it directly
        listener(this.resourcesConfig.Auth?.Cognito);
        else // otherwise register the listener and run it later when Amplify gets configured with a valid oauth config
        this.oAuthListener = listener;
    }
    notifyOAuthListener() {
        if (!this.resourcesConfig.Auth?.Cognito.loginWith?.oauth || !this.oAuthListener) return;
        this.oAuthListener(this.resourcesConfig.Auth?.Cognito);
        // the listener should only be notified once with a valid oauth config
        this.oAuthListener = undefined;
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` orchestrates cross-category communication within the library.
 */ const $d9009b35813b573c$export$a3858a9a153cffc7 = new $d9009b35813b573c$export$b412d755cfa0136();

var $39b3979787198c97$exports = {};
(function(global, factory) {
    $39b3979787198c97$exports = factory();
})($39b3979787198c97$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $19002707866b8978$export$dae7d845015939d5 {
    constructor(data = {}){
        const { path: path , domain: domain , expires: expires , sameSite: sameSite , secure: secure  } = data;
        this.domain = domain;
        this.path = path || "/";
        this.expires = Object.prototype.hasOwnProperty.call(data, "expires") ? expires : 365;
        this.secure = Object.prototype.hasOwnProperty.call(data, "secure") ? secure : true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (!sameSite || ![
                "strict",
                "lax",
                "none"
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = sameSite;
        }
    }
    async setItem(key, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).get(key);
        return item ?? null;
    }
    async removeItem(key) {
        (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure,
            ...this.sameSite && {
                sameSite: this.sameSite
            }
        };
    }
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $e4876bf018e81b36$export$4e712df6b850c8d0;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
})($e4876bf018e81b36$export$4e712df6b850c8d0 || ($e4876bf018e81b36$export$4e712df6b850c8d0 = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $fc284bac6252ec64$export$f5362e8a6666a455 extends (0, $05b2dc7abeec3af3$export$37321a6dace1881c) {
    constructor(){
        super({
            name: (0, $e4876bf018e81b36$export$4e712df6b850c8d0).PlatformNotSupported,
            message: "Function not supported on current platform"
        });
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $4970eef2b985f880$export$8536778e426ddf92 {
    constructor(storage){
        this.storage = storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, $fc284bac6252ec64$export$f5362e8a6666a455)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, $fc284bac6252ec64$export$f5362e8a6666a455)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, $fc284bac6252ec64$export$f5362e8a6666a455)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, $fc284bac6252ec64$export$f5362e8a6666a455)();
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $f760777b4ecb21d0$export$e4315e25b840a0ea {
    constructor(){
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        return this.storage.get(key) ?? null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const $77335959be8d0fb9$export$5d9abaf8ff62cd65 = ()=>typeof window !== "undefined" && window.localStorage ? window.localStorage : new (0, $f760777b4ecb21d0$export$e4315e25b840a0ea)();
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const $77335959be8d0fb9$export$518dcc1598f87b = ()=>typeof window !== "undefined" && window.sessionStorage ? window.sessionStorage : new (0, $f760777b4ecb21d0$export$e4315e25b840a0ea)();


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $2165b74f660a7d7f$export$bec45e7703e93690 extends (0, $4970eef2b985f880$export$8536778e426ddf92) {
    constructor(){
        super((0, $77335959be8d0fb9$export$5d9abaf8ff62cd65)());
    }
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $b9254a1066f71a36$export$2c4b17e1c2e0931 extends (0, $4970eef2b985f880$export$8536778e426ddf92) {
    constructor(){
        super((0, $77335959be8d0fb9$export$518dcc1598f87b)());
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c1a7077392f3b8b2$export$586b30dcaeecb901 = new (0, $2165b74f660a7d7f$export$bec45e7703e93690)();
const $c1a7077392f3b8b2$export$f119d83aa936d634 = new (0, $b9254a1066f71a36$export$2c4b17e1c2e0931)();
const $c1a7077392f3b8b2$export$41feb988b3a84f03 = new (0, $4970eef2b985f880$export$8536778e426ddf92)(new (0, $f760777b4ecb21d0$export$e4315e25b840a0ea)());








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $75891aafa6b8443f$export$e003cc239f955cb6 = ()=>{
    if (typeof window === "object" && typeof window.crypto === "object") return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === "object") return crypto;
    throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
        name: "MissingPolyfill",
        message: "Cannot resolve the `crypto` function from the environment."
    });
};
const $75891aafa6b8443f$export$94f295707b435c6d = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.btoa === "function") return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === "function") return btoa;
    throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `btoa` function from the environment."
    });
};
const $75891aafa6b8443f$export$ea737e7700106b27 = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.atob === "function") return window.atob;
    // Next.js global polyfill
    if (typeof atob === "function") return atob;
    throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `atob` function from the environment."
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ef7237a6eb0adc7d$export$1e303d38dab7b376 = {
    convert (input) {
        return (0, $75891aafa6b8443f$export$ea737e7700106b27)()(input);
    }
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2923b69a4f2b8c7f$export$5cb8fc27ccbe9d40 = (errorMap, AssertionError = (0, $05b2dc7abeec3af3$export$37321a6dace1881c))=>(assertion, name, additionalContext)=>{
        const { message: message , recoverySuggestion: recoverySuggestion  } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name: name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion: recoverySuggestion
        });
    };




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $35f97ba24e00c443$export$7b5c8b570ea8407;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})($35f97ba24e00c443$export$7b5c8b570ea8407 || ($35f97ba24e00c443$export$7b5c8b570ea8407 = {}));
const $35f97ba24e00c443$var$authConfigurationErrorMap = {
    [$35f97ba24e00c443$export$7b5c8b570ea8407.AuthTokenConfigException]: {
        message: "Auth Token Provider not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app."
    },
    [$35f97ba24e00c443$export$7b5c8b570ea8407.AuthUserPoolAndIdentityPoolException]: {
        message: "Auth UserPool or IdentityPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
    },
    [$35f97ba24e00c443$export$7b5c8b570ea8407.AuthUserPoolException]: {
        message: "Auth UserPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
    },
    [$35f97ba24e00c443$export$7b5c8b570ea8407.InvalidIdentityPoolIdException]: {
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    },
    [$35f97ba24e00c443$export$7b5c8b570ea8407.OAuthNotConfigureException]: {
        message: "oauth param not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
    }
};
const $35f97ba24e00c443$export$a7a9523472993e97 = (0, $2923b69a4f2b8c7f$export$5cb8fc27ccbe9d40)($35f97ba24e00c443$var$authConfigurationErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $d0b404dc65adc192$export$80c92581e59ed502(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    (0, $35f97ba24e00c443$export$a7a9523472993e97)(assertionValid, (0, $35f97ba24e00c443$export$7b5c8b570ea8407).AuthUserPoolException);
}
function $d0b404dc65adc192$export$c13e6dbaf90a8e5f(cognitoConfig) {
    const validOAuthConfig = !!cognitoConfig?.loginWith?.oauth?.domain && !!cognitoConfig?.loginWith?.oauth?.redirectSignOut && !!cognitoConfig?.loginWith?.oauth?.redirectSignIn && !!cognitoConfig?.loginWith?.oauth?.responseType;
    (0, $35f97ba24e00c443$export$a7a9523472993e97)(validOAuthConfig, (0, $35f97ba24e00c443$export$7b5c8b570ea8407).OAuthNotConfigureException);
}
function $d0b404dc65adc192$export$8a2f5318ea3215e3(cognitoConfig) {
    const validConfig = !!cognitoConfig?.identityPoolId;
    (0, $35f97ba24e00c443$export$a7a9523472993e97)(validConfig, (0, $35f97ba24e00c443$export$7b5c8b570ea8407).InvalidIdentityPoolIdException);
}
function $d0b404dc65adc192$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token");
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, "+").replace(/_/g, "/");
        const jsonStr = decodeURIComponent((0, $ef7237a6eb0adc7d$export$1e303d38dab7b376).convert(base64).split("").map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload: payload
        };
    } catch (err) {
        throw new Error("Invalid token payload");
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $68efb77f62f1efb5$export$145273558d58e0ac extends (0, $05b2dc7abeec3af3$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $68efb77f62f1efb5$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $68efb77f62f1efb5$export$145273558d58e0ac.prototype);
    }
}


const $e75e7ee74a72b3de$export$b8429d1428aad8ba = {
    accessToken: "accessToken",
    idToken: "idToken",
    oidcProvider: "oidcProvider",
    clockDrift: "clockDrift",
    refreshToken: "refreshToken",
    deviceKey: "deviceKey",
    randomPasswordKey: "randomPasswordKey",
    deviceGroupKey: "deviceGroupKey",
    signInDetails: "signInDetails"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $2cef52a724b824ad$export$cc5909720f29144;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})($2cef52a724b824ad$export$cc5909720f29144 || ($2cef52a724b824ad$export$cc5909720f29144 = {}));
const $2cef52a724b824ad$var$tokenValidationErrorMap = {
    [$2cef52a724b824ad$export$cc5909720f29144.InvalidAuthTokens]: {
        message: "Invalid tokens.",
        recoverySuggestion: "Make sure the tokens are valid."
    }
};
const $2cef52a724b824ad$export$a7a9523472993e97 = (0, $2923b69a4f2b8c7f$export$5cb8fc27ccbe9d40)($2cef52a724b824ad$var$tokenValidationErrorMap);


class $62bb7d16e56984d5$export$a36be852d43d512 {
    constructor(){
        this.name = "CognitoIdentityServiceProvider"; // To be backwards compatible with V5, no migration needed
    }
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "KeyValueStorageNotFoundException",
            message: "KeyValueStorage was not found in TokenStore"
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                name: "NoSessionFoundException",
                message: "Auth session was not found. Make sure to call signIn."
            });
            const accessToken = (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(itString) : undefined;
            const refreshToken = await this.getKeyValueStorage().getItem(authKeys.refreshToken) ?? undefined;
            const clockDriftString = await this.getKeyValueStorage().getItem(authKeys.clockDrift) ?? "0";
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            const tokens = {
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken,
                deviceMetadata: await this.getDeviceMetadata() ?? undefined,
                clockDrift: clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, $2cef52a724b824ad$export$a7a9523472993e97)(tokens !== undefined, (0, $2cef52a724b824ad$export$cc5909720f29144).InvalidAuthTokens);
        await this.clearTokens();
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        if (tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        if (tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey())
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return randomPassword && deviceGroupKey && deviceKey ? {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const lastAuthUser = username ?? await this.getLastAuthUser();
        return $62bb7d16e56984d5$export$4647c72f6828a74d(this.name, `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${this.name}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        const lastAuthUser = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey()) ?? "username";
        return lastAuthUser;
    }
}
const $62bb7d16e56984d5$export$4647c72f6828a74d = (provider, identifier)=>{
    return $62bb7d16e56984d5$export$dfb8da757ca62eed((0, $e75e7ee74a72b3de$export$b8429d1428aad8ba))(`${provider}`, identifier);
};
function $62bb7d16e56984d5$export$dfb8da757ca62eed(authKeys) {
    const keys = Object.values({
        ...authKeys
    });
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>({
                ...acc,
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $88802c4070901871$export$dad1700b96c3a835 = {
    identityId: "identityId"
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $bb88847e241335cc$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("DefaultIdentityIdStore");
class $bb88847e241335cc$export$3e97b78667a539a0 {
    setAuthConfig(authConfigParam) {
        (0, $d0b404dc65adc192$export$8a2f5318ea3215e3)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = $bb88847e241335cc$var$createKeysForAuthStorage("Cognito", authConfigParam.Cognito.identityPoolId);
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this.keyValueStorage = keyValueStorage;
    }
    async loadIdentityId() {
        (0, $d0b404dc65adc192$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        try {
            if (this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: "primary"
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (storedIdentityId) return {
                    id: storedIdentityId,
                    type: "guest"
                };
                return null;
            }
        } catch (err) {
            $bb88847e241335cc$var$logger.log("Error getting stored IdentityId.", err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        (0, $d0b404dc65adc192$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        if (identity.type === "guest") {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            this.keyValueStorage.removeItem(this._authKeys.identityId);
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
}
const $bb88847e241335cc$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $62bb7d16e56984d5$export$dfb8da757ca62eed)((0, $88802c4070901871$export$dad1700b96c3a835))(`com.amplify.${provider}`, identifier);
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $706f3dc369998648$export$978f9418fe0cb26c = (response)=>{
    const { headers: headers , statusCode: statusCode  } = response;
    return {
        ...$706f3dc369998648$var$isMetadataBearer(response) ? response.$metadata : {},
        httpStatusCode: statusCode,
        requestId: headers["x-amzn-requestid"] ?? headers["x-amzn-request-id"] ?? headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    };
};
const $706f3dc369998648$var$isMetadataBearer = (response)=>typeof response?.$metadata === "object";



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const $209f6e497b3a00cd$export$be467dfcc0538e25 = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await $209f6e497b3a00cd$export$759bcb35b0d1bf81(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[,:]+/);
        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
        return cleanValue;
    };
    const code = sanitizeErrorCode(response.headers["x-amzn-errortype"] ?? body.code ?? body.__type ?? "UnknownError");
    const message = body.message ?? body.Message ?? "Unknown error";
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, $706f3dc369998648$export$978f9418fe0cb26c)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const $209f6e497b3a00cd$export$759bcb35b0d1bf81 = async (response)=>{
    if (!response.body) throw new Error("Missing response payload");
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, $706f3dc369998648$export$978f9418fe0cb26c)(response)
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f3f8f97d845c2fa1$export$880429a8ae983d4d = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = {
            ...defaultConfig,
            ...config
        };
        // We may want to allow different endpoints from given config(other than region) and input.
        // Currently S3 supports additional `useAccelerateEndpoint` option to use accelerate endpoint.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, {
            ...resolvedConfig
        });
        return deserializer(response);
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ const $536c8e8dca0d7a6d$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const $536c8e8dca0d7a6d$export$d7c12af0c0f12206 = {
    partitions: [
        $536c8e8dca0d7a6d$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const $83f0685006e72a3c$export$1c28e37cdcc37f6d = (region)=>{
    const { partitions: partitions  } = (0, $536c8e8dca0d7a6d$export$d7c12af0c0f12206);
    for (const { regions: regions , outputs: outputs , regionRegex: regionRegex  } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, $536c8e8dca0d7a6d$export$72f3cee421ee8a74).outputs.dnsSuffix;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7930ce1b6e24c566$var$DEFAULT_RETRY_ATTEMPTS = 3;
/**
 * Retry middleware
 */ const $7930ce1b6e24c566$export$72f002d3da1a429f = ({ maxAttempts: maxAttempts = $7930ce1b6e24c566$var$DEFAULT_RETRY_ATTEMPTS , retryDecider: retryDecider , computeDelay: computeDelay , abortSignal: abortSignal  })=>{
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            let attemptsCount = context.attemptsCount ?? 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    $7930ce1b6e24c566$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    $7930ce1b6e24c566$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!abortSignal?.aborted && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = (context.attemptsCount ?? 0) > attemptsCount ? context.attemptsCount ?? 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                if (await retryDecider(response, error)) {
                    if (!abortSignal?.aborted && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await $7930ce1b6e24c566$var$cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal?.aborted) throw new Error("Request aborted.");
            else return handleTerminalErrorOrResponse();
        };
};
const $7930ce1b6e24c566$var$cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal?.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal?.addEventListener("abort", function cancelSleep(_) {
        clearTimeout(timeoutId);
        abortSignal?.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const $7930ce1b6e24c566$var$addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput.$metadata = {
        ...nextHandlerOutput.$metadata ?? {},
        attempts: attempts
    };
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ const $78db0a64bb1e3bda$export$ff28171a05413bc5 = ({ userAgentHeader: userAgentHeader = "x-amz-user-agent" , userAgentValue: userAgentValue = ""  })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ const $e4148c4bd51790db$export$f074d76e52925468 = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (composeHandlerRequest)=>coreHandler(composeHandlerRequest, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ const $277c56c6bc847e76$export$580ad1ce15092b15 = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $99aca15d9a40e265$var$shouldSendBody = (method)=>![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const $99aca15d9a40e265$export$d2573baf35521e4c = async ({ url: url , method: method , headers: headers , body: body  }, { abortSignal: abortSignal , cache: cache , withCrossDomainCredentials: withCrossDomainCredentials  })=>{
    let resp;
    try {
        resp = await fetch(url, {
            method: method,
            headers: headers,
            body: $99aca15d9a40e265$var$shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache: cache,
            credentials: withCrossDomainCredentials ? "include" : "same-origin"
        });
    } catch (e) {
        // TODO: needs to revise error handling in v6
        // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
        // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
        if (e instanceof TypeError) throw new Error("Network error");
        throw e;
    }
    const responseHeaders = {};
    resp.headers?.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign(resp.body ?? {}, {
        text: (0, $277c56c6bc847e76$export$580ad1ce15092b15)(()=>resp.text()),
        blob: (0, $277c56c6bc847e76$export$580ad1ce15092b15)(()=>resp.blob()),
        json: (0, $277c56c6bc847e76$export$580ad1ce15092b15)(()=>resp.json())
    });
    return {
        ...httpResponse,
        body: bodyWithMixin
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c35e4257eb1069ca$export$ed7e1ccf00f39c4a = (0, $e4148c4bd51790db$export$f074d76e52925468)((0, $99aca15d9a40e265$export$d2573baf35521e4c), [
    (0, $78db0a64bb1e3bda$export$ff28171a05413bc5),
    (0, $7930ce1b6e24c566$export$72f002d3da1a429f)
]);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $68e475df1f6104a0$export$76041b1400befb8b = 300000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function $24fc84ed0122c4cd$export$caea50bde345f648(maxDelayMs = (0, $68e475df1f6104a0$export$76041b1400befb8b)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const $3d87caf0cda2471c$var$DEFAULT_MAX_DELAY_MS = 300000;
const $3d87caf0cda2471c$export$caea50bde345f648 = (attempt)=>{
    const delayFunction = (0, $24fc84ed0122c4cd$export$caea50bde345f648)($3d87caf0cda2471c$var$DEFAULT_MAX_DELAY_MS);
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? $3d87caf0cda2471c$var$DEFAULT_MAX_DELAY_MS : delay;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
const $541acb6b4e50c7ee$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const $541acb6b4e50c7ee$export$7b87435661177a94 = (errorCode)=>!!errorCode && $541acb6b4e50c7ee$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const $d6ccf8c3d159d43b$export$b919d98317a7685f = (errorParser)=>async (response, error)=>{
        const parsedError = error ?? await errorParser(response) ?? undefined;
        const errorCode = parsedError?.code || parsedError?.name;
        const statusCode = response?.statusCode;
        return $d6ccf8c3d159d43b$var$isConnectionError(error) || $d6ccf8c3d159d43b$var$isThrottlingError(statusCode, errorCode) || (0, $541acb6b4e50c7ee$export$7b87435661177a94)(errorCode) || $d6ccf8c3d159d43b$var$isServerSideError(statusCode, errorCode);
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const $d6ccf8c3d159d43b$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
const $d6ccf8c3d159d43b$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $d6ccf8c3d159d43b$var$isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && $d6ccf8c3d159d43b$var$THROTTLING_ERROR_CODES.includes(errorCode);
const $d6ccf8c3d159d43b$var$isConnectionError = (error)=>error?.name === "Network error";
const $d6ccf8c3d159d43b$var$isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && $d6ccf8c3d159d43b$var$TIMEOUT_ERROR_CODES.includes(errorCode);




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3415b1d6f221136c$export$beb82d9d9136c16e = URL;
const $3415b1d6f221136c$export$4ea7bbdac595b5fb = URLSearchParams;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $3c92cd7927458afb$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($3c92cd7927458afb$export$638889172ebce0c4 || ($3c92cd7927458afb$export$638889172ebce0c4 = {}));
var $3c92cd7927458afb$export$3a8840c5b2ecf003;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($3c92cd7927458afb$export$3a8840c5b2ecf003 || ($3c92cd7927458afb$export$3a8840c5b2ecf003 = {}));
var $3c92cd7927458afb$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})($3c92cd7927458afb$export$30c16f5c43437fd7 || ($3c92cd7927458afb$export$30c16f5c43437fd7 = {}));
var $3c92cd7927458afb$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($3c92cd7927458afb$export$126e20fdc0f0d34b || ($3c92cd7927458afb$export$126e20fdc0f0d34b = {}));
var $3c92cd7927458afb$export$900b1436d7e65f4;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
})($3c92cd7927458afb$export$900b1436d7e65f4 || ($3c92cd7927458afb$export$900b1436d7e65f4 = {}));
var $3c92cd7927458afb$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($3c92cd7927458afb$export$2f5a715aba4cde93 || ($3c92cd7927458afb$export$2f5a715aba4cde93 = {}));
var $3c92cd7927458afb$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})($3c92cd7927458afb$export$afafab3eb8fc6fef || ($3c92cd7927458afb$export$afafab3eb8fc6fef = {}));
var $3c92cd7927458afb$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})($3c92cd7927458afb$export$c01a8c16ffda791e || ($3c92cd7927458afb$export$c01a8c16ffda791e = {}));
var $3c92cd7927458afb$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($3c92cd7927458afb$export$68e0695a774ab7fa || ($3c92cd7927458afb$export$68e0695a774ab7fa = {}));
var $3c92cd7927458afb$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($3c92cd7927458afb$export$aa89b4c447a07cee || ($3c92cd7927458afb$export$aa89b4c447a07cee = {}));
var $3c92cd7927458afb$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($3c92cd7927458afb$export$ade48b30f1e78672 || ($3c92cd7927458afb$export$ade48b30f1e78672 = {}));
var $3c92cd7927458afb$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
})($3c92cd7927458afb$export$2c5ee06ab9fa5040 || ($3c92cd7927458afb$export$2c5ee06ab9fa5040 = {}));
var $3c92cd7927458afb$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
})($3c92cd7927458afb$export$d4f3c54b808b00ce || ($3c92cd7927458afb$export$d4f3c54b808b00ce = {}));


// generated by genversion
const $6283134e3d15f982$export$83d89fbfd8236492 = "6.3.8";




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $4acf49f6c3e67aec$exports = {};
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = $4acf49f6c3e67aec$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};


const $bcd50ea5d1d053e5$export$a15eed0e463030a9 = ()=>{
    return typeof $parcel$global !== "undefined";
};
const $bcd50ea5d1d053e5$export$a5e7eb32e5221222 = ()=>{
    return typeof globalThis !== "undefined";
};
const $bcd50ea5d1d053e5$export$daba2802a1a41c1f = ()=>{
    return typeof window !== "undefined";
};
const $bcd50ea5d1d053e5$export$b949ebcb877faa59 = ()=>{
    return typeof document !== "undefined";
};
const $bcd50ea5d1d053e5$export$ba10401363d0f7f6 = ()=>{
    return typeof $4acf49f6c3e67aec$exports !== "undefined";
};
const $bcd50ea5d1d053e5$export$252f88727cff70c7 = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function $f76ed8322b6112f5$export$ba3f37c54f0f7805() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith("_react") || key.startsWith("__react");
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll("[id]"));
    return (0, $bcd50ea5d1d053e5$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $f76ed8322b6112f5$export$86269c582305790() {
    return (0, $bcd50ea5d1d053e5$export$ba10401363d0f7f6)() && typeof $4acf49f6c3e67aec$exports.env !== "undefined" && !!Object.keys($4acf49f6c3e67aec$exports.env).find((key)=>key.includes("react"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function $98a2a6d8e59bc551$export$d91d90d62b78936d() {
    return (0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)() && (0, $bcd50ea5d1d053e5$export$252f88727cff70c7)(window, "__VUE");
}
function $98a2a6d8e59bc551$export$257a4c0f8294a101() {
    return (0, $bcd50ea5d1d053e5$export$a15eed0e463030a9)() && (0, $bcd50ea5d1d053e5$export$252f88727cff70c7)($parcel$global, "__VUE");
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function $33fe5b712fd6ea7f$export$6dafc32a94edaed3() {
    return (0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)() && (0, $bcd50ea5d1d053e5$export$252f88727cff70c7)(window, "__SVELTE");
}
function $33fe5b712fd6ea7f$export$819dcb7fe144d8b0() {
    return (0, $bcd50ea5d1d053e5$export$ba10401363d0f7f6)() && typeof $4acf49f6c3e67aec$exports.env !== "undefined" && !!Object.keys($4acf49f6c3e67aec$exports.env).find((key)=>key.includes("svelte"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function $e0ec3dcfa395bd6f$export$f8462bcf03110eff() {
    return (0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)() && window.next && typeof window.next === "object";
}
function $e0ec3dcfa395bd6f$export$61c08ed144a5d4ca() {
    return (0, $bcd50ea5d1d053e5$export$a15eed0e463030a9)() && ((0, $bcd50ea5d1d053e5$export$252f88727cff70c7)($parcel$global, "__next") || (0, $bcd50ea5d1d053e5$export$252f88727cff70c7)($parcel$global, "__NEXT"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function $77c2761ae348e7c6$export$bed54a4e6d9d25fb() {
    return (0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)() && (window.__NUXT__ !== undefined || window.$nuxt !== undefined);
}
function $77c2761ae348e7c6$export$fb3ce982948d27e8() {
    return (0, $bcd50ea5d1d053e5$export$a15eed0e463030a9)() && typeof $parcel$global.__NUXT_PATHS__ !== "undefined";
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function $eb8dc834355ce742$export$b5a20bd39eb02ba0() {
    const angularVersionSetInDocument = Boolean((0, $bcd50ea5d1d053e5$export$b949ebcb877faa59)() && document.querySelector("[ng-version]"));
    const angularContentSetInWindow = Boolean((0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)() && typeof window.ng !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $eb8dc834355ce742$export$8ab518c8987c870f() {
    return (0, $bcd50ea5d1d053e5$export$ba10401363d0f7f6)() && typeof $4acf49f6c3e67aec$exports.env === "object" && undefined?.startsWith("ng ") || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $aa4d36e220d6a82b$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function $d142b08e8972a60f$export$85fd46d5e29a4f7e() {
    return (0, $bcd50ea5d1d053e5$export$a15eed0e463030a9)() && typeof $parcel$global.expo !== "undefined";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $e3843c4666559957$export$41b1270b988065fb() {
    return (0, $bcd50ea5d1d053e5$export$daba2802a1a41c1f)();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const $ff29f6127d654378$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $d142b08e8972a60f$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $aa4d36e220d6a82b$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $e0ec3dcfa395bd6f$export$f8462bcf03110eff)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $77c2761ae348e7c6$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $eb8dc834355ce742$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).React,
        detectionMethod: (0, $f76ed8322b6112f5$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $98a2a6d8e59bc551$export$d91d90d62b78936d)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $33fe5b712fd6ea7f$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $e3843c4666559957$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $e0ec3dcfa395bd6f$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $77c2761ae348e7c6$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $f76ed8322b6112f5$export$86269c582305790)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $98a2a6d8e59bc551$export$257a4c0f8294a101)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $eb8dc834355ce742$export$8ab518c8987c870f)
    },
    {
        platform: (0, $3c92cd7927458afb$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $33fe5b712fd6ea7f$export$819dcb7fe144d8b0)
    }
];
function $ff29f6127d654378$export$17b446b869dad473() {
    return $ff29f6127d654378$var$detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())?.platform || (0, $3c92cd7927458afb$export$638889172ebce0c4).ServerSideUnknown;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let $ab1822ffbc37c551$var$frameworkCache;
const $ab1822ffbc37c551$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
let $ab1822ffbc37c551$var$resetTriggered = false;
const $ab1822ffbc37c551$var$SSR_RESET_TIMEOUT = 10; // ms
const $ab1822ffbc37c551$var$WEB_RESET_TIMEOUT = 10; // ms
const $ab1822ffbc37c551$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
const $ab1822ffbc37c551$export$9ce73e459ec93b6a = ()=>{
    if (!$ab1822ffbc37c551$var$frameworkCache) {
        $ab1822ffbc37c551$var$frameworkCache = (0, $ff29f6127d654378$export$17b446b869dad473)();
        if ($ab1822ffbc37c551$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($ab1822ffbc37c551$export$d56891f33aa26edc.length)$ab1822ffbc37c551$export$d56891f33aa26edc.pop()?.();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $ab1822ffbc37c551$export$d56891f33aa26edc.forEach((fcn)=>{
            fcn();
        });
        // Retry once for either Unknown type after a delay (explained below)
        $ab1822ffbc37c551$var$resetTimeout((0, $3c92cd7927458afb$export$638889172ebce0c4).ServerSideUnknown, $ab1822ffbc37c551$var$SSR_RESET_TIMEOUT);
        $ab1822ffbc37c551$var$resetTimeout((0, $3c92cd7927458afb$export$638889172ebce0c4).WebUnknown, $ab1822ffbc37c551$var$WEB_RESET_TIMEOUT);
    }
    return $ab1822ffbc37c551$var$frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const $ab1822ffbc37c551$export$5d5c467ce0b213f = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($ab1822ffbc37c551$var$resetTriggered) return;
    $ab1822ffbc37c551$export$d56891f33aa26edc.push(fcn);
};
function $ab1822ffbc37c551$export$d2adf65b87e47523() {
    $ab1822ffbc37c551$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $ab1822ffbc37c551$var$resetTimeout(framework, delay) {
    if ($ab1822ffbc37c551$var$frameworkCache === framework && !$ab1822ffbc37c551$var$resetTriggered) setTimeout(()=>{
        $ab1822ffbc37c551$export$d2adf65b87e47523();
        $ab1822ffbc37c551$var$resetTriggered = true;
        setTimeout($ab1822ffbc37c551$export$9ce73e459ec93b6a, $ab1822ffbc37c551$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
const $180c43f7f36cc759$var$customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const $180c43f7f36cc759$export$20cd2fa9001e90da = (input)=>{
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    $180c43f7f36cc759$var$customUserAgentState[input.category] = input.apis.reduce((acc, api)=>({
            ...acc,
            [api]: {
                refCount: acc[api]?.refCount ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        }), $180c43f7f36cc759$var$customUserAgentState[input.category] ?? {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = $180c43f7f36cc759$var$customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) $180c43f7f36cc759$var$customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete $180c43f7f36cc759$var$customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys($180c43f7f36cc759$var$customUserAgentState[input.category]).length) delete $180c43f7f36cc759$var$customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const $180c43f7f36cc759$export$e399dbcfd99a2928 = (category, api)=>$180c43f7f36cc759$var$customUserAgentState[category]?.[api]?.additionalDetails;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $94d73b8725ccf9a9$var$BASE_USER_AGENT = `aws-amplify`;
class $94d73b8725ccf9a9$var$PlatformBuilder {
    constructor(){
        this.userAgent = `${$94d73b8725ccf9a9$var$BASE_USER_AGENT}/${0, $6283134e3d15f982$export$83d89fbfd8236492}`;
    }
    get framework() {
        return (0, $ab1822ffbc37c551$export$9ce73e459ec93b6a)();
    }
    get isReactNative() {
        return this.framework === (0, $3c92cd7927458afb$export$638889172ebce0c4).ReactNative || this.framework === (0, $3c92cd7927458afb$export$638889172ebce0c4).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, $ab1822ffbc37c551$export$5d5c467ce0b213f)(fcn);
    }
}
const $94d73b8725ccf9a9$export$2dffd0b5373a4389 = new $94d73b8725ccf9a9$var$PlatformBuilder();
const $94d73b8725ccf9a9$export$7d201307d8979e21 = ({ category: category , action: action  } = {})=>{
    const userAgent = [
        [
            $94d73b8725ccf9a9$var$BASE_USER_AGENT,
            (0, $6283134e3d15f982$export$83d89fbfd8236492)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $ab1822ffbc37c551$export$9ce73e459ec93b6a)()
    ]);
    if (category && action) {
        const customState = (0, $180c43f7f36cc759$export$e399dbcfd99a2928)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const $94d73b8725ccf9a9$export$ede38edb26c0bfdf = (customUserAgentDetails)=>{
    const userAgent = $94d73b8725ccf9a9$export$7d201307d8979e21(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(" ");
    return userAgentString;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $ed2c57ee51bb104b$var$SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $ed2c57ee51bb104b$var$endpointResolver = ({ region: region  })=>({
        url: new (0, $3415b1d6f221136c$export$beb82d9d9136c16e)(`https://cognito-identity.${region}.${(0, $83f0685006e72a3c$export$1c28e37cdcc37f6d)(region)}`)
    });
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $ed2c57ee51bb104b$var$disableCacheMiddlewareFactory = ()=>(next)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $ed2c57ee51bb104b$export$8029646671d2c482 = (0, $e4148c4bd51790db$export$f074d76e52925468)((0, $c35e4257eb1069ca$export$ed7e1ccf00f39c4a), [
    $ed2c57ee51bb104b$var$disableCacheMiddlewareFactory
]);
/**
 * @internal
 */ const $ed2c57ee51bb104b$export$f84bd70098573c5c = {
    service: $ed2c57ee51bb104b$var$SERVICE_NAME,
    endpointResolver: $ed2c57ee51bb104b$var$endpointResolver,
    retryDecider: (0, $d6ccf8c3d159d43b$export$b919d98317a7685f)((0, $209f6e497b3a00cd$export$be467dfcc0538e25)),
    computeDelay: (0, $3d87caf0cda2471c$export$caea50bde345f648),
    userAgentValue: (0, $94d73b8725ccf9a9$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};
(0, $ab1822ffbc37c551$export$5d5c467ce0b213f)(()=>{
    $ed2c57ee51bb104b$export$f84bd70098573c5c.userAgentValue = (0, $94d73b8725ccf9a9$export$ede38edb26c0bfdf)();
});
/**
 * @internal
 */ const $ed2c57ee51bb104b$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityService.${operation}`
    });
/**
 * @internal
 */ const $ed2c57ee51bb104b$export$a692bdb7eb624f96 = ({ url: url  }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $edb2ac2ae5c1ecb4$var$getCredentialsForIdentitySerializer = (input, endpoint)=>{
    const headers = (0, $ed2c57ee51bb104b$export$a46bbeaba09f7285)("GetCredentialsForIdentity");
    const body = JSON.stringify(input);
    return (0, $ed2c57ee51bb104b$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $edb2ac2ae5c1ecb4$var$getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $209f6e497b3a00cd$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $209f6e497b3a00cd$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            Credentials: $edb2ac2ae5c1ecb4$var$deserializeCredentials(body.Credentials),
            $metadata: (0, $706f3dc369998648$export$978f9418fe0cb26c)(response)
        };
    }
};
const $edb2ac2ae5c1ecb4$var$deserializeCredentials = ({ AccessKeyId: AccessKeyId , SecretKey: SecretKey , SessionToken: SessionToken , Expiration: Expiration  } = {})=>{
    return {
        AccessKeyId: AccessKeyId,
        SecretKey: SecretKey,
        SessionToken: SessionToken,
        Expiration: Expiration && new Date(Expiration * 1000)
    };
};
/**
 * @internal
 */ const $edb2ac2ae5c1ecb4$export$a49c1c173ab96b58 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $ed2c57ee51bb104b$export$8029646671d2c482), $edb2ac2ae5c1ecb4$var$getCredentialsForIdentitySerializer, $edb2ac2ae5c1ecb4$var$getCredentialsForIdentityDeserializer, (0, $ed2c57ee51bb104b$export$f84bd70098573c5c));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $ba04bdf708a65180$export$d4a625cede2da71b(userPoolId) {
    const region = userPoolId?.split("_")[0];
    if (!userPoolId || userPoolId.indexOf("_") < 0 || !region || typeof region !== "string") throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "InvalidUserPoolId",
        message: "Invalid user pool id provided."
    });
    return region;
}
function $ba04bdf708a65180$export$8fb32fba519c460(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(":")) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "InvalidIdentityPoolIdException",
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    });
    return identityPoolId.split(":")[0];
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d78d124ef376faa5$export$d29d1996d6b6f5e3 = "UserUnAuthenticatedException";
const $d78d124ef376faa5$export$bdd0e7e9babcd5c8 = "UserAlreadyAuthenticatedException";
const $d78d124ef376faa5$export$740e7000ac27ebf3 = "DeviceMetadataNotFoundException";
const $d78d124ef376faa5$export$fe46a12932d2550a = "AutoSignInException";
const $d78d124ef376faa5$export$36f9d08d6bc647dd = "InvalidRedirectException";
const $d78d124ef376faa5$export$60b68b138a52e5ae = new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
    name: $d78d124ef376faa5$export$36f9d08d6bc647dd,
    message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
    recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
});
const $d78d124ef376faa5$export$27ddc47447101bcf = "InvalidOriginException";
const $d78d124ef376faa5$export$c01b4acd6291e035 = new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
    name: $d78d124ef376faa5$export$27ddc47447101bcf,
    message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
    recoverySuggestion: "Please call signInWithRedirect from the same origin."
});
const $d78d124ef376faa5$export$625255707e22459c = "OAuthSignOutException";
const $d78d124ef376faa5$export$a0a904daf48e2c33 = "TokenRefreshException";
const $d78d124ef376faa5$export$606cffc85964c24b = "UnexpectedSignInInterruptionException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $45fe96cf99d947f4$export$d76f9f8544dc304d(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function $45fe96cf99d947f4$export$77712ea5882cac9f(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $d78d124ef376faa5$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $45fe96cf99d947f4$export$f4d99632f0717a4b(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $d78d124ef376faa5$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
const $45fe96cf99d947f4$export$31fce2aaeafa4b60 = new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
    name: (0, $d78d124ef376faa5$export$a0a904daf48e2c33),
    message: `Token refresh is not supported when authenticated with the 'implicit grant' (token) oauth flow. 
	Please change your oauth configuration to use 'code grant' flow.`,
    recoverySuggestion: `Please logout and change your Amplify configuration to use "code grant" flow. 
	E.g { responseType: 'code' }`
});
const $45fe96cf99d947f4$export$35cfa8cbd2d5bcdd = new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
    name: (0, $d78d124ef376faa5$export$d29d1996d6b6f5e3),
    message: "User needs to be authenticated to call this API.",
    recoverySuggestion: "Sign in before calling this API again."
});
function $45fe96cf99d947f4$export$be38b2d22222d505(tokens) {
    if ($45fe96cf99d947f4$var$isAuthenticatedWithImplicitOauthFlow(tokens)) throw $45fe96cf99d947f4$export$31fce2aaeafa4b60;
    if (!$45fe96cf99d947f4$var$isAuthenticatedWithRefreshToken(tokens)) throw $45fe96cf99d947f4$export$35cfa8cbd2d5bcdd;
}
function $45fe96cf99d947f4$export$b6f03be79626ab0f(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $d78d124ef376faa5$export$740e7000ac27ebf3),
        message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
        recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
    });
}
const $45fe96cf99d947f4$export$3820b4ff343394ea = {
    inflightOAuth: "inflightOAuth",
    oauthSignIn: "oauthSignIn",
    oauthPKCE: "oauthPKCE",
    oauthState: "oauthState"
};
function $45fe96cf99d947f4$var$isAuthenticated(tokens) {
    return tokens?.accessToken || tokens?.idToken;
}
function $45fe96cf99d947f4$var$isAuthenticatedWithRefreshToken(tokens) {
    return $45fe96cf99d947f4$var$isAuthenticated(tokens) && tokens?.refreshToken;
}
function $45fe96cf99d947f4$var$isAuthenticatedWithImplicitOauthFlow(tokens) {
    return $45fe96cf99d947f4$var$isAuthenticated(tokens) && !tokens?.refreshToken;
}










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a249ed39c095f0d6$var$getIdSerializer = (input, endpoint)=>{
    const headers = (0, $ed2c57ee51bb104b$export$a46bbeaba09f7285)("GetId");
    const body = JSON.stringify(input);
    return (0, $ed2c57ee51bb104b$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $a249ed39c095f0d6$var$getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $209f6e497b3a00cd$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $209f6e497b3a00cd$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            $metadata: (0, $706f3dc369998648$export$978f9418fe0cb26c)(response)
        };
    }
};
/**
 * @internal
 */ const $a249ed39c095f0d6$export$218c8c3169c024d2 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $ed2c57ee51bb104b$export$8029646671d2c482), $a249ed39c095f0d6$var$getIdSerializer, $a249ed39c095f0d6$var$getIdDeserializer, (0, $ed2c57ee51bb104b$export$f84bd70098573c5c));






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $4b5a2b344a373c19$export$edfb13e85a2c0dc4(idToken) {
    const issuer = (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "InvalidIdTokenException",
        message: "Invalid Idtoken."
    });
    const domainName = issuer.replace(/(^\w+:|^)\/\//, "");
    res[domainName] = idToken;
    return res;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2aa3236ba3e3e288$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("CognitoIdentityIdProvider");
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration exceptions: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service exceptions: {@link GetIdException }
 */ async function $2aa3236ba3e3e288$export$7c3e576630d5e301({ tokens: tokens , authConfig: authConfig , identityIdStore: identityIdStore  }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    let identityId = await identityIdStore.loadIdentityId();
    // Tokens are available so return primary identityId
    if (tokens) {
        // If there is existing primary identityId in-memory return that
        if (identityId && identityId.type === "primary") return identityId.id;
        else {
            const logins = tokens.idToken ? (0, $4b5a2b344a373c19$export$edfb13e85a2c0dc4)(tokens.idToken.toString()) : {};
            const generatedIdentityId = await $2aa3236ba3e3e288$var$generateIdentityId(logins, authConfig);
            if (identityId && identityId.id === generatedIdentityId) $2aa3236ba3e3e288$var$logger.debug(`The guest identity ${identityId.id} has become the primary identity.`);
            identityId = {
                id: generatedIdentityId,
                type: "primary"
            };
        }
    } else {
        // If there is existing guest identityId cached return that
        if (identityId && identityId.type === "guest") return identityId.id;
        else identityId = {
            id: await $2aa3236ba3e3e288$var$generateIdentityId({}, authConfig),
            type: "guest"
        };
    }
    // Store in-memory or local storage depending on guest or primary identityId
    identityIdStore.storeIdentityId(identityId);
    return identityId.id;
}
async function $2aa3236ba3e3e288$var$generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig?.identityPoolId;
    const region = (0, $ba04bdf708a65180$export$8fb32fba519c460)(identityPoolId);
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    const idResult = // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    (await (0, $a249ed39c095f0d6$export$218c8c3169c024d2)({
        region: region
    }, {
        IdentityPoolId: identityPoolId,
        Logins: logins
    })).IdentityId;
    if (!idResult) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "GetIdResponseException",
        message: "Received undefined response from getId operation",
        recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
    });
    return idResult;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $944bc1f68a1ebd42$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("CognitoCredentialsProvider");
const $944bc1f68a1ebd42$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class $944bc1f68a1ebd42$export$be6550e37264dc26 {
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
    async clearCredentialsAndIdentityId() {
        $944bc1f68a1ebd42$var$logger.debug("Clearing out credentials and identityId");
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        $944bc1f68a1ebd42$var$logger.debug("Clearing out in-memory credentials");
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const { tokens: tokens  } = getCredentialsOptions;
        const { authConfig: authConfig  } = getCredentialsOptions;
        try {
            (0, $d0b404dc65adc192$export$8a2f5318ea3215e3)(authConfig?.Cognito);
        } catch  {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const { forceRefresh: forceRefresh  } = getCredentialsOptions;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, $2aa3236ba3e3e288$export$7c3e576630d5e301)({
            tokens: tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, $45fe96cf99d947f4$export$f4d99632f0717a4b)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            $944bc1f68a1ebd42$var$logger.info("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, $ba04bdf708a65180$export$8fb32fba519c460)(authConfig.identityPoolId);
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        const clientResult = await (0, $edb2ac2ae5c1ecb4$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $944bc1f68a1ebd42$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "guest"
                });
            }
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: false
            };
            return res;
        } else throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "CredentialsNotFoundException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            $944bc1f68a1ebd42$var$logger.debug("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, $4b5a2b344a373c19$export$edfb13e85a2c0dc4)(authTokens.idToken.toString()) : {};
        const region = (0, $ba04bdf708a65180$export$8fb32fba519c460)(authConfig.identityPoolId);
        const clientResult = await (0, $edb2ac2ae5c1ecb4$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId,
            Logins: logins
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: true,
                associatedIdToken: authTokens.idToken?.toString()
            };
            this._nextCredentialsRefresh = new Date().getTime() + $944bc1f68a1ebd42$var$CREDENTIALS_TTL;
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "primary"
                });
            }
            return res;
        } else throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "CredentialsException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        return !!tokens && !!this._credentialsAndIdentityId?.associatedIdToken && tokens.idToken?.toString() !== this._credentialsAndIdentityId.associatedIdToken;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */ const $bdeddb1a422eb307$export$be43b753aec531e2 = new (0, $944bc1f68a1ebd42$export$be6550e37264dc26)(new (0, $bb88847e241335cc$export$3e97b78667a539a0)((0, $c1a7077392f3b8b2$export$586b30dcaeecb901)));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * returns in-flight promise if there is one
 *
 * @param asyncFunction - asyncFunction to be deduped.
 * @returns - the return type of the callback
 */ const $21fb99b99f7fb41a$export$cd8d22e3dc00ae5a = (asyncFunction)=>{
    let inflightPromise;
    return async (...args)=>{
        if (inflightPromise) return inflightPromise;
        inflightPromise = new Promise((resolve, reject)=>{
            asyncFunction(...args).then((result)=>{
                resolve(result);
            }).catch((error)=>{
                reject(error);
            }).finally(()=>{
                inflightPromise = undefined;
            });
        });
        return inflightPromise;
    };
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $609100932f10eceb$export$5b3890f50cd4853f(error) {
    if (!error || error.name === "Error" || error instanceof TypeError) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $e4876bf018e81b36$export$4e712df6b850c8d0).Unknown,
        message: "An unknown error has occurred.",
        underlyingError: error
    });
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $0543eacbb4c61b8c$var$SERVICE_NAME = "cognito-idp";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $0543eacbb4c61b8c$var$endpointResolver = ({ region: region  })=>{
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const customURL = authConfig?.userPoolEndpoint;
    const defaultURL = new (0, $3415b1d6f221136c$export$beb82d9d9136c16e)(`https://${$0543eacbb4c61b8c$var$SERVICE_NAME}.${region}.${(0, $83f0685006e72a3c$export$1c28e37cdcc37f6d)(region)}`);
    return {
        url: customURL ? new (0, $3415b1d6f221136c$export$beb82d9d9136c16e)(customURL) : defaultURL
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $0543eacbb4c61b8c$var$disableCacheMiddlewareFactory = ()=>(next, _)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $0543eacbb4c61b8c$export$10f11e95d7a96f7b = (0, $e4148c4bd51790db$export$f074d76e52925468)((0, $c35e4257eb1069ca$export$ed7e1ccf00f39c4a), [
    $0543eacbb4c61b8c$var$disableCacheMiddlewareFactory
]);
/**
 * @internal
 */ const $0543eacbb4c61b8c$export$f84bd70098573c5c = {
    service: $0543eacbb4c61b8c$var$SERVICE_NAME,
    endpointResolver: $0543eacbb4c61b8c$var$endpointResolver,
    retryDecider: (0, $d6ccf8c3d159d43b$export$b919d98317a7685f)((0, $209f6e497b3a00cd$export$be467dfcc0538e25)),
    computeDelay: (0, $3d87caf0cda2471c$export$caea50bde345f648),
    userAgentValue: (0, $94d73b8725ccf9a9$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};
/**
 * @internal
 */ const $0543eacbb4c61b8c$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityProviderService.${operation}`
    });
/**
 * @internal
 */ const $0543eacbb4c61b8c$export$a692bdb7eb624f96 = ({ url: url  }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $83cecb517fee2de6$var$buildUserPoolSerializer = (operation)=>(input, endpoint)=>{
        const headers = (0, $0543eacbb4c61b8c$export$a46bbeaba09f7285)(operation);
        const body = JSON.stringify(input);
        return (0, $0543eacbb4c61b8c$export$a692bdb7eb624f96)(endpoint, headers, body);
    };
const $83cecb517fee2de6$var$buildUserPoolDeserializer = ()=>{
    return async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $209f6e497b3a00cd$export$be467dfcc0538e25)(response);
            (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
            throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        } else {
            const body = await (0, $209f6e497b3a00cd$export$759bcb35b0d1bf81)(response);
            return body;
        }
    };
};
const $83cecb517fee2de6$var$handleEmptyResponseDeserializer = ()=>{
    return async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $209f6e497b3a00cd$export$be467dfcc0538e25)(response);
            (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
            throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        } else return undefined;
    };
};
const $83cecb517fee2de6$export$567b0d5ec943f827 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("InitiateAuth"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$2428f6ba65615593 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("RevokeToken"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$cf64224bcd829024 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("SignUp"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$2ce39ab6662e8c24 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("ConfirmSignUp"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$66791fb2cfeec3e = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("ForgotPassword"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$c7a5d0826ce3a2b2 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("ConfirmForgotPassword"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$b196467a22b300ec = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("RespondToAuthChallenge"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$f24137cafeaef1a1 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("ResendConfirmationCode"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$72b1124e126ff51c = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("VerifySoftwareToken"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$4531a27964554be8 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("AssociateSoftwareToken"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$b6a1b2cc7e7e6b1e = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("SetUserMFAPreference"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$7cbf767827cd68ba = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("GetUser"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$99d837dc30eb1ef7 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("ChangePassword"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$3a7ad63dc35b752f = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("ConfirmDevice"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$d0b7632b5e5fb312 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("ForgetDevice"), $83cecb517fee2de6$var$handleEmptyResponseDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$7d0f10f273c0438a = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("DeleteUser"), $83cecb517fee2de6$var$handleEmptyResponseDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$3a9721eaccd0e7b3 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("GetUserAttributeVerificationCode"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$a92c2ab9b6303723 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("GlobalSignOut"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$16ff8cb4f547be0 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("UpdateUserAttributes"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$40fc6c986f86e9a5 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("VerifyUserAttribute"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$e1c4af6b7c9755a8 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("UpdateDeviceStatus"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$11154f886a75108 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("ListDevices"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));
const $83cecb517fee2de6$export$a97f0f1c87d00e1 = (0, $f3f8f97d845c2fa1$export$880429a8ae983d4d)((0, $0543eacbb4c61b8c$export$10f11e95d7a96f7b), $83cecb517fee2de6$var$buildUserPoolSerializer("DeleteUserAttributes"), $83cecb517fee2de6$var$buildUserPoolDeserializer(), (0, $0543eacbb4c61b8c$export$f84bd70098573c5c));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $931df5209d775015$export$b6e6cdd1f90faa62({ username: username , userPoolId: userPoolId , userPoolClientId: userPoolClientId  }) {
    if (typeof window === "undefined") return undefined;
    const amazonCognitoAdvancedSecurityData = window.AmazonCognitoAdvancedSecurityData;
    if (typeof amazonCognitoAdvancedSecurityData === "undefined") return undefined;
    const advancedSecurityData = amazonCognitoAdvancedSecurityData.getData(username, userPoolId, userPoolClientId);
    if (advancedSecurityData) {
        const userContextData = {
            EncodedData: advancedSecurityData
        };
        return userContextData;
    }
    return {};
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $180f57fe422b6b7f$var$refreshAuthTokensFunction = async ({ tokens: tokens , authConfig: authConfig , username: username  })=>{
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig?.Cognito);
    const region = (0, $ba04bdf708a65180$export$d4a625cede2da71b)(authConfig.Cognito.userPoolId);
    (0, $45fe96cf99d947f4$export$be38b2d22222d505)(tokens);
    const refreshTokenString = tokens.refreshToken;
    const AuthParameters = {
        REFRESH_TOKEN: refreshTokenString
    };
    if (tokens.deviceMetadata?.deviceKey) AuthParameters.DEVICE_KEY = tokens.deviceMetadata.deviceKey;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: authConfig.Cognito.userPoolId,
        userPoolClientId: authConfig.Cognito.userPoolClientId
    });
    const { AuthenticationResult: AuthenticationResult  } = await (0, $83cecb517fee2de6$export$567b0d5ec943f827)({
        region: region
    }, {
        ClientId: authConfig?.Cognito?.userPoolClientId,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: AuthParameters,
        UserContextData: UserContextData
    });
    const accessToken = (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(AuthenticationResult?.AccessToken ?? "");
    const idToken = AuthenticationResult?.IdToken ? (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken) : undefined;
    const { iat: iat  } = accessToken.payload;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "iatNotFoundException",
        message: "iat not found in access token"
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    return {
        accessToken: accessToken,
        idToken: idToken,
        clockDrift: clockDrift,
        refreshToken: refreshTokenString,
        username: username
    };
};
const $180f57fe422b6b7f$export$ab413c2cb4a135d9 = (0, $21fb99b99f7fb41a$export$cd8d22e3dc00ae5a)($180f57fe422b6b7f$var$refreshAuthTokensFunction);
const $180f57fe422b6b7f$export$d5c14381105da273 = $180f57fe422b6b7f$var$refreshAuthTokensFunction;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $667590a172222acf$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined" && typeof window.document !== "undefined";








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $52c2ee4fd5af8dee$var$V5_HOSTED_UI_KEY = "amplify-signin-with-hostedUI";
const $52c2ee4fd5af8dee$var$name = "CognitoIdentityServiceProvider";
class $52c2ee4fd5af8dee$export$9b2cef5d94f9b6e8 {
    constructor(keyValueStorage){
        this.keyValueStorage = keyValueStorage;
    }
    async clearOAuthInflightData() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState)
        ]);
    }
    async clearOAuthData() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem($52c2ee4fd5af8dee$var$V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.getItem(authKeys.inflightOAuth) === "true";
    }
    async storeOAuthInFlight(inflight) {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem($52c2ee4fd5af8dee$var$V5_HOSTED_UI_KEY);
        const [isOAuthSignIn, preferPrivateSession] = (await this.keyValueStorage.getItem(authKeys.oauthSignIn))?.split(",") ?? [];
        return {
            isOAuthSignIn: isOAuthSignIn === "true" || isLegacyHostedUISignIn === "true",
            preferPrivateSession: preferPrivateSession === "true"
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $52c2ee4fd5af8dee$var$createKeysForAuthStorage($52c2ee4fd5af8dee$var$name, this.cognitoConfig.userPoolClientId);
        await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
}
const $52c2ee4fd5af8dee$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $62bb7d16e56984d5$export$dfb8da757ca62eed)((0, $45fe96cf99d947f4$export$3820b4ff343394ea))(provider, identifier);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $67460d2d430d09f6$export$2ed0ec267eb6cb1c = new (0, $52c2ee4fd5af8dee$export$9b2cef5d94f9b6e8)((0, $c1a7077392f3b8b2$export$586b30dcaeecb901));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d6f902f31e3139f0$var$inflightPromises = [];
const $d6f902f31e3139f0$export$c55b09e0e9be0d04 = (resolver)=>{
    $d6f902f31e3139f0$var$inflightPromises.push(resolver);
};
const $d6f902f31e3139f0$export$bcb0b7a105a5df59 = ()=>{
    while($d6f902f31e3139f0$var$inflightPromises.length)$d6f902f31e3139f0$var$inflightPromises.pop()?.();
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $ce02cb698cdbaab3$export$ba2f3fbc8979d2e6 {
    constructor(){
        this.waitForInflightOAuth = (0, $667590a172222acf$export$4e09c449d6c407f7)() ? async ()=>{
            if (!await (0, $67460d2d430d09f6$export$2ed0ec267eb6cb1c).loadOAuthInFlight()) return;
            if (this.inflightPromise) return this.inflightPromise;
            // when there is valid oauth config and there is an inflight oauth flow, try
            // to block async calls that require fetching tokens before the oauth flow completes
            // e.g. getCurrentUser, fetchAuthSession etc.
            this.inflightPromise = new Promise((resolve, _reject)=>{
                (0, $d6f902f31e3139f0$export$c55b09e0e9be0d04)(resolve);
            });
            return this.inflightPromise;
        } : async ()=>{
        // no-op for non-browser environments
        };
    }
    setAuthConfig(authConfig) {
        (0, $67460d2d430d09f6$export$2ed0ec267eb6cb1c).setAuthConfig(authConfig.Cognito);
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "EmptyTokenStoreException",
            message: "TokenStore not set"
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "EmptyTokenRefresherException",
            message: "TokenRefresher not set"
        });
        return this.tokenRefresher;
    }
    async getTokens(options) {
        let tokens;
        try {
            (0, $d0b404dc65adc192$export$80c92581e59ed502)(this.authConfig?.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        this.inflightPromise = undefined;
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        const idTokenExpired = !!tokens?.idToken && (0, $2a776d17fcab286a$export$b007d77a962aa175)({
            expiresAt: (tokens.idToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        const accessTokenExpired = (0, $2a776d17fcab286a$export$b007d77a962aa175)({
            expiresAt: (tokens.accessToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        if (options?.forceRefresh || idTokenExpired || accessTokenExpired) {
            tokens = await this.refreshTokens({
                tokens: tokens,
                username: username
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens?.accessToken,
            idToken: tokens?.idToken,
            signInDetails: tokens?.signInDetails
        };
    }
    async refreshTokens({ tokens: tokens , username: username  }) {
        try {
            const { signInDetails: signInDetails  } = tokens;
            const newTokens = await this.getTokenRefresher()({
                tokens: tokens,
                authConfig: this.authConfig,
                username: username
            });
            newTokens.signInDetails = signInDetails;
            await this.setTokens({
                tokens: newTokens
            });
            (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("auth", {
                event: "tokenRefresh"
            }, "Auth", (0, $c9802061728ce106$export$aadf71dd9875dd20));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(err);
        if (err.message !== "Network error") // TODO(v6): Check errors on client
        this.clearTokens();
        (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("auth", {
            event: "tokenRefresh_failure",
            data: {
                error: err
            }
        }, "Auth", (0, $c9802061728ce106$export$aadf71dd9875dd20));
        if (err.name.startsWith("NotAuthorizedException")) return null;
        throw err;
    }
    async setTokens({ tokens: tokens  }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $884faf73974cd31a$export$85b743bbda58cb6c {
    constructor(){
        this.authTokenStore = new (0, $62bb7d16e56984d5$export$a36be852d43d512)();
        this.authTokenStore.setKeyValueStorage((0, $c1a7077392f3b8b2$export$586b30dcaeecb901));
        this.tokenOrchestrator = new (0, $ce02cb698cdbaab3$export$ba2f3fbc8979d2e6)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, $180f57fe422b6b7f$export$ab413c2cb4a135d9));
    }
    getTokens({ forceRefresh: forceRefresh  } = {
        forceRefresh: false
    }) {
        return this.tokenOrchestrator.getTokens({
            forceRefresh: forceRefresh
        });
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The default provider for the JWT access token and ID token issued from the configured Cognito user pool. It manages
 * the refresh and storage of the tokens. It stores the tokens in `window.localStorage` if available, and falls back to
 * in-memory storage if not.
 */ const $8165b6923e40c4bf$export$18e158b80aac31a7 = new (0, $884faf73974cd31a$export$85b743bbda58cb6c)();
const { tokenOrchestrator: $8165b6923e40c4bf$export$66561e66d62991d0  } = $8165b6923e40c4bf$export$18e158b80aac31a7;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $15c60452aaf7d22d$export$11ac3725994bec7b = {
    /**
     * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
     *
     * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
     * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
     * @param libraryOptions The {@link LibraryOptions} additional options for the library.
     *
     * @example
     * import config from './amplifyconfiguration.json';
     *
     * Amplify.configure(config);
     */ configure (resourceConfig, libraryOptions) {
        const resolvedResourceConfig = (0, $c617356b2a6163e9$export$f101a69cd6dc6202)(resourceConfig);
        // If no Auth config is provided, no special handling will be required, configure as is.
        // Otherwise, we can assume an Auth config is provided from here on.
        if (!resolvedResourceConfig.Auth) {
            (0, $d9009b35813b573c$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        // If Auth options are provided, always just configure as is.
        // Otherwise, we can assume no Auth libraryOptions were provided from here on.
        if (libraryOptions?.Auth) {
            (0, $d9009b35813b573c$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
            return;
        }
        // If no Auth libraryOptions were previously configured, then always add default providers.
        if (!(0, $d9009b35813b573c$export$a3858a9a153cffc7).libraryOptions.Auth) {
            (0, $8165b6923e40c4bf$export$18e158b80aac31a7).setAuthConfig(resolvedResourceConfig.Auth);
            (0, $8165b6923e40c4bf$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions?.ssr ? new (0, $19002707866b8978$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $c1a7077392f3b8b2$export$586b30dcaeecb901));
            (0, $d9009b35813b573c$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                ...libraryOptions,
                Auth: {
                    tokenProvider: (0, $8165b6923e40c4bf$export$18e158b80aac31a7),
                    credentialsProvider: (0, $bdeddb1a422eb307$export$be43b753aec531e2)
                }
            });
            return;
        }
        // At this point, Auth libraryOptions would have been previously configured and no overriding
        // Auth options were given, so we should preserve the currently configured Auth libraryOptions.
        if (libraryOptions) {
            // If ssr is provided through libraryOptions, we should respect the intentional reconfiguration.
            if (libraryOptions.ssr !== undefined) (0, $8165b6923e40c4bf$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions.ssr ? new (0, $19002707866b8978$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $c1a7077392f3b8b2$export$586b30dcaeecb901));
            (0, $d9009b35813b573c$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                Auth: (0, $d9009b35813b573c$export$a3858a9a153cffc7).libraryOptions.Auth,
                ...libraryOptions
            });
            return;
        }
        // Finally, if there were no libraryOptions given at all, we should simply not touch the currently
        // configured libraryOptions.
        (0, $d9009b35813b573c$export$a3858a9a153cffc7).configure(resolvedResourceConfig);
    },
    /**
     * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
     * `Amplify.configure`.
     *
     * @returns An {@link ResourcesConfig} object.
     */ getConfig () {
        return (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig();
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $37d361b81fa35812$export$12d5c695b2213c4a;
(function(AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
})($37d361b81fa35812$export$12d5c695b2213c4a || ($37d361b81fa35812$export$12d5c695b2213c4a = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7ccba6b199ab94b3$export$195137955146d376 = {
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyChallengeResponse]: {
        message: "challengeResponse is required to confirmSignIn"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername]: {
        message: "username is required to confirmResetPassword"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmSignUpCode]: {
        message: "code is required to confirmSignUp"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode]: {
        message: "confirmationCode is required to confirmResetPassword"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword]: {
        message: "newPassword is required to confirmResetPassword"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyResendSignUpCodeUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyResetPasswordUsername]: {
        message: "username is required to resetPassword"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInPassword]: {
        message: "password is required to signIn"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername]: {
        message: "username is required to signIn"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignUpPassword]: {
        message: "password is required to signUp"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignUpUsername]: {
        message: "username is required to signUp"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).CustomAuthSignInPassword]: {
        message: "A password is not needed when signing in with CUSTOM_WITHOUT_SRP",
        recoverySuggestion: "Do not include a password in your signIn call."
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).IncorrectMFAMethod]: {
        message: "Incorrect MFA method was chosen. It should be either SMS or TOTP",
        recoverySuggestion: "Try to pass TOTP or SMS as the challengeResponse"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyVerifyTOTPSetupCode]: {
        message: "code is required to verifyTotpSetup"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyUpdatePassword]: {
        message: "oldPassword and newPassword are required to changePassword"
    },
    [(0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode]: {
        message: "confirmation code is required to confirmUserAttribute"
    }
};
// TODO: delete this code when the Auth class is removed.
var $7ccba6b199ab94b3$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})($7ccba6b199ab94b3$export$c3070468b9d65120 || ($7ccba6b199ab94b3$export$c3070468b9d65120 = {}));
var $7ccba6b199ab94b3$export$473ab0b56598aacd;
(function(AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})($7ccba6b199ab94b3$export$473ab0b56598aacd || ($7ccba6b199ab94b3$export$473ab0b56598aacd = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $5dfe0da1f6ddb527$export$45936001d12f9b53(assertion, name) {
    const { message: message , recoverySuggestion: recoverySuggestion  } = (0, $7ccba6b199ab94b3$export$195137955146d376)[name];
    if (!assertion) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $9ed36e63af9e9ee7$export$7c746b75f47c9c7d(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join("");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0f87662804872ba2$export$695b149896bd3e2a = {
    convert (input, { urlSafe: urlSafe  } = {
        urlSafe: false
    }) {
        const inputStr = typeof input === "string" ? input : (0, $9ed36e63af9e9ee7$export$7c746b75f47c9c7d)(input);
        const encodedStr = (0, $75891aafa6b8443f$export$94f295707b435c6d)()(inputStr);
        // see details about the char replacing at https://datatracker.ietf.org/doc/html/rfc4648#section-5
        return urlSafe ? encodedStr.replace(/\+/g, "-").replace(/\//g, "_") : encodedStr;
    }
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Retrieves the device name using the User-Agent Client Hints API if available,
 * falling back to the traditional userAgent string if not.
 *
 * @returns {Promise<string>} A promise that resolves with a string representing the device name.
 *
 * Example Output:
 * navigator.userAgentData:
 *   'macOS 14.2.1 arm macOS Not A(Brand/99.0.0.0;Google Chrome/121.0.6167.160;Chromium/121.0.6167.160'
 * navigator.userAgent:
 *   'Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:109.0) Gecko/20100101 Firefox/115.0'
 */ const $6751c708615ca735$export$98f0aedb14d75123 = async ()=>{
    const { userAgentData: userAgentData  } = navigator;
    if (!userAgentData) return navigator.userAgent;
    const { platform: platform = "" , platformVersion: platformVersion = "" , model: model = "" , architecture: architecture = "" , fullVersionList: fullVersionList = []  } = await userAgentData.getHighEntropyValues([
        "platform",
        "platformVersion",
        "architecture",
        "model",
        "fullVersionList"
    ]);
    const versionList = fullVersionList.map((v)=>`${v.brand}/${v.version}`).join(";");
    const deviceName = [
        platform,
        platformVersion,
        architecture,
        model,
        platform,
        versionList
    ].filter((value)=>value).join(" ");
    return deviceName;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $c13b5be9426121ff$export$3cc5c71ef5f25e57;
(function(AssociateSoftwareTokenException) {
    AssociateSoftwareTokenException["ConcurrentModificationException"] = "ConcurrentModificationException";
    AssociateSoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    AssociateSoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    AssociateSoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    AssociateSoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    AssociateSoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    AssociateSoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
})($c13b5be9426121ff$export$3cc5c71ef5f25e57 || ($c13b5be9426121ff$export$3cc5c71ef5f25e57 = {}));
var $c13b5be9426121ff$export$4327725e8bb80c51;
(function(ChangePasswordException) {
    ChangePasswordException["ForbiddenException"] = "ForbiddenException";
    ChangePasswordException["InternalErrorException"] = "InternalErrorException";
    ChangePasswordException["InvalidParameterException"] = "InvalidParameterException";
    ChangePasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ChangePasswordException["LimitExceededException"] = "LimitExceededException";
    ChangePasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ChangePasswordException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ChangePasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ChangePasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ChangePasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ChangePasswordException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$4327725e8bb80c51 || ($c13b5be9426121ff$export$4327725e8bb80c51 = {}));
var $c13b5be9426121ff$export$87a956d0b1b725a1;
(function(ConfirmDeviceException) {
    ConfirmDeviceException["ForbiddenException"] = "ForbiddenException";
    ConfirmDeviceException["InternalErrorException"] = "InternalErrorException";
    ConfirmDeviceException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmDeviceException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ConfirmDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ConfirmDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmDeviceException["UsernameExistsException"] = "UsernameExistsException";
    ConfirmDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$87a956d0b1b725a1 || ($c13b5be9426121ff$export$87a956d0b1b725a1 = {}));
var $c13b5be9426121ff$export$b86a388af82085af;
(function(ConfirmForgotPasswordException) {
    ConfirmForgotPasswordException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmForgotPasswordException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ConfirmForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ConfirmForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmForgotPasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ConfirmForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmForgotPasswordException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmForgotPasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$b86a388af82085af || ($c13b5be9426121ff$export$b86a388af82085af = {}));
var $c13b5be9426121ff$export$2ec29642a27fd055;
(function(ConfirmSignUpException) {
    ConfirmSignUpException["AliasExistsException"] = "AliasExistsException";
    ConfirmSignUpException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmSignUpException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmSignUpException["ForbiddenException"] = "ForbiddenException";
    ConfirmSignUpException["InternalErrorException"] = "InternalErrorException";
    ConfirmSignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmSignUpException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmSignUpException["LimitExceededException"] = "LimitExceededException";
    ConfirmSignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmSignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmSignUpException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmSignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmSignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmSignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmSignUpException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$2ec29642a27fd055 || ($c13b5be9426121ff$export$2ec29642a27fd055 = {}));
var $c13b5be9426121ff$export$c6d546f0ab5ecb26;
(function(DeleteUserAttributesException) {
    DeleteUserAttributesException["ForbiddenException"] = "ForbiddenException";
    DeleteUserAttributesException["InternalErrorException"] = "InternalErrorException";
    DeleteUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$c6d546f0ab5ecb26 || ($c13b5be9426121ff$export$c6d546f0ab5ecb26 = {}));
var $c13b5be9426121ff$export$315864c77a135492;
(function(DeleteUserException) {
    DeleteUserException["ForbiddenException"] = "ForbiddenException";
    DeleteUserException["InternalErrorException"] = "InternalErrorException";
    DeleteUserException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$315864c77a135492 || ($c13b5be9426121ff$export$315864c77a135492 = {}));
var $c13b5be9426121ff$export$622cff54bc9a0bb0;
(function(ForgetDeviceException) {
    ForgetDeviceException["ForbiddenException"] = "ForbiddenException";
    ForgetDeviceException["InternalErrorException"] = "InternalErrorException";
    ForgetDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ForgetDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ForgetDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgetDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ForgetDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgetDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgetDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ForgetDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$622cff54bc9a0bb0 || ($c13b5be9426121ff$export$622cff54bc9a0bb0 = {}));
var $c13b5be9426121ff$export$cedaef1e1242f8be;
(function(ForgotPasswordException) {
    ForgotPasswordException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ForgotPasswordException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ForgotPasswordException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ForgotPasswordException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$cedaef1e1242f8be || ($c13b5be9426121ff$export$cedaef1e1242f8be = {}));
var $c13b5be9426121ff$export$8d5b6b7a140e0c94;
(function(GetUserException) {
    GetUserException["ForbiddenException"] = "ForbiddenException";
    GetUserException["InternalErrorException"] = "InternalErrorException";
    GetUserException["InvalidParameterException"] = "InvalidParameterException";
    GetUserException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$8d5b6b7a140e0c94 || ($c13b5be9426121ff$export$8d5b6b7a140e0c94 = {}));
var $c13b5be9426121ff$export$506f117795ed2bb2;
(function(GetIdException) {
    GetIdException["ExternalServiceException"] = "ExternalServiceException";
    GetIdException["InternalErrorException"] = "InternalErrorException";
    GetIdException["InvalidParameterException"] = "InvalidParameterException";
    GetIdException["LimitExceededException"] = "LimitExceededException";
    GetIdException["NotAuthorizedException"] = "NotAuthorizedException";
    GetIdException["ResourceConflictException"] = "ResourceConflictException";
    GetIdException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetIdException["TooManyRequestsException"] = "TooManyRequestsException";
})($c13b5be9426121ff$export$506f117795ed2bb2 || ($c13b5be9426121ff$export$506f117795ed2bb2 = {}));
var $c13b5be9426121ff$export$9bff15c85d75f437;
(function(GetCredentialsForIdentityException) {
    GetCredentialsForIdentityException["ExternalServiceException"] = "ExternalServiceException";
    GetCredentialsForIdentityException["InternalErrorException"] = "InternalErrorException";
    GetCredentialsForIdentityException["InvalidIdentityPoolConfigurationException"] = "InvalidIdentityPoolConfigurationException";
    GetCredentialsForIdentityException["InvalidParameterException"] = "InvalidParameterException";
    GetCredentialsForIdentityException["NotAuthorizedException"] = "NotAuthorizedException";
    GetCredentialsForIdentityException["ResourceConflictException"] = "ResourceConflictException";
    GetCredentialsForIdentityException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetCredentialsForIdentityException["TooManyRequestsException"] = "TooManyRequestsException";
})($c13b5be9426121ff$export$9bff15c85d75f437 || ($c13b5be9426121ff$export$9bff15c85d75f437 = {}));
var $c13b5be9426121ff$export$2a6bba23fbf84d1b;
(function(GetUserAttributeVerificationException) {
    GetUserAttributeVerificationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    GetUserAttributeVerificationException["ForbiddenException"] = "ForbiddenException";
    GetUserAttributeVerificationException["InternalErrorException"] = "InternalErrorException";
    GetUserAttributeVerificationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    GetUserAttributeVerificationException["InvalidParameterException"] = "InvalidParameterException";
    GetUserAttributeVerificationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    GetUserAttributeVerificationException["LimitExceededException"] = "LimitExceededException";
    GetUserAttributeVerificationException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserAttributeVerificationException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserAttributeVerificationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserAttributeVerificationException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserAttributeVerificationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    GetUserAttributeVerificationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    GetUserAttributeVerificationException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserAttributeVerificationException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$2a6bba23fbf84d1b || ($c13b5be9426121ff$export$2a6bba23fbf84d1b = {}));
var $c13b5be9426121ff$export$3f7e490ba4e0b71e;
(function(GlobalSignOutException) {
    GlobalSignOutException["ForbiddenException"] = "ForbiddenException";
    GlobalSignOutException["InternalErrorException"] = "InternalErrorException";
    GlobalSignOutException["InvalidParameterException"] = "InvalidParameterException";
    GlobalSignOutException["NotAuthorizedException"] = "NotAuthorizedException";
    GlobalSignOutException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GlobalSignOutException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GlobalSignOutException["TooManyRequestsException"] = "TooManyRequestsException";
    GlobalSignOutException["UserNotConfirmedException"] = "UserNotConfirmedException";
})($c13b5be9426121ff$export$3f7e490ba4e0b71e || ($c13b5be9426121ff$export$3f7e490ba4e0b71e = {}));
var $c13b5be9426121ff$export$43ac0110dfdad33b;
(function(InitiateAuthException) {
    InitiateAuthException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    InitiateAuthException["ForbiddenException"] = "ForbiddenException";
    InitiateAuthException["InternalErrorException"] = "InternalErrorException";
    InitiateAuthException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    InitiateAuthException["InvalidParameterException"] = "InvalidParameterException";
    InitiateAuthException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    InitiateAuthException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    InitiateAuthException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    InitiateAuthException["NotAuthorizedException"] = "NotAuthorizedException";
    InitiateAuthException["ResourceNotFoundException"] = "ResourceNotFoundException";
    InitiateAuthException["TooManyRequestsException"] = "TooManyRequestsException";
    InitiateAuthException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    InitiateAuthException["UserLambdaValidationException"] = "UserLambdaValidationException";
    InitiateAuthException["UserNotConfirmedException"] = "UserNotConfirmedException";
    InitiateAuthException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$43ac0110dfdad33b || ($c13b5be9426121ff$export$43ac0110dfdad33b = {}));
var $c13b5be9426121ff$export$8807b62ddb0e4d9d;
(function(ResendConfirmationException) {
    ResendConfirmationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ResendConfirmationException["ForbiddenException"] = "ForbiddenException";
    ResendConfirmationException["InternalErrorException"] = "InternalErrorException";
    ResendConfirmationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ResendConfirmationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ResendConfirmationException["InvalidParameterException"] = "InvalidParameterException";
    ResendConfirmationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ResendConfirmationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ResendConfirmationException["LimitExceededException"] = "LimitExceededException";
    ResendConfirmationException["NotAuthorizedException"] = "NotAuthorizedException";
    ResendConfirmationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ResendConfirmationException["TooManyRequestsException"] = "TooManyRequestsException";
    ResendConfirmationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ResendConfirmationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ResendConfirmationException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$8807b62ddb0e4d9d || ($c13b5be9426121ff$export$8807b62ddb0e4d9d = {}));
var $c13b5be9426121ff$export$da9908386393628f;
(function(RespondToAuthChallengeException) {
    RespondToAuthChallengeException["AliasExistsException"] = "AliasExistsException";
    RespondToAuthChallengeException["CodeMismatchException"] = "CodeMismatchException";
    RespondToAuthChallengeException["ExpiredCodeException"] = "ExpiredCodeException";
    RespondToAuthChallengeException["ForbiddenException"] = "ForbiddenException";
    RespondToAuthChallengeException["InternalErrorException"] = "InternalErrorException";
    RespondToAuthChallengeException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    RespondToAuthChallengeException["InvalidParameterException"] = "InvalidParameterException";
    RespondToAuthChallengeException["InvalidPasswordException"] = "InvalidPasswordException";
    RespondToAuthChallengeException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    RespondToAuthChallengeException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    RespondToAuthChallengeException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    RespondToAuthChallengeException["MFAMethodNotFoundException"] = "MFAMethodNotFoundException";
    RespondToAuthChallengeException["NotAuthorizedException"] = "NotAuthorizedException";
    RespondToAuthChallengeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    RespondToAuthChallengeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    RespondToAuthChallengeException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    RespondToAuthChallengeException["TooManyRequestsException"] = "TooManyRequestsException";
    RespondToAuthChallengeException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    RespondToAuthChallengeException["UserLambdaValidationException"] = "UserLambdaValidationException";
    RespondToAuthChallengeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    RespondToAuthChallengeException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$da9908386393628f || ($c13b5be9426121ff$export$da9908386393628f = {}));
var $c13b5be9426121ff$export$23ea34859d89459d;
(function(SetUserMFAPreferenceException) {
    SetUserMFAPreferenceException["ForbiddenException"] = "ForbiddenException";
    SetUserMFAPreferenceException["InternalErrorException"] = "InternalErrorException";
    SetUserMFAPreferenceException["InvalidParameterException"] = "InvalidParameterException";
    SetUserMFAPreferenceException["NotAuthorizedException"] = "NotAuthorizedException";
    SetUserMFAPreferenceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    SetUserMFAPreferenceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SetUserMFAPreferenceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    SetUserMFAPreferenceException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$23ea34859d89459d || ($c13b5be9426121ff$export$23ea34859d89459d = {}));
var $c13b5be9426121ff$export$d0816902ed99fce6;
(function(SignUpException) {
    SignUpException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    SignUpException["InternalErrorException"] = "InternalErrorException";
    SignUpException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    SignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    SignUpException["InvalidParameterException"] = "InvalidParameterException";
    SignUpException["InvalidPasswordException"] = "InvalidPasswordException";
    SignUpException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    SignUpException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    SignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    SignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    SignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    SignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    SignUpException["UsernameExistsException"] = "UsernameExistsException";
})($c13b5be9426121ff$export$d0816902ed99fce6 || ($c13b5be9426121ff$export$d0816902ed99fce6 = {}));
var $c13b5be9426121ff$export$44cb15f260897376;
(function(UpdateUserAttributesException) {
    UpdateUserAttributesException["AliasExistsException"] = "AliasExistsException";
    UpdateUserAttributesException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    UpdateUserAttributesException["CodeMismatchException"] = "CodeMismatchException";
    UpdateUserAttributesException["ExpiredCodeException"] = "ExpiredCodeException";
    UpdateUserAttributesException["ForbiddenException"] = "ForbiddenException";
    UpdateUserAttributesException["InternalErrorException"] = "InternalErrorException";
    UpdateUserAttributesException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    UpdateUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    UpdateUserAttributesException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    UpdateUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateUserAttributesException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    UpdateUserAttributesException["UserLambdaValidationException"] = "UserLambdaValidationException";
    UpdateUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$44cb15f260897376 || ($c13b5be9426121ff$export$44cb15f260897376 = {}));
var $c13b5be9426121ff$export$a974f64d24be573a;
(function(VerifySoftwareTokenException) {
    VerifySoftwareTokenException["CodeMismatchException"] = "CodeMismatchException";
    VerifySoftwareTokenException["EnableSoftwareTokenMFAException"] = "EnableSoftwareTokenMFAException";
    VerifySoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    VerifySoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    VerifySoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    VerifySoftwareTokenException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    VerifySoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifySoftwareTokenException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifySoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifySoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    VerifySoftwareTokenException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifySoftwareTokenException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifySoftwareTokenException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$a974f64d24be573a || ($c13b5be9426121ff$export$a974f64d24be573a = {}));
var $c13b5be9426121ff$export$527caabb62d14fe3;
(function(VerifyUserAttributeException) {
    VerifyUserAttributeException["AliasExistsException"] = "AliasExistsException";
    VerifyUserAttributeException["CodeMismatchException"] = "CodeMismatchException";
    VerifyUserAttributeException["ExpiredCodeException"] = "ExpiredCodeException";
    VerifyUserAttributeException["ForbiddenException"] = "ForbiddenException";
    VerifyUserAttributeException["InternalErrorException"] = "InternalErrorException";
    VerifyUserAttributeException["InvalidParameterException"] = "InvalidParameterException";
    VerifyUserAttributeException["LimitExceededException"] = "LimitExceededException";
    VerifyUserAttributeException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifyUserAttributeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifyUserAttributeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifyUserAttributeException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifyUserAttributeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifyUserAttributeException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$527caabb62d14fe3 || ($c13b5be9426121ff$export$527caabb62d14fe3 = {}));
var $c13b5be9426121ff$export$de57be1863bdb9d6;
(function(UpdateDeviceStatusException) {
    UpdateDeviceStatusException["ForbiddenException"] = "ForbiddenException";
    UpdateDeviceStatusException["InternalErrorException"] = "InternalErrorException";
    UpdateDeviceStatusException["InvalidParameterException"] = "InvalidParameterException";
    UpdateDeviceStatusException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    UpdateDeviceStatusException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateDeviceStatusException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateDeviceStatusException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateDeviceStatusException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateDeviceStatusException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateDeviceStatusException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$de57be1863bdb9d6 || ($c13b5be9426121ff$export$de57be1863bdb9d6 = {}));
var $c13b5be9426121ff$export$eb8cb06bdb07bf0c;
(function(ListDevicesException) {
    ListDevicesException["ForbiddenException"] = "ForbiddenException";
    ListDevicesException["InternalErrorException"] = "InternalErrorException";
    ListDevicesException["InvalidParameterException"] = "InvalidParameterException";
    ListDevicesException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ListDevicesException["NotAuthorizedException"] = "NotAuthorizedException";
    ListDevicesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ListDevicesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ListDevicesException["TooManyRequestsException"] = "TooManyRequestsException";
    ListDevicesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ListDevicesException["UserNotFoundException"] = "UserNotFoundException";
})($c13b5be9426121ff$export$eb8cb06bdb07bf0c || ($c13b5be9426121ff$export$eb8cb06bdb07bf0c = {}));
const $c13b5be9426121ff$export$ecd3eb1722b48d26 = "SetUpTOTPException";









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e259644c3d1dc6cd$export$e5432d4c8eb97ea7 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const tokens = await amplify.Auth.getTokens({
        forceRefresh: false
    });
    (0, $45fe96cf99d947f4$export$77712ea5882cac9f)(tokens);
    const { "cognito:username": username , sub: sub  } = tokens.idToken?.payload ?? {};
    const authUser = {
        username: username,
        userId: sub
    };
    const signInDetails = $e259644c3d1dc6cd$var$getSignInDetailsFromTokens(tokens);
    if (signInDetails) authUser.signInDetails = signInDetails;
    return authUser;
};
function $e259644c3d1dc6cd$var$getSignInDetailsFromTokens(tokens) {
    return tokens?.signInDetails;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Gets the current user from the idToken.
 *
 * @param input -  The GetCurrentUserInput object.
 * @returns GetCurrentUserOutput
 * @throws - {@link InitiateAuthException} - Thrown when the service fails to refresh the tokens.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $06d09becd613c1b3$export$e5432d4c8eb97ea7 = async ()=>{
    return (0, $e259644c3d1dc6cd$export$e5432d4c8eb97ea7)((0, $d9009b35813b573c$export$a3858a9a153cffc7));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $d85f0aaaaf37a11b$export$d6cd780379f37dae = (action, customUserAgentDetails)=>(0, $94d73b8725ccf9a9$export$ede38edb26c0bfdf)({
        category: (0, $3c92cd7927458afb$export$3a8840c5b2ecf003).Auth,
        action: action,
        ...customUserAgentDetails
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f8a791ed74ba6194$var$signInReducer = (state, action)=>{
    switch(action.type){
        case "SET_SIGN_IN_SESSION":
            return {
                ...state,
                signInSession: action.value
            };
        case "SET_SIGN_IN_STATE":
            return {
                ...action.value
            };
        case "SET_CHALLENGE_NAME":
            return {
                ...state,
                challengeName: action.value
            };
        case "SET_USERNAME":
            return {
                ...state,
                username: action.value
            };
        case "SET_INITIAL_STATE":
            return $f8a791ed74ba6194$var$defaultState();
        default:
            return state;
    }
};
function $f8a791ed74ba6194$var$defaultState() {
    return {
        username: undefined,
        challengeName: undefined,
        signInSession: undefined
    };
}
const $f8a791ed74ba6194$var$createStore = (reducer)=>{
    let currentState = reducer($f8a791ed74ba6194$var$defaultState(), {
        type: "SET_INITIAL_STATE"
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $f8a791ed74ba6194$export$390d5da4c63a4a41 = $f8a791ed74ba6194$var$createStore($f8a791ed74ba6194$var$signInReducer);
function $f8a791ed74ba6194$export$bae72361b690e075(state) {
    $f8a791ed74ba6194$export$390d5da4c63a4a41.dispatch({
        type: "SET_SIGN_IN_STATE",
        value: state
    });
}
function $f8a791ed74ba6194$export$f3dfaa7234c98dc0() {
    $f8a791ed74ba6194$export$390d5da4c63a4a41.dispatch({
        type: "SET_INITIAL_STATE"
    });
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8afd980693d9bf70$export$f5d75491a17f02c = {
    convert (input) {
        return new TextEncoder().encode(input);
    }
};


/* eslint-disable */ // @ts-nocheck -> BigInteger is already a vended utility
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $839faf96146888f4$export$2e2bcd8739ae039(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $839faf96146888f4$var$nbi() {
    return new $839faf96146888f4$export$2e2bcd8739ae039(null, null);
}
// Bits per digit
let $839faf96146888f4$var$dbits;
// JavaScript engine analysis
const $839faf96146888f4$var$canary = 0xdeadbeefcafe;
const $839faf96146888f4$var$j_lm = ($839faf96146888f4$var$canary & 0xffffff) === 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $839faf96146888f4$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        const v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $839faf96146888f4$var$am2(i, x, w, j, c, n) {
    const xl = x & 0x7fff;
    const xh = x >> 15;
    while(--n >= 0){
        let l = this[i] & 0x7fff;
        const h = this[i++] >> 15;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $839faf96146888f4$var$am3(i, x, w, j, c, n) {
    const xl = x & 0x3fff;
    const xh = x >> 14;
    while(--n >= 0){
        let l = this[i] & 0x3fff;
        const h = this[i++] >> 14;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
const $839faf96146888f4$var$inBrowser = typeof navigator !== "undefined";
if ($839faf96146888f4$var$inBrowser && $839faf96146888f4$var$j_lm && navigator.appName === "Microsoft Internet Explorer") {
    $839faf96146888f4$export$2e2bcd8739ae039.prototype.am = $839faf96146888f4$var$am2;
    $839faf96146888f4$var$dbits = 30;
} else if ($839faf96146888f4$var$inBrowser && $839faf96146888f4$var$j_lm && navigator.appName !== "Netscape") {
    $839faf96146888f4$export$2e2bcd8739ae039.prototype.am = $839faf96146888f4$var$am1;
    $839faf96146888f4$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $839faf96146888f4$export$2e2bcd8739ae039.prototype.am = $839faf96146888f4$var$am3;
    $839faf96146888f4$var$dbits = 28;
}
$839faf96146888f4$export$2e2bcd8739ae039.prototype.DB = $839faf96146888f4$var$dbits;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.DM = (1 << $839faf96146888f4$var$dbits) - 1;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.DV = 1 << $839faf96146888f4$var$dbits;
const $839faf96146888f4$var$BI_FP = 52;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.FV = Math.pow(2, $839faf96146888f4$var$BI_FP);
$839faf96146888f4$export$2e2bcd8739ae039.prototype.F1 = $839faf96146888f4$var$BI_FP - $839faf96146888f4$var$dbits;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.F2 = 2 * $839faf96146888f4$var$dbits - $839faf96146888f4$var$BI_FP;
// Digit conversions
const $839faf96146888f4$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
const $839faf96146888f4$var$BI_RC = [];
let $839faf96146888f4$var$rr, $839faf96146888f4$var$vv;
$839faf96146888f4$var$rr = "0".charCodeAt(0);
for($839faf96146888f4$var$vv = 0; $839faf96146888f4$var$vv <= 9; ++$839faf96146888f4$var$vv)$839faf96146888f4$var$BI_RC[$839faf96146888f4$var$rr++] = $839faf96146888f4$var$vv;
$839faf96146888f4$var$rr = "a".charCodeAt(0);
for($839faf96146888f4$var$vv = 10; $839faf96146888f4$var$vv < 36; ++$839faf96146888f4$var$vv)$839faf96146888f4$var$BI_RC[$839faf96146888f4$var$rr++] = $839faf96146888f4$var$vv;
$839faf96146888f4$var$rr = "A".charCodeAt(0);
for($839faf96146888f4$var$vv = 10; $839faf96146888f4$var$vv < 36; ++$839faf96146888f4$var$vv)$839faf96146888f4$var$BI_RC[$839faf96146888f4$var$rr++] = $839faf96146888f4$var$vv;
function $839faf96146888f4$var$int2char(n) {
    return $839faf96146888f4$var$BI_RM.charAt(n);
}
function $839faf96146888f4$var$intAt(s, i) {
    const c = $839faf96146888f4$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $839faf96146888f4$var$bnpCopyTo(r) {
    for(let i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $839faf96146888f4$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $839faf96146888f4$var$nbv(i) {
    const r = $839faf96146888f4$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $839faf96146888f4$var$bnpFromString(s, b) {
    let k;
    if (b === 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    let i = s.length;
    let mi = false;
    let sh = 0;
    while(--i >= 0){
        const x = $839faf96146888f4$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) === "-") mi = true;
            continue;
        }
        mi = false;
        if (sh === 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $839faf96146888f4$export$2e2bcd8739ae039.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $839faf96146888f4$var$bnpClamp() {
    const c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $839faf96146888f4$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    let k;
    if (b == 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    const km = (1 << k) - 1;
    let d;
    let m = false;
    let r = "";
    let i = this.t;
    let p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $839faf96146888f4$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $839faf96146888f4$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $839faf96146888f4$var$bnNegate() {
    const r = $839faf96146888f4$var$nbi();
    $839faf96146888f4$export$2e2bcd8739ae039.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $839faf96146888f4$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $839faf96146888f4$var$bnCompareTo(a) {
    let r = this.s - a.s;
    if (r != 0) return r;
    let i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $839faf96146888f4$var$nbits(x) {
    let r = 1;
    let t;
    if ((t = x >>> 16) !== 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) !== 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) !== 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) !== 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) !== 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $839faf96146888f4$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $839faf96146888f4$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $839faf96146888f4$var$bnpDLShiftTo(n, r) {
    let i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $839faf96146888f4$var$bnpDRShiftTo(n, r) {
    for(let i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $839faf96146888f4$var$bnpLShiftTo(n, r) {
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << cbs) - 1;
    const ds = Math.floor(n / this.DB);
    let c = this.s << bs & this.DM;
    let i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $839faf96146888f4$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    const ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(let i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $839faf96146888f4$var$bnpSubTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $839faf96146888f4$var$bnpMultiplyTo(a, r) {
    const x = this.abs();
    const y = a.abs();
    let i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s !== a.s) $839faf96146888f4$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $839faf96146888f4$var$bnpSquareTo(r) {
    const x = this.abs();
    let i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        const c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $839faf96146888f4$var$bnpDivRemTo(m, q, r) {
    const pm = m.abs();
    if (pm.t <= 0) return;
    const pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r === null) r = $839faf96146888f4$var$nbi();
    const y = $839faf96146888f4$var$nbi();
    const ts = this.s;
    const ms = m.s;
    const nsh = this.DB - $839faf96146888f4$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    const ys = y.t;
    const y0 = y[ys - 1];
    if (y0 === 0) return;
    const yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    const d1 = this.FV / yt;
    const d2 = (1 << this.F1) / yt;
    const e = 1 << this.F2;
    let i = r.t;
    let j = i - ys;
    const t = q === null ? $839faf96146888f4$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $839faf96146888f4$export$2e2bcd8739ae039.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        let qd = r[--i] === y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q !== null) {
        r.drShiftTo(ys, q);
        if (ts !== ms) $839faf96146888f4$export$2e2bcd8739ae039.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $839faf96146888f4$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (public) this mod a
function $839faf96146888f4$var$bnMod(a) {
    const r = $839faf96146888f4$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($839faf96146888f4$export$2e2bcd8739ae039.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $839faf96146888f4$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    const x = this[0];
    if ((x & 1) === 0) return 0;
    let y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $839faf96146888f4$var$bnEquals(a) {
    return this.compareTo(a) === 0;
}
// (protected) r = this + a
function $839faf96146888f4$var$bnpAddTo(a, r) {
    let i = 0;
    let c = 0;
    const m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $839faf96146888f4$var$bnAdd(a) {
    const r = $839faf96146888f4$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $839faf96146888f4$var$bnSubtract(a) {
    const r = $839faf96146888f4$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $839faf96146888f4$var$bnMultiply(a) {
    const r = $839faf96146888f4$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $839faf96146888f4$var$bnDivide(a) {
    const r = $839faf96146888f4$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $839faf96146888f4$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $839faf96146888f4$var$montConvert(x) {
    const r = $839faf96146888f4$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($839faf96146888f4$export$2e2bcd8739ae039.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $839faf96146888f4$var$montRevert(x) {
    const r = $839faf96146888f4$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $839faf96146888f4$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(let i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        let j = x[i] & 0x7fff;
        const u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $839faf96146888f4$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $839faf96146888f4$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$839faf96146888f4$var$Montgomery.prototype.convert = $839faf96146888f4$var$montConvert;
$839faf96146888f4$var$Montgomery.prototype.revert = $839faf96146888f4$var$montRevert;
$839faf96146888f4$var$Montgomery.prototype.reduce = $839faf96146888f4$var$montReduce;
$839faf96146888f4$var$Montgomery.prototype.mulTo = $839faf96146888f4$var$montMulTo;
$839faf96146888f4$var$Montgomery.prototype.sqrTo = $839faf96146888f4$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $839faf96146888f4$var$bnModPow(e, m, callback) {
    let i = e.bitLength();
    let k;
    let r = $839faf96146888f4$var$nbv(1);
    const z = new $839faf96146888f4$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    const g = [];
    let n = 3;
    const k1 = k - 1;
    const km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        const g2 = $839faf96146888f4$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $839faf96146888f4$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    let j = e.t - 1;
    let w;
    let is1 = true;
    let r2 = $839faf96146888f4$var$nbi();
    let t;
    i = $839faf96146888f4$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) === 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) === 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    const result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$839faf96146888f4$export$2e2bcd8739ae039.prototype.copyTo = $839faf96146888f4$var$bnpCopyTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.fromInt = $839faf96146888f4$var$bnpFromInt;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.fromString = $839faf96146888f4$var$bnpFromString;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.clamp = $839faf96146888f4$var$bnpClamp;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.dlShiftTo = $839faf96146888f4$var$bnpDLShiftTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.drShiftTo = $839faf96146888f4$var$bnpDRShiftTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.lShiftTo = $839faf96146888f4$var$bnpLShiftTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.rShiftTo = $839faf96146888f4$var$bnpRShiftTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.subTo = $839faf96146888f4$var$bnpSubTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.multiplyTo = $839faf96146888f4$var$bnpMultiplyTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.squareTo = $839faf96146888f4$var$bnpSquareTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.divRemTo = $839faf96146888f4$var$bnpDivRemTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.invDigit = $839faf96146888f4$var$bnpInvDigit;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.addTo = $839faf96146888f4$var$bnpAddTo;
// public
$839faf96146888f4$export$2e2bcd8739ae039.prototype.toString = $839faf96146888f4$var$bnToString;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.negate = $839faf96146888f4$var$bnNegate;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.abs = $839faf96146888f4$var$bnAbs;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.compareTo = $839faf96146888f4$var$bnCompareTo;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.bitLength = $839faf96146888f4$var$bnBitLength;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.mod = $839faf96146888f4$var$bnMod;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.equals = $839faf96146888f4$var$bnEquals;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.add = $839faf96146888f4$var$bnAdd;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.subtract = $839faf96146888f4$var$bnSubtract;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.multiply = $839faf96146888f4$var$bnMultiply;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.divide = $839faf96146888f4$var$bnDivide;
$839faf96146888f4$export$2e2bcd8739ae039.prototype.modPow = $839faf96146888f4$var$bnModPow;
// "constants"
$839faf96146888f4$export$2e2bcd8739ae039.ZERO = $839faf96146888f4$var$nbv(0);
$839faf96146888f4$export$2e2bcd8739ae039.ONE = $839faf96146888f4$var$nbv(1);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $04b7fba5022fa024$export$f7340100dd3acd38 = async ({ a: a , g: g , k: k , x: x , B: B , N: N , U: U  })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(x, N, (outerErr, outerResult)=>{
            if (outerErr) {
                reject(outerErr);
                return;
            }
            B.subtract(k.multiply(outerResult)).modPow(a.add(U.multiply(x)), N, (innerErr, innerResult)=>{
                if (innerErr) {
                    reject(innerErr);
                    return;
                }
                resolve(innerResult.mod(N));
            });
        });
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $54a0e8e62b1cf7be$export$baab4dd8c7240846 = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
const $54a0e8e62b1cf7be$export$a0f75f7d2f3bd702 = {};
const $54a0e8e62b1cf7be$export$fcb552daf117d7e3 = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $54a0e8e62b1cf7be$export$a0f75f7d2f3bd702[i] = encodedByte;
    $54a0e8e62b1cf7be$export$fcb552daf117d7e3[encodedByte] = i;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ const $d9c2f17b8749cd84$export$b772e43c3daf2e7a = (encoded)=>{
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in (0, $54a0e8e62b1cf7be$export$fcb552daf117d7e3)) out[i / 2] = (0, $54a0e8e62b1cf7be$export$fcb552daf117d7e3)[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ const $9a5292c2de1a98b1$export$22a20ab34c1d7a2b = (bytes)=>{
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += (0, $54a0e8e62b1cf7be$export$a0f75f7d2f3bd702)[bytes[i]];
    return out;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a `SourceData`
 * @param {SourceData} data Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $b8d29a2e181619db$export$629ee8d7d3ebacd1 = (data)=>{
    const sha256 = new (0, $475efd9fa7b1a9cc$export$3b58ea8124ac5e28)();
    sha256.update(data);
    const hashedData = sha256.digestSync();
    const hashHexFromUint8 = (0, $9a5292c2de1a98b1$export$22a20ab34c1d7a2b)(hashedData);
    return new Array(64 - hashHexFromUint8.length).join("0") + hashHexFromUint8;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a hex string
 * @param {string} hexStr Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $131acfb31ddfe2fb$export$8b112e065a8843a = (hexStr)=>(0, $b8d29a2e181619db$export$629ee8d7d3ebacd1)((0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)(hexStr));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ const $7e835c3efa00f07a$var$HEX_MSB_REGEX = /^[89a-f]/i;
/**
 * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
 *
 * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
 * byte array containing the two's-complement representation of a BigInteger. The array contains
 * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
 *
 * Examples showing how ambiguity is avoided by left padding with:
 * 	"00" (for positive values where the most-significant-bit is set)
 *  "FF" (for negative values where the most-significant-bit is set)
 *
 * padHex(bigInteger.fromInt(-236))  === "FF14"
 * padHex(bigInteger.fromInt(20))    === "14"
 *
 * padHex(bigInteger.fromInt(-200))  === "FF38"
 * padHex(bigInteger.fromInt(56))    === "38"
 *
 * padHex(bigInteger.fromInt(-20))   === "EC"
 * padHex(bigInteger.fromInt(236))   === "00EC"
 *
 * padHex(bigInteger.fromInt(-56))   === "C8"
 * padHex(bigInteger.fromInt(200))   === "00C8"
 *
 * @param {AuthBigInteger} bigInt Number to encode.
 * @returns {String} even-length hex string of the two's complement encoding.
 */ const $7e835c3efa00f07a$export$35d4ea07514a0402 = (bigInt)=>{
    if (!(bigInt instanceof (0, $839faf96146888f4$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
    const isNegative = bigInt.compareTo((0, $839faf96146888f4$export$2e2bcd8739ae039).ZERO) < 0;
    /* Get a hex string for abs(bigInt) */ let hexStr = bigInt.abs().toString(16);
    /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? `0${hexStr}` : hexStr;
    /* Prepend "00" if the most significant bit is set */ hexStr = $7e835c3efa00f07a$var$HEX_MSB_REGEX.test(hexStr) ? `00${hexStr}` : hexStr;
    if (isNegative) {
        /* Flip the bits of the representation */ const invertedNibbles = hexStr.split("").map((x)=>{
            const invertedNibble = ~parseInt(x, 16) & 0xf;
            return "0123456789ABCDEF".charAt(invertedNibble);
        }).join("");
        /* After flipping the bits, add one to get the 2's complement representation */ const flippedBitsBI = new (0, $839faf96146888f4$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $839faf96146888f4$export$2e2bcd8739ae039).ONE);
        hexStr = flippedBitsBI.toString(16);
        /*
        For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128

        Any sequence of '1' bits on the left can always be substituted with a single '1' bit
        without changing the represented value.

        This only happens in the case when the input is 80...00
        */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
    }
    return hexStr;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $76d0b69b01ecb24b$export$e2f40082638513e7 = ({ A: A , B: B  })=>{
    const U = new (0, $839faf96146888f4$export$2e2bcd8739ae039)((0, $131acfb31ddfe2fb$export$8b112e065a8843a)((0, $7e835c3efa00f07a$export$35d4ea07514a0402)(A) + (0, $7e835c3efa00f07a$export$35d4ea07514a0402)(B)), 16);
    if (U.equals((0, $839faf96146888f4$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
    return U;
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Standard HKDF algorithm.
 *
 * @param {Uint8Array} ikm Input key material.
 * @param {Uint8Array} salt Salt value.
 * @param {Uint8Array} info Context and application specific info.
 *
 * @returns {Uint8Array} Strong key material.
 *
 * @internal
 */ const $873de60f2b95e3e2$export$295a0a5429217d03 = (ikm, salt, info)=>{
    const awsCryptoHash = new (0, $475efd9fa7b1a9cc$export$3b58ea8124ac5e28)(salt);
    awsCryptoHash.update(ikm);
    const resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
    const awsCryptoHashHmac = new (0, $475efd9fa7b1a9cc$export$3b58ea8124ac5e28)(resultFromAWSCryptoPrk);
    awsCryptoHashHmac.update(info);
    const resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
    const hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
    return hashHexFromAWSCrypto.slice(0, 16);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*
 * Cryptographically secure pseudorandom number generator
 * As Math.random() is cryptographically not safe to use
 */ function $21c9035b228450bc$export$d265930babe23ca5() {
    const crypto = (0, $75891aafa6b8443f$export$e003cc239f955cb6)();
    const randomResult = crypto.getRandomValues(new Uint32Array(1))[0];
    return randomResult;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $6de7f9f1e1bbc4c2$var$hexStringify(wordArray) {
    // Shortcuts
    const { words: words  } = wordArray;
    const { sigBytes: sigBytes  } = wordArray;
    // Convert
    const hexChars = [];
    for(let i = 0; i < sigBytes; i++){
        const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
class $6de7f9f1e1bbc4c2$export$4cd4919e303276a6 {
    constructor(words, sigBytes){
        this.words = [];
        let Words = words;
        Words = this.words = Words || [];
        if (sigBytes !== undefined) this.sigBytes = sigBytes;
        else this.sigBytes = Words.length * 4;
    }
    random(nBytes) {
        const words = [];
        for(let i = 0; i < nBytes; i += 4)words.push((0, $21c9035b228450bc$export$d265930babe23ca5)());
        return new $6de7f9f1e1bbc4c2$export$4cd4919e303276a6(words, nBytes);
    }
    toString() {
        return $6de7f9f1e1bbc4c2$var$hexStringify(this);
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a Uint8Array with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Uint8Array} fixed-length sequence of random bytes
 */ const $25ea71e06c11381c$export$763d6fc7c4b5dc52 = (nBytes)=>{
    const str = new (0, $6de7f9f1e1bbc4c2$export$4cd4919e303276a6)().random(nBytes).toString();
    return (0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)(str);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Helper function to generate a random string
 * @returns {string} a random value.
 *
 * @internal
 */ const $ba71225bb85e6075$export$8c487394e1c35fbe = ()=>(0, $0f87662804872ba2$export$695b149896bd3e2a).convert((0, $25ea71e06c11381c$export$763d6fc7c4b5dc52)(40));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @class */ class $beaf1a34a8aa7752$export$2e2bcd8739ae039 {
    constructor({ userPoolName: userPoolName , a: a , g: g , A: A , N: N  }){
        this.encoder = (0, $8afd980693d9bf70$export$f5d75491a17f02c);
        this.userPoolName = userPoolName;
        this.a = a;
        this.g = g;
        this.A = A;
        this.N = N;
        this.k = new (0, $839faf96146888f4$export$2e2bcd8739ae039)((0, $131acfb31ddfe2fb$export$8b112e065a8843a)(`${(0, $7e835c3efa00f07a$export$35d4ea07514a0402)(N)}${(0, $7e835c3efa00f07a$export$35d4ea07514a0402)(g)}`), 16);
    }
    /**
     * @returns {string} Generated random value included in password hash.
     */ getRandomPassword() {
        if (!this.randomPassword) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "EmptyBigIntegerRandomPassword",
            message: "random password is empty"
        });
        return this.randomPassword;
    }
    /**
     * @returns {string} Generated random value included in devices hash.
     */ getSaltToHashDevices() {
        if (!this.saltToHashDevices) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "EmptyBigIntegersaltToHashDevices",
            message: "saltToHashDevices is empty"
        });
        return this.saltToHashDevices;
    }
    /**
     * @returns {string} Value used to verify devices.
     */ getVerifierDevices() {
        if (!this.verifierDevices) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: "EmptyBigIntegerVerifierDevices",
            message: "verifyDevices is empty"
        });
        return this.verifierDevices;
    }
    /**
     * Generate salts and compute verifier.
     *
     * @param {string} deviceGroupKey Devices to generate verifier for.
     * @param {string} username User to generate verifier for.
     *
     * @returns {Promise<void>}
     */ async generateHashDevice(deviceGroupKey, username) {
        this.randomPassword = (0, $ba71225bb85e6075$export$8c487394e1c35fbe)();
        const combinedString = `${deviceGroupKey}${username}:${this.randomPassword}`;
        const hashedString = (0, $b8d29a2e181619db$export$629ee8d7d3ebacd1)(combinedString);
        const hexRandom = (0, $9a5292c2de1a98b1$export$22a20ab34c1d7a2b)((0, $25ea71e06c11381c$export$763d6fc7c4b5dc52)(16));
        // The random hex will be unambiguously represented as a postive integer
        this.saltToHashDevices = (0, $7e835c3efa00f07a$export$35d4ea07514a0402)(new (0, $839faf96146888f4$export$2e2bcd8739ae039)(hexRandom, 16));
        return new Promise((resolve, reject)=>{
            this.g.modPow(new (0, $839faf96146888f4$export$2e2bcd8739ae039)((0, $131acfb31ddfe2fb$export$8b112e065a8843a)(this.saltToHashDevices + hashedString), 16), this.N, (err, result)=>{
                if (err) {
                    reject(err);
                    return;
                }
                this.verifierDevices = (0, $7e835c3efa00f07a$export$35d4ea07514a0402)(result);
                resolve();
            });
        });
    }
    /**
     * Calculates the final HKDF key based on computed S value, computed U value and the key
     *
     * @param {String} username Username.
     * @param {String} password Password.
     * @param {AuthBigInteger} B Server B value.
     * @param {AuthBigInteger} salt Generated salt.
     */ async getPasswordAuthenticationKey({ username: username , password: password , serverBValue: serverBValue , salt: salt  }) {
        if (serverBValue.mod(this.N).equals((0, $839faf96146888f4$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        const U = (0, $76d0b69b01ecb24b$export$e2f40082638513e7)({
            A: this.A,
            B: serverBValue
        });
        const usernamePassword = `${this.userPoolName}${username}:${password}`;
        const usernamePasswordHash = (0, $b8d29a2e181619db$export$629ee8d7d3ebacd1)(usernamePassword);
        const x = new (0, $839faf96146888f4$export$2e2bcd8739ae039)((0, $131acfb31ddfe2fb$export$8b112e065a8843a)((0, $7e835c3efa00f07a$export$35d4ea07514a0402)(salt) + usernamePasswordHash), 16);
        const S = await (0, $04b7fba5022fa024$export$f7340100dd3acd38)({
            a: this.a,
            g: this.g,
            k: this.k,
            x: x,
            B: serverBValue,
            N: this.N,
            U: U
        });
        const context = this.encoder.convert("Caldera Derived Key");
        const spacer = this.encoder.convert(String.fromCharCode(1));
        const info = new Uint8Array(context.byteLength + spacer.byteLength);
        info.set(context, 0);
        info.set(spacer, context.byteLength);
        const hkdfKey = (0, $873de60f2b95e3e2$export$295a0a5429217d03)((0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)((0, $7e835c3efa00f07a$export$35d4ea07514a0402)(S)), (0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)((0, $7e835c3efa00f07a$export$35d4ea07514a0402)(U)), info);
        return hkdfKey;
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $088c16dd8980815f$export$53a55138f9e96c65 = async ({ a: a , g: g , N: N  })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(a, N, (err, A)=>{
            if (err) {
                reject(err);
                return;
            }
            if (A.mod(N).equals((0, $839faf96146888f4$export$2e2bcd8739ae039).ZERO)) {
                reject(new Error("Illegal parameter. A mod N cannot be 0."));
                return;
            }
            resolve(A);
        });
    });
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a new {@link AuthenticationHelper} instance with randomly generated BigInteger seed
 *
 * @param userPoolName Cognito user pool name.
 * @returns An {@link AuthenticationHelper} instance.
 *
 * @internal
 */ const $4b165f329812d8bd$export$47560e2dc89f678c = async (userPoolName)=>{
    const N = new (0, $839faf96146888f4$export$2e2bcd8739ae039)((0, $54a0e8e62b1cf7be$export$baab4dd8c7240846), 16);
    const g = new (0, $839faf96146888f4$export$2e2bcd8739ae039)("2", 16);
    const a = $4b165f329812d8bd$var$generateRandomBigInteger();
    const A = await (0, $088c16dd8980815f$export$53a55138f9e96c65)({
        a: a,
        g: g,
        N: N
    });
    return new (0, $beaf1a34a8aa7752$export$2e2bcd8739ae039)({
        userPoolName: userPoolName,
        a: a,
        g: g,
        A: A,
        N: N
    });
};
/**
 * Generates a random BigInteger.
 *
 * @returns {BigInteger} a random value.
 */ const $4b165f329812d8bd$var$generateRandomBigInteger = ()=>{
    // This will be interpreted as a postive 128-bit integer
    const hexRandom = (0, $9a5292c2de1a98b1$export$22a20ab34c1d7a2b)((0, $25ea71e06c11381c$export$763d6fc7c4b5dc52)(128));
    // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
    return new (0, $839faf96146888f4$export$2e2bcd8739ae039)(hexRandom, 16);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $04399cc05aa3ed90$var$MONTH_NAMES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $04399cc05aa3ed90$var$WEEK_NAMES = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $04399cc05aa3ed90$export$218a6e05f05aec48 = ()=>{
    const now = new Date();
    const weekDay = $04399cc05aa3ed90$var$WEEK_NAMES[now.getUTCDay()];
    const month = $04399cc05aa3ed90$var$MONTH_NAMES[now.getUTCMonth()];
    const day = now.getUTCDate();
    let hours = now.getUTCHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = now.getUTCMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let seconds = now.getUTCSeconds();
    if (seconds < 10) seconds = `0${seconds}`;
    const year = now.getUTCFullYear();
    // ddd MMM D HH:mm:ss UTC YYYY
    const dateNow = `${weekDay} ${month} ${day} ${hours}:${minutes}:${seconds} UTC ${year}`;
    return dateNow;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $650c859408628344$export$577b7d8a4f1b23fd = ({ userPoolName: userPoolName , username: username , challengeParameters: challengeParameters , dateNow: dateNow , hkdf: hkdf  })=>{
    const bufUPIDaToB = (0, $8afd980693d9bf70$export$f5d75491a17f02c).convert(userPoolName);
    const bufUNaToB = (0, $8afd980693d9bf70$export$f5d75491a17f02c).convert(username);
    const bufSBaToB = $650c859408628344$var$urlB64ToUint8Array(challengeParameters.SECRET_BLOCK);
    const bufDNaToB = (0, $8afd980693d9bf70$export$f5d75491a17f02c).convert(dateNow);
    const bufConcat = new Uint8Array(bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength + bufDNaToB.byteLength);
    bufConcat.set(bufUPIDaToB, 0);
    bufConcat.set(bufUNaToB, bufUPIDaToB.byteLength);
    bufConcat.set(bufSBaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength);
    bufConcat.set(bufDNaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength);
    const awsCryptoHash = new (0, $475efd9fa7b1a9cc$export$3b58ea8124ac5e28)(hkdf);
    awsCryptoHash.update(bufConcat);
    const resultFromAWSCrypto = awsCryptoHash.digestSync();
    const signatureString = (0, $0f87662804872ba2$export$695b149896bd3e2a).convert(resultFromAWSCrypto);
    return signatureString;
};
const $650c859408628344$var$urlB64ToUint8Array = (base64String)=>{
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = (0, $ef7237a6eb0adc7d$export$1e303d38dab7b376).convert(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $1ca9fe6154565c83$var$USER_ATTRIBUTES = "userAttributes.";
async function $1ca9fe6154565c83$export$6fe6331471b54d26({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , config: config , tokenOrchestrator: tokenOrchestrator  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const challengeResponses = {
        USERNAME: username,
        ANSWER: challengeResponse
    };
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "CUSTOM_CHALLENGE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $83cecb517fee2de6$export$b196467a22b300ec)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $1ca9fe6154565c83$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $1ca9fe6154565c83$export$9b78cd405a35bccd({ challengeResponse: challengeResponse , username: username , clientMetadata: clientMetadata , session: session , deviceName: deviceName , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const challengeResponses = {
        USERNAME: username
    };
    const { Session: Session  } = await (0, $83cecb517fee2de6$export$72b1124e126ff51c)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        UserCode: challengeResponse,
        Session: session,
        FriendlyDeviceName: deviceName
    });
    (0, $f8a791ed74ba6194$export$390d5da4c63a4a41).dispatch({
        type: "SET_SIGN_IN_SESSION",
        value: Session
    });
    const jsonReq = {
        ChallengeName: "MFA_SETUP",
        ChallengeResponses: challengeResponses,
        Session: Session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId
    };
    return (0, $83cecb517fee2de6$export$b196467a22b300ec)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId)
    }, jsonReq);
}
async function $1ca9fe6154565c83$export$f0699fc2b71f49c0({ challengeResponse: challengeResponse , username: username , clientMetadata: clientMetadata , session: session , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(challengeResponse === "TOTP" || challengeResponse === "SMS", (0, $37d361b81fa35812$export$12d5c695b2213c4a).IncorrectMFAMethod);
    const challengeResponses = {
        USERNAME: username,
        ANSWER: $1ca9fe6154565c83$export$7e7902092e38fcff(challengeResponse)
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SELECT_MFA_TYPE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $83cecb517fee2de6$export$b196467a22b300ec)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $1ca9fe6154565c83$export$3eab958abdf5e22d({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const challengeResponses = {
        USERNAME: username,
        SMS_MFA_CODE: challengeResponse
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SMS_MFA",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $83cecb517fee2de6$export$b196467a22b300ec)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $1ca9fe6154565c83$export$b89ff5a8f5e11286({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const challengeResponses = {
        USERNAME: username,
        SOFTWARE_TOKEN_MFA_CODE: challengeResponse
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SOFTWARE_TOKEN_MFA",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $83cecb517fee2de6$export$b196467a22b300ec)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $1ca9fe6154565c83$export$df3f8a8c68da6a2e({ challengeResponse: challengeResponse , clientMetadata: clientMetadata , session: session , username: username , requiredAttributes: requiredAttributes , config: config  }) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const challengeResponses = {
        ...$1ca9fe6154565c83$export$c7c9603a6b1fd815(requiredAttributes),
        NEW_PASSWORD: challengeResponse,
        USERNAME: username
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "NEW_PASSWORD_REQUIRED",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $83cecb517fee2de6$export$b196467a22b300ec)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $1ca9fe6154565c83$export$29fb48d356e16a7(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId , userPoolId: userPoolId  } = config;
    const authParameters = {
        USERNAME: username,
        PASSWORD: password
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_PASSWORD_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $83cecb517fee2de6$export$567b0d5ec943f827)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? response.ChallengeParameters?.USER_ID_FOR_SRP ?? username;
    $1ca9fe6154565c83$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $1ca9fe6154565c83$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $1ca9fe6154565c83$export$13a3ef5ef8cac338(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $4b165f329812d8bd$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_SRP_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const resp = await (0, $83cecb517fee2de6$export$567b0d5ec943f827)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const { ChallengeParameters: challengeParameters , Session: session  } = resp;
    const activeUsername = challengeParameters?.USERNAME ?? username;
    $1ca9fe6154565c83$export$fecfbc200868d412(activeUsername);
    return $1ca9fe6154565c83$export$30f932fe98713ccc($1ca9fe6154565c83$export$7f7b64167822fe34, [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $1ca9fe6154565c83$export$1a654dcab55e0de5(username, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId , userPoolId: userPoolId  } = config;
    const authParameters = {
        USERNAME: username
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $83cecb517fee2de6$export$567b0d5ec943f827)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    $1ca9fe6154565c83$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $1ca9fe6154565c83$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $1ca9fe6154565c83$export$9ce9dd351616104c(username, password, clientMetadata, config, tokenOrchestrator) {
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(config);
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $4b165f329812d8bd$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        CHALLENGE_NAME: "SRP_A"
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const { ChallengeParameters: challengeParameters , Session: session  } = await (0, $83cecb517fee2de6$export$567b0d5ec943f827)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = challengeParameters?.USERNAME ?? username;
    $1ca9fe6154565c83$export$fecfbc200868d412(activeUsername);
    return $1ca9fe6154565c83$export$30f932fe98713ccc($1ca9fe6154565c83$export$7f7b64167822fe34, [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $1ca9fe6154565c83$var$handleDeviceSRPAuth({ username: username , config: config , clientMetadata: clientMetadata , session: session , tokenOrchestrator: tokenOrchestrator  }) {
    const { userPoolId: userPoolId  } = config;
    const clientId = config.userPoolClientId;
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $45fe96cf99d947f4$export$b6f03be79626ab0f)(deviceMetadata);
    const authenticationHelper = await (0, $4b165f329812d8bd$export$47560e2dc89f678c)(deviceMetadata.deviceGroupKey);
    const challengeResponses = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        DEVICE_KEY: deviceMetadata.deviceKey
    };
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: clientId,
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session
    };
    const { ChallengeParameters: respondedChallengeParameters , Session: Session  } = await (0, $83cecb517fee2de6$export$b196467a22b300ec)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
    return $1ca9fe6154565c83$var$handleDevicePasswordVerifier(username, respondedChallengeParameters, clientMetadata, Session, authenticationHelper, config, tokenOrchestrator);
}
async function $1ca9fe6154565c83$var$handleDevicePasswordVerifier(username, challengeParameters, clientMetadata, session, authenticationHelper, { userPoolId: userPoolId , userPoolClientId: userPoolClientId  }, tokenOrchestrator) {
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $45fe96cf99d947f4$export$b6f03be79626ab0f)(deviceMetadata);
    const serverBValue = new (0, $839faf96146888f4$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $839faf96146888f4$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const { deviceKey: deviceKey  } = deviceMetadata;
    const { deviceGroupKey: deviceGroupKey  } = deviceMetadata;
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: deviceMetadata.deviceKey,
        password: deviceMetadata.randomPassword,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $04399cc05aa3ed90$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: challengeParameters?.USERNAME ?? username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $650c859408628344$export$577b7d8a4f1b23fd)({
            username: deviceKey,
            userPoolName: deviceGroupKey,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        }),
        DEVICE_KEY: deviceKey
    };
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
        ClientId: userPoolClientId,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        UserContextData: UserContextData
    };
    return (0, $83cecb517fee2de6$export$b196467a22b300ec)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
}
async function $1ca9fe6154565c83$export$7f7b64167822fe34(password, challengeParameters, clientMetadata, session, authenticationHelper, config, tokenOrchestrator) {
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const serverBValue = new (0, $839faf96146888f4$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $839faf96146888f4$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const username = challengeParameters?.USER_ID_FOR_SRP;
    if (!username) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: "EmptyUserIdForSRPException",
        message: "USER_ID_FOR_SRP was not found in challengeParameters"
    });
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: username,
        password: password,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $04399cc05aa3ed90$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $650c859408628344$export$577b7d8a4f1b23fd)({
            username: username,
            userPoolName: userPoolName,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        })
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses.DEVICE_KEY = deviceMetadata.deviceKey;
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "PASSWORD_VERIFIER",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $83cecb517fee2de6$export$b196467a22b300ec)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $1ca9fe6154565c83$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $1ca9fe6154565c83$export$cf152400b58b8e65(params) {
    const { challengeName: challengeName , challengeParameters: challengeParameters  } = params;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    switch(challengeName){
        case "CUSTOM_CHALLENGE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
                    additionalInfo: challengeParameters
                }
            };
        case "MFA_SETUP":
            {
                const { signInSession: signInSession , username: username  } = (0, $f8a791ed74ba6194$export$390d5da4c63a4a41).getState();
                if (!$1ca9fe6154565c83$export$aac29c972ddf3e91(challengeParameters, "TOTP")) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                    name: (0, $7ccba6b199ab94b3$export$473ab0b56598aacd).SignInException,
                    message: `Cannot initiate MFA setup from available types: ${$1ca9fe6154565c83$export$d70c792e078766ea($1ca9fe6154565c83$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_SETUP))}`
                });
                const { Session: Session , SecretCode: secretCode  } = await (0, $83cecb517fee2de6$export$4531a27964554be8)({
                    region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(authConfig.userPoolId)
                }, {
                    Session: signInSession
                });
                (0, $f8a791ed74ba6194$export$390d5da4c63a4a41).dispatch({
                    type: "SET_SIGN_IN_SESSION",
                    value: Session
                });
                return {
                    isSignedIn: false,
                    nextStep: {
                        signInStep: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
                        totpSetupDetails: $1ca9fe6154565c83$export$b105c3e8e4f5ce91(secretCode, username)
                    }
                };
            }
        case "NEW_PASSWORD_REQUIRED":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
                    missingAttributes: $1ca9fe6154565c83$export$fbe550151e406473(challengeParameters.requiredAttributes)
                }
            };
        case "SELECT_MFA_TYPE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
                    allowedMFATypes: $1ca9fe6154565c83$export$d70c792e078766ea($1ca9fe6154565c83$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_CHOOSE))
                }
            };
        case "SMS_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case "SOFTWARE_TOKEN_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
                }
            };
    }
    // TODO: remove this error message for production apps
    throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $7ccba6b199ab94b3$export$473ab0b56598aacd).SignInException,
        message: "An error occurred during the sign in process. " + `${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $1ca9fe6154565c83$export$b105c3e8e4f5ce91(secretCode, username) {
    return {
        sharedSecret: secretCode,
        getSetupUri: (appName, accountName)=>{
            const totpUri = `otpauth://totp/${appName}:${accountName ?? username}?secret=${secretCode}&issuer=${appName}`;
            return new (0, $3415b1d6f221136c$export$beb82d9d9136c16e)(totpUri);
        }
    };
}
function $1ca9fe6154565c83$export$cafe99bb44d49edb(errorName) {
    if (errorName === (0, $c13b5be9426121ff$export$43ac0110dfdad33b).PasswordResetRequiredException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "RESET_PASSWORD"
        }
    };
    else if (errorName === (0, $c13b5be9426121ff$export$43ac0110dfdad33b).UserNotConfirmedException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "CONFIRM_SIGN_UP"
        }
    };
}
function $1ca9fe6154565c83$export$fbe550151e406473(attributes) {
    if (!attributes) return [];
    const parsedAttributes = JSON.parse(attributes).map((att)=>att.includes($1ca9fe6154565c83$var$USER_ATTRIBUTES) ? att.replace($1ca9fe6154565c83$var$USER_ATTRIBUTES, "") : att);
    return parsedAttributes;
}
function $1ca9fe6154565c83$export$c7c9603a6b1fd815(attributes) {
    if (!attributes) return {};
    const newAttributes = {};
    Object.entries(attributes).forEach(([key, value])=>{
        if (value) newAttributes[`${$1ca9fe6154565c83$var$USER_ATTRIBUTES}${key}`] = value;
    });
    return newAttributes;
}
async function $1ca9fe6154565c83$export$cfd8b50d0f78e4fa(username, challengeName, session, challengeResponse, config, tokenOrchestrator, clientMetadata, options) {
    const userAttributes = options?.userAttributes;
    const deviceName = options?.friendlyDeviceName;
    switch(challengeName){
        case "SMS_MFA":
            return $1ca9fe6154565c83$export$3eab958abdf5e22d({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "SELECT_MFA_TYPE":
            return $1ca9fe6154565c83$export$f0699fc2b71f49c0({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "MFA_SETUP":
            return $1ca9fe6154565c83$export$9b78cd405a35bccd({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                deviceName: deviceName,
                config: config
            });
        case "NEW_PASSWORD_REQUIRED":
            return $1ca9fe6154565c83$export$df3f8a8c68da6a2e({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                requiredAttributes: userAttributes,
                config: config
            });
        case "CUSTOM_CHALLENGE":
            return $1ca9fe6154565c83$export$30f932fe98713ccc($1ca9fe6154565c83$export$6fe6331471b54d26, [
                {
                    challengeResponse: challengeResponse,
                    clientMetadata: clientMetadata,
                    session: session,
                    username: username,
                    config: config,
                    tokenOrchestrator: tokenOrchestrator
                }
            ], username, tokenOrchestrator);
        case "SOFTWARE_TOKEN_MFA":
            return $1ca9fe6154565c83$export$b89ff5a8f5e11286({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
    }
    // TODO: remove this error message for production apps
    throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $7ccba6b199ab94b3$export$473ab0b56598aacd).SignInException,
        message: `An error occurred during the sign in process. 
		${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $1ca9fe6154565c83$export$7e7902092e38fcff(mfa) {
    let mfaType = "SMS_MFA";
    if (mfa === "TOTP") mfaType = "SOFTWARE_TOKEN_MFA";
    return mfaType;
}
function $1ca9fe6154565c83$export$6ce04ce89055b1fe(type) {
    if (type === "SMS_MFA") return "SMS";
    if (type === "SOFTWARE_TOKEN_MFA") return "TOTP";
// TODO: log warning for unknown MFA type
}
function $1ca9fe6154565c83$export$d70c792e078766ea(types) {
    if (!types) return undefined;
    return types.map($1ca9fe6154565c83$export$6ce04ce89055b1fe).filter(Boolean);
}
function $1ca9fe6154565c83$export$4055ded9e78438ba(mfa) {
    if (!mfa) return [];
    return JSON.parse(mfa);
}
function $1ca9fe6154565c83$export$aac29c972ddf3e91(challengeParams, mfaType) {
    const { MFAS_CAN_SETUP: MFAS_CAN_SETUP  } = challengeParams;
    const mfaTypes = $1ca9fe6154565c83$export$d70c792e078766ea($1ca9fe6154565c83$export$4055ded9e78438ba(MFAS_CAN_SETUP));
    if (!mfaTypes) return false;
    return mfaTypes.includes(mfaType);
}
async function $1ca9fe6154565c83$export$8061cd07f982ef08() {
    let authUser;
    try {
        authUser = await (0, $06d09becd613c1b3$export$e5432d4c8eb97ea7)();
    } catch (error) {}
    if (authUser && authUser.userId && authUser.username) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $d78d124ef376faa5$export$bdd0e7e9babcd5c8),
        message: "There is already a signed in user.",
        recoverySuggestion: "Call signOut before calling signIn again."
    });
}
/**
 * This function is used to kick off the device management flow.
 *
 * If an error is thrown while generating a hash device or calling the `ConfirmDevice`
 * client, then this API will ignore the error and return undefined. Otherwise the authentication
 * flow will not complete and the user won't be able to be signed in.
 *
 * @returns DeviceMetadata | undefined
 */ async function $1ca9fe6154565c83$export$5fd317fac33d34b1(userPoolId, newDeviceMetadata, accessToken) {
    if (!newDeviceMetadata) return undefined;
    const userPoolName = userPoolId.split("_")[1] || "";
    const authenticationHelper = await (0, $4b165f329812d8bd$export$47560e2dc89f678c)(userPoolName);
    const deviceKey = newDeviceMetadata?.DeviceKey;
    const deviceGroupKey = newDeviceMetadata?.DeviceGroupKey;
    try {
        await authenticationHelper.generateHashDevice(deviceGroupKey ?? "", deviceKey ?? "");
    } catch (errGenHash) {
        // TODO: log error here
        return undefined;
    }
    const deviceSecretVerifierConfig = {
        Salt: (0, $0f87662804872ba2$export$695b149896bd3e2a).convert((0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)(authenticationHelper.getSaltToHashDevices())),
        PasswordVerifier: (0, $0f87662804872ba2$export$695b149896bd3e2a).convert((0, $d9c2f17b8749cd84$export$b772e43c3daf2e7a)(authenticationHelper.getVerifierDevices()))
    };
    const randomPassword = authenticationHelper.getRandomPassword();
    try {
        await (0, $83cecb517fee2de6$export$3a7ad63dc35b752f)({
            region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId)
        }, {
            AccessToken: accessToken,
            DeviceName: await (0, $6751c708615ca735$export$98f0aedb14d75123)(),
            DeviceKey: newDeviceMetadata?.DeviceKey,
            DeviceSecretVerifierConfig: deviceSecretVerifierConfig
        });
        return {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        };
    } catch (error) {
        // TODO: log error here
        return undefined;
    }
}
/**
 * It will retry the function if the error is a `ResourceNotFoundException` and
 * will clean the device keys stored in the storage mechanism.
 *
 */ async function $1ca9fe6154565c83$export$30f932fe98713ccc(func, args, username, tokenOrchestrator) {
    try {
        return await func(...args);
    } catch (error) {
        if (error instanceof (0, $68efb77f62f1efb5$export$145273558d58e0ac) && error.name === "ResourceNotFoundException" && error.message.includes("Device does not exist.")) {
            await tokenOrchestrator.clearDeviceMetadata(username);
            return func(...args);
        }
        throw error;
    }
}
function $1ca9fe6154565c83$export$fecfbc200868d412(username) {
    const { dispatch: dispatch  } = (0, $f8a791ed74ba6194$export$390d5da4c63a4a41);
    dispatch({
        type: "SET_USERNAME",
        value: username
    });
}
function $1ca9fe6154565c83$export$cc3585de146a51be(username) {
    const state = (0, $f8a791ed74ba6194$export$390d5da4c63a4a41).getState();
    return state.username ?? username;
}











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $f111a020d487e86b$export$729df6fdd19b8b0d(AuthenticationResult) {
    if (AuthenticationResult.AccessToken) {
        const accessToken = (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(AuthenticationResult.AccessToken);
        const accessTokenIssuedAtInMillis = (accessToken.payload.iat || 0) * 1000;
        const currentTime = new Date().getTime();
        const clockDrift = accessTokenIssuedAtInMillis > 0 ? accessTokenIssuedAtInMillis - currentTime : 0;
        let idToken;
        let refreshToken;
        let deviceMetadata;
        if (AuthenticationResult.RefreshToken) refreshToken = AuthenticationResult.RefreshToken;
        if (AuthenticationResult.IdToken) idToken = (0, $d0b404dc65adc192$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken);
        if (AuthenticationResult?.NewDeviceMetadata) deviceMetadata = AuthenticationResult.NewDeviceMetadata;
        const tokens = {
            accessToken: accessToken,
            idToken: idToken,
            refreshToken: refreshToken,
            clockDrift: clockDrift,
            deviceMetadata: deviceMetadata,
            username: AuthenticationResult.username
        };
        if (AuthenticationResult?.signInDetails) tokens.signInDetails = AuthenticationResult.signInDetails;
        await (0, $8165b6923e40c4bf$export$66561e66d62991d0).setTokens({
            tokens: tokens
        });
    } else // This would be a service error
    throw new (0, $05b2dc7abeec3af3$export$37321a6dace1881c)({
        message: "Invalid tokens",
        name: "InvalidTokens",
        recoverySuggestion: "Check Cognito UserPool settings"
    });
}











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e91f0cfaaf120c70$export$3f27bc10068ef877 = "Unable to get user session following successful sign-in.";
const $e91f0cfaaf120c70$export$4d78d2ee899572ab = async ()=>{
    try {
        (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedIn",
            data: await (0, $06d09becd613c1b3$export$e5432d4c8eb97ea7)()
        }, "Auth", (0, $c9802061728ce106$export$aadf71dd9875dd20));
    } catch (error) {
        if (error.name === (0, $d78d124ef376faa5$export$d29d1996d6b6f5e3)) throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: (0, $d78d124ef376faa5$export$606cffc85964c24b),
            message: $e91f0cfaaf120c70$export$3f27bc10068ef877,
            recoverySuggestion: "This most likely is due to auth tokens not being persisted. If you are using cookie store, please ensure cookies can be correctly set from your server."
        });
        throw error;
    }
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow without password
 *
 * @param input -  The SignInWithCustomAuthInput object
 * @returns AuthSignInResult
 * @throws service: {@link InitiateAuthException } - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws SignInWithCustomAuthOutput - Thrown when the token provider config is invalid.
 */ async function $c97fbb3fa2c54de2$export$7f948971bcf643ff(input) {
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const { username: username , password: password , options: options  } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITHOUT_SRP"
    };
    const metadata = options?.clientMetadata;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).CustomAuthSignInPassword);
    try {
        const { ChallengeName: retriedChallengeName , ChallengeParameters: retiredChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $1ca9fe6154565c83$export$30f932fe98713ccc)((0, $1ca9fe6154565c83$export$1a654dcab55e0de5), [
            username,
            metadata,
            authConfig,
            (0, $8165b6923e40c4bf$export$66561e66d62991d0)
        ], username, (0, $8165b6923e40c4bf$export$66561e66d62991d0));
        const activeUsername = (0, $1ca9fe6154565c83$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $f8a791ed74ba6194$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retriedChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            (0, $f8a791ed74ba6194$export$f3dfaa7234c98dc0)();
            await (0, $f111a020d487e86b$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $1ca9fe6154565c83$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            await (0, $e91f0cfaaf120c70$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $1ca9fe6154565c83$export$cf152400b58b8e65)({
            challengeName: retriedChallengeName,
            challengeParameters: retiredChallengeParameters
        });
    } catch (error) {
        (0, $f8a791ed74ba6194$export$f3dfaa7234c98dc0)();
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
        const result = (0, $1ca9fe6154565c83$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow with SRP
 *
 * @param input -  The SignInWithCustomSRPAuthInput object
 * @returns SignInWithCustomSRPAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito
 * service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $eea874a375b73269$export$2c0317ed1bbb0787(input) {
    const { username: username , password: password , options: options  } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITH_SRP"
    };
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName , ChallengeParameters: handledChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $1ca9fe6154565c83$export$9ce9dd351616104c)(username, password, metadata, authConfig, (0, $8165b6923e40c4bf$export$66561e66d62991d0));
        const activeUsername = (0, $1ca9fe6154565c83$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $f8a791ed74ba6194$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f111a020d487e86b$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $1ca9fe6154565c83$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $f8a791ed74ba6194$export$f3dfaa7234c98dc0)();
            await (0, $e91f0cfaaf120c70$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $1ca9fe6154565c83$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $f8a791ed74ba6194$export$f3dfaa7234c98dc0)();
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
        const result = (0, $1ca9fe6154565c83$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input - The SignInWithSRPInput object
 * @returns SignInWithSRPOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $23eafbcadeebb6d2$export$728178cf826a5ab9(input) {
    const { username: username , password: password  } = input;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_SRP_AUTH"
    };
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const clientMetaData = input.options?.clientMetadata;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: handledChallengeName , ChallengeParameters: handledChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $1ca9fe6154565c83$export$13a3ef5ef8cac338)(username, password, clientMetaData, authConfig, (0, $8165b6923e40c4bf$export$66561e66d62991d0));
        const activeUsername = (0, $1ca9fe6154565c83$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $f8a791ed74ba6194$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: handledChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            (0, $f8a791ed74ba6194$export$f3dfaa7234c98dc0)();
            await (0, $f111a020d487e86b$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $1ca9fe6154565c83$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            await (0, $e91f0cfaaf120c70$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $1ca9fe6154565c83$export$cf152400b58b8e65)({
            challengeName: handledChallengeName,
            challengeParameters: handledChallengeParameters
        });
    } catch (error) {
        (0, $f8a791ed74ba6194$export$f3dfaa7234c98dc0)();
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
        const result = (0, $1ca9fe6154565c83$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using USER_PASSWORD_AUTH AuthFlowType
 *
 * @param input - The SignInWithUserPasswordInput object
 * @returns SignInWithUserPasswordOutput
 * @throws service: {@link InitiateAuthException } - Cognito service error thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $dd2292507d1980a8$export$200af5a623414b2b(input) {
    const { username: username , password: password , options: options  } = input;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_PASSWORD_AUTH"
    };
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: retiredChallengeName , ChallengeParameters: retriedChallengeParameters , AuthenticationResult: AuthenticationResult , Session: Session  } = await (0, $1ca9fe6154565c83$export$30f932fe98713ccc)((0, $1ca9fe6154565c83$export$29fb48d356e16a7), [
            username,
            password,
            metadata,
            authConfig,
            (0, $8165b6923e40c4bf$export$66561e66d62991d0)
        ], username, (0, $8165b6923e40c4bf$export$66561e66d62991d0));
        const activeUsername = (0, $1ca9fe6154565c83$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $f8a791ed74ba6194$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: retiredChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $f111a020d487e86b$export$729df6fdd19b8b0d)({
                ...AuthenticationResult,
                username: activeUsername,
                NewDeviceMetadata: await (0, $1ca9fe6154565c83$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $f8a791ed74ba6194$export$f3dfaa7234c98dc0)();
            await (0, $e91f0cfaaf120c70$export$4d78d2ee899572ab)();
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $1ca9fe6154565c83$export$cf152400b58b8e65)({
            challengeName: retiredChallengeName,
            challengeParameters: retriedChallengeParameters
        });
    } catch (error) {
        (0, $f8a791ed74ba6194$export$f3dfaa7234c98dc0)();
        (0, $609100932f10eceb$export$5b3890f50cd4853f)(error);
        const result = (0, $1ca9fe6154565c83$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input -  The SignInInput object
 * @returns SignInOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException }
 *  - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $2cb9c637e17f5e83$export$9670d83f11d4b64a(input) {
    const authFlowType = input.options?.authFlowType;
    await (0, $1ca9fe6154565c83$export$8061cd07f982ef08)();
    switch(authFlowType){
        case "USER_SRP_AUTH":
            return (0, $23eafbcadeebb6d2$export$728178cf826a5ab9)(input);
        case "USER_PASSWORD_AUTH":
            return (0, $dd2292507d1980a8$export$200af5a623414b2b)(input);
        case "CUSTOM_WITHOUT_SRP":
            return (0, $c97fbb3fa2c54de2$export$7f948971bcf643ff)(input);
        case "CUSTOM_WITH_SRP":
            return (0, $eea874a375b73269$export$2c0317ed1bbb0787)(input);
        default:
            return (0, $23eafbcadeebb6d2$export$728178cf826a5ab9)(input);
    }
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $84ab96e5fb6bfc37$var$initialAutoSignIn = async ()=>{
    throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
        name: (0, $d78d124ef376faa5$export$fe46a12932d2550a),
        message: "The autoSignIn flow has not started, or has been cancelled/completed.",
        recoverySuggestion: "Please try to use the signIn API or log out before starting a new autoSignIn flow."
    });
};
/**
 * Signs a user in automatically after finishing the sign-up process.
 *
 * This API will automatically sign a user in if the autoSignIn flow has been completed in the following cases:
 * - User confirmed their account with a verification code sent to their phone or email (default option).
 * - User confirmed their account with a verification link sent to their phone or email. In order to
 * enable this option you need to go to the Amazon Cognito [console](https://aws.amazon.com/pm/cognito),
 * look for your userpool, then go to the `Messaging` tab and enable `link` mode inside the `Verification message` option.
 * Finally you need to define the `signUpVerificationMethod` in your `Auth` config.
 *
 * @example
 * ```typescript
 *  Amplify.configure({
 *    Auth: {
 *     Cognito: {
 *    ...cognitoConfig,
 *    signUpVerificationMethod: "link" // the default value is "code"
 *   }
 *	}});
 * ```
 *
 * @throws AutoSignInException - Thrown when the autoSignIn flow has not started, or has been cancelled/completed.
 * @returns The signInOutput.
 *
 * @example
 * ```typescript
 *  // handleSignUp.ts
 * async function handleSignUp(
 *   username:string,
 *   password:string
 * ){
 *   try {
 *     const { nextStep } = await signUp({
 *       username,
 *       password,
 *       options: {
 *         userAttributes:{ email:'email@email.com'},
 *         autoSignIn: true // This enables the auto sign-in flow.
 *       },
 *     });
 *
 *     handleSignUpStep(nextStep);
 *
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // handleConfirmSignUp.ts
 * async function handleConfirmSignUp(username:string, confirmationCode:string) {
 *   try {
 *     const { nextStep } = await confirmSignUp({
 *       username,
 *       confirmationCode,
 *     });
 *
 *     handleSignUpStep(nextStep);
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // signUpUtils.ts
 * async function handleSignUpStep( step: SignUpOutput["nextStep"]) {
 * switch (step.signUpStep) {
 *   case "CONFIRM_SIGN_UP":
 *
 *    // Redirect end-user to confirm-sign up screen.
 *
 *   case "COMPLETE_AUTO_SIGN_IN":
 *	   const codeDeliveryDetails = step.codeDeliveryDetails;
 *     if (codeDeliveryDetails) {
 *      // Redirect user to confirm-sign-up with link screen.
 *     }
 *     const signInOutput = await autoSignIn();
 *   // handle sign-in steps
 * }
 *
 * ```
 */ // TODO(Eslint): can this be refactored not using `let` on exported member?
// eslint-disable-next-line import/no-mutable-exports
let $84ab96e5fb6bfc37$export$c5378dc7d6787fa5 = $84ab96e5fb6bfc37$var$initialAutoSignIn;
/**
 * Sets the context of autoSignIn at run time.
 * @internal
 */ function $84ab96e5fb6bfc37$export$7dcbf67a23c27835(callback) {
    $84ab96e5fb6bfc37$export$c5378dc7d6787fa5 = callback;
}
/**
 * Resets the context
 *
 * @internal
 */ function $84ab96e5fb6bfc37$export$1ffa2742ce5c589b() {
    $84ab96e5fb6bfc37$export$c5378dc7d6787fa5 = $84ab96e5fb6bfc37$var$initialAutoSignIn;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e92a233c003b80cf$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
function $e92a233c003b80cf$export$385d6b43f72ecccf(signInInput) {
    const stopHubListener = (0, $c9802061728ce106$export$45dde0743a4c8d6e).listen("auth-internal", async ({ payload: payload  })=>{
        switch(payload.event){
            case "confirmSignUp":
                {
                    const response = payload.data;
                    if (response?.isSignUpComplete) {
                        (0, $c9802061728ce106$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                            event: "autoSignIn"
                        });
                        (0, $84ab96e5fb6bfc37$export$7dcbf67a23c27835)($e92a233c003b80cf$var$autoSignInWithCode(signInInput));
                        stopHubListener();
                    }
                }
        }
    });
    // This will stop the listener if confirmSignUp is not resolved.
    const timeOutId = setTimeout(()=>{
        stopHubListener();
        $e92a233c003b80cf$export$be9e824afabf429b(false);
        clearTimeout(timeOutId);
        (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
    }, $e92a233c003b80cf$var$MAX_AUTOSIGNIN_POLLING_MS);
}
function $e92a233c003b80cf$var$debounce(fun, delay) {
    let timer;
    return (args)=>{
        if (!timer) fun(...args);
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = undefined;
        }, delay);
    };
}
function $e92a233c003b80cf$var$handleAutoSignInWithLink(signInInput, resolve, reject) {
    const start = Date.now();
    const autoSignInPollingIntervalId = setInterval(async ()=>{
        const elapsedTime = Date.now() - start;
        const maxTime = $e92a233c003b80cf$var$MAX_AUTOSIGNIN_POLLING_MS;
        if (elapsedTime > maxTime) {
            clearInterval(autoSignInPollingIntervalId);
            $e92a233c003b80cf$export$be9e824afabf429b(false);
            reject(new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
                name: (0, $d78d124ef376faa5$export$fe46a12932d2550a),
                message: "The account was not confirmed on time.",
                recoverySuggestion: "Try to verify your account by clicking the link sent your email or phone and then login manually."
            }));
            (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
        } else try {
            const signInOutput = await (0, $2cb9c637e17f5e83$export$9670d83f11d4b64a)(signInInput);
            if (signInOutput.nextStep.signInStep !== "CONFIRM_SIGN_UP") {
                resolve(signInOutput);
                clearInterval(autoSignInPollingIntervalId);
                $e92a233c003b80cf$export$be9e824afabf429b(false);
                (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
            }
        } catch (error) {
            clearInterval(autoSignInPollingIntervalId);
            $e92a233c003b80cf$export$be9e824afabf429b(false);
            reject(error);
            (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
        }
    }, 5000);
}
const $e92a233c003b80cf$var$debouncedAutoSignInWithLink = $e92a233c003b80cf$var$debounce($e92a233c003b80cf$var$handleAutoSignInWithLink, 300);
const $e92a233c003b80cf$var$debouncedAutoSignWithCodeOrUserConfirmed = $e92a233c003b80cf$var$debounce($e92a233c003b80cf$var$handleAutoSignInWithCodeOrUserConfirmed, 300);
let $e92a233c003b80cf$var$autoSignInStarted = false;
let $e92a233c003b80cf$var$usernameUsedForAutoSignIn;
function $e92a233c003b80cf$export$9542ecebf2267645(username) {
    $e92a233c003b80cf$var$usernameUsedForAutoSignIn = username;
}
function $e92a233c003b80cf$export$2eb7cf6e92e4b85f(username) {
    return $e92a233c003b80cf$var$usernameUsedForAutoSignIn === username;
}
function $e92a233c003b80cf$export$ae4fc21c931f7784() {
    return $e92a233c003b80cf$var$autoSignInStarted;
}
function $e92a233c003b80cf$export$be9e824afabf429b(value) {
    if (value === false) $e92a233c003b80cf$export$9542ecebf2267645(undefined);
    $e92a233c003b80cf$var$autoSignInStarted = value;
}
function $e92a233c003b80cf$export$9fd29532e325aae0(output) {
    return !!output.UserConfirmed;
}
function $e92a233c003b80cf$export$feaed4858b71e8a(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $e92a233c003b80cf$var$debouncedAutoSignInWithLink([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
async function $e92a233c003b80cf$var$handleAutoSignInWithCodeOrUserConfirmed(signInInput, resolve, reject) {
    try {
        const output = await (0, $2cb9c637e17f5e83$export$9670d83f11d4b64a)(signInInput);
        resolve(output);
        (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
    } catch (error) {
        reject(error);
        (0, $84ab96e5fb6bfc37$export$1ffa2742ce5c589b)();
    }
}
function $e92a233c003b80cf$var$autoSignInWithCode(signInInput) {
    return async ()=>{
        return new Promise((resolve, reject)=>{
            $e92a233c003b80cf$var$debouncedAutoSignWithCodeOrUserConfirmed([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
const $e92a233c003b80cf$export$9ec2c3d010185172 = $e92a233c003b80cf$var$autoSignInWithCode;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a new user account.
 *
 * @param input -  The ConfirmSignUpInput object.
 * @returns ConfirmSignUpOutput
 * @throws -{@link ConfirmSignUpException }
 * Thrown due to an invalid confirmation code.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $e8e960606449d760$export$2ce39ab6662e8c24(input) {
    const { username: username , confirmationCode: confirmationCode , options: options  } = input;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = authConfig;
    const clientMetadata = options?.clientMetadata;
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!confirmationCode, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptyConfirmSignUpCode);
    const UserContextData = (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    await (0, $83cecb517fee2de6$export$2ce39ab6662e8c24)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).ConfirmSignUp)
    }, {
        Username: username,
        ConfirmationCode: confirmationCode,
        ClientMetadata: clientMetadata,
        ForceAliasCreation: options?.forceAliasCreation,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    return new Promise((resolve, reject)=>{
        try {
            const signUpOut = {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: "DONE"
                }
            };
            if (!(0, $e92a233c003b80cf$export$ae4fc21c931f7784)() || !(0, $e92a233c003b80cf$export$2eb7cf6e92e4b85f)(username)) {
                resolve(signUpOut);
                return;
            }
            const stopListener = (0, $c9802061728ce106$export$45dde0743a4c8d6e).listen("auth-internal", ({ payload: payload  })=>{
                switch(payload.event){
                    case "autoSignIn":
                        resolve({
                            isSignUpComplete: true,
                            nextStep: {
                                signUpStep: "COMPLETE_AUTO_SIGN_IN"
                            }
                        });
                        (0, $e92a233c003b80cf$export$be9e824afabf429b)(false);
                        stopListener();
                }
            });
            (0, $c9802061728ce106$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                event: "confirmSignUp",
                data: signUpOut
            });
        } catch (error) {
            reject(error);
        }
    });
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $6a3d0165c96d8b3d$export$39430dfe49142ae = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $56b943a689c803eb$export$39430dfe49142ae = (options)=>{
    return (0, $6a3d0165c96d8b3d$export$39430dfe49142ae)((0, $d9009b35813b573c$export$a3858a9a153cffc7), options);
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Transforms a user attributes object into an array of AttributeType objects.
 * @param attributes user attributes to be mapped to AttributeType objects.
 * @returns an array of AttributeType objects.
 */ function $26de5e277ff0a29a$export$720a7caa078a04b0(attributes) {
    return Object.entries(attributes).map(([key, value])=>({
            Name: key,
            Value: value
        }));
}
/**
 * Transforms an array of AttributeType objects into a user attributes object.
 *
 * @param attributes - an array of AttributeType objects.
 * @returns AuthUserAttributes object.
 */ function $26de5e277ff0a29a$export$1b975641d03f3b17(attributes) {
    const userAttributes = {};
    attributes?.forEach((attribute)=>{
        if (attribute.Name) userAttributes[attribute.Name] = attribute.Value;
    });
    return userAttributes;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9f6fe7a2e637c67f$export$5dc95ecf3f16c6c9 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    const { tokens: tokens  } = await (0, $6a3d0165c96d8b3d$export$39430dfe49142ae)(amplify, {
        forceRefresh: false
    });
    (0, $45fe96cf99d947f4$export$77712ea5882cac9f)(tokens);
    const { UserAttributes: UserAttributes  } = await (0, $83cecb517fee2de6$export$7cbf767827cd68ba)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).FetchUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    return (0, $26de5e277ff0a29a$export$1b975641d03f3b17)(UserAttributes);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetches the current user attributes while authenticated.
 *
 * @throws - {@link GetUserException} - Cognito service errors thrown when the service is not able to get the user.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $d5dec7a857031cfa$export$5dc95ecf3f16c6c9 = ()=>{
    return (0, $9f6fe7a2e637c67f$export$5dc95ecf3f16c6c9)((0, $d9009b35813b573c$export$a3858a9a153cffc7));
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $761398897f4408f5$export$d1b63878dfcc70a6() {
    return (0, $d9009b35813b573c$export$a3858a9a153cffc7).Auth.clearCredentials();
}



















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3921b3ba76f9552f$export$f8a4fedaab76b065 = async (store)=>{
    await store.clearOAuthData();
    (0, $8165b6923e40c4bf$export$66561e66d62991d0).clearTokens();
    await (0, $761398897f4408f5$export$d1b63878dfcc70a6)();
    (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signedOut"
    }, "Auth", (0, $c9802061728ce106$export$aadf71dd9875dd20));
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $a955d12a9fd50322$export$a673d54799039714 = async (url)=>{
    if (!window?.location) return;
    // enforce HTTPS
    window.location.href = url.replace("http://", "https://");
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @internal */ function $1f553bf159d1f595$export$93832c3affb240d3(redirects) {
    const redirectUrlFromTheSameOrigin = redirects?.find($1f553bf159d1f595$var$isSameOriginAndPathName) ?? redirects?.find($1f553bf159d1f595$var$isTheSameDomain);
    const redirectUrlFromDifferentOrigin = redirects?.find($1f553bf159d1f595$var$isHttps) ?? redirects?.find($1f553bf159d1f595$var$isHttp);
    if (redirectUrlFromTheSameOrigin) return redirectUrlFromTheSameOrigin;
    else if (redirectUrlFromDifferentOrigin) throw 0, $d78d124ef376faa5$export$c01b4acd6291e035;
    throw 0, $d78d124ef376faa5$export$60b68b138a52e5ae;
}
// origin + pathname => https://example.com/app
const $1f553bf159d1f595$var$isSameOriginAndPathName = (redirect)=>redirect.startsWith(String((window.location.origin + window.location.pathname) ?? "/"));
// domain => outlook.live.com, github.com
const $1f553bf159d1f595$var$isTheSameDomain = (redirect)=>redirect.includes(String(window.location.hostname));
const $1f553bf159d1f595$var$isHttp = (redirect)=>redirect.startsWith("http://");
const $1f553bf159d1f595$var$isHttps = (redirect)=>redirect.startsWith("https://");


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2c9d40c3a431c601$export$a20426d3d43ad21f = async (authConfig, preferPrivateSession = false)=>{
    (0, $d0b404dc65adc192$export$c13e6dbaf90a8e5f)(authConfig);
    const { loginWith: loginWith , userPoolClientId: userPoolClientId  } = authConfig;
    const { domain: domain , redirectSignOut: redirectSignOut  } = loginWith.oauth;
    const signoutUri = (0, $1f553bf159d1f595$export$93832c3affb240d3)(redirectSignOut);
    const oAuthLogoutEndpoint = `https://${domain}/logout?${Object.entries({
        client_id: userPoolClientId,
        logout_uri: encodeURIComponent(signoutUri)
    }).map(([k, v])=>`${k}=${v}`).join("&")}`;
    return (0, $a955d12a9fd50322$export$a673d54799039714)(oAuthLogoutEndpoint);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $db781626f98e890f$export$74290142c99a2f64 = async (cognitoConfig, store)=>{
    const { isOAuthSignIn: isOAuthSignIn  } = await store.loadOAuthSignIn();
    // Clear everything before attempting to visted logout endpoint since the current application
    // state could be wiped away on redirect
    await (0, $3921b3ba76f9552f$export$f8a4fedaab76b065)(store);
    if (isOAuthSignIn) // On web, this will always end up being a void action
    return (0, $2c9d40c3a431c601$export$a20426d3d43ad21f)(cognitoConfig);
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e0d56740eddbd6fc$var$logger = new (0, $cda4d9e419200573$export$ba6a9c7ac8291f7f)("Auth");
/**
 * Signs a user out
 *
 * @param input - The SignOutInput object
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $e0d56740eddbd6fc$export$b0ac3a1c242cb1ea(input) {
    const cognitoConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(cognitoConfig);
    if (input?.global) await $e0d56740eddbd6fc$var$globalSignOut(cognitoConfig);
    else await $e0d56740eddbd6fc$var$clientSignOut(cognitoConfig);
    let hasOAuthConfig;
    try {
        (0, $d0b404dc65adc192$export$c13e6dbaf90a8e5f)(cognitoConfig);
        hasOAuthConfig = true;
    } catch (err) {
        hasOAuthConfig = false;
    }
    if (hasOAuthConfig) {
        const oAuthStore = new (0, $52c2ee4fd5af8dee$export$9b2cef5d94f9b6e8)((0, $c1a7077392f3b8b2$export$586b30dcaeecb901));
        oAuthStore.setAuthConfig(cognitoConfig);
        const { type: type  } = await (0, $db781626f98e890f$export$74290142c99a2f64)(cognitoConfig, oAuthStore) ?? {};
        if (type === "error") throw new (0, $68efb77f62f1efb5$export$145273558d58e0ac)({
            name: (0, $d78d124ef376faa5$export$625255707e22459c),
            message: "An error occurred when attempting to log out from OAuth provider."
        });
    } else {
        // complete sign out
        (0, $8165b6923e40c4bf$export$66561e66d62991d0).clearTokens();
        await (0, $761398897f4408f5$export$d1b63878dfcc70a6)();
        (0, $c9802061728ce106$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedOut"
        }, "Auth", (0, $c9802061728ce106$export$aadf71dd9875dd20));
    }
}
async function $e0d56740eddbd6fc$var$clientSignOut(cognitoConfig) {
    try {
        const authTokens = await (0, $8165b6923e40c4bf$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $45fe96cf99d947f4$export$be38b2d22222d505)(authTokens);
        if ($e0d56740eddbd6fc$var$isSessionRevocable(authTokens.accessToken)) await (0, $83cecb517fee2de6$export$2428f6ba65615593)({
            region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(cognitoConfig.userPoolId),
            userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignOut)
        }, {
            ClientId: cognitoConfig.userPoolClientId,
            Token: authTokens.refreshToken
        });
    } catch (err) {
        // this shouldn't throw
        $e0d56740eddbd6fc$var$logger.debug("Client signOut error caught but will proceed with token removal");
    }
}
async function $e0d56740eddbd6fc$var$globalSignOut(cognitoConfig) {
    try {
        const authTokens = await (0, $8165b6923e40c4bf$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $45fe96cf99d947f4$export$77712ea5882cac9f)(authTokens);
        await (0, $83cecb517fee2de6$export$a92c2ab9b6303723)({
            region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(cognitoConfig.userPoolId),
            userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignOut)
        }, {
            AccessToken: authTokens.accessToken.toString()
        });
    } catch (err) {
        // it should not throw
        $e0d56740eddbd6fc$var$logger.debug("Global signOut error caught but will proceed with token removal");
    }
}
const $e0d56740eddbd6fc$var$isSessionRevocable = (token)=>!!token?.payload?.origin_jti;












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Creates a user
 *
 * @param input - The SignUpInput object
 * @returns SignUpOutput
 * @throws service: {@link SignUpException } - Cognito service errors thrown during the sign-up process.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $b163cbe6f8b04bf5$export$cf64224bcd829024(input) {
    const { username: username , password: password , options: options  } = input;
    const authConfig = (0, $d9009b35813b573c$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signUpVerificationMethod = authConfig?.signUpVerificationMethod ?? "code";
    const { clientMetadata: clientMetadata , validationData: validationData , autoSignIn: autoSignIn  } = input.options ?? {};
    (0, $d0b404dc65adc192$export$80c92581e59ed502)(authConfig);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!username, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignUpUsername);
    (0, $5dfe0da1f6ddb527$export$45936001d12f9b53)(!!password, (0, $37d361b81fa35812$export$12d5c695b2213c4a).EmptySignUpPassword);
    const signInServiceOptions = typeof autoSignIn !== "boolean" ? autoSignIn : undefined;
    const signInInput = {
        username: username,
        options: signInServiceOptions
    };
    // if the authFlowType is 'CUSTOM_WITHOUT_SRP' then we don't include the password
    if (signInServiceOptions?.authFlowType !== "CUSTOM_WITHOUT_SRP") signInInput.password = password;
    if (signInServiceOptions || autoSignIn === true) {
        (0, $e92a233c003b80cf$export$9542ecebf2267645)(username);
        (0, $e92a233c003b80cf$export$be9e824afabf429b)(true);
    }
    const { userPoolId: userPoolId , userPoolClientId: userPoolClientId  } = authConfig;
    const clientOutput = await (0, $83cecb517fee2de6$export$cf64224bcd829024)({
        region: (0, $ba04bdf708a65180$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $d85f0aaaaf37a11b$export$d6cd780379f37dae)((0, $3c92cd7927458afb$export$900b1436d7e65f4).SignUp)
    }, {
        Username: username,
        Password: password,
        UserAttributes: options?.userAttributes && (0, $26de5e277ff0a29a$export$720a7caa078a04b0)(options?.userAttributes),
        ClientMetadata: clientMetadata,
        ValidationData: validationData && (0, $26de5e277ff0a29a$export$720a7caa078a04b0)(validationData),
        ClientId: userPoolClientId,
        UserContextData: (0, $931df5209d775015$export$b6e6cdd1f90faa62)({
            username: username,
            userPoolId: userPoolId,
            userPoolClientId: userPoolClientId
        })
    });
    const { UserSub: UserSub , CodeDeliveryDetails: CodeDeliveryDetails  } = clientOutput;
    if ((0, $e92a233c003b80cf$export$9fd29532e325aae0)(clientOutput) && (0, $e92a233c003b80cf$export$ae4fc21c931f7784)()) {
        (0, $84ab96e5fb6bfc37$export$7dcbf67a23c27835)((0, $e92a233c003b80cf$export$9ec2c3d010185172)(signInInput));
        return {
            isSignUpComplete: true,
            nextStep: {
                signUpStep: "COMPLETE_AUTO_SIGN_IN"
            },
            userId: UserSub
        };
    } else if ((0, $e92a233c003b80cf$export$9fd29532e325aae0)(clientOutput) && !(0, $e92a233c003b80cf$export$ae4fc21c931f7784)()) return {
        isSignUpComplete: true,
        nextStep: {
            signUpStep: "DONE"
        },
        userId: UserSub
    };
    else if (!(0, $e92a233c003b80cf$export$9fd29532e325aae0)(clientOutput) && (0, $e92a233c003b80cf$export$ae4fc21c931f7784)() && signUpVerificationMethod === "code") (0, $e92a233c003b80cf$export$385d6b43f72ecccf)(signInInput);
    else if (!(0, $e92a233c003b80cf$export$9fd29532e325aae0)(clientOutput) && (0, $e92a233c003b80cf$export$ae4fc21c931f7784)() && signUpVerificationMethod === "link") {
        (0, $84ab96e5fb6bfc37$export$7dcbf67a23c27835)((0, $e92a233c003b80cf$export$feaed4858b71e8a)(signInInput));
        return {
            isSignUpComplete: false,
            nextStep: {
                signUpStep: "COMPLETE_AUTO_SIGN_IN",
                codeDeliveryDetails: {
                    deliveryMedium: CodeDeliveryDetails?.DeliveryMedium,
                    destination: CodeDeliveryDetails?.Destination,
                    attributeName: CodeDeliveryDetails?.AttributeName
                }
            },
            userId: UserSub
        };
    }
    return {
        isSignUpComplete: false,
        nextStep: {
            signUpStep: "CONFIRM_SIGN_UP",
            codeDeliveryDetails: {
                deliveryMedium: CodeDeliveryDetails?.DeliveryMedium,
                destination: CodeDeliveryDetails?.Destination,
                attributeName: CodeDeliveryDetails?.AttributeName
            }
        },
        userId: UserSub
    };
}


const $9bbe216c50eeb619$var$awsmobile = {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_7JcFWzzGV",
    aws_user_pools_web_client_id: "25ddqh121qq67eei4st0srkl9s",
    oauth: {},
    aws_cognito_username_attributes: [
        "EMAIL"
    ],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: [
        "EMAIL"
    ],
    aws_cognito_verification_mechanisms: [
        "EMAIL"
    ]
};
var $9bbe216c50eeb619$export$2e2bcd8739ae039 = $9bbe216c50eeb619$var$awsmobile;


// Context
// Intervals are pretty darn tricky in React; if you're not careful, you'll wind up with a "stale" interval, one which can't access current values of state or props.
// This hook allows us to sidestep that confusion, and it also gives us a superpower: we can modify the delay without having to worry about stopping and starting the interval.
// I learned about this hook from Dan in his blog post (https://overreacted.io/making-setinterval-declarative-with-react-hooks/) on the subject, and he does a fantastic job explaining what all this funkiness is and why you need it. He explains it better than I would be able to, so if you're curious how it works, read his blog post all about it!
// I did make one significant change to his version: My version of the hook returns the interval ID, similar to window.setInterval. This allows you to cancel the interval imperatively, if you need to. Note that this is an escape hatch: the primary declarative way to cancel the interval is to set the delay equal to null.
// Link to this headingUsage
// useInterval looks quite a bit like setInterval in its usage:
// JS
// useInterval(() => {
//   console.log('I fire every second!');
// }, 1000);
// Here's an example of a "Stopwatch" component. useInterval lets us track how much time has elapsed since the user has started the stopwatch.
// JSX
// const Stopwatch = () => {
//   const [status, setStatus] = React.useState('idle');
//   const [timeElapsed, setTimeElapsed] = React.useState(0);
//   useInterval(
//     () => {
//       setTimeElapsed((timeElapsed) => timeElapsed + 1);
//     },
//     status === 'running' ? 1000 : null
//   );
//   const toggle = () => {
//     setTimeElapsed(0);
//     setStatus((status) => (status === 'running' ? 'idle' : 'running'));
//   };
//   return (
//     <>
//       Time Elapsed: {timeElapsed} second(s)
//       <button onClick={toggle}>
//         {status === 'running' ? 'Stop' : 'Start'}
//       </button>
//     </>
//   );
// };

var $exYeM = parcelRequire("exYeM");
function $ea8c1bc85a530331$var$useInterval(callback, delay) {
    const intervalRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    const savedCallback = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(callback);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const tick = ()=>savedCallback.current();
        if (typeof delay === "number") {
            intervalRef.current = window.setInterval(tick, delay);
            return ()=>window.clearInterval(intervalRef.current);
        }
    }, [
        delay
    ]);
    return intervalRef;
}
var $ea8c1bc85a530331$export$2e2bcd8739ae039 = $ea8c1bc85a530331$var$useInterval;


(0, $15c60452aaf7d22d$export$11ac3725994bec7b).configure((0, $9bbe216c50eeb619$export$2e2bcd8739ae039));
const $5d80ae41f2d7c184$export$38ee920e59704589 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext();
// const ENDPOINT = process.env.REACT_APP_TASKS_API;
// const AUTH_ENDPOINT = process.env.REACT_APP_TASKS_API;
// const API_KEY = process.env.REACT_APP_API_KEY;
function $5d80ae41f2d7c184$var$UserProvider({ children: children  }) {
    const [isAuthenticated, setIsAuthenticated] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [authUpdated, setAuthUpdated] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const [token, setToken] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [isAuthModalOpen, setIsAuthModalOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [infiniteScrollToken, setInfiniteScrollToken] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [stats, setStats] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const fetchToken = async ()=>{
        try {
            const { tokens: tokens  } = await (0, $56b943a689c803eb$export$39430dfe49142ae)({
                forceRefresh: true
            });
            const idToken = tokens.idToken.toString();
            setToken(idToken);
        } catch (err) {
            setIsAuthenticated(false);
        }
    };
    (0, $ea8c1bc85a530331$export$2e2bcd8739ae039)(fetchToken, isAuthenticated ? 3600000 : null);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === "visible") fetchToken().catch(()=>{
                window.alert("fetchToken failed");
            });
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return ()=>{
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const getUserData = async ()=>{
            try {
                const { username: username , userId: userId , signInDetails: signInDetails  } = await (0, $06d09becd613c1b3$export$e5432d4c8eb97ea7)();
                const userAttributes = await (0, $d5dec7a857031cfa$export$5dc95ecf3f16c6c9)();
                setIsAuthenticated(true);
                const { tokens: tokens  } = await (0, $56b943a689c803eb$export$39430dfe49142ae)({
                    forceRefresh: true
                });
                const idToken = tokens.idToken.toString();
                setToken(idToken);
            } catch (err) {
                setIsAuthenticated(false);
            }
        };
        getUserData();
    }, [
        authUpdated
    ]);
    // const deleteQuery = async (queryId) => {
    //   const oldQuery = userQueries.filter((query) => {
    //     return query.MATRIX_SHAREID.S === queryId;
    //   })[0];
    //   const oldUlid = oldQuery.MATRIX_ULID.S;
    //   setUserQueries((oldValue) => {
    //     return oldValue.filter((query) => {
    //       return query.MATRIX_SHAREID.S !== queryId;
    //     });
    //   });
    //   const URL = AUTH_ENDPOINT + `query?id=${queryId}&ulid=${oldUlid}`;
    //   const HEADERS = {
    //     'Content-Type': 'application/json',
    //     Authorization: token,
    //   };
    //   const request = new Request(URL, {
    //     method: 'DELETE',
    //     headers: HEADERS,
    //     timeout: 100000,
    //   });
    //   const response = await fetch(request);
    //   const json = await response.json();
    // };
    // const deleteSequence = async (sequenceId) => {
    //   const oldSequence = userSequences.filter((sequence) => {
    //     return sequence.id === sequenceId;
    //   })[0];
    //   const sequenceTitle = oldSequence.name;
    //   const payload = { title: sequenceTitle };
    //   const URL = AUTH_ENDPOINT + `sequence`;
    //   const HEADERS = {
    //     'Content-Type': 'application/json',
    //     Authorization: token,
    //   };
    //   const request = new Request(URL, {
    //     method: 'DELETE',
    //     headers: HEADERS,
    //     body: JSON.stringify(payload),
    //     timeout: 100000,
    //   });
    //   const response = await fetch(request);
    //   const json = await response.json();
    // };
    const handleLogout = async ()=>{
        try {
            await (0, $e0d56740eddbd6fc$export$b0ac3a1c242cb1ea)();
            setIsAuthenticated(false);
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (err) {}
    };
    const handleLogin = async (email, password)=>{
        try {
            const input = {
                username: email,
                password: password
            };
            const response = await (0, $2cb9c637e17f5e83$export$9670d83f11d4b64a)(input);
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (err) {}
    };
    const handleSignUp = async (email, password)=>{
        try {
            const input = {
                username: email,
                password: password,
                options: {
                    userAttributes: {
                        email: email
                    }
                }
            };
            const signUpResponse = await (0, $b163cbe6f8b04bf5$export$cf64224bcd829024)(input);
        } catch (err) {}
    };
    const handleConfirmSignUp = async (email, code)=>{
        try {
            const { isSignUpComplete: isSignUpComplete , nextStep: nextStep  } = await (0, $e8e960606449d760$export$2ce39ab6662e8c24)({
                username: email,
                confirmationCode: code
            });
            setAuthUpdated((oldValue)=>oldValue + 1);
        } catch (error) {}
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($5d80ae41f2d7c184$export$38ee920e59704589.Provider, {
        value: {
            isAuthenticated: isAuthenticated,
            setIsAuthenticated: setIsAuthenticated,
            handleLogout: handleLogout,
            handleLogin: handleLogin,
            handleSignUp: handleSignUp,
            handleConfirmSignUp: handleConfirmSignUp,
            isAuthModalOpen: isAuthModalOpen,
            setIsAuthModalOpen: setIsAuthModalOpen,
            token: token,
            stats: stats
        },
        children: children
    });
}
var $5d80ae41f2d7c184$export$2e2bcd8739ae039 = $5d80ae41f2d7c184$var$UserProvider;




const $b0893505d0f7ae16$export$58d75f9829cbe158 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext();
const $b0893505d0f7ae16$var$AUTH_ENDPOINT = "https://mn28cogtk2.execute-api.us-east-1.amazonaws.com/dev/";
function $b0893505d0f7ae16$var$DataProvider({ children: children  }) {
    const [tasks, setTasks] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState({
        tasks: {},
        columns: {
            "column-1": {
                id: "column-1",
                title: "All",
                taskIds: []
            }
        },
        columnOrder: [
            "column-1"
        ]
    });
    const [subTasks, setSubTasks] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [projectsList, setProjectsList] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [projects, setProjects] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([
        "DEFAULT"
    ]);
    const [projectTasksWereRequested, setProjectTasksWereRequested] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(true);
    const [projectTasksWereFetched, setProjectTasksWereFetched] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [projectsListWasRequested, setProjectsListWasRequested] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(true);
    const [projectsListWasFetched, setProjectsListWasFetched] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const { token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const getProjectTitleFromTaskId = (taskId)=>{
        for(const columnId in tasks.columns){
            if (tasks.columns[columnId].taskIds.includes(taskId)) return tasks.columns[columnId].title;
        }
        return null;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        async function getProjectTasks() {
            const URL = $b0893505d0f7ae16$var$AUTH_ENDPOINT + `task?projects=${projects.join(",")}`;
            const HEADERS = {
                "Content-Type": "application/json",
                Authorization: token
            };
            const request = new Request(URL, {
                method: "GET",
                headers: HEADERS,
                timeout: 100000
            });
            try {
                const response = await fetch(request);
                const json = await response.json();
                const tasksByProject = json["TASKS_BY_PROJECT"];
                const rawSubTasks = json["SUBTASKS"];
                const retrievedSubTasks = rawSubTasks.reduce((acc, subtask)=>{
                    const subtaskId = subtask.SK1.replace("SUBTASK#", "");
                    acc[subtaskId] = {
                        id: subtaskId,
                        taskId: subtask.TASK,
                        status: subtask.STATUS,
                        content: subtask.SUBTASK
                    };
                    return acc;
                }, {});
                const processed = {};
                const columns = {};
                const columnOrder = [];
                const columnsList = [];
                Object.keys(tasksByProject).forEach((project, index)=>{
                    columnsList.push(project);
                    const ids = tasksByProject[project].map((task)=>{
                        processed[task.ID] = {
                            id: task.ID,
                            project: project,
                            content: task.TASK,
                            status: task.STATUS,
                            ...task.DEADLINE && {
                                deadline: task.DEADLINE
                            },
                            ...task.DEST_SK1 && {
                                dest_sk1: task.DEST_SK1
                            },
                            ...task.HABIT_RATING && {
                                habit_rating: task.HABIT_RATING
                            },
                            subtasks: JSON.parse(task.SUBTASKS)
                        };
                        return task.ID;
                    });
                    const columnId = `column-${index + 1}`;
                    columns[columnId] = {
                        id: columnId,
                        title: project,
                        taskIds: ids
                    };
                    columnOrder.push(columnId);
                });
                const data = {
                    tasks: processed,
                    columns: columns,
                    columnOrder: columnOrder
                };
                setTasks((oldData)=>data);
                setSubTasks((oldData)=>retrievedSubTasks);
                setProjects(columnsList);
                return tasksByProject;
            } catch (error) {
                console.error("Error fetching project tasks:", error);
            }
        }
        if (projectTasksWereRequested && !projectTasksWereFetched && token) {
            getProjectTasks();
            setProjectTasksWereRequested(false);
            setProjectTasksWereFetched(true);
        }
    }, [
        projectTasksWereRequested,
        projectTasksWereFetched,
        projects,
        token
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        async function getProjects() {
            const URL = $b0893505d0f7ae16$var$AUTH_ENDPOINT + `project`;
            const HEADERS = {
                "Content-Type": "application/json",
                Authorization: token
            };
            const request = new Request(URL, {
                method: "GET",
                headers: HEADERS,
                timeout: 100000
            });
            const response = await fetch(request);
            const json = await response.json();
            setProjectsList((oldData)=>json);
            return json;
        }
        if (projectsListWasRequested && !projectsListWasFetched && token) {
            getProjects();
            setProjectsListWasRequested(false);
            setProjectsListWasFetched(true);
        }
    }, [
        projectsListWasRequested,
        projectsListWasFetched,
        token
    ]);
    function fetchTasks() {
        setProjectTasksWereRequested(true);
        setProjectTasksWereFetched(false);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        fetchTasks();
    }, [
        token
    ]);
    const deleteTask = async (id)=>{
        const project = getProjectTitleFromTaskId(id);
        const URL = $b0893505d0f7ae16$var$AUTH_ENDPOINT + `task?project=${project}&id=${id}`;
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const request = new Request(URL, {
            method: "DELETE",
            headers: HEADERS,
            timeout: 100000
        });
        const result = fetch(request);
    };
    const deleteSubTask = async (id, taskId)=>{
        const URL = $b0893505d0f7ae16$var$AUTH_ENDPOINT + `subtask?id=${id}&task=${taskId}`;
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const request = new Request(URL, {
            method: "DELETE",
            headers: HEADERS,
            timeout: 100000
        });
        const result = fetch(request);
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($b0893505d0f7ae16$export$58d75f9829cbe158.Provider, {
        value: {
            tasks: tasks,
            projects: projects,
            setTasks: setTasks,
            setProjects: setProjects,
            fetchTasks: fetchTasks,
            deleteTask: deleteTask,
            deleteSubTask: deleteSubTask,
            projectsList: projectsList,
            setProjectsList: setProjectsList,
            setProjectTasksWereRequested: setProjectTasksWereRequested,
            setProjectTasksWereFetched: setProjectTasksWereFetched,
            subTasks: subTasks,
            setSubTasks: setSubTasks
        },
        children: children
    });
}
var $b0893505d0f7ae16$export$2e2bcd8739ae039 = $b0893505d0f7ae16$var$DataProvider;




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a488b22f0ec4487a$var$extendStatics = function(d, b) {
    $a488b22f0ec4487a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a488b22f0ec4487a$var$extendStatics(d, b);
};
function $a488b22f0ec4487a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a488b22f0ec4487a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a488b22f0ec4487a$export$18ce0697a983be9b = function() {
    $a488b22f0ec4487a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a488b22f0ec4487a$export$18ce0697a983be9b.apply(this, arguments);
};
function $a488b22f0ec4487a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a488b22f0ec4487a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a488b22f0ec4487a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a488b22f0ec4487a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a488b22f0ec4487a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a488b22f0ec4487a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a488b22f0ec4487a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a488b22f0ec4487a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a488b22f0ec4487a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a488b22f0ec4487a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a488b22f0ec4487a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a488b22f0ec4487a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a488b22f0ec4487a$export$45d3717a4c69092e(o, m, p);
}
function $a488b22f0ec4487a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a488b22f0ec4487a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a488b22f0ec4487a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a488b22f0ec4487a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a488b22f0ec4487a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a488b22f0ec4487a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a488b22f0ec4487a$export$10c90e4f7922046c(v) {
    return this instanceof $a488b22f0ec4487a$export$10c90e4f7922046c ? (this.v = v, this) : new $a488b22f0ec4487a$export$10c90e4f7922046c(v);
}
function $a488b22f0ec4487a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a488b22f0ec4487a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a488b22f0ec4487a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a488b22f0ec4487a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a488b22f0ec4487a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a488b22f0ec4487a$export$19a8beecd37a4c45 === "function" ? $a488b22f0ec4487a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a488b22f0ec4487a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a488b22f0ec4487a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a488b22f0ec4487a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a488b22f0ec4487a$export$45d3717a4c69092e(result, mod, k);
    }
    $a488b22f0ec4487a$var$__setModuleDefault(result, mod);
    return result;
}
function $a488b22f0ec4487a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a488b22f0ec4487a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a488b22f0ec4487a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a488b22f0ec4487a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a488b22f0ec4487a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a488b22f0ec4487a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a488b22f0ec4487a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a488b22f0ec4487a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a488b22f0ec4487a$export$2e2bcd8739ae039 = {
    __extends: $a488b22f0ec4487a$export$a8ba968b8961cb8a,
    __assign: $a488b22f0ec4487a$export$18ce0697a983be9b,
    __rest: $a488b22f0ec4487a$export$3c9a16f847548506,
    __decorate: $a488b22f0ec4487a$export$29e00dfd3077644b,
    __param: $a488b22f0ec4487a$export$d5ad3fd78186038f,
    __metadata: $a488b22f0ec4487a$export$f1db080c865becb9,
    __awaiter: $a488b22f0ec4487a$export$1050f835b63b671e,
    __generator: $a488b22f0ec4487a$export$67ebef60e6f28a6,
    __createBinding: $a488b22f0ec4487a$export$45d3717a4c69092e,
    __exportStar: $a488b22f0ec4487a$export$f33643c0debef087,
    __values: $a488b22f0ec4487a$export$19a8beecd37a4c45,
    __read: $a488b22f0ec4487a$export$8d051b38c9118094,
    __spread: $a488b22f0ec4487a$export$afc72e2116322959,
    __spreadArrays: $a488b22f0ec4487a$export$6388937ca91ccae8,
    __spreadArray: $a488b22f0ec4487a$export$1216008129fb82ed,
    __await: $a488b22f0ec4487a$export$10c90e4f7922046c,
    __asyncGenerator: $a488b22f0ec4487a$export$e427f37a30a4de9b,
    __asyncDelegator: $a488b22f0ec4487a$export$bbd80228419bb833,
    __asyncValues: $a488b22f0ec4487a$export$e3b29a3d6162315f,
    __makeTemplateObject: $a488b22f0ec4487a$export$4fb47efe1390b86f,
    __importStar: $a488b22f0ec4487a$export$c21735bcef00d192,
    __importDefault: $a488b22f0ec4487a$export$da59b14a69baef04,
    __classPrivateFieldGet: $a488b22f0ec4487a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a488b22f0ec4487a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a488b22f0ec4487a$export$81fdc39f203e4e04,
    __addDisposableResource: $a488b22f0ec4487a$export$88ac25d8e944e405,
    __disposeResources: $a488b22f0ec4487a$export$8f076105dc360e92
};


function $292fca7ef59d5404$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $2d7b665dfc4c324e$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $2d7b665dfc4c324e$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $292fca7ef59d5404$export$2e2bcd8739ae039)(function(prop) {
    return $2d7b665dfc4c324e$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $exYeM = parcelRequire("exYeM");
var $031c5e26b7af07bf$exports = {};
//
$031c5e26b7af07bf$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $98c7a0c432789d27$export$71ad59f2e432cfe8 = "-ms-";
var $98c7a0c432789d27$export$2c0f367103c8d01c = "-moz-";
var $98c7a0c432789d27$export$39dfd62a25e0fe93 = "-webkit-";
var $98c7a0c432789d27$export$a29989082612d0d9 = "comm";
var $98c7a0c432789d27$export$aa3a2e812ca8570d = "rule";
var $98c7a0c432789d27$export$527d108ccf083c2b = "decl";
var $98c7a0c432789d27$export$d3d35020fa5b54f0 = "@page";
var $98c7a0c432789d27$export$500415a86c544f73 = "@media";
var $98c7a0c432789d27$export$a763edbf796b780a = "@import";
var $98c7a0c432789d27$export$2790aeb8b4e5c826 = "@charset";
var $98c7a0c432789d27$export$1cc683e23b84b133 = "@viewport";
var $98c7a0c432789d27$export$9447a5efea57e862 = "@supports";
var $98c7a0c432789d27$export$ef011b4e114b1fba = "@document";
var $98c7a0c432789d27$export$6aad947bda0f3f46 = "@namespace";
var $98c7a0c432789d27$export$b44a8529a35fcb60 = "@keyframes";
var $98c7a0c432789d27$export$2c16de31893252e6 = "@font-face";
var $98c7a0c432789d27$export$3d846dd52e150c6f = "@counter-style";
var $98c7a0c432789d27$export$22314bfbb57653fe = "@font-feature-values";
var $98c7a0c432789d27$export$d773506282b3cfe6 = "@layer";
var $98c7a0c432789d27$export$1c5a554c78c0cd12 = "@scope";
var $98c7a0c432789d27$export$2335f513bbd82c6d = Math.abs;
var $98c7a0c432789d27$export$6788812c4e6611e6 = String.fromCharCode;
var $98c7a0c432789d27$export$e6e34fd1f2686227 = Object.assign;
function $98c7a0c432789d27$export$d6af199866bfb566(e, r) {
    return $98c7a0c432789d27$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 0)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 1)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 2)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 3) : 0;
}
function $98c7a0c432789d27$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $98c7a0c432789d27$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $98c7a0c432789d27$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $98c7a0c432789d27$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $98c7a0c432789d27$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $98c7a0c432789d27$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $98c7a0c432789d27$export$36776f635604f274(e) {
    return e.length;
}
function $98c7a0c432789d27$export$f9084667e487ed46(e) {
    return e.length;
}
function $98c7a0c432789d27$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $98c7a0c432789d27$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $98c7a0c432789d27$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$98c7a0c432789d27$export$4659b591c19bdf3d(e, r);
    });
}
var $98c7a0c432789d27$export$53f1d5ea8de3d7c = 1;
var $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1;
var $98c7a0c432789d27$export$f24224f1c91d8156 = 0;
var $98c7a0c432789d27$export$5880b8b5730aff45 = 0;
var $98c7a0c432789d27$export$c0306caf338ac095 = 0;
var $98c7a0c432789d27$export$30a86d91af8ff6e6 = "";
function $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $98c7a0c432789d27$export$53f1d5ea8de3d7c,
        column: $98c7a0c432789d27$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $98c7a0c432789d27$export$784d13d8ee351f07(e, r) {
    return $98c7a0c432789d27$export$e6e34fd1f2686227($98c7a0c432789d27$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $98c7a0c432789d27$export$590e8b2c435046d9(e) {
    while(e.root)e = $98c7a0c432789d27$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $98c7a0c432789d27$export$10d8903dec122b9d(e, e.siblings);
}
function $98c7a0c432789d27$export$eba6f6f03b0a92e7() {
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$232faf9add678146() {
    $98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$5880b8b5730aff45 > 0 ? $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, --$98c7a0c432789d27$export$5880b8b5730aff45) : 0;
    if ($98c7a0c432789d27$export$4e0c71f277ca26b3--, $98c7a0c432789d27$export$c0306caf338ac095 === 10) $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$53f1d5ea8de3d7c--;
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$48cfd1e771a65c4f() {
    $98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$5880b8b5730aff45 < $98c7a0c432789d27$export$f24224f1c91d8156 ? $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, $98c7a0c432789d27$export$5880b8b5730aff45++) : 0;
    if ($98c7a0c432789d27$export$4e0c71f277ca26b3++, $98c7a0c432789d27$export$c0306caf338ac095 === 10) $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$53f1d5ea8de3d7c++;
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$4d3fb11e950abb9e() {
    return $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, $98c7a0c432789d27$export$5880b8b5730aff45);
}
function $98c7a0c432789d27$export$e88cb2efb12ae807() {
    return $98c7a0c432789d27$export$5880b8b5730aff45;
}
function $98c7a0c432789d27$export$58adb3bec8346d0f(e, r) {
    return $98c7a0c432789d27$export$2f35ab04d2335697($98c7a0c432789d27$export$30a86d91af8ff6e6, e, r);
}
function $98c7a0c432789d27$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $98c7a0c432789d27$export$2de70f21292aac9e(e) {
    return $98c7a0c432789d27$export$53f1d5ea8de3d7c = $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$f24224f1c91d8156 = $98c7a0c432789d27$export$36776f635604f274($98c7a0c432789d27$export$30a86d91af8ff6e6 = e), $98c7a0c432789d27$export$5880b8b5730aff45 = 0, [];
}
function $98c7a0c432789d27$export$45918ac1574455b1(e) {
    return $98c7a0c432789d27$export$30a86d91af8ff6e6 = "", e;
}
function $98c7a0c432789d27$export$410ac95b9ec204b8(e) {
    return $98c7a0c432789d27$export$87c2784dc9fc4ab($98c7a0c432789d27$export$58adb3bec8346d0f($98c7a0c432789d27$export$5880b8b5730aff45 - 1, $98c7a0c432789d27$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $98c7a0c432789d27$export$660b2ee2d4fb4eff(e) {
    return $98c7a0c432789d27$export$45918ac1574455b1($98c7a0c432789d27$export$5f8c09e3ae6f64e1($98c7a0c432789d27$export$2de70f21292aac9e(e)));
}
function $98c7a0c432789d27$export$7af1228ff777d175(e) {
    while($98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$4d3fb11e950abb9e())if ($98c7a0c432789d27$export$c0306caf338ac095 < 33) $98c7a0c432789d27$export$48cfd1e771a65c4f();
    else break;
    return $98c7a0c432789d27$export$9e1725a4cfeada27(e) > 2 || $98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $98c7a0c432789d27$export$5f8c09e3ae6f64e1(e) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())switch($98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$c0306caf338ac095)){
        case 0:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$c2ab62c7bf24634($98c7a0c432789d27$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$410ac95b9ec204b8($98c7a0c432789d27$export$c0306caf338ac095), e);
            break;
        default:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$6788812c4e6611e6($98c7a0c432789d27$export$c0306caf338ac095), e);
    }
    return e;
}
function $98c7a0c432789d27$export$955ba06d119e085e(e, r) {
    while(--r && $98c7a0c432789d27$export$48cfd1e771a65c4f())if ($98c7a0c432789d27$export$c0306caf338ac095 < 48 || $98c7a0c432789d27$export$c0306caf338ac095 > 102 || $98c7a0c432789d27$export$c0306caf338ac095 > 57 && $98c7a0c432789d27$export$c0306caf338ac095 < 65 || $98c7a0c432789d27$export$c0306caf338ac095 > 70 && $98c7a0c432789d27$export$c0306caf338ac095 < 97) break;
    return $98c7a0c432789d27$export$58adb3bec8346d0f(e, $98c7a0c432789d27$export$e88cb2efb12ae807() + (r < 6 && $98c7a0c432789d27$export$4d3fb11e950abb9e() == 32 && $98c7a0c432789d27$export$48cfd1e771a65c4f() == 32));
}
function $98c7a0c432789d27$export$c889f2fcc19dbf12(e) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())switch($98c7a0c432789d27$export$c0306caf338ac095){
        case e:
            return $98c7a0c432789d27$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $98c7a0c432789d27$export$c889f2fcc19dbf12($98c7a0c432789d27$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $98c7a0c432789d27$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $98c7a0c432789d27$export$48cfd1e771a65c4f();
            break;
    }
    return $98c7a0c432789d27$export$5880b8b5730aff45;
}
function $98c7a0c432789d27$export$4254d4e2b3745c4c(e, r) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())if (e + $98c7a0c432789d27$export$c0306caf338ac095 === 57) break;
    else if (e + $98c7a0c432789d27$export$c0306caf338ac095 === 84 && $98c7a0c432789d27$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $98c7a0c432789d27$export$58adb3bec8346d0f(r, $98c7a0c432789d27$export$5880b8b5730aff45 - 1) + "*" + $98c7a0c432789d27$export$6788812c4e6611e6(e === 47 ? e : $98c7a0c432789d27$export$48cfd1e771a65c4f());
}
function $98c7a0c432789d27$export$c2ab62c7bf24634(e) {
    while(!$98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$4d3fb11e950abb9e()))$98c7a0c432789d27$export$48cfd1e771a65c4f();
    return $98c7a0c432789d27$export$58adb3bec8346d0f(e, $98c7a0c432789d27$export$5880b8b5730aff45);
}
function $98c7a0c432789d27$export$ef7acd7185315e22(e) {
    return $98c7a0c432789d27$export$45918ac1574455b1($98c7a0c432789d27$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $98c7a0c432789d27$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $98c7a0c432789d27$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $98c7a0c432789d27$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $98c7a0c432789d27$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($98c7a0c432789d27$export$f8e21b1e77979a08(z += $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $98c7a0c432789d27$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $98c7a0c432789d27$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $98c7a0c432789d27$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $98c7a0c432789d27$export$955ba06d119e085e($98c7a0c432789d27$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($98c7a0c432789d27$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$4a34f930e789283c($98c7a0c432789d27$export$4254d4e2b3745c4c($98c7a0c432789d27$export$48cfd1e771a65c4f(), $98c7a0c432789d27$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $98c7a0c432789d27$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $98c7a0c432789d27$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $98c7a0c432789d27$export$36776f635604f274(z) - l) $98c7a0c432789d27$export$10d8903dec122b9d(p > 32 ? $98c7a0c432789d27$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $98c7a0c432789d27$export$f8483753829ec8f3($98c7a0c432789d27$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $98c7a0c432789d27$export$10d8903dec122b9d(j = $98c7a0c432789d27$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $98c7a0c432789d27$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $98c7a0c432789d27$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $98c7a0c432789d27$export$98e6a39c04603d36(e, j, j, n && $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $98c7a0c432789d27$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $98c7a0c432789d27$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $98c7a0c432789d27$export$232faf9add678146() == 125) continue;
            }
            switch(z += $98c7a0c432789d27$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($98c7a0c432789d27$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($98c7a0c432789d27$export$4d3fb11e950abb9e() === 45) z += $98c7a0c432789d27$export$410ac95b9ec204b8($98c7a0c432789d27$export$48cfd1e771a65c4f());
                    v = $98c7a0c432789d27$export$4d3fb11e950abb9e(), o = l = $98c7a0c432789d27$export$36776f635604f274(k = z += $98c7a0c432789d27$export$c2ab62c7bf24634($98c7a0c432789d27$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $98c7a0c432789d27$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $98c7a0c432789d27$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $98c7a0c432789d27$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $98c7a0c432789d27$export$2f35ab04d2335697(e, p + 1, p = $98c7a0c432789d27$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $98c7a0c432789d27$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $98c7a0c432789d27$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, s === 0 ? $98c7a0c432789d27$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $98c7a0c432789d27$export$4a34f930e789283c(e, r, a, c) {
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, $98c7a0c432789d27$export$a29989082612d0d9, $98c7a0c432789d27$export$6788812c4e6611e6($98c7a0c432789d27$export$eba6f6f03b0a92e7()), $98c7a0c432789d27$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $98c7a0c432789d27$export$f8483753829ec8f3(e, r, a, n, c) {
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, $98c7a0c432789d27$export$527d108ccf083c2b, $98c7a0c432789d27$export$2f35ab04d2335697(e, 0, n), $98c7a0c432789d27$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $98c7a0c432789d27$export$82e9f45cca5ba907(n, c, s) {
    switch($98c7a0c432789d27$export$d6af199866bfb566(n, c)){
        case 5103:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $98c7a0c432789d27$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$2c0f367103c8d01c + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($98c7a0c432789d27$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-$1$2" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-item-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$98c7a0c432789d27$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-row-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-line-pack" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-grow", "") + $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-pack:$3" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$98c7a0c432789d27$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-column-align" + $98c7a0c432789d27$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $98c7a0c432789d27$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$98c7a0c432789d27$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$98c7a0c432789d27$export$f8e21b1e77979a08(s, "span", 0) ? $98c7a0c432789d27$export$4659b591c19bdf3d(s, /\d+/) : +$98c7a0c432789d27$export$4659b591c19bdf3d(s, /\d+/) - +$98c7a0c432789d27$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $98c7a0c432789d27$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($98c7a0c432789d27$export$36776f635604f274(n) - 1 - c > 6) switch($98c7a0c432789d27$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $98c7a0c432789d27$export$2c0f367103c8d01c + ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$98c7a0c432789d27$export$f8e21b1e77979a08(n, "stretch", 0) ? $98c7a0c432789d27$export$82e9f45cca5ba907($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $98c7a0c432789d27$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $98c7a0c432789d27$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 6) === 121) return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, ":", ":" + $98c7a0c432789d27$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($98c7a0c432789d27$export$a9db5e087081082d(n, $98c7a0c432789d27$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + ($98c7a0c432789d27$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, ":", ":" + $98c7a0c432789d27$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $98c7a0c432789d27$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $98c7a0c432789d27$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $98c7a0c432789d27$export$a763edbf796b780a:
        case $98c7a0c432789d27$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $98c7a0c432789d27$export$a29989082612d0d9:
            return "";
        case $98c7a0c432789d27$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $98c7a0c432789d27$export$aa3a2e812ca8570d:
            if (!$98c7a0c432789d27$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $98c7a0c432789d27$export$36776f635604f274(a = $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $98c7a0c432789d27$export$5a7767152ae0305f(e) {
    var r = $98c7a0c432789d27$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $98c7a0c432789d27$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $98c7a0c432789d27$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $98c7a0c432789d27$export$527d108ccf083c2b:
                n.return = $98c7a0c432789d27$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $98c7a0c432789d27$export$b44a8529a35fcb60:
                return $98c7a0c432789d27$export$dfdc1655ccc5b9cb([
                    $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                        value: $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $98c7a0c432789d27$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $98c7a0c432789d27$export$aa3a2e812ca8570d:
                if (n.length) return $98c7a0c432789d27$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($98c7a0c432789d27$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $98c7a0c432789d27$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $98c7a0c432789d27$export$e6e34fd1f2686227(n, {
                                props: $98c7a0c432789d27$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $98c7a0c432789d27$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $98c7a0c432789d27$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $98c7a0c432789d27$export$590e8b2c435046d9($98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $98c7a0c432789d27$export$e6e34fd1f2686227(n, {
                                props: $98c7a0c432789d27$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $98c7a0c432789d27$export$76a88f7de6507443(e) {
    switch(e.type){
        case $98c7a0c432789d27$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $98c7a0c432789d27$export$1be1fc439b849fdf($98c7a0c432789d27$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($98c7a0c432789d27$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $98c7a0c432789d27$export$2f35ab04d2335697(r, 1, $98c7a0c432789d27$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $98c7a0c432789d27$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $98c7a0c432789d27$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $98c7a0c432789d27$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d9cd8dcf50c5790f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $93948c98236af5c1$var$f = ("undefined" != typeof $4acf49f6c3e67aec$exports && void 0 !== $4acf49f6c3e67aec$exports.env && undefined, "data-styled"), $93948c98236af5c1$var$m = "active", $93948c98236af5c1$var$y = "data-styled-version", $93948c98236af5c1$export$83d89fbfd8236492 = "6.1.11", $93948c98236af5c1$var$g = "/*!sc*/\n", $93948c98236af5c1$var$S = "undefined" != typeof window && "HTMLElement" in window, $93948c98236af5c1$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $4acf49f6c3e67aec$exports && $4acf49f6c3e67aec$exports.env, "undefined" != typeof $4acf49f6c3e67aec$exports && $4acf49f6c3e67aec$exports.env, false)), $93948c98236af5c1$var$b = {}, $93948c98236af5c1$var$E = /invalid hook call/i, $93948c98236af5c1$var$N = new Set, $93948c98236af5c1$var$P = function(t, n) {
    var o, s, i, a, e;
}, $93948c98236af5c1$var$_ = Object.freeze([]), $93948c98236af5c1$var$C = Object.freeze({});
function $93948c98236af5c1$var$I(e, t, n) {
    return void 0 === n && (n = $93948c98236af5c1$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $93948c98236af5c1$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $93948c98236af5c1$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $93948c98236af5c1$var$D = /(^-|-$)/g;
function $93948c98236af5c1$var$R(e) {
    return e.replace($93948c98236af5c1$var$O, "-").replace($93948c98236af5c1$var$D, "");
}
var $93948c98236af5c1$var$T = /(a)(d)/gi, $93948c98236af5c1$var$k = 52, $93948c98236af5c1$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $93948c98236af5c1$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $93948c98236af5c1$var$k; t = t / $93948c98236af5c1$var$k | 0)n = $93948c98236af5c1$var$j(t % $93948c98236af5c1$var$k) + n;
    return ($93948c98236af5c1$var$j(t % $93948c98236af5c1$var$k) + n).replace($93948c98236af5c1$var$T, "$1-$2");
}
var $93948c98236af5c1$var$V, $93948c98236af5c1$var$F = 5381, $93948c98236af5c1$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $93948c98236af5c1$var$$ = function(e) {
    return $93948c98236af5c1$var$M($93948c98236af5c1$var$F, e);
};
function $93948c98236af5c1$var$z(e) {
    return $93948c98236af5c1$var$x($93948c98236af5c1$var$$(e) >>> 0);
}
function $93948c98236af5c1$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $93948c98236af5c1$var$L(e) {
    return "string" == typeof e && true;
}
var $93948c98236af5c1$var$G = "function" == typeof Symbol && Symbol.for, $93948c98236af5c1$var$Y = $93948c98236af5c1$var$G ? Symbol.for("react.memo") : 60115, $93948c98236af5c1$var$W = $93948c98236af5c1$var$G ? Symbol.for("react.forward_ref") : 60112, $93948c98236af5c1$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $93948c98236af5c1$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $93948c98236af5c1$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $93948c98236af5c1$var$J = (($93948c98236af5c1$var$V = {})[$93948c98236af5c1$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $93948c98236af5c1$var$V[$93948c98236af5c1$var$Y] = $93948c98236af5c1$var$U, $93948c98236af5c1$var$V);
function $93948c98236af5c1$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $93948c98236af5c1$var$Y ? $93948c98236af5c1$var$U : "$$typeof" in e ? $93948c98236af5c1$var$J[e.$$typeof] : $93948c98236af5c1$var$q;
}
var $93948c98236af5c1$var$Z = Object.defineProperty, $93948c98236af5c1$var$K = Object.getOwnPropertyNames, $93948c98236af5c1$var$Q = Object.getOwnPropertySymbols, $93948c98236af5c1$var$ee = Object.getOwnPropertyDescriptor, $93948c98236af5c1$var$te = Object.getPrototypeOf, $93948c98236af5c1$var$ne = Object.prototype;
function $93948c98236af5c1$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($93948c98236af5c1$var$ne) {
            var o = $93948c98236af5c1$var$te(t);
            o && o !== $93948c98236af5c1$var$ne && $93948c98236af5c1$var$oe(e, o, n);
        }
        var r = $93948c98236af5c1$var$K(t);
        $93948c98236af5c1$var$Q && (r = r.concat($93948c98236af5c1$var$Q(t)));
        for(var s = $93948c98236af5c1$var$X(e), i = $93948c98236af5c1$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $93948c98236af5c1$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $93948c98236af5c1$var$ee(t, c);
                try {
                    $93948c98236af5c1$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $93948c98236af5c1$var$re(e) {
    return "function" == typeof e;
}
function $93948c98236af5c1$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $93948c98236af5c1$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $93948c98236af5c1$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $93948c98236af5c1$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $93948c98236af5c1$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$93948c98236af5c1$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $93948c98236af5c1$var$le(e[o], t[o]);
    else if ($93948c98236af5c1$var$ce(t)) for(var o in t)e[o] = $93948c98236af5c1$var$le(e[o], t[o]);
    return e;
}
function $93948c98236af5c1$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $93948c98236af5c1$var$pe = {};
function $93948c98236af5c1$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $93948c98236af5c1$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $93948c98236af5c1$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $93948c98236af5c1$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($93948c98236af5c1$var$g);
        return t;
    }, e;
}(), $93948c98236af5c1$var$me = 1073741824, $93948c98236af5c1$var$ye = new Map, $93948c98236af5c1$var$ve = new Map, $93948c98236af5c1$var$ge = 1, $93948c98236af5c1$var$Se = function(e) {
    if ($93948c98236af5c1$var$ye.has(e)) return $93948c98236af5c1$var$ye.get(e);
    for(; $93948c98236af5c1$var$ve.has($93948c98236af5c1$var$ge);)$93948c98236af5c1$var$ge++;
    var t = $93948c98236af5c1$var$ge++;
    return $93948c98236af5c1$var$ye.set(e, t), $93948c98236af5c1$var$ve.set(t, e), t;
}, $93948c98236af5c1$var$we = function(e, t) {
    $93948c98236af5c1$var$ge = t + 1, $93948c98236af5c1$var$ye.set(e, t), $93948c98236af5c1$var$ve.set(t, e);
}, $93948c98236af5c1$var$be = "style[".concat($93948c98236af5c1$var$f, "][").concat($93948c98236af5c1$var$y, '="').concat($93948c98236af5c1$export$83d89fbfd8236492, '"]'), $93948c98236af5c1$var$Ee = new RegExp("^".concat($93948c98236af5c1$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $93948c98236af5c1$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $93948c98236af5c1$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($93948c98236af5c1$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($93948c98236af5c1$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($93948c98236af5c1$var$we(u, l), $93948c98236af5c1$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $93948c98236af5c1$var$_e() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $93948c98236af5c1$var$Ce = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($93948c98236af5c1$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($93948c98236af5c1$var$f, $93948c98236af5c1$var$m), o.setAttribute($93948c98236af5c1$var$y, $93948c98236af5c1$export$83d89fbfd8236492);
    var i = $93948c98236af5c1$var$_e();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $93948c98236af5c1$var$Ie = function() {
    function e(e) {
        this.element = $93948c98236af5c1$var$Ce(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $93948c98236af5c1$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $93948c98236af5c1$var$Ae = function() {
    function e(e) {
        this.element = $93948c98236af5c1$var$Ce(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $93948c98236af5c1$var$Oe = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $93948c98236af5c1$var$De = $93948c98236af5c1$var$S, $93948c98236af5c1$var$Re = {
    isServer: !$93948c98236af5c1$var$S,
    useCSSOMInjection: !$93948c98236af5c1$var$w
}, $93948c98236af5c1$var$Te = function() {
    function e(e, n, o) {
        void 0 === e && (e = $93948c98236af5c1$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, $93948c98236af5c1$var$Re), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $93948c98236af5c1$var$S && $93948c98236af5c1$var$De && ($93948c98236af5c1$var$De = !1, function(e) {
            for(var t = document.querySelectorAll($93948c98236af5c1$var$be), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && r.getAttribute($93948c98236af5c1$var$f) !== $93948c98236af5c1$var$m && ($93948c98236af5c1$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $93948c98236af5c1$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $93948c98236af5c1$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($93948c98236af5c1$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($93948c98236af5c1$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $93948c98236af5c1$var$Se(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $93948c98236af5c1$var$Oe(n) : t ? new $93948c98236af5c1$var$Ie(n) : new $93948c98236af5c1$var$Ae(n);
        }(this.options), new $93948c98236af5c1$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($93948c98236af5c1$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($93948c98236af5c1$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($93948c98236af5c1$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $93948c98236af5c1$var$ke = /&/g, $93948c98236af5c1$var$je = /^\s*\/\/.*$/gm;
function $93948c98236af5c1$var$xe(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $93948c98236af5c1$var$xe(e.children, t)), e;
    });
}
function $93948c98236af5c1$var$Ve(e) {
    var t, n, o, r = void 0 === e ? $93948c98236af5c1$var$C : e, s = r.options, i = void 0 === s ? $93948c98236af5c1$var$C : s, a = r.plugins, c = void 0 === a ? $93948c98236af5c1$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $98c7a0c432789d27$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($93948c98236af5c1$var$ke, n).replace(o, l));
    }), i.prefix && u.push($98c7a0c432789d27$export$e08c7d021b829b7a), u.push($98c7a0c432789d27$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($93948c98236af5c1$var$je, ""), l = $98c7a0c432789d27$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $93948c98236af5c1$var$xe(l, i.namespace));
        var p = [];
        return $98c7a0c432789d27$export$dfdc1655ccc5b9cb(l, $98c7a0c432789d27$export$5a7767152ae0305f(u.concat($98c7a0c432789d27$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $93948c98236af5c1$var$he(15), $93948c98236af5c1$var$M(e, t.name);
    }, $93948c98236af5c1$var$F).toString() : "", p;
}
var $93948c98236af5c1$var$Fe = new $93948c98236af5c1$var$Te, $93948c98236af5c1$var$Me = $93948c98236af5c1$var$Ve(), $93948c98236af5c1$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $93948c98236af5c1$var$Fe,
    stylis: $93948c98236af5c1$var$Me
}), $93948c98236af5c1$export$91317688fc694efa = $93948c98236af5c1$export$8c190ef828af4c86.Consumer, $93948c98236af5c1$var$Be = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(void 0);
function $93948c98236af5c1$var$Le() {
    return (0, $exYeM.useContext)($93948c98236af5c1$export$8c190ef828af4c86);
}
function $93948c98236af5c1$export$a473771da2f0ff7c(e) {
    var t = (0, $exYeM.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $93948c98236af5c1$var$Le().styleSheet, l = (0, $exYeM.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $exYeM.useMemo)(function() {
        return $93948c98236af5c1$var$Ve({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $exYeM.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($031c5e26b7af07bf$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $exYeM.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$var$Be.Provider, {
        value: u
    }, e.children));
}
var $93948c98236af5c1$var$Ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $93948c98236af5c1$var$Me);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $93948c98236af5c1$var$ue(this, function() {
            throw $93948c98236af5c1$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $93948c98236af5c1$var$Me), this.name + e.hash;
    }, e;
}(), $93948c98236af5c1$var$We = function(e) {
    return e >= "A" && e <= "Z";
};
function $93948c98236af5c1$var$qe(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $93948c98236af5c1$var$We(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $93948c98236af5c1$var$He = function(e) {
    return null == e || !1 === e || "" === e;
}, $93948c98236af5c1$var$Ue = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$93948c98236af5c1$var$He(i) && (Array.isArray(i) && i.isCss || $93948c98236af5c1$var$re(i) ? r.push("".concat($93948c98236af5c1$var$qe(s), ":"), i, ";") : $93948c98236af5c1$var$ce(i) ? r.push.apply(r, (0, $a488b22f0ec4487a$export$1216008129fb82ed)((0, $a488b22f0ec4487a$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $93948c98236af5c1$var$Ue(i), !1), [
            "}"
        ], !1)) : r.push("".concat($93948c98236af5c1$var$qe(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $d9cd8dcf50c5790f$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $93948c98236af5c1$var$Je(e, t, n, o) {
    if ($93948c98236af5c1$var$He(e)) return [];
    if ($93948c98236af5c1$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($93948c98236af5c1$var$re(e)) {
        if (!$93948c98236af5c1$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $93948c98236af5c1$var$Je(r, t, n, o);
    }
    var s;
    return e instanceof $93948c98236af5c1$var$Ye ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $93948c98236af5c1$var$ce(e) ? $93948c98236af5c1$var$Ue(e) : Array.isArray(e) ? Array.prototype.concat.apply($93948c98236af5c1$var$_, e.map(function(e) {
        return $93948c98236af5c1$var$Je(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $93948c98236af5c1$var$Xe(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($93948c98236af5c1$var$re(n) && !$93948c98236af5c1$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $93948c98236af5c1$var$Ze = $93948c98236af5c1$var$$($93948c98236af5c1$export$83d89fbfd8236492), $93948c98236af5c1$var$Ke = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $93948c98236af5c1$var$Xe(e), this.componentId = t, this.baseHash = $93948c98236af5c1$var$M($93948c98236af5c1$var$Ze, t), this.baseStyle = n, $93948c98236af5c1$var$Te.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $93948c98236af5c1$var$ie(o, this.staticRulesId);
            else {
                var r = $93948c98236af5c1$var$ae($93948c98236af5c1$var$Je(this.rules, e, t, n)), s = $93948c98236af5c1$var$x($93948c98236af5c1$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $93948c98236af5c1$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $93948c98236af5c1$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $93948c98236af5c1$var$ae($93948c98236af5c1$var$Je(u, e, t, n));
                    a = $93948c98236af5c1$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $93948c98236af5c1$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $93948c98236af5c1$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $93948c98236af5c1$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(void 0), $93948c98236af5c1$export$b631efc24e9d5e2f = $93948c98236af5c1$export$2c657da244d00bd6.Consumer;
function $93948c98236af5c1$export$93d4e7f90805808f() {
    var e = (0, $exYeM.useContext)($93948c98236af5c1$export$2c657da244d00bd6);
    if (!e) throw $93948c98236af5c1$var$he(18);
    return e;
}
function $93948c98236af5c1$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), r = (0, $exYeM.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $93948c98236af5c1$var$he(14);
            if ($93948c98236af5c1$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $93948c98236af5c1$var$he(8);
            return n ? (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $93948c98236af5c1$var$ot = {}, $93948c98236af5c1$var$rt = new Set;
function $93948c98236af5c1$var$st(e, r, s) {
    var i = $93948c98236af5c1$export$7ba318d8d2f06c76(e), a = e, c = !$93948c98236af5c1$var$L(e), p = r.attrs, d = void 0 === p ? $93948c98236af5c1$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $93948c98236af5c1$var$R(e);
        $93948c98236af5c1$var$ot[n] = ($93948c98236af5c1$var$ot[n] || 0) + 1;
        var o = "".concat(n, "-").concat($93948c98236af5c1$var$z($93948c98236af5c1$export$83d89fbfd8236492 + n + $93948c98236af5c1$var$ot[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $93948c98236af5c1$var$L(e) ? "styled.".concat(e) : "Styled(".concat($93948c98236af5c1$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($93948c98236af5c1$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $93948c98236af5c1$var$Ke(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), m = $93948c98236af5c1$var$Le(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $93948c98236af5c1$var$I(r, f, c) || $93948c98236af5c1$var$C, g = function(e, n, o) {
                for(var r, s = (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $93948c98236af5c1$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $93948c98236af5c1$var$ie(s[c], a[c]) : "style" === c ? (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $93948c98236af5c1$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $93948c98236af5c1$var$Le(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $93948c98236af5c1$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$93948c98236af5c1$var$L(S) && !$93948c98236af5c1$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $exYeM.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $93948c98236af5c1$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$93948c98236af5c1$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $93948c98236af5c1$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $93948c98236af5c1$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $93948c98236af5c1$var$it(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $93948c98236af5c1$var$at = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $93948c98236af5c1$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($93948c98236af5c1$var$re(t) || $93948c98236af5c1$var$ce(t)) return $93948c98236af5c1$var$at($93948c98236af5c1$var$Je($93948c98236af5c1$var$it($93948c98236af5c1$var$_, (0, $a488b22f0ec4487a$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $93948c98236af5c1$var$Je(r) : $93948c98236af5c1$var$at($93948c98236af5c1$var$Je($93948c98236af5c1$var$it(r, n)));
}
function $93948c98236af5c1$var$lt(n, o, r) {
    if (void 0 === r && (r = $93948c98236af5c1$var$C), !o) throw $93948c98236af5c1$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $93948c98236af5c1$export$dbf350e5966cf602.apply(void 0, (0, $a488b22f0ec4487a$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $93948c98236af5c1$var$lt(n, o, (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $93948c98236af5c1$var$lt(n, o, (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $93948c98236af5c1$var$ut = function(e) {
    return $93948c98236af5c1$var$lt($93948c98236af5c1$var$st, e);
}, $93948c98236af5c1$export$2e2bcd8739ae039 = $93948c98236af5c1$var$ut;
$93948c98236af5c1$var$A.forEach(function(e) {
    $93948c98236af5c1$export$2e2bcd8739ae039[e] = $93948c98236af5c1$var$ut(e);
});
var $93948c98236af5c1$var$dt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $93948c98236af5c1$var$Xe(e), $93948c98236af5c1$var$Te.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($93948c98236af5c1$var$ae($93948c98236af5c1$var$Je(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $93948c98236af5c1$var$Te.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $93948c98236af5c1$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $93948c98236af5c1$export$dbf350e5966cf602.apply(void 0, (0, $a488b22f0ec4487a$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($93948c98236af5c1$var$z(JSON.stringify(i))), c = new $93948c98236af5c1$var$dt(i, a);
    var l = function(e) {
        var t = $93948c98236af5c1$var$Le(), n = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $93948c98236af5c1$var$b, o, s);
        else {
            var i = (0, $a488b22f0ec4487a$export$18ce0697a983be9b)((0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, n), {
                theme: $93948c98236af5c1$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(l);
}
function $93948c98236af5c1$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $93948c98236af5c1$var$ae($93948c98236af5c1$export$dbf350e5966cf602.apply(void 0, (0, $a488b22f0ec4487a$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $93948c98236af5c1$var$z(r);
    return new $93948c98236af5c1$var$Ye(s, r);
}
function $93948c98236af5c1$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(function(n, r) {
        var s = $93948c98236af5c1$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext($93948c98236af5c1$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(e, (0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($93948c98236af5c1$var$B(e), ")"), $93948c98236af5c1$var$oe(n, e);
}
var $93948c98236af5c1$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $93948c98236af5c1$var$_e(), o = $93948c98236af5c1$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($93948c98236af5c1$var$f, '="true"'),
                "".concat($93948c98236af5c1$var$y, '="').concat($93948c98236af5c1$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $93948c98236af5c1$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $93948c98236af5c1$var$he(2);
            var r = ((n = {})[$93948c98236af5c1$var$f] = "", n[$93948c98236af5c1$var$y] = $93948c98236af5c1$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $93948c98236af5c1$var$_e();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("style", (0, $a488b22f0ec4487a$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $93948c98236af5c1$var$Te({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $93948c98236af5c1$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93948c98236af5c1$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $93948c98236af5c1$var$he(3);
    }, e;
}(), $93948c98236af5c1$export$5c87cfe6c475f500 = {
    StyleSheet: $93948c98236af5c1$var$Te,
    mainSheet: $93948c98236af5c1$var$Fe
};
var $93948c98236af5c1$var$gt = "__sc-".concat($93948c98236af5c1$var$f, "__");


function $ce2bbf7743ae7f98$var$Header() {
    const { randomItem: randomItem , setApiWasRequested: setApiWasRequested , setRequestWasHandled: setRequestWasHandled  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    function handleClick() {
        setApiWasRequested(true);
        setRequestWasHandled(false);
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("header", {
                className: `${$55016c398784f6a3$export$38e42c68cf43b5d4} ${(0, $55016c398784f6a3$export$385906a4ef528034)}`,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h1", {
                    children: "James Shapiro"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                children: [
                    "Invisible",
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        className: $55016c398784f6a3$export$69d0d1846105bbd3,
                        children: "PLACEHOLDER"
                    }),
                    "placeholder",
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        className: $55016c398784f6a3$export$69d0d1846105bbd3,
                        children: "DEMO"
                    }),
                    "Demo"
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($ce2bbf7743ae7f98$var$Button, {
                onClick: handleClick,
                children: "Invoke API (see console)"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                children: [
                    "Random Data Context Item: ",
                    randomItem
                ]
            })
        ]
    });
}
var $ce2bbf7743ae7f98$export$2e2bcd8739ae039 = $ce2bbf7743ae7f98$var$Header;
const $ce2bbf7743ae7f98$var$Button = (0, $93948c98236af5c1$export$2e2bcd8739ae039).button`
  padding: 20px;
  background-color: hsl(217, 100%, 61%);
  color: white;
  width: fit-content;
  border-radius: 8px;
  margin: 100px auto;
  border: 2px solid black;
`;




parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
// packages/core/primitive/src/primitive.tsx
function $a20bcd1655f7f422$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true  } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $exYeM = parcelRequire("exYeM");
function $a0301a3b12ffad9c$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $a0301a3b12ffad9c$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$a0301a3b12ffad9c$var$setRef(ref, node));
}
function $a0301a3b12ffad9c$export$c7b2cbe3552a0d05(...refs) {
    return $exYeM.useCallback($a0301a3b12ffad9c$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $exYeM = parcelRequire("exYeM");

function $e1a745ecb8941240$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $exYeM.createContext(defaultContext);
    function Provider(props) {
        const { children: children , ...context } = props;
        const value = $exYeM.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $exYeM.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $e1a745ecb8941240$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $exYeM.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope , children: children , ...context } = props;
            const Context = scope?.[scopeName][index] || BaseContext;
            const value = $exYeM.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName][index] || BaseContext;
            const context = $exYeM.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $exYeM.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $exYeM.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $e1a745ecb8941240$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $e1a745ecb8941240$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope , scopeName: scopeName  })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $exYeM.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// packages/react/id/src/id.tsx

var $exYeM = parcelRequire("exYeM");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $exYeM = parcelRequire("exYeM");
var $96a334e7374a91f2$export$e5c5a5f917a5871c = Boolean(globalThis?.document) ? $exYeM.useLayoutEffect : ()=>{};


var $6e53b15deb1e14e9$var$useReactId = $exYeM["useId".toString()] || (()=>void 0);
var $6e53b15deb1e14e9$var$count = 0;
function $6e53b15deb1e14e9$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $exYeM.useState($6e53b15deb1e14e9$var$useReactId());
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($6e53b15deb1e14e9$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $exYeM = parcelRequire("exYeM");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $exYeM = parcelRequire("exYeM");
function $cec6513cd2787f04$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $exYeM.useRef(callback);
    $exYeM.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $exYeM.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


function $ceaa710ce91b202b$export$6f32135080cb4c3({ prop: prop , defaultProp: defaultProp , onChange: onChange = ()=>{}  }) {
    const [uncontrolledProp, setUncontrolledProp] = $ceaa710ce91b202b$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onChange);
    const setValue = $exYeM.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $ceaa710ce91b202b$var$useUncontrolledState({ defaultProp: defaultProp , onChange: onChange  }) {
    const uncontrolledState = $exYeM.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $exYeM.useRef(value);
    const handleChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onChange);
    $exYeM.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $exYeM = parcelRequire("exYeM");

// packages/react/primitive/src/Primitive.tsx

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
// packages/react/slot/src/Slot.tsx

var $exYeM = parcelRequire("exYeM");


var $8d4dfd758f40b63f$export$8c6ed5c666ac1360 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    const childrenArray = $exYeM.Children.toArray(children);
    const slottable = childrenArray.find($8d4dfd758f40b63f$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($exYeM.Children.count(newElement) > 1) return $exYeM.Children.only(null);
                return $exYeM.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($8d4dfd758f40b63f$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $exYeM.isValidElement(newElement) ? $exYeM.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($8d4dfd758f40b63f$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$8d4dfd758f40b63f$export$8c6ed5c666ac1360.displayName = "Slot";
var $8d4dfd758f40b63f$var$SlotClone = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children , ...slotProps } = props;
    if ($exYeM.isValidElement(children)) {
        const childrenRef = $8d4dfd758f40b63f$var$getElementRef(children);
        return $exYeM.cloneElement(children, {
            ...$8d4dfd758f40b63f$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $a0301a3b12ffad9c$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $exYeM.Children.count(children) > 1 ? $exYeM.Children.only(null) : null;
});
$8d4dfd758f40b63f$var$SlotClone.displayName = "SlotClone";
var $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45 = ({ children: children  })=>{
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: children
    });
};
function $8d4dfd758f40b63f$var$isSlottable(child) {
    return $exYeM.isValidElement(child) && child.type === $8d4dfd758f40b63f$export$d9f1ccf0bdb05d45;
}
function $8d4dfd758f40b63f$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $8d4dfd758f40b63f$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $8d4dfd758f40b63f$export$be92b6f5f03c0fe9 = $8d4dfd758f40b63f$export$8c6ed5c666ac1360;



var $9b1158d53fe98b0a$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $9b1158d53fe98b0a$export$250ffa63cdc0d034 = $9b1158d53fe98b0a$var$NODES.reduce((primitive, node)=>{
    const Node = $exYeM.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild , ...primitiveProps } = props;
        const Comp = asChild ? (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $9b1158d53fe98b0a$export$6d1a0317bde7de7f(target, event) {
    if (target) $d2lNW.flushSync(()=>target.dispatchEvent(event));
}
var $9b1158d53fe98b0a$export$be92b6f5f03c0fe9 = $9b1158d53fe98b0a$export$250ffa63cdc0d034;




// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $exYeM = parcelRequire("exYeM");

function $34fe34d34d8734af$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $exYeM.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $0516f19b588c56c0$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $0516f19b588c56c0$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $0516f19b588c56c0$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $0516f19b588c56c0$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $0516f19b588c56c0$var$originalBodyPointerEvents;
var $0516f19b588c56c0$var$DismissableLayerContext = $exYeM.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $0516f19b588c56c0$export$177fb62ff3ec1f22 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , onFocusOutside: onFocusOutside , onInteractOutside: onInteractOutside , onDismiss: onDismiss , ...layerProps } = props;
    const context = $exYeM.useContext($0516f19b588c56c0$var$DismissableLayerContext);
    const [node, setNode] = $exYeM.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $exYeM.useState({});
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $0516f19b588c56c0$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    const focusOutside = $0516f19b588c56c0$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $34fe34d34d8734af$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $exYeM.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $0516f19b588c56c0$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $0516f19b588c56c0$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $0516f19b588c56c0$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $exYeM.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $0516f19b588c56c0$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $exYeM.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($0516f19b588c56c0$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($0516f19b588c56c0$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$0516f19b588c56c0$export$177fb62ff3ec1f22.displayName = $0516f19b588c56c0$var$DISMISSABLE_LAYER_NAME;
var $0516f19b588c56c0$var$BRANCH_NAME = "DismissableLayerBranch";
var $0516f19b588c56c0$export$4d5eb2109db14228 = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $exYeM.useContext($0516f19b588c56c0$var$DismissableLayerContext);
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $exYeM.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$0516f19b588c56c0$export$4d5eb2109db14228.displayName = $0516f19b588c56c0$var$BRANCH_NAME;
function $0516f19b588c56c0$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis?.document) {
    const handlePointerDownOutside = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $exYeM.useRef(false);
    const handleClickRef = $exYeM.useRef(()=>{});
    $exYeM.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $0516f19b588c56c0$var$handleAndDispatchCustomEvent($0516f19b588c56c0$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $0516f19b588c56c0$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $exYeM.useRef(false);
    $exYeM.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $0516f19b588c56c0$var$handleAndDispatchCustomEvent($0516f19b588c56c0$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $0516f19b588c56c0$var$dispatchUpdate() {
    const event = new CustomEvent($0516f19b588c56c0$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $0516f19b588c56c0$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete  }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $9b1158d53fe98b0a$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $0516f19b588c56c0$export$be92b6f5f03c0fe9 = $0516f19b588c56c0$export$177fb62ff3ec1f22;
var $0516f19b588c56c0$export$aecb2ddcb55c95be = $0516f19b588c56c0$export$4d5eb2109db14228;



var $exYeM = parcelRequire("exYeM");




"use client";
var $0d95d7873b2aecf3$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $0d95d7873b2aecf3$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $0d95d7873b2aecf3$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0d95d7873b2aecf3$var$FOCUS_SCOPE_NAME = "FocusScope";
var $0d95d7873b2aecf3$export$20e40289641fbbb6 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false , trapped: trapped = false , onMountAutoFocus: onMountAutoFocusProp , onUnmountAutoFocus: onUnmountAutoFocusProp , ...scopeProps } = props;
    const [container, setContainer] = $exYeM.useState(null);
    const onMountAutoFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $exYeM.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $exYeM.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $0d95d7873b2aecf3$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $0d95d7873b2aecf3$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0d95d7873b2aecf3$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $exYeM.useEffect(()=>{
        if (container) {
            $0d95d7873b2aecf3$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0d95d7873b2aecf3$var$AUTOFOCUS_ON_MOUNT, $0d95d7873b2aecf3$var$EVENT_OPTIONS);
                container.addEventListener($0d95d7873b2aecf3$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0d95d7873b2aecf3$var$focusFirst($0d95d7873b2aecf3$var$removeLinks($0d95d7873b2aecf3$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0d95d7873b2aecf3$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($0d95d7873b2aecf3$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0d95d7873b2aecf3$var$AUTOFOCUS_ON_UNMOUNT, $0d95d7873b2aecf3$var$EVENT_OPTIONS);
                    container.addEventListener($0d95d7873b2aecf3$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0d95d7873b2aecf3$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($0d95d7873b2aecf3$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0d95d7873b2aecf3$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $exYeM.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $0d95d7873b2aecf3$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0d95d7873b2aecf3$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0d95d7873b2aecf3$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$0d95d7873b2aecf3$export$20e40289641fbbb6.displayName = $0d95d7873b2aecf3$var$FOCUS_SCOPE_NAME;
function $0d95d7873b2aecf3$var$focusFirst(candidates, { select: select = false  } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0d95d7873b2aecf3$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $0d95d7873b2aecf3$var$getTabbableEdges(container) {
    const candidates = $0d95d7873b2aecf3$var$getTabbableCandidates(container);
    const first = $0d95d7873b2aecf3$var$findVisible(candidates, container);
    const last = $0d95d7873b2aecf3$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $0d95d7873b2aecf3$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $0d95d7873b2aecf3$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$0d95d7873b2aecf3$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0d95d7873b2aecf3$var$isHidden(node, { upTo: upTo  }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0d95d7873b2aecf3$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0d95d7873b2aecf3$var$focus(element, { select: select = false  } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $0d95d7873b2aecf3$var$isSelectableInput(element) && select) element.select();
    }
}
var $0d95d7873b2aecf3$var$focusScopesStack = $0d95d7873b2aecf3$var$createFocusScopesStack();
function $0d95d7873b2aecf3$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $0d95d7873b2aecf3$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $0d95d7873b2aecf3$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $0d95d7873b2aecf3$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0d95d7873b2aecf3$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $0d95d7873b2aecf3$export$be92b6f5f03c0fe9 = $0d95d7873b2aecf3$export$20e40289641fbbb6;



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");



"use client";
var $965ca2171585ad7a$var$PORTAL_NAME = "Portal";
var $965ca2171585ad7a$export$602eac185826482c = $exYeM.forwardRef((props, forwardedRef)=>{
    const { container: containerProp , ...portalProps } = props;
    const [mounted, setMounted] = $exYeM.useState(false);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(/* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$965ca2171585ad7a$export$602eac185826482c.displayName = $965ca2171585ad7a$var$PORTAL_NAME;
var $965ca2171585ad7a$export$be92b6f5f03c0fe9 = $965ca2171585ad7a$export$602eac185826482c;



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");


"use client";
function $4a876f8b5705075b$var$useStateMachine(initialState, machine) {
    return $exYeM.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $4a876f8b5705075b$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present , children: children  } = props;
    const presence = $4a876f8b5705075b$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $exYeM.Children.only(children);
    const ref = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(presence.ref, $4a876f8b5705075b$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $exYeM.cloneElement(child, {
        ref: ref
    }) : null;
};
$4a876f8b5705075b$export$99c2b779aa4e8b8b.displayName = "Presence";
function $4a876f8b5705075b$var$usePresence(present) {
    const [node, setNode] = $exYeM.useState();
    const stylesRef = $exYeM.useRef({});
    const prevPresentRef = $exYeM.useRef(present);
    const prevAnimationNameRef = $exYeM.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $4a876f8b5705075b$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $exYeM.useEffect(()=>{
        const currentAnimationName = $4a876f8b5705075b$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $4a876f8b5705075b$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $4a876f8b5705075b$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) $d2lNW.flushSync(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $4a876f8b5705075b$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $exYeM.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $4a876f8b5705075b$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $4a876f8b5705075b$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




var $exYeM = parcelRequire("exYeM");
"use client";
var $c12fde423b091e9b$var$count = 0;
function $c12fde423b091e9b$export$ac5b58043b79449b(props) {
    $c12fde423b091e9b$export$b7ece24a22aeda8c();
    return props.children;
}
function $c12fde423b091e9b$export$b7ece24a22aeda8c() {
    $exYeM.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", edgeGuards[0] ?? $c12fde423b091e9b$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", edgeGuards[1] ?? $c12fde423b091e9b$var$createFocusGuard());
        $c12fde423b091e9b$var$count++;
        return ()=>{
            if ($c12fde423b091e9b$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $c12fde423b091e9b$var$count--;
        };
    }, []);
}
function $c12fde423b091e9b$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
var $c12fde423b091e9b$export$be92b6f5f03c0fe9 = $c12fde423b091e9b$export$ac5b58043b79449b;




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
var $a424de23c132f073$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $a424de23c132f073$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $a424de23c132f073$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $a424de23c132f073$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $exYeM = parcelRequire("exYeM");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $584d39a8643d937a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $exYeM = parcelRequire("exYeM");
function $d00d56265ba92762$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $exYeM.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $d221d2c5d570aa1d$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $exYeM.useLayoutEffect : $exYeM.useEffect;
var $d221d2c5d570aa1d$var$currentValues = new WeakMap();
function $d221d2c5d570aa1d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $d00d56265ba92762$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $d221d2c5d570aa1d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $d221d2c5d570aa1d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $584d39a8643d937a$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $d221d2c5d570aa1d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $f527f4cfb322b92a$var$ItoI(a) {
    return a;
}
function $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $f527f4cfb322b92a$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $f527f4cfb322b92a$var$ItoI;
    return $f527f4cfb322b92a$var$innerCreateMedium(defaults, middleware);
}
function $f527f4cfb322b92a$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $f527f4cfb322b92a$var$innerCreateMedium(null);
    medium.options = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $4fc5d5f926eb9841$export$e27363444bedfeac = (0, $f527f4cfb322b92a$export$e13ec7dd7a14088d)();


var $6c2939159ce57a12$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $6c2939159ce57a12$export$22940b497e769dee = $exYeM.forwardRef(function(props, parentRef) {
    var ref = $exYeM.useRef(null);
    var _a = $exYeM.useState({
        onScrollCapture: $6c2939159ce57a12$var$nothing,
        onWheelCapture: $6c2939159ce57a12$var$nothing,
        onTouchMoveCapture: $6c2939159ce57a12$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $d221d2c5d570aa1d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rest), callbacks);
    return $exYeM.createElement($exYeM.Fragment, null, enabled && $exYeM.createElement(SideCar, {
        sideCar: (0, $4fc5d5f926eb9841$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $exYeM.cloneElement($exYeM.Children.only(children), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)((0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $exYeM.createElement(Container, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$6c2939159ce57a12$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$6c2939159ce57a12$export$22940b497e769dee.classNames = {
    fullWidth: (0, $a424de23c132f073$export$898e37bbd2a0ae4e),
    zeroRight: (0, $a424de23c132f073$export$1da7500147d4bc3)
};




var $exYeM = parcelRequire("exYeM");
var $20ca6eb20b4dc049$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $3433e5a3eb89c040$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $exYeM.createElement(Target, (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, rest));
};
$20ca6eb20b4dc049$var$SideCar.isSideCarExport = true;
function $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $20ca6eb20b4dc049$var$SideCar;
}




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $c01c422d43bc8e57$var$currentNonce;
var $c01c422d43bc8e57$export$c5f670b24c0ae95a = function(nonce) {
    $c01c422d43bc8e57$var$currentNonce = nonce;
};
var $c01c422d43bc8e57$export$2b85b721e524d74b = function() {
    if ($c01c422d43bc8e57$var$currentNonce) return $c01c422d43bc8e57$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $00191a54979f785d$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $c01c422d43bc8e57$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $00191a54979f785d$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $00191a54979f785d$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $00191a54979f785d$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $00191a54979f785d$var$makeStyleTag()) {
                    $00191a54979f785d$var$injectStyles(stylesheet, style);
                    $00191a54979f785d$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $071c3d40780405a9$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $00191a54979f785d$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $exYeM.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $3d3e09c66c873f3e$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $071c3d40780405a9$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $8c733fa2685d08ec$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $8c733fa2685d08ec$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $8c733fa2685d08ec$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $8c733fa2685d08ec$var$parse(left),
        $8c733fa2685d08ec$var$parse(top),
        $8c733fa2685d08ec$var$parse(right)
    ];
};
var $8c733fa2685d08ec$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $8c733fa2685d08ec$export$efed13b5d0ca3386;
    var offsets = $8c733fa2685d08ec$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $b8129a946e86d087$var$Style = (0, $3d3e09c66c873f3e$export$c1248ee86ba532c8)();
var $b8129a946e86d087$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $b8129a946e86d087$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $a424de23c132f073$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($b8129a946e86d087$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " .").concat((0, $a424de23c132f073$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " .").concat((0, $a424de23c132f073$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($b8129a946e86d087$export$65254d5f26cb9564, "] {\n    ").concat((0, $a424de23c132f073$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $b8129a946e86d087$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($b8129a946e86d087$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $b8129a946e86d087$export$a1939b1f9f9b02dc = function() {
    $exYeM.useEffect(function() {
        document.body.setAttribute($b8129a946e86d087$export$65254d5f26cb9564, ($b8129a946e86d087$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $b8129a946e86d087$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($b8129a946e86d087$export$65254d5f26cb9564);
            else document.body.setAttribute($b8129a946e86d087$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $b8129a946e86d087$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $b8129a946e86d087$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $exYeM.useMemo(function() {
        return (0, $8c733fa2685d08ec$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $exYeM.createElement($b8129a946e86d087$var$Style, {
        styles: $b8129a946e86d087$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $00c689171e355a98$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $00c689171e355a98$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $00c689171e355a98$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
    // @ts-ignore
    window.removeEventListener("test", $00c689171e355a98$var$options, $00c689171e355a98$var$options);
} catch (err) {
    $00c689171e355a98$var$passiveSupported = false;
}
var $00c689171e355a98$export$10a6e88623fa9454 = $00c689171e355a98$var$passiveSupported ? {
    passive: false
} : false;


var $895262f629112328$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $895262f629112328$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$895262f629112328$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $895262f629112328$var$elementCouldBeVScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowY");
};
var $895262f629112328$var$elementCouldBeHScrolled = function(node) {
    return $895262f629112328$var$elementCanBeScrolled(node, "overflowX");
};
var $895262f629112328$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $895262f629112328$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $895262f629112328$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $895262f629112328$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $895262f629112328$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $895262f629112328$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$elementCouldBeVScrolled(node) : $895262f629112328$var$elementCouldBeHScrolled(node);
};
var $895262f629112328$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $895262f629112328$var$getVScrollVariables(node) : $895262f629112328$var$getHScrollVariables(node);
};
var $895262f629112328$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $895262f629112328$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $895262f629112328$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $895262f629112328$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($895262f629112328$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $e11a1edcdcbdc39d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $e11a1edcdcbdc39d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $e11a1edcdcbdc39d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $e11a1edcdcbdc39d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $e11a1edcdcbdc39d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $e11a1edcdcbdc39d$var$idCounter = 0;
var $e11a1edcdcbdc39d$var$lockStack = [];
function $e11a1edcdcbdc39d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $exYeM.useRef([]);
    var touchStartRef = $exYeM.useRef([
        0,
        0
    ]);
    var activeAxis = $exYeM.useRef();
    var id = $exYeM.useState($e11a1edcdcbdc39d$var$idCounter++)[0];
    var Style = $exYeM.useState((0, $3d3e09c66c873f3e$export$c1248ee86ba532c8))[0];
    var lastProps = $exYeM.useRef(props);
    $exYeM.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $exYeM.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $3433e5a3eb89c040$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($e11a1edcdcbdc39d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $exYeM.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $895262f629112328$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $895262f629112328$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $895262f629112328$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $exYeM.useCallback(function(_event) {
        var event = _event;
        if (!$e11a1edcdcbdc39d$var$lockStack.length || $e11a1edcdcbdc39d$var$lockStack[$e11a1edcdcbdc39d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event) : $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $e11a1edcdcbdc39d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($e11a1edcdcbdc39d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $exYeM.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $e11a1edcdcbdc39d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $exYeM.useCallback(function(event) {
        touchStartRef.current = $e11a1edcdcbdc39d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $exYeM.useCallback(function(event) {
        shouldCancel(event.type, $e11a1edcdcbdc39d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $exYeM.useEffect(function() {
        $e11a1edcdcbdc39d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $00c689171e355a98$export$10a6e88623fa9454));
        return function() {
            $e11a1edcdcbdc39d$var$lockStack = $e11a1edcdcbdc39d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $00c689171e355a98$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $00c689171e355a98$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $exYeM.createElement($exYeM.Fragment, null, inert ? $exYeM.createElement(Style, {
        styles: $e11a1edcdcbdc39d$var$generateStyle(id)
    }) : null, removeScrollBar ? $exYeM.createElement((0, $b8129a946e86d087$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $e11a1edcdcbdc39d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $5f000f9080e28e0a$export$2e2bcd8739ae039 = (0, $20ca6eb20b4dc049$export$6cacc8fb0a9b94ce)((0, $4fc5d5f926eb9841$export$e27363444bedfeac), (0, $e11a1edcdcbdc39d$export$a09dbff87b5da2d));


var $471317fac98e876e$var$ReactRemoveScroll = $exYeM.forwardRef(function(props, ref) {
    return $exYeM.createElement((0, $6c2939159ce57a12$export$22940b497e769dee), (0, $3433e5a3eb89c040$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $5f000f9080e28e0a$export$2e2bcd8739ae039)
    }));
});
$471317fac98e876e$var$ReactRemoveScroll.classNames = (0, $6c2939159ce57a12$export$22940b497e769dee).classNames;
var $471317fac98e876e$export$2e2bcd8739ae039 = $471317fac98e876e$var$ReactRemoveScroll;


var $ed7fbe99f365bc63$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $ed7fbe99f365bc63$var$counterMap = new WeakMap();
var $ed7fbe99f365bc63$var$uncontrolledNodes = new WeakMap();
var $ed7fbe99f365bc63$var$markerMap = {};
var $ed7fbe99f365bc63$var$lockCount = 0;
var $ed7fbe99f365bc63$var$unwrapHost = function(node) {
    return node && (node.host || $ed7fbe99f365bc63$var$unwrapHost(node.parentNode));
};
var $ed7fbe99f365bc63$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $ed7fbe99f365bc63$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $ed7fbe99f365bc63$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $ed7fbe99f365bc63$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$ed7fbe99f365bc63$var$markerMap[markerName]) $ed7fbe99f365bc63$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $ed7fbe99f365bc63$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($ed7fbe99f365bc63$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $ed7fbe99f365bc63$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $ed7fbe99f365bc63$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $ed7fbe99f365bc63$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $ed7fbe99f365bc63$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $ed7fbe99f365bc63$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$ed7fbe99f365bc63$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $ed7fbe99f365bc63$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $ed7fbe99f365bc63$var$lockCount--;
        if (!$ed7fbe99f365bc63$var$lockCount) {
            // clear
            $ed7fbe99f365bc63$var$counterMap = new WeakMap();
            $ed7fbe99f365bc63$var$counterMap = new WeakMap();
            $ed7fbe99f365bc63$var$uncontrolledNodes = new WeakMap();
            $ed7fbe99f365bc63$var$markerMap = {};
        }
    };
};
var $ed7fbe99f365bc63$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $ed7fbe99f365bc63$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $ed7fbe99f365bc63$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $ed7fbe99f365bc63$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $ed7fbe99f365bc63$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $ed7fbe99f365bc63$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $ed7fbe99f365bc63$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $ed7fbe99f365bc63$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($ed7fbe99f365bc63$export$cc95fea82d705fca() ? $ed7fbe99f365bc63$export$59151cc8db999a24 : $ed7fbe99f365bc63$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};




"use client";
var $d624d4ffa9e1ab8a$var$DIALOG_NAME = "Dialog";
var [$d624d4ffa9e1ab8a$var$createDialogContext, $d624d4ffa9e1ab8a$export$cc702773b8ea3e41] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($d624d4ffa9e1ab8a$var$DIALOG_NAME);
var [$d624d4ffa9e1ab8a$var$DialogProvider, $d624d4ffa9e1ab8a$var$useDialogContext] = $d624d4ffa9e1ab8a$var$createDialogContext($d624d4ffa9e1ab8a$var$DIALOG_NAME);
var $d624d4ffa9e1ab8a$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , modal: modal = true  } = props;
    const triggerRef = $exYeM.useRef(null);
    const contentRef = $exYeM.useRef(null);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        titleId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        descriptionId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $exYeM.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$d624d4ffa9e1ab8a$export$3ddf2d174ce01153.displayName = $d624d4ffa9e1ab8a$var$DIALOG_NAME;
var $d624d4ffa9e1ab8a$var$TRIGGER_NAME = "DialogTrigger";
var $d624d4ffa9e1ab8a$export$2e1e1122cf0cba88 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...triggerProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $d624d4ffa9e1ab8a$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$d624d4ffa9e1ab8a$export$2e1e1122cf0cba88.displayName = $d624d4ffa9e1ab8a$var$TRIGGER_NAME;
var $d624d4ffa9e1ab8a$var$PORTAL_NAME = "DialogPortal";
var [$d624d4ffa9e1ab8a$var$PortalProvider, $d624d4ffa9e1ab8a$var$usePortalContext] = $d624d4ffa9e1ab8a$var$createDialogContext($d624d4ffa9e1ab8a$var$PORTAL_NAME, {
    forceMount: void 0
});
var $d624d4ffa9e1ab8a$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog , forceMount: forceMount , children: children , container: container  } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $exYeM.Children.map(children, (child)=>/* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $965ca2171585ad7a$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$d624d4ffa9e1ab8a$export$dad7c95542bacce0.displayName = $d624d4ffa9e1ab8a$var$PORTAL_NAME;
var $d624d4ffa9e1ab8a$var$OVERLAY_NAME = "DialogOverlay";
var $d624d4ffa9e1ab8a$export$bd1d06c79be19e17 = $exYeM.forwardRef((props, forwardedRef)=>{
    const portalContext = $d624d4ffa9e1ab8a$var$usePortalContext($d624d4ffa9e1ab8a$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...overlayProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$d624d4ffa9e1ab8a$export$bd1d06c79be19e17.displayName = $d624d4ffa9e1ab8a$var$OVERLAY_NAME;
var $d624d4ffa9e1ab8a$var$DialogOverlayImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...overlayProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $471317fac98e876e$export$2e2bcd8739ae039), {
        as: (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
            "data-state": $d624d4ffa9e1ab8a$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $d624d4ffa9e1ab8a$var$CONTENT_NAME = "DialogContent";
var $d624d4ffa9e1ab8a$export$b6d9565de1e068cf = $exYeM.forwardRef((props, forwardedRef)=>{
    const portalContext = $d624d4ffa9e1ab8a$var$usePortalContext($d624d4ffa9e1ab8a$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount , ...contentProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$d624d4ffa9e1ab8a$export$b6d9565de1e068cf.displayName = $d624d4ffa9e1ab8a$var$CONTENT_NAME;
var $d624d4ffa9e1ab8a$var$DialogContentModal = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $exYeM.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $d624d4ffa9e1ab8a$var$DialogContentNonModal = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $exYeM.useRef(false);
    const hasPointerDownOutsideRef = $exYeM.useRef(false);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $d624d4ffa9e1ab8a$var$DialogContentImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , trapFocus: trapFocus , onOpenAutoFocus: onOpenAutoFocus , onCloseAutoFocus: onCloseAutoFocus , ...contentProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    (0, $c12fde423b091e9b$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $0d95d7873b2aecf3$export$20e40289641fbbb6), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $d624d4ffa9e1ab8a$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $d624d4ffa9e1ab8a$var$TITLE_NAME = "DialogTitle";
var $d624d4ffa9e1ab8a$export$16f7638e4a34b909 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...titleProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$d624d4ffa9e1ab8a$export$16f7638e4a34b909.displayName = $d624d4ffa9e1ab8a$var$TITLE_NAME;
var $d624d4ffa9e1ab8a$var$DESCRIPTION_NAME = "DialogDescription";
var $d624d4ffa9e1ab8a$export$94e94c2ec2c954d5 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...descriptionProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$d624d4ffa9e1ab8a$export$94e94c2ec2c954d5.displayName = $d624d4ffa9e1ab8a$var$DESCRIPTION_NAME;
var $d624d4ffa9e1ab8a$var$CLOSE_NAME = "DialogClose";
var $d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog , ...closeProps } = props;
    const context = $d624d4ffa9e1ab8a$var$useDialogContext($d624d4ffa9e1ab8a$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac.displayName = $d624d4ffa9e1ab8a$var$CLOSE_NAME;
function $d624d4ffa9e1ab8a$var$getState(open) {
    return open ? "open" : "closed";
}
var $d624d4ffa9e1ab8a$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$d624d4ffa9e1ab8a$export$69b62a49393917d6, $d624d4ffa9e1ab8a$var$useWarningContext] = (0, $e1a745ecb8941240$export$fd42f52fd3ae1109)($d624d4ffa9e1ab8a$var$TITLE_WARNING_NAME, {
    contentName: $d624d4ffa9e1ab8a$var$CONTENT_NAME,
    titleName: $d624d4ffa9e1ab8a$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $d624d4ffa9e1ab8a$var$TitleWarning = ({ titleId: titleId  })=>{
    const titleWarningContext = $d624d4ffa9e1ab8a$var$useWarningContext($d624d4ffa9e1ab8a$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $exYeM.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $d624d4ffa9e1ab8a$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $d624d4ffa9e1ab8a$var$DescriptionWarning = ({ contentRef: contentRef , descriptionId: descriptionId  })=>{
    const descriptionWarningContext = $d624d4ffa9e1ab8a$var$useWarningContext($d624d4ffa9e1ab8a$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $exYeM.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9 = $d624d4ffa9e1ab8a$export$3ddf2d174ce01153;
var $d624d4ffa9e1ab8a$export$41fb9f06171c75f4 = $d624d4ffa9e1ab8a$export$2e1e1122cf0cba88;
var $d624d4ffa9e1ab8a$export$602eac185826482c = $d624d4ffa9e1ab8a$export$dad7c95542bacce0;
var $d624d4ffa9e1ab8a$export$c6fdb837b070b4ff = $d624d4ffa9e1ab8a$export$bd1d06c79be19e17;
var $d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2 = $d624d4ffa9e1ab8a$export$b6d9565de1e068cf;
var $d624d4ffa9e1ab8a$export$f99233281efd08a0 = $d624d4ffa9e1ab8a$export$16f7638e4a34b909;
var $d624d4ffa9e1ab8a$export$393edc798c47379d = $d624d4ffa9e1ab8a$export$94e94c2ec2c954d5;
var $d624d4ffa9e1ab8a$export$f39c2d165cd861fe = $d624d4ffa9e1ab8a$export$fba2fb7cd781b7ac;






var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");




"use client";
function $ac7c84a01af4e06e$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope , children: children  } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children  } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360), {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef((props, forwardedRef)=>{
        const { scope: scope , children: children , ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
        const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}








// packages/react/direction/src/Direction.tsx

var $exYeM = parcelRequire("exYeM");

var $9cee77c98b858c29$var$DirectionContext = $exYeM.createContext(void 0);
var $9cee77c98b858c29$export$c760c09fdd558351 = (props)=>{
    const { dir: dir , children: children  } = props;
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($9cee77c98b858c29$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $9cee77c98b858c29$export$b39126d51d94e6f3(localDir) {
    const globalDir = $exYeM.useContext($9cee77c98b858c29$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $9cee77c98b858c29$export$2881499e37b75b9a = $9cee77c98b858c29$export$c760c09fdd558351;



"use client";
var $71edc3b1c9a6f9c6$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $71edc3b1c9a6f9c6$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $71edc3b1c9a6f9c6$var$GROUP_NAME = "RovingFocusGroup";
var [$71edc3b1c9a6f9c6$var$Collection, $71edc3b1c9a6f9c6$var$useCollection, $71edc3b1c9a6f9c6$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($71edc3b1c9a6f9c6$var$GROUP_NAME);
var [$71edc3b1c9a6f9c6$var$createRovingFocusGroupContext, $71edc3b1c9a6f9c6$export$c7109489551a4f4] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($71edc3b1c9a6f9c6$var$GROUP_NAME, [
    $71edc3b1c9a6f9c6$var$createCollectionScope
]);
var [$71edc3b1c9a6f9c6$var$RovingFocusProvider, $71edc3b1c9a6f9c6$var$useRovingFocusContext] = $71edc3b1c9a6f9c6$var$createRovingFocusGroupContext($71edc3b1c9a6f9c6$var$GROUP_NAME);
var $71edc3b1c9a6f9c6$export$8699f7c8af148338 = $exYeM.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$71edc3b1c9a6f9c6$export$8699f7c8af148338.displayName = $71edc3b1c9a6f9c6$var$GROUP_NAME;
var $71edc3b1c9a6f9c6$var$RovingFocusGroupImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , orientation: orientation , loop: loop = false , dir: dir , currentTabStopId: currentTabStopIdProp , defaultCurrentTabStopId: defaultCurrentTabStopId , onCurrentTabStopIdChange: onCurrentTabStopIdChange , onEntryFocus: onEntryFocus , preventScrollOnEntryFocus: preventScrollOnEntryFocus = false , ...groupProps } = props;
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $exYeM.useState(false);
    const handleEntryFocus = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $71edc3b1c9a6f9c6$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $exYeM.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $exYeM.useState(0);
    $exYeM.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($71edc3b1c9a6f9c6$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($71edc3b1c9a6f9c6$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $exYeM.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $exYeM.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $exYeM.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $exYeM.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($71edc3b1c9a6f9c6$var$ENTRY_FOCUS, $71edc3b1c9a6f9c6$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $71edc3b1c9a6f9c6$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $71edc3b1c9a6f9c6$var$ITEM_NAME = "RovingFocusGroupItem";
var $71edc3b1c9a6f9c6$export$ab9df7c53fe8454 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup , focusable: focusable = true , active: active = false , tabStopId: tabStopId , ...itemProps } = props;
    const autoId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $71edc3b1c9a6f9c6$var$useRovingFocusContext($71edc3b1c9a6f9c6$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $71edc3b1c9a6f9c6$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd , onFocusableItemRemove: onFocusableItemRemove  } = context;
    $exYeM.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $71edc3b1c9a6f9c6$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $71edc3b1c9a6f9c6$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$71edc3b1c9a6f9c6$var$focusFirst(candidateNodes));
                }
            })
        })
    });
});
$71edc3b1c9a6f9c6$export$ab9df7c53fe8454.displayName = $71edc3b1c9a6f9c6$var$ITEM_NAME;
var $71edc3b1c9a6f9c6$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $71edc3b1c9a6f9c6$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $71edc3b1c9a6f9c6$var$getFocusIntent(event, orientation, dir) {
    const key = $71edc3b1c9a6f9c6$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $71edc3b1c9a6f9c6$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $71edc3b1c9a6f9c6$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $71edc3b1c9a6f9c6$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $71edc3b1c9a6f9c6$export$be92b6f5f03c0fe9 = $71edc3b1c9a6f9c6$export$8699f7c8af148338;
var $71edc3b1c9a6f9c6$export$6d08773d2e66f8f2 = $71edc3b1c9a6f9c6$export$ab9df7c53fe8454;








"use client";
var $7fe50bc4532e8371$var$TABS_NAME = "Tabs";
var [$7fe50bc4532e8371$var$createTabsContext, $7fe50bc4532e8371$export$355f5bd209d7b13a] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($7fe50bc4532e8371$var$TABS_NAME, [
    (0, $71edc3b1c9a6f9c6$export$c7109489551a4f4)
]);
var $7fe50bc4532e8371$var$useRovingFocusGroupScope = (0, $71edc3b1c9a6f9c6$export$c7109489551a4f4)();
var [$7fe50bc4532e8371$var$TabsProvider, $7fe50bc4532e8371$var$useTabsContext] = $7fe50bc4532e8371$var$createTabsContext($7fe50bc4532e8371$var$TABS_NAME);
var $7fe50bc4532e8371$export$b2539bed5023c21c = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: valueProp , onValueChange: onValueChange , defaultValue: defaultValue , orientation: orientation = "horizontal" , dir: dir , activationMode: activationMode = "automatic" , ...tabsProps } = props;
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
            dir: direction,
            "data-orientation": orientation,
            ...tabsProps,
            ref: forwardedRef
        })
    });
});
$7fe50bc4532e8371$export$b2539bed5023c21c.displayName = $7fe50bc4532e8371$var$TABS_NAME;
var $7fe50bc4532e8371$var$TAB_LIST_NAME = "TabsList";
var $7fe50bc4532e8371$export$9712d22edc0d78c1 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , loop: loop = true , ...listProps } = props;
    const context = $7fe50bc4532e8371$var$useTabsContext($7fe50bc4532e8371$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $7fe50bc4532e8371$var$useRovingFocusGroupScope(__scopeTabs);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$export$be92b6f5f03c0fe9, {
        asChild: true,
        ...rovingFocusGroupScope,
        orientation: context.orientation,
        dir: context.dir,
        loop: loop,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
            role: "tablist",
            "aria-orientation": context.orientation,
            ...listProps,
            ref: forwardedRef
        })
    });
});
$7fe50bc4532e8371$export$9712d22edc0d78c1.displayName = $7fe50bc4532e8371$var$TAB_LIST_NAME;
var $7fe50bc4532e8371$var$TRIGGER_NAME = "TabsTrigger";
var $7fe50bc4532e8371$export$8114b9fdfdf9f3ba = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , disabled: disabled = false , ...triggerProps } = props;
    const context = $7fe50bc4532e8371$var$useTabsContext($7fe50bc4532e8371$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $7fe50bc4532e8371$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $7fe50bc4532e8371$var$makeTriggerId(context.baseId, value);
    const contentId = $7fe50bc4532e8371$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($71edc3b1c9a6f9c6$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: isSelected,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, {
            type: "button",
            role: "tab",
            "aria-selected": isSelected,
            "aria-controls": contentId,
            "data-state": isSelected ? "active" : "inactive",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            id: triggerId,
            ...triggerProps,
            ref: forwardedRef,
            onMouseDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
                else event.preventDefault();
            }),
            onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if ([
                    " ",
                    "Enter"
                ].includes(event.key)) context.onValueChange(value);
            }),
            onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(props.onFocus, ()=>{
                const isAutomaticActivation = context.activationMode !== "manual";
                if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
            })
        })
    });
});
$7fe50bc4532e8371$export$8114b9fdfdf9f3ba.displayName = $7fe50bc4532e8371$var$TRIGGER_NAME;
var $7fe50bc4532e8371$var$CONTENT_NAME = "TabsContent";
var $7fe50bc4532e8371$export$bd905d70e8fd2ebb = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs , value: value , forceMount: forceMount , children: children , ...contentProps } = props;
    const context = $7fe50bc4532e8371$var$useTabsContext($7fe50bc4532e8371$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $7fe50bc4532e8371$var$makeTriggerId(context.baseId, value);
    const contentId = $7fe50bc4532e8371$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = $exYeM.useRef(isSelected);
    $exYeM.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $4a876f8b5705075b$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected,
        children: ({ present: present  })=>/* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
                "data-state": isSelected ? "active" : "inactive",
                "data-orientation": context.orientation,
                role: "tabpanel",
                "aria-labelledby": triggerId,
                hidden: !present,
                id: contentId,
                tabIndex: 0,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...props.style,
                    animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
                },
                children: present && children
            })
    });
});
$7fe50bc4532e8371$export$bd905d70e8fd2ebb.displayName = $7fe50bc4532e8371$var$CONTENT_NAME;
function $7fe50bc4532e8371$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $7fe50bc4532e8371$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
var $7fe50bc4532e8371$export$be92b6f5f03c0fe9 = $7fe50bc4532e8371$export$b2539bed5023c21c;
var $7fe50bc4532e8371$export$54c2e3dc7acea9f5 = $7fe50bc4532e8371$export$9712d22edc0d78c1;
var $7fe50bc4532e8371$export$41fb9f06171c75f4 = $7fe50bc4532e8371$export$8114b9fdfdf9f3ba;
var $7fe50bc4532e8371$export$7c6e2c02157bb7d2 = $7fe50bc4532e8371$export$bd905d70e8fd2ebb;


const $bd57f7f38adb375b$var$AuthDialog = ()=>{
    const [email, setEmail] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [password, setPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [confirmPassword, setConfirmPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const { handleLogin: handleLogin , handleSignUp: handleSignUp , handleConfirmSignUp: handleConfirmSignUp , setIsAuthModalOpen: setIsAuthModalOpen  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const [dialogOpen, setDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [code, setCode] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [awaitingConfirmation, setAwaitingConfirmation] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const passwordIsLongEnough = password.length >= 8;
    const passwordContainsNumber = /\d/.test(password);
    const passwordContainsSpecialCharacter = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
    const passwordContainsUppercase = /[A-Z]/.test(password);
    const passwordContainsLowercase = /[a-z]/.test(password);
    const passwordMatchesConfirm = password === confirmPassword && password.length > 0;
    const passwordIsValid = passwordIsLongEnough && passwordContainsNumber && passwordContainsSpecialCharacter && passwordContainsUppercase && passwordContainsLowercase && passwordMatchesConfirm;
    function handleLoginAttempt() {
        handleLogin(email, password);
        setDialogOpen(false);
        setIsAuthModalOpen(false);
    }
    function handleSignUpAttempt() {
        if (!passwordIsValid) {
            window.alert("Password is not valid! Review the requirements!");
            return;
        }
        if (email === "") {
            window.alert("Email not valid!");
            return;
        }
        handleSignUp(email, password);
        setAwaitingConfirmation(true);
    }
    function handleConfirmSignUpAttempt() {
        handleConfirmSignUp(email, code);
        setAwaitingConfirmation(false);
        setTimeout(()=>{
            handleLogin(email, password);
        }, 1000);
        setDialogOpen(false);
        setIsAuthModalOpen(false);
    }
    const signUpForm = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                className: "Text",
                children: "Create an account!"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$393edc798c47379d, {
                className: "AuthDialogDescription"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "email",
                        children: "Email"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        value: email,
                        onChange: (e)=>setEmail(e.target.value),
                        className: "Input",
                        id: "email",
                        type: "email"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "password",
                        children: "Password"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        value: password,
                        onChange: (e)=>setPassword(e.target.value),
                        className: "Input",
                        id: "password",
                        type: "password"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "confirmpassword",
                        children: "Confirm Password"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        value: confirmPassword,
                        onChange: (e)=>setConfirmPassword(e.target.value),
                        className: "Input",
                        id: "password",
                        type: "password"
                    })
                ]
            }),
            passwordIsLongEnough ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">= 8 characters long"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "< 8 characters long!"
            }),
            passwordContainsNumber ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 number"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 number!"
            }),
            passwordContainsSpecialCharacter ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 special character"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 special character"
            }),
            passwordContainsUppercase ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 uppercase letter"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 uppercase letter"
            }),
            passwordContainsLowercase ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: ">=1 lowercase letter"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "<1 lowercase letter"
            }),
            passwordMatchesConfirm ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "green"
                },
                children: "Password matches confirm"
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    color: "red"
                },
                children: "Password & confirm don't match"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    display: "flex",
                    marginTop: 20,
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                    onClick: handleSignUpAttempt,
                    className: "Button green",
                    children: "Sign Up"
                })
            })
        ]
    });
    const confirmForm = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                className: "Text",
                children: `Enter Confirmation Code Sent to ${email}`
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$393edc798c47379d, {
                className: "AuthDialogDescription"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                className: "Fieldset",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                        className: "Label",
                        htmlFor: "code",
                        children: "Confirmation Code"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        value: code,
                        onChange: (e)=>setCode(e.target.value),
                        className: "Input",
                        id: "code",
                        type: "text"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    display: "flex",
                    marginTop: 20,
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                    onClick: handleConfirmSignUpAttempt,
                    className: "Button green",
                    children: "Confirm"
                })
            })
        ]
    });
    const signUpTabContent = awaitingConfirmation ? confirmForm : signUpForm;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9, {
        open: dialogOpen,
        onOpenChange: ()=>{
            setDialogOpen((oldValue)=>{
                setIsAuthModalOpen(!oldValue);
                return !oldValue;
            });
        },
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: "Button violet",
                    children: "Login"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$602eac185826482c, {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$c6fdb837b070b4ff, {
                        className: "AuthDialogOverlay"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2, {
                        className: "AuthDialogContent",
                        asChild: true,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($7fe50bc4532e8371$export$be92b6f5f03c0fe9, {
                            className: "TabsRoot",
                            defaultValue: "tab1",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($7fe50bc4532e8371$export$54c2e3dc7acea9f5, {
                                    className: "TabsList",
                                    "aria-label": "Manage your account",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$export$41fb9f06171c75f4, {
                                            className: "TabsTrigger",
                                            value: "tab1",
                                            children: "Log In"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$export$41fb9f06171c75f4, {
                                            className: "TabsTrigger",
                                            value: "tab2",
                                            children: "Sign Up"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($7fe50bc4532e8371$export$7c6e2c02157bb7d2, {
                                    className: "TabsContent",
                                    value: "tab1",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                            className: "Text",
                                            children: "Your username is your email."
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                            className: "Fieldset",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                                    className: "Label",
                                                    htmlFor: "email",
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                    value: email,
                                                    onChange: (e)=>setEmail(e.target.value),
                                                    className: "Input",
                                                    id: "email",
                                                    type: "email"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                            className: "Fieldset",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                                    className: "Label",
                                                    htmlFor: "password",
                                                    children: "Password"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                    value: password,
                                                    onChange: (e)=>setPassword(e.target.value),
                                                    className: "Input",
                                                    id: "password",
                                                    type: "password"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                marginTop: 20,
                                                justifyContent: "flex-end"
                                            },
                                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                onClick: handleLoginAttempt,
                                                className: "Button green",
                                                children: "Log In"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7fe50bc4532e8371$export$7c6e2c02157bb7d2, {
                                    className: "TabsContent",
                                    value: "tab2",
                                    children: signUpTabContent
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $bd57f7f38adb375b$export$2e2bcd8739ae039 = $bd57f7f38adb375b$var$AuthDialog;






var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c12e32cf04d921d4$var$_excluded = [
    "color"
];
var $c12e32cf04d921d4$export$12f5813a529780ed = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877197 7.49984C0.877197 3.84216 3.84234 0.877014 7.50003 0.877014C11.1577 0.877014 14.1229 3.84216 14.1229 7.49984C14.1229 11.1575 11.1577 14.1227 7.50003 14.1227C3.84234 14.1227 0.877197 11.1575 0.877197 7.49984ZM7.50003 1.82701C4.36702 1.82701 1.8272 4.36683 1.8272 7.49984C1.8272 10.6328 4.36702 13.1727 7.50003 13.1727C10.633 13.1727 13.1729 10.6328 13.1729 7.49984C13.1729 4.36683 10.633 1.82701 7.50003 1.82701ZM7.12457 9.00001C7.06994 9.12735 6.33165 11.9592 6.33165 11.9592C6.26018 12.226 5.98601 12.3843 5.71928 12.3128C5.45255 12.2413 5.29425 11.9672 5.36573 11.7004C5.36573 11.7004 6.24661 8.87268 6.24661 8.27007V6.80099L4.28763 6.27608C4.0209 6.20461 3.86261 5.93045 3.93408 5.66371C4.00555 5.39698 4.27972 5.23869 4.54645 5.31016C4.54645 5.31016 6.20042 5.87268 6.84579 5.87268H8.15505C8.80042 5.87268 10.4534 5.31042 10.4534 5.31042C10.7202 5.23895 10.9943 5.39724 11.0658 5.66397C11.1373 5.93071 10.979 6.20487 10.7122 6.27635L8.74661 6.80303V8.27007C8.74661 8.87268 9.62663 11.6971 9.62663 11.6971C9.6981 11.9639 9.5398 12.238 9.27307 12.3095C9.00634 12.381 8.73217 12.2227 8.6607 11.956C8.6607 11.956 7.91994 9.12735 7.86866 9.00001C7.81994 8.87268 7.65006 8.87268 7.65006 8.87268H7.34317C7.34317 8.87268 7.16994 8.87268 7.12457 9.00001ZM7.50043 5.12007C8.12175 5.12007 8.62543 4.61639 8.62543 3.99507C8.62543 3.37375 8.12175 2.87007 7.50043 2.87007C6.87911 2.87007 6.37543 3.37375 6.37543 3.99507C6.37543 4.61639 6.87911 5.12007 7.50043 5.12007Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1 = [
    "color"
];
var $c12e32cf04d921d4$export$c40c07f3e63e590d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0 1.5C0 1.22386 0.223858 1 0.5 1H2.5C2.77614 1 3 1.22386 3 1.5C3 1.77614 2.77614 2 2.5 2H0.5C0.223858 2 0 1.77614 0 1.5ZM4 1.5C4 1.22386 4.22386 1 4.5 1H14.5C14.7761 1 15 1.22386 15 1.5C15 1.77614 14.7761 2 14.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.77614 11.7761 5 11.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM0 7.5C0 7.22386 0.223858 7 0.5 7H2.5C2.77614 7 3 7.22386 3 7.5C3 7.77614 2.77614 8 2.5 8H0.5C0.223858 8 0 7.77614 0 7.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H4.5C4.22386 11 4 10.7761 4 10.5ZM0 13.5C0 13.2239 0.223858 13 0.5 13H2.5C2.77614 13 3 13.2239 3 13.5C3 13.7761 2.77614 14 2.5 14H0.5C0.223858 14 0 13.7761 0 13.5ZM4 13.5C4 13.2239 4.22386 13 4.5 13H14.5C14.7761 13 15 13.2239 15 13.5C15 13.7761 14.7761 14 14.5 14H4.5C4.22386 14 4 13.7761 4 13.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2 = [
    "color"
];
var $c12e32cf04d921d4$export$315d3fae607b3916 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10.5 1.75003C10.7107 1.75003 10.8988 1.88217 10.9703 2.08042L13.9703 10.4C14.064 10.6598 13.9293 10.9463 13.6696 11.04C13.4098 11.1336 13.1233 10.999 13.0296 10.7392L12.0477 8.01606H8.95227L7.97031 10.7392C7.87664 10.999 7.59012 11.1336 7.33035 11.04C7.07058 10.9463 6.93593 10.6598 7.0296 10.4L10.0296 2.08042C10.1011 1.88217 10.2892 1.75003 10.5 1.75003ZM10.5 3.72402L11.7411 7.16606H9.25877L10.5 3.72402ZM2.49949 2.09997C2.7204 2.09997 2.89949 2.27906 2.89949 2.49997L2.89949 9.53428L4.21664 8.21713C4.37285 8.06092 4.62612 8.06092 4.78233 8.21713C4.93854 8.37334 4.93854 8.6266 4.78233 8.78281L2.78233 10.7828C2.70732 10.8578 2.60557 10.9 2.49949 10.9C2.3934 10.9 2.29166 10.8578 2.21664 10.7828L0.216645 8.78281C0.0604349 8.6266 0.0604349 8.37334 0.216645 8.21713C0.372854 8.06092 0.62612 8.06092 0.78233 8.21713L2.09949 9.53428L2.09949 2.49997C2.09949 2.27906 2.27857 2.09997 2.49949 2.09997ZM0.0999695 13.5001C0.0999695 13.2791 0.279056 13.1001 0.499969 13.1001H14.5C14.7209 13.1001 14.9 13.2791 14.9 13.5001C14.9 13.721 14.7209 13.9001 14.5 13.9001H0.499969C0.279056 13.9001 0.0999695 13.721 0.0999695 13.5001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3 = [
    "color"
];
var $c12e32cf04d921d4$export$28c63a2a77a6b6ba = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9 3C9 2.44772 8.55229 2 8 2H7C6.44772 2 6 2.44772 6 3L6 14H1.5C1.22386 14 1 14.2239 1 14.5C1 14.7761 1.22386 15 1.5 15L6 15H9H13.5C13.7761 15 14 14.7761 14 14.5C14 14.2239 13.7761 14 13.5 14H9V3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4 = [
    "color"
];
var $c12e32cf04d921d4$export$5284d356b9eb3ea0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.99988 6C1.44759 6 0.999877 6.44772 0.999877 7L0.999877 8C0.999877 8.55228 1.44759 9 1.99988 9L6.99988 9L6.99988 13.5C6.99988 13.7761 7.22374 14 7.49988 14C7.77602 14 7.99988 13.7761 7.99988 13.5L7.99988 9L12.9999 9C13.5522 9 13.9999 8.55228 13.9999 8L13.9999 7C13.9999 6.44772 13.5522 6 12.9999 6L7.99988 6L7.99988 1.5C7.99988 1.22386 7.77602 1 7.49988 1C7.22373 1 6.99988 1.22386 6.99988 1.5L6.99988 6L1.99988 6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$5 = [
    "color"
];
var $c12e32cf04d921d4$export$a87e0381c7863d70 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$5);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.99988 1C6.44759 1 5.99988 1.44772 5.99988 2V7H1.49988C1.22374 7 0.999878 7.22386 0.999878 7.5C0.999878 7.77614 1.22374 8 1.49988 8H5.99988V13C5.99988 13.5523 6.44759 14 6.99988 14H7.99988C8.55216 14 8.99988 13.5523 8.99988 13V8H13.4999C13.776 8 13.9999 7.77614 13.9999 7.5C13.9999 7.22386 13.776 7 13.4999 7H8.99988V2C8.99988 1.44772 8.55216 1 7.99988 1L6.99988 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$6 = [
    "color"
];
var $c12e32cf04d921d4$export$43a2a6205c884160 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$6);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.499995 0.999995C0.223855 0.999995 -5.58458e-07 1.22385 -5.46388e-07 1.49999L-2.18554e-08 13.4999C-9.78492e-09 13.776 0.223855 13.9999 0.499995 13.9999C0.776136 13.9999 0.999991 13.776 0.999991 13.4999L0.999991 8.99993L12 8.99993C12.5523 8.99993 13 8.55222 13 7.99993L13 6.99994C13 6.44766 12.5523 5.99995 12 5.99995L0.999991 5.99995L0.999991 1.49999C0.999991 1.22385 0.776135 0.999995 0.499995 0.999995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$7 = [
    "color"
];
var $c12e32cf04d921d4$export$589ba7400e24d687 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$7);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14.4999 1C14.2237 1 13.9999 1.22386 13.9999 1.5L13.9999 6L2.99988 6C2.44759 6 1.99988 6.44772 1.99988 7L1.99988 8C1.99988 8.55228 2.44759 9 2.99988 9L13.9999 9L13.9999 13.5C13.9999 13.7761 14.2237 14 14.4999 14C14.776 14 14.9999 13.7761 14.9999 13.5L14.9999 9L14.9999 6L14.9999 1.5C14.9999 1.22386 14.776 1 14.4999 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$8 = [
    "color"
];
var $c12e32cf04d921d4$export$359aaf594ac84c59 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$8);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 0C1.22386 0 1 0.223858 1 0.5C1 0.776142 1.22386 1 1.5 1H6V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V1H13.5C13.7761 1 14 0.776142 14 0.5C14 0.223858 13.7761 0 13.5 0H9H6H1.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$9 = [
    "color"
];
var $c12e32cf04d921d4$export$c5eda4f4203e72ab = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$9);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 0.75L9.75 3H5.25L7.5 0.75ZM7.5 14.25L9.75 12H5.25L7.5 14.25ZM3 5.25L0.75 7.5L3 9.75V5.25ZM14.25 7.5L12 5.25V9.75L14.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$a = [
    "color"
];
var $c12e32cf04d921d4$export$c3671dfffcc20189 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$a);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.8914 2.1937C9.1158 2.35464 9.16725 2.66701 9.00631 2.89141L2.47388 12H13.5C13.7761 12 14 12.2239 14 12.5C14 12.7762 13.7761 13 13.5 13H1.5C1.31254 13 1.14082 12.8952 1.0552 12.7284C0.969578 12.5616 0.984438 12.361 1.09369 12.2086L8.19369 2.30862C8.35462 2.08422 8.667 2.03277 8.8914 2.1937ZM11.1 6.50001C11.1 6.22387 11.3238 6.00001 11.6 6.00001C11.8761 6.00001 12.1 6.22387 12.1 6.50001C12.1 6.77615 11.8761 7.00001 11.6 7.00001C11.3238 7.00001 11.1 6.77615 11.1 6.50001ZM10.4 4.00001C10.1239 4.00001 9.90003 4.22387 9.90003 4.50001C9.90003 4.77615 10.1239 5.00001 10.4 5.00001C10.6762 5.00001 10.9 4.77615 10.9 4.50001C10.9 4.22387 10.6762 4.00001 10.4 4.00001ZM12.1 8.50001C12.1 8.22387 12.3238 8.00001 12.6 8.00001C12.8761 8.00001 13.1 8.22387 13.1 8.50001C13.1 8.77615 12.8761 9.00001 12.6 9.00001C12.3238 9.00001 12.1 8.77615 12.1 8.50001ZM13.4 10C13.1239 10 12.9 10.2239 12.9 10.5C12.9 10.7761 13.1239 11 13.4 11C13.6762 11 13.9 10.7761 13.9 10.5C13.9 10.2239 13.6762 10 13.4 10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$b = [
    "color"
];
var $c12e32cf04d921d4$export$64abfa02d870a554 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$b);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.30902 1C2.93025 1 2.58398 1.214 2.41459 1.55279L1.05279 4.27639C1.01807 4.34582 1 4.42238 1 4.5V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V4.5C14 4.42238 13.9819 4.34582 13.9472 4.27639L12.5854 1.55281C12.416 1.21403 12.0698 1.00003 11.691 1.00003L7.5 1.00001L3.30902 1ZM3.30902 2L7 2.00001V4H2.30902L3.30902 2ZM8 4V2.00002L11.691 2.00003L12.691 4H8ZM7.5 5H13V13H2V5H7.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H9.5C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7H5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$c = [
    "color"
];
var $c12e32cf04d921d4$export$ba8ee9ef4800b4a5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$c);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.3536 3.64644C11.5488 3.8417 11.5488 4.15828 11.3536 4.35354L4.70711 11L9 11C9.27614 11 9.5 11.2239 9.5 11.5C9.5 11.7761 9.27614 12 9 12L3.5 12C3.36739 12 3.24021 11.9473 3.14645 11.8536C3.05268 11.7598 3 11.6326 3 11.5L3 5.99999C3 5.72385 3.22386 5.49999 3.5 5.49999C3.77614 5.49999 4 5.72385 4 5.99999V10.2929L10.6464 3.64643C10.8417 3.45117 11.1583 3.45117 11.3536 3.64644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$d = [
    "color"
];
var $c12e32cf04d921d4$export$1a0b00ff4e10643e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$d);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.64645 3.64644C3.45118 3.8417 3.45118 4.15828 3.64645 4.35354L10.2929 11L6 11C5.72386 11 5.5 11.2239 5.5 11.5C5.5 11.7761 5.72386 12 6 12L11.5 12C11.6326 12 11.7598 11.9473 11.8536 11.8536C11.9473 11.7598 12 11.6326 12 11.5L12 5.99999C12 5.72385 11.7761 5.49999 11.5 5.49999C11.2239 5.49999 11 5.72385 11 5.99999V10.2929L4.35355 3.64643C4.15829 3.45117 3.84171 3.45117 3.64645 3.64644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$e = [
    "color"
];
var $c12e32cf04d921d4$export$1c939d3c9b6931b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$e);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 11.2929L11.1464 8.14645C11.3417 7.95118 11.6583 7.95118 11.8536 8.14645C12.0488 8.34171 12.0488 8.65829 11.8536 8.85355L7.85355 12.8536C7.75979 12.9473 7.63261 13 7.5 13C7.36739 13 7.24021 12.9473 7.14645 12.8536L3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645C3.34171 7.95118 3.65829 7.95118 3.85355 8.14645L7 11.2929L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$f = [
    "color"
];
var $c12e32cf04d921d4$export$8afed21ef5c2afa5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$f);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$g = [
    "color"
];
var $c12e32cf04d921d4$export$9ca09caa9c849d9c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$g);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$h = [
    "color"
];
var $c12e32cf04d921d4$export$9f5fe8cc556ac1f3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$h);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6465L4.70711 4L9 4C9.27614 4 9.5 3.77614 9.5 3.5C9.5 3.22386 9.27614 3 9 3L3.5 3C3.36739 3 3.24021 3.05268 3.14645 3.14645C3.05268 3.24022 3 3.36739 3 3.5L3 9.00001C3 9.27615 3.22386 9.50001 3.5 9.50001C3.77614 9.50001 4 9.27615 4 9.00001V4.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$i = [
    "color"
];
var $c12e32cf04d921d4$export$64a9bd58f7494197 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$i);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$j = [
    "color"
];
var $c12e32cf04d921d4$export$f1a507b991affc46 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$j);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.14645 2.14645C7.34171 1.95118 7.65829 1.95118 7.85355 2.14645L11.8536 6.14645C12.0488 6.34171 12.0488 6.65829 11.8536 6.85355C11.6583 7.04882 11.3417 7.04882 11.1464 6.85355L8 3.70711L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 3.70711L3.85355 6.85355C3.65829 7.04882 3.34171 7.04882 3.14645 6.85355C2.95118 6.65829 2.95118 6.34171 3.14645 6.14645L7.14645 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$k = [
    "color"
];
var $c12e32cf04d921d4$export$843c734d18c2237 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$k);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.5 2H12.5C12.7761 2 13 2.22386 13 2.5V12.5C13 12.7761 12.7761 13 12.5 13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5ZM7.5 4C7.77614 4 8 3.77614 8 3.5C8 3.22386 7.77614 3 7.5 3C7.22386 3 7 3.22386 7 3.5C7 3.77614 7.22386 4 7.5 4ZM8 5.5C8 5.77614 7.77614 6 7.5 6C7.22386 6 7 5.77614 7 5.5C7 5.22386 7.22386 5 7.5 5C7.77614 5 8 5.22386 8 5.5ZM7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8ZM10 7.5C10 7.77614 9.77614 8 9.5 8C9.22386 8 9 7.77614 9 7.5C9 7.22386 9.22386 7 9.5 7C9.77614 7 10 7.22386 10 7.5ZM11.5 8C11.7761 8 12 7.77614 12 7.5C12 7.22386 11.7761 7 11.5 7C11.2239 7 11 7.22386 11 7.5C11 7.77614 11.2239 8 11.5 8Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$l = [
    "color"
];
var $c12e32cf04d921d4$export$b1f22795a41806ac = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$l);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$m = [
    "color"
];
var $c12e32cf04d921d4$export$a7965fbad5d67169 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$m);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 1C5 0.447715 5.44772 0 6 0H9C9.55228 0 10 0.447715 10 1V2H14C14.5523 2 15 2.44772 15 3V6C15 6.8888 14.6131 7.68734 14 8.23608V11.5C14 12.3284 13.3284 13 12.5 13H2.5C1.67157 13 1 12.3284 1 11.5V8.2359C0.38697 7.68721 0 6.88883 0 6V3C0 2.44772 0.447716 2 1 2H5V1ZM9 1V2H6V1H9ZM1 3H5H5.5H9.5H10H14V6C14 6.654 13.6866 7.23467 13.1997 7.6004C12.8655 7.85144 12.4508 8 12 8H8V7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5V8H3C2.5493 8 2.1346 7.85133 1.80029 7.60022C1.31335 7.23446 1 6.65396 1 6V3ZM7 9H3C2.64961 9 2.31292 8.93972 2 8.82905V11.5C2 11.7761 2.22386 12 2.5 12H12.5C12.7761 12 13 11.7761 13 11.5V8.82915C12.6871 8.93978 12.3504 9 12 9H8V9.5C8 9.77614 7.77614 10 7.5 10C7.22386 10 7 9.77614 7 9.5V9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$n = [
    "color"
];
var $c12e32cf04d921d4$export$e32f68df2d27987 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$n);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 6H11.5C12.3284 6 13 6.67157 13 7.5C13 8.32843 12.3284 9 11.5 9H3.5C2.67157 9 2 8.32843 2 7.5C2 6.67157 2.67157 6 3.5 6ZM1 7.5C1 6.11929 2.11929 5 3.5 5H11.5C12.8807 5 14 6.11929 14 7.5C14 8.88071 12.8807 10 11.5 10H3.5C2.11929 10 1 8.88071 1 7.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$o = [
    "color"
];
var $c12e32cf04d921d4$export$472946dc5493045a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$o);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.5 1C11.7761 1 12 1.22386 12 1.5V13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V1.5C11 1.22386 11.2239 1 11.5 1ZM9.5 3C9.77614 3 10 3.22386 10 3.5V13.5C10 13.7761 9.77614 14 9.5 14C9.22386 14 9 13.7761 9 13.5V3.5C9 3.22386 9.22386 3 9.5 3ZM13.5 3C13.7761 3 14 3.22386 14 3.5V13.5C14 13.7761 13.7761 14 13.5 14C13.2239 14 13 13.7761 13 13.5V3.5C13 3.22386 13.2239 3 13.5 3ZM5.5 4C5.77614 4 6 4.22386 6 4.5V13.5C6 13.7761 5.77614 14 5.5 14C5.22386 14 5 13.7761 5 13.5V4.5C5 4.22386 5.22386 4 5.5 4ZM1.5 5C1.77614 5 2 5.22386 2 5.5V13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5V5.5C1 5.22386 1.22386 5 1.5 5ZM7.5 5C7.77614 5 8 5.22386 8 5.5V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.5C7 5.22386 7.22386 5 7.5 5ZM3.5 7C3.77614 7 4 7.22386 4 7.5V13.5C4 13.7761 3.77614 14 3.5 14C3.22386 14 3 13.7761 3 13.5V7.5C3 7.22386 3.22386 7 3.5 7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$p = [
    "color"
];
var $c12e32cf04d921d4$export$2235404cc2cfe93c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$p);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.60124 1.25086C8.60124 1.75459 8.26278 2.17927 7.80087 2.30989C10.1459 2.4647 12 4.41582 12 6.79999V10.25C12 11.0563 12.0329 11.7074 12.7236 12.0528C12.931 12.1565 13.0399 12.3892 12.9866 12.6149C12.9333 12.8406 12.7319 13 12.5 13H8.16144C8.36904 13.1832 8.49997 13.4513 8.49997 13.75C8.49997 14.3023 8.05226 14.75 7.49997 14.75C6.94769 14.75 6.49997 14.3023 6.49997 13.75C6.49997 13.4513 6.63091 13.1832 6.83851 13H2.49999C2.2681 13 2.06664 12.8406 2.01336 12.6149C1.96009 12.3892 2.06897 12.1565 2.27638 12.0528C2.96708 11.7074 2.99999 11.0563 2.99999 10.25V6.79999C2.99999 4.41537 4.85481 2.46396 7.20042 2.3098C6.73867 2.17908 6.40036 1.75448 6.40036 1.25086C6.40036 0.643104 6.89304 0.150421 7.5008 0.150421C8.10855 0.150421 8.60124 0.643104 8.60124 1.25086ZM7.49999 3.29999C5.56699 3.29999 3.99999 4.86699 3.99999 6.79999V10.25L4.00002 10.3009C4.0005 10.7463 4.00121 11.4084 3.69929 12H11.3007C10.9988 11.4084 10.9995 10.7463 11 10.3009L11 10.25V6.79999C11 4.86699 9.43299 3.29999 7.49999 3.29999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$q = [
    "color"
];
var $c12e32cf04d921d4$export$cd91dad3f7d2f1be = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 9C3 6.5 4.5 4.25 7.5 1.5C10.5 4.25 12 6.5 12 9C12 11.4853 9.98528 13.5 7.5 13.5C5.01472 13.5 3 11.4853 3 9ZM10.9524 8.30307C9.67347 7.82121 8.2879 8.46208 6.98956 9.06259C5.9327 9.55142 4.93365 10.0135 4.09695 9.82153C4.03357 9.55804 4 9.28294 4 9C4 7.11203 5.02686 5.27195 7.5 2.87357C9.66837 4.97639 10.725 6.65004 10.9524 8.30307Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$r = [
    "color"
];
var $c12e32cf04d921d4$export$93cb139c864b0aec = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$r);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H11.5C11.7761 2 12 2.22386 12 2.5V13.5C12 13.6818 11.9014 13.8492 11.7424 13.9373C11.5834 14.0254 11.3891 14.0203 11.235 13.924L7.5 11.5896L3.765 13.924C3.61087 14.0203 3.41659 14.0254 3.25762 13.9373C3.09864 13.8492 3 13.6818 3 13.5V2.5ZM4 3V12.5979L6.97 10.7416C7.29427 10.539 7.70573 10.539 8.03 10.7416L11 12.5979V3H4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$s = [
    "color"
];
var $c12e32cf04d921d4$export$77df11a9db3bfb4e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$s);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V13.5C3 13.6818 3.09864 13.8492 3.25762 13.9373C3.41659 14.0254 3.61087 14.0203 3.765 13.924L7.5 11.5896L11.235 13.924C11.3891 14.0203 11.5834 14.0254 11.7424 13.9373C11.9014 13.8492 12 13.6818 12 13.5V2.5C12 2.22386 11.7761 2 11.5 2H3.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$t = [
    "color"
];
var $c12e32cf04d921d4$export$2b8bb78df07fc3c1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$t);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H14C14.4142 0.25 14.75 0.585786 14.75 1V14C14.75 14.4142 14.4142 14.75 14 14.75H1C0.585786 14.75 0.25 14.4142 0.25 14V1ZM1.75 1.75V13.25H13.25V1.75H1.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$u = [
    "color"
];
var $c12e32cf04d921d4$export$1986587b5169c3d1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$u);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 13.25L14 13.25V14.75L1 14.75V13.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$v = [
    "color"
];
var $c12e32cf04d921d4$export$9e3588048b381346 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$v);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$w = [
    "color"
];
var $c12e32cf04d921d4$export$db4fc3403d513c1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$w);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 6.625C1.01675 6.625 0.625 7.01675 0.625 7.5C0.625 7.98325 1.01675 8.375 1.5 8.375C1.98325 8.375 2.375 7.98325 2.375 7.5C2.375 7.01675 1.98325 6.625 1.5 6.625ZM5.5 6.625C5.01675 6.625 4.625 7.01675 4.625 7.5C4.625 7.98325 5.01675 8.375 5.5 8.375C5.98325 8.375 6.375 7.98325 6.375 7.5C6.375 7.01675 5.98325 6.625 5.5 6.625ZM9.5 6.625C9.01675 6.625 8.625 7.01675 8.625 7.5C8.625 7.98325 9.01675 8.375 9.5 8.375C9.98325 8.375 10.375 7.98325 10.375 7.5C10.375 7.01675 9.98325 6.625 9.5 6.625ZM12.625 7.5C12.625 7.01675 13.0168 6.625 13.5 6.625C13.9832 6.625 14.375 7.01675 14.375 7.5C14.375 7.98325 13.9832 8.375 13.5 8.375C13.0168 8.375 12.625 7.98325 12.625 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$x = [
    "color"
];
var $c12e32cf04d921d4$export$90857351d8240996 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$x);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.75 1L1.75 14L0.249999 14L0.25 1L1.75 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("rect", {
        x: "10",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "10",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "12",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "12",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 5)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "5",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 5)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 3)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "3",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 3)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 9)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "9",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 9)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 11)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "11",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 11)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "6",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "6",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "4",
        y: "7",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "4",
        y: "13",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "10",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 10 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "12",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 12 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 8 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 14 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "6",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 6 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "4",
        y: "1",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(90 4 1)",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$y = [
    "color"
];
var $c12e32cf04d921d4$export$fc99bfbabe8fe100 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$z = [
    "color"
];
var $c12e32cf04d921d4$export$d19e24a090b81f38 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.25 1L13.25 14L14.75 14L14.75 1L13.25 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 5)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 5)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 3)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 3)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 9)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 9)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 11)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 11)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 7)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 13)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 5 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 3 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 7 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 1 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 9 1)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        width: "1",
        height: "1",
        rx: ".5",
        transform: "matrix(0 1 1 0 11 1)",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$A = [
    "color"
];
var $c12e32cf04d921d4$export$ca09e5ae294d45cc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$A);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$B = [
    "color"
];
var $c12e32cf04d921d4$export$fbe2d4727aba00b7 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$B);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "5.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "3.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "13.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "1.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "13",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "5",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "3",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "9",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "11",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "9.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "7",
        y: "11.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "1",
        y: "7.025",
        width: "1",
        height: "1",
        rx: ".5",
        fill: color
    }), (0, $exYeM.createElement)("path", {
        d: "M1 1.49994C1 1.2238 1.22386 0.999939 1.5 0.999939H6V1.99994H2V5.99994H1V1.49994ZM13 1.99994H9V0.999939H13.5C13.7761 0.999939 14 1.2238 14 1.49994V5.99994H13V1.99994ZM1 13.4999V8.99994H2V12.9999H6V13.9999H1.5C1.22386 13.9999 1 13.7761 1 13.4999ZM13 12.9999V8.99994H14V13.4999C14 13.7761 13.7761 13.9999 13.5 13.9999H9.5V12.9999H13Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$C = [
    "color"
];
var $c12e32cf04d921d4$export$99084cce0e645aeb = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$C);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H3.5C3.77614 7 4 7.22386 4 7.5C4 7.77614 3.77614 8 3.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11ZM11 11.5C11 11.2239 11.2239 11 11.5 11C11.7761 11 12 11.2239 12 11.5C12 11.7761 11.7761 12 11.5 12C11.2239 12 11 11.7761 11 11.5ZM13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11ZM6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H8.5C8.77614 8 9 7.77614 9 7.5C9 7.22386 8.77614 7 8.5 7H6.5ZM11 7.5C11 7.22386 11.2239 7 11.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H11.5C11.2239 8 11 7.77614 11 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$D = [
    "color"
];
var $c12e32cf04d921d4$export$c244c53943ad4d08 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$D);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14 1.75L1 1.75L1 0.249999L14 0.25L14 1.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 10)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 10)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 12)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 12)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "10",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 10 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "10",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 10 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "12",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 12 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "12",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 12 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "6",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 6 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "6",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 6 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "4",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 4 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "4",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 4 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 6)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 6)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "8",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 8 4)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "2",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 2 4)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "10",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 10)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "12",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 12)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "8",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 8)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "14",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 14)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "6",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 6)",
        fill: color
    }), (0, $exYeM.createElement)("rect", {
        x: "14",
        y: "4",
        width: "1",
        height: "1",
        rx: ".5",
        transform: "rotate(-180 14 4)",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$E = [
    "color"
];
var $c12e32cf04d921d4$export$26dc332286fcc660 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$E);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 3H14V4H1V3ZM1 6H14V8H1V6ZM14 10.25H1V12.75H14V10.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$F = [
    "color"
];
var $c12e32cf04d921d4$export$adedf1569d7107de = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$F);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.5 2H2.5C2.22386 2 2 2.22386 2 2.5V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$G = [
    "color"
];
var $c12e32cf04d921d4$export$742ea6014cb11378 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$G);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.99998 0.999976C1.44769 0.999976 0.999976 1.44769 0.999976 1.99998V13C0.999976 13.5523 1.44769 14 1.99998 14H13C13.5523 14 14 13.5523 14 13V1.99998C14 1.44769 13.5523 0.999976 13 0.999976H1.99998ZM1.99998 1.99998L13 1.99998V13H1.99998V1.99998ZM4.49996 3.99996C4.22382 3.99996 3.99996 4.22382 3.99996 4.49996V10.5C3.99996 10.7761 4.22382 11 4.49996 11H10.5C10.7761 11 11 10.7761 11 10.5V4.49996C11 4.22382 10.7761 3.99996 10.5 3.99996H4.49996ZM4.99996 9.99996V4.99996H9.99996V9.99996H4.99996Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$H = [
    "color"
];
var $c12e32cf04d921d4$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$H);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H2C1.44772 10 1 9.55228 1 9V6C1 5.44772 1.44772 5 2 5ZM0 6C0 4.89543 0.895431 4 2 4H13C14.1046 4 15 4.89543 15 6V9C15 10.1046 14.1046 11 13 11H2C0.89543 11 0 10.1046 0 9V6ZM4.5 6.75C4.08579 6.75 3.75 7.08579 3.75 7.5C3.75 7.91421 4.08579 8.25 4.5 8.25C4.91421 8.25 5.25 7.91421 5.25 7.5C5.25 7.08579 4.91421 6.75 4.5 6.75ZM6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5C8.25 7.91421 7.91421 8.25 7.5 8.25C7.08579 8.25 6.75 7.91421 6.75 7.5ZM10.5 6.75C10.0858 6.75 9.75 7.08579 9.75 7.5C9.75 7.91421 10.0858 8.25 10.5 8.25C10.9142 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 10.9142 6.75 10.5 6.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$I = [
    "color"
];
var $c12e32cf04d921d4$export$5fda1783bb83f57b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$I);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.5 1C4.77614 1 5 1.22386 5 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12.5C13.3284 2 14 2.67157 14 3.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V3.5C1 2.67157 1.67157 2 2.5 2H4V1.5C4 1.22386 4.22386 1 4.5 1ZM10 3V3.5C10 3.77614 10.2239 4 10.5 4C10.7761 4 11 3.77614 11 3.5V3H12.5C12.7761 3 13 3.22386 13 3.5V5H2V3.5C2 3.22386 2.22386 3 2.5 3H4V3.5C4 3.77614 4.22386 4 4.5 4C4.77614 4 5 3.77614 5 3.5V3H10ZM2 6V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V6H2ZM7 7.5C7 7.22386 7.22386 7 7.5 7C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8C7.22386 8 7 7.77614 7 7.5ZM9.5 7C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7ZM11 7.5C11 7.22386 11.2239 7 11.5 7C11.7761 7 12 7.22386 12 7.5C12 7.77614 11.7761 8 11.5 8C11.2239 8 11 7.77614 11 7.5ZM11.5 9C11.2239 9 11 9.22386 11 9.5C11 9.77614 11.2239 10 11.5 10C11.7761 10 12 9.77614 12 9.5C12 9.22386 11.7761 9 11.5 9ZM9 9.5C9 9.22386 9.22386 9 9.5 9C9.77614 9 10 9.22386 10 9.5C10 9.77614 9.77614 10 9.5 10C9.22386 10 9 9.77614 9 9.5ZM7.5 9C7.22386 9 7 9.22386 7 9.5C7 9.77614 7.22386 10 7.5 10C7.77614 10 8 9.77614 8 9.5C8 9.22386 7.77614 9 7.5 9ZM5 9.5C5 9.22386 5.22386 9 5.5 9C5.77614 9 6 9.22386 6 9.5C6 9.77614 5.77614 10 5.5 10C5.22386 10 5 9.77614 5 9.5ZM3.5 9C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10C3.77614 10 4 9.77614 4 9.5C4 9.22386 3.77614 9 3.5 9ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$J = [
    "color"
];
var $c12e32cf04d921d4$export$1bd12807c2fea239 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$J);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 3C1.44772 3 1 3.44772 1 4V11C1 11.5523 1.44772 12 2 12H13C13.5523 12 14 11.5523 14 11V4C14 3.44772 13.5523 3 13 3H2ZM0 4C0 2.89543 0.895431 2 2 2H13C14.1046 2 15 2.89543 15 4V11C15 12.1046 14.1046 13 13 13H2C0.895431 13 0 12.1046 0 11V4ZM2 4.25C2 4.11193 2.11193 4 2.25 4H4.75C4.88807 4 5 4.11193 5 4.25V5.75454C5 5.89261 4.88807 6.00454 4.75 6.00454H2.25C2.11193 6.00454 2 5.89261 2 5.75454V4.25ZM12.101 7.58421C12.101 9.02073 10.9365 10.1853 9.49998 10.1853C8.06346 10.1853 6.89893 9.02073 6.89893 7.58421C6.89893 6.14769 8.06346 4.98315 9.49998 4.98315C10.9365 4.98315 12.101 6.14769 12.101 7.58421ZM13.101 7.58421C13.101 9.57302 11.4888 11.1853 9.49998 11.1853C7.51117 11.1853 5.89893 9.57302 5.89893 7.58421C5.89893 5.5954 7.51117 3.98315 9.49998 3.98315C11.4888 3.98315 13.101 5.5954 13.101 7.58421Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$K = [
    "color"
];
var $c12e32cf04d921d4$export$16dbc2701f60a606 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$K);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$L = [
    "color"
];
var $c12e32cf04d921d4$export$cf8d533bd52e80e3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$L);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.5 3C2.22386 3 2 3.22386 2 3.5V9.5C2 9.77614 2.22386 10 2.5 10H12.5C12.7761 10 13 9.77614 13 9.5V3.5C13 3.22386 12.7761 3 12.5 3H2.5ZM1 9.5C1 10.1531 1.4174 10.7087 2 10.9146V11.5C2 12.3284 2.67157 13 3.5 13H11.5C12.3284 13 13 12.3284 13 11.5V10.9146C13.5826 10.7087 14 10.1531 14 9.5V3.5C14 2.67157 13.3284 2 12.5 2H2.5C1.67157 2 1 2.67157 1 3.5V9.5ZM12 11.5V11H3V11.5C3 11.7761 3.22386 12 3.5 12H11.5C11.7761 12 12 11.7761 12 11.5ZM5.5 6C5.22386 6 5 6.22386 5 6.5C5 6.77614 5.22386 7 5.5 7H9.5C9.77614 7 10 6.77614 10 6.5C10 6.22386 9.77614 6 9.5 6H5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$M = [
    "color"
];
var $c12e32cf04d921d4$export$e590b2572239e122 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$M);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12ZM5 6.5C5 6.22386 5.22386 6 5.5 6H7V4.5C7 4.22386 7.22386 4 7.5 4C7.77614 4 8 4.22386 8 4.5V6H9.5C9.77614 6 10 6.22386 10 6.5C10 6.77614 9.77614 7 9.5 7H8V8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5V7H5.5C5.22386 7 5 6.77614 5 6.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$N = [
    "color"
];
var $c12e32cf04d921d4$export$73a4c78a4a00962 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$N);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$O = [
    "color"
];
var $c12e32cf04d921d4$export$810196a5854768f3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$O);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.81809 4.18179C8.99383 4.35753 8.99383 4.64245 8.81809 4.81819L6.13629 7.49999L8.81809 10.1818C8.99383 10.3575 8.99383 10.6424 8.81809 10.8182C8.64236 10.9939 8.35743 10.9939 8.1817 10.8182L5.1817 7.81819C5.09731 7.73379 5.0499 7.61933 5.0499 7.49999C5.0499 7.38064 5.09731 7.26618 5.1817 7.18179L8.1817 4.18179C8.35743 4.00605 8.64236 4.00605 8.81809 4.18179Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$P = [
    "color"
];
var $c12e32cf04d921d4$export$5e4a7579d3e78657 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$P);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.18194 4.18185C6.35767 4.00611 6.6426 4.00611 6.81833 4.18185L9.81833 7.18185C9.90272 7.26624 9.95013 7.3807 9.95013 7.50005C9.95013 7.6194 9.90272 7.73386 9.81833 7.81825L6.81833 10.8182C6.6426 10.994 6.35767 10.994 6.18194 10.8182C6.0062 10.6425 6.0062 10.3576 6.18194 10.1819L8.86374 7.50005L6.18194 4.81825C6.0062 4.64251 6.0062 4.35759 6.18194 4.18185Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$Q = [
    "color"
];
var $c12e32cf04d921d4$export$432020ae7f5a1085 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$Q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$R = [
    "color"
];
var $c12e32cf04d921d4$export$7d1b8b90f61377d1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$R);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.18179 8.81819C4.00605 8.64245 4.00605 8.35753 4.18179 8.18179L7.18179 5.18179C7.26618 5.0974 7.38064 5.04999 7.49999 5.04999C7.61933 5.04999 7.73379 5.0974 7.81819 5.18179L10.8182 8.18179C10.9939 8.35753 10.9939 8.64245 10.8182 8.81819C10.6424 8.99392 10.3575 8.99392 10.1818 8.81819L7.49999 6.13638L4.81819 8.81819C4.64245 8.99392 4.35753 8.99392 4.18179 8.81819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$S = [
    "color"
];
var $c12e32cf04d921d4$export$83414514025c111b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$S);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.5 3L2.5 3.00002C1.67157 3.00002 1 3.6716 1 4.50002V9.50003C1 10.3285 1.67157 11 2.5 11H7.50003C7.63264 11 7.75982 11.0527 7.85358 11.1465L10 13.2929V11.5C10 11.2239 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3285 14 9.50003V4.5C14 3.67157 13.3284 3 12.5 3ZM2.49999 2.00002L12.5 2C13.8807 2 15 3.11929 15 4.5V9.50003C15 10.8807 13.8807 12 12.5 12H11V14.5C11 14.7022 10.8782 14.8845 10.6913 14.9619C10.5045 15.0393 10.2894 14.9965 10.1464 14.8536L7.29292 12H2.5C1.11929 12 0 10.8807 0 9.50003V4.50002C0 3.11931 1.11928 2.00003 2.49999 2.00002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$T = [
    "color"
];
var $c12e32cf04d921d4$export$7dd004358974b05d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$T);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$U = [
    "color"
];
var $c12e32cf04d921d4$export$54060461b8d0e637 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$U);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$V = [
    "color"
];
var $c12e32cf04d921d4$export$c0a1936901b0e55 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$V);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 3H12V12H3L3 3ZM2 3C2 2.44771 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44771 13 2 12.5523 2 12V3ZM10.3498 5.51105C10.506 5.28337 10.4481 4.97212 10.2204 4.81587C9.99275 4.65961 9.6815 4.71751 9.52525 4.94519L6.64048 9.14857L5.19733 7.40889C5.02102 7.19635 4.7058 7.16699 4.49327 7.34329C4.28073 7.5196 4.25137 7.83482 4.42767 8.04735L6.2934 10.2964C6.39348 10.4171 6.54437 10.4838 6.70097 10.4767C6.85757 10.4695 7.00177 10.3894 7.09047 10.2601L10.3498 5.51105Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$W = [
    "color"
];
var $c12e32cf04d921d4$export$4857d3f3f5f8319b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$W);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$X = [
    "color"
];
var $c12e32cf04d921d4$export$20bc5960c3c9eebb = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$X);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$Y = [
    "color"
];
var $c12e32cf04d921d4$export$b837bd7eac09a33e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$Y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$Z = [
    "color"
];
var $c12e32cf04d921d4$export$7f01a6cbee61a0f2 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$Z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$_ = [
    "color"
];
var $c12e32cf04d921d4$export$9c1c3f5a4a271817 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$_);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49991C0.877075 3.84222 3.84222 0.877075 7.49991 0.877075C11.1576 0.877075 14.1227 3.84222 14.1227 7.49991C14.1227 11.1576 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1576 0.877075 7.49991ZM7.49991 1.82708C4.36689 1.82708 1.82708 4.36689 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49991C13.1727 4.36689 10.6329 1.82708 7.49991 1.82708Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$$ = [
    "color"
];
var $c12e32cf04d921d4$export$10324e86d7995e4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$$);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM3.85768 3.15057C4.84311 2.32448 6.11342 1.82708 7.49991 1.82708C10.6329 1.82708 13.1727 4.36689 13.1727 7.49991C13.1727 8.88638 12.6753 10.1567 11.8492 11.1421L3.85768 3.15057ZM3.15057 3.85768C2.32448 4.84311 1.82708 6.11342 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C8.88638 13.1727 10.1567 12.6753 11.1421 11.8492L3.15057 3.85768Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$10 = [
    "color"
];
var $c12e32cf04d921d4$export$60f3f00eeba09710 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$10);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM11 2V2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.33579 3 4 2.66421 4 2.25V2H3.5C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V2.5C12 2.22386 11.7761 2 11.5 2H11Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$11 = [
    "color"
];
var $c12e32cf04d921d4$export$1a4dc243f6e39802 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$11);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H7V13H3.5C3.22386 13 3 12.7761 3 12.5V2.5C3 2.22386 3.22386 2 3.5 2H4V2.25C4 2.66421 4.33579 3 4.75 3H10.25C10.6642 3 11 2.66421 11 2.25V2H11.5C11.7761 2 12 2.22386 12 2.5V7H13V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM9 8.5C9 8.77614 8.77614 9 8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5ZM10.5 9C10.7761 9 11 8.77614 11 8.5C11 8.22386 10.7761 8 10.5 8C10.2239 8 10 8.22386 10 8.5C10 8.77614 10.2239 9 10.5 9ZM13 8.5C13 8.77614 12.7761 9 12.5 9C12.2239 9 12 8.77614 12 8.5C12 8.22386 12.2239 8 12.5 8C12.7761 8 13 8.22386 13 8.5ZM14.5 9C14.7761 9 15 8.77614 15 8.5C15 8.22386 14.7761 8 14.5 8C14.2239 8 14 8.22386 14 8.5C14 8.77614 14.2239 9 14.5 9ZM15 10.5C15 10.7761 14.7761 11 14.5 11C14.2239 11 14 10.7761 14 10.5C14 10.2239 14.2239 10 14.5 10C14.7761 10 15 10.2239 15 10.5ZM14.5 13C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12C14.2239 12 14 12.2239 14 12.5C14 12.7761 14.2239 13 14.5 13ZM14.5 15C14.7761 15 15 14.7761 15 14.5C15 14.2239 14.7761 14 14.5 14C14.2239 14 14 14.2239 14 14.5C14 14.7761 14.2239 15 14.5 15ZM8.5 11C8.77614 11 9 10.7761 9 10.5C9 10.2239 8.77614 10 8.5 10C8.22386 10 8 10.2239 8 10.5C8 10.7761 8.22386 11 8.5 11ZM9 12.5C9 12.7761 8.77614 13 8.5 13C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12C8.77614 12 9 12.2239 9 12.5ZM8.5 15C8.77614 15 9 14.7761 9 14.5C9 14.2239 8.77614 14 8.5 14C8.22386 14 8 14.2239 8 14.5C8 14.7761 8.22386 15 8.5 15ZM11 14.5C11 14.7761 10.7761 15 10.5 15C10.2239 15 10 14.7761 10 14.5C10 14.2239 10.2239 14 10.5 14C10.7761 14 11 14.2239 11 14.5ZM12.5 15C12.7761 15 13 14.7761 13 14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$12 = [
    "color"
];
var $c12e32cf04d921d4$export$8099ab97743c966c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$12);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.50009 0.877014C3.84241 0.877014 0.877258 3.84216 0.877258 7.49984C0.877258 11.1575 3.8424 14.1227 7.50009 14.1227C11.1578 14.1227 14.1229 11.1575 14.1229 7.49984C14.1229 3.84216 11.1577 0.877014 7.50009 0.877014ZM1.82726 7.49984C1.82726 4.36683 4.36708 1.82701 7.50009 1.82701C10.6331 1.82701 13.1729 4.36683 13.1729 7.49984C13.1729 10.6328 10.6331 13.1727 7.50009 13.1727C4.36708 13.1727 1.82726 10.6328 1.82726 7.49984ZM8 4.50001C8 4.22387 7.77614 4.00001 7.5 4.00001C7.22386 4.00001 7 4.22387 7 4.50001V7.50001C7 7.63262 7.05268 7.7598 7.14645 7.85357L9.14645 9.85357C9.34171 10.0488 9.65829 10.0488 9.85355 9.85357C10.0488 9.65831 10.0488 9.34172 9.85355 9.14646L8 7.29291V4.50001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$13 = [
    "color"
];
var $c12e32cf04d921d4$export$8036f09137bee589 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$13);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$14 = [
    "color"
];
var $c12e32cf04d921d4$export$32cdc32ad6ae0658 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$14);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.71144 0.796902C7.57741 0.734357 7.42257 0.734357 7.28855 0.796902L1.28855 3.5969C1.11251 3.67905 0.999993 3.85573 0.999993 4.04999V10.95C0.999993 11.1443 1.11251 11.3209 1.28855 11.4031L7.28855 14.2031C7.42257 14.2656 7.57741 14.2656 7.71144 14.2031L13.7114 11.4031C13.8875 11.3209 14 11.1443 14 10.95V4.04999C14 3.85573 13.8875 3.67905 13.7114 3.5969L7.71144 0.796902ZM7.49999 3.15674L5.98039 2.51091L7.49999 1.80176L9.01959 2.51091L7.49999 3.15674ZM7.69556 4.16018L10.2382 3.07958L12.2719 4.02865L7.49999 6.05671L2.72808 4.02865L4.76181 3.07958L7.30442 4.16018C7.42939 4.2133 7.57059 4.2133 7.69556 4.16018ZM7.99999 6.93078L13 4.80578V7.92966L11.0821 8.8119C10.7273 8.97509 10.5 9.32988 10.5 9.72039V11.7982L7.99999 12.9649V6.93078ZM11.5 11.3316L13 10.6316V9.03039L11.5 9.72039V11.3316ZM6.99999 6.93078V12.9649L4.50231 11.7993V9.72036C4.50231 9.32985 4.27499 8.97506 3.92022 8.81187L1.99999 7.92856V4.80578L6.99999 6.93078ZM1.99999 10.6316L3.50231 11.3326L3.50231 9.72036L1.99999 9.02929V10.6316Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$15 = [
    "color"
];
var $c12e32cf04d921d4$export$bda33a04439dd942 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$15);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49985C0.877075 3.84216 3.84222 0.877014 7.49991 0.877014C11.1576 0.877014 14.1227 3.84216 14.1227 7.49985C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49985ZM3.78135 3.21565C4.68298 2.43239 5.83429 1.92904 7.09998 1.84089V6.53429L3.78135 3.21565ZM3.21567 3.78134C2.43242 4.68298 1.92909 5.83428 1.84095 7.09997H6.5343L3.21567 3.78134ZM6.5343 7.89997H1.84097C1.92916 9.16562 2.43253 10.3169 3.21579 11.2185L6.5343 7.89997ZM3.78149 11.7842C4.6831 12.5673 5.83435 13.0707 7.09998 13.1588V8.46566L3.78149 11.7842ZM7.89998 8.46566V13.1588C9.16559 13.0706 10.3168 12.5673 11.2184 11.7841L7.89998 8.46566ZM11.7841 11.2184C12.5673 10.3168 13.0707 9.16558 13.1588 7.89997H8.46567L11.7841 11.2184ZM8.46567 7.09997H13.1589C13.0707 5.83432 12.5674 4.68305 11.7842 3.78143L8.46567 7.09997ZM11.2185 3.21573C10.3169 2.43246 9.16565 1.92909 7.89998 1.8409V6.53429L11.2185 3.21573Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$16 = [
    "color"
];
var $c12e32cf04d921d4$export$bfc20b5a7dea0537 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$16);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.00012 1.5C8.00012 1.22386 7.77626 1 7.50012 1C7.22398 1 7.00012 1.22386 7.00012 1.5V13.5C7.00012 13.7761 7.22398 14 7.50012 14C7.77626 14 8.00012 13.7761 8.00012 13.5V1.5ZM3.31812 5.818C3.49386 5.64227 3.49386 5.35734 3.31812 5.18161C3.14239 5.00587 2.85746 5.00587 2.68173 5.18161L0.681729 7.18161C0.505993 7.35734 0.505993 7.64227 0.681729 7.818L2.68173 9.818C2.85746 9.99374 3.14239 9.99374 3.31812 9.818C3.49386 9.64227 3.49386 9.35734 3.31812 9.18161L2.08632 7.9498H5.50017C5.7487 7.9498 5.95017 7.74833 5.95017 7.4998C5.95017 7.25128 5.7487 7.0498 5.50017 7.0498H2.08632L3.31812 5.818ZM12.3181 5.18161C12.1424 5.00587 11.8575 5.00587 11.6817 5.18161C11.506 5.35734 11.506 5.64227 11.6817 5.818L12.9135 7.0498H9.50017C9.25164 7.0498 9.05017 7.25128 9.05017 7.4998C9.05017 7.74833 9.25164 7.9498 9.50017 7.9498H12.9135L11.6817 9.18161C11.506 9.35734 11.506 9.64227 11.6817 9.818C11.8575 9.99374 12.1424 9.99374 12.3181 9.818L14.3181 7.818C14.4939 7.64227 14.4939 7.35734 14.3181 7.18161L12.3181 5.18161Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$17 = [
    "color"
];
var $c12e32cf04d921d4$export$38f001d9cffdd080 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$17);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.14998 14V1H0.849976V14H2.14998ZM6.14998 14V1H4.84998V14H6.14998ZM10.15 1V14H8.84998V1H10.15ZM14.15 14V1H12.85V14H14.15Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$18 = [
    "color"
];
var $c12e32cf04d921d4$export$13d9ab7fa696f910 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$18);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.94969 7.49989C9.94969 8.85288 8.85288 9.94969 7.49989 9.94969C6.14691 9.94969 5.0501 8.85288 5.0501 7.49989C5.0501 6.14691 6.14691 5.0501 7.49989 5.0501C8.85288 5.0501 9.94969 6.14691 9.94969 7.49989ZM10.8632 8C10.6213 9.64055 9.20764 10.8997 7.49989 10.8997C5.79214 10.8997 4.37847 9.64055 4.13662 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H4.13659C4.37835 5.35935 5.79206 4.1001 7.49989 4.1001C9.20772 4.1001 10.6214 5.35935 10.8632 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H10.8632Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$19 = [
    "color"
];
var $c12e32cf04d921d4$export$a8e03ddff565be2c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$19);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.67129 3.14634C4.47603 3.34161 4.47603 3.65819 4.67129 3.85345L7.14616 6.32833C7.34142 6.52359 7.65801 6.52359 7.85327 6.32833L10.3281 3.85345C10.5234 3.65819 10.5234 3.34161 10.3281 3.14634L7.85327 0.671471C7.65801 0.476209 7.34142 0.476209 7.14616 0.671471L4.67129 3.14634ZM7.49971 5.26766L5.73195 3.4999L7.49971 1.73213L9.26748 3.4999L7.49971 5.26766ZM8.67129 7.14634C8.47603 7.34161 8.47603 7.65819 8.67129 7.85345L11.1462 10.3283C11.3414 10.5236 11.658 10.5236 11.8533 10.3283L14.3281 7.85345C14.5234 7.65819 14.5234 7.34161 14.3281 7.14634L11.8533 4.67147C11.658 4.47621 11.3414 4.47621 11.1462 4.67147L8.67129 7.14634ZM11.4997 9.26766L9.73195 7.4999L11.4997 5.73213L13.2675 7.4999L11.4997 9.26766ZM4.67129 11.8535C4.47603 11.6582 4.47603 11.3416 4.67129 11.1463L7.14616 8.67147C7.34142 8.47621 7.65801 8.47621 7.85327 8.67147L10.3281 11.1463C10.5234 11.3416 10.5234 11.6582 10.3281 11.8535L7.85327 14.3283C7.65801 14.5236 7.34142 14.5236 7.14616 14.3283L4.67129 11.8535ZM5.73195 11.4999L7.49971 13.2677L9.26748 11.4999L7.49971 9.73213L5.73195 11.4999ZM0.671288 7.14649C0.476026 7.34175 0.476026 7.65834 0.671288 7.8536L3.14616 10.3285C3.34142 10.5237 3.65801 10.5237 3.85327 10.3285L6.32814 7.8536C6.5234 7.65834 6.5234 7.34175 6.32814 7.14649L3.85327 4.67162C3.65801 4.47636 3.34142 4.47636 3.14616 4.67162L0.671288 7.14649ZM3.49972 9.26781L1.73195 7.50005L3.49972 5.73228L5.26748 7.50005L3.49972 9.26781Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1a = [
    "color"
];
var $c12e32cf04d921d4$export$467c6b1dbd59bc1e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1a);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.87935 1H3.9H11.1H11.1207C11.5231 0.999994 11.8553 0.999989 12.1259 1.0221C12.407 1.04506 12.6653 1.09434 12.908 1.21799C13.2843 1.40973 13.5903 1.7157 13.782 2.09202C13.9057 2.33469 13.9549 2.59304 13.9779 2.87409C14 3.14468 14 3.47686 14 3.87934V3.9V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H3.9H3.87934C3.47686 14 3.14468 14 2.87409 13.9779C2.59304 13.9549 2.33469 13.9057 2.09202 13.782C1.7157 13.5903 1.40973 13.2843 1.21799 12.908C1.09434 12.6653 1.04506 12.407 1.0221 12.1259C0.999989 11.8553 0.999994 11.5231 1 11.1207V11.1207V11.1V3.9V3.87935V3.87934C0.999994 3.47686 0.999989 3.14468 1.0221 2.87409C1.04506 2.59304 1.09434 2.33469 1.21799 2.09202C1.40973 1.7157 1.7157 1.40973 2.09202 1.21799C2.33469 1.09434 2.59304 1.04506 2.87409 1.0221C3.14469 0.999989 3.47687 0.999994 3.87935 1ZM2.95552 2.01878C2.73631 2.03669 2.62421 2.06915 2.54601 2.10899C2.35785 2.20487 2.20487 2.35785 2.10899 2.54601C2.06915 2.62421 2.03669 2.73631 2.01878 2.95552C2.00039 3.18056 2 3.47171 2 3.9V7H7V2H3.9C3.47171 2 3.18056 2.00039 2.95552 2.01878ZM7 8H2V11.1C2 11.5283 2.00039 11.8194 2.01878 12.0445C2.03669 12.2637 2.06915 12.3758 2.10899 12.454C2.20487 12.6422 2.35785 12.7951 2.54601 12.891C2.62421 12.9309 2.73631 12.9633 2.95552 12.9812C3.18056 12.9996 3.47171 13 3.9 13H7V8ZM8 8H13V11.1C13 11.5283 12.9996 11.8194 12.9812 12.0445C12.9633 12.2637 12.9309 12.3758 12.891 12.454C12.7951 12.6422 12.6422 12.7951 12.454 12.891C12.3758 12.9309 12.2637 12.9633 12.0445 12.9812C11.8194 12.9996 11.5283 13 11.1 13H8V8ZM13 7H8V2H11.1C11.5283 2 11.8194 2.00039 12.0445 2.01878C12.2637 2.03669 12.3758 2.06915 12.454 2.10899C12.6422 2.20487 12.7951 2.35785 12.891 2.54601C12.9309 2.62421 12.9633 2.73631 12.9812 2.95552C12.9996 3.18056 13 3.47171 13 3.9V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1b = [
    "color"
];
var $c12e32cf04d921d4$export$8b4f0e3d2d9d0b5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1b);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.85367 1.48956C7.65841 1.29429 7.34182 1.29429 7.14656 1.48956L1.48971 7.14641C1.29445 7.34167 1.29445 7.65825 1.48971 7.85352L7.14656 13.5104C7.34182 13.7056 7.65841 13.7056 7.85367 13.5104L13.5105 7.85352C13.7058 7.65825 13.7058 7.34167 13.5105 7.14641L7.85367 1.48956ZM7.5 2.55033L2.55037 7.49996L7.5 12.4496V2.55033Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1c = [
    "color"
];
var $c12e32cf04d921d4$export$4edbb1daceb32596 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1c);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.1465 1.48959C7.34176 1.29432 7.65835 1.29432 7.85361 1.48959L13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355L7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104L1.48965 7.85355C1.29439 7.65829 1.29439 7.3417 1.48965 7.14644L7.1465 1.48959ZM7.50005 2.55025L2.55031 7.49999L7.50005 12.4497L12.4498 7.49999L7.50005 2.55025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1d = [
    "color"
];
var $c12e32cf04d921d4$export$8a42855f849911b4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1d);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959L1.48965 7.14644C1.29439 7.3417 1.29439 7.65829 1.48965 7.85355L3.9645 10.3284L1.64644 12.6464C1.45118 12.8417 1.45118 13.1583 1.64644 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.6716 11.0355L7.1465 13.5104C7.34176 13.7057 7.65835 13.7057 7.85361 13.5104L13.5105 7.85355C13.7057 7.65829 13.7057 7.3417 13.5105 7.14644L11.0356 4.67154L13.3535 2.35355C13.5488 2.15829 13.5488 1.84171 13.3535 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.3285 3.96443L7.85361 1.48959ZM9.62135 4.67154L7.50005 2.55025L2.55031 7.49999L4.6716 9.62129L9.62135 4.67154ZM5.37871 10.3284L7.50005 12.4497L12.4498 7.49999L10.3285 5.37865L5.37871 10.3284Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1e = [
    "color"
];
var $c12e32cf04d921d4$export$39c9cf5aa1336b1f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1e);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.8034 7.14644C12.9986 6.95118 13.3152 6.95118 13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355C13.3152 8.04881 12.9986 8.04881 12.8034 7.85355C12.6081 7.65828 12.6081 7.3417 12.8034 7.14644ZM12.0962 8.56065C12.2915 8.75592 12.2915 9.0725 12.0962 9.26776C11.901 9.46302 11.5844 9.46302 11.3891 9.26776C11.1939 9.0725 11.1939 8.75592 11.3891 8.56065C11.5844 8.36539 11.901 8.36539 12.0962 8.56065ZM10.682 9.97487C10.8773 10.1701 10.8773 10.4867 10.682 10.682C10.4868 10.8772 10.1702 10.8772 9.97493 10.682C9.77967 10.4867 9.77967 10.1701 9.97493 9.97487C10.1702 9.7796 10.4868 9.7796 10.682 9.97487ZM9.26782 11.3891C9.46308 11.5843 9.46308 11.9009 9.26782 12.0962C9.07256 12.2915 8.75598 12.2915 8.56071 12.0962C8.36545 11.9009 8.36545 11.5843 8.56072 11.3891C8.75598 11.1938 9.07256 11.1938 9.26782 11.3891ZM7.1465 13.5104C6.95124 13.3151 6.95124 12.9986 7.1465 12.8033C7.17091 12.7789 7.19721 12.7575 7.22494 12.7392C7.41901 12.6111 7.68275 12.6324 7.85361 12.8033C8.04887 12.9986 8.04887 13.3151 7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M2.90386 8.56065C2.7086 8.75592 2.7086 9.0725 2.90386 9.26776 3.09912 9.46302 3.41571 9.46302 3.61097 9.26776 3.80623 9.0725 3.80623 8.75592 3.61097 8.56065 3.41571 8.36539 3.09912 8.36539 2.90386 8.56065zM4.31807 9.97487C4.12281 10.1701 4.12281 10.4867 4.31807 10.682 4.51334 10.8772 4.82992 10.8772 5.02518 10.682 5.22044 10.4867 5.22044 10.1701 5.02518 9.97487 4.82992 9.7796 4.51334 9.7796 4.31807 9.97487zM5.73229 11.3891C5.53703 11.5843 5.53703 11.9009 5.73229 12.0962 5.92755 12.2914 6.24413 12.2915 6.43939 12.0962 6.63466 11.9009 6.63466 11.5843 6.43939 11.3891 6.24413 11.1938 5.92755 11.1938 5.73229 11.3891zM2.19675 7.85355C2.36761 7.68269 2.38897 7.41895 2.26082 7.22488 2.09046 6.96684 1.71063 6.92546 1.48965 7.14644 1.29439 7.3417 1.29439 7.65829 1.48965 7.85355 1.68491 8.04881 2.00149 8.04881 2.19675 7.85355zM3.61097 5.73223C3.41571 5.53696 3.09912 5.53696 2.90386 5.73223 2.7086 5.92749 2.7086 6.24407 2.90386 6.43933 3.09912 6.6346 3.41571 6.6346 3.61097 6.43933 3.80623 6.24407 3.80623 5.92749 3.61097 5.73223zM5.02518 4.31801C4.82992 4.12275 4.51334 4.12275 4.31807 4.31801 4.12281 4.51328 4.12281 4.82986 4.31807 5.02512 4.51334 5.22038 4.82992 5.22038 5.02518 5.02512 5.22044 4.82986 5.22044 4.51328 5.02518 4.31801zM6.43939 2.9038C6.24413 2.70854 5.92755 2.70854 5.73229 2.9038 5.53703 3.09906 5.53703 3.41564 5.73229 3.61091 5.92755 3.80617 6.24413 3.80617 6.43939 3.61091 6.63466 3.41564 6.63466 3.09906 6.43939 2.9038zM7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959 6.95124 1.68485 6.95124 2.00143 7.1465 2.19669 7.34176 2.39196 7.65835 2.39196 7.85361 2.19669 8.04887 2.00143 8.04887 1.68485 7.85361 1.48959zM9.26782 2.9038C9.07256 2.70854 8.75598 2.70854 8.56071 2.9038 8.36545 3.09906 8.36545 3.41564 8.56071 3.61091 8.75598 3.80617 9.07256 3.80617 9.26782 3.61091 9.46308 3.41564 9.46308 3.09906 9.26782 2.9038zM10.682 4.31801C10.4868 4.12275 10.1702 4.12275 9.97493 4.31801 9.77967 4.51328 9.77967 4.82986 9.97493 5.02512 10.1702 5.22038 10.4868 5.22038 10.682 5.02512 10.8773 4.82986 10.8773 4.51328 10.682 4.31801zM12.0962 5.73223C11.901 5.53696 11.5844 5.53696 11.3891 5.73223 11.1939 5.92749 11.1939 6.24407 11.3891 6.43933 11.5844 6.6346 11.901 6.6346 12.0962 6.43933 12.2915 6.24407 12.2915 5.92749 12.0962 5.73223z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$1f = [
    "color"
];
var $c12e32cf04d921d4$export$6d6da6edaddd5876 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1f);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM5 13H10V2L5 2L5 13ZM4 13C4 13.5523 4.44772 14 5 14H10C10.5523 14 11 13.5523 11 13V2C11 1.44772 10.5523 1 10 1H5C4.44772 1 4 1.44771 4 2V13ZM13.5 2C13.7761 2 14 1.77614 14 1.5C14 1.22386 13.7761 1 13.5 1C13.2239 1 13 1.22386 13 1.5C13 1.77614 13.2239 2 13.5 2ZM2 3.5C2 3.77614 1.77614 4 1.5 4C1.22386 4 1 3.77614 1 3.5C1 3.22386 1.22386 3 1.5 3C1.77614 3 2 3.22386 2 3.5ZM13.5 4C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3C13.2239 3 13 3.22386 13 3.5C13 3.77614 13.2239 4 13.5 4ZM2 5.5C2 5.77614 1.77614 6 1.5 6C1.22386 6 1 5.77614 1 5.5C1 5.22386 1.22386 5 1.5 5C1.77614 5 2 5.22386 2 5.5ZM13.5 6C13.7761 6 14 5.77614 14 5.5C14 5.22386 13.7761 5 13.5 5C13.2239 5 13 5.22386 13 5.5C13 5.77614 13.2239 6 13.5 6ZM2 7.5C2 7.77614 1.77614 8 1.5 8C1.22386 8 1 7.77614 1 7.5C1 7.22386 1.22386 7 1.5 7C1.77614 7 2 7.22386 2 7.5ZM13.5 8C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7C13.2239 7 13 7.22386 13 7.5C13 7.77614 13.2239 8 13.5 8ZM2 9.5C2 9.77614 1.77614 10 1.5 10C1.22386 10 1 9.77614 1 9.5C1 9.22386 1.22386 9 1.5 9C1.77614 9 2 9.22386 2 9.5ZM13.5 10C13.7761 10 14 9.77614 14 9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5C13 9.77614 13.2239 10 13.5 10ZM2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5ZM13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12ZM2 13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5C1 13.2239 1.22386 13 1.5 13C1.77614 13 2 13.2239 2 13.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1g = [
    "color"
];
var $c12e32cf04d921d4$export$4231f341127e9d59 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1g);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.0697 1.76746C12.4807 1.21947 11.4605 0.454311 11.0495 1.0023C10.6385 1.55028 11.6588 2.31544 12.0697 1.76746ZM8.39263 1.07811C7.15585 0.950602 5.7823 1.16348 4.58433 1.70937C3.38552 2.25563 2.32735 3.15309 1.78844 4.41832C1.37574 5.38724 1.01715 6.28113 1.00088 7.44354C0.984724 8.59844 1.30522 9.96898 2.13174 11.928C2.61142 13.0649 4.03963 13.5446 5.13895 13.8079C6.40836 14.1119 7.80857 14.1914 8.6644 14.0742C9.36515 13.9782 10.1448 13.8284 10.7987 13.297C11.8977 12.4039 12.9009 11.3955 13.4994 10.3393C14.104 9.27221 14.3256 8.09207 13.7216 6.95324C13.5628 6.65373 13.316 6.57734 13.0412 6.4923C12.9374 6.46016 12.8295 6.42678 12.7209 6.37966C11.6211 5.90234 10.9646 5.34963 10.9135 5.02876C10.8656 4.72808 10.9221 4.51463 10.9811 4.29181C11.0129 4.17199 11.0453 4.04947 11.0626 3.90922C11.0838 3.73737 11.0814 3.33319 10.6996 3.12761C10.4048 2.96888 10.2164 2.65843 10.0407 2.36904C9.99742 2.29775 9.95492 2.22773 9.9118 2.16158C9.62634 1.72367 9.20769 1.16213 8.39263 1.07811ZM4.99899 2.61935C3.96483 3.09058 3.12554 3.83097 2.70846 4.81018C2.29808 5.77368 2.01406 6.50873 2.00079 7.45753C1.98741 8.41385 2.25043 9.6368 3.0531 11.5393C3.39181 12.3421 4.62167 12.6557 5.37186 12.8354C6.5493 13.1174 7.822 13.1802 8.52868 13.0834C9.21271 12.9897 9.74568 12.8642 10.1681 12.5209C11.229 11.6587 12.121 10.7435 12.6293 9.84635C12.9349 9.30709 13.5141 7.7028 12.6292 7.3873C10.7539 6.71875 10.262 6.06669 9.99011 5.41268C9.80915 4.97744 9.82868 4.52282 9.95741 4.07885L9.95741 4.07884C9.97662 4.0126 9.99538 3.94791 10.0334 3.88882C9.81857 3.73676 9.6515 3.55195 9.51464 3.3715C9.42876 3.25828 9.3469 3.12099 9.26197 2.97856C9.01866 2.57052 8.75018 2.12027 8.29008 2.07283C7.22889 1.96343 6.03398 2.14772 4.99899 2.61935ZM13.2081 3.77471C13.441 3.22671 12.4547 2.63606 12.0822 3.10163C11.5817 3.72732 12.9029 4.49281 13.2081 3.77471ZM14.3672 2.26031C14.9668 2.27493 15.1551 1.11603 14.5718 0.949371C13.8076 0.731026 13.5918 2.24139 14.3672 2.26031ZM14.2857 5.09098C14.8644 5.10004 15.0462 4.38222 14.4832 4.27899C13.7455 4.14375 13.5373 5.07927 14.2857 5.09098ZM6.9075 4.28672C6.46898 4.66754 6.0522 4.15185 5.97983 3.7365C5.86848 3.09744 6.33696 2.56856 6.94823 2.91156C7.43344 3.18382 7.26678 3.97471 6.9075 4.28672ZM4.94455 5.88184C5.40885 5.41754 4.59567 4.57013 4.11425 5.05154C3.83338 5.33242 4.00936 5.65376 4.23744 5.88184C4.43271 6.0771 4.74929 6.0771 4.94455 5.88184ZM6.97716 6.71984C7.31181 7.38914 8.48804 6.79159 7.99413 6.14788C7.86519 5.97983 7.68657 5.9494 7.62145 5.94207C7.21217 5.89601 6.76349 6.2925 6.97716 6.71984ZM6.98798 8.72461C7.14066 9.1188 7.51122 9.3187 7.91915 9.1633C8.27434 9.02799 8.33186 8.39689 8.17175 8.07427C8.02331 7.77514 7.63956 7.67793 7.33747 7.79417C6.98512 7.92976 6.85672 8.38708 6.98576 8.71889L6.98798 8.72461ZM10.3885 8.84081C10.7575 8.6566 11.4617 8.82771 11.4617 9.31199C11.4617 9.71286 10.9587 10.2165 10.5634 10.2826C10.1813 10.3465 9.70515 9.97581 9.76648 9.57718C9.81445 9.26539 10.1217 8.97401 10.3885 8.84081ZM7.56704 10.8432C7.33461 10.7502 7.14353 10.8601 7.11437 10.8769L7.11279 10.8778C6.90782 10.9949 6.71383 11.2439 6.6747 11.4842C6.59018 12.0034 7.13199 12.1239 7.52661 12.0987C8.2074 12.0553 8.06547 11.0426 7.56704 10.8432ZM4.8805 10.8932C5.0674 10.7723 5.15658 10.5363 5.08293 10.3153C4.93046 9.79687 4.3246 9.71252 3.96561 10.1297C3.79336 10.3299 3.80749 10.6274 3.99214 10.8105L3.99495 10.814L3.9979 10.8176C4.22025 11.0942 4.63624 11.1857 4.8805 10.8932ZM3.04695 7.81318C3.33147 8.0977 3.60077 8.15067 3.98443 8.05859C4.60826 7.90887 4.13814 6.24299 3.047 6.87296C2.70939 7.06788 2.86716 7.63339 3.04695 7.81318Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1h = [
    "color"
];
var $c12e32cf04d921d4$export$51b6cd98f8778f0d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1h);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1i = [
    "color"
];
var $c12e32cf04d921d4$export$53250eb5c8bd1390 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1i);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.87737 12H9.9H11.5C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11H9.9C8.77164 11 7.95545 10.9996 7.31352 10.9472C6.67744 10.8952 6.25662 10.7946 5.91103 10.6185C5.25247 10.283 4.71703 9.74753 4.38148 9.08897C4.20539 8.74338 4.10481 8.32256 4.05284 7.68648C4.00039 7.04455 4 6.22836 4 5.1V3.5C4 3.22386 3.77614 3 3.5 3C3.22386 3 3 3.22386 3 3.5V5.1V5.12263C3 6.22359 3 7.08052 3.05616 7.76791C3.11318 8.46584 3.23058 9.0329 3.49047 9.54296C3.9219 10.3897 4.61031 11.0781 5.45704 11.5095C5.9671 11.7694 6.53416 11.8868 7.23209 11.9438C7.91948 12 8.77641 12 9.87737 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1j = [
    "color"
];
var $c12e32cf04d921d4$export$13d7020d49a403c9 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1j);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.12263 12H5.1H3.5C3.22386 12 3 11.7761 3 11.5C3 11.2239 3.22386 11 3.5 11H5.1C6.22836 11 7.04455 10.9996 7.68648 10.9472C8.32256 10.8952 8.74338 10.7946 9.08897 10.6185C9.74753 10.283 10.283 9.74753 10.6185 9.08897C10.7946 8.74338 10.8952 8.32256 10.9472 7.68648C10.9996 7.04455 11 6.22836 11 5.1V3.5C11 3.22386 11.2239 3 11.5 3C11.7761 3 12 3.22386 12 3.5V5.1V5.12263C12 6.22359 12 7.08052 11.9438 7.76791C11.8868 8.46584 11.7694 9.0329 11.5095 9.54296C11.0781 10.3897 10.3897 11.0781 9.54296 11.5095C9.0329 11.7694 8.46584 11.8868 7.76791 11.9438C7.08052 12 6.22359 12 5.12263 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1k = [
    "color"
];
var $c12e32cf04d921d4$export$e709160419ee2246 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1k);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.87737 3H9.9H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H9.9C8.77164 4 7.95545 4.00039 7.31352 4.05284C6.67744 4.10481 6.25662 4.20539 5.91103 4.38148C5.25247 4.71703 4.71703 5.25247 4.38148 5.91103C4.20539 6.25662 4.10481 6.67744 4.05284 7.31352C4.00039 7.95545 4 8.77164 4 9.9V11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5V9.9V9.87737C3 8.77641 3 7.91948 3.05616 7.23209C3.11318 6.53416 3.23058 5.9671 3.49047 5.45704C3.9219 4.61031 4.61031 3.9219 5.45704 3.49047C5.9671 3.23058 6.53416 3.11318 7.23209 3.05616C7.91948 3 8.77641 3 9.87737 3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1l = [
    "color"
];
var $c12e32cf04d921d4$export$8e3e82083a0db3ff = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1l);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.12263 3H5.1H3.5C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H5.1C6.22836 4 7.04455 4.00039 7.68648 4.05284C8.32256 4.10481 8.74338 4.20539 9.08897 4.38148C9.74753 4.71703 10.283 5.25247 10.6185 5.91103C10.7946 6.25662 10.8952 6.67744 10.9472 7.31352C10.9996 7.95545 11 8.77164 11 9.9V11.5C11 11.7761 11.2239 12 11.5 12C11.7761 12 12 11.7761 12 11.5V9.9V9.87737C12 8.77641 12 7.91948 11.9438 7.23209C11.8868 6.53416 11.7694 5.9671 11.5095 5.45704C11.0781 4.61031 10.3897 3.9219 9.54296 3.49047C9.0329 3.23058 8.46584 3.11318 7.76791 3.05616C7.08052 3 6.22359 3 5.12263 3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1m = [
    "color"
];
var $c12e32cf04d921d4$export$3473a9c28d168741 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1m);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.5 2L4.87935 2C4.47687 1.99999 4.14469 1.99999 3.87409 2.0221C3.59304 2.04506 3.33469 2.09434 3.09202 2.21799C2.7157 2.40973 2.40973 2.7157 2.21799 3.09202C2.09434 3.33469 2.04506 3.59304 2.0221 3.87409C1.99999 4.14468 1.99999 4.47686 2 4.87933V4.87935V5.5C2 5.77614 2.22386 6 2.5 6C2.77614 6 3 5.77614 3 5.5V4.9C3 4.47171 3.00039 4.18056 3.01878 3.95552C3.03669 3.73631 3.06915 3.62421 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.62421 3.06915 3.73631 3.03669 3.95552 3.01878C4.18056 3.00039 4.47171 3 4.9 3H5.5C5.77614 3 6 2.77614 6 2.5C6 2.22386 5.77614 2 5.5 2ZM13 9.5C13 9.22386 12.7761 9 12.5 9C12.2239 9 12 9.22386 12 9.5V10.1C12 10.5283 11.9996 10.8194 11.9812 11.0445C11.9633 11.2637 11.9309 11.3758 11.891 11.454C11.7951 11.6422 11.6422 11.7951 11.454 11.891C11.3758 11.9309 11.2637 11.9633 11.0445 11.9812C10.8194 11.9996 10.5283 12 10.1 12H9.5C9.22386 12 9 12.2239 9 12.5C9 12.7761 9.22386 13 9.5 13H10.1206C10.5231 13 10.8553 13 11.1259 12.9779C11.407 12.9549 11.6653 12.9057 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C12.9057 11.6653 12.9549 11.407 12.9779 11.1259C13 10.8553 13 10.5232 13 10.1207V10.1207V10.1207V10.1206V9.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V10.1C3 10.5283 3.00039 10.8194 3.01878 11.0445C3.03669 11.2637 3.06915 11.3758 3.10899 11.454C3.20487 11.6422 3.35785 11.7951 3.54601 11.891C3.62421 11.9309 3.73631 11.9633 3.95552 11.9812C4.18056 11.9996 4.47171 12 4.9 12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H4.87935C4.47687 13 4.14469 13 3.87409 12.9779C3.59304 12.9549 3.33469 12.9057 3.09202 12.782C2.7157 12.5903 2.40973 12.2843 2.21799 11.908C2.09434 11.6653 2.04506 11.407 2.0221 11.1259C1.99999 10.8553 1.99999 10.5231 2 10.1207V10.1206V10.1V9.5C2 9.22386 2.22386 9 2.5 9ZM10.1 3C10.5283 3 10.8194 3.00039 11.0445 3.01878C11.2637 3.03669 11.3758 3.06915 11.454 3.10899C11.6422 3.20487 11.7951 3.35785 11.891 3.54601C11.9309 3.62421 11.9633 3.73631 11.9812 3.95552C11.9996 4.18056 12 4.47171 12 4.9V5.5C12 5.77614 12.2239 6 12.5 6C12.7761 6 13 5.77614 13 5.5V4.87935V4.87934C13 4.47686 13 4.14468 12.9779 3.87409C12.9549 3.59304 12.9057 3.33469 12.782 3.09202C12.5903 2.7157 12.2843 2.40973 11.908 2.21799C11.6653 2.09434 11.407 2.04506 11.1259 2.0221C10.8553 1.99999 10.5231 1.99999 10.1206 2L10.1 2H9.5C9.22386 2 9 2.22386 9 2.5C9 2.77614 9.22386 3 9.5 3H10.1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1n = [
    "color"
];
var $c12e32cf04d921d4$export$d947354b0bb44dfa = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1n);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.7217 1.84998 3.34851 3.90636 2.76336 4.99997H4.5C4.77614 4.99997 5 5.22383 5 5.49997C5 5.77611 4.77614 5.99997 4.5 5.99997H1.5C1.22386 5.99997 1 5.77611 1 5.49997V2.49997C1 2.22383 1.22386 1.99997 1.5 1.99997C1.77614 1.99997 2 2.22383 2 2.49997V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7 10V5.00001H8V10H7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1o = [
    "color"
];
var $c12e32cf04d921d4$export$92a2757a17018399 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1o);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.72167 1.84998 3.34849 3.9064 2.76335 5H4.5C4.77614 5 5 5.22386 5 5.5C5 5.77614 4.77614 6 4.5 6H1.5C1.22386 6 1 5.77614 1 5.5V2.5C1 2.22386 1.22386 2 1.5 2C1.77614 2 2 2.22386 2 2.5V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7.5 4.00001C7.77614 4.00001 8 4.22387 8 4.50001V7.29291L9.85355 9.14646C10.0488 9.34172 10.0488 9.65831 9.85355 9.85357C9.65829 10.0488 9.34171 10.0488 9.14645 9.85357L7.14645 7.85357C7.05268 7.7598 7 7.63262 7 7.50001V4.50001C7 4.22387 7.22386 4.00001 7.5 4.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1p = [
    "color"
];
var $c12e32cf04d921d4$export$9816aad82d905e6 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1p);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 8.00684e-07C3.77614 7.88614e-07 4 0.223859 4 0.500001L4 3.00006L11.5 3.00006C11.7761 3.00006 12 3.22392 12 3.50006L12 11.0001L14.5 11C14.7761 11 15 11.2238 15 11.5C15 11.7761 14.7762 12 14.5 12L12 12.0001L12 14.5C12 14.7761 11.7761 15 11.5 15C11.2239 15 11 14.7761 11 14.5L11 12.0001L3.5 12.0001C3.22386 12.0001 3 11.7762 3 11.5001L3 4.00005L0.499989 4C0.223847 4 -6.10541e-06 3.77613 -5.02576e-07 3.49999C5.13006e-06 3.22385 0.223867 3 0.50001 3L3 3.00005L3 0.500001C3 0.223859 3.22386 8.12755e-07 3.5 8.00684e-07ZM4 4.00006L4 11.0001L11 11.0001L11 4.00006L4 4.00006Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1q = [
    "color"
];
var $c12e32cf04d921d4$export$8c97d895bfadca90 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.8536 2.85355C13.0488 2.65829 13.0488 2.34171 12.8536 2.14645C12.6583 1.95118 12.3417 1.95118 12.1464 2.14645L7.5 6.79289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L6.79289 7.5L2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536C2.34171 13.0488 2.65829 13.0488 2.85355 12.8536L7.5 8.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.20711 7.5L12.8536 2.85355Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1r = [
    "color"
];
var $c12e32cf04d921d4$export$b7fa469a3cb3cd4f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1r);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1s = [
    "color"
];
var $c12e32cf04d921d4$export$8710c0d3947fcfc3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1s);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1t = [
    "color"
];
var $c12e32cf04d921d4$export$d5c5855fccded9fe = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1t);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.50207C0.877075 3.84319 3.84319 0.877075 7.50208 0.877075C11.1609 0.877075 14.1271 3.84319 14.1271 7.50207C14.1271 11.1609 11.1609 14.1271 7.50208 14.1271C3.84319 14.1271 0.877075 11.1609 0.877075 7.50207ZM1.84898 7.00003C2.0886 4.26639 4.26639 2.0886 7.00003 1.84898V4.50003C7.00003 4.77617 7.22388 5.00003 7.50003 5.00003C7.77617 5.00003 8.00003 4.77617 8.00003 4.50003V1.84862C10.7356 2.08643 12.9154 4.26502 13.1552 7.00003H10.5C10.2239 7.00003 10 7.22388 10 7.50003C10 7.77617 10.2239 8.00003 10.5 8.00003H13.1555C12.9176 10.7369 10.7369 12.9176 8.00003 13.1555V10.5C8.00003 10.2239 7.77617 10 7.50003 10C7.22388 10 7.00003 10.2239 7.00003 10.5V13.1552C4.26502 12.9154 2.08643 10.7356 1.84862 8.00003H4.50003C4.77617 8.00003 5.00003 7.77617 5.00003 7.50003C5.00003 7.22388 4.77617 7.00003 4.50003 7.00003H1.84898Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1u = [
    "color"
];
var $c12e32cf04d921d4$export$d0fffbce0e008b09 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1u);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V1.80687C10.6922 2.0935 12.8167 4.28012 13.0068 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H12.9888C12.7094 10.6244 10.6244 12.7094 8 12.9888V14.5C8 14.7761 7.77614 15 7.5 15C7.22386 15 7 14.7761 7 14.5V13.0068C4.28012 12.8167 2.0935 10.6922 1.80687 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H1.78886C1.98376 4.21166 4.21166 1.98376 7 1.78886V0.5C7 0.223858 7.22386 0 7.5 0ZM8 12.0322V9.5C8 9.22386 7.77614 9 7.5 9C7.22386 9 7 9.22386 7 9.5V12.054C4.80517 11.8689 3.04222 10.1668 2.76344 8H5.5C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7H2.7417C2.93252 4.73662 4.73662 2.93252 7 2.7417V5.5C7 5.77614 7.22386 6 7.5 6C7.77614 6 8 5.77614 8 5.5V2.76344C10.1668 3.04222 11.8689 4.80517 12.054 7H9.5C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8H12.0322C11.7621 10.0991 10.0991 11.7621 8 12.0322Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1v = [
    "color"
];
var $c12e32cf04d921d4$export$18abdbf97bad2a11 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1v);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.60913 0.0634287C4.39082 0.0088505 4.16575 0.12393 4.08218 0.332867L3.1538 2.6538L0.832866 3.58218C0.702884 3.63417 0.604504 3.7437 0.566705 3.87849C0.528906 4.01329 0.555994 4.158 0.639992 4.26999L2.01148 6.09864L1.06343 9.89085C1.00944 10.1068 1.12145 10.3298 1.32691 10.4154L4.20115 11.613L5.62557 13.7496C5.73412 13.9124 5.93545 13.9864 6.12362 13.9327L9.62362 12.9327C9.62988 12.9309 9.63611 12.929 9.64229 12.9269L12.6423 11.9269C12.7923 11.8769 12.905 11.7519 12.9393 11.5976L13.9393 7.09761C13.9776 6.92506 13.9114 6.74605 13.77 6.63999L11.95 5.27499V2.99999C11.95 2.82955 11.8537 2.67373 11.7012 2.5975L8.70124 1.0975C8.67187 1.08282 8.64098 1.07139 8.60913 1.06343L4.60913 0.0634287ZM11.4323 6.01173L12.7748 7.01858L10.2119 9.15429C10.1476 9.20786 10.0995 9.2783 10.0731 9.35769L9.25382 11.8155L7.73849 10.8684C7.52774 10.7367 7.25011 10.8007 7.11839 11.0115C6.98667 11.2222 7.05074 11.4999 7.26149 11.6316L8.40341 12.3453L6.19221 12.9771L4.87441 11.0004C4.82513 10.9265 4.75508 10.8688 4.67307 10.8346L2.03046 9.73352L2.85134 6.44999H4.99999C5.24852 6.44999 5.44999 6.24852 5.44999 5.99999C5.44999 5.75146 5.24852 5.54999 4.99999 5.54999H2.72499L1.7123 4.19974L3.51407 3.47903L6.35769 4.4269C6.53655 4.48652 6.73361 4.42832 6.85138 4.28111L8.62413 2.06518L11.05 3.27811V5.19533L8.83287 6.08218C8.70996 6.13134 8.61494 6.23212 8.57308 6.35769L8.07308 7.85769C7.99449 8.09346 8.12191 8.34831 8.35769 8.4269C8.59346 8.50549 8.84831 8.37807 8.9269 8.14229L9.3609 6.84029L11.4323 6.01173ZM7.71052 1.76648L6.34462 3.47386L4.09505 2.724L4.77192 1.03183L7.71052 1.76648ZM10.2115 11.7885L12.116 11.1537L12.7745 8.19034L10.8864 9.76374L10.2115 11.7885Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1w = [
    "color"
];
var $c12e32cf04d921d4$export$315ae6298b7de94 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1w);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1x = [
    "color"
];
var $c12e32cf04d921d4$export$4e8767be554cec68 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1x);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.29227 0.048984C3.47033 -0.032338 3.67946 -0.00228214 3.8274 0.125891L12.8587 7.95026C13.0134 8.08432 13.0708 8.29916 13.0035 8.49251C12.9362 8.68586 12.7578 8.81866 12.5533 8.82768L9.21887 8.97474L11.1504 13.2187C11.2648 13.47 11.1538 13.7664 10.9026 13.8808L8.75024 14.8613C8.499 14.9758 8.20255 14.8649 8.08802 14.6137L6.15339 10.3703L3.86279 12.7855C3.72196 12.934 3.50487 12.9817 3.31479 12.9059C3.1247 12.8301 3 12.6461 3 12.4414V0.503792C3 0.308048 3.11422 0.130306 3.29227 0.048984ZM4 1.59852V11.1877L5.93799 9.14425C6.05238 9.02363 6.21924 8.96776 6.38319 8.99516C6.54715 9.02256 6.68677 9.12965 6.75573 9.2809L8.79056 13.7441L10.0332 13.178L8.00195 8.71497C7.93313 8.56376 7.94391 8.38824 8.03072 8.24659C8.11753 8.10494 8.26903 8.01566 8.435 8.00834L11.2549 7.88397L4 1.59852Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1y = [
    "color"
];
var $c12e32cf04d921d4$export$d665abe9390574dd = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2C5.42215 2 6.0399 2.23054 6.42075 2.56379C6.79286 2.88939 7 3.36626 7 4V7H5.75C5.47386 7 5.25 7.22386 5.25 7.5C5.25 7.77614 5.47386 8 5.75 8H7V11C7 11.6337 6.79286 12.1106 6.42075 12.4362C6.0399 12.7695 5.42215 13 4.5 13C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14C5.57785 14 6.4601 13.7305 7.07925 13.1888C7.24168 13.0467 7.38169 12.8896 7.5 12.7198C7.61832 12.8896 7.75832 13.0467 7.92075 13.1888C8.5399 13.7305 9.42215 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.57785 13 8.9601 12.7695 8.57925 12.4362C8.20714 12.1106 8 11.6337 8 11V8H9.25C9.52614 8 9.75 7.77614 9.75 7.5C9.75 7.22386 9.52614 7 9.25 7H8V4C8 3.36626 8.20714 2.88939 8.57925 2.56379C8.9601 2.23054 9.57785 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.42215 1 8.5399 1.26946 7.92075 1.81121C7.75832 1.95333 7.61832 2.11043 7.5 2.28023C7.38168 2.11043 7.24168 1.95333 7.07925 1.81121C6.4601 1.26946 5.57785 1 4.5 1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1z = [
    "color"
];
var $c12e32cf04d921d4$export$a2bc8cb49334c5d1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 7.5C5 7.22386 5.22386 7 5.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H5.5C5.22386 8 5 7.77614 5 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1A = [
    "color"
];
var $c12e32cf04d921d4$export$8fd9d8340b1bb79a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1A);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.8 1L2.74967 0.99997C2.52122 0.999752 2.32429 0.999564 2.14983 1.04145C1.60136 1.17312 1.17312 1.60136 1.04145 2.14983C0.999564 2.32429 0.999752 2.52122 0.99997 2.74967L1 2.8V5.2L0.99997 5.25033C0.999752 5.47878 0.999564 5.67572 1.04145 5.85017C1.17312 6.39864 1.60136 6.82688 2.14983 6.95856C2.32429 7.00044 2.52122 7.00025 2.74967 7.00003L2.8 7H5.2L5.25033 7.00003C5.47878 7.00025 5.67572 7.00044 5.85017 6.95856C6.39864 6.82688 6.82688 6.39864 6.95856 5.85017C7.00044 5.67572 7.00025 5.47878 7.00003 5.25033L7 5.2V2.8L7.00003 2.74967C7.00025 2.52122 7.00044 2.32429 6.95856 2.14983C6.82688 1.60136 6.39864 1.17312 5.85017 1.04145C5.67572 0.999564 5.47878 0.999752 5.25033 0.99997L5.2 1H2.8ZM2.38328 2.01382C2.42632 2.00348 2.49222 2 2.8 2H5.2C5.50779 2 5.57369 2.00348 5.61672 2.01382C5.79955 2.05771 5.94229 2.20045 5.98619 2.38328C5.99652 2.42632 6 2.49222 6 2.8V5.2C6 5.50779 5.99652 5.57369 5.98619 5.61672C5.94229 5.79955 5.79955 5.94229 5.61672 5.98619C5.57369 5.99652 5.50779 6 5.2 6H2.8C2.49222 6 2.42632 5.99652 2.38328 5.98619C2.20045 5.94229 2.05771 5.79955 2.01382 5.61672C2.00348 5.57369 2 5.50779 2 5.2V2.8C2 2.49222 2.00348 2.42632 2.01382 2.38328C2.05771 2.20045 2.20045 2.05771 2.38328 2.01382ZM9.8 1L9.74967 0.99997C9.52122 0.999752 9.32429 0.999564 9.14983 1.04145C8.60136 1.17312 8.17312 1.60136 8.04145 2.14983C7.99956 2.32429 7.99975 2.52122 7.99997 2.74967L8 2.8V5.2L7.99997 5.25033C7.99975 5.47878 7.99956 5.67572 8.04145 5.85017C8.17312 6.39864 8.60136 6.82688 9.14983 6.95856C9.32429 7.00044 9.52122 7.00025 9.74967 7.00003L9.8 7H12.2L12.2503 7.00003C12.4788 7.00025 12.6757 7.00044 12.8502 6.95856C13.3986 6.82688 13.8269 6.39864 13.9586 5.85017C14.0004 5.67572 14.0003 5.47878 14 5.25033L14 5.2V2.8L14 2.74967C14.0003 2.52122 14.0004 2.32429 13.9586 2.14983C13.8269 1.60136 13.3986 1.17312 12.8502 1.04145C12.6757 0.999564 12.4788 0.999752 12.2503 0.99997L12.2 1H9.8ZM9.38328 2.01382C9.42632 2.00348 9.49222 2 9.8 2H12.2C12.5078 2 12.5737 2.00348 12.6167 2.01382C12.7995 2.05771 12.9423 2.20045 12.9862 2.38328C12.9965 2.42632 13 2.49222 13 2.8V5.2C13 5.50779 12.9965 5.57369 12.9862 5.61672C12.9423 5.79955 12.7995 5.94229 12.6167 5.98619C12.5737 5.99652 12.5078 6 12.2 6H9.8C9.49222 6 9.42632 5.99652 9.38328 5.98619C9.20045 5.94229 9.05771 5.79955 9.01382 5.61672C9.00348 5.57369 9 5.50779 9 5.2V2.8C9 2.49222 9.00348 2.42632 9.01382 2.38328C9.05771 2.20045 9.20045 2.05771 9.38328 2.01382ZM2.74967 7.99997L2.8 8H5.2L5.25033 7.99997C5.47878 7.99975 5.67572 7.99956 5.85017 8.04145C6.39864 8.17312 6.82688 8.60136 6.95856 9.14983C7.00044 9.32429 7.00025 9.52122 7.00003 9.74967L7 9.8V12.2L7.00003 12.2503C7.00025 12.4788 7.00044 12.6757 6.95856 12.8502C6.82688 13.3986 6.39864 13.8269 5.85017 13.9586C5.67572 14.0004 5.47878 14.0003 5.25033 14L5.2 14H2.8L2.74967 14C2.52122 14.0003 2.32429 14.0004 2.14983 13.9586C1.60136 13.8269 1.17312 13.3986 1.04145 12.8502C0.999564 12.6757 0.999752 12.4788 0.99997 12.2503L1 12.2V9.8L0.99997 9.74967C0.999752 9.52122 0.999564 9.32429 1.04145 9.14983C1.17312 8.60136 1.60136 8.17312 2.14983 8.04145C2.32429 7.99956 2.52122 7.99975 2.74967 7.99997ZM2.8 9C2.49222 9 2.42632 9.00348 2.38328 9.01382C2.20045 9.05771 2.05771 9.20045 2.01382 9.38328C2.00348 9.42632 2 9.49222 2 9.8V12.2C2 12.5078 2.00348 12.5737 2.01382 12.6167C2.05771 12.7995 2.20045 12.9423 2.38328 12.9862C2.42632 12.9965 2.49222 13 2.8 13H5.2C5.50779 13 5.57369 12.9965 5.61672 12.9862C5.79955 12.9423 5.94229 12.7995 5.98619 12.6167C5.99652 12.5737 6 12.5078 6 12.2V9.8C6 9.49222 5.99652 9.42632 5.98619 9.38328C5.94229 9.20045 5.79955 9.05771 5.61672 9.01382C5.57369 9.00348 5.50779 9 5.2 9H2.8ZM9.8 8L9.74967 7.99997C9.52122 7.99975 9.32429 7.99956 9.14983 8.04145C8.60136 8.17312 8.17312 8.60136 8.04145 9.14983C7.99956 9.32429 7.99975 9.52122 7.99997 9.74967L8 9.8V12.2L7.99997 12.2503C7.99975 12.4788 7.99956 12.6757 8.04145 12.8502C8.17312 13.3986 8.60136 13.8269 9.14983 13.9586C9.32429 14.0004 9.52122 14.0003 9.74967 14L9.8 14H12.2L12.2503 14C12.4788 14.0003 12.6757 14.0004 12.8502 13.9586C13.3986 13.8269 13.8269 13.3986 13.9586 12.8502C14.0004 12.6757 14.0003 12.4788 14 12.2503L14 12.2V9.8L14 9.74967C14.0003 9.52122 14.0004 9.32429 13.9586 9.14983C13.8269 8.60136 13.3986 8.17312 12.8502 8.04145C12.6757 7.99956 12.4788 7.99975 12.2503 7.99997L12.2 8H9.8ZM9.38328 9.01382C9.42632 9.00348 9.49222 9 9.8 9H12.2C12.5078 9 12.5737 9.00348 12.6167 9.01382C12.7995 9.05771 12.9423 9.20045 12.9862 9.38328C12.9965 9.42632 13 9.49222 13 9.8V12.2C13 12.5078 12.9965 12.5737 12.9862 12.6167C12.9423 12.7995 12.7995 12.9423 12.6167 12.9862C12.5737 12.9965 12.5078 13 12.2 13H9.8C9.49222 13 9.42632 12.9965 9.38328 12.9862C9.20045 12.9423 9.05771 12.7995 9.01382 12.6167C9.00348 12.5737 9 12.5078 9 12.2V9.8C9 9.49222 9.00348 9.42632 9.01382 9.38328C9.05771 9.20045 9.20045 9.05771 9.38328 9.01382Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1B = [
    "color"
];
var $c12e32cf04d921d4$export$78a6319cfd8cd037 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1B);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 3.25C1 3.11193 1.11193 3 1.25 3H13.75C13.8881 3 14 3.11193 14 3.25V10.75C14 10.8881 13.8881 11 13.75 11H1.25C1.11193 11 1 10.8881 1 10.75V3.25ZM1.25 2C0.559643 2 0 2.55964 0 3.25V10.75C0 11.4404 0.559644 12 1.25 12H5.07341L4.82991 13.2986C4.76645 13.6371 5.02612 13.95 5.37049 13.95H9.62951C9.97389 13.95 10.2336 13.6371 10.1701 13.2986L9.92659 12H13.75C14.4404 12 15 11.4404 15 10.75V3.25C15 2.55964 14.4404 2 13.75 2H1.25ZM9.01091 12H5.98909L5.79222 13.05H9.20778L9.01091 12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1C = [
    "color"
];
var $c12e32cf04d921d4$export$63405b713b830f28 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1C);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1D = [
    "color"
];
var $c12e32cf04d921d4$export$e9e14b59da099a2a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1D);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM1.82708 7.49991C1.82708 4.36689 4.36689 1.82707 7.49991 1.82707C10.6329 1.82707 13.1727 4.36689 13.1727 7.49991C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49991ZM8.37287 7.50006C8.37287 7.98196 7.98221 8.37263 7.5003 8.37263C7.01839 8.37263 6.62773 7.98196 6.62773 7.50006C6.62773 7.01815 7.01839 6.62748 7.5003 6.62748C7.98221 6.62748 8.37287 7.01815 8.37287 7.50006ZM9.32287 7.50006C9.32287 8.50664 8.50688 9.32263 7.5003 9.32263C6.49372 9.32263 5.67773 8.50664 5.67773 7.50006C5.67773 6.49348 6.49372 5.67748 7.5003 5.67748C8.50688 5.67748 9.32287 6.49348 9.32287 7.50006Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1E = [
    "color"
];
var $c12e32cf04d921d4$export$bf776c57f6d5a7c1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1E);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.07451 1.82584C5.03267 1.81926 4.99014 1.81825 4.94803 1.82284C4.10683 1.91446 2.82673 2.36828 2.07115 2.77808C2.02106 2.80525 1.97621 2.84112 1.93869 2.88402C1.62502 3.24266 1.34046 3.82836 1.11706 4.38186C0.887447 4.95076 0.697293 5.55032 0.588937 5.98354C0.236232 7.39369 0.042502 9.08728 0.0174948 10.6925C0.0162429 10.7729 0.0351883 10.8523 0.0725931 10.9234C0.373679 11.496 1.02015 12.027 1.66809 12.4152C2.32332 12.8078 3.08732 13.1182 3.70385 13.1778C3.85335 13.1922 4.00098 13.1358 4.10282 13.0255C4.2572 12.8581 4.5193 12.4676 4.71745 12.1643C4.80739 12.0267 4.89157 11.8953 4.95845 11.7901C5.62023 11.9106 6.45043 11.9801 7.50002 11.9801C8.54844 11.9801 9.37796 11.9107 10.0394 11.7905C10.1062 11.8957 10.1903 12.0269 10.2801 12.1643C10.4783 12.4676 10.7404 12.8581 10.8947 13.0255C10.9966 13.1358 11.1442 13.1922 11.2937 13.1778C11.9102 13.1182 12.6742 12.8078 13.3295 12.4152C13.9774 12.027 14.6239 11.496 14.925 10.9234C14.9624 10.8523 14.9813 10.7729 14.9801 10.6925C14.9551 9.08728 14.7613 7.39369 14.4086 5.98354C14.3003 5.55032 14.1101 4.95076 13.8805 4.38186C13.6571 3.82836 13.3725 3.24266 13.0589 2.88402C13.0214 2.84112 12.9765 2.80525 12.9264 2.77808C12.1708 2.36828 10.8907 1.91446 10.0495 1.82284C10.0074 1.81825 9.96489 1.81926 9.92305 1.82584C9.71676 1.85825 9.5391 1.96458 9.40809 2.06355C9.26977 2.16804 9.1413 2.29668 9.0304 2.42682C8.86968 2.61544 8.71437 2.84488 8.61428 3.06225C8.27237 3.03501 7.90138 3.02 7.5 3.02C7.0977 3.02 6.72593 3.03508 6.38337 3.06244C6.28328 2.84501 6.12792 2.61549 5.96716 2.42682C5.85626 2.29668 5.72778 2.16804 5.58947 2.06355C5.45846 1.96458 5.2808 1.85825 5.07451 1.82584ZM11.0181 11.5382C11.0395 11.5713 11.0615 11.6051 11.0838 11.6392C11.2169 11.843 11.3487 12.0385 11.4508 12.1809C11.8475 12.0916 12.352 11.8818 12.8361 11.5917C13.3795 11.2661 13.8098 10.8918 14.0177 10.5739C13.9852 9.06758 13.7993 7.50369 13.4773 6.21648C13.38 5.82759 13.2038 5.27021 12.9903 4.74117C12.7893 4.24326 12.5753 3.82162 12.388 3.5792C11.7376 3.24219 10.7129 2.88582 10.0454 2.78987C10.0308 2.79839 10.0113 2.81102 9.98675 2.82955C9.91863 2.881 9.84018 2.95666 9.76111 3.04945C9.71959 3.09817 9.68166 3.1471 9.64768 3.19449C9.953 3.25031 10.2253 3.3171 10.4662 3.39123C11.1499 3.6016 11.6428 3.89039 11.884 4.212C12.0431 4.42408 12.0001 4.72494 11.788 4.884C11.5759 5.04306 11.2751 5.00008 11.116 4.788C11.0572 4.70961 10.8001 4.4984 10.1838 4.30877C9.58933 4.12585 8.71356 3.98 7.5 3.98C6.28644 3.98 5.41067 4.12585 4.81616 4.30877C4.19988 4.4984 3.94279 4.70961 3.884 4.788C3.72494 5.00008 3.42408 5.04306 3.212 4.884C2.99992 4.72494 2.95694 4.42408 3.116 4.212C3.35721 3.89039 3.85011 3.6016 4.53383 3.39123C4.77418 3.31727 5.04571 3.25062 5.35016 3.19488C5.31611 3.14738 5.27808 3.09831 5.23645 3.04945C5.15738 2.95666 5.07893 2.881 5.01081 2.82955C4.98628 2.81102 4.96674 2.79839 4.95217 2.78987C4.28464 2.88582 3.25999 3.24219 2.60954 3.5792C2.42226 3.82162 2.20825 4.24326 2.00729 4.74117C1.79376 5.27021 1.61752 5.82759 1.52025 6.21648C1.19829 7.50369 1.01236 9.06758 0.97986 10.5739C1.18772 10.8918 1.61807 11.2661 2.16148 11.5917C2.64557 11.8818 3.15003 12.0916 3.5468 12.1809C3.64885 12.0385 3.78065 11.843 3.9138 11.6392C3.93626 11.6048 3.95838 11.5708 3.97996 11.5375C3.19521 11.2591 2.77361 10.8758 2.50064 10.4664C2.35359 10.2458 2.4132 9.94778 2.63377 9.80074C2.85435 9.65369 3.15236 9.71329 3.29941 9.93387C3.56077 10.3259 4.24355 11.0201 7.50002 11.0201C10.7565 11.0201 11.4392 10.326 11.7006 9.93386C11.8477 9.71329 12.1457 9.65369 12.3663 9.80074C12.5869 9.94779 12.6465 10.2458 12.4994 10.4664C12.2262 10.8762 11.8041 11.2598 11.0181 11.5382ZM4.08049 7.01221C4.32412 6.74984 4.65476 6.60162 5.00007 6.59998C5.34538 6.60162 5.67603 6.74984 5.91966 7.01221C6.16329 7.27459 6.30007 7.62974 6.30007 7.99998C6.30007 8.37021 6.16329 8.72536 5.91966 8.98774C5.67603 9.25011 5.34538 9.39833 5.00007 9.39998C4.65476 9.39833 4.32412 9.25011 4.08049 8.98774C3.83685 8.72536 3.70007 8.37021 3.70007 7.99998C3.70007 7.62974 3.83685 7.27459 4.08049 7.01221ZM9.99885 6.59998C9.65354 6.60162 9.3229 6.74984 9.07926 7.01221C8.83563 7.27459 8.69885 7.62974 8.69885 7.99998C8.69885 8.37021 8.83563 8.72536 9.07926 8.98774C9.3229 9.25011 9.65354 9.39833 9.99885 9.39998C10.3442 9.39833 10.6748 9.25011 10.9184 8.98774C11.1621 8.72536 11.2989 8.37021 11.2989 7.99998C11.2989 7.62974 11.1621 7.27459 10.9184 7.01221C10.6748 6.74984 10.3442 6.60162 9.99885 6.59998Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$1F = [
    "color"
];
var $c12e32cf04d921d4$export$67e4f137381994a7 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1F);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1G = [
    "color"
];
var $c12e32cf04d921d4$export$4941448a902289ea = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1G);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1H = [
    "color"
];
var $c12e32cf04d921d4$export$1638d451d4588271 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1H);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 9.125C8.39746 9.125 9.125 8.39746 9.125 7.5C9.125 6.60254 8.39746 5.875 7.5 5.875C6.60254 5.875 5.875 6.60254 5.875 7.5C5.875 8.39746 6.60254 9.125 7.5 9.125ZM7.5 10.125C8.94975 10.125 10.125 8.94975 10.125 7.5C10.125 6.05025 8.94975 4.875 7.5 4.875C6.05025 4.875 4.875 6.05025 4.875 7.5C4.875 8.94975 6.05025 10.125 7.5 10.125Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1I = [
    "color"
];
var $c12e32cf04d921d4$export$5ce415a59e297ace = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1I);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.875 7.5C9.875 8.81168 8.81168 9.875 7.5 9.875C6.18832 9.875 5.125 8.81168 5.125 7.5C5.125 6.18832 6.18832 5.125 7.5 5.125C8.81168 5.125 9.875 6.18832 9.875 7.5Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$1J = [
    "color"
];
var $c12e32cf04d921d4$export$9789fa787c2a8e33 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1J);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1K = [
    "color"
];
var $c12e32cf04d921d4$export$f50786ff8e0cdf62 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1K);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.625 2.5C8.625 3.12132 8.12132 3.625 7.5 3.625C6.87868 3.625 6.375 3.12132 6.375 2.5C6.375 1.87868 6.87868 1.375 7.5 1.375C8.12132 1.375 8.625 1.87868 8.625 2.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM7.5 13.625C8.12132 13.625 8.625 13.1213 8.625 12.5C8.625 11.8787 8.12132 11.375 7.5 11.375C6.87868 11.375 6.375 11.8787 6.375 12.5C6.375 13.1213 6.87868 13.625 7.5 13.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1L = [
    "color"
];
var $c12e32cf04d921d4$export$de42cbda950c1561 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1L);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.85355 2.14645C3.65829 1.95118 3.34171 1.95118 3.14645 2.14645C2.95118 2.34171 2.95118 2.65829 3.14645 2.85355L7.14645 6.85355C7.34171 7.04882 7.65829 7.04882 7.85355 6.85355L11.8536 2.85355C12.0488 2.65829 12.0488 2.34171 11.8536 2.14645C11.6583 1.95118 11.3417 1.95118 11.1464 2.14645L7.5 5.79289L3.85355 2.14645ZM3.85355 8.14645C3.65829 7.95118 3.34171 7.95118 3.14645 8.14645C2.95118 8.34171 2.95118 8.65829 3.14645 8.85355L7.14645 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L11.8536 8.85355C12.0488 8.65829 12.0488 8.34171 11.8536 8.14645C11.6583 7.95118 11.3417 7.95118 11.1464 8.14645L7.5 11.7929L3.85355 8.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1M = [
    "color"
];
var $c12e32cf04d921d4$export$8f14af9007650906 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1M);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1N = [
    "color"
];
var $c12e32cf04d921d4$export$90b329a415b2a5d4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1N);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1O = [
    "color"
];
var $c12e32cf04d921d4$export$4625b0d11d3861cc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1O);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.1464 6.85355C11.3417 7.04882 11.6583 7.04882 11.8536 6.85355C12.0488 6.65829 12.0488 6.34171 11.8536 6.14645L7.85355 2.14645C7.65829 1.95118 7.34171 1.95118 7.14645 2.14645L3.14645 6.14645C2.95118 6.34171 2.95118 6.65829 3.14645 6.85355C3.34171 7.04882 3.65829 7.04882 3.85355 6.85355L7.5 3.20711L11.1464 6.85355ZM11.1464 12.8536C11.3417 13.0488 11.6583 13.0488 11.8536 12.8536C12.0488 12.6583 12.0488 12.3417 11.8536 12.1464L7.85355 8.14645C7.65829 7.95118 7.34171 7.95118 7.14645 8.14645L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L7.5 9.20711L11.1464 12.8536Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1P = [
    "color"
];
var $c12e32cf04d921d4$export$4e54df4252b4a99c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1P);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1Q = [
    "color"
];
var $c12e32cf04d921d4$export$209fdd70701c1b6e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1Q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "4.5",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "6.5",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "8.499",
        cy: "12.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "2.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "4.5",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "6.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "8.499",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "10.498",
        r: ".6",
        fill: color
    }), (0, $exYeM.createElement)("circle", {
        cx: "10.499",
        cy: "12.498",
        r: ".6",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$1R = [
    "color"
];
var $c12e32cf04d921d4$export$829e9de7006febc4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1R);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1S = [
    "color"
];
var $c12e32cf04d921d4$export$e6848a231b25a576 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1S);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.49998 4.09998C2.27906 4.09998 2.09998 4.27906 2.09998 4.49998C2.09998 4.72089 2.27906 4.89998 2.49998 4.89998H12.5C12.7209 4.89998 12.9 4.72089 12.9 4.49998C12.9 4.27906 12.7209 4.09998 12.5 4.09998H2.49998ZM2.49998 6.09998C2.27906 6.09998 2.09998 6.27906 2.09998 6.49998C2.09998 6.72089 2.27906 6.89998 2.49998 6.89998H12.5C12.7209 6.89998 12.9 6.72089 12.9 6.49998C12.9 6.27906 12.7209 6.09998 12.5 6.09998H2.49998ZM2.09998 8.49998C2.09998 8.27906 2.27906 8.09998 2.49998 8.09998H12.5C12.7209 8.09998 12.9 8.27906 12.9 8.49998C12.9 8.72089 12.7209 8.89998 12.5 8.89998H2.49998C2.27906 8.89998 2.09998 8.72089 2.09998 8.49998ZM2.49998 10.1C2.27906 10.1 2.09998 10.2791 2.09998 10.5C2.09998 10.7209 2.27906 10.9 2.49998 10.9H12.5C12.7209 10.9 12.9 10.7209 12.9 10.5C12.9 10.2791 12.7209 10.1 12.5 10.1H2.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1T = [
    "color"
];
var $c12e32cf04d921d4$export$b72a86f6a31cd8d8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1T);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.09998 12.5C4.09998 12.7209 4.27906 12.9 4.49998 12.9C4.72089 12.9 4.89998 12.7209 4.89998 12.5L4.89998 2.50002C4.89998 2.27911 4.72089 2.10003 4.49998 2.10003C4.27906 2.10003 4.09998 2.27911 4.09998 2.50002L4.09998 12.5ZM6.09998 12.5C6.09998 12.7209 6.27906 12.9 6.49998 12.9C6.72089 12.9 6.89998 12.7209 6.89998 12.5L6.89998 2.50002C6.89998 2.27911 6.72089 2.10003 6.49998 2.10003C6.27906 2.10003 6.09998 2.27911 6.09998 2.50002L6.09998 12.5ZM8.49998 12.9C8.27906 12.9 8.09998 12.7209 8.09998 12.5L8.09998 2.50002C8.09998 2.27911 8.27906 2.10002 8.49998 2.10002C8.72089 2.10002 8.89998 2.27911 8.89998 2.50002L8.89998 12.5C8.89998 12.7209 8.72089 12.9 8.49998 12.9ZM10.1 12.5C10.1 12.7209 10.2791 12.9 10.5 12.9C10.7209 12.9 10.9 12.7209 10.9 12.5L10.9 2.50002C10.9 2.27911 10.7209 2.10002 10.5 2.10002C10.2791 2.10002 10.1 2.27911 10.1 2.50002L10.1 12.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1U = [
    "color"
];
var $c12e32cf04d921d4$export$d678e82375a26dcf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1U);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10.3285 1.13607C10.1332 0.940809 9.81662 0.940808 9.62136 1.13607C9.42609 1.33133 9.42609 1.64792 9.62136 1.84318L10.2744 2.49619L5.42563 6.13274L4.31805 5.02516C4.12279 4.8299 3.80621 4.8299 3.61095 5.02516C3.41569 5.22042 3.41569 5.537 3.61095 5.73226L5.02516 7.14648L6.08582 8.20714L2.81545 11.4775C2.62019 11.6728 2.62019 11.9894 2.81545 12.1846C3.01072 12.3799 3.3273 12.3799 3.52256 12.1846L6.79293 8.91425L7.85359 9.97491L9.2678 11.3891C9.46306 11.5844 9.77965 11.5844 9.97491 11.3891C10.1702 11.1939 10.1702 10.8773 9.97491 10.682L8.86733 9.57443L12.5039 4.7257L13.1569 5.37871C13.3522 5.57397 13.6687 5.57397 13.864 5.37871C14.0593 5.18345 14.0593 4.86687 13.864 4.6716L12.8033 3.61094L11.3891 2.19673L10.3285 1.13607ZM6.13992 6.84702L10.9887 3.21047L11.7896 4.01142L8.15305 8.86015L6.13992 6.84702Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1V = [
    "color"
];
var $c12e32cf04d921d4$export$c6212c739d4cf8da = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1V);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1W = [
    "color"
];
var $c12e32cf04d921d4$export$e5daec7136b0534 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1W);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49999 3.09998C7.27907 3.09998 7.09999 3.27906 7.09999 3.49998C7.09999 3.72089 7.27907 3.89998 7.49999 3.89998H14.5C14.7209 3.89998 14.9 3.72089 14.9 3.49998C14.9 3.27906 14.7209 3.09998 14.5 3.09998H7.49999ZM7.49998 5.1C7.27907 5.1 7.09998 5.27908 7.09998 5.5C7.09998 5.72091 7.27907 5.9 7.49998 5.9H14.5C14.7209 5.9 14.9 5.72091 14.9 5.5C14.9 5.27908 14.7209 5.1 14.5 5.1H7.49998ZM7.1 7.5C7.1 7.27908 7.27909 7.1 7.5 7.1H14.5C14.7209 7.1 14.9 7.27908 14.9 7.5C14.9 7.72091 14.7209 7.9 14.5 7.9H7.5C7.27909 7.9 7.1 7.72091 7.1 7.5ZM7.49998 9.1C7.27907 9.1 7.09998 9.27908 7.09998 9.5C7.09998 9.72091 7.27907 9.9 7.49998 9.9H14.5C14.7209 9.9 14.9 9.72091 14.9 9.5C14.9 9.27908 14.7209 9.1 14.5 9.1H7.49998ZM7.09998 11.5C7.09998 11.2791 7.27907 11.1 7.49998 11.1H14.5C14.7209 11.1 14.9 11.2791 14.9 11.5C14.9 11.7209 14.7209 11.9 14.5 11.9H7.49998C7.27907 11.9 7.09998 11.7209 7.09998 11.5ZM2.5 9.25003L5 6.00003H0L2.5 9.25003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1X = [
    "color"
];
var $c12e32cf04d921d4$export$296bea1be8b4086a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1X);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2H12V13H4.5C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14H12C12.5523 14 13 13.5523 13 13V2C13 1.44772 12.5523 1 12 1H4.5ZM6.60355 4.89645C6.40829 4.70118 6.09171 4.70118 5.89645 4.89645C5.70118 5.09171 5.70118 5.40829 5.89645 5.60355L7.29289 7H0.5C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H7.29289L5.89645 9.39645C5.70118 9.59171 5.70118 9.90829 5.89645 10.1036C6.09171 10.2988 6.40829 10.2988 6.60355 10.1036L8.85355 7.85355C9.04882 7.65829 9.04882 7.34171 8.85355 7.14645L6.60355 4.89645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1Y = [
    "color"
];
var $c12e32cf04d921d4$export$5886b995403a6540 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1Y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 2.5C2 2.22386 2.22386 2 2.5 2H5.5C5.77614 2 6 2.22386 6 2.5C6 2.77614 5.77614 3 5.5 3H3V5.5C3 5.77614 2.77614 6 2.5 6C2.22386 6 2 5.77614 2 5.5V2.5ZM9 2.5C9 2.22386 9.22386 2 9.5 2H12.5C12.7761 2 13 2.22386 13 2.5V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3H9.5C9.22386 3 9 2.77614 9 2.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H2.5C2.22386 13 2 12.7761 2 12.5V9.5C2 9.22386 2.22386 9 2.5 9ZM12.5 9C12.7761 9 13 9.22386 13 9.5V12.5C13 12.7761 12.7761 13 12.5 13H9.5C9.22386 13 9 12.7761 9 12.5C9 12.2239 9.22386 12 9.5 12H12V9.5C12 9.22386 12.2239 9 12.5 9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1Z = [
    "color"
];
var $c12e32cf04d921d4$export$c81ccc0bdd70284 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1Z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1_ = [
    "color"
];
var $c12e32cf04d921d4$export$808857d2db6c57a2 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1_);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.94721 0.164594C7.66569 0.0238299 7.33431 0.0238302 7.05279 0.164594L0.552786 3.41459C0.214002 3.58399 0 3.93025 0 4.30902V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V4.30902C15 3.93025 14.786 3.58399 14.4472 3.41459L7.94721 0.164594ZM13.5689 4.09349L7.5 1.05902L1.43105 4.09349L7.5 7.29136L13.5689 4.09349ZM1 4.88366V12H14V4.88366L7.70977 8.19813C7.57848 8.26731 7.42152 8.26731 7.29023 8.19813L1 4.88366Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$1$ = [
    "color"
];
var $c12e32cf04d921d4$export$b6c544816d254f36 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$1$);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.36052 0.72921C8.55578 0.533948 8.87236 0.533948 9.06763 0.72921L14.2708 5.93235C14.466 6.12761 14.466 6.4442 14.2708 6.63946L8.95513 11.9551L7.3466 13.5636C6.76081 14.1494 5.81106 14.1494 5.22528 13.5636L1.43635 9.7747C0.850563 9.18891 0.850563 8.23917 1.43635 7.65338L3.04488 6.04485L8.36052 0.72921ZM8.71407 1.78987L4.10554 6.3984L8.60157 10.8944L13.2101 6.28591L8.71407 1.78987ZM7.89447 11.6015L3.39843 7.10551L2.14346 8.36049C1.94819 8.55575 1.94819 8.87233 2.14346 9.06759L5.93238 12.8565C6.12765 13.0518 6.44423 13.0518 6.63949 12.8565L7.89447 11.6015Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$20 = [
    "color"
];
var $c12e32cf04d921d4$export$b409b230b61d4724 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$20);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.4449 0.608765C8.0183 -0.107015 6.9817 -0.107015 6.55509 0.608766L0.161178 11.3368C-0.275824 12.07 0.252503 13 1.10608 13H13.8939C14.7475 13 15.2758 12.07 14.8388 11.3368L8.4449 0.608765ZM7.4141 1.12073C7.45288 1.05566 7.54712 1.05566 7.5859 1.12073L13.9798 11.8488C14.0196 11.9154 13.9715 12 13.8939 12H1.10608C1.02849 12 0.980454 11.9154 1.02018 11.8488L7.4141 1.12073ZM6.8269 4.48611C6.81221 4.10423 7.11783 3.78663 7.5 3.78663C7.88217 3.78663 8.18778 4.10423 8.1731 4.48612L8.01921 8.48701C8.00848 8.766 7.7792 8.98664 7.5 8.98664C7.2208 8.98664 6.99151 8.766 6.98078 8.48701L6.8269 4.48611ZM8.24989 10.476C8.24989 10.8902 7.9141 11.226 7.49989 11.226C7.08567 11.226 6.74989 10.8902 6.74989 10.476C6.74989 10.0618 7.08567 9.72599 7.49989 9.72599C7.9141 9.72599 8.24989 10.0618 8.24989 10.476Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$21 = [
    "color"
];
var $c12e32cf04d921d4$export$72b807c0098a555f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$21);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 1C2.44771 1 2 1.44772 2 2V13C2 13.5523 2.44772 14 3 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H3V2L10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1H3ZM12.6036 4.89645C12.4083 4.70118 12.0917 4.70118 11.8964 4.89645C11.7012 5.09171 11.7012 5.40829 11.8964 5.60355L13.2929 7H6.5C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H13.2929L11.8964 9.39645C11.7012 9.59171 11.7012 9.90829 11.8964 10.1036C12.0917 10.2988 12.4083 10.2988 12.6036 10.1036L14.8536 7.85355C15.0488 7.65829 15.0488 7.34171 14.8536 7.14645L12.6036 4.89645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$22 = [
    "color"
];
var $c12e32cf04d921d4$export$7e82c66e763fb043 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$22);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.5 2C5.77614 2 6 2.22386 6 2.5V5.5C6 5.77614 5.77614 6 5.5 6H2.5C2.22386 6 2 5.77614 2 5.5C2 5.22386 2.22386 5 2.5 5H5V2.5C5 2.22386 5.22386 2 5.5 2ZM9.5 2C9.77614 2 10 2.22386 10 2.5V5H12.5C12.7761 5 13 5.22386 13 5.5C13 5.77614 12.7761 6 12.5 6H9.5C9.22386 6 9 5.77614 9 5.5V2.5C9 2.22386 9.22386 2 9.5 2ZM2 9.5C2 9.22386 2.22386 9 2.5 9H5.5C5.77614 9 6 9.22386 6 9.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V10H2.5C2.22386 10 2 9.77614 2 9.5ZM9 9.5C9 9.22386 9.22386 9 9.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H10V12.5C10 12.7761 9.77614 13 9.5 13C9.22386 13 9 12.7761 9 12.5V9.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$23 = [
    "color"
];
var $c12e32cf04d921d4$export$9bd11592bfa362e7 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$23);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$24 = [
    "color"
];
var $c12e32cf04d921d4$export$f2c2531e46a6c1ea = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$24);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14.7649 6.07596C14.9991 6.22231 15.0703 6.53079 14.9239 6.76495C14.4849 7.46743 13.9632 8.10645 13.3702 8.66305L14.5712 9.86406C14.7664 10.0593 14.7664 10.3759 14.5712 10.5712C14.3759 10.7664 14.0593 10.7664 13.8641 10.5712L12.6011 9.30817C11.805 9.90283 10.9089 10.3621 9.93375 10.651L10.383 12.3277C10.4544 12.5944 10.2961 12.8685 10.0294 12.94C9.76267 13.0115 9.4885 12.8532 9.41704 12.5865L8.95917 10.8775C8.48743 10.958 8.00036 10.9999 7.50001 10.9999C6.99965 10.9999 6.51257 10.958 6.04082 10.8775L5.58299 12.5864C5.51153 12.8532 5.23737 13.0115 4.97064 12.94C4.7039 12.8686 4.5456 12.5944 4.61706 12.3277L5.06625 10.651C4.09111 10.3621 3.19503 9.90282 2.3989 9.30815L1.1359 10.5712C0.940638 10.7664 0.624058 10.7664 0.428798 10.5712C0.233537 10.3759 0.233537 10.0593 0.428798 9.86405L1.62982 8.66303C1.03682 8.10643 0.515113 7.46742 0.0760677 6.76495C-0.0702867 6.53079 0.000898544 6.22231 0.235065 6.07596C0.469231 5.9296 0.777703 6.00079 0.924058 6.23496C1.40354 7.00213 1.989 7.68057 2.66233 8.2427C2.67315 8.25096 2.6837 8.25972 2.69397 8.26898C4.00897 9.35527 5.65537 9.99991 7.50001 9.99991C10.3078 9.99991 12.6564 8.5063 14.076 6.23495C14.2223 6.00079 14.5308 5.9296 14.7649 6.07596Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$25 = [
    "color"
];
var $c12e32cf04d921d4$export$3547759c3ff9b44c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$25);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$26 = [
    "color"
];
var $c12e32cf04d921d4$export$620653f31aa3377e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$26);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$27 = [
    "color"
];
var $c12e32cf04d921d4$export$b8f42e9471d5f647 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$27);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82708 7.49972C1.82708 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82708 10.6327 1.82708 7.49972ZM5.03747 9.21395C4.87949 8.98746 4.56782 8.93193 4.34133 9.08991C4.11484 9.24789 4.05931 9.55956 4.21729 9.78605C4.93926 10.8211 6.14033 11.5 7.50004 11.5C8.85974 11.5 10.0608 10.8211 10.7828 9.78605C10.9408 9.55956 10.8852 9.24789 10.6587 9.08991C10.4323 8.93193 10.1206 8.98746 9.9626 9.21395C9.41963 9.99238 8.51907 10.5 7.50004 10.5C6.481 10.5 5.58044 9.99238 5.03747 9.21395ZM5.37503 6.84998C5.85828 6.84998 6.25003 6.45815 6.25003 5.97498C6.25003 5.4918 5.85828 5.09998 5.37503 5.09998C4.89179 5.09998 4.50003 5.4918 4.50003 5.97498C4.50003 6.45815 4.89179 6.84998 5.37503 6.84998ZM10.5 5.97498C10.5 6.45815 10.1083 6.84998 9.62503 6.84998C9.14179 6.84998 8.75003 6.45815 8.75003 5.97498C8.75003 5.4918 9.14179 5.09998 9.62503 5.09998C10.1083 5.09998 10.5 5.4918 10.5 5.97498Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$28 = [
    "color"
];
var $c12e32cf04d921d4$export$2b3d0ca2fe16e98c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$28);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.00005 2.04999H5.52505C4.71043 2.04999 4.05005 2.71037 4.05005 3.52499C4.05005 4.33961 4.71043 4.99999 5.52505 4.99999H7.00005V2.04999ZM7.00005 1.04999H8.00005H9.47505C10.842 1.04999 11.95 2.15808 11.95 3.52499C11.95 4.33163 11.5642 5.04815 10.9669 5.49999C11.5642 5.95184 11.95 6.66836 11.95 7.475C11.95 8.8419 10.842 9.95 9.47505 9.95C8.92236 9.95 8.41198 9.76884 8.00005 9.46266V9.95L8.00005 11.425C8.00005 12.7919 6.89195 13.9 5.52505 13.9C4.15814 13.9 3.05005 12.7919 3.05005 11.425C3.05005 10.6183 3.43593 9.90184 4.03317 9.44999C3.43593 8.99814 3.05005 8.28163 3.05005 7.475C3.05005 6.66836 3.43594 5.95184 4.03319 5.5C3.43594 5.04815 3.05005 4.33163 3.05005 3.52499C3.05005 2.15808 4.15814 1.04999 5.52505 1.04999H7.00005ZM8.00005 2.04999V4.99999H9.47505C10.2897 4.99999 10.95 4.33961 10.95 3.52499C10.95 2.71037 10.2897 2.04999 9.47505 2.04999H8.00005ZM5.52505 8.94998H7.00005L7.00005 7.4788L7.00005 7.475L7.00005 7.4712V6H5.52505C4.71043 6 4.05005 6.66038 4.05005 7.475C4.05005 8.28767 4.70727 8.94684 5.5192 8.94999L5.52505 8.94998ZM4.05005 11.425C4.05005 10.6123 4.70727 9.95315 5.5192 9.94999L5.52505 9.95H7.00005L7.00005 11.425C7.00005 12.2396 6.33967 12.9 5.52505 12.9C4.71043 12.9 4.05005 12.2396 4.05005 11.425ZM8.00005 7.47206C8.00164 6.65879 8.66141 6 9.47505 6C10.2897 6 10.95 6.66038 10.95 7.475C10.95 8.28962 10.2897 8.95 9.47505 8.95C8.66141 8.95 8.00164 8.29121 8.00005 7.47794V7.47206Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$29 = [
    "color"
];
var $c12e32cf04d921d4$export$8c1a3d13e85d78b7 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$29);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V6H8.5C8.22386 6 8 5.77614 8 5.5V2H3.5ZM9 2.70711L11.2929 5H9V2.70711ZM2 2.5C2 1.67157 2.67157 1 3.5 1H8.5C8.63261 1 8.75979 1.05268 8.85355 1.14645L12.8536 5.14645C12.9473 5.24021 13 5.36739 13 5.5V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2a = [
    "color"
];
var $c12e32cf04d921d4$export$3c5dbe056aa7c94f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2a);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.29289L12 4.70711V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.60355C13 4.40464 12.921 4.21388 12.7803 4.07322L9.85355 1.14645C9.75979 1.05268 9.63261 1 9.5 1H3.5ZM5.25 7C4.97386 7 4.75 7.22386 4.75 7.5C4.75 7.77614 4.97386 8 5.25 8H9.75C10.0261 8 10.25 7.77614 10.25 7.5C10.25 7.22386 10.0261 7 9.75 7H5.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2b = [
    "color"
];
var $c12e32cf04d921d4$export$ca191b730434e9b4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2b);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V4.70711L9.29289 2H3.5ZM2 2.5C2 1.67157 2.67157 1 3.5 1H9.5C9.63261 1 9.75979 1.05268 9.85355 1.14645L12.7803 4.07322C12.921 4.21388 13 4.40464 13 4.60355V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5ZM4.75 7.5C4.75 7.22386 4.97386 7 5.25 7H7V5.25C7 4.97386 7.22386 4.75 7.5 4.75C7.77614 4.75 8 4.97386 8 5.25V7H9.75C10.0261 7 10.25 7.22386 10.25 7.5C10.25 7.77614 10.0261 8 9.75 8H8V9.75C8 10.0261 7.77614 10.25 7.5 10.25C7.22386 10.25 7 10.0261 7 9.75V8H5.25C4.97386 8 4.75 7.77614 4.75 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2c = [
    "color"
];
var $c12e32cf04d921d4$export$605674723bcc715c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2c);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.08579C9.21839 2 9.34557 2.05268 9.43934 2.14645L11.8536 4.56066C11.9473 4.65443 12 4.78161 12 4.91421V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.91421C13 4.51639 12.842 4.13486 12.5607 3.85355L10.1464 1.43934C9.86514 1.15804 9.48361 1 9.08579 1H3.5ZM4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H7.5C7.77614 5 8 4.77614 8 4.5C8 4.22386 7.77614 4 7.5 4H4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H10.5C10.7761 11 11 10.7761 11 10.5C11 10.2239 10.7761 10 10.5 10H4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2d = [
    "color"
];
var $c12e32cf04d921d4$export$1a2ae984f27cf526 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2d);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.10505 12C4.70805 12 4.4236 11.912 4.25171 11.736C4.0839 11.5559 4 11.2715 4 10.8827V4.11733C4 3.72033 4.08595 3.43588 4.25784 3.26398C4.43383 3.08799 4.71623 3 5.10505 3C6.42741 3 8.25591 3 9.02852 3C10.1373 3 11.0539 3.98153 11.0539 5.1846C11.0539 6.08501 10.6037 6.81855 9.70327 7.23602C10.8657 7.44851 11.5176 8.62787 11.5176 9.48128C11.5176 10.5125 10.9902 12 9.27734 12C8.77742 12 6.42626 12 5.10505 12ZM8.37891 8.00341H5.8V10.631H8.37891C8.9 10.631 9.6296 10.1211 9.6296 9.29877C9.6296 8.47643 8.9 8.00341 8.37891 8.00341ZM5.8 4.36903V6.69577H8.17969C8.53906 6.69577 9.27734 6.35939 9.27734 5.50002C9.27734 4.64064 8.48047 4.36903 8.17969 4.36903H5.8Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$2e = [
    "color"
];
var $c12e32cf04d921d4$export$79d8792587f7aca5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2e);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.5 4.5C2.5 3.09886 3.59886 2 5 2H12.499C12.7752 2 13 2.22386 13 2.5C13 2.77614 12.7761 3 12.5 3H8.69244L8.40509 3.85458C8.18869 4.49752 7.89401 5.37197 7.58091 6.29794C7.50259 6.52956 7.42308 6.76453 7.34332 7H8.5C8.77614 7 9 7.22386 9 7.5C9 7.77614 8.77614 8 8.5 8H7.00407C6.56724 9.28543 6.16435 10.4613 5.95799 11.0386C5.63627 11.9386 5.20712 12.4857 4.66741 12.7778C4.16335 13.0507 3.64154 13.0503 3.28378 13.05L3.25 13.05C2.94624 13.05 2.7 12.8037 2.7 12.5C2.7 12.1962 2.94624 11.95 3.25 11.95C3.64182 11.95 3.9035 11.9405 4.14374 11.8105C4.36443 11.691 4.65532 11.4148 4.92217 10.6683C5.10695 10.1514 5.45375 9.14134 5.8422 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H6.18187C6.30127 6.64785 6.42132 6.29323 6.53887 5.94559C6.85175 5.02025 7.14627 4.14631 7.36256 3.50368L7.53192 3H5C4.15114 3 3.5 3.65114 3.5 4.5C3.5 4.77614 3.27614 5 3 5C2.72386 5 2.5 4.77614 2.5 4.5Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$2f = [
    "color"
];
var $c12e32cf04d921d4$export$f5ac866b2a77627a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2f);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.67494 3.50017C5.67494 3.25164 5.87641 3.05017 6.12494 3.05017H10.6249C10.8735 3.05017 11.0749 3.25164 11.0749 3.50017C11.0749 3.7487 10.8735 3.95017 10.6249 3.95017H9.00587L7.2309 11.05H8.87493C9.12345 11.05 9.32493 11.2515 9.32493 11.5C9.32493 11.7486 9.12345 11.95 8.87493 11.95H4.37493C4.1264 11.95 3.92493 11.7486 3.92493 11.5C3.92493 11.2515 4.1264 11.05 4.37493 11.05H5.99397L7.76894 3.95017H6.12494C5.87641 3.95017 5.67494 3.7487 5.67494 3.50017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2g = [
    "color"
];
var $c12e32cf04d921d4$export$9f94aa21504b3fcd = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2g);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.79993 3.50017C4.79993 3.25164 5.0014 3.05017 5.24993 3.05017H9.74993C9.99845 3.05017 10.1999 3.25164 10.1999 3.50017C10.1999 3.7487 9.99845 3.95017 9.74993 3.95017H8.09993V11.05H9.74994C9.99847 11.05 10.1999 11.2515 10.1999 11.5C10.1999 11.7486 9.99847 11.95 9.74994 11.95H5.24994C5.00141 11.95 4.79994 11.7486 4.79994 11.5C4.79994 11.2515 5.00141 11.05 5.24994 11.05H6.89993V3.95017H5.24993C5.0014 3.95017 4.79993 3.7487 4.79993 3.50017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2h = [
    "color"
];
var $c12e32cf04d921d4$export$88890ea574fb3a19 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2h);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.78233 2.21707C2.70732 2.14206 2.60557 2.09991 2.49949 2.09991C2.3934 2.09991 2.29166 2.14206 2.21664 2.21707L0.216645 4.21707C0.0604351 4.37328 0.0604351 4.62655 0.216645 4.78276C0.372855 4.93897 0.626121 4.93897 0.78233 4.78276L2.09949 3.4656L2.09949 11.5342L0.78233 10.2171C0.62612 10.0609 0.372854 10.0609 0.216645 10.2171C0.0604349 10.3733 0.0604349 10.6265 0.216645 10.7828L2.21664 12.7828C2.29166 12.8578 2.3934 12.8999 2.49949 12.8999C2.60557 12.8999 2.70731 12.8578 2.78233 12.7828L4.78233 10.7828C4.93854 10.6265 4.93854 10.3733 4.78233 10.2171C4.62612 10.0609 4.37285 10.0609 4.21664 10.2171L2.89949 11.5342L2.89949 3.4656L4.21664 4.78276C4.37285 4.93897 4.62612 4.93897 4.78233 4.78276C4.93854 4.62655 4.93854 4.37328 4.78233 4.21707L2.78233 2.21707ZM10.5 2.74997C10.7107 2.74997 10.8988 2.88211 10.9703 3.08036L13.9703 11.3999C14.064 11.6597 13.9293 11.9462 13.6696 12.0399C13.4098 12.1336 13.1233 11.9989 13.0296 11.7392L12.0477 9.016H8.95228L7.97033 11.7392C7.87666 11.9989 7.59013 12.1336 7.33036 12.0399C7.07059 11.9462 6.93595 11.6597 7.02962 11.3999L10.0296 3.08036C10.1011 2.88211 10.2892 2.74997 10.5 2.74997ZM10.5 4.72396L11.7412 8.166H9.25879L10.5 4.72396Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2i = [
    "color"
];
var $c12e32cf04d921d4$export$805712ff48c03e2e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2i);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.03791 9.98075C0.934777 9.6583 1.11603 9.37719 1.40005 9.24871C1.68408 9.12022 2.09463 9.13412 2.27071 9.45426C2.85393 10.5147 3.64599 10.7282 4.48665 10.7282C5.52721 10.7282 6.29659 10.2615 6.29659 9.45426C6.29659 8.8047 5.9119 8.46416 4.87134 8.14253L4.15872 7.92181C2.64518 7.44883 1.88842 6.69206 1.88842 5.45601C1.88842 3.79743 3.27583 2.6875 5.24342 2.6875C6.91733 2.6875 7.97409 3.33536 8.43833 4.31065C8.57087 4.58909 8.57614 4.91294 8.22794 5.19114C7.87974 5.46934 7.52351 5.34799 7.23327 5.03839C6.47215 4.22653 5.99545 4.04968 5.25604 4.04968C4.1398 4.04968 3.547 4.63618 3.547 5.27943C3.547 5.86592 3.96322 6.23169 4.94702 6.5344L5.67856 6.76143C7.22994 7.23441 7.97409 7.95964 7.97409 9.17047C7.97409 10.7723 6.69389 12.0903 4.46143 12.0903C2.86612 12.0903 1.40005 11.1131 1.03791 9.98075ZM11.8491 8.77985C10.661 8.39543 10.1649 7.86114 10.1649 6.98805C10.1649 5.86736 11.1636 5.04639 12.6128 5.04639C13.8546 5.04639 14.6629 5.63345 14.9778 6.6346C15.0443 6.84599 14.9593 6.98006 14.7475 7.0491C14.5394 7.11697 14.3176 7.09974 14.238 6.89611C13.9356 6.12273 13.352 5.76311 12.5998 5.76311C11.6467 5.76311 11.0135 6.25178 11.0135 6.91638C11.0135 7.45066 11.3464 7.75038 12.2473 8.04358L12.8348 8.23254C14.062 8.62999 14.5516 9.13821 14.5516 10.0178C14.5516 11.1972 13.481 12.0442 11.9927 12.0442C10.6439 12.0442 9.65644 11.2809 9.41979 10.3361C9.36535 10.1188 9.41192 10.0287 9.70039 9.96184C9.98886 9.89499 10.0714 9.89918 10.1715 10.1369C10.4555 10.8114 11.1531 11.3275 12.0318 11.3275C12.9914 11.3275 13.6834 10.7802 13.6834 10.0634C13.6834 9.53567 13.3961 9.28807 12.4366 8.97532L11.8491 8.77985Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2j = [
    "color"
];
var $c12e32cf04d921d4$export$bbfc12447ec5dbe8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2j);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V4H5V1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5V4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H4V10H1.5C1.22386 10 1 10.2239 1 10.5C1 10.7761 1.22386 11 1.5 11H4V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V11H10V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H11V5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H11V1.5ZM10 10V5H5V10H10Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2k = [
    "color"
];
var $c12e32cf04d921d4$export$49fa3bb64381879 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2k);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.3825 1.29567C3.46241 1.11432 3.64188 0.997284 3.84005 0.997284H11.5C11.7761 0.997284 12 1.22114 12 1.49728V5.5C12 5.77614 11.7761 6 11.5 6H8.63521L11.5288 9.16247C11.6626 9.3087 11.6974 9.52015 11.6175 9.70154C11.5376 9.88293 11.3582 10 11.16 10H8V13.5C8 13.7022 7.87818 13.8845 7.69134 13.9619C7.5045 14.0393 7.28945 13.9966 7.14645 13.8536L3.14645 9.85355C3.05268 9.75979 3 9.63261 3 9.5V5.5C3 5.22386 3.22386 5 3.5 5H6.36531L3.47105 1.83468C3.33732 1.68844 3.30259 1.47701 3.3825 1.29567ZM7.72032 5L4.97474 1.99728H11V5H7.72032ZM7.27978 6H4V9H7.5H10.0247L7.27978 6ZM4.70711 10L7 12.2929V10H4.70711Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2l = [
    "color"
];
var $c12e32cf04d921d4$export$70208e77f6c45b17 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2l);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.07095 0.650238C6.67391 0.650238 6.32977 0.925096 6.24198 1.31231L6.0039 2.36247C5.6249 2.47269 5.26335 2.62363 4.92436 2.81013L4.01335 2.23585C3.67748 2.02413 3.23978 2.07312 2.95903 2.35386L2.35294 2.95996C2.0722 3.2407 2.0232 3.6784 2.23493 4.01427L2.80942 4.92561C2.62307 5.2645 2.47227 5.62594 2.36216 6.00481L1.31209 6.24287C0.924883 6.33065 0.650024 6.6748 0.650024 7.07183V7.92897C0.650024 8.32601 0.924883 8.67015 1.31209 8.75794L2.36228 8.99603C2.47246 9.375 2.62335 9.73652 2.80979 10.0755L2.2354 10.9867C2.02367 11.3225 2.07267 11.7602 2.35341 12.041L2.95951 12.6471C3.24025 12.9278 3.67795 12.9768 4.01382 12.7651L4.92506 12.1907C5.26384 12.377 5.62516 12.5278 6.0039 12.6379L6.24198 13.6881C6.32977 14.0753 6.67391 14.3502 7.07095 14.3502H7.92809C8.32512 14.3502 8.66927 14.0753 8.75705 13.6881L8.99505 12.6383C9.37411 12.5282 9.73573 12.3773 10.0748 12.1909L10.986 12.7653C11.3218 12.977 11.7595 12.928 12.0403 12.6473L12.6464 12.0412C12.9271 11.7604 12.9761 11.3227 12.7644 10.9869L12.1902 10.076C12.3768 9.73688 12.5278 9.37515 12.638 8.99596L13.6879 8.75794C14.0751 8.67015 14.35 8.32601 14.35 7.92897V7.07183C14.35 6.6748 14.0751 6.33065 13.6879 6.24287L12.6381 6.00488C12.528 5.62578 12.3771 5.26414 12.1906 4.92507L12.7648 4.01407C12.9766 3.6782 12.9276 3.2405 12.6468 2.95975L12.0407 2.35366C11.76 2.07292 11.3223 2.02392 10.9864 2.23565L10.0755 2.80989C9.73622 2.62328 9.37437 2.47229 8.99505 2.36209L8.75705 1.31231C8.66927 0.925096 8.32512 0.650238 7.92809 0.650238H7.07095ZM4.92053 3.81251C5.44724 3.44339 6.05665 3.18424 6.71543 3.06839L7.07095 1.50024H7.92809L8.28355 3.06816C8.94267 3.18387 9.5524 3.44302 10.0794 3.81224L11.4397 2.9547L12.0458 3.56079L11.1882 4.92117C11.5573 5.44798 11.8164 6.0575 11.9321 6.71638L13.5 7.07183V7.92897L11.932 8.28444C11.8162 8.94342 11.557 9.55301 11.1878 10.0798L12.0453 11.4402L11.4392 12.0462L10.0787 11.1886C9.55192 11.5576 8.94241 11.8166 8.28355 11.9323L7.92809 13.5002H7.07095L6.71543 11.932C6.0569 11.8162 5.44772 11.5572 4.92116 11.1883L3.56055 12.046L2.95445 11.4399L3.81213 10.0794C3.4431 9.55266 3.18403 8.94326 3.06825 8.2845L1.50002 7.92897V7.07183L3.06818 6.71632C3.18388 6.05765 3.44283 5.44833 3.81171 4.92165L2.95398 3.561L3.56008 2.95491L4.92053 3.81251ZM9.02496 7.50008C9.02496 8.34226 8.34223 9.02499 7.50005 9.02499C6.65786 9.02499 5.97513 8.34226 5.97513 7.50008C5.97513 6.65789 6.65786 5.97516 7.50005 5.97516C8.34223 5.97516 9.02496 6.65789 9.02496 7.50008ZM9.92496 7.50008C9.92496 8.83932 8.83929 9.92499 7.50005 9.92499C6.1608 9.92499 5.07513 8.83932 5.07513 7.50008C5.07513 6.16084 6.1608 5.07516 7.50005 5.07516C8.83929 5.07516 9.92496 6.16084 9.92496 7.50008Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2m = [
    "color"
];
var $c12e32cf04d921d4$export$9a0862960670d05c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2m);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49933 0.25C3.49635 0.25 0.25 3.49593 0.25 7.50024C0.25 10.703 2.32715 13.4206 5.2081 14.3797C5.57084 14.446 5.70302 14.2222 5.70302 14.0299C5.70302 13.8576 5.69679 13.4019 5.69323 12.797C3.67661 13.235 3.25112 11.825 3.25112 11.825C2.92132 10.9874 2.44599 10.7644 2.44599 10.7644C1.78773 10.3149 2.49584 10.3238 2.49584 10.3238C3.22353 10.375 3.60629 11.0711 3.60629 11.0711C4.25298 12.1788 5.30335 11.8588 5.71638 11.6732C5.78225 11.205 5.96962 10.8854 6.17658 10.7043C4.56675 10.5209 2.87415 9.89918 2.87415 7.12104C2.87415 6.32925 3.15677 5.68257 3.62053 5.17563C3.54576 4.99226 3.29697 4.25521 3.69174 3.25691C3.69174 3.25691 4.30015 3.06196 5.68522 3.99973C6.26337 3.83906 6.8838 3.75895 7.50022 3.75583C8.1162 3.75895 8.73619 3.83906 9.31523 3.99973C10.6994 3.06196 11.3069 3.25691 11.3069 3.25691C11.7026 4.25521 11.4538 4.99226 11.3795 5.17563C11.8441 5.68257 12.1245 6.32925 12.1245 7.12104C12.1245 9.9063 10.4292 10.5192 8.81452 10.6985C9.07444 10.9224 9.30633 11.3648 9.30633 12.0413C9.30633 13.0102 9.29742 13.7922 9.29742 14.0299C9.29742 14.2239 9.42828 14.4496 9.79591 14.3788C12.6746 13.4179 14.75 10.7025 14.75 7.50024C14.75 3.49593 11.5036 0.25 7.49933 0.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2n = [
    "color"
];
var $c12e32cf04d921d4$export$a70e2e549144f66 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2n);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49996 1.80002C4.35194 1.80002 1.79996 4.352 1.79996 7.50002C1.79996 10.648 4.35194 13.2 7.49996 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.352 10.648 1.80002 7.49996 1.80002ZM0.899963 7.50002C0.899963 3.85494 3.85488 0.900024 7.49996 0.900024C11.145 0.900024 14.1 3.85494 14.1 7.50002C14.1 11.1451 11.145 14.1 7.49996 14.1C3.85488 14.1 0.899963 11.1451 0.899963 7.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M13.4999 7.89998H1.49994V7.09998H13.4999V7.89998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M7.09991 13.5V1.5H7.89991V13.5H7.09991zM10.375 7.49998C10.375 5.32724 9.59364 3.17778 8.06183 1.75656L8.53793 1.24341C10.2396 2.82218 11.075 5.17273 11.075 7.49998 11.075 9.82724 10.2396 12.1778 8.53793 13.7566L8.06183 13.2434C9.59364 11.8222 10.375 9.67273 10.375 7.49998zM3.99969 7.5C3.99969 5.17611 4.80786 2.82678 6.45768 1.24719L6.94177 1.75281C5.4582 3.17323 4.69969 5.32389 4.69969 7.5 4.6997 9.67611 5.45822 11.8268 6.94179 13.2472L6.45769 13.7528C4.80788 12.1732 3.9997 9.8239 3.99969 7.5z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49996 3.95801C9.66928 3.95801 11.8753 4.35915 13.3706 5.19448 13.5394 5.28875 13.5998 5.50197 13.5055 5.67073 13.4113 5.83948 13.198 5.89987 13.0293 5.8056 11.6794 5.05155 9.60799 4.65801 7.49996 4.65801 5.39192 4.65801 3.32052 5.05155 1.97064 5.8056 1.80188 5.89987 1.58866 5.83948 1.49439 5.67073 1.40013 5.50197 1.46051 5.28875 1.62927 5.19448 3.12466 4.35915 5.33063 3.95801 7.49996 3.95801zM7.49996 10.85C9.66928 10.85 11.8753 10.4488 13.3706 9.6135 13.5394 9.51924 13.5998 9.30601 13.5055 9.13726 13.4113 8.9685 13.198 8.90812 13.0293 9.00238 11.6794 9.75643 9.60799 10.15 7.49996 10.15 5.39192 10.15 3.32052 9.75643 1.97064 9.00239 1.80188 8.90812 1.58866 8.9685 1.49439 9.13726 1.40013 9.30601 1.46051 9.51924 1.62927 9.6135 3.12466 10.4488 5.33063 10.85 7.49996 10.85z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2o = [
    "color"
];
var $c12e32cf04d921d4$export$fa17e9a974485717 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2o);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.5 2H8V7H13V2.5C13 2.22386 12.7761 2 12.5 2ZM13 8H8V13H12.5C12.7761 13 13 12.7761 13 12.5V8ZM7 7V2H2.5C2.22386 2 2 2.22386 2 2.5V7H7ZM2 8V12.5C2 12.7761 2.22386 13 2.5 13H7V8H2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2p = [
    "color"
];
var $c12e32cf04d921d4$export$97eeb400c5f33310 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2p);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.44995 0.949951C1.31734 0.949951 1.19016 1.00263 1.0964 1.0964C1.00263 1.19017 0.949951 1.31735 0.949951 1.44995L0.949966 3.44995C0.949969 3.7261 1.17383 3.94995 1.44997 3.94995C1.72611 3.94995 1.94997 3.72609 1.94997 3.44995L1.94995 1.94995H3.44997C3.72611 1.94995 3.94997 1.72609 3.94997 1.44995C3.94997 1.17381 3.72611 0.949951 3.44997 0.949951H1.44995ZM5.94995 0.949951C5.67381 0.949951 5.44995 1.17381 5.44995 1.44995C5.44995 1.72609 5.67381 1.94995 5.94995 1.94995H8.94995C9.22609 1.94995 9.44995 1.72609 9.44995 1.44995C9.44995 1.17381 9.22609 0.949951 8.94995 0.949951H5.94995ZM5.44995 13.45C5.44995 13.1738 5.67381 12.95 5.94995 12.95H8.94995C9.22609 12.95 9.44995 13.1738 9.44995 13.45C9.44995 13.7261 9.22609 13.95 8.94995 13.95H5.94995C5.67381 13.95 5.44995 13.7261 5.44995 13.45ZM1.94995 5.94995C1.94995 5.67381 1.72609 5.44995 1.44995 5.44995C1.17381 5.44995 0.949951 5.67381 0.949951 5.94995V8.94995C0.949951 9.22609 1.17381 9.44995 1.44995 9.44995C1.72609 9.44995 1.94995 9.22609 1.94995 8.94995V5.94995ZM13.45 5.44995C13.7261 5.44995 13.95 5.67381 13.95 5.94995V8.94995C13.95 9.22609 13.7261 9.44995 13.45 9.44995C13.1738 9.44995 12.95 9.22609 12.95 8.94995V5.94995C12.95 5.67381 13.1738 5.44995 13.45 5.44995ZM11.45 0.949951C11.1738 0.949951 10.95 1.17381 10.95 1.44995C10.95 1.72609 11.1738 1.94995 11.45 1.94995H12.9499V3.44995C12.9499 3.72609 13.1738 3.94995 13.4499 3.94995C13.7261 3.94995 13.9499 3.72609 13.9499 3.44995V1.44995C13.9499 1.17381 13.7252 0.949951 13.449 0.949951H11.45ZM1.44995 10.95C1.72609 10.95 1.94995 11.1738 1.94995 11.45V12.95H3.44997C3.72611 12.95 3.94997 13.1738 3.94997 13.45C3.94997 13.7261 3.72611 13.95 3.44997 13.95H1.44995C1.17381 13.95 0.949951 13.7261 0.949951 13.45V11.45C0.949951 11.1738 1.17381 10.95 1.44995 10.95ZM13.95 11.45C13.95 11.1738 13.7261 10.95 13.45 10.95C13.1738 10.9499 12.95 11.1738 12.95 11.4499L12.9491 12.95H11.45C11.1738 12.95 10.95 13.1738 10.95 13.45C10.95 13.7261 11.1738 13.95 11.45 13.95H13.4499C13.7261 13.95 13.9499 13.7261 13.9499 13.45L13.95 11.45Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2q = [
    "color"
];
var $c12e32cf04d921d4$export$1106febb4d651860 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.00003 1.84861C4.10114 2.1017 1.82707 4.53515 1.82707 7.49972C1.82707 10.4643 4.10114 12.8977 7.00003 13.1508V1.84861ZM8.00003 13.1508C10.8988 12.8976 13.1727 10.4642 13.1727 7.49972C13.1727 4.53524 10.8988 2.10185 8.00003 1.84864V13.1508Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2r = [
    "color"
];
var $c12e32cf04d921d4$export$991e44cd0549467c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2r);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.49988 1.82689C4.36688 1.8269 1.82707 4.36672 1.82707 7.49972C1.82707 10.6327 4.36688 13.1725 7.49988 13.1726V1.82689Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2s = [
    "color"
];
var $c12e32cf04d921d4$export$ea8e5ed9f4a6e89d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2s);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2t = [
    "color"
];
var $c12e32cf04d921d4$export$f9eb84fdaa009a42 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2t);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.8113 1.64706C6.62188 2.87918 6.68268 3.88523 6.76848 5.30499C6.78415 5.56426 6.80065 5.83732 6.81661 6.12808C6.83111 6.39208 6.63758 6.62172 6.37495 6.65217C6.11232 6.68262 5.87138 6.50334 5.82509 6.24304L5.74754 5.80698C5.64402 5.16529 5.48355 4.25481 5.17807 3.44741C4.86241 2.61312 4.4486 2.04121 3.93436 1.86044C3.64994 1.76104 3.41901 1.84279 3.25868 2.01052C3.08746 2.18962 2.9976 2.47065 3.0627 2.75399C3.2146 3.34424 3.44627 3.9167 3.69836 4.51802C3.72082 4.57158 3.74346 4.62543 3.76621 4.67954C3.9954 5.22457 4.23619 5.7972 4.41644 6.39081L4.41691 6.39238C4.562 6.87586 4.65646 7.2595 4.73086 7.56165C4.76034 7.68138 4.78667 7.78831 4.81175 7.88359C4.86768 8.09606 4.77836 8.32014 4.59161 8.43588C4.40486 8.55161 4.16445 8.53188 3.99907 8.38725C3.73749 8.15848 3.515 7.92784 3.31817 7.71802C3.27627 7.67335 3.23602 7.63018 3.19705 7.58838C3.04777 7.42826 2.91712 7.28812 2.78334 7.16029C2.45989 6.85122 2.18398 6.68004 1.80585 6.64369L1.80324 6.64343C1.56117 6.61888 1.41402 6.66441 1.31756 6.72627C1.21899 6.78947 1.11988 6.90414 1.03784 7.1123C0.976576 7.28492 1.01515 7.62987 1.1929 7.96911L1.19728 7.97747C1.40086 8.38452 1.74475 8.81587 2.18141 9.29299C2.39739 9.52898 2.62872 9.76849 2.86934 10.0174L2.87966 10.0281C3.11546 10.2721 3.35962 10.5247 3.59713 10.7827C4.4288 11.6863 5.27706 12.7538 5.4627 14H11.5087C11.5636 12.4353 11.8756 11.268 12.2875 10.1346C12.4454 9.70041 12.6121 9.28412 12.7826 8.85829C13.1097 8.04139 13.4509 7.18937 13.7705 6.10824C14.0989 4.99737 14.0097 4.37033 13.8613 4.03984C13.717 3.71858 13.4914 3.61786 13.3816 3.59606C13.1381 3.54774 13.0384 3.60947 12.9698 3.67901C12.867 3.78316 12.7698 3.98273 12.6921 4.30269C12.6166 4.61345 12.5752 4.96517 12.533 5.32501L12.5298 5.35285C12.4924 5.67242 12.4505 6.03016 12.3665 6.30098C12.3383 6.40699 12.2819 6.50407 12.1979 6.57539C12.1382 6.6261 12.0104 6.70818 11.8309 6.69312C11.5424 6.66891 11.3712 6.42143 11.365 6.14783C11.356 5.75454 11.3883 5.35864 11.4074 4.96608C11.4428 4.23646 11.477 3.5337 11.4245 2.8342L11.4242 2.82934C11.3916 2.32997 11.0493 2.00228 10.7007 1.9228C10.5305 1.88401 10.369 1.90601 10.2347 1.9835C10.103 2.05946 9.95535 2.21318 9.8574 2.51394L9.85631 2.51726C9.81525 2.6404 9.77298 2.87753 9.73606 3.2124C9.70044 3.53542 9.67337 3.91279 9.65156 4.29418C9.6329 4.62033 9.61785 4.9584 9.60434 5.26194C9.58728 5.64529 9.57267 5.97357 9.55633 6.1532C9.54983 6.22459 9.52939 6.29493 9.49501 6.35785C9.47356 6.39711 9.36115 6.60947 9.07106 6.61843C8.77917 6.62744 8.63975 6.40057 8.61698 6.35919C8.55634 6.24899 8.55066 6.11807 8.54754 5.99283C8.54474 5.88064 8.54294 5.71798 8.54174 5.54767C8.53935 5.20582 8.53935 4.81919 8.53935 4.70952C8.53935 3.6657 8.53838 2.65372 8.44714 1.64372C8.39183 1.24127 8.06278 1.00455 7.6436 1.00005C7.22399 0.995552 6.87918 1.22704 6.8113 1.64706ZM9.41219 1.3617C9.21469 0.448484 8.39913 0.00810324 7.65433 0.00011154C6.86452 -0.00836308 5.98761 0.465881 5.82365 1.49037L5.82318 1.49334C5.78239 1.7584 5.75229 2.01481 5.7309 2.26652C5.39423 1.67364 4.92622 1.14894 4.2655 0.916859C3.58661 0.679312 2.9492 0.887087 2.53582 1.31952C2.13415 1.73971 1.94438 2.36742 2.09031 2.98746L2.09269 2.99713C2.26478 3.66808 2.52396 4.30316 2.77613 4.90465C2.79814 4.95717 2.8201 5.00941 2.84194 5.06139C3.02139 5.48842 3.19378 5.89866 3.33871 6.31256C2.96404 5.98142 2.51925 5.70796 1.90276 5.6484C1.48865 5.60663 1.10391 5.67536 0.777805 5.88444C0.454239 6.0919 0.240671 6.40405 0.104187 6.75406L0.100868 6.76281C-0.10184 7.31286 0.0663312 7.97157 0.304895 8.42897C0.573704 8.96474 0.996104 9.47904 1.44372 9.96813C1.67046 10.2159 1.91136 10.4652 2.15033 10.7124L2.15682 10.7191C2.39524 10.9658 2.63217 11.2109 2.86134 11.4599C3.80937 12.49 4.50002 13.4632 4.50002 14.5C4.50002 14.7761 4.72388 15 5.00002 15H12C12.2762 15 12.5 14.7761 12.5 14.5C12.5 12.8212 12.8021 11.6462 13.2274 10.4762C13.3653 10.0968 13.5216 9.70579 13.6868 9.29247C14.0238 8.44922 14.398 7.51298 14.7295 6.39175C15.0956 5.15324 15.0559 4.25904 14.7735 3.63017C14.487 2.99208 13.9798 2.6953 13.5763 2.6152C13.1276 2.52614 12.7367 2.60475 12.4268 2.83081C12.4253 2.80773 12.4236 2.78468 12.4219 2.76167C12.3587 1.8105 11.6907 1.12285 10.923 0.947821C10.5346 0.859287 10.1111 0.900393 9.73509 1.11724C9.61852 1.18446 9.51055 1.26623 9.41219 1.3617Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2u = [
    "color"
];
var $c12e32cf04d921d4$export$635e9dadffe43ee = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2u);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.75432 2.0502C8.50579 2.0502 8.30432 2.25167 8.30432 2.5002C8.30432 2.74873 8.50579 2.9502 8.75432 2.9502H9.94997V7.05004H5.04997V2.9502H6.25432C6.50285 2.9502 6.70432 2.74873 6.70432 2.5002C6.70432 2.25167 6.50285 2.0502 6.25432 2.0502H2.75432C2.50579 2.0502 2.30432 2.25167 2.30432 2.5002C2.30432 2.74873 2.50579 2.9502 2.75432 2.9502H3.94997V12.0502H2.75432C2.50579 12.0502 2.30432 12.2517 2.30432 12.5002C2.30432 12.7487 2.50579 12.9502 2.75432 12.9502H6.25432C6.50285 12.9502 6.70432 12.7487 6.70432 12.5002C6.70432 12.2517 6.50285 12.0502 6.25432 12.0502H5.04997V7.95004H9.94997V12.0502H8.75432C8.50579 12.0502 8.30432 12.2517 8.30432 12.5002C8.30432 12.7487 8.50579 12.9502 8.75432 12.9502H12.2543C12.5028 12.9502 12.7043 12.7487 12.7043 12.5002C12.7043 12.2517 12.5028 12.0502 12.2543 12.0502H11.05V2.9502H12.2543C12.5028 2.9502 12.7043 2.74873 12.7043 2.5002C12.7043 2.25167 12.5028 2.0502 12.2543 2.0502H8.75432Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2v = [
    "color"
];
var $c12e32cf04d921d4$export$16f03ed71cfb60c9 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2v);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.89346 2.35248C3.49195 2.35248 2.35248 3.49359 2.35248 4.90532C2.35248 6.38164 3.20954 7.9168 4.37255 9.33522C5.39396 10.581 6.59464 11.6702 7.50002 12.4778C8.4054 11.6702 9.60608 10.581 10.6275 9.33522C11.7905 7.9168 12.6476 6.38164 12.6476 4.90532C12.6476 3.49359 11.5081 2.35248 10.1066 2.35248C9.27059 2.35248 8.81894 2.64323 8.5397 2.95843C8.27877 3.25295 8.14623 3.58566 8.02501 3.88993C8.00391 3.9429 7.98315 3.99501 7.96211 4.04591C7.88482 4.23294 7.7024 4.35494 7.50002 4.35494C7.29765 4.35494 7.11523 4.23295 7.03793 4.04592C7.01689 3.99501 6.99612 3.94289 6.97502 3.8899C6.8538 3.58564 6.72126 3.25294 6.46034 2.95843C6.18109 2.64323 5.72945 2.35248 4.89346 2.35248ZM1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.0084 1.35248 6.73504 1.76049 7.20884 2.2953C7.32062 2.42147 7.41686 2.55382 7.50002 2.68545C7.58318 2.55382 7.67941 2.42147 7.79119 2.2953C8.265 1.76049 8.99164 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2w = [
    "color"
];
var $c12e32cf04d921d4$export$b4120a3a3b5e8fcd = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2w);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.25769 1.35248 6.86058 1.92336 7.50002 2.93545C8.13946 1.92336 8.74235 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2x = [
    "color"
];
var $c12e32cf04d921d4$export$141e350c1bf9e61a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2x);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.1813 1.68179C7.35704 1.50605 7.64196 1.50605 7.8177 1.68179L10.3177 4.18179C10.4934 4.35753 10.4934 4.64245 10.3177 4.81819C10.142 4.99392 9.85704 4.99392 9.6813 4.81819L7.9495 3.08638L7.9495 11.9136L9.6813 10.1818C9.85704 10.0061 10.142 10.0061 10.3177 10.1818C10.4934 10.3575 10.4934 10.6424 10.3177 10.8182L7.8177 13.3182C7.73331 13.4026 7.61885 13.45 7.4995 13.45C7.38015 13.45 7.26569 13.4026 7.1813 13.3182L4.6813 10.8182C4.50557 10.6424 4.50557 10.3575 4.6813 10.1818C4.85704 10.0061 5.14196 10.0061 5.3177 10.1818L7.0495 11.9136L7.0495 3.08638L5.3177 4.81819C5.14196 4.99392 4.85704 4.99392 4.6813 4.81819C4.50557 4.64245 4.50557 4.35753 4.6813 4.18179L7.1813 1.68179Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2y = [
    "color"
];
var $c12e32cf04d921d4$export$9360f6250c6c6a8c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.3536 13.3536C12.1583 13.5488 11.8417 13.5488 11.6465 13.3536L6.39645 8.10355C6.36478 8.07188 6.33824 8.03702 6.31685 8H5.00002C4.78719 8 4.59769 7.86528 4.52777 7.66426L2.12777 0.764277C2.05268 0.548387 2.13355 0.309061 2.3242 0.182972C2.51486 0.0568819 2.76674 0.0761337 2.93602 0.229734L8.336 5.12972C8.44044 5.22449 8.50001 5.35897 8.50001 5.5V5.81684C8.53702 5.83824 8.57189 5.86478 8.60356 5.89645L13.8536 11.1464C14.0488 11.3417 14.0488 11.6583 13.8536 11.8536L12.3536 13.3536ZM8.25 6.95711L7.45711 7.75L12 12.2929L12.7929 11.5L8.25 6.95711ZM3.71669 2.28845L5.35549 7H6.2929L7.50001 5.79289V5.72146L3.71669 2.28845Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2z = [
    "color"
];
var $c12e32cf04d921d4$export$92c8767b874048d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.07926 0.222253C7.31275 -0.007434 7.6873 -0.007434 7.92079 0.222253L14.6708 6.86227C14.907 7.09465 14.9101 7.47453 14.6778 7.71076C14.4454 7.947 14.0655 7.95012 13.8293 7.71773L13 6.90201V12.5C13 12.7761 12.7762 13 12.5 13H2.50002C2.22388 13 2.00002 12.7761 2.00002 12.5V6.90201L1.17079 7.71773C0.934558 7.95012 0.554672 7.947 0.32229 7.71076C0.0899079 7.47453 0.0930283 7.09465 0.32926 6.86227L7.07926 0.222253ZM7.50002 1.49163L12 5.91831V12H10V8.49999C10 8.22385 9.77617 7.99999 9.50002 7.99999H6.50002C6.22388 7.99999 6.00002 8.22385 6.00002 8.49999V12H3.00002V5.91831L7.50002 1.49163ZM7.00002 12H9.00002V8.99999H7.00002V12Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2A = [
    "color"
];
var $c12e32cf04d921d4$export$13a4588734565757 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2A);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 0.0032959C6.80473 0.0032959 6.24953 0.281106 6.25 0.749995C6.25 0.997258 6.42446 1.12014 6.57687 1.22749C6.69507 1.31074 6.8 1.38465 6.8 1.5C6.8 1.7071 6.06224 1.74264 5.19789 1.78427C3.97553 1.84314 2.5 1.91421 2.5 2.5C2.5 2.77614 2.72386 3 3 3H12C12.2761 3 12.5 2.77614 12.5 2.5C12.5 1.91421 11.0245 1.84314 9.80211 1.78427C8.93776 1.74264 8.2 1.7071 8.2 1.5C8.2 1.38465 8.30493 1.31074 8.42313 1.22749C8.57554 1.12014 8.75 0.997258 8.75 0.749995C8.75047 0.281106 8.19527 0.0032959 7.5 0.0032959ZM2.89451 6.12266C2.25806 6.52471 1.90417 7.31118 2.02473 8.0556L2.83588 12.4772C3.00993 13.3562 3.7629 14 4.66061 14H10.3373C11.2354 14 11.9884 13.3562 12.1625 12.4772L12.9736 8.05607C13.089 7.32358 12.8284 6.53276 12.1331 6.09373C11.7283 5.83013 11.6412 5.33231 12.1331 5.12796C12.8284 4.86435 12.6948 4 12 4H10.3001H6.80005H2.99996C2.30469 4 2.19878 4.89328 2.89451 5.15689C3.38642 5.33231 3.29939 5.83013 2.89451 6.12266ZM8.20006 6.25C8.20006 5.81769 8.08572 5.37615 7.90635 5L4.11093 5C4.20626 5.21312 4.2419 5.43889 4.22904 5.65521C4.19522 6.22412 3.84587 6.66899 3.48016 6.93322L3.45492 6.95146L3.42858 6.9681C3.13407 7.15414 2.95801 7.53989 3.01058 7.88749L3.81797 12.2886C3.90513 12.7154 4.26148 13 4.66061 13H10.3373C10.737 13 11.0932 12.7153 11.1804 12.2886L11.9874 7.8898C12.048 7.48247 11.8954 7.12631 11.5992 6.93927L11.5875 6.93184L11.5875 6.93176C11.1947 6.67602 10.8331 6.22785 10.7986 5.64798C10.7846 5.412 10.8264 5.19397 10.9112 5H9.05517C9.01987 5.14611 9.00006 5.31201 9.00006 5.5C9.00006 5.9745 9.21679 6.37127 9.44367 6.78662C9.69284 7.24278 9.95425 7.72136 9.95425 8.34993C9.95425 9.2698 9.49868 9.84205 8.62189 9.84205C8.13206 9.84205 7.57818 9.46097 7.57818 8.75781C7.57818 8.35279 7.71558 8.01646 7.86121 7.65998C8.0254 7.25806 8.20006 6.83051 8.20006 6.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2B = [
    "color"
];
var $c12e32cf04d921d4$export$583b57cdbe59a84e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2B);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14 11.0001V4.00006L1 4.00006L1 11.0001H14ZM15 4.00006V11.0001C15 11.5523 14.5523 12.0001 14 12.0001H1C0.447715 12.0001 0 11.5523 0 11.0001V4.00006C0 3.44778 0.447715 3.00006 1 3.00006H14C14.5523 3.00006 15 3.44778 15 4.00006ZM2 5.25C2 5.11193 2.11193 5 2.25 5H5.75C5.88807 5 6 5.11193 6 5.25V9.75C6 9.88807 5.88807 10 5.75 10H2.25C2.11193 10 2 9.88807 2 9.75V5.25ZM7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H7.5ZM7 9.5C7 9.22386 7.22386 9 7.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H7.5C7.22386 10 7 9.77614 7 9.5ZM7.5 5C7.22386 5 7 5.22386 7 5.5C7 5.77614 7.22386 6 7.5 6H11.5C11.7761 6 12 5.77614 12 5.5C12 5.22386 11.7761 5 11.5 5H7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2C = [
    "color"
];
var $c12e32cf04d921d4$export$4a122bafaa48b23d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2C);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2D = [
    "color"
];
var $c12e32cf04d921d4$export$7a1b52edf33ca2d9 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2D);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2E = [
    "color"
];
var $c12e32cf04d921d4$export$f8fea9f50a4bfae6 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2E);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.5 1C6.22386 1 6 1.22386 6 1.5C6 1.77614 6.22386 2 6.5 2C7.12671 2 7.45718 2.20028 7.65563 2.47812C7.8781 2.78957 8 3.28837 8 4V11C8 11.7116 7.8781 12.2104 7.65563 12.5219C7.45718 12.7997 7.12671 13 6.5 13C6.22386 13 6 13.2239 6 13.5C6 13.7761 6.22386 14 6.5 14C7.37329 14 8.04282 13.7003 8.46937 13.1031C8.47976 13.0886 8.48997 13.0739 8.5 13.0591C8.51003 13.0739 8.52024 13.0886 8.53063 13.1031C8.95718 13.7003 9.62671 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.87329 13 9.54282 12.7997 9.34437 12.5219C9.1219 12.2104 9 11.7116 9 11V4C9 3.28837 9.1219 2.78957 9.34437 2.47812C9.54282 2.20028 9.87329 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.62671 1 8.95718 1.29972 8.53063 1.89688C8.52024 1.91143 8.51003 1.92611 8.5 1.9409C8.48997 1.92611 8.47976 1.91143 8.46937 1.89688C8.04282 1.29972 7.37329 1 6.5 1ZM14 5H11V4H14C14.5523 4 15 4.44772 15 5V10C15 10.5523 14.5523 11 14 11H11V10H14V5ZM6 4V5H1L1 10H6V11H1C0.447715 11 0 10.5523 0 10V5C0 4.44772 0.447715 4 1 4H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2F = [
    "color"
];
var $c12e32cf04d921d4$export$632f10cfe13035ff = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2F);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.9091 12.909C13.2365 12.5817 13.4918 12.1895 13.6588 11.7577C13.8195 11.3443 13.9294 10.8718 13.961 10.1799C13.9926 9.48665 14.0001 9.26529 14.0001 7.50001C14.0001 5.73473 13.9926 5.51328 13.961 4.82008C13.9294 4.12821 13.8195 3.65573 13.6588 3.24228C13.4956 2.80857 13.2398 2.41567 12.9091 2.091C12.5844 1.76028 12.1915 1.50437 11.7578 1.34113C11.3443 1.18056 10.8718 1.0707 10.1799 1.03924C9.48675 1.00748 9.26537 1 7.50006 1C5.73476 1 5.51333 1.00748 4.82014 1.03912C4.12826 1.0707 3.65578 1.18056 3.24233 1.34125C2.80862 1.50447 2.41573 1.76032 2.09105 2.09098C1.76032 2.41563 1.5044 2.80852 1.34113 3.24225C1.18056 3.65573 1.0707 4.12821 1.03924 4.82008C1.00748 5.51328 1 5.73471 1 7.50001C1 9.26532 1.00748 9.48675 1.03924 10.1799C1.07083 10.8718 1.18069 11.3443 1.34138 11.7577C1.5046 12.1915 1.76045 12.5843 2.09111 12.909C2.41578 13.2397 2.80867 13.4955 3.24238 13.6587C3.65586 13.8194 4.12834 13.9293 4.82019 13.9609C5.51348 13.9925 5.73483 14 7.50012 14C9.2654 14 9.48685 13.9925 10.18 13.9609C10.8719 13.9293 11.3444 13.8194 11.7578 13.6587C12.1896 13.4917 12.5818 13.2364 12.9091 12.909ZM1.99949 6.73496C1.99974 6.94524 2.00005 7.19543 2.00005 7.50002C2.00005 7.80461 1.99974 8.0548 1.99949 8.26507C1.99849 9.08596 1.99824 9.29856 2.01963 9.7655C2.04625 10.3509 2.07823 10.7811 2.17588 11.1053C2.26976 11.417 2.37505 11.7342 2.7188 12.1171C3.06255 12.4999 3.39411 12.6733 3.81645 12.8007C4.23879 12.928 4.7696 12.9554 5.23052 12.9764C5.75332 13.0003 5.96052 13.0002 7.05714 12.9999L7.50006 12.9999C7.79304 12.9999 8.03569 13.0001 8.2409 13.0004C9.08195 13.0013 9.29425 13.0015 9.76575 12.9799C10.3512 12.9533 10.7814 12.9213 11.1056 12.8237C11.4173 12.7298 11.7345 12.6245 12.1173 12.2807C12.5001 11.937 12.6735 11.6054 12.8009 11.1831C12.9283 10.7607 12.9557 10.2299 12.9767 9.76902C13.0005 9.24689 13.0004 9.04027 13.0002 7.94749V7.94738L13.0001 7.50039L13.0001 7.05747C13.0004 5.96085 13.0005 5.75365 12.9766 5.23085C12.9556 4.76993 12.9282 4.23912 12.8009 3.81678C12.6735 3.39445 12.5001 3.06288 12.1173 2.71913C11.7345 2.37538 11.4172 2.27009 11.1056 2.17621C10.7813 2.07856 10.3511 2.04658 9.76571 2.01996C9.29421 1.99836 9.08194 1.99859 8.24092 1.99951H8.24092C8.0357 1.99974 7.79305 2.00001 7.50006 2.00001L7.05704 1.99993C5.96051 1.99964 5.75331 1.99958 5.23052 2.02343C4.7696 2.04446 4.23879 2.07183 3.81645 2.19921C3.39411 2.32659 3.06255 2.49999 2.7188 2.88281C2.37505 3.26562 2.26976 3.58286 2.17588 3.89453C2.07823 4.21874 2.04625 4.64894 2.01963 5.23437C1.99824 5.70131 1.99849 5.91401 1.99949 6.73496ZM7.49996 5.25015C6.25741 5.25015 5.25012 6.25744 5.25012 7.49999C5.25012 8.74254 6.25741 9.74983 7.49996 9.74983C8.74251 9.74983 9.7498 8.74254 9.7498 7.49999C9.7498 6.25744 8.74251 5.25015 7.49996 5.25015ZM4.25012 7.49999C4.25012 5.70515 5.70512 4.25015 7.49996 4.25015C9.2948 4.25015 10.7498 5.70515 10.7498 7.49999C10.7498 9.29483 9.2948 10.7498 7.49996 10.7498C5.70512 10.7498 4.25012 9.29483 4.25012 7.49999ZM10.9697 4.7803C11.3839 4.7803 11.7197 4.44452 11.7197 4.0303C11.7197 3.61609 11.3839 3.2803 10.9697 3.2803C10.5555 3.2803 10.2197 3.61609 10.2197 4.0303C10.2197 4.44452 10.5555 4.7803 10.9697 4.7803Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$2G = [
    "color"
];
var $c12e32cf04d921d4$export$97dac707ecee26f6 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2G);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5 4H1.5C1.22386 4 1 4.22386 1 4.5V10.5C1 10.7761 1.22386 11 1.5 11H13.5C13.7761 11 14 10.7761 14 10.5V4.5C14 4.22386 13.7761 4 13.5 4ZM1.5 3C0.671573 3 0 3.67157 0 4.5V10.5C0 11.3284 0.671573 12 1.5 12H13.5C14.3284 12 15 11.3284 15 10.5V4.5C15 3.67157 14.3284 3 13.5 3H1.5ZM2 5H3V6H2V5ZM5 5H4V6H5V5ZM6 5H7V6H6V5ZM9 5H8V6H9V5ZM10 5H11V6H10V5ZM13 5H12V6H13V5ZM11 7H12V8H11V7ZM13 9H12V10H13V9ZM9 7H10V8H9V7ZM8 7H7V8H8V7ZM5 7H6V8H5V7ZM4 7H3V8H4V7ZM2 9H3V10H2V9ZM11 9H4V10H11V9Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$2H = [
    "color"
];
var $c12e32cf04d921d4$export$73ea89eab1c37fa2 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2H);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2I = [
    "color"
];
var $c12e32cf04d921d4$export$b94473071ddf9fbf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2I);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 4.25C2 4.11193 2.11193 4 2.25 4H12.75C12.8881 4 13 4.11193 13 4.25V11.5H2V4.25ZM2.25 3C1.55964 3 1 3.55964 1 4.25V12H0V12.5C0 12.7761 0.223858 13 0.5 13H14.5C14.7761 13 15 12.7761 15 12.5V12H14V4.25C14 3.55964 13.4404 3 12.75 3H2.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2J = [
    "color"
];
var $c12e32cf04d921d4$export$a00948e6c38bedc8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2J);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.75432 0.819537C7.59742 0.726821 7.4025 0.726821 7.24559 0.819537L1.74559 4.06954C1.59336 4.15949 1.49996 4.32317 1.49996 4.5C1.49996 4.67683 1.59336 4.84051 1.74559 4.93046L7.24559 8.18046C7.4025 8.27318 7.59742 8.27318 7.75432 8.18046L13.2543 4.93046C13.4066 4.84051 13.5 4.67683 13.5 4.5C13.5 4.32317 13.4066 4.15949 13.2543 4.06954L7.75432 0.819537ZM7.49996 7.16923L2.9828 4.5L7.49996 1.83077L12.0171 4.5L7.49996 7.16923ZM1.5695 7.49564C1.70998 7.2579 2.01659 7.17906 2.25432 7.31954L7.49996 10.4192L12.7456 7.31954C12.9833 7.17906 13.2899 7.2579 13.4304 7.49564C13.5709 7.73337 13.4921 8.03998 13.2543 8.18046L7.75432 11.4305C7.59742 11.5232 7.4025 11.5232 7.24559 11.4305L1.74559 8.18046C1.50786 8.03998 1.42901 7.73337 1.5695 7.49564ZM1.56949 10.4956C1.70998 10.2579 2.01658 10.1791 2.25432 10.3195L7.49996 13.4192L12.7456 10.3195C12.9833 10.1791 13.2899 10.2579 13.4304 10.4956C13.5709 10.7334 13.4921 11.04 13.2543 11.1805L7.75432 14.4305C7.59742 14.5232 7.4025 14.5232 7.24559 14.4305L1.74559 11.1805C1.50785 11.04 1.42901 10.7334 1.56949 10.4956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2K = [
    "color"
];
var $c12e32cf04d921d4$export$b5c6e0b0c099878a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2K);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9 2H6V13H9V2ZM10 2V13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2H10ZM2.5 2H5V13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2L = [
    "color"
];
var $c12e32cf04d921d4$export$2d8928fe752eaf76 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2L);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.68979 2.75C3.89667 2.74979 4.08232 2.87701 4.15679 3.07003L7.36662 11.39C7.46602 11.6477 7.33774 11.9371 7.0801 12.0365C6.82247 12.1359 6.53304 12.0076 6.43365 11.75L5.3825 9.02537H2.01133L0.966992 11.749C0.868128 12.0068 0.578964 12.1357 0.321126 12.0369C0.0632878 11.938 -0.0655864 11.6488 0.0332774 11.391L3.22344 3.07099C3.29751 2.87782 3.4829 2.75021 3.68979 2.75ZM3.69174 4.64284L5.05458 8.17537H2.33724L3.69174 4.64284ZM10.8989 5.20703C9.25818 5.20703 8.00915 6.68569 8.00915 8.60972C8.00915 10.6337 9.35818 12.0124 10.8989 12.0124C11.7214 12.0124 12.5744 11.6692 13.1543 11.0219V11.53C13.1543 11.7785 13.3557 11.98 13.6043 11.98C13.8528 11.98 14.0543 11.7785 14.0543 11.53V5.72C14.0543 5.47147 13.8528 5.27 13.6043 5.27C13.3557 5.27 13.1543 5.47147 13.1543 5.72V6.22317C12.6054 5.60095 11.7924 5.20703 10.8989 5.20703ZM13.1543 9.79823V7.30195C12.7639 6.58101 11.9414 6.05757 11.0868 6.05757C10.1088 6.05757 9.03503 6.96581 9.03503 8.60955C9.03503 10.1533 10.0088 11.1615 11.0868 11.1615C11.9701 11.1615 12.7719 10.4952 13.1543 9.79823Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2M = [
    "color"
];
var $c12e32cf04d921d4$export$ba5807ad0c0f9980 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2M);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.69899 5.20703C2.05823 5.20703 0.809204 6.68569 0.809204 8.60972C0.809204 10.6337 2.15823 12.0124 3.69899 12.0124C4.52126 12.0124 5.37402 11.6693 5.9539 11.0223V11.53C5.9539 11.7785 6.15537 11.98 6.4039 11.98C6.65243 11.98 6.8539 11.7785 6.8539 11.53V5.72001C6.8539 5.47149 6.65243 5.27001 6.4039 5.27001C6.15537 5.27001 5.9539 5.47149 5.9539 5.72001V6.22269C5.40506 5.60075 4.59218 5.20703 3.69899 5.20703ZM5.9539 9.799V7.30117C5.56339 6.58064 4.74118 6.05757 3.8868 6.05757C2.9089 6.05757 1.83508 6.96581 1.83508 8.60955C1.83508 10.1533 2.80889 11.1615 3.8868 11.1615C4.76984 11.1615 5.57141 10.4957 5.9539 9.799ZM10.799 5.20703C9.15823 5.20703 7.9092 6.68569 7.9092 8.60972C7.9092 10.6337 9.25823 12.0124 10.799 12.0124C11.6215 12.0124 12.4744 11.6692 13.0543 11.0218V11.53C13.0543 11.7785 13.2558 11.98 13.5043 11.98C13.7529 11.98 13.9543 11.7785 13.9543 11.53V5.72C13.9543 5.47147 13.7529 5.27 13.5043 5.27C13.2558 5.27 13.0543 5.47147 13.0543 5.72V6.22318C12.5055 5.60095 11.6924 5.20703 10.799 5.20703ZM13.0543 9.79822V7.30196C12.664 6.58102 11.8415 6.05757 10.9868 6.05757C10.0089 6.05757 8.93508 6.96581 8.93508 8.60955C8.93508 10.1533 9.90889 11.1615 10.9868 11.1615C11.8702 11.1615 12.672 10.4952 13.0543 9.79822Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2N = [
    "color"
];
var $c12e32cf04d921d4$export$7e8527e8d8b03e5e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2N);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.2895 2.75C11.4964 2.74979 11.6821 2.87701 11.7565 3.07003L14.9664 11.39C15.0657 11.6477 14.9375 11.9371 14.6798 12.0365C14.4222 12.1359 14.1328 12.0076 14.0334 11.75L12.9822 9.02537H9.61106L8.56672 11.749C8.46786 12.0068 8.1787 12.1357 7.92086 12.0369C7.66302 11.938 7.53415 11.6488 7.63301 11.391L10.8232 3.07099C10.8972 2.87782 11.0826 2.75021 11.2895 2.75ZM11.2915 4.64284L12.6543 8.17537H9.93698L11.2915 4.64284ZM2.89895 5.20703C1.25818 5.20703 0.00915527 6.68569 0.00915527 8.60972C0.00915527 10.6337 1.35818 12.0124 2.89895 12.0124C3.72141 12.0124 4.57438 11.6692 5.15427 11.0219V11.53C5.15427 11.7785 5.35574 11.98 5.60427 11.98C5.8528 11.98 6.05427 11.7785 6.05427 11.53V5.72C6.05427 5.47147 5.8528 5.27 5.60427 5.27C5.35574 5.27 5.15427 5.47147 5.15427 5.72V6.22317C4.60543 5.60095 3.79236 5.20703 2.89895 5.20703ZM5.15427 9.79823V7.30195C4.76393 6.58101 3.94144 6.05757 3.08675 6.05757C2.10885 6.05757 1.03503 6.96581 1.03503 8.60955C1.03503 10.1533 2.00885 11.1615 3.08675 11.1615C3.97011 11.1615 4.77195 10.4952 5.15427 9.79823Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2O = [
    "color"
];
var $c12e32cf04d921d4$export$9395c236dc77b2d2 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2O);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.6255 2.75C3.83478 2.75 4.02192 2.88034 4.09448 3.07664L7.16985 11.3962C7.2656 11.6552 7.13324 11.9428 6.87423 12.0386C6.61522 12.1343 6.32763 12.002 6.23188 11.7429L5.22387 9.01603H2.02712L1.01911 11.7429C0.923362 12.002 0.635774 12.1343 0.376762 12.0386C0.117749 11.9428 -0.0146052 11.6552 0.0811401 11.3962L3.15651 3.07664C3.22908 2.88034 3.41621 2.75 3.6255 2.75ZM3.6255 4.69207L4.90966 8.16603H2.34133L3.6255 4.69207ZM11.3719 2.75C11.5811 2.75 11.7683 2.88034 11.8408 3.07664L14.9162 11.3962C15.012 11.6552 14.8796 11.9428 14.6206 12.0386C14.3616 12.1343 14.074 12.002 13.9782 11.7429L12.9702 9.01603H9.77348L8.76547 11.7429C8.66972 12.002 8.38213 12.1343 8.12312 12.0386C7.86411 11.9428 7.73175 11.6552 7.8275 11.3962L10.9029 3.07664C10.9754 2.88034 11.1626 2.75 11.3719 2.75ZM11.3719 4.69207L12.656 8.16603H10.0877L11.3719 4.69207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2P = [
    "color"
];
var $c12e32cf04d921d4$export$b5d24f94d82d9f2b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2P);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.55293 0.999969C4.75295 0.999969 4.93372 1.11917 5.0125 1.30301L8.01106 8.29982C8.11984 8.55363 8.00226 8.84757 7.74844 8.95635C7.49463 9.06512 7.20069 8.94754 7.09191 8.69373L6.11613 6.41685H2.98973L2.01395 8.69373C1.90517 8.94754 1.61123 9.06512 1.35742 8.95635C1.1036 8.84757 0.986023 8.55363 1.0948 8.29982L4.09336 1.30301C4.17214 1.11917 4.35291 0.999969 4.55293 0.999969ZM4.55293 2.76929L5.75186 5.56685H3.354L4.55293 2.76929ZM11.0562 9.00214C11.2617 9.00214 11.4463 8.87633 11.5215 8.68502L14.2733 1.68299C14.3743 1.42598 14.2478 1.13575 13.9908 1.03475C13.7338 0.933747 13.4436 1.06021 13.3426 1.31722L11.0562 7.13514L8.76973 1.31722C8.66873 1.06021 8.3785 0.933747 8.1215 1.03475C7.86449 1.13575 7.73802 1.42598 7.83902 1.68299L10.5908 8.68502C10.666 8.87633 10.8506 9.00214 11.0562 9.00214ZM14.9537 12.4999C14.9537 12.606 14.9115 12.7077 14.8365 12.7828L12.8365 14.7828C12.6803 14.939 12.4271 14.939 12.2708 14.7828C12.1146 14.6265 12.1146 14.3733 12.2708 14.2171L13.588 12.8999H1.51937L2.83653 14.2171C2.99274 14.3733 2.99274 14.6265 2.83653 14.7828C2.68032 14.939 2.42705 14.939 2.27084 14.7828L0.270843 12.7828C0.195828 12.7077 0.153687 12.606 0.153687 12.4999C0.153687 12.3938 0.195828 12.2921 0.270843 12.2171L2.27084 10.2171C2.42705 10.0609 2.68032 10.0609 2.83653 10.2171C2.99274 10.3733 2.99274 10.6265 2.83653 10.7828L1.51937 12.0999L13.588 12.0999L12.2708 10.7828C12.1146 10.6265 12.1146 10.3733 12.2708 10.2171C12.4271 10.0609 12.6803 10.0609 12.8365 10.2171L14.8365 12.2171C14.9115 12.2921 14.9537 12.3938 14.9537 12.4999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2Q = [
    "color"
];
var $c12e32cf04d921d4$export$afee984ac0331725 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2Q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.69667 0.0403541C8.90859 0.131038 9.03106 0.354857 8.99316 0.582235L8.0902 6.00001H12.5C12.6893 6.00001 12.8625 6.10701 12.9472 6.27641C13.0319 6.4458 13.0136 6.6485 12.8999 6.80001L6.89997 14.8C6.76167 14.9844 6.51521 15.0503 6.30328 14.9597C6.09135 14.869 5.96888 14.6452 6.00678 14.4178L6.90974 9H2.49999C2.31061 9 2.13748 8.893 2.05278 8.72361C1.96809 8.55422 1.98636 8.35151 2.09999 8.2L8.09997 0.200038C8.23828 0.0156255 8.48474 -0.0503301 8.69667 0.0403541ZM3.49999 8.00001H7.49997C7.64695 8.00001 7.78648 8.06467 7.88148 8.17682C7.97648 8.28896 8.01733 8.43723 7.99317 8.5822L7.33027 12.5596L11.5 7.00001H7.49997C7.353 7.00001 7.21347 6.93534 7.11846 6.8232C7.02346 6.71105 6.98261 6.56279 7.00678 6.41781L7.66968 2.44042L3.49999 8.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2R = [
    "color"
];
var $c12e32cf04d921d4$export$9b61d117ad943959 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2R);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.78233 2.21713C3.70732 2.14212 3.60557 2.09998 3.49949 2.09998C3.3934 2.09998 3.29166 2.14212 3.21664 2.21713L1.21664 4.21713C1.06044 4.37334 1.06044 4.62661 1.21664 4.78282C1.37285 4.93903 1.62612 4.93903 1.78233 4.78282L3.09949 3.46566L3.09949 11.5343L1.78233 10.2171C1.62612 10.0609 1.37285 10.0609 1.21664 10.2171C1.06043 10.3733 1.06043 10.6266 1.21664 10.7828L3.21664 12.7828C3.29166 12.8578 3.3934 12.9 3.49949 12.9C3.60557 12.9 3.70731 12.8578 3.78233 12.7828L5.78233 10.7828C5.93854 10.6266 5.93854 10.3733 5.78233 10.2171C5.62612 10.0609 5.37285 10.0609 5.21664 10.2171L3.89949 11.5343L3.89949 3.46566L5.21664 4.78282C5.37285 4.93903 5.62612 4.93903 5.78233 4.78282C5.93854 4.62661 5.93854 4.37334 5.78233 4.21713L3.78233 2.21713ZM8.49998 3.99997C8.22383 3.99997 7.99998 4.22382 7.99998 4.49997C7.99998 4.77611 8.22383 4.99997 8.49998 4.99997H14.5C14.7761 4.99997 15 4.77611 15 4.49997C15 4.22382 14.7761 3.99997 14.5 3.99997H8.49998ZM7.99998 7.49997C7.99998 7.22382 8.22383 6.99997 8.49998 6.99997H14.5C14.7761 6.99997 15 7.22382 15 7.49997C15 7.77611 14.7761 7.99997 14.5 7.99997H8.49998C8.22383 7.99997 7.99998 7.77611 7.99998 7.49997ZM8.49998 9.99997C8.22383 9.99997 7.99998 10.2238 7.99998 10.5C7.99998 10.7761 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7761 15 10.5C15 10.2238 14.7761 9.99997 14.5 9.99997H8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2S = [
    "color"
];
var $c12e32cf04d921d4$export$c99cd348175308cb = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2S);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.62471 4.00001L4.56402 4.00001C4.04134 3.99993 3.70687 3.99988 3.4182 4.055C2.2379 4.28039 1.29846 5.17053 1.05815 6.33035C0.999538 6.61321 0.999604 6.93998 0.999703 7.43689L0.999711 7.50001L0.999703 7.56313C0.999604 8.06004 0.999538 8.38681 1.05815 8.66967C1.29846 9.8295 2.2379 10.7196 3.4182 10.945C3.70688 11.0001 4.04135 11.0001 4.56403 11L4.62471 11H5.49971C5.77585 11 5.99971 10.7762 5.99971 10.5C5.99971 10.2239 5.77585 10 5.49971 10H4.62471C4.02084 10 3.78907 9.99777 3.60577 9.96277C2.80262 9.8094 2.19157 9.21108 2.03735 8.46678C2.00233 8.29778 1.99971 8.08251 1.99971 7.50001C1.99971 6.91752 2.00233 6.70225 2.03735 6.53324C2.19157 5.78895 2.80262 5.19062 3.60577 5.03725C3.78907 5.00225 4.02084 5.00001 4.62471 5.00001H5.49971C5.77585 5.00001 5.99971 4.77615 5.99971 4.50001C5.99971 4.22387 5.77585 4.00001 5.49971 4.00001H4.62471ZM10.3747 5.00001C10.9786 5.00001 11.2104 5.00225 11.3937 5.03725C12.1968 5.19062 12.8079 5.78895 12.9621 6.53324C12.9971 6.70225 12.9997 6.91752 12.9997 7.50001C12.9997 8.08251 12.9971 8.29778 12.9621 8.46678C12.8079 9.21108 12.1968 9.8094 11.3937 9.96277C11.2104 9.99777 10.9786 10 10.3747 10H9.49971C9.22357 10 8.99971 10.2239 8.99971 10.5C8.99971 10.7762 9.22357 11 9.49971 11H10.3747L10.4354 11C10.9581 11.0001 11.2925 11.0001 11.5812 10.945C12.7615 10.7196 13.701 9.8295 13.9413 8.66967C13.9999 8.38681 13.9998 8.06005 13.9997 7.56314L13.9997 7.50001L13.9997 7.43688C13.9998 6.93998 13.9999 6.61321 13.9413 6.33035C13.701 5.17053 12.7615 4.28039 11.5812 4.055C11.2925 3.99988 10.9581 3.99993 10.4354 4.00001L10.3747 4.00001H9.49971C9.22357 4.00001 8.99971 4.22387 8.99971 4.50001C8.99971 4.77615 9.22357 5.00001 9.49971 5.00001H10.3747ZM5.00038 7C4.72424 7 4.50038 7.22386 4.50038 7.5C4.50038 7.77614 4.72424 8 5.00038 8H10.0004C10.2765 8 10.5004 7.77614 10.5004 7.5C10.5004 7.22386 10.2765 7 10.0004 7H5.00038Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2T = [
    "color"
];
var $c12e32cf04d921d4$export$a0f93c0a3250ca9d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2T);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8.51194 3.00541C9.18829 2.54594 10.0435 2.53694 10.6788 2.95419C10.8231 3.04893 10.9771 3.1993 11.389 3.61119C11.8009 4.02307 11.9513 4.17714 12.046 4.32141C12.4633 4.95675 12.4543 5.81192 11.9948 6.48827C11.8899 6.64264 11.7276 6.80811 11.3006 7.23511L10.6819 7.85383C10.4867 8.04909 10.4867 8.36567 10.6819 8.56093C10.8772 8.7562 11.1938 8.7562 11.389 8.56093L12.0077 7.94221L12.0507 7.89929C12.4203 7.52976 12.6568 7.2933 12.822 7.0502C13.4972 6.05623 13.5321 4.76252 12.8819 3.77248C12.7233 3.53102 12.4922 3.30001 12.1408 2.94871L12.0961 2.90408L12.0515 2.85942C11.7002 2.508 11.4692 2.27689 11.2277 2.11832C10.2377 1.46813 8.94398 1.50299 7.95001 2.17822C7.70691 2.34336 7.47044 2.57991 7.1009 2.94955L7.058 2.99247L6.43928 3.61119C6.24401 3.80645 6.24401 4.12303 6.43928 4.31829C6.63454 4.51355 6.95112 4.51355 7.14638 4.31829L7.7651 3.69957C8.1921 3.27257 8.35757 3.11027 8.51194 3.00541ZM4.31796 7.14672C4.51322 6.95146 4.51322 6.63487 4.31796 6.43961C4.12269 6.24435 3.80611 6.24435 3.61085 6.43961L2.99213 7.05833L2.94922 7.10124C2.57957 7.47077 2.34303 7.70724 2.17788 7.95035C1.50265 8.94432 1.4678 10.238 2.11799 11.2281C2.27656 11.4695 2.50766 11.7005 2.8591 12.0518L2.90374 12.0965L2.94837 12.1411C3.29967 12.4925 3.53068 12.7237 3.77214 12.8822C4.76219 13.5324 6.05589 13.4976 7.04986 12.8223C7.29296 12.6572 7.52943 12.4206 7.89896 12.051L7.89897 12.051L7.94188 12.0081L8.5606 11.3894C8.75586 11.1941 8.75586 10.8775 8.5606 10.6823C8.36533 10.487 8.04875 10.487 7.85349 10.6823L7.23477 11.301C6.80777 11.728 6.6423 11.8903 6.48794 11.9951C5.81158 12.4546 4.95642 12.4636 4.32107 12.0464C4.17681 11.9516 4.02274 11.8012 3.61085 11.3894C3.19896 10.9775 3.0486 10.8234 2.95385 10.6791C2.53661 10.0438 2.54561 9.18863 3.00507 8.51227C3.10993 8.35791 3.27224 8.19244 3.69924 7.76544L4.31796 7.14672ZM9.62172 6.08558C9.81698 5.89032 9.81698 5.57373 9.62172 5.37847C9.42646 5.18321 9.10988 5.18321 8.91461 5.37847L5.37908 8.91401C5.18382 9.10927 5.18382 9.42585 5.37908 9.62111C5.57434 9.81637 5.89092 9.81637 6.08619 9.62111L9.62172 6.08558Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2U = [
    "color"
];
var $c12e32cf04d921d4$export$c2a4804b810abd59 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2U);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L13.3536 2.35355ZM2.03735 8.46678C2.17398 9.12619 2.66918 9.67103 3.33886 9.89338L2.57833 10.6539C1.80843 10.2534 1.23784 9.53693 1.05815 8.66967C0.999538 8.38681 0.999604 8.06004 0.999703 7.56313L0.999711 7.50001L0.999703 7.43689C0.999604 6.93998 0.999538 6.61321 1.05815 6.33035C1.29846 5.17053 2.2379 4.28039 3.4182 4.055C3.70687 3.99988 4.04134 3.99993 4.56402 4.00001L4.62471 4.00001H5.49971C5.77585 4.00001 5.99971 4.22387 5.99971 4.50001C5.99971 4.77615 5.77585 5.00001 5.49971 5.00001H4.62471C4.02084 5.00001 3.78907 5.00225 3.60577 5.03725C2.80262 5.19062 2.19157 5.78895 2.03735 6.53324C2.00233 6.70225 1.99971 6.91752 1.99971 7.50001C1.99971 8.08251 2.00233 8.29778 2.03735 8.46678ZM12.9621 6.53324C12.8255 5.87397 12.3304 5.32922 11.661 5.10679L12.4215 4.34631C13.1912 4.74686 13.7616 5.46323 13.9413 6.33035C13.9999 6.61321 13.9998 6.93998 13.9997 7.43688L13.9997 7.50001L13.9997 7.56314C13.9998 8.06005 13.9999 8.38681 13.9413 8.66967C13.701 9.8295 12.7615 10.7196 11.5812 10.945C11.2925 11.0001 10.9581 11.0001 10.4354 11L10.3747 11H9.49971C9.22357 11 8.99971 10.7762 8.99971 10.5C8.99971 10.2239 9.22357 10 9.49971 10H10.3747C10.9786 10 11.2104 9.99777 11.3937 9.96277C12.1968 9.8094 12.8079 9.21108 12.9621 8.46678C12.9971 8.29778 12.9997 8.08251 12.9997 7.50001C12.9997 6.91752 12.9971 6.70225 12.9621 6.53324Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2V = [
    "color"
];
var $c12e32cf04d921d4$export$c8d5b415f7d58ebc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2V);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.50021 0C4.77635 0 5.0002 0.223853 5.0002 0.49999V2.49995C5.0002 2.77609 4.77635 2.99994 4.50021 2.99994C4.22408 2.99994 4.00022 2.77609 4.00022 2.49995V0.49999C4.00022 0.223853 4.22408 0 4.50021 0ZM0.646451 0.64647C0.84171 0.451212 1.15829 0.451212 1.35354 0.64647L2.85351 2.14644C3.04877 2.3417 3.04877 2.65827 2.85351 2.85353C2.65826 3.04879 2.34168 3.04879 2.14642 2.85353L0.646452 1.35356C0.451193 1.1583 0.451193 0.841728 0.646451 0.64647ZM0.00030517 4.49991C0.00030517 4.22377 0.224158 3.99992 0.500295 3.99992H2.50025C2.77639 3.99992 3.00024 4.22377 3.00024 4.49991C3.00024 4.77605 2.77639 4.9999 2.50025 4.9999H0.500295C0.224158 4.9999 0.00030517 4.77605 0.00030517 4.49991ZM12.0001 10.4998C12.0001 10.2236 12.2239 9.9998 12.5001 9.9998H14.5C14.7761 9.9998 15 10.2236 15 10.4998C15 10.7759 14.7761 10.9998 14.5 10.9998H12.5001C12.2239 10.9998 12.0001 10.7759 12.0001 10.4998ZM10.5001 11.9998C10.7762 11.9998 11.0001 12.2236 11.0001 12.4997V14.4997C11.0001 14.7758 10.7762 14.9997 10.5001 14.9997C10.224 14.9997 10.0001 14.7758 10.0001 14.4997V12.4997C10.0001 12.2236 10.224 11.9998 10.5001 11.9998ZM12.1462 12.1462C12.3415 11.951 12.658 11.951 12.8533 12.1462L14.3533 13.6462C14.5485 13.8415 14.5485 14.158 14.3533 14.3533C14.158 14.5485 13.8414 14.5485 13.6462 14.3533L12.1462 12.8533C11.951 12.6581 11.951 12.3415 12.1462 12.1462ZM7.76478 3.69938C8.19177 3.27238 8.35724 3.11008 8.5116 3.00522C9.18794 2.54577 10.0431 2.53677 10.6784 2.95401C10.8227 3.04875 10.9767 3.19911 11.3886 3.61099C11.8005 4.02287 11.9509 4.17694 12.0456 4.3212C12.4628 4.95653 12.4539 5.81168 11.9944 6.48802C11.8895 6.64238 11.7272 6.80785 11.3002 7.23484L10.6815 7.85354C10.4863 8.0488 10.4863 8.36538 10.6815 8.56064C10.8768 8.75589 11.1934 8.75589 11.3886 8.56064L12.0073 7.94193L12.0502 7.89903C12.4199 7.5295 12.6564 7.29303 12.8216 7.04993C13.4968 6.05598 13.5316 4.7623 12.8815 3.77228C12.7229 3.53083 12.4918 3.29982 12.1404 2.94853L12.0957 2.9039L12.0511 2.85925C11.6998 2.50782 11.4688 2.27672 11.2273 2.11816C10.2373 1.46798 8.94364 1.50284 7.94968 2.17805C7.70659 2.34319 7.47012 2.57973 7.1006 2.94936L7.1006 2.94937L7.05769 2.99228L6.43898 3.61099C6.24372 3.80625 6.24372 4.12282 6.43898 4.31808C6.63424 4.51334 6.95081 4.51334 7.14607 4.31808L7.76478 3.69938ZM2.99191 7.05807L2.94899 7.10097C2.57935 7.4705 2.34282 7.70697 2.17767 7.95006C1.50246 8.94401 1.4676 10.2377 2.11778 11.2277C2.27634 11.4692 2.50744 11.7002 2.85886 12.0515L2.85888 12.0515L2.90352 12.0961L2.94815 12.1407L2.94815 12.1407L2.94817 12.1408C3.29945 12.4922 3.53045 12.7233 3.7719 12.8818C4.76193 13.532 6.0556 13.4972 7.04956 12.8219C7.29265 12.6568 7.52912 12.4203 7.89865 12.0506L7.94155 12.0077L8.56026 11.389C8.75552 11.1937 8.75552 10.8772 8.56026 10.6819C8.365 10.4867 8.04842 10.4867 7.85317 10.6819L7.23446 11.3006C6.80747 11.7276 6.642 11.8899 6.48764 11.9948C5.8113 12.4542 4.95615 12.4632 4.32082 12.046C4.17656 11.9512 4.02249 11.8009 3.61061 11.389C3.19873 10.9771 3.04837 10.8231 2.95363 10.6788C2.53639 10.0435 2.54539 9.18832 3.00484 8.51198C3.10971 8.35761 3.27201 8.19215 3.699 7.76516L4.3177 7.14645C4.51296 6.95119 4.51296 6.63462 4.3177 6.43936C4.12245 6.2441 3.80587 6.2441 3.61061 6.43936L2.99191 7.05807Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2W = [
    "color"
];
var $c12e32cf04d921d4$export$928cb2cfdd1b2e72 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2W);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.56427 3.99988C4.58422 3.99989 4.60445 3.99989 4.62496 3.99989H5.49996C5.7761 3.99989 5.99996 4.22375 5.99996 4.49989C5.99996 4.77603 5.7761 4.99989 5.49996 4.99989H4.62496C4.02108 4.99989 3.78932 5.00213 3.60601 5.03713C2.80287 5.1905 2.19181 5.78883 2.03759 6.53312C2.00257 6.70212 1.99996 6.91739 1.99996 7.49989C1.99996 8.08239 2.00257 8.29766 2.03759 8.46666C2.19181 9.21095 2.80287 9.80928 3.60601 9.96265C3.78932 9.99765 4.02108 9.99989 4.62496 9.99989H5.49996C5.7761 9.99989 5.99996 10.2237 5.99996 10.4999C5.99996 10.776 5.7761 10.9999 5.49996 10.9999H4.62496C4.60445 10.9999 4.58422 10.9999 4.56427 10.9999C4.04159 11 3.70712 11 3.41845 10.9449C2.23814 10.7195 1.29871 9.82937 1.05839 8.66955C0.999782 8.38669 0.999848 8.05992 0.999947 7.56301C0.999951 7.54227 0.999955 7.52123 0.999955 7.49989C0.999955 7.47855 0.999951 7.45751 0.999947 7.43677C0.999848 6.93986 0.999782 6.61309 1.05839 6.33023C1.29871 5.17041 2.23814 4.28027 3.41845 4.05488C3.70712 3.99976 4.04159 3.99981 4.56427 3.99988ZM11.3939 5.03713C11.2106 5.00213 10.9788 4.99989 10.375 4.99989H9.49996C9.22381 4.99989 8.99996 4.77603 8.99996 4.49989C8.99996 4.22375 9.22381 3.99989 9.49996 3.99989H10.375C10.3955 3.99989 10.4157 3.99989 10.4356 3.99988C10.9583 3.99981 11.2928 3.99976 11.5815 4.05488C12.7618 4.28027 13.7012 5.17041 13.9415 6.33023C14.0001 6.61309 14.0001 6.93985 14 7.43676C14 7.4575 14 7.47854 14 7.49989C14 7.52124 14 7.54228 14 7.56302C14.0001 8.05992 14.0001 8.38669 13.9415 8.66955C13.7012 9.82937 12.7618 10.7195 11.5815 10.9449C11.2928 11 10.9583 11 10.4356 10.9999C10.4157 10.9999 10.3955 10.9999 10.375 10.9999H9.49996C9.22381 10.9999 8.99996 10.776 8.99996 10.4999C8.99996 10.2237 9.22381 9.99989 9.49996 9.99989H10.375C10.9788 9.99989 11.2106 9.99765 11.3939 9.96265C12.197 9.80928 12.8081 9.21095 12.9623 8.46666C12.9973 8.29766 13 8.08239 13 7.49989C13 6.91739 12.9973 6.70212 12.9623 6.53312C12.8081 5.78883 12.197 5.1905 11.3939 5.03713Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2X = [
    "color"
];
var $c12e32cf04d921d4$export$36a31df0698e942 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2X);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10.6788 2.95419C10.0435 2.53694 9.18829 2.54594 8.51194 3.00541C8.35757 3.11027 8.1921 3.27257 7.7651 3.69957L7.14638 4.31829C6.95112 4.51355 6.63454 4.51355 6.43928 4.31829C6.24401 4.12303 6.24401 3.80645 6.43928 3.61119L7.058 2.99247C7.0725 2.97797 7.08679 2.96366 7.1009 2.94955C7.47044 2.57991 7.70691 2.34336 7.95001 2.17822C8.94398 1.50299 10.2377 1.46813 11.2277 2.11832C11.4692 2.27689 11.7002 2.508 12.0515 2.85942C12.0662 2.8741 12.081 2.88898 12.0961 2.90408C12.1112 2.91917 12.1261 2.93405 12.1408 2.94871C12.4922 3.30001 12.7233 3.53102 12.8819 3.77248C13.5321 4.76252 13.4972 6.05623 12.822 7.0502C12.6568 7.2933 12.4203 7.52976 12.0507 7.89929C12.0366 7.9134 12.0222 7.92771 12.0077 7.94221L11.389 8.56093C11.1938 8.7562 10.8772 8.7562 10.6819 8.56093C10.4867 8.36567 10.4867 8.04909 10.6819 7.85383L11.3006 7.23511C11.7276 6.80811 11.8899 6.64264 11.9948 6.48827C12.4543 5.81192 12.4633 4.95675 12.046 4.32141C11.9513 4.17714 11.8009 4.02307 11.389 3.61119C10.9771 3.1993 10.8231 3.04893 10.6788 2.95419ZM4.31796 6.43961C4.51322 6.63487 4.51322 6.95146 4.31796 7.14672L3.69924 7.76544C3.27224 8.19244 3.10993 8.35791 3.00507 8.51227C2.54561 9.18863 2.53661 10.0438 2.95385 10.6791C3.0486 10.8234 3.19896 10.9775 3.61085 11.3894C4.02274 11.8012 4.17681 11.9516 4.32107 12.0464C4.95642 12.4636 5.81158 12.4546 6.48794 11.9951C6.6423 11.8903 6.80777 11.728 7.23477 11.301L7.85349 10.6823C8.04875 10.487 8.36533 10.487 8.5606 10.6823C8.75586 10.8775 8.75586 11.1941 8.5606 11.3894L7.94188 12.0081C7.92738 12.0226 7.91307 12.0369 7.89897 12.051C7.52943 12.4206 7.29296 12.6572 7.04986 12.8223C6.05589 13.4976 4.76219 13.5324 3.77214 12.8822C3.53068 12.7237 3.29967 12.4925 2.94837 12.1411C2.93371 12.1264 2.91883 12.1116 2.90374 12.0965C2.88865 12.0814 2.87377 12.0665 2.8591 12.0518C2.50766 11.7005 2.27656 11.4695 2.11799 11.2281C1.4678 10.238 1.50265 8.94432 2.17788 7.95035C2.34303 7.70724 2.57957 7.47077 2.94922 7.10124C2.96333 7.08713 2.97763 7.07283 2.99213 7.05833L3.61085 6.43961C3.80611 6.24435 4.12269 6.24435 4.31796 6.43961Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2Y = [
    "color"
];
var $c12e32cf04d921d4$export$8ec07838913349db = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2Y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 1C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V2C14 1.44772 13.5523 1 13 1H2ZM3.05 6H4.95V12H3.05V6ZM5.075 4.005C5.075 4.59871 4.59371 5.08 4 5.08C3.4063 5.08 2.925 4.59871 2.925 4.005C2.925 3.41129 3.4063 2.93 4 2.93C4.59371 2.93 5.075 3.41129 5.075 4.005ZM12 8.35713C12 6.55208 10.8334 5.85033 9.67449 5.85033C9.29502 5.83163 8.91721 5.91119 8.57874 6.08107C8.32172 6.21007 8.05265 6.50523 7.84516 7.01853H7.79179V6.00044H6V12.0047H7.90616V8.8112C7.8786 8.48413 7.98327 8.06142 8.19741 7.80987C8.41156 7.55832 8.71789 7.49825 8.95015 7.46774H9.02258C9.62874 7.46774 10.0786 7.84301 10.0786 8.78868V12.0047H11.9847L12 8.35713Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2Z = [
    "color"
];
var $c12e32cf04d921d4$export$9b1a2d77017d0edb = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2Z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 5.25C1.91421 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 1.91421 3.75 1.5 3.75C1.08579 3.75 0.75 4.08579 0.75 4.5C0.75 4.91421 1.08579 5.25 1.5 5.25ZM4 4.5C4 4.22386 4.22386 4 4.5 4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H13.5C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H4.5ZM2.25 7.5C2.25 7.91421 1.91421 8.25 1.5 8.25C1.08579 8.25 0.75 7.91421 0.75 7.5C0.75 7.08579 1.08579 6.75 1.5 6.75C1.91421 6.75 2.25 7.08579 2.25 7.5ZM1.5 11.25C1.91421 11.25 2.25 10.9142 2.25 10.5C2.25 10.0858 1.91421 9.75 1.5 9.75C1.08579 9.75 0.75 10.0858 0.75 10.5C0.75 10.9142 1.08579 11.25 1.5 11.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2_ = [
    "color"
];
var $c12e32cf04d921d4$export$f53936b98653a113 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2_);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 4.63601C5 3.76031 5.24219 3.1054 5.64323 2.67357C6.03934 2.24705 6.64582 1.9783 7.5014 1.9783C8.35745 1.9783 8.96306 2.24652 9.35823 2.67208C9.75838 3.10299 10 3.75708 10 4.63325V5.99999H5V4.63601ZM4 5.99999V4.63601C4 3.58148 4.29339 2.65754 4.91049 1.99307C5.53252 1.32329 6.42675 0.978302 7.5014 0.978302C8.57583 0.978302 9.46952 1.32233 10.091 1.99162C10.7076 2.65557 11 3.57896 11 4.63325V5.99999H12C12.5523 5.99999 13 6.44771 13 6.99999V13C13 13.5523 12.5523 14 12 14H3C2.44772 14 2 13.5523 2 13V6.99999C2 6.44771 2.44772 5.99999 3 5.99999H4ZM3 6.99999H12V13H3V6.99999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$2$ = [
    "color"
];
var $c12e32cf04d921d4$export$5f7f9efc246369d3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$2$);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.4986 0C6.3257 0 5.36107 0.38943 4.73753 1.19361C4.23745 1.83856 4 2.68242 4 3.63325H5C5 2.84313 5.19691 2.23312 5.5278 1.80636C5.91615 1.30552 6.55152 1 7.4986 1C8.35683 1 8.96336 1.26502 9.35846 1.68623C9.75793 2.11211 10 2.76044 10 3.63601V6H3C2.44772 6 2 6.44772 2 7V13C2 13.5523 2.44772 14 3 14H12C12.5523 14 13 13.5523 13 13V7C13 6.44771 12.5523 6 12 6H11V3.63601C11 2.58135 10.7065 1.66167 10.0878 1.0021C9.46477 0.337871 8.57061 0 7.4986 0ZM3 7H12V13H3V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$30 = [
    "color"
];
var $c12e32cf04d921d4$export$fea8b3d7473481c5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$30);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9 3.63601C9 2.76044 9.24207 2.11211 9.64154 1.68623C10.0366 1.26502 10.6432 1 11.5014 1C12.4485 1 13.0839 1.30552 13.4722 1.80636C13.8031 2.23312 14 2.84313 14 3.63325H15C15 2.68242 14.7626 1.83856 14.2625 1.19361C13.6389 0.38943 12.6743 0 11.5014 0C10.4294 0 9.53523 0.337871 8.91218 1.0021C8.29351 1.66167 8 2.58135 8 3.63601V6H1C0.447715 6 0 6.44772 0 7V13C0 13.5523 0.447715 14 1 14H10C10.5523 14 11 13.5523 11 13V7C11 6.44772 10.5523 6 10 6H9V3.63601ZM1 7H10V13H1V7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$31 = [
    "color"
];
var $c12e32cf04d921d4$export$ab1b7565a980cdcc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$31);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.35355 1.85355C3.54882 1.65829 3.54882 1.34171 3.35355 1.14645C3.15829 0.951184 2.84171 0.951184 2.64645 1.14645L0.646447 3.14645C0.451184 3.34171 0.451184 3.65829 0.646447 3.85355L2.64645 5.85355C2.84171 6.04882 3.15829 6.04882 3.35355 5.85355C3.54882 5.65829 3.54882 5.34171 3.35355 5.14645L2.20711 4H9.5C11.433 4 13 5.567 13 7.5C13 7.77614 13.2239 8 13.5 8C13.7761 8 14 7.77614 14 7.5C14 5.01472 11.9853 3 9.5 3H2.20711L3.35355 1.85355ZM2 7.5C2 7.22386 1.77614 7 1.5 7C1.22386 7 1 7.22386 1 7.5C1 9.98528 3.01472 12 5.5 12H12.7929L11.6464 13.1464C11.4512 13.3417 11.4512 13.6583 11.6464 13.8536C11.8417 14.0488 12.1583 14.0488 12.3536 13.8536L14.3536 11.8536C14.5488 11.6583 14.5488 11.3417 14.3536 11.1464L12.3536 9.14645C12.1583 8.95118 11.8417 8.95118 11.6464 9.14645C11.4512 9.34171 11.4512 9.65829 11.6464 9.85355L12.7929 11H5.5C3.567 11 2 9.433 2 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$32 = [
    "color"
];
var $c12e32cf04d921d4$export$bd662a7321ab10c4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$32);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.9 0.499976C13.9 0.279062 13.7209 0.0999756 13.5 0.0999756C13.2791 0.0999756 13.1 0.279062 13.1 0.499976V1.09998H12.5C12.2791 1.09998 12.1 1.27906 12.1 1.49998C12.1 1.72089 12.2791 1.89998 12.5 1.89998H13.1V2.49998C13.1 2.72089 13.2791 2.89998 13.5 2.89998C13.7209 2.89998 13.9 2.72089 13.9 2.49998V1.89998H14.5C14.7209 1.89998 14.9 1.72089 14.9 1.49998C14.9 1.27906 14.7209 1.09998 14.5 1.09998H13.9V0.499976ZM11.8536 3.14642C12.0488 3.34168 12.0488 3.65826 11.8536 3.85353L10.8536 4.85353C10.6583 5.04879 10.3417 5.04879 10.1465 4.85353C9.9512 4.65827 9.9512 4.34169 10.1465 4.14642L11.1464 3.14643C11.3417 2.95116 11.6583 2.95116 11.8536 3.14642ZM9.85357 5.14642C10.0488 5.34168 10.0488 5.65827 9.85357 5.85353L2.85355 12.8535C2.65829 13.0488 2.34171 13.0488 2.14645 12.8535C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L9.14646 5.14642C9.34172 4.95116 9.65831 4.95116 9.85357 5.14642ZM13.5 5.09998C13.7209 5.09998 13.9 5.27906 13.9 5.49998V6.09998H14.5C14.7209 6.09998 14.9 6.27906 14.9 6.49998C14.9 6.72089 14.7209 6.89998 14.5 6.89998H13.9V7.49998C13.9 7.72089 13.7209 7.89998 13.5 7.89998C13.2791 7.89998 13.1 7.72089 13.1 7.49998V6.89998H12.5C12.2791 6.89998 12.1 6.72089 12.1 6.49998C12.1 6.27906 12.2791 6.09998 12.5 6.09998H13.1V5.49998C13.1 5.27906 13.2791 5.09998 13.5 5.09998ZM8.90002 0.499976C8.90002 0.279062 8.72093 0.0999756 8.50002 0.0999756C8.2791 0.0999756 8.10002 0.279062 8.10002 0.499976V1.09998H7.50002C7.2791 1.09998 7.10002 1.27906 7.10002 1.49998C7.10002 1.72089 7.2791 1.89998 7.50002 1.89998H8.10002V2.49998C8.10002 2.72089 8.2791 2.89998 8.50002 2.89998C8.72093 2.89998 8.90002 2.72089 8.90002 2.49998V1.89998H9.50002C9.72093 1.89998 9.90002 1.72089 9.90002 1.49998C9.90002 1.27906 9.72093 1.09998 9.50002 1.09998H8.90002V0.499976Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$33 = [
    "color"
];
var $c12e32cf04d921d4$export$f7658c347b037c3f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$33);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$34 = [
    "color"
];
var $c12e32cf04d921d4$export$fca30e52ebed3683 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$34);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.49988 2.00012C1.77602 2.00012 1.99988 1.77626 1.99988 1.50012C1.99988 1.22398 1.77602 1.00012 1.49988 1.00012C1.22374 1.00012 0.999878 1.22398 0.999878 1.50012C0.999878 1.77626 1.22374 2.00012 1.49988 2.00012ZM4.49988 2.00012C4.77602 2.00012 4.99988 1.77626 4.99988 1.50012C4.99988 1.22398 4.77602 1.00012 4.49988 1.00012C4.22374 1.00012 3.99988 1.22398 3.99988 1.50012C3.99988 1.77626 4.22374 2.00012 4.49988 2.00012ZM7.99988 1.50012C7.99988 1.77626 7.77602 2.00012 7.49988 2.00012C7.22374 2.00012 6.99988 1.77626 6.99988 1.50012C6.99988 1.22398 7.22374 1.00012 7.49988 1.00012C7.77602 1.00012 7.99988 1.22398 7.99988 1.50012ZM10.4999 2.00012C10.776 2.00012 10.9999 1.77626 10.9999 1.50012C10.9999 1.22398 10.776 1.00012 10.4999 1.00012C10.2237 1.00012 9.99988 1.22398 9.99988 1.50012C9.99988 1.77626 10.2237 2.00012 10.4999 2.00012ZM13.9999 1.50012C13.9999 1.77626 13.776 2.00012 13.4999 2.00012C13.2237 2.00012 12.9999 1.77626 12.9999 1.50012C12.9999 1.22398 13.2237 1.00012 13.4999 1.00012C13.776 1.00012 13.9999 1.22398 13.9999 1.50012ZM1.49988 14.0001C1.77602 14.0001 1.99988 13.7763 1.99988 13.5001C1.99988 13.224 1.77602 13.0001 1.49988 13.0001C1.22374 13.0001 0.999878 13.224 0.999878 13.5001C0.999878 13.7763 1.22374 14.0001 1.49988 14.0001ZM1.99988 10.5001C1.99988 10.7763 1.77602 11.0001 1.49988 11.0001C1.22374 11.0001 0.999878 10.7763 0.999878 10.5001C0.999878 10.224 1.22374 10.0001 1.49988 10.0001C1.77602 10.0001 1.99988 10.224 1.99988 10.5001ZM1.49988 8.00012C1.77602 8.00012 1.99988 7.77626 1.99988 7.50012C1.99988 7.22398 1.77602 7.00012 1.49988 7.00012C1.22374 7.00012 0.999878 7.22398 0.999878 7.50012C0.999878 7.77626 1.22374 8.00012 1.49988 8.00012ZM1.99988 4.50012C1.99988 4.77626 1.77602 5.00012 1.49988 5.00012C1.22374 5.00012 0.999878 4.77626 0.999878 4.50012C0.999878 4.22398 1.22374 4.00012 1.49988 4.00012C1.77602 4.00012 1.99988 4.22398 1.99988 4.50012ZM13.4999 11.0001C13.776 11.0001 13.9999 10.7763 13.9999 10.5001C13.9999 10.224 13.776 10.0001 13.4999 10.0001C13.2237 10.0001 12.9999 10.224 12.9999 10.5001C12.9999 10.7763 13.2237 11.0001 13.4999 11.0001ZM13.9999 7.50012C13.9999 7.77626 13.776 8.00012 13.4999 8.00012C13.2237 8.00012 12.9999 7.77626 12.9999 7.50012C12.9999 7.22398 13.2237 7.00012 13.4999 7.00012C13.776 7.00012 13.9999 7.22398 13.9999 7.50012ZM13.4999 5.00012C13.776 5.00012 13.9999 4.77626 13.9999 4.50012C13.9999 4.22398 13.776 4.00012 13.4999 4.00012C13.2237 4.00012 12.9999 4.22398 12.9999 4.50012C12.9999 4.77626 13.2237 5.00012 13.4999 5.00012ZM4.99988 13.5001C4.99988 13.7763 4.77602 14.0001 4.49988 14.0001C4.22374 14.0001 3.99988 13.7763 3.99988 13.5001C3.99988 13.224 4.22374 13.0001 4.49988 13.0001C4.77602 13.0001 4.99988 13.224 4.99988 13.5001ZM7.49988 14.0001C7.77602 14.0001 7.99988 13.7763 7.99988 13.5001C7.99988 13.224 7.77602 13.0001 7.49988 13.0001C7.22374 13.0001 6.99988 13.224 6.99988 13.5001C6.99988 13.7763 7.22374 14.0001 7.49988 14.0001ZM10.9999 13.5001C10.9999 13.7763 10.776 14.0001 10.4999 14.0001C10.2237 14.0001 9.99988 13.7763 9.99988 13.5001C9.99988 13.224 10.2237 13.0001 10.4999 13.0001C10.776 13.0001 10.9999 13.224 10.9999 13.5001ZM13.4999 14.0001C13.776 14.0001 13.9999 13.7763 13.9999 13.5001C13.9999 13.224 13.776 13.0001 13.4999 13.0001C13.2237 13.0001 12.9999 13.224 12.9999 13.5001C12.9999 13.7763 13.2237 14.0001 13.4999 14.0001ZM3.99988 5.00012C3.99988 4.44784 4.44759 4.00012 4.99988 4.00012H9.99988C10.5522 4.00012 10.9999 4.44784 10.9999 5.00012V10.0001C10.9999 10.5524 10.5522 11.0001 9.99988 11.0001H4.99988C4.44759 11.0001 3.99988 10.5524 3.99988 10.0001V5.00012ZM4.99988 5.00012H9.99988V10.0001H4.99988V5.00012Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$35 = [
    "color"
];
var $c12e32cf04d921d4$export$afa4b2f99a1f67c0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$35);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 2H14V13H1L1 2ZM0 2C0 1.44772 0.447715 1 1 1H14C14.5523 1 15 1.44772 15 2V13C15 13.5523 14.5523 14 14 14H1C0.447715 14 0 13.5523 0 13V2ZM4.875 7.5C4.875 6.05025 6.05025 4.875 7.5 4.875C8.94975 4.875 10.125 6.05025 10.125 7.5C10.125 8.94975 8.94975 10.125 7.5 10.125C6.05025 10.125 4.875 8.94975 4.875 7.5ZM7.5 3.875C5.49797 3.875 3.875 5.49797 3.875 7.5C3.875 9.50203 5.49797 11.125 7.5 11.125C9.50203 11.125 11.125 9.50203 11.125 7.5C11.125 5.49797 9.50203 3.875 7.5 3.875Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$36 = [
    "color"
];
var $c12e32cf04d921d4$export$34d98fe14bf296c1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$36);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 1C0.447715 1 0 1.44772 0 2V13C0 13.5523 0.447715 14 1 14H14C14.5523 14 15 13.5523 15 13V2C15 1.44772 14.5523 1 14 1H1ZM7.5 10.625C9.22589 10.625 10.625 9.22589 10.625 7.5C10.625 5.77411 9.22589 4.375 7.5 4.375C5.77411 4.375 4.375 5.77411 4.375 7.5C4.375 9.22589 5.77411 10.625 7.5 10.625Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$37 = [
    "color"
];
var $c12e32cf04d921d4$export$cb808a3c41736d8e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$37);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$38 = [
    "color"
];
var $c12e32cf04d921d4$export$80cd35ac42af1413 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$38);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$39 = [
    "color"
];
var $c12e32cf04d921d4$export$7829447535316b17 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$39);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.14921 3.99996C2.14921 2.97778 2.97784 2.14915 4.00002 2.14915C5.02219 2.14915 5.85083 2.97778 5.85083 3.99996C5.85083 5.02213 5.02219 5.85077 4.00002 5.85077C2.97784 5.85077 2.14921 5.02213 2.14921 3.99996ZM4.00002 1.24915C2.48079 1.24915 1.24921 2.48073 1.24921 3.99996C1.24921 5.51919 2.48079 6.75077 4.00002 6.75077C5.51925 6.75077 6.75083 5.51919 6.75083 3.99996C6.75083 2.48073 5.51925 1.24915 4.00002 1.24915ZM5.82034 11.0001L2.49998 12.8369V9.16331L5.82034 11.0001ZM2.63883 8.21159C2.17228 7.9535 1.59998 8.29093 1.59998 8.82411V13.1761C1.59998 13.7093 2.17228 14.0467 2.63883 13.7886L6.57235 11.6126C7.05389 11.3462 7.05389 10.654 6.57235 10.3876L2.63883 8.21159ZM8.30001 9.00003C8.30001 8.61343 8.61341 8.30003 9.00001 8.30003H13C13.3866 8.30003 13.7 8.61343 13.7 9.00003V13C13.7 13.3866 13.3866 13.7 13 13.7H9.00001C8.61341 13.7 8.30001 13.3866 8.30001 13V9.00003ZM9.20001 9.20003V12.8H12.8V9.20003H9.20001ZM13.4432 2.19311C13.6189 2.01737 13.6189 1.73245 13.4432 1.55671C13.2675 1.38098 12.9826 1.38098 12.8068 1.55671L11 3.36353L9.19321 1.55674C9.01748 1.381 8.73255 1.381 8.55682 1.55674C8.38108 1.73247 8.38108 2.0174 8.55682 2.19313L10.3636 3.99992L8.55682 5.80671C8.38108 5.98245 8.38108 6.26737 8.55682 6.44311C8.73255 6.61885 9.01748 6.61885 9.19321 6.44311L11 4.63632L12.8068 6.44314C12.9826 6.61887 13.2675 6.61887 13.4432 6.44314C13.6189 6.2674 13.6189 5.98247 13.4432 5.80674L11.6364 3.99992L13.4432 2.19311Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3a = [
    "color"
];
var $c12e32cf04d921d4$export$5560e721cf131890 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3a);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3b = [
    "color"
];
var $c12e32cf04d921d4$export$8154ac77932ca099 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3b);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5L4 7C4 7.01671 4.00082 7.03323 4.00242 7.04952C2.86009 7.28022 2 8.28967 2 9.5C2 10.7103 2.86009 11.7198 4.00242 11.9505C4.00082 11.9668 4 11.9833 4 12V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V12C5 11.9833 4.99918 11.9668 4.99758 11.9505C6.1399 11.7198 7 10.7103 7 9.5C7 8.28967 6.1399 7.28022 4.99758 7.04952C4.99918 7.03323 5 7.01671 5 7L5 1.5ZM11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V3C10 3.01671 10.0008 3.03323 10.0024 3.04952C8.8601 3.28022 8 4.28967 8 5.5C8 6.71033 8.8601 7.71978 10.0024 7.95048C10.0008 7.96677 10 7.98329 10 8V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V8C11 7.98329 10.9992 7.96677 10.9976 7.95048C12.1399 7.71978 13 6.71033 13 5.5C13 4.28967 12.1399 3.28022 10.9976 3.04952C10.9992 3.03323 11 3.01671 11 3V1.5ZM4.5 8C3.67157 8 3 8.67157 3 9.5C3 10.3284 3.67157 11 4.5 11C5.32843 11 6 10.3284 6 9.5C6 8.67157 5.32843 8 4.5 8ZM9 5.5C9 4.67157 9.67157 4 10.5 4C11.3284 4 12 4.67157 12 5.5C12 6.32843 11.3284 7 10.5 7C9.67157 7 9 6.32843 9 5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3c = [
    "color"
];
var $c12e32cf04d921d4$export$4484d2284bbfa969 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3c);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4 2.5C4 2.22386 4.22386 2 4.5 2H10.5C10.7761 2 11 2.22386 11 2.5V12.5C11 12.7761 10.7761 13 10.5 13H4.5C4.22386 13 4 12.7761 4 12.5V2.5ZM4.5 1C3.67157 1 3 1.67157 3 2.5V12.5C3 13.3284 3.67157 14 4.5 14H10.5C11.3284 14 12 13.3284 12 12.5V2.5C12 1.67157 11.3284 1 10.5 1H4.5ZM6 11.65C5.8067 11.65 5.65 11.8067 5.65 12C5.65 12.1933 5.8067 12.35 6 12.35H9C9.1933 12.35 9.35 12.1933 9.35 12C9.35 11.8067 9.1933 11.65 9 11.65H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3d = [
    "color"
];
var $c12e32cf04d921d4$export$a2a3256d1cc3a69a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3d);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.25925 3.16667L4.37036 5.33333V1L7.25925 3.16667ZM1 8.22222L3.88889 6.05555L1 3.88889V8.22222ZM1 14L3.88889 11.8333L1 9.66666V14ZM7.74072 8.22222L10.6296 6.05555L7.74072 3.88889V8.22222ZM14 3.16667L11.1111 5.33333V1L14 3.16667ZM11.1111 11.1111L14 8.94444L11.1111 6.77777V11.1111ZM3.88889 11.1111L1 8.94444L3.88889 6.77777V11.1111ZM4.37036 6.05555L7.25925 8.22222V3.88889L4.37036 6.05555ZM3.88889 5.33333L1 3.16667L3.88889 1V5.33333ZM7.74072 3.16667L10.6296 5.33333V1L7.74072 3.16667ZM14 8.22222L11.1111 6.05555L14 3.88889V8.22222ZM11.1111 11.8333L14 14V9.66666L11.1111 11.8333Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3e = [
    "color"
];
var $c12e32cf04d921d4$export$41051b6be05d5fb0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3e);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.89998 0.499976C2.89998 0.279062 2.72089 0.0999756 2.49998 0.0999756C2.27906 0.0999756 2.09998 0.279062 2.09998 0.499976V1.09998H1.49998C1.27906 1.09998 1.09998 1.27906 1.09998 1.49998C1.09998 1.72089 1.27906 1.89998 1.49998 1.89998H2.09998V2.49998C2.09998 2.72089 2.27906 2.89998 2.49998 2.89998C2.72089 2.89998 2.89998 2.72089 2.89998 2.49998V1.89998H3.49998C3.72089 1.89998 3.89998 1.72089 3.89998 1.49998C3.89998 1.27906 3.72089 1.09998 3.49998 1.09998H2.89998V0.499976ZM5.89998 3.49998C5.89998 3.27906 5.72089 3.09998 5.49998 3.09998C5.27906 3.09998 5.09998 3.27906 5.09998 3.49998V4.09998H4.49998C4.27906 4.09998 4.09998 4.27906 4.09998 4.49998C4.09998 4.72089 4.27906 4.89998 4.49998 4.89998H5.09998V5.49998C5.09998 5.72089 5.27906 5.89998 5.49998 5.89998C5.72089 5.89998 5.89998 5.72089 5.89998 5.49998V4.89998H6.49998C6.72089 4.89998 6.89998 4.72089 6.89998 4.49998C6.89998 4.27906 6.72089 4.09998 6.49998 4.09998H5.89998V3.49998ZM1.89998 6.49998C1.89998 6.27906 1.72089 6.09998 1.49998 6.09998C1.27906 6.09998 1.09998 6.27906 1.09998 6.49998V7.09998H0.499976C0.279062 7.09998 0.0999756 7.27906 0.0999756 7.49998C0.0999756 7.72089 0.279062 7.89998 0.499976 7.89998H1.09998V8.49998C1.09998 8.72089 1.27906 8.89997 1.49998 8.89997C1.72089 8.89997 1.89998 8.72089 1.89998 8.49998V7.89998H2.49998C2.72089 7.89998 2.89998 7.72089 2.89998 7.49998C2.89998 7.27906 2.72089 7.09998 2.49998 7.09998H1.89998V6.49998ZM8.54406 0.98184L8.24618 0.941586C8.03275 0.917676 7.90692 1.1655 8.02936 1.34194C8.17013 1.54479 8.29981 1.75592 8.41754 1.97445C8.91878 2.90485 9.20322 3.96932 9.20322 5.10022C9.20322 8.37201 6.82247 11.0878 3.69887 11.6097C3.45736 11.65 3.20988 11.6772 2.96008 11.6906C2.74563 11.702 2.62729 11.9535 2.77721 12.1072C2.84551 12.1773 2.91535 12.2458 2.98667 12.3128L3.05883 12.3795L3.31883 12.6045L3.50684 12.7532L3.62796 12.8433L3.81491 12.9742L3.99079 13.089C4.11175 13.1651 4.23536 13.2375 4.36157 13.3059L4.62496 13.4412L4.88553 13.5607L5.18837 13.6828L5.43169 13.7686C5.56564 13.8128 5.70149 13.8529 5.83857 13.8885C5.94262 13.9155 6.04767 13.9401 6.15405 13.9622C6.27993 13.9883 6.40713 14.0109 6.53544 14.0298L6.85241 14.0685L7.11934 14.0892C7.24637 14.0965 7.37436 14.1002 7.50322 14.1002C11.1483 14.1002 14.1032 11.1453 14.1032 7.50023C14.1032 7.25044 14.0893 7.00389 14.0623 6.76131L14.0255 6.48407C13.991 6.26083 13.9453 6.04129 13.8891 5.82642C13.8213 5.56709 13.7382 5.31398 13.6409 5.06881L13.5279 4.80132L13.4507 4.63542L13.3766 4.48666C13.2178 4.17773 13.0353 3.88295 12.8312 3.60423L12.6782 3.40352L12.4793 3.16432L12.3157 2.98361L12.1961 2.85951L12.0355 2.70246L11.8134 2.50184L11.4925 2.24191L11.2483 2.06498L10.9562 1.87446L10.6346 1.68894L10.3073 1.52378L10.1938 1.47176L9.95488 1.3706L9.67791 1.2669L9.42566 1.1846L9.10075 1.09489L8.83599 1.03486L8.54406 0.98184ZM10.4032 5.30023C10.4032 4.27588 10.2002 3.29829 9.83244 2.40604C11.7623 3.28995 13.1032 5.23862 13.1032 7.50023C13.1032 10.593 10.596 13.1002 7.50322 13.1002C6.63646 13.1002 5.81597 12.9036 5.08355 12.5522C6.5419 12.0941 7.81081 11.2082 8.74322 10.0416C8.87963 10.2284 9.10028 10.3497 9.34928 10.3497C9.76349 10.3497 10.0993 10.0139 10.0993 9.59971C10.0993 9.24256 9.84965 8.94373 9.51535 8.86816C9.57741 8.75165 9.63653 8.63334 9.6926 8.51332C9.88358 8.63163 10.1088 8.69993 10.35 8.69993C11.0403 8.69993 11.6 8.14028 11.6 7.44993C11.6 6.75976 11.0406 6.20024 10.3505 6.19993C10.3853 5.90487 10.4032 5.60464 10.4032 5.30023Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3f = [
    "color"
];
var $c12e32cf04d921d4$export$3e0409b11e4da6d2 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3f);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.81819 0.93179C7.64245 0.756054 7.35753 0.756054 7.18179 0.93179L5.43179 2.68179C5.25605 2.85753 5.25605 3.14245 5.43179 3.31819C5.60753 3.49392 5.89245 3.49392 6.06819 3.31819L6.99999 2.38638V5.49999C6.99999 5.77613 7.22385 5.99999 7.49999 5.99999C7.77613 5.99999 7.99999 5.77613 7.99999 5.49999V2.38638L8.93179 3.31819C9.10753 3.49392 9.39245 3.49392 9.56819 3.31819C9.74392 3.14245 9.74392 2.85753 9.56819 2.68179L7.81819 0.93179ZM7.99999 9.49999C7.99999 9.22385 7.77613 8.99999 7.49999 8.99999C7.22385 8.99999 6.99999 9.22385 6.99999 9.49999V12.6136L6.06819 11.6818C5.89245 11.5061 5.60753 11.5061 5.43179 11.6818C5.25605 11.8575 5.25605 12.1424 5.43179 12.3182L7.18179 14.0682C7.35753 14.2439 7.64245 14.2439 7.81819 14.0682L9.56819 12.3182C9.74392 12.1424 9.74392 11.8575 9.56819 11.6818C9.39245 11.5061 9.10753 11.5061 8.93179 11.6818L7.99999 12.6136V9.49999ZM8.99999 7.49999C8.99999 7.22385 9.22385 6.99999 9.49999 6.99999H12.6136L11.6818 6.06819C11.5061 5.89245 11.5061 5.60753 11.6818 5.43179C11.8575 5.25605 12.1424 5.25605 12.3182 5.43179L14.0682 7.18179C14.2439 7.35753 14.2439 7.64245 14.0682 7.81819L12.3182 9.56819C12.1424 9.74392 11.8575 9.74392 11.6818 9.56819C11.5061 9.39245 11.5061 9.10753 11.6818 8.93179L12.6136 7.99999H9.49999C9.22385 7.99999 8.99999 7.77613 8.99999 7.49999ZM3.31819 6.06819L2.38638 6.99999H5.49999C5.77613 6.99999 5.99999 7.22385 5.99999 7.49999C5.99999 7.77613 5.77613 7.99999 5.49999 7.99999H2.38638L3.31819 8.93179C3.49392 9.10753 3.49392 9.39245 3.31819 9.56819C3.14245 9.74392 2.85753 9.74392 2.68179 9.56819L0.93179 7.81819C0.756054 7.64245 0.756054 7.35753 0.93179 7.18179L2.68179 5.43179C2.85753 5.25605 3.14245 5.25605 3.31819 5.43179C3.49392 5.60753 3.49392 5.89245 3.31819 6.06819Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3g = [
    "color"
];
var $c12e32cf04d921d4$export$f8668531034d5b61 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3g);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.25781 3.11684C3.67771 3.45796 3.83523 3.43193 4.62369 3.37933L12.0571 2.93299C12.2147 2.93299 12.0836 2.77571 12.0311 2.74957L10.7965 1.85711C10.56 1.67347 10.2448 1.46315 9.64083 1.51576L2.44308 2.04074C2.18059 2.06677 2.12815 2.19801 2.2327 2.30322L3.25781 3.11684ZM3.7041 4.84917V12.6704C3.7041 13.0907 3.91415 13.248 4.38693 13.222L12.5562 12.7493C13.0292 12.7233 13.0819 12.4341 13.0819 12.0927V4.32397C13.0819 3.98306 12.9508 3.79921 12.6612 3.82545L4.12422 4.32397C3.80918 4.35044 3.7041 4.50803 3.7041 4.84917ZM11.7688 5.26872C11.8212 5.50518 11.7688 5.74142 11.5319 5.76799L11.1383 5.84641V11.6205C10.7965 11.8042 10.4814 11.9092 10.2188 11.9092C9.79835 11.9092 9.69305 11.7779 9.37812 11.3844L6.80345 7.34249V11.2532L7.61816 11.437C7.61816 11.437 7.61816 11.9092 6.96086 11.9092L5.14879 12.0143C5.09615 11.9092 5.14879 11.647 5.33259 11.5944L5.80546 11.4634V6.29276L5.1489 6.24015C5.09625 6.00369 5.22739 5.66278 5.5954 5.63631L7.53935 5.50528L10.2188 9.5998V5.97765L9.53564 5.89924C9.4832 5.61018 9.69305 5.40028 9.95576 5.37425L11.7688 5.26872ZM1.83874 1.33212L9.32557 0.780787C10.245 0.701932 10.4815 0.754753 11.0594 1.17452L13.4492 2.85424C13.8436 3.14309 13.975 3.22173 13.975 3.53661V12.7493C13.975 13.3266 13.7647 13.6681 13.0293 13.7203L4.33492 14.2454C3.78291 14.2717 3.52019 14.193 3.23111 13.8253L1.47116 11.5419C1.1558 11.1216 1.02466 10.8071 1.02466 10.4392V2.25041C1.02466 1.77825 1.23504 1.38441 1.83874 1.33212Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$3h = [
    "color"
];
var $c12e32cf04d921d4$export$8af0311c2e327563 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3h);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 1.5C4.5 4.25 3 6.5 3 9C3 11.4853 5.01472 13.5 7.5 13.5C9.98528 13.5 12 11.4853 12 9C12 6.5 10.5 4.25 7.5 1.5ZM11 9C11 7.11203 9.97315 5.27195 7.5 2.87357C5.02686 5.27195 4 7.11203 4 9C4 10.933 5.567 12.5 7.5 12.5C9.433 12.5 11 10.933 11 9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3i = [
    "color"
];
var $c12e32cf04d921d4$export$31dd750d53ed8eca = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3i);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$3j = [
    "color"
];
var $c12e32cf04d921d4$export$cc1d3fa780ad61dc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3j);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.49985 1.10001C3.27894 1.10001 3.09985 1.27909 3.09985 1.50001C3.09985 1.72092 3.27894 1.90001 3.49985 1.90001H11.4999C11.7208 1.90001 11.8999 1.72092 11.8999 1.50001C11.8999 1.27909 11.7208 1.10001 11.4999 1.10001H3.49985ZM4.99995 4.25001C4.99995 3.97387 4.77609 3.75001 4.49995 3.75001C4.22381 3.75001 3.99995 3.97387 3.99995 4.25001V9.55001C3.99995 11.483 5.56695 13.05 7.49995 13.05C9.43295 13.05 11 11.483 11 9.55001V4.25001C11 3.97387 10.7761 3.75001 10.5 3.75001C10.2238 3.75001 9.99995 3.97387 9.99995 4.25001V9.55001C9.99995 10.9307 8.88066 12.05 7.49995 12.05C6.11924 12.05 4.99995 10.9307 4.99995 9.55001V4.25001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3k = [
    "color"
];
var $c12e32cf04d921d4$export$2ff5a181c2f67fef = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3k);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.85714 2H12.1429C12.6162 2 13 2.38376 13 2.85714V12.1429C13 12.6162 12.6162 13 12.1429 13H2.85714C2.38376 13 2 12.6162 2 12.1429V2.85714C2 2.38376 2.38376 2 2.85714 2ZM1 2.85714C1 1.83147 1.83147 1 2.85714 1H12.1429C13.1685 1 14 1.83147 14 2.85714V12.1429C14 13.1685 13.1685 14 12.1429 14H2.85714C1.83147 14 1 13.1685 1 12.1429V2.85714ZM7.49988 5.00012C7.77602 5.00012 7.99988 4.77626 7.99988 4.50012C7.99988 4.22398 7.77602 4.00012 7.49988 4.00012C7.22374 4.00012 6.99988 4.22398 6.99988 4.50012C6.99988 4.77626 7.22374 5.00012 7.49988 5.00012ZM4.49988 11.0001C4.77602 11.0001 4.99988 10.7763 4.99988 10.5001C4.99988 10.224 4.77602 10.0001 4.49988 10.0001C4.22374 10.0001 3.99988 10.224 3.99988 10.5001C3.99988 10.7763 4.22374 11.0001 4.49988 11.0001ZM4.99988 7.50012C4.99988 7.77626 4.77602 8.00012 4.49988 8.00012C4.22374 8.00012 3.99988 7.77626 3.99988 7.50012C3.99988 7.22398 4.22374 7.00012 4.49988 7.00012C4.77602 7.00012 4.99988 7.22398 4.99988 7.50012ZM4.49988 5.00012C4.77602 5.00012 4.99988 4.77626 4.99988 4.50012C4.99988 4.22398 4.77602 4.00012 4.49988 4.00012C4.22374 4.00012 3.99988 4.22398 3.99988 4.50012C3.99988 4.77626 4.22374 5.00012 4.49988 5.00012ZM10.9999 10.5001C10.9999 10.7763 10.776 11.0001 10.4999 11.0001C10.2237 11.0001 9.99988 10.7763 9.99988 10.5001C9.99988 10.224 10.2237 10.0001 10.4999 10.0001C10.776 10.0001 10.9999 10.224 10.9999 10.5001ZM10.4999 8.00012C10.776 8.00012 10.9999 7.77626 10.9999 7.50012C10.9999 7.22398 10.776 7.00012 10.4999 7.00012C10.2237 7.00012 9.99988 7.22398 9.99988 7.50012C9.99988 7.77626 10.2237 8.00012 10.4999 8.00012ZM10.9999 4.50012C10.9999 4.77626 10.776 5.00012 10.4999 5.00012C10.2237 5.00012 9.99988 4.77626 9.99988 4.50012C9.99988 4.22398 10.2237 4.00012 10.4999 4.00012C10.776 4.00012 10.9999 4.22398 10.9999 4.50012ZM7.49988 11.0001C7.77602 11.0001 7.99988 10.7763 7.99988 10.5001C7.99988 10.224 7.77602 10.0001 7.49988 10.0001C7.22374 10.0001 6.99988 10.224 6.99988 10.5001C6.99988 10.7763 7.22374 11.0001 7.49988 11.0001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3l = [
    "color"
];
var $c12e32cf04d921d4$export$7e727ef41af0217d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3l);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.20308 1.04312C1.00481 0.954998 0.772341 1.0048 0.627577 1.16641C0.482813 1.32802 0.458794 1.56455 0.568117 1.75196L3.92115 7.50002L0.568117 13.2481C0.458794 13.4355 0.482813 13.672 0.627577 13.8336C0.772341 13.9952 1.00481 14.045 1.20308 13.9569L14.7031 7.95693C14.8836 7.87668 15 7.69762 15 7.50002C15 7.30243 14.8836 7.12337 14.7031 7.04312L1.20308 1.04312ZM4.84553 7.10002L2.21234 2.586L13.2689 7.50002L2.21234 12.414L4.84552 7.90002H9C9.22092 7.90002 9.4 7.72094 9.4 7.50002C9.4 7.27911 9.22092 7.10002 9 7.10002H4.84553Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3m = [
    "color"
];
var $c12e32cf04d921d4$export$9b47433640e5db3a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3m);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.04995 2.74998C6.04995 2.44623 5.80371 2.19998 5.49995 2.19998C5.19619 2.19998 4.94995 2.44623 4.94995 2.74998V12.25C4.94995 12.5537 5.19619 12.8 5.49995 12.8C5.80371 12.8 6.04995 12.5537 6.04995 12.25V2.74998ZM10.05 2.74998C10.05 2.44623 9.80371 2.19998 9.49995 2.19998C9.19619 2.19998 8.94995 2.44623 8.94995 2.74998V12.25C8.94995 12.5537 9.19619 12.8 9.49995 12.8C9.80371 12.8 10.05 12.5537 10.05 12.25V2.74998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3n = [
    "color"
];
var $c12e32cf04d921d4$export$41c6eabacaa37313 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3n);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.8536 1.14645C11.6583 0.951184 11.3417 0.951184 11.1465 1.14645L3.71455 8.57836C3.62459 8.66832 3.55263 8.77461 3.50251 8.89155L2.04044 12.303C1.9599 12.491 2.00189 12.709 2.14646 12.8536C2.29103 12.9981 2.50905 13.0401 2.69697 12.9596L6.10847 11.4975C6.2254 11.4474 6.3317 11.3754 6.42166 11.2855L13.8536 3.85355C14.0488 3.65829 14.0488 3.34171 13.8536 3.14645L11.8536 1.14645ZM4.42166 9.28547L11.5 2.20711L12.7929 3.5L5.71455 10.5784L4.21924 11.2192L3.78081 10.7808L4.42166 9.28547Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3o = [
    "color"
];
var $c12e32cf04d921d4$export$bedf874c76d8ae34 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3o);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.1464 1.14645C12.3417 0.951184 12.6583 0.951184 12.8535 1.14645L14.8535 3.14645C15.0488 3.34171 15.0488 3.65829 14.8535 3.85355L10.9109 7.79618C10.8349 7.87218 10.7471 7.93543 10.651 7.9835L6.72359 9.94721C6.53109 10.0435 6.29861 10.0057 6.14643 9.85355C5.99425 9.70137 5.95652 9.46889 6.05277 9.27639L8.01648 5.34897C8.06455 5.25283 8.1278 5.16507 8.2038 5.08907L12.1464 1.14645ZM12.5 2.20711L8.91091 5.79618L7.87266 7.87267L8.12731 8.12732L10.2038 7.08907L13.7929 3.5L12.5 2.20711ZM9.99998 2L8.99998 3H4.9C4.47171 3 4.18056 3.00039 3.95552 3.01877C3.73631 3.03668 3.62421 3.06915 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3.06915 3.62421 3.03669 3.73631 3.01878 3.95552C3.00039 4.18056 3 4.47171 3 4.9V11.1C3 11.5283 3.00039 11.8194 3.01878 12.0445C3.03669 12.2637 3.06915 12.3758 3.10899 12.454C3.20487 12.6422 3.35785 12.7951 3.54601 12.891C3.62421 12.9309 3.73631 12.9633 3.95552 12.9812C4.18056 12.9996 4.47171 13 4.9 13H11.1C11.5283 13 11.8194 12.9996 12.0445 12.9812C12.2637 12.9633 12.3758 12.9309 12.454 12.891C12.6422 12.7951 12.7951 12.6422 12.891 12.454C12.9309 12.3758 12.9633 12.2637 12.9812 12.0445C12.9996 11.8194 13 11.5283 13 11.1V6.99998L14 5.99998V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H4.9H4.87934C4.47686 14 4.14468 14 3.87409 13.9779C3.59304 13.9549 3.33469 13.9057 3.09202 13.782C2.7157 13.5903 2.40973 13.2843 2.21799 12.908C2.09434 12.6653 2.04506 12.407 2.0221 12.1259C1.99999 11.8553 1.99999 11.5231 2 11.1207V11.1206V11.1V4.9V4.87935V4.87932V4.87931C1.99999 4.47685 1.99999 4.14468 2.0221 3.87409C2.04506 3.59304 2.09434 3.33469 2.21799 3.09202C2.40973 2.71569 2.7157 2.40973 3.09202 2.21799C3.33469 2.09434 3.59304 2.04506 3.87409 2.0221C4.14468 1.99999 4.47685 1.99999 4.87932 2H4.87935H4.9H9.99998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3p = [
    "color"
];
var $c12e32cf04d921d4$export$7dcc8f518762622d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3p);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3q = [
    "color"
];
var $c12e32cf04d921d4$export$b86b18d4ddcc0181 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.85001 7.50043C1.85001 4.37975 4.37963 1.85001 7.50001 1.85001C10.6204 1.85001 13.15 4.37975 13.15 7.50043C13.15 10.6211 10.6204 13.1509 7.50001 13.1509C4.37963 13.1509 1.85001 10.6211 1.85001 7.50043ZM7.50001 0.850006C3.82728 0.850006 0.850006 3.82753 0.850006 7.50043C0.850006 11.1733 3.82728 14.1509 7.50001 14.1509C11.1727 14.1509 14.15 11.1733 14.15 7.50043C14.15 3.82753 11.1727 0.850006 7.50001 0.850006ZM7.00001 8.00001V3.12811C7.16411 3.10954 7.33094 3.10001 7.50001 3.10001C9.93006 3.10001 11.9 5.07014 11.9 7.50043C11.9 7.66935 11.8905 7.83604 11.872 8.00001H7.00001Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3r = [
    "color"
];
var $c12e32cf04d921d4$export$d5d0c446063e1490 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3r);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3 5.5C3 7.983 4.99169 9 7 9V12.5C7 12.7761 7.22386 13 7.5 13C7.77614 13 8 12.7761 8 12.5V9V3.1H9V12.5C9 12.7761 9.22386 13 9.5 13C9.77614 13 10 12.7761 10 12.5V3.1H11.5C11.8038 3.1 12.05 2.85376 12.05 2.55C12.05 2.24624 11.8038 2 11.5 2H9.5H8H7.5H7C4.99169 2 3 3.017 3 5.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3s = [
    "color"
];
var $c12e32cf04d921d4$export$f65249e0566edf55 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3s);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.5 13.95C13.7485 13.95 13.95 13.7485 13.95 13.5C13.95 13.2514 13.7485 13.05 13.5 13.05L1.49995 13.05C1.25142 13.05 1.04995 13.2514 1.04995 13.5C1.04995 13.7485 1.25142 13.95 1.49995 13.95L13.5 13.95ZM11.0681 7.5683C11.2439 7.39257 11.2439 7.10764 11.0681 6.93191C10.8924 6.75617 10.6075 6.75617 10.4317 6.93191L7.94993 9.41371L7.94993 1.49998C7.94993 1.25146 7.74846 1.04998 7.49993 1.04998C7.2514 1.04998 7.04993 1.25146 7.04993 1.49998L7.04993 9.41371L4.56813 6.93191C4.39239 6.75617 4.10746 6.75617 3.93173 6.93191C3.75599 7.10764 3.75599 7.39257 3.93173 7.5683L7.18173 10.8183C7.35746 10.994 7.64239 10.994 7.81812 10.8183L11.0681 7.5683Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3t = [
    "color"
];
var $c12e32cf04d921d4$export$d57f0cfd6aca7ffa = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3t);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.05005 13.5C2.05005 13.7485 2.25152 13.95 2.50005 13.95C2.74858 13.95 2.95005 13.7485 2.95005 13.5L2.95005 1.49995C2.95005 1.25142 2.74858 1.04995 2.50005 1.04995C2.25152 1.04995 2.05005 1.25142 2.05005 1.49995L2.05005 13.5ZM8.4317 11.0681C8.60743 11.2439 8.89236 11.2439 9.06809 11.0681C9.24383 10.8924 9.24383 10.6075 9.06809 10.4317L6.58629 7.94993L14.5 7.94993C14.7485 7.94993 14.95 7.74846 14.95 7.49993C14.95 7.2514 14.7485 7.04993 14.5 7.04993L6.58629 7.04993L9.06809 4.56813C9.24383 4.39239 9.24383 4.10746 9.06809 3.93173C8.89236 3.75599 8.60743 3.75599 8.4317 3.93173L5.1817 7.18173C5.00596 7.35746 5.00596 7.64239 5.1817 7.81812L8.4317 11.0681Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3u = [
    "color"
];
var $c12e32cf04d921d4$export$fe9311722b59190b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3u);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.95 1.50005C12.95 1.25152 12.7485 1.05005 12.5 1.05005C12.2514 1.05005 12.05 1.25152 12.05 1.50005L12.05 13.5C12.05 13.7486 12.2514 13.95 12.5 13.95C12.7485 13.95 12.95 13.7486 12.95 13.5L12.95 1.50005ZM6.5683 3.93188C6.39257 3.75614 6.10764 3.75614 5.93191 3.93188C5.75617 4.10761 5.75617 4.39254 5.93191 4.56827L8.41371 7.05007L0.499984 7.05007C0.251456 7.05007 0.0499847 7.25155 0.0499847 7.50007C0.0499846 7.7486 0.251457 7.95007 0.499984 7.95007L8.41371 7.95007L5.93191 10.4319C5.75617 10.6076 5.75617 10.8925 5.93191 11.0683C6.10764 11.244 6.39257 11.244 6.56831 11.0683L9.8183 7.81827C9.99404 7.64254 9.99404 7.35761 9.8183 7.18188L6.5683 3.93188Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3v = [
    "color"
];
var $c12e32cf04d921d4$export$71e4148884d34eff = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3v);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.50005 1.05005C1.25152 1.05005 1.05005 1.25152 1.05005 1.50005C1.05005 1.74858 1.25152 1.95005 1.50005 1.95005L13.5 1.95005C13.7486 1.95005 13.95 1.74858 13.95 1.50005C13.95 1.25152 13.7486 1.05005 13.5 1.05005H1.50005ZM3.93188 7.43169C3.75614 7.60743 3.75614 7.89236 3.93188 8.06809C4.10761 8.24383 4.39254 8.24383 4.56827 8.06809L7.05007 5.58629V13.5C7.05007 13.7485 7.25155 13.95 7.50007 13.95C7.7486 13.95 7.95007 13.7485 7.95007 13.5L7.95007 5.58629L10.4319 8.06809C10.6076 8.24383 10.8925 8.24383 11.0683 8.06809C11.244 7.89235 11.244 7.60743 11.0683 7.43169L7.81827 4.18169C7.64254 4.00596 7.35761 4.00596 7.18188 4.18169L3.93188 7.43169Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3w = [
    "color"
];
var $c12e32cf04d921d4$export$a6630b90defda83f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3w);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.24182 2.32181C3.3919 2.23132 3.5784 2.22601 3.73338 2.30781L12.7334 7.05781C12.8974 7.14436 13 7.31457 13 7.5C13 7.68543 12.8974 7.85564 12.7334 7.94219L3.73338 12.6922C3.5784 12.774 3.3919 12.7687 3.24182 12.6782C3.09175 12.5877 3 12.4252 3 12.25V2.75C3 2.57476 3.09175 2.4123 3.24182 2.32181ZM4 3.57925V11.4207L11.4288 7.5L4 3.57925Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3x = [
    "color"
];
var $c12e32cf04d921d4$export$f21ab0717a89c77f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3x);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3y = [
    "color"
];
var $c12e32cf04d921d4$export$75a23c9e49a976a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM7.50003 4C7.77617 4 8.00003 4.22386 8.00003 4.5V7H10.5C10.7762 7 11 7.22386 11 7.5C11 7.77614 10.7762 8 10.5 8H8.00003V10.5C8.00003 10.7761 7.77617 11 7.50003 11C7.22389 11 7.00003 10.7761 7.00003 10.5V8H4.50003C4.22389 8 4.00003 7.77614 4.00003 7.5C4.00003 7.22386 4.22389 7 4.50003 7H7.00003V4.5C7.00003 4.22386 7.22389 4 7.50003 4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3z = [
    "color"
];
var $c12e32cf04d921d4$export$58a334b597cee6d6 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.07505 4.10001C5.07505 2.91103 6.25727 1.92502 7.50005 1.92502C8.74283 1.92502 9.92505 2.91103 9.92505 4.10001C9.92505 5.19861 9.36782 5.71436 8.61854 6.37884L8.58757 6.4063C7.84481 7.06467 6.92505 7.87995 6.92505 9.5C6.92505 9.81757 7.18248 10.075 7.50005 10.075C7.81761 10.075 8.07505 9.81757 8.07505 9.5C8.07505 8.41517 8.62945 7.90623 9.38156 7.23925L9.40238 7.22079C10.1496 6.55829 11.075 5.73775 11.075 4.10001C11.075 2.12757 9.21869 0.775024 7.50005 0.775024C5.7814 0.775024 3.92505 2.12757 3.92505 4.10001C3.92505 4.41758 4.18249 4.67501 4.50005 4.67501C4.81761 4.67501 5.07505 4.41758 5.07505 4.10001ZM7.50005 13.3575C7.9833 13.3575 8.37505 12.9657 8.37505 12.4825C8.37505 11.9992 7.9833 11.6075 7.50005 11.6075C7.0168 11.6075 6.62505 11.9992 6.62505 12.4825C6.62505 12.9657 7.0168 13.3575 7.50005 13.3575Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3A = [
    "color"
];
var $c12e32cf04d921d4$export$2548f56a2855ec74 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3A);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3B = [
    "color"
];
var $c12e32cf04d921d4$export$62bd98fc131b5caa = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3B);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9.42503 3.44136C10.0561 3.23654 10.7837 3.2402 11.3792 3.54623C12.7532 4.25224 13.3477 6.07191 12.7946 8C12.5465 8.8649 12.1102 9.70472 11.1861 10.5524C10.262 11.4 8.98034 11.9 8.38571 11.9C8.17269 11.9 8 11.7321 8 11.525C8 11.3179 8.17644 11.15 8.38571 11.15C9.06497 11.15 9.67189 10.7804 10.3906 10.236C10.9406 9.8193 11.3701 9.28633 11.608 8.82191C12.0628 7.93367 12.0782 6.68174 11.3433 6.34901C10.9904 6.73455 10.5295 6.95946 9.97725 6.95946C8.7773 6.95946 8.0701 5.99412 8.10051 5.12009C8.12957 4.28474 8.66032 3.68954 9.42503 3.44136ZM3.42503 3.44136C4.05614 3.23654 4.78366 3.2402 5.37923 3.54623C6.7532 4.25224 7.34766 6.07191 6.79462 8C6.54654 8.8649 6.11019 9.70472 5.1861 10.5524C4.26201 11.4 2.98034 11.9 2.38571 11.9C2.17269 11.9 2 11.7321 2 11.525C2 11.3179 2.17644 11.15 2.38571 11.15C3.06497 11.15 3.67189 10.7804 4.39058 10.236C4.94065 9.8193 5.37014 9.28633 5.60797 8.82191C6.06282 7.93367 6.07821 6.68174 5.3433 6.34901C4.99037 6.73455 4.52948 6.95946 3.97725 6.95946C2.7773 6.95946 2.0701 5.99412 2.10051 5.12009C2.12957 4.28474 2.66032 3.68954 3.42503 3.44136Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3C = [
    "color"
];
var $c12e32cf04d921d4$export$c617f5f26da0904b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3C);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 11.1575 3.84216 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1575 0.877045 7.49985 0.877045ZM1.82701 7.49988C1.82701 4.36686 4.36683 1.82704 7.49985 1.82704C10.6328 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6328 13.1727 7.49985 13.1727C4.36683 13.1727 1.82701 10.6329 1.82701 7.49988ZM7.49999 9.49999C8.60456 9.49999 9.49999 8.60456 9.49999 7.49999C9.49999 6.39542 8.60456 5.49999 7.49999 5.49999C6.39542 5.49999 5.49999 6.39542 5.49999 7.49999C5.49999 8.60456 6.39542 9.49999 7.49999 9.49999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3D = [
    "color"
];
var $c12e32cf04d921d4$export$b6cede2da0e4d831 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3D);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.2 1H4.17741H4.1774C3.86936 0.999988 3.60368 0.999978 3.38609 1.02067C3.15576 1.04257 2.92825 1.09113 2.71625 1.22104C2.51442 1.34472 2.34473 1.51442 2.22104 1.71625C2.09113 1.92825 2.04257 2.15576 2.02067 2.38609C1.99998 2.60367 1.99999 2.86935 2 3.17738V3.1774V3.2V11.8V11.8226V11.8226C1.99999 12.1307 1.99998 12.3963 2.02067 12.6139C2.04257 12.8442 2.09113 13.0717 2.22104 13.2837C2.34473 13.4856 2.51442 13.6553 2.71625 13.779C2.92825 13.9089 3.15576 13.9574 3.38609 13.9793C3.60368 14 3.86937 14 4.17741 14H4.2H10.8H10.8226C11.1306 14 11.3963 14 11.6139 13.9793C11.8442 13.9574 12.0717 13.9089 12.2837 13.779C12.4856 13.6553 12.6553 13.4856 12.779 13.2837C12.9089 13.0717 12.9574 12.8442 12.9793 12.6139C13 12.3963 13 12.1306 13 11.8226V11.8V3.2V3.17741C13 2.86936 13 2.60368 12.9793 2.38609C12.9574 2.15576 12.9089 1.92825 12.779 1.71625C12.6553 1.51442 12.4856 1.34472 12.2837 1.22104C12.0717 1.09113 11.8442 1.04257 11.6139 1.02067C11.3963 0.999978 11.1306 0.999988 10.8226 1H10.8H4.2ZM3.23875 2.07368C3.26722 2.05623 3.32362 2.03112 3.48075 2.01618C3.64532 2.00053 3.86298 2 4.2 2H10.8C11.137 2 11.3547 2.00053 11.5193 2.01618C11.6764 2.03112 11.7328 2.05623 11.7613 2.07368C11.8285 2.11491 11.8851 2.17147 11.9263 2.23875C11.9438 2.26722 11.9689 2.32362 11.9838 2.48075C11.9995 2.64532 12 2.86298 12 3.2V11.8C12 12.137 11.9995 12.3547 11.9838 12.5193C11.9689 12.6764 11.9438 12.7328 11.9263 12.7613C11.8851 12.8285 11.8285 12.8851 11.7613 12.9263C11.7328 12.9438 11.6764 12.9689 11.5193 12.9838C11.3547 12.9995 11.137 13 10.8 13H4.2C3.86298 13 3.64532 12.9995 3.48075 12.9838C3.32362 12.9689 3.26722 12.9438 3.23875 12.9263C3.17147 12.8851 3.11491 12.8285 3.07368 12.7613C3.05624 12.7328 3.03112 12.6764 3.01618 12.5193C3.00053 12.3547 3 12.137 3 11.8V3.2C3 2.86298 3.00053 2.64532 3.01618 2.48075C3.03112 2.32362 3.05624 2.26722 3.07368 2.23875C3.11491 2.17147 3.17147 2.11491 3.23875 2.07368ZM5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H8C8.27614 11 8.5 10.7761 8.5 10.5C8.5 10.2239 8.27614 10 8 10H5ZM4.5 7.5C4.5 7.22386 4.72386 7 5 7H10C10.2761 7 10.5 7.22386 10.5 7.5C10.5 7.77614 10.2761 8 10 8H5C4.72386 8 4.5 7.77614 4.5 7.5ZM5 4C4.72386 4 4.5 4.22386 4.5 4.5C4.5 4.77614 4.72386 5 5 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3E = [
    "color"
];
var $c12e32cf04d921d4$export$ca36f1a1d2d1ca14 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3E);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.84998 7.49998C1.84998 4.66458 4.05979 1.84998 7.49998 1.84998C10.2783 1.84998 11.6515 3.9064 12.2367 5H10.5C10.2239 5 10 5.22386 10 5.5C10 5.77614 10.2239 6 10.5 6H13.5C13.7761 6 14 5.77614 14 5.5V2.5C14 2.22386 13.7761 2 13.5 2C13.2239 2 13 2.22386 13 2.5V4.31318C12.2955 3.07126 10.6659 0.849976 7.49998 0.849976C3.43716 0.849976 0.849976 4.18537 0.849976 7.49998C0.849976 10.8146 3.43716 14.15 7.49998 14.15C9.44382 14.15 11.0622 13.3808 12.2145 12.2084C12.8315 11.5806 13.3133 10.839 13.6418 10.0407C13.7469 9.78536 13.6251 9.49315 13.3698 9.38806C13.1144 9.28296 12.8222 9.40478 12.7171 9.66014C12.4363 10.3425 12.0251 10.9745 11.5013 11.5074C10.5295 12.4963 9.16504 13.15 7.49998 13.15C4.05979 13.15 1.84998 10.3354 1.84998 7.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3F = [
    "color"
];
var $c12e32cf04d921d4$export$7637ad60dd86d3b1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3F);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.70711 4H9C11.4853 4 13.5 6.01472 13.5 8.5C13.5 10.9853 11.4853 13 9 13H5C4.72386 13 4.5 12.7761 4.5 12.5C4.5 12.2239 4.72386 12 5 12H9C10.933 12 12.5 10.433 12.5 8.5C12.5 6.567 10.933 5 9 5H3.70711L4.85355 6.14645C5.04882 6.34171 5.04882 6.65829 4.85355 6.85355C4.65829 7.04882 4.34171 7.04882 4.14645 6.85355L2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3G = [
    "color"
];
var $c12e32cf04d921d4$export$199745d7f18c0761 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3G);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.04995 2.74995C3.04995 2.44619 2.80371 2.19995 2.49995 2.19995C2.19619 2.19995 1.94995 2.44619 1.94995 2.74995V12.25C1.94995 12.5537 2.19619 12.8 2.49995 12.8C2.80371 12.8 3.04995 12.5537 3.04995 12.25V2.74995ZM5.73333 2.30776C5.57835 2.22596 5.39185 2.23127 5.24177 2.32176C5.0917 2.41225 4.99995 2.57471 4.99995 2.74995V12.25C4.99995 12.4252 5.0917 12.5877 5.24177 12.6781C5.39185 12.7686 5.57835 12.7739 5.73333 12.6921L14.7333 7.94214C14.8973 7.85559 15 7.68539 15 7.49995C15 7.31452 14.8973 7.14431 14.7333 7.05776L5.73333 2.30776ZM5.99995 11.4207V3.5792L13.4287 7.49995L5.99995 11.4207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3H = [
    "color"
];
var $c12e32cf04d921d4$export$8e0d2500d5bd92ef = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3H);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.85357 3.85355L7.65355 3.05353C8.2981 2.40901 9.42858 1.96172 10.552 1.80125C11.1056 1.72217 11.6291 1.71725 12.0564 1.78124C12.4987 1.84748 12.7698 1.97696 12.8965 2.10357C13.0231 2.23018 13.1526 2.50125 13.2188 2.94357C13.2828 3.37086 13.2779 3.89439 13.1988 4.44801C13.0383 5.57139 12.591 6.70188 11.9464 7.34645L7.49999 11.7929L6.35354 10.6465C6.15827 10.4512 5.84169 10.4512 5.64643 10.6465C5.45117 10.8417 5.45117 11.1583 5.64643 11.3536L7.14644 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L8.40073 12.3064L9.57124 14.2572C9.65046 14.3893 9.78608 14.4774 9.9389 14.4963C10.0917 14.5151 10.2447 14.4624 10.3535 14.3536L12.3535 12.3536C12.4648 12.2423 12.5172 12.0851 12.495 11.9293L12.0303 8.67679L12.6536 8.05355C13.509 7.19808 14.0117 5.82855 14.1887 4.58943C14.2784 3.9618 14.2891 3.33847 14.2078 2.79546C14.1287 2.26748 13.9519 1.74482 13.6035 1.39645C13.2552 1.04809 12.7325 0.871332 12.2045 0.792264C11.6615 0.710945 11.0382 0.721644 10.4105 0.8113C9.17143 0.988306 7.80189 1.491 6.94644 2.34642L6.32322 2.96968L3.07071 2.50504C2.91492 2.48278 2.75773 2.53517 2.64645 2.64646L0.646451 4.64645C0.537579 4.75533 0.484938 4.90829 0.50375 5.0611C0.522563 5.21391 0.61073 5.34954 0.742757 5.42876L2.69364 6.59928L2.14646 7.14645C2.0527 7.24022 2.00002 7.3674 2.00002 7.50001C2.00002 7.63261 2.0527 7.75979 2.14646 7.85356L3.64647 9.35356C3.84173 9.54883 4.15831 9.54883 4.35357 9.35356C4.54884 9.1583 4.54884 8.84172 4.35357 8.64646L3.20712 7.50001L3.85357 6.85356L6.85357 3.85355ZM10.0993 13.1936L9.12959 11.5775L11.1464 9.56067L11.4697 11.8232L10.0993 13.1936ZM3.42251 5.87041L5.43935 3.85356L3.17678 3.53034L1.80638 4.90074L3.42251 5.87041ZM2.35356 10.3535C2.54882 10.1583 2.54882 9.8417 2.35356 9.64644C2.1583 9.45118 1.84171 9.45118 1.64645 9.64644L0.646451 10.6464C0.451188 10.8417 0.451188 11.1583 0.646451 11.3535C0.841713 11.5488 1.1583 11.5488 1.35356 11.3535L2.35356 10.3535ZM3.85358 11.8536C4.04884 11.6583 4.04885 11.3417 3.85359 11.1465C3.65833 10.9512 3.34175 10.9512 3.14648 11.1465L1.14645 13.1464C0.95119 13.3417 0.951187 13.6583 1.14645 13.8535C1.34171 14.0488 1.65829 14.0488 1.85355 13.8536L3.85358 11.8536ZM5.35356 13.3535C5.54882 13.1583 5.54882 12.8417 5.35356 12.6464C5.1583 12.4512 4.84171 12.4512 4.64645 12.6464L3.64645 13.6464C3.45119 13.8417 3.45119 14.1583 3.64645 14.3535C3.84171 14.5488 4.1583 14.5488 4.35356 14.3535L5.35356 13.3535ZM9.49997 6.74881C10.1897 6.74881 10.7488 6.1897 10.7488 5.5C10.7488 4.8103 10.1897 4.25118 9.49997 4.25118C8.81026 4.25118 8.25115 4.8103 8.25115 5.5C8.25115 6.1897 8.81026 6.74881 9.49997 6.74881Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3I = [
    "color"
];
var $c12e32cf04d921d4$export$f0960ce3e1a6f234 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3I);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.59664 2.93628C7.76085 3.06401 8.00012 2.94698 8.00012 2.73895V1.99998C9.98143 2 11.1848 2.3637 11.9105 3.08945C12.6363 3.81522 13 5.0186 13 6.99998C13 7.27613 13.2239 7.49998 13.5 7.49998C13.7761 7.49998 14 7.27613 14 6.99998C14 4.9438 13.6325 3.39719 12.6176 2.38234C11.6028 1.36752 10.0562 0.999999 8.00012 0.999984V0.261266C8.00012 0.0532293 7.76085 -0.0637944 7.59664 0.063928L6.00384 1.30277C5.87516 1.40286 5.87516 1.59735 6.00384 1.69744L7.59664 2.93628ZM9.5 5H2.5C2.22386 5 2 5.22386 2 5.5V12.5C2 12.7761 2.22386 13 2.5 13H9.5C9.77614 13 10 12.7761 10 12.5V5.5C10 5.22386 9.77614 5 9.5 5ZM2.5 4C1.67157 4 1 4.67157 1 5.5V12.5C1 13.3284 1.67157 14 2.5 14H9.5C10.3284 14 11 13.3284 11 12.5V5.5C11 4.67157 10.3284 4 9.5 4H2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3J = [
    "color"
];
var $c12e32cf04d921d4$export$f0399077805ff597 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3J);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.81832 0.68179C7.64258 0.506054 7.35766 0.506054 7.18192 0.68179L5.18192 2.68179C5.00619 2.85753 5.00619 3.14245 5.18192 3.31819C5.35766 3.49392 5.64258 3.49392 5.81832 3.31819L7.05012 2.08638L7.05012 5.50023C7.05012 5.74876 7.25159 5.95023 7.50012 5.95023C7.74865 5.95023 7.95012 5.74876 7.95012 5.50023L7.95012 2.08638L9.18192 3.31819C9.35766 3.49392 9.64258 3.49392 9.81832 3.31819C9.99406 3.14245 9.99406 2.85753 9.81832 2.68179L7.81832 0.68179ZM7.95012 12.9136V9.50023C7.95012 9.2517 7.74865 9.05023 7.50012 9.05023C7.25159 9.05023 7.05012 9.2517 7.05012 9.50023V12.9136L5.81832 11.6818C5.64258 11.5061 5.35766 11.5061 5.18192 11.6818C5.00619 11.8575 5.00619 12.1424 5.18192 12.3182L7.18192 14.3182C7.26632 14.4026 7.38077 14.45 7.50012 14.45C7.61947 14.45 7.73393 14.4026 7.81832 14.3182L9.81832 12.3182C9.99406 12.1424 9.99406 11.8575 9.81832 11.6818C9.64258 11.5061 9.35766 11.5061 9.18192 11.6818L7.95012 12.9136ZM1.49994 7.00017C1.2238 7.00017 0.999939 7.22403 0.999939 7.50017C0.999939 7.77631 1.2238 8.00017 1.49994 8.00017L13.4999 8.00017C13.7761 8.00017 13.9999 7.77631 13.9999 7.50017C13.9999 7.22403 13.7761 7.00017 13.4999 7.00017L1.49994 7.00017Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3K = [
    "color"
];
var $c12e32cf04d921d4$export$472271f3e918e2f4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3K);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14 12.85L1 12.85L1 14.15L14 14.15L14 12.85ZM14 8.85002L1 8.85002L1 10.15L14 10.15L14 8.85002ZM1 4.85003L14 4.85003L14 6.15003L1 6.15002L1 4.85003ZM14 0.850025L1 0.850025L1 2.15002L14 2.15002L14 0.850025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3L = [
    "color"
];
var $c12e32cf04d921d4$export$c3403272e8c8becf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3L);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.5 4C0.223858 4 0 4.22386 0 4.5V10.5C0 10.7761 0.223858 11 0.5 11H14.5C14.7761 11 15 10.7761 15 10.5V4.5C15 4.22386 14.7761 4 14.5 4H0.5ZM1 10V5H2.075V7.5C2.075 7.73472 2.26528 7.925 2.5 7.925C2.73472 7.925 2.925 7.73472 2.925 7.5V5H4.075V6.5C4.075 6.73472 4.26528 6.925 4.5 6.925C4.73472 6.925 4.925 6.73472 4.925 6.5V5H6.075V6.5C6.075 6.73472 6.26528 6.925 6.5 6.925C6.73472 6.925 6.925 6.73472 6.925 6.5V5H8.075V7.5C8.075 7.73472 8.26528 7.925 8.5 7.925C8.73472 7.925 8.925 7.73472 8.925 7.5V5H10.075V6.5C10.075 6.73472 10.2653 6.925 10.5 6.925C10.7347 6.925 10.925 6.73472 10.925 6.5V5H12.075V6.5C12.075 6.73472 12.2653 6.925 12.5 6.925C12.7347 6.925 12.925 6.73472 12.925 6.5V5H14V10H1Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3M = [
    "color"
];
var $c12e32cf04d921d4$export$e940813548ac56bd = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3M);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.5 0C0.223858 0 0 0.223858 0 0.5V14.5C0 14.7761 0.223858 15 0.5 15H4.5C4.77614 15 5 14.7761 5 14.5V5H14.5C14.7761 5 15 4.77614 15 4.5V0.5C15 0.223858 14.7761 0 14.5 0H0.5ZM1 4.07505L1 1H4.07502C4.07502 1 4.07502 1 4.07502 1L4.07505 4.07507L1 4.07505ZM0.999997 4.92505L1 14H4V12.925H2.75002C2.5153 12.925 2.32502 12.7348 2.32502 12.5C2.32502 12.2653 2.5153 12.075 2.75002 12.075H4V10.925H2.25002C2.0153 10.925 1.82502 10.7347 1.82502 10.5C1.82502 10.2653 2.0153 10.075 2.25002 10.075H4V8.92504L2.75002 8.92502C2.5153 8.92502 2.32502 8.73474 2.32502 8.50002C2.32503 8.26529 2.51531 8.07502 2.75003 8.07502L4 8.07504V6.92502L2.74999 6.925C2.51527 6.925 2.325 6.73472 2.325 6.5C2.325 6.26528 2.51529 6.075 2.75001 6.075L4 6.07502V4.92507L0.999997 4.92505ZM4.92505 4H6.075V2.75006C6.075 2.51534 6.26528 2.32506 6.5 2.32506C6.73472 2.32506 6.925 2.51534 6.925 2.75006V4H8.07502V2.75005C8.07502 2.51533 8.2653 2.32505 8.50002 2.32505C8.73474 2.32505 8.92502 2.51533 8.92502 2.75005V4H10.0751V2.25005C10.0751 2.01533 10.2653 1.82505 10.5001 1.82505C10.7348 1.82505 10.9251 2.01533 10.9251 2.25005V4H12.0751V2.75005C12.0751 2.51533 12.2654 2.32505 12.5001 2.32505C12.7348 2.32505 12.9251 2.51533 12.9251 2.75005V4H14V1H4.92502L4.92505 4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3N = [
    "color"
];
var $c12e32cf04d921d4$export$ca010e7ed4ef0790 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3N);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.949988 4.48455C0.949988 5.34059 1.64395 6.03455 2.49999 6.03455C3.35603 6.03455 4.04999 5.34059 4.04999 4.48455C4.04999 3.6285 3.35603 2.93455 2.49999 2.93455C1.64395 2.93455 0.949988 3.6285 0.949988 4.48455ZM2.49999 6.93455C1.14689 6.93455 0.0499878 5.83764 0.0499878 4.48455C0.0499878 3.13145 1.14689 2.03455 2.49999 2.03455C3.85309 2.03455 4.94999 3.13145 4.94999 4.48455C4.94999 4.80813 4.88726 5.11707 4.77329 5.39985L5.73655 6.04413C5.72943 6.06656 5.72269 6.08914 5.71635 6.11188L5.56288 6.66186L5.21005 6.89773L4.21554 6.23366C3.77357 6.6672 3.168 6.93455 2.49999 6.93455ZM0.949991 10.5C0.949991 9.64394 1.64395 8.94998 2.49999 8.94998C3.35603 8.94998 4.04999 9.64394 4.04999 10.5C4.04999 11.356 3.35603 12.05 2.49999 12.05C1.64395 12.05 0.949991 11.356 0.949991 10.5ZM2.49999 8.04998C1.14689 8.04998 0.0499908 9.14688 0.0499908 10.5C0.0499908 11.8531 1.14689 12.95 2.49999 12.95C3.85309 12.95 4.94999 11.8531 4.94999 10.5C4.94999 10.1803 4.88877 9.87497 4.77743 9.595L15 2.75737L14.0486 2.85737C12.7077 2.9983 11.4091 3.40895 10.231 4.06461L7.15646 5.77564C6.92307 5.90553 6.75134 6.12339 6.67955 6.38066L6.42653 7.28737L4.22437 8.75957C3.78166 8.32091 3.17246 8.04998 2.49999 8.04998ZM7.14435 9.2149L7.15646 9.22176L10.231 10.9328C11.4091 11.5884 12.7077 11.9991 14.0486 12.14L15 12.24L8.81072 8.1003L7.14435 9.2149Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3O = [
    "color"
];
var $c12e32cf04d921d4$export$ab8815222a429372 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3O);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM2 5L2 10H13V5H2ZM2 4C1.44772 4 1 4.44772 1 5V10C1 10.5523 1.44772 11 2 11H13C13.5523 11 14 10.5523 14 10V5C14 4.44772 13.5523 4 13 4H2ZM1.5 14C1.77614 14 2 13.7761 2 13.5C2 13.2239 1.77614 13 1.5 13C1.22386 13 1 13.2239 1 13.5C1 13.7761 1.22386 14 1.5 14ZM4 1.5C4 1.77614 3.77614 2 3.5 2C3.22386 2 3 1.77614 3 1.5C3 1.22386 3.22386 1 3.5 1C3.77614 1 4 1.22386 4 1.5ZM3.5 14C3.77614 14 4 13.7761 4 13.5C4 13.2239 3.77614 13 3.5 13C3.22386 13 3 13.2239 3 13.5C3 13.7761 3.22386 14 3.5 14ZM6 1.5C6 1.77614 5.77614 2 5.5 2C5.22386 2 5 1.77614 5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5ZM5.5 14C5.77614 14 6 13.7761 6 13.5C6 13.2239 5.77614 13 5.5 13C5.22386 13 5 13.2239 5 13.5C5 13.7761 5.22386 14 5.5 14ZM8 1.5C8 1.77614 7.77614 2 7.5 2C7.22386 2 7 1.77614 7 1.5C7 1.22386 7.22386 1 7.5 1C7.77614 1 8 1.22386 8 1.5ZM7.5 14C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13C7.22386 13 7 13.2239 7 13.5C7 13.7761 7.22386 14 7.5 14ZM10 1.5C10 1.77614 9.77614 2 9.5 2C9.22386 2 9 1.77614 9 1.5C9 1.22386 9.22386 1 9.5 1C9.77614 1 10 1.22386 10 1.5ZM9.5 14C9.77614 14 10 13.7761 10 13.5C10 13.2239 9.77614 13 9.5 13C9.22386 13 9 13.2239 9 13.5C9 13.7761 9.22386 14 9.5 14ZM12 1.5C12 1.77614 11.7761 2 11.5 2C11.2239 2 11 1.77614 11 1.5C11 1.22386 11.2239 1 11.5 1C11.7761 1 12 1.22386 12 1.5ZM11.5 14C11.7761 14 12 13.7761 12 13.5C12 13.2239 11.7761 13 11.5 13C11.2239 13 11 13.2239 11 13.5C11 13.7761 11.2239 14 11.5 14ZM14 1.5C14 1.77614 13.7761 2 13.5 2C13.2239 2 13 1.77614 13 1.5C13 1.22386 13.2239 1 13.5 1C13.7761 1 14 1.22386 14 1.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3P = [
    "color"
];
var $c12e32cf04d921d4$export$9a1f3409566e1d35 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3P);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6 3.5C6 2.67157 6.67157 2 7.5 2C8.32843 2 9 2.67157 9 3.5C9 4.32843 8.32843 5 7.5 5C6.67157 5 6 4.32843 6 3.5ZM8 5.94999C9.14112 5.71836 10 4.70948 10 3.5C10 2.11929 8.88071 1 7.5 1C6.11929 1 5 2.11929 5 3.5C5 4.70948 5.85888 5.71836 7 5.94999V13.5C7 13.7761 7.22386 14 7.5 14C7.77614 14 8 13.7761 8 13.5V5.94999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3Q = [
    "color"
];
var $c12e32cf04d921d4$export$8217100f92ae3d76 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3Q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10 3.5C10 4.70948 9.14112 5.71836 8 5.94999V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.94999C5.85888 5.71836 5 4.70948 5 3.5C5 2.11929 6.11929 1 7.5 1C8.88071 1 10 2.11929 10 3.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3R = [
    "color"
];
var $c12e32cf04d921d4$export$30dea8f5f241e3b3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3R);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        opacity: ".05",
        d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".1",
        d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".15",
        d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".2",
        d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".25",
        d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".3",
        d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".35",
        d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".4",
        d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".45",
        d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".5",
        d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3S = [
    "color"
];
var $c12e32cf04d921d4$export$c7400a1254b7566e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3S);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        opacity: ".05",
        d: "M12.1619 3.85182C8.35817 4.88918 4.88936 8.358 3.85199 12.1617L3.3696 12.0301C4.45356 8.05564 8.05581 4.45339 12.0303 3.36943L12.1619 3.85182Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".1",
        d: "M11.8807 3.42707C8.03441 4.50542 4.50561 8.03422 3.42726 11.8805L2.94582 11.7456C4.07129 7.73121 7.7314 4.0711 11.7458 2.94563L11.8807 3.42707Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".15",
        d: "M11.5201 3.02556C7.69092 4.16199 4.16779 7.68323 3.02805 11.512L2.54883 11.3694C3.73676 7.37869 7.38659 3.73076 11.3778 2.54623L11.5201 3.02556Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".2",
        d: "M11.0468 2.66169C7.31117 3.87664 3.87918 7.3079 2.66298 11.0434L2.18754 10.8886C3.45324 7.00109 7.00445 3.45062 10.8921 2.18621L11.0468 2.66169Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".25",
        d: "M10.5201 2.32365C6.92091 3.61447 3.62391 6.90876 2.32845 10.5073L1.858 10.338C3.20398 6.59909 6.61155 3.19424 10.3513 1.85301L10.5201 2.32365Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".3",
        d: "M9.90222 2.03122C6.50003 3.39465 3.39968 6.49367 2.03399 9.89551L1.56998 9.70924C2.98651 6.18076 6.18728 2.98133 9.71622 1.5671L9.90222 2.03122Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".35",
        d: "M9.20727 1.78873C6.06136 3.20349 3.21103 6.05203 1.79331 9.19738L1.33747 8.99192C2.80536 5.73528 5.74485 2.7976 9.0022 1.33272L9.20727 1.78873Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".4",
        d: "M8.40713 1.62085C5.59323 3.05117 3.05794 5.58509 1.62544 8.39847L1.17987 8.1716C2.66036 5.26397 5.27232 2.6534 8.18057 1.17513L8.40713 1.62085Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".45",
        d: "M7.46207 1.56747C5.08689 2.94695 2.95362 5.07912 1.57249 7.45379L1.14028 7.20241C2.56503 4.75273 4.7607 2.55818 7.21096 1.1351L7.46207 1.56747Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".5",
        d: "M6.30407 1.70487C4.51964 2.91063 2.90983 4.52061 1.7043 6.30513L1.28998 6.02524C2.5313 4.18773 4.18673 2.53214 6.02413 1.29059L6.30407 1.70487Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3T = [
    "color"
];
var $c12e32cf04d921d4$export$126350cae9fbd558 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3T);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        opacity: ".05",
        d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".1",
        d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".15",
        d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".2",
        d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".25",
        d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".3",
        d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".35",
        d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".4",
        d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".45",
        d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".5",
        d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 9.1488 1.47969 10.657 2.4767 11.8162L1.64647 12.6464C1.45121 12.8417 1.45121 13.1583 1.64647 13.3535C1.84173 13.5488 2.15832 13.5488 2.35358 13.3535L3.18383 12.5233C4.34302 13.5202 5.8511 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34298 12.5233 3.1838L13.3536 2.35355C13.5488 2.15829 13.5488 1.8417 13.3536 1.64644C13.1583 1.45118 12.8417 1.45118 12.6465 1.64644L11.8162 2.47667C10.657 1.47966 9.14883 0.877045 7.49991 0.877045ZM11.1423 3.15065C10.1568 2.32449 8.88644 1.82704 7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 8.88641 2.32452 10.1568 3.15069 11.1422L11.1423 3.15065ZM3.85781 11.8493C4.84322 12.6753 6.11348 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11345 12.6754 4.84319 11.8493 3.85778L3.85781 11.8493Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3U = [
    "color"
];
var $c12e32cf04d921d4$export$a3edb785270158f1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3U);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        opacity: ".05",
        d: "M12.1398 3.88617C13.8553 4.94159 15 6.83701 15 9.00001C15 12.3137 12.3137 15 9.00002 15C6.84351 15 4.95296 13.8621 3.89569 12.1552L4.32076 11.8919C5.29069 13.4578 7.02376 14.5 9.00002 14.5C12.0376 14.5 14.5 12.0375 14.5 9.00001C14.5 7.01781 13.4516 5.28027 11.8778 4.31203L12.1398 3.88617Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".2",
        d: "M12.851 5.07321C13.8684 6.07106 14.5 7.46199 14.5 9C14.5 12.0375 12.0376 14.5 9.00004 14.5C7.46215 14.5 6.07132 13.8685 5.07349 12.8513L5.43043 12.5011C6.3381 13.4264 7.60186 14 9.00004 14C11.7614 14 14 11.7614 14 9C14 7.60171 13.4264 6.33786 12.5009 5.43017L12.851 5.07321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".35",
        d: "M13.3022 6.45071C13.7455 7.19737 14 8.06935 14 9.00001C14 11.7614 11.7614 14 9.00002 14C8.04868 14 7.15868 13.7341 6.40118 13.2724L6.66142 12.8454C7.34275 13.2607 8.14306 13.5 9.00002 13.5C11.4853 13.5 13.5 11.4853 13.5 9.00001C13.5 8.16165 13.271 7.37754 12.8722 6.70599L13.3022 6.45071Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".5",
        d: "M13.3745 7.94022C13.4566 8.28031 13.5 8.63525 13.5 9.00001C13.5 11.4853 11.4853 13.5 9.00003 13.5C8.61104 13.5 8.23323 13.4506 7.87268 13.3576L7.99759 12.8734C8.31768 12.956 8.65353 13 9.00003 13C11.2091 13 13 11.2091 13 9.00001C13 8.67509 12.9613 8.35953 12.8884 8.05757L13.3745 7.94022Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        opacity: ".65",
        d: "M12.9155 9.82133C12.5898 11.3813 11.3562 12.6072 9.79205 12.9215L9.69354 12.4313C11.0613 12.1565 12.1413 11.0834 12.4261 9.71915L12.9155 9.82133Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }), (0, $exYeM.createElement)("path", {
        d: "M1.2771 7.50253C1.2771 4.06456 4.06413 1.27753 7.5021 1.27753C10.94 1.27753 13.7271 4.06456 13.7271 7.50253C13.7271 10.9405 10.94 13.7275 7.5021 13.7275C4.06413 13.7275 1.2771 10.9405 1.2771 7.50253ZM7.5021 2.22753C4.5888 2.22753 2.2271 4.58923 2.2271 7.50253C2.2271 10.4158 4.5888 12.7775 7.5021 12.7775C10.4154 12.7775 12.7771 10.4158 12.7771 7.50253C12.7771 4.58923 10.4154 2.22753 7.5021 2.22753Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3V = [
    "color"
];
var $c12e32cf04d921d4$export$fe819ae1b3a84d32 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3V);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 7.50003C5 8.32845 4.32843 9.00003 3.5 9.00003C2.67157 9.00003 2 8.32845 2 7.50003C2 6.6716 2.67157 6.00003 3.5 6.00003C4.32843 6.00003 5 6.6716 5 7.50003ZM5.71313 8.66388C5.29445 9.45838 4.46048 10 3.5 10C2.11929 10 1 8.88074 1 7.50003C1 6.11931 2.11929 5.00003 3.5 5.00003C4.46048 5.00003 5.29445 5.54167 5.71313 6.33616L9.10424 4.21671C9.03643 3.98968 9 3.74911 9 3.50003C9 2.11932 10.1193 1.00003 11.5 1.00003C12.8807 1.00003 14 2.11932 14 3.50003C14 4.88074 12.8807 6.00003 11.5 6.00003C10.6915 6.00003 9.97264 5.61624 9.51566 5.0209L5.9853 7.22738C5.99502 7.31692 6 7.40789 6 7.50003C6 7.59216 5.99502 7.68312 5.9853 7.77267L9.51567 9.97915C9.97265 9.38382 10.6915 9.00003 11.5 9.00003C12.8807 9.00003 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5C9 11.2509 9.03643 11.0104 9.10425 10.7833L5.71313 8.66388ZM11.5 5.00003C12.3284 5.00003 13 4.32846 13 3.50003C13 2.6716 12.3284 2.00003 11.5 2.00003C10.6716 2.00003 10 2.6716 10 3.50003C10 4.32846 10.6716 5.00003 11.5 5.00003ZM13 11.5C13 12.3285 12.3284 13 11.5 13C10.6716 13 10 12.3285 10 11.5C10 10.6716 10.6716 10 11.5 10C12.3284 10 13 10.6716 13 11.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3W = [
    "color"
];
var $c12e32cf04d921d4$export$fd8d21248a547675 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3W);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.5 5.00006C3.22386 5.00006 3 5.22392 3 5.50006L3 11.5001C3 11.7762 3.22386 12.0001 3.5 12.0001L11.5 12.0001C11.7761 12.0001 12 11.7762 12 11.5001L12 5.50006C12 5.22392 11.7761 5.00006 11.5 5.00006L10.25 5.00006C9.97386 5.00006 9.75 4.7762 9.75 4.50006C9.75 4.22392 9.97386 4.00006 10.25 4.00006L11.5 4.00006C12.3284 4.00006 13 4.67163 13 5.50006L13 11.5001C13 12.3285 12.3284 13.0001 11.5 13.0001L3.5 13.0001C2.67157 13.0001 2 12.3285 2 11.5001L2 5.50006C2 4.67163 2.67157 4.00006 3.5 4.00006L4.75 4.00006C5.02614 4.00006 5.25 4.22392 5.25 4.50006C5.25 4.7762 5.02614 5.00006 4.75 5.00006L3.5 5.00006ZM7 1.6364L5.5682 3.0682C5.39246 3.24393 5.10754 3.24393 4.9318 3.0682C4.75607 2.89246 4.75607 2.60754 4.9318 2.4318L7.1818 0.181802C7.26619 0.09741 7.38065 0.049999 7.5 0.049999C7.61935 0.049999 7.73381 0.09741 7.8182 0.181802L10.0682 2.4318C10.2439 2.60754 10.2439 2.89246 10.0682 3.0682C9.89246 3.24393 9.60754 3.24393 9.4318 3.0682L8 1.6364L8 8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5L7 1.6364Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3X = [
    "color"
];
var $c12e32cf04d921d4$export$f584b8d6931467fb = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3X);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M12.3536 1.14645C12.1583 0.951184 11.8417 0.951184 11.6464 1.14645C11.4512 1.34171 11.4512 1.65829 11.6464 1.85355L12.7929 3H12C10.7037 3 9.71111 3.58423 8.87248 4.38931C8.20065 5.03427 7.59349 5.85684 6.99461 6.6682C6.86287 6.84668 6.73154 7.02462 6.6 7.2C5.10874 9.18835 3.49037 11 0.5 11C0.223858 11 0 11.2239 0 11.5C0 11.7761 0.223858 12 0.5 12C4.00963 12 5.89126 9.81165 7.4 7.8C7.54367 7.60845 7.6832 7.41962 7.81996 7.23454L7.82005 7.23443L7.82006 7.23441C8.41674 6.42695 8.96069 5.69085 9.56502 5.11069C10.2889 4.41577 11.0463 4 12 4H12.7929L11.6464 5.14645C11.4512 5.34171 11.4512 5.65829 11.6464 5.85355C11.8417 6.04882 12.1583 6.04882 12.3536 5.85355L14.3536 3.85355C14.5488 3.65829 14.5488 3.34171 14.3536 3.14645L12.3536 1.14645ZM0.5 3C3.35278 3 5.12992 4.44588 6.50548 6.06746L6.3762 6.24266C6.2483 6.4161 6.12293 6.58609 6 6.75C5.96397 6.79804 5.92798 6.84581 5.892 6.89331C4.57348 5.29306 3.02637 4 0.5 4C0.223858 4 0 3.77614 0 3.5C0 3.22386 0.223858 3 0.5 3ZM8.87248 10.6107C8.37284 10.131 7.90897 9.55314 7.45767 8.95468C7.64688 8.71693 7.82704 8.48061 8 8.25L8.08987 8.12987C8.58412 8.79402 9.05288 9.39766 9.56502 9.88931C10.2889 10.5842 11.0463 11 12 11H12.7929L11.6464 9.85355C11.4512 9.65829 11.4512 9.34171 11.6464 9.14645C11.8417 8.95118 12.1583 8.95118 12.3536 9.14645L14.3536 11.1464C14.5488 11.3417 14.5488 11.6583 14.3536 11.8536L12.3536 13.8536C12.1583 14.0488 11.8417 14.0488 11.6464 13.8536C11.4512 13.6583 11.4512 13.3417 11.6464 13.1464L12.7929 12H12C10.7037 12 9.71111 11.4158 8.87248 10.6107Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3Y = [
    "color"
];
var $c12e32cf04d921d4$export$9b9cddf895f6c38e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3Y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M11.5 3.04999C11.7485 3.04999 11.95 3.25146 11.95 3.49999V7.49999C11.95 7.74852 11.7485 7.94999 11.5 7.94999C11.2515 7.94999 11.05 7.74852 11.05 7.49999V4.58639L4.58638 11.05H7.49999C7.74852 11.05 7.94999 11.2515 7.94999 11.5C7.94999 11.7485 7.74852 11.95 7.49999 11.95L3.49999 11.95C3.38064 11.95 3.26618 11.9026 3.18179 11.8182C3.0974 11.7338 3.04999 11.6193 3.04999 11.5L3.04999 7.49999C3.04999 7.25146 3.25146 7.04999 3.49999 7.04999C3.74852 7.04999 3.94999 7.25146 3.94999 7.49999L3.94999 10.4136L10.4136 3.94999L7.49999 3.94999C7.25146 3.94999 7.04999 3.74852 7.04999 3.49999C7.04999 3.25146 7.25146 3.04999 7.49999 3.04999L11.5 3.04999Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3Z = [
    "color"
];
var $c12e32cf04d921d4$export$5881b38319b9ceb7 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3Z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.53731 0.826873C7.5125 0.824392 7.4875 0.824392 7.46269 0.826873L3.96269 1.17687C3.85672 1.18747 3.76025 1.24262 3.69736 1.32857L0.699771 5.42528C0.654046 5.48627 0.62647 5.56165 0.625057 5.6434C0.625019 5.6456 0.625 5.64781 0.625 5.65001C0.625 5.65052 0.625001 5.65103 0.625003 5.65153C0.625363 5.74237 0.658021 5.82559 0.712087 5.8903L7.21042 13.7883C7.28165 13.8749 7.38789 13.925 7.5 13.925C7.61211 13.925 7.71835 13.8749 7.78958 13.7883L14.2879 5.89031C14.342 5.8256 14.3746 5.74237 14.375 5.65153C14.375 5.65103 14.375 5.65052 14.375 5.65001C14.375 5.64849 14.375 5.64697 14.375 5.64545C14.3749 5.63963 14.3747 5.63382 14.3744 5.62801C14.37 5.55219 14.3431 5.48242 14.3002 5.42527L11.3026 1.32857C11.2397 1.24262 11.1433 1.18747 11.0373 1.17687L7.53731 0.826873ZM10.925 5.27501V5.25236L10.9223 5.27501H10.925ZM10.9342 5.17498H13.1877L11.2495 2.5261L10.9342 5.17498ZM10.5707 1.88395L8.04432 1.63131L10.1747 5.21034L10.5707 1.88395ZM6.95568 1.63131L4.42931 1.88395L4.82531 5.21034L6.95568 1.63131ZM3.75046 2.5261L1.81226 5.17498H4.0658L3.75046 2.5261ZM1.79416 6.02501L6.75861 12.0587L4.22371 6.0669C4.21787 6.0531 4.21314 6.0391 4.20949 6.02501H1.79416ZM5.15055 6.02501L7.49999 12.1085L9.84943 6.02501H9.78681H5.21319H5.15055ZM10.7905 6.02501C10.7869 6.0391 10.7821 6.0531 10.7763 6.0669L8.24139 12.0587L13.2058 6.02501H10.7905ZM7.5 2.18317L9.34038 5.27501H5.65962L7.5 2.18317Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3_ = [
    "color"
];
var $c12e32cf04d921d4$export$fab36db504d71648 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3_);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.10876 14L9.46582 1H10.8178L5.46074 14H4.10876Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$3$ = [
    "color"
];
var $c12e32cf04d921d4$export$c1a54868c36d9c70 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$3$);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10.3004 7.49991C10.3004 8.4943 9.49426 9.30041 8.49988 9.30041C7.50549 9.30041 6.69938 8.4943 6.69938 7.49991C6.69938 6.50553 7.50549 5.69942 8.49988 5.69942C9.49426 5.69942 10.3004 6.50553 10.3004 7.49991ZM11.205 8C10.9699 9.28029 9.84816 10.2504 8.49988 10.2504C7.1516 10.2504 6.0299 9.28029 5.79473 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H5.7947C6.0298 5.71962 7.15154 4.74942 8.49988 4.74942C9.84822 4.74942 10.97 5.71962 11.2051 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H11.205Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$40 = [
    "color"
];
var $c12e32cf04d921d4$export$389ac29f15551cc = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$40);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14.4999 0.999994C14.2237 0.999994 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L9.99992 5.99995C9.44764 5.99995 8.99993 6.44766 8.99993 6.99994L8.99993 7.99994C8.99993 8.55222 9.44764 8.99993 9.99992 8.99993L13.9999 8.99993L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999994 14.4999 0.999994ZM4.99996 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999994 0.499996 0.999994C0.223856 0.999994 -9.7852e-09 1.22385 -2.18557e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99993L4.99996 8.99993C5.55224 8.99993 5.99995 8.55222 5.99995 7.99993L5.99995 6.99994C5.99995 6.44766 5.55224 5.99995 4.99996 5.99995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$41 = [
    "color"
];
var $c12e32cf04d921d4$export$d6c80469522241f6 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$41);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1L9 1V5C9 5.55228 8.55228 6 8 6H7C6.44772 6 6 5.55228 6 5V1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 9C6.44772 9 6 9.44771 6 10V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9V10C9 9.44772 8.55228 9 8 9H7Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$42 = [
    "color"
];
var $c12e32cf04d921d4$export$d569b77eb092ec4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$42);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992ZM0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992ZM1.99998 6.99994C1.99998 6.44766 2.44769 5.99995 2.99998 5.99995L5.99995 5.99995C6.55223 5.99995 6.99994 6.44766 6.99994 6.99994L6.99994 7.99993C6.99994 8.55221 6.55223 8.99992 5.99995 8.99992L2.99998 8.99992C2.4477 8.99992 1.99998 8.55221 1.99998 7.99993L1.99998 6.99994ZM8.99993 5.99995C8.44765 5.99995 7.99993 6.44766 7.99993 6.99994L7.99993 7.99993C7.99993 8.55221 8.44765 8.99992 8.99993 8.99992L11.9999 8.99992C12.5522 8.99992 12.9999 8.55221 12.9999 7.99993L12.9999 6.99994C12.9999 6.44766 12.5522 5.99995 11.9999 5.99995L8.99993 5.99995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$43 = [
    "color"
];
var $c12e32cf04d921d4$export$7b2a11c2d6945102 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$43);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 2C6.44772 2 6 2.44772 6 3V6C6 6.55228 6.44772 7 7 7H8C8.55228 7 9 6.55228 9 6V3C9 2.44772 8.55228 2 8 2H7ZM7 8C6.44772 8 6 8.44771 6 9V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V9C9 8.44772 8.55228 8 8 8H7ZM1.49988 14C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H1.49988Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$44 = [
    "color"
];
var $c12e32cf04d921d4$export$7fee6559072912ad = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$44);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.46968 1.05085C7.64122 1.13475 7.75 1.30904 7.75 1.5V13.5C7.75 13.691 7.64122 13.8653 7.46968 13.9492C7.29813 14.0331 7.09377 14.0119 6.94303 13.8947L3.2213 11H1.5C0.671571 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.2213L6.94303 1.10533C7.09377 0.988085 7.29813 0.966945 7.46968 1.05085ZM6.75 2.52232L3.69983 4.89468C3.61206 4.96294 3.50405 5 3.39286 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77615 1.22386 10 1.5 10H3.39286C3.50405 10 3.61206 10.0371 3.69983 10.1053L6.75 12.4777V2.52232ZM10.2784 3.84804C10.4623 3.72567 10.7106 3.77557 10.833 3.95949C12.2558 6.09798 12.2558 8.90199 10.833 11.0405C10.7106 11.2244 10.4623 11.2743 10.2784 11.1519C10.0944 11.0296 10.0445 10.7813 10.1669 10.5973C11.4111 8.72728 11.4111 6.27269 10.1669 4.40264C10.0445 4.21871 10.0944 3.97041 10.2784 3.84804ZM12.6785 1.43044C12.5356 1.2619 12.2832 1.24104 12.1147 1.38386C11.9462 1.52667 11.9253 1.77908 12.0681 1.94762C14.7773 5.14488 14.7773 9.85513 12.0681 13.0524C11.9253 13.2209 11.9462 13.4733 12.1147 13.6161C12.2832 13.759 12.5356 13.7381 12.6785 13.5696C15.6406 10.0739 15.6406 4.92612 12.6785 1.43044Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$45 = [
    "color"
];
var $c12e32cf04d921d4$export$a45f43fe1bacf3af = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$45);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.833 3.95949C10.7106 3.77557 10.4623 3.72567 10.2784 3.84804C10.0944 3.97041 10.0445 4.21871 10.1669 4.40264C11.4111 6.27268 11.4111 8.72728 10.1669 10.5973C10.0445 10.7813 10.0944 11.0296 10.2784 11.1519C10.4623 11.2743 10.7106 11.2244 10.833 11.0405C12.2558 8.90199 12.2558 6.09798 10.833 3.95949Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$46 = [
    "color"
];
var $c12e32cf04d921d4$export$9ea4d02db3207a8b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$46);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.72361 1.05279C7.893 1.13749 8 1.31062 8 1.5V13.5C8 13.6894 7.893 13.8625 7.72361 13.9472C7.55421 14.0319 7.35151 14.0136 7.2 13.9L3.33333 11H1.5C0.671573 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.33333L7.2 1.1C7.35151 0.986371 7.55421 0.968093 7.72361 1.05279ZM7 2.5L3.8 4.9C3.71345 4.96491 3.60819 5 3.5 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77614 1.22386 10 1.5 10H3.5C3.60819 10 3.71345 10.0351 3.8 10.1L7 12.5V2.5ZM14.8536 5.14645C15.0488 5.34171 15.0488 5.65829 14.8536 5.85355L13.2071 7.5L14.8536 9.14645C15.0488 9.34171 15.0488 9.65829 14.8536 9.85355C14.6583 10.0488 14.3417 10.0488 14.1464 9.85355L12.5 8.20711L10.8536 9.85355C10.6583 10.0488 10.3417 10.0488 10.1464 9.85355C9.95118 9.65829 9.95118 9.34171 10.1464 9.14645L11.7929 7.5L10.1464 5.85355C9.95118 5.65829 9.95118 5.34171 10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645L12.5 6.79289L14.1464 5.14645C14.3417 4.95118 14.6583 4.95118 14.8536 5.14645Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$47 = [
    "color"
];
var $c12e32cf04d921d4$export$c28fae3b5b7c9a0b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$47);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.083 5.05577C9.96066 4.87185 9.71235 4.82195 9.52843 4.94432C9.3445 5.06669 9.2946 5.31499 9.41697 5.49892C10.2207 6.70693 10.2207 8.29303 9.41697 9.50104C9.2946 9.68496 9.3445 9.93326 9.52843 10.0556C9.71235 10.178 9.96066 10.1281 10.083 9.94418C11.0653 8.46773 11.0653 6.53222 10.083 5.05577Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$48 = [
    "color"
];
var $c12e32cf04d921d4$export$c19d0dc844f6640 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$48);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 1H1.5H13.5H14V1.5V13.5V14H13.5H1.5H1V13.5V1.5V1ZM2 2V13H13V2H2Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$49 = [
    "color"
];
var $c12e32cf04d921d4$export$f95b8a41f9121b54 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$49);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.75432 1.81954C7.59742 1.72682 7.4025 1.72682 7.24559 1.81954L1.74559 5.06954C1.59336 5.15949 1.49996 5.32317 1.49996 5.5C1.49996 5.67683 1.59336 5.84051 1.74559 5.93046L7.24559 9.18046C7.4025 9.27318 7.59742 9.27318 7.75432 9.18046L13.2543 5.93046C13.4066 5.84051 13.5 5.67683 13.5 5.5C13.5 5.32317 13.4066 5.15949 13.2543 5.06954L7.75432 1.81954ZM7.49996 8.16923L2.9828 5.5L7.49996 2.83077L12.0171 5.5L7.49996 8.16923ZM2.25432 8.31954C2.01658 8.17906 1.70998 8.2579 1.56949 8.49564C1.42901 8.73337 1.50785 9.03998 1.74559 9.18046L7.24559 12.4305C7.4025 12.5232 7.59742 12.5232 7.75432 12.4305L13.2543 9.18046C13.4921 9.03998 13.5709 8.73337 13.4304 8.49564C13.2899 8.2579 12.9833 8.17906 12.7456 8.31954L7.49996 11.4192L2.25432 8.31954Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4a = [
    "color"
];
var $c12e32cf04d921d4$export$2ee28caa7f1e962e = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4a);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.97942 1.25171L6.9585 1.30199L5.58662 4.60039C5.54342 4.70426 5.44573 4.77523 5.3336 4.78422L1.7727 5.0697L1.71841 5.07405L1.38687 5.10063L1.08608 5.12475C0.820085 5.14607 0.712228 5.47802 0.914889 5.65162L1.14406 5.84793L1.39666 6.06431L1.43802 6.09974L4.15105 8.42374C4.23648 8.49692 4.2738 8.61176 4.24769 8.72118L3.41882 12.196L3.40618 12.249L3.32901 12.5725L3.25899 12.866C3.19708 13.1256 3.47945 13.3308 3.70718 13.1917L3.9647 13.0344L4.24854 12.861L4.29502 12.8326L7.34365 10.9705C7.43965 10.9119 7.5604 10.9119 7.6564 10.9705L10.705 12.8326L10.7515 12.861L11.0354 13.0344L11.2929 13.1917C11.5206 13.3308 11.803 13.1256 11.7411 12.866L11.671 12.5725L11.5939 12.249L11.5812 12.196L10.7524 8.72118C10.7263 8.61176 10.7636 8.49692 10.849 8.42374L13.562 6.09974L13.6034 6.06431L13.856 5.84793L14.0852 5.65162C14.2878 5.47802 14.18 5.14607 13.914 5.12475L13.6132 5.10063L13.2816 5.07405L13.2274 5.0697L9.66645 4.78422C9.55432 4.77523 9.45663 4.70426 9.41343 4.60039L8.04155 1.30199L8.02064 1.25171L7.89291 0.944609L7.77702 0.665992C7.67454 0.419604 7.32551 0.419604 7.22303 0.665992L7.10715 0.944609L6.97942 1.25171ZM7.50003 2.60397L6.50994 4.98442C6.32273 5.43453 5.89944 5.74207 5.41351 5.78103L2.84361 5.98705L4.8016 7.66428C5.17183 7.98142 5.33351 8.47903 5.2204 8.95321L4.62221 11.461L6.8224 10.1171C7.23842 9.86302 7.76164 9.86302 8.17766 10.1171L10.3778 11.461L9.77965 8.95321C9.66654 8.47903 9.82822 7.98142 10.1984 7.66428L12.1564 5.98705L9.58654 5.78103C9.10061 5.74207 8.67732 5.43453 8.49011 4.98442L7.50003 2.60397Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4b = [
    "color"
];
var $c12e32cf04d921d4$export$b9957ed2bd2cc18b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4b);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$4c = [
    "color"
];
var $c12e32cf04d921d4$export$fa3807a0e988146 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4c);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.84998 7.49998C1.84998 7.21321 1.87134 6.93143 1.91256 6.65615L9.56374 2.23875C9.86311 2.35627 10.15 2.49861 10.4219 2.66322L3.77065 6.50332C3.73669 6.52183 3.70482 6.5449 3.67602 6.57238C3.5911 6.65308 3.54245 6.76286 3.53682 6.87658C3.53359 6.9418 3.54451 7.00831 3.57086 7.07137C3.58927 7.1157 3.6149 7.15742 3.64744 7.19458C3.67306 7.22396 3.702 7.24941 3.73337 7.27069L7.32533 9.83813L3.87232 11.8317C2.63604 10.7953 1.84998 9.23944 1.84998 7.49998ZM8.36843 10.2751C8.37682 10.2706 8.38509 10.2659 8.39322 10.2608L9.84091 9.42499C9.84706 9.42163 9.85314 9.41812 9.85915 9.41446L11.3101 8.57677C11.3655 8.54649 11.4154 8.504 11.4554 8.44995C11.6034 8.25031 11.5616 7.96848 11.362 7.82046L7.82779 5.20017L11.2161 3.24393C12.4013 4.27963 13.15 5.80237 13.15 7.49998C13.15 7.83546 13.1207 8.16411 13.0647 8.48353L5.56875 12.8113C5.26138 12.6995 4.96646 12.5618 4.68662 12.4008L8.36843 10.2751ZM8.18149 9.34383L4.81659 6.93868L5.50918 6.53881L8.80604 8.98324L8.18149 9.34383ZM6.35875 6.04832L6.97822 5.69067L10.2751 8.13506L9.6556 8.49275L6.35875 6.04832ZM8.3318 1.91078L2.24263 5.42636C3.06941 3.33188 5.11164 1.84998 7.49998 1.84998C7.78258 1.84998 8.06033 1.87072 8.3318 1.91078ZM6.84684 13.1126C7.06114 13.1373 7.27908 13.15 7.49998 13.15C9.8246 13.15 11.8213 11.7461 12.6886 9.7399L6.84684 13.1126ZM7.49998 0.849976C3.82728 0.849976 0.849976 3.82728 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4d = [
    "color"
];
var $c12e32cf04d921d4$export$dc6949a98411e916 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4d);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 3C2 2.44772 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44772 13 2 12.5523 2 12V3ZM12 3H3V12H12V3Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4e = [
    "color"
];
var $c12e32cf04d921d4$export$93c9322cdb01abe0 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4e);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L11.858 2.25806C12.1021 2.01398 12.4978 2.01398 12.7419 2.25806C12.986 2.50214 12.986 2.89786 12.7419 3.14194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13362 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.99998 4.5C7.99998 4.22386 7.77612 4 7.49998 4C7.22383 4 6.99998 4.22386 6.99998 4.5V9.5C6.99998 9.77614 7.22383 10 7.49998 10C7.77612 10 7.99998 9.77614 7.99998 9.5V4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4f = [
    "color"
];
var $c12e32cf04d921d4$export$672f8b757251d92b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4f);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99992L13.9999 8.99992L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4g = [
    "color"
];
var $c12e32cf04d921d4$export$dd3bd56329b5fe85 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4g);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H6H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM9 14V1L6 1V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4h = [
    "color"
];
var $c12e32cf04d921d4$export$25ec4ecc9c5701a5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4h);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.00003 3.25C5.00003 2.97386 4.77617 2.75 4.50003 2.75C4.22389 2.75 4.00003 2.97386 4.00003 3.25V7.10003H2.49998C2.27906 7.10003 2.09998 7.27912 2.09998 7.50003C2.09998 7.72094 2.27906 7.90003 2.49998 7.90003H4.00003V8.55C4.00003 10.483 5.56703 12.05 7.50003 12.05C9.43303 12.05 11 10.483 11 8.55V7.90003H12.5C12.7209 7.90003 12.9 7.72094 12.9 7.50003C12.9 7.27912 12.7209 7.10003 12.5 7.10003H11V3.25C11 2.97386 10.7762 2.75 10.5 2.75C10.2239 2.75 10 2.97386 10 3.25V7.10003H5.00003V3.25ZM5.00003 7.90003V8.55C5.00003 9.93071 6.11932 11.05 7.50003 11.05C8.88074 11.05 10 9.93071 10 8.55V7.90003H5.00003Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4i = [
    "color"
];
var $c12e32cf04d921d4$export$cd27c497b93dbe8d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4i);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V0.5C7 0.223858 7.22386 0 7.5 0ZM2.1967 2.1967C2.39196 2.00144 2.70854 2.00144 2.90381 2.1967L4.31802 3.61091C4.51328 3.80617 4.51328 4.12276 4.31802 4.31802C4.12276 4.51328 3.80617 4.51328 3.61091 4.31802L2.1967 2.90381C2.00144 2.70854 2.00144 2.39196 2.1967 2.1967ZM0.5 7C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H2.5C2.77614 8 3 7.77614 3 7.5C3 7.22386 2.77614 7 2.5 7H0.5ZM2.1967 12.8033C2.00144 12.608 2.00144 12.2915 2.1967 12.0962L3.61091 10.682C3.80617 10.4867 4.12276 10.4867 4.31802 10.682C4.51328 10.8772 4.51328 11.1938 4.31802 11.3891L2.90381 12.8033C2.70854 12.9986 2.39196 12.9986 2.1967 12.8033ZM12.5 7C12.2239 7 12 7.22386 12 7.5C12 7.77614 12.2239 8 12.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12.5ZM10.682 4.31802C10.4867 4.12276 10.4867 3.80617 10.682 3.61091L12.0962 2.1967C12.2915 2.00144 12.608 2.00144 12.8033 2.1967C12.9986 2.39196 12.9986 2.70854 12.8033 2.90381L11.3891 4.31802C11.1938 4.51328 10.8772 4.51328 10.682 4.31802ZM8 12.5C8 12.2239 7.77614 12 7.5 12C7.22386 12 7 12.2239 7 12.5V14.5C7 14.7761 7.22386 15 7.5 15C7.77614 15 8 14.7761 8 14.5V12.5ZM10.682 10.682C10.8772 10.4867 11.1938 10.4867 11.3891 10.682L12.8033 12.0962C12.9986 12.2915 12.9986 12.608 12.8033 12.8033C12.608 12.9986 12.2915 12.9986 12.0962 12.8033L10.682 11.3891C10.4867 11.1938 10.4867 10.8772 10.682 10.682ZM5.5 7.5C5.5 6.39543 6.39543 5.5 7.5 5.5C8.60457 5.5 9.5 6.39543 9.5 7.5C9.5 8.60457 8.60457 9.5 7.5 9.5C6.39543 9.5 5.5 8.60457 5.5 7.5ZM7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 5.84315 10.5 7.5 10.5C9.15685 10.5 10.5 9.15685 10.5 7.5C10.5 5.84315 9.15685 4.5 7.5 4.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4j = [
    "color"
];
var $c12e32cf04d921d4$export$381bc0c1798a0082 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4j);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4ZM7.67133 11C6.65183 10.175 6 8.91363 6 7.5C6 6.08637 6.65183 4.82498 7.67133 4H4.5C2.567 4 1 5.567 1 7.5C1 9.433 2.567 11 4.5 11H7.67133ZM0 7.5C0 5.01472 2.01472 3 4.5 3H10.5C12.9853 3 15 5.01472 15 7.5C15 9.98528 12.9853 12 10.5 12H4.5C2.01472 12 0 9.98528 0 7.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4k = [
    "color"
];
var $c12e32cf04d921d4$export$b6fcc44f764b8899 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4k);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4l = [
    "color"
];
var $c12e32cf04d921d4$export$560b0277c649ed6b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4l);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8 2H12.5C12.7761 2 13 2.22386 13 2.5V5H8V2ZM7 5V2H2.5C2.22386 2 2 2.22386 2 2.5V5H7ZM2 6V9H7V6H2ZM8 6H13V9H8V6ZM8 10H13V12.5C13 12.7761 12.7761 13 12.5 13H8V10ZM2 12.5V10H7V13H2.5C2.22386 13 2 12.7761 2 12.5ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4m = [
    "color"
];
var $c12e32cf04d921d4$export$aea5b1a1d88a7a75 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4m);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.900024 7.50002C0.900024 3.85495 3.85495 0.900024 7.50002 0.900024C11.1451 0.900024 14.1 3.85495 14.1 7.50002C14.1 11.1451 11.1451 14.1 7.50002 14.1C3.85495 14.1 0.900024 11.1451 0.900024 7.50002ZM7.50002 1.80002C4.35201 1.80002 1.80002 4.35201 1.80002 7.50002C1.80002 10.648 4.35201 13.2 7.50002 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.35201 10.648 1.80002 7.50002 1.80002ZM3.07504 7.50002C3.07504 5.05617 5.05618 3.07502 7.50004 3.07502C9.94388 3.07502 11.925 5.05617 11.925 7.50002C11.925 9.94386 9.94388 11.925 7.50004 11.925C5.05618 11.925 3.07504 9.94386 3.07504 7.50002ZM7.50004 3.92502C5.52562 3.92502 3.92504 5.52561 3.92504 7.50002C3.92504 9.47442 5.52563 11.075 7.50004 11.075C9.47444 11.075 11.075 9.47442 11.075 7.50002C11.075 5.52561 9.47444 3.92502 7.50004 3.92502ZM7.50004 5.25002C6.2574 5.25002 5.25004 6.25739 5.25004 7.50002C5.25004 8.74266 6.2574 9.75002 7.50004 9.75002C8.74267 9.75002 9.75004 8.74266 9.75004 7.50002C9.75004 6.25738 8.74267 5.25002 7.50004 5.25002ZM6.05004 7.50002C6.05004 6.69921 6.69923 6.05002 7.50004 6.05002C8.30084 6.05002 8.95004 6.69921 8.95004 7.50002C8.95004 8.30083 8.30084 8.95002 7.50004 8.95002C6.69923 8.95002 6.05004 8.30083 6.05004 7.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4n = [
    "color"
];
var $c12e32cf04d921d4$export$4a7d2a945910cc57 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4n);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.94993 2.95002L3.94993 4.49998C3.94993 4.74851 3.74845 4.94998 3.49993 4.94998C3.2514 4.94998 3.04993 4.74851 3.04993 4.49998V2.50004C3.04993 2.45246 3.05731 2.40661 3.07099 2.36357C3.12878 2.18175 3.29897 2.05002 3.49993 2.05002H11.4999C11.6553 2.05002 11.7922 2.12872 11.8731 2.24842C11.9216 2.32024 11.9499 2.40682 11.9499 2.50002L11.9499 2.50004V4.49998C11.9499 4.74851 11.7485 4.94998 11.4999 4.94998C11.2514 4.94998 11.0499 4.74851 11.0499 4.49998V2.95002H8.04993V12.05H9.25428C9.50281 12.05 9.70428 12.2515 9.70428 12.5C9.70428 12.7486 9.50281 12.95 9.25428 12.95H5.75428C5.50575 12.95 5.30428 12.7486 5.30428 12.5C5.30428 12.2515 5.50575 12.05 5.75428 12.05H6.94993V2.95002H3.94993Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4o = [
    "color"
];
var $c12e32cf04d921d4$export$934aaa521722e7a1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4o);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.89949 5.50002C3.89949 5.27911 3.7204 5.10003 3.49949 5.10003C3.27857 5.10003 3.09949 5.27911 3.09949 5.50002L3.09949 12.5343L1.78233 11.2172C1.62612 11.061 1.37285 11.061 1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829L3.21664 13.7829C3.29166 13.8579 3.3934 13.9 3.49949 13.9C3.60557 13.9 3.70732 13.8579 3.78233 13.7829L5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172C5.62612 11.061 5.37285 11.061 5.21664 11.2172L3.89949 12.5343L3.89949 5.50002ZM8.49998 13C8.22383 13 7.99998 12.7762 7.99998 12.5C7.99998 12.2239 8.22383 12 8.49998 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7762 14.7761 13 14.5 13H8.49998ZM8.49998 10C8.22383 10 7.99998 9.77617 7.99998 9.50002C7.99998 9.22388 8.22383 9.00002 8.49998 9.00002H14.5C14.7761 9.00002 15 9.22388 15 9.50002C15 9.77617 14.7761 10 14.5 10H8.49998ZM7.99998 6.50002C7.99998 6.77617 8.22383 7.00002 8.49998 7.00002H14.5C14.7761 7.00002 15 6.77617 15 6.50002C15 6.22388 14.7761 6.00002 14.5 6.00002H8.49998C8.22383 6.00002 7.99998 6.22388 7.99998 6.50002Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4p = [
    "color"
];
var $c12e32cf04d921d4$export$c0990f168a0bad08 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4p);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H10.5C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM3 10.5C3 10.2239 3.22386 10 3.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H3.5C3.22386 11 3 10.7761 3 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4q = [
    "color"
];
var $c12e32cf04d921d4$export$8ea3580a4e458099 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H12.5C12.7761 5 13 4.77614 13 4.5C13 4.22386 12.7761 4 12.5 4H2.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4r = [
    "color"
];
var $c12e32cf04d921d4$export$e9337773b10190a1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4r);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H7.5C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4s = [
    "color"
];
var $c12e32cf04d921d4$export$79a9a721b029c6d9 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4s);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.49949 14.9C3.7204 14.9 3.89949 14.7209 3.89949 14.5L3.89949 10.4657L5.21664 11.7829C5.37285 11.9391 5.62612 11.9391 5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172L3.78233 9.21718C3.70732 9.14217 3.60557 9.10002 3.49949 9.10002C3.3934 9.10002 3.29166 9.14217 3.21664 9.21718L1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829C1.37285 11.9391 1.62612 11.9391 1.78233 11.7829L3.09949 10.4657L3.09949 14.5C3.09949 14.7209 3.27857 14.9 3.49949 14.9ZM7.99998 10.5C7.99998 10.7762 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7762 15 10.5C15 10.2239 14.7761 10 14.5 10H8.49998C8.22383 10 7.99998 10.2239 7.99998 10.5ZM7.99998 7.50002C7.99998 7.77617 8.22383 8.00002 8.49998 8.00002H14.5C14.7761 8.00002 15 7.77617 15 7.50002C15 7.22388 14.7761 7.00002 14.5 7.00002H8.49998C8.22383 7.00002 7.99998 7.22388 7.99998 7.50002ZM8.49998 5.00002C8.22383 5.00002 7.99998 4.77617 7.99998 4.50002C7.99998 4.22388 8.22383 4.00002 8.49998 4.00002H14.5C14.7761 4.00002 15 4.22388 15 4.50002C15 4.77617 14.7761 5.00002 14.5 5.00002H8.49998ZM3.89949 0.500025C3.89949 0.279111 3.7204 0.100025 3.49949 0.100025C3.27857 0.100025 3.09949 0.279111 3.09949 0.500025L3.09949 4.53434L1.78233 3.21718C1.62612 3.06097 1.37285 3.06097 1.21664 3.21718C1.06043 3.37339 1.06043 3.62666 1.21664 3.78287L3.21664 5.78287C3.29166 5.85788 3.3934 5.90002 3.49949 5.90002C3.60557 5.90002 3.70732 5.85788 3.78233 5.78287L5.78233 3.78287C5.93854 3.62666 5.93854 3.37339 5.78233 3.21718C5.62612 3.06097 5.37285 3.06097 5.21664 3.21718L3.89949 4.53434L3.89949 0.500025Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4t = [
    "color"
];
var $c12e32cf04d921d4$export$2b644951427679e4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4t);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM7 7.5C7 7.22386 7.22386 7 7.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H7.5C7.22386 8 7 7.77614 7 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H4.5C4.22386 11 4 10.7761 4 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4u = [
    "color"
];
var $c12e32cf04d921d4$export$65298c635b1d5567 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4u);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M3.89949 9.49998C3.89949 9.72089 3.7204 9.89997 3.49949 9.89997C3.27857 9.89997 3.09949 9.72089 3.09949 9.49998L3.09949 2.46566L1.78233 3.78282C1.62612 3.93903 1.37285 3.93903 1.21664 3.78282C1.06043 3.62661 1.06043 3.37334 1.21664 3.21713L3.21664 1.21713C3.29166 1.14212 3.3934 1.09998 3.49949 1.09998C3.60557 1.09998 3.70732 1.14212 3.78233 1.21713L5.78233 3.21713C5.93854 3.37334 5.93854 3.62661 5.78233 3.78282C5.62612 3.93903 5.37285 3.93903 5.21664 3.78282L3.89949 2.46566L3.89949 9.49998ZM8.49998 1.99998C8.22383 1.99998 7.99998 2.22383 7.99998 2.49998C7.99998 2.77612 8.22383 2.99998 8.49998 2.99998H14.5C14.7761 2.99998 15 2.77612 15 2.49998C15 2.22383 14.7761 1.99998 14.5 1.99998H8.49998ZM8.49998 4.99998C8.22383 4.99998 7.99998 5.22383 7.99998 5.49998C7.99998 5.77612 8.22383 5.99998 8.49998 5.99998H14.5C14.7761 5.99998 15 5.77612 15 5.49998C15 5.22383 14.7761 4.99998 14.5 4.99998H8.49998ZM7.99998 8.49998C7.99998 8.22383 8.22383 7.99998 8.49998 7.99998H14.5C14.7761 7.99998 15 8.22383 15 8.49998C15 8.77612 14.7761 8.99998 14.5 8.99998H8.49998C8.22383 8.99998 7.99998 8.77612 7.99998 8.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4v = [
    "color"
];
var $c12e32cf04d921d4$export$2407db3e81e79ec8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4v);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L11.9291 2.36383C11.9159 2.32246 11.897 2.28368 11.8732 2.24845C11.7923 2.12875 11.6554 2.05005 11.5001 2.05005H3.50005C3.29909 2.05005 3.1289 2.18178 3.07111 2.3636C3.05743 2.40665 3.05005 2.45249 3.05005 2.50007V4.50001C3.05005 4.74854 3.25152 4.95001 3.50005 4.95001C3.74858 4.95001 3.95005 4.74854 3.95005 4.50001V2.95005H6.95006V7.34284L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L6.95006 8.75705V12.0501H5.7544C5.50587 12.0501 5.3044 12.2515 5.3044 12.5001C5.3044 12.7486 5.50587 12.9501 5.7544 12.9501H9.2544C9.50293 12.9501 9.7044 12.7486 9.7044 12.5001C9.7044 12.2515 9.50293 12.0501 9.2544 12.0501H8.05006V7.65705L13.3536 2.35355ZM8.05006 6.24284L11.0501 3.24283V2.95005H8.05006V6.24284Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4w = [
    "color"
];
var $c12e32cf04d921d4$export$d02861c1158d3b3d = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4w);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5 3.5C5 3.22386 5.22386 3 5.5 3H9.5C9.77614 3 10 3.22386 10 3.5V6H12.5C12.6873 6 12.8589 6.10467 12.9446 6.27121C13.0303 6.43774 13.0157 6.63821 12.9069 6.79062L7.90687 13.7906C7.81301 13.922 7.66148 14 7.5 14C7.33853 14 7.18699 13.922 7.09314 13.7906L2.09314 6.79062C1.98427 6.63821 1.96972 6.43774 2.05542 6.27121C2.14112 6.10467 2.31271 6 2.5 6H5V3.5ZM6 4V6.5C6 6.77614 5.77614 7 5.5 7H3.4716L7.5 12.6398L11.5284 7H9.5C9.22386 7 9 6.77614 9 6.5V4H6Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4x = [
    "color"
];
var $c12e32cf04d921d4$export$90890f1931da847b = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4x);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1 7.5C1 7.66148 1.07798 7.81301 1.20938 7.90687L8.20938 12.9069C8.36179 13.0157 8.56226 13.0303 8.72879 12.9446C8.89533 12.8589 9 12.6873 9 12.5L9 10L11.5 10C11.7761 10 12 9.77614 12 9.5L12 5.5C12 5.22386 11.7761 5 11.5 5L9 5L9 2.5C9 2.31271 8.89533 2.14112 8.72879 2.05542C8.56226 1.96972 8.36179 1.98427 8.20938 2.09313L1.20938 7.09314C1.07798 7.18699 1 7.33853 1 7.5ZM8 3.4716L8 5.5C8 5.77614 8.22386 6 8.5 6L11 6L11 9L8.5 9C8.22386 9 8 9.22386 8 9.5L8 11.5284L2.36023 7.5L8 3.4716Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4y = [
    "color"
];
var $c12e32cf04d921d4$export$72a6223ceb8df5ef = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14 7.5C14 7.66148 13.922 7.81301 13.7906 7.90687L6.79062 12.9069C6.63821 13.0157 6.43774 13.0303 6.27121 12.9446C6.10467 12.8589 6 12.6873 6 12.5L6 10L3.5 10C3.22386 10 3 9.77614 3 9.5L3 5.5C3 5.22386 3.22386 5 3.5 5L6 5L6 2.5C6 2.31271 6.10467 2.14112 6.27121 2.05542C6.43774 1.96972 6.63821 1.98427 6.79062 2.09313L13.7906 7.09314C13.922 7.18699 14 7.33853 14 7.5ZM7 3.4716L7 5.5C7 5.77614 6.77614 6 6.5 6L4 6L4 9L6.5 9C6.77614 9 7 9.22386 7 9.5L7 11.5284L12.6398 7.5L7 3.4716Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4z = [
    "color"
];
var $c12e32cf04d921d4$export$edde007a504cdbfe = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.5 1C7.66148 1 7.81301 1.07798 7.90687 1.20938L12.9069 8.20938C13.0157 8.36179 13.0303 8.56226 12.9446 8.72879C12.8589 8.89533 12.6873 9 12.5 9H10V11.5C10 11.7761 9.77614 12 9.5 12H5.5C5.22386 12 5 11.7761 5 11.5V9H2.5C2.31271 9 2.14112 8.89533 2.05542 8.72879C1.96972 8.56226 1.98427 8.36179 2.09314 8.20938L7.09314 1.20938C7.18699 1.07798 7.33853 1 7.5 1ZM3.4716 8H5.5C5.77614 8 6 8.22386 6 8.5V11H9V8.5C9 8.22386 9.22386 8 9.5 8H11.5284L7.5 2.36023L3.4716 8Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4A = [
    "color"
];
var $c12e32cf04d921d4$export$579848c7cccecf3f = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4A);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49998 0.849976C7.22383 0.849976 6.99998 1.07383 6.99998 1.34998V3.52234C6.99998 3.79848 7.22383 4.02234 7.49998 4.02234C7.77612 4.02234 7.99998 3.79848 7.99998 3.52234V1.8718C10.8862 2.12488 13.15 4.54806 13.15 7.49998C13.15 10.6204 10.6204 13.15 7.49998 13.15C4.37957 13.15 1.84998 10.6204 1.84998 7.49998C1.84998 6.10612 2.35407 4.83128 3.19049 3.8459C3.36919 3.63538 3.34339 3.31985 3.13286 3.14115C2.92234 2.96245 2.60681 2.98825 2.42811 3.19877C1.44405 4.35808 0.849976 5.86029 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976ZM6.74049 8.08072L4.22363 4.57237C4.15231 4.47295 4.16346 4.33652 4.24998 4.25C4.33649 4.16348 4.47293 4.15233 4.57234 4.22365L8.08069 6.74051C8.56227 7.08599 8.61906 7.78091 8.19998 8.2C7.78089 8.61909 7.08597 8.56229 6.74049 8.08072Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4B = [
    "color"
];
var $c12e32cf04d921d4$export$872ef4fe88315cc3 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4B);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4C = [
    "color"
];
var $c12e32cf04d921d4$export$df10b15f2353def5 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4C);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M13.0502 2.74989C13.0502 2.44613 12.804 2.19989 12.5002 2.19989C12.1965 2.19989 11.9502 2.44613 11.9502 2.74989V7.2825C11.9046 7.18802 11.8295 7.10851 11.7334 7.05776L2.73338 2.30776C2.5784 2.22596 2.3919 2.23127 2.24182 2.32176C2.09175 2.41225 2 2.57471 2 2.74995V12.25C2 12.4252 2.09175 12.5877 2.24182 12.6781C2.3919 12.7686 2.5784 12.7739 2.73338 12.6921L11.7334 7.94214C11.8295 7.89139 11.9046 7.81188 11.9502 7.7174V12.2499C11.9502 12.5536 12.1965 12.7999 12.5002 12.7999C12.804 12.7999 13.0502 12.5536 13.0502 12.2499V2.74989ZM3 11.4207V3.5792L10.4288 7.49995L3 11.4207Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4D = [
    "color"
];
var $c12e32cf04d921d4$export$6130ef86fd52e250 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4D);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.94976 2.74989C1.94976 2.44613 2.196 2.19989 2.49976 2.19989C2.80351 2.19989 3.04976 2.44613 3.04976 2.74989V7.2825C3.0954 7.18802 3.17046 7.10851 3.26662 7.05776L12.2666 2.30776C12.4216 2.22596 12.6081 2.23127 12.7582 2.32176C12.9083 2.41225 13 2.57471 13 2.74995V12.25C13 12.4252 12.9083 12.5877 12.7582 12.6781C12.6081 12.7686 12.4216 12.7739 12.2666 12.6921L3.26662 7.94214C3.17046 7.89139 3.0954 7.81188 3.04976 7.7174V12.2499C3.04976 12.5536 2.80351 12.7999 2.49976 12.7999C2.196 12.7999 1.94976 12.5536 1.94976 12.2499V2.74989ZM4.57122 7.49995L12 11.4207V3.5792L4.57122 7.49995Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4E = [
    "color"
];
var $c12e32cf04d921d4$export$ee1fdf1996836514 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4E);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4F = [
    "color"
];
var $c12e32cf04d921d4$export$287e71cda35821ff = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4F);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        opacity: ".25",
        d: "M0 0H3V3H0V0ZM6 3H3V6H0V9H3V12H0V15H3V12H6V15H9V12H12V15H15V12H12V9H15V6H12V3H15V0H12V3H9V0H6V3ZM6 6V3H9V6H6ZM6 9H3V6H6V9ZM9 9V6H12V9H9ZM9 9H6V12H9V9Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4G = [
    "color"
];
var $c12e32cf04d921d4$export$d23329de703dffc4 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4G);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.5 1C5.22386 1 5 1.22386 5 1.5C5 1.77614 5.22386 2 5.5 2H9.5C9.77614 2 10 1.77614 10 1.5C10 1.22386 9.77614 1 9.5 1H5.5ZM3 3.5C3 3.22386 3.22386 3 3.5 3H5H10H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H11V12C11 12.5523 10.5523 13 10 13H5C4.44772 13 4 12.5523 4 12V4L3.5 4C3.22386 4 3 3.77614 3 3.5ZM5 4H10V12H5V4Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4H = [
    "color"
];
var $c12e32cf04d921d4$export$b445c2dc6993f9f8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4H);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4 6H11L7.5 10.5L4 6Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$4I = [
    "color"
];
var $c12e32cf04d921d4$export$62f44957433ecfbf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4I);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M9 4L9 11L4.5 7.5L9 4Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$4J = [
    "color"
];
var $c12e32cf04d921d4$export$43e4d35e8a44b537 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4J);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6 11L6 4L10.5 7.5L6 11Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$4K = [
    "color"
];
var $c12e32cf04d921d4$export$9ff28f4659896371 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4K);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4 9H11L7.5 4.5L4 9Z",
        fill: color
    }));
});
var $c12e32cf04d921d4$var$_excluded$4L = [
    "color"
];
var $c12e32cf04d921d4$export$890946d7e35b6ab9 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4L);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.23336 4.69629C7.23336 2.96884 8.63335 1.56857 10.36 1.56857C11.3736 1.56857 12.183 2.04804 12.7254 2.74385C13.3079 2.62467 13.8557 2.40913 14.3513 2.11508C14.1559 2.72598 13.7424 3.2396 13.2033 3.56463C13.2038 3.56568 13.2042 3.56674 13.2047 3.56779C13.7334 3.50361 14.2364 3.36302 14.7048 3.15546L14.7037 3.15715C14.3667 3.66183 13.9431 4.10736 13.4561 4.47034C13.4823 4.64672 13.4956 4.82427 13.4956 5.00079C13.4956 8.6871 10.6873 12.9746 5.52122 12.9746C3.93906 12.9746 2.46544 12.511 1.22505 11.7152C0.992632 11.5661 0.925108 11.2568 1.07423 11.0244C1.0874 11.0038 1.10183 10.9846 1.11734 10.9666C1.20582 10.8202 1.37438 10.7309 1.5554 10.7522C2.47066 10.8601 3.38568 10.7485 4.19219 10.3962C3.39226 10.0434 2.77129 9.35975 2.50204 8.51974C2.45359 8.3686 2.48835 8.20311 2.59351 8.08422C2.59716 8.0801 2.60087 8.07606 2.60464 8.0721C1.96391 7.50819 1.55973 6.68208 1.55973 5.76143V5.72759C1.55973 5.56814 1.64411 5.42059 1.78155 5.33974C1.82671 5.31317 1.87537 5.29511 1.92532 5.28558C1.70549 4.86154 1.58116 4.37984 1.58116 3.86958C1.58116 3.40165 1.58384 2.81192 1.91332 2.28081C1.98718 2.16175 2.10758 2.08915 2.2364 2.07195C2.42588 2.01237 2.64087 2.06969 2.77406 2.23302C3.86536 3.57126 5.44066 4.49583 7.23366 4.73961L7.23336 4.69629ZM5.52122 11.9746C4.73387 11.9746 3.97781 11.8435 3.27248 11.6023C4.13012 11.4538 4.95307 11.1159 5.66218 10.5602C5.81211 10.4427 5.87182 10.2435 5.81126 10.0629C5.7507 9.88234 5.583 9.75943 5.39255 9.75607C4.68968 9.74366 4.06712 9.39716 3.67793 8.86845C3.86828 8.85306 4.05428 8.82039 4.23445 8.77167C4.43603 8.71716 4.57363 8.53114 4.56674 8.32243C4.55985 8.11372 4.41029 7.93718 4.20555 7.89607C3.42694 7.73977 2.79883 7.16764 2.56169 6.42174C2.76255 6.47025 2.97102 6.4991 3.18482 6.5061C3.38563 6.51267 3.56646 6.38533 3.62795 6.19405C3.68943 6.00277 3.61666 5.79391 3.44963 5.68224C2.86523 5.29155 2.48116 4.62464 2.48116 3.86958C2.48116 3.70213 2.48352 3.55268 2.49355 3.41719C3.85115 4.79913 5.70873 5.68931 7.77588 5.79338C7.93225 5.80126 8.08328 5.73543 8.18395 5.61553C8.28463 5.49562 8.32332 5.33548 8.28851 5.18284C8.25255 5.02517 8.23336 4.86284 8.23336 4.69629C8.23336 3.52085 9.18591 2.56857 10.36 2.56857C11.5943 2.56857 12.4956 3.71208 12.4956 5.00079C12.4956 8.25709 10.0202 11.9746 5.52122 11.9746Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4M = [
    "color"
];
var $c12e32cf04d921d4$export$4ce1642bb7f15c79 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4M);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M5.00001 2.75C5.00001 2.47386 4.77615 2.25 4.50001 2.25C4.22387 2.25 4.00001 2.47386 4.00001 2.75V8.05C4.00001 9.983 5.56702 11.55 7.50001 11.55C9.43301 11.55 11 9.983 11 8.05V2.75C11 2.47386 10.7762 2.25 10.5 2.25C10.2239 2.25 10 2.47386 10 2.75V8.05C10 9.43071 8.88072 10.55 7.50001 10.55C6.1193 10.55 5.00001 9.43071 5.00001 8.05V2.75ZM3.49998 13.1001C3.27906 13.1001 3.09998 13.2791 3.09998 13.5001C3.09998 13.721 3.27906 13.9001 3.49998 13.9001H11.5C11.7209 13.9001 11.9 13.721 11.9 13.5001C11.9 13.2791 11.7209 13.1001 11.5 13.1001H3.49998Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4N = [
    "color"
];
var $c12e32cf04d921d4$export$35f5c3e250802cd1 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4N);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4O = [
    "color"
];
var $c12e32cf04d921d4$export$8df90684a752ef81 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4O);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.81825 1.18188C7.64251 1.00615 7.35759 1.00615 7.18185 1.18188L4.18185 4.18188C4.00611 4.35762 4.00611 4.64254 4.18185 4.81828C4.35759 4.99401 4.64251 4.99401 4.81825 4.81828L7.05005 2.58648V9.49996C7.05005 9.74849 7.25152 9.94996 7.50005 9.94996C7.74858 9.94996 7.95005 9.74849 7.95005 9.49996V2.58648L10.1819 4.81828C10.3576 4.99401 10.6425 4.99401 10.8182 4.81828C10.994 4.64254 10.994 4.35762 10.8182 4.18188L7.81825 1.18188ZM2.5 9.99997C2.77614 9.99997 3 10.2238 3 10.5V12C3 12.5538 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2238 12.2239 9.99997 12.5 9.99997C12.7761 9.99997 13 10.2238 13 10.5V12C13 13.104 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2238 2.22386 9.99997 2.5 9.99997Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4P = [
    "color"
];
var $c12e32cf04d921d4$export$6e6352268496f418 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4P);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4Q = [
    "color"
];
var $c12e32cf04d921d4$export$aff958e91ee0391a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4Q);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 9.1488 1.47963 10.657 2.47665 11.8162L1.64643 12.6464C1.45117 12.8417 1.45117 13.1583 1.64643 13.3535C1.8417 13.5488 2.15828 13.5488 2.35354 13.3535L3.18377 12.5233C4.34296 13.5202 5.85104 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34299 12.5233 3.1838L13.3535 2.35354C13.5488 2.15827 13.5488 1.84169 13.3535 1.64643C13.1583 1.45117 12.8417 1.45117 12.6464 1.64643L11.8162 2.47668C10.657 1.47966 9.14877 0.877045 7.49985 0.877045ZM11.1422 3.15066C10.1567 2.32449 8.88639 1.82704 7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.88642 2.32446 10.1568 3.15063 11.1422L11.1422 3.15066ZM3.85776 11.8493C4.84317 12.6753 6.11343 13.1727 7.49985 13.1727C10.6328 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11346 12.6753 4.8432 11.8493 3.85779L3.85776 11.8493Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4R = [
    "color"
];
var $c12e32cf04d921d4$export$18bf59af111847c = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4R);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7.49998 1L6.92321 2.00307L1.17498 12L0.599976 13H1.7535H13.2464H14.4L13.825 12L8.07674 2.00307L7.49998 1ZM7.49998 3.00613L2.3285 12H12.6714L7.49998 3.00613Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4S = [
    "color"
];
var $c12e32cf04d921d4$export$4ec8735ec23c8112 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4S);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.76447 3.12199C5.63151 3.04859 6.56082 3 7.5 3C8.43918 3 9.36849 3.04859 10.2355 3.12199C11.2796 3.21037 11.9553 3.27008 12.472 3.39203C12.9425 3.50304 13.2048 3.64976 13.4306 3.88086C13.4553 3.90618 13.4902 3.94414 13.5133 3.97092C13.7126 4.20149 13.8435 4.4887 13.918 5.03283C13.9978 5.6156 14 6.37644 14 7.52493C14 8.66026 13.9978 9.41019 13.9181 9.98538C13.8439 10.5206 13.7137 10.8061 13.5125 11.0387C13.4896 11.0651 13.4541 11.1038 13.4296 11.1287C13.2009 11.3625 12.9406 11.5076 12.4818 11.6164C11.9752 11.7365 11.3143 11.7942 10.2878 11.8797C9.41948 11.9521 8.47566 12 7.5 12C6.52434 12 5.58052 11.9521 4.7122 11.8797C3.68572 11.7942 3.02477 11.7365 2.51816 11.6164C2.05936 11.5076 1.7991 11.3625 1.57037 11.1287C1.54593 11.1038 1.51035 11.0651 1.48748 11.0387C1.28628 10.8061 1.15612 10.5206 1.08193 9.98538C1.00221 9.41019 1 8.66026 1 7.52493C1 6.37644 1.00216 5.6156 1.082 5.03283C1.15654 4.4887 1.28744 4.20149 1.48666 3.97092C1.5098 3.94414 1.54468 3.90618 1.56942 3.88086C1.7952 3.64976 2.05752 3.50304 2.52796 3.39203C3.04473 3.27008 3.7204 3.21037 4.76447 3.12199ZM0 7.52493C0 5.28296 0 4.16198 0.729985 3.31713C0.766457 3.27491 0.815139 3.22194 0.854123 3.18204C1.63439 2.38339 2.64963 2.29744 4.68012 2.12555C5.56923 2.05028 6.52724 2 7.5 2C8.47276 2 9.43077 2.05028 10.3199 2.12555C12.3504 2.29744 13.3656 2.38339 14.1459 3.18204C14.1849 3.22194 14.2335 3.27491 14.27 3.31713C15 4.16198 15 5.28296 15 7.52493C15 9.74012 15 10.8477 14.2688 11.6929C14.2326 11.7348 14.1832 11.7885 14.1444 11.8281C13.3629 12.6269 12.3655 12.71 10.3709 12.8763C9.47971 12.9505 8.50782 13 7.5 13C6.49218 13 5.52028 12.9505 4.62915 12.8763C2.63446 12.71 1.63712 12.6269 0.855558 11.8281C0.816844 11.7885 0.767442 11.7348 0.731221 11.6929C0 10.8477 0 9.74012 0 7.52493ZM5.25 5.38264C5.25 5.20225 5.43522 5.08124 5.60041 5.15369L10.428 7.27105C10.6274 7.35853 10.6274 7.64147 10.428 7.72895L5.60041 9.84631C5.43522 9.91876 5.25 9.79775 5.25 9.61736V5.38264Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4T = [
    "color"
];
var $c12e32cf04d921d4$export$6262053f5289408a = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4T);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M7 2H1.5C1.22386 2 1 2.22386 1 2.5V7H7V2ZM8 2V7H14V2.5C14 2.22386 13.7761 2 13.5 2H8ZM7 8H1V12.5C1 12.7761 1.22386 13 1.5 13H7V8ZM8 13V8H14V12.5C14 12.7761 13.7761 13 13.5 13H8ZM1.5 1C0.671573 1 0 1.67157 0 2.5V12.5C0 13.3284 0.671573 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.67157 14.3284 1 13.5 1H1.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4U = [
    "color"
];
var $c12e32cf04d921d4$export$832ec864fd299632 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4U);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M1.5 2H13.5C13.7761 2 14 2.22386 14 2.5V7H1V2.5C1 2.22386 1.22386 2 1.5 2ZM1 8V12.5C1 12.7761 1.22386 13 1.5 13H13.5C13.7761 13 14 12.7761 14 12.5V8H1ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4V = [
    "color"
];
var $c12e32cf04d921d4$export$c65e16705969a7a8 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4V);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M14 2.58711L1.85163 13H13.5C13.7761 13 14 12.7761 14 12.5V2.58711ZM0.762879 13.8067L0.825396 13.8796L0.854717 13.8545C1.05017 13.9478 1.26899 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.93949 14.6926 1.45078 14.2371 1.19331L14.1746 1.12037L14.1453 1.1455C13.9498 1.05222 13.731 1 13.5 1H1.5C0.671573 1 0 1.67157 0 2.5V12.5C0 13.0605 0.307435 13.5492 0.762879 13.8067ZM1 12.4129L13.1484 2H1.5C1.22386 2 1 2.22386 1 2.5V12.4129Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4W = [
    "color"
];
var $c12e32cf04d921d4$export$96186050b98a4434 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4W);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M8 2H13.5C13.7761 2 14 2.22386 14 2.5V12.5C14 12.7761 13.7761 13 13.5 13H8V2ZM7 2H1.5C1.22386 2 1 2.22386 1 2.5V12.5C1 12.7761 1.22386 13 1.5 13H7V2ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4X = [
    "color"
];
var $c12e32cf04d921d4$export$815859cc984b9edf = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4X);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M4.81812 4.68161C4.99386 4.85734 4.99386 5.14227 4.81812 5.318L3.08632 7.0498H11.9135L10.1817 5.318C10.006 5.14227 10.006 4.85734 10.1817 4.68161C10.3575 4.50587 10.6424 4.50587 10.8181 4.68161L13.3181 7.18161C13.4939 7.35734 13.4939 7.64227 13.3181 7.818L10.8181 10.318C10.6424 10.4937 10.3575 10.4937 10.1817 10.318C10.006 10.1423 10.006 9.85734 10.1817 9.68161L11.9135 7.9498H3.08632L4.81812 9.68161C4.99386 9.85734 4.99386 10.1423 4.81812 10.318C4.64239 10.4937 4.35746 10.4937 4.18173 10.318L1.68173 7.818C1.50599 7.64227 1.50599 7.35734 1.68173 7.18161L4.18173 4.68161C4.35746 4.50587 4.64239 4.50587 4.81812 4.68161Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4Y = [
    "color"
];
var $c12e32cf04d921d4$export$418cedbcfc990387 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4Y);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159ZM4.25 6.5C4.25 6.22386 4.47386 6 4.75 6H6V4.75C6 4.47386 6.22386 4.25 6.5 4.25C6.77614 4.25 7 4.47386 7 4.75V6H8.25C8.52614 6 8.75 6.22386 8.75 6.5C8.75 6.77614 8.52614 7 8.25 7H7V8.25C7 8.52614 6.77614 8.75 6.5 8.75C6.22386 8.75 6 8.52614 6 8.25V7H4.75C4.47386 7 4.25 6.77614 4.25 6.5Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});
var $c12e32cf04d921d4$var$_excluded$4Z = [
    "color"
];
var $c12e32cf04d921d4$export$fbd55a4c69e8e024 = /*#__PURE__*/ (0, $exYeM.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, props = $c12e32cf04d921d4$var$_objectWithoutPropertiesLoose(_ref, $c12e32cf04d921d4$var$_excluded$4Z);
    return (0, $exYeM.createElement)("svg", Object.assign({
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        ref: forwardedRef
    }), (0, $exYeM.createElement)("path", {
        d: "M6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10ZM6.5 11C7.56251 11 8.53901 10.6318 9.30884 10.0159L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L10.0159 9.30884C10.6318 8.53901 11 7.56251 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11ZM4.75 6C4.47386 6 4.25 6.22386 4.25 6.5C4.25 6.77614 4.47386 7 4.75 7H8.25C8.52614 7 8.75 6.77614 8.75 6.5C8.75 6.22386 8.52614 6 8.25 6H4.75Z",
        fill: color,
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
});





const $28f7e5886da50bd4$var$AUTH_ENDPOINT = "https://mn28cogtk2.execute-api.us-east-1.amazonaws.com/dev/";
const $28f7e5886da50bd4$var$ProjectDialog = ()=>{
    // const AuthDialog = () => {
    const [project, setProject] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const { setProjectsList: setProjectsList  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    const { token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const createProject = async ()=>{
        const URL = $28f7e5886da50bd4$var$AUTH_ENDPOINT + `project`;
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const BODY = JSON.stringify({
            project: project
        });
        const request = new Request(URL, {
            method: "POST",
            headers: HEADERS,
            body: BODY,
            timeout: 100000
        });
        const result = fetch(request);
    };
    function handleAddAttempt() {
        createProject();
        setProjectsList((oldValue)=>[
                project,
                ...oldValue
            ]);
    // if (!passwordIsValid) {
    //   window.alert('Password is not valid! Review the requirements!');
    //   return;
    // }
    // handleAddTask(email, password, firstname, lastname);
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9, {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                    className: "ProjectButton violet",
                    children: "+Project"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$602eac185826482c, {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$c6fdb837b070b4ff, {
                        className: "ProjectDialogOverlay"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2, {
                        className: "ProjectDialogContent",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$f99233281efd08a0, {
                                className: "ProjectDialogTitle",
                                children: "Add Project"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "ProjectFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "ProjectLabel",
                                        htmlFor: "name",
                                        children: "Project"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                        value: project,
                                        onChange: (e)=>setProject(e.target.value),
                                        className: "ProjectInput",
                                        id: "name"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    marginTop: 25,
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$f39c2d165cd861fe, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                        onClick: handleAddAttempt,
                                        className: "ProjectButton green",
                                        children: "Submit"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$f39c2d165cd861fe, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                    className: "ProjectIconButton",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c12e32cf04d921d4$export$b7fa469a3cb3cd4f), {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $28f7e5886da50bd4$export$2e2bcd8739ae039 = $28f7e5886da50bd4$var$ProjectDialog;






var $exYeM = parcelRequire("exYeM");


var $34e4c9f69f0b056f$export$c973a4b3cb86a03d;
var $34e4c9f69f0b056f$export$99b400cabb58c515;
var $34e4c9f69f0b056f$export$13ef48a934230896;
var $34e4c9f69f0b056f$export$6b9198de19accfe6;
var $34e4c9f69f0b056f$export$f67338d29bd972f8;
var $34e4c9f69f0b056f$export$536bd91ba45f6b0a;
var $34e4c9f69f0b056f$export$eba4b1df07cb1d3;
var $34e4c9f69f0b056f$export$3ac1e88a1c0b9f1;
var $34e4c9f69f0b056f$export$9ed6e7b40248d36d;
var $34e4c9f69f0b056f$export$496307dcaa6031c4;
$34e4c9f69f0b056f$export$c973a4b3cb86a03d = `_7MS-Oq_SelectContent`;
$34e4c9f69f0b056f$export$99b400cabb58c515 = `_7MS-Oq_SelectIcon`;
$34e4c9f69f0b056f$export$13ef48a934230896 = `_7MS-Oq_SelectItem`;
$34e4c9f69f0b056f$export$6b9198de19accfe6 = `_7MS-Oq_SelectItemIndicator`;
$34e4c9f69f0b056f$export$f67338d29bd972f8 = `_7MS-Oq_SelectLabel`;
$34e4c9f69f0b056f$export$536bd91ba45f6b0a = `_7MS-Oq_SelectScrollButton`;
$34e4c9f69f0b056f$export$eba4b1df07cb1d3 = `_7MS-Oq_SelectSeparator`;
$34e4c9f69f0b056f$export$3ac1e88a1c0b9f1 = `_7MS-Oq_SelectTrigger`;
$34e4c9f69f0b056f$export$9ed6e7b40248d36d = `_7MS-Oq_SelectViewport`;
$34e4c9f69f0b056f$export$496307dcaa6031c4 = `_7MS-Oq_selectRoot`;



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
// packages/core/number/src/number.ts
function $a24d3ee4d7110eb6$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}












var $exYeM = parcelRequire("exYeM");

var $jiVm5 = parcelRequire("jiVm5");
var $9Q6OH = parcelRequire("9Q6OH");
// packages/react/arrow/src/Arrow.tsx

var $exYeM = parcelRequire("exYeM");


var $51f35d4f6c07a0fd$var$NAME = "Arrow";
var $51f35d4f6c07a0fd$export$21b07c8f274aebd5 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { children: children , width: width = 10 , height: height = 5 , ...arrowProps } = props;
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$51f35d4f6c07a0fd$export$21b07c8f274aebd5.displayName = $51f35d4f6c07a0fd$var$NAME;
var $51f35d4f6c07a0fd$export$be92b6f5f03c0fe9 = $51f35d4f6c07a0fd$export$21b07c8f274aebd5;







// packages/react/use-size/src/useSize.tsx

var $exYeM = parcelRequire("exYeM");

function $e3071ccbaf099f7e$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $exYeM.useState(void 0);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



"use client";
var $7b6292e260c70ed7$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $7b6292e260c70ed7$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $7b6292e260c70ed7$var$POPPER_NAME = "Popper";
var [$7b6292e260c70ed7$var$createPopperContext, $7b6292e260c70ed7$export$722aac194ae923] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($7b6292e260c70ed7$var$POPPER_NAME);
var [$7b6292e260c70ed7$var$PopperProvider, $7b6292e260c70ed7$var$usePopperContext] = $7b6292e260c70ed7$var$createPopperContext($7b6292e260c70ed7$var$POPPER_NAME);
var $7b6292e260c70ed7$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper , children: children  } = props;
    const [anchor, setAnchor] = $exYeM.useState(null);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($7b6292e260c70ed7$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$7b6292e260c70ed7$export$badac9ada3a0bdf9.displayName = $7b6292e260c70ed7$var$POPPER_NAME;
var $7b6292e260c70ed7$var$ANCHOR_NAME = "PopperAnchor";
var $7b6292e260c70ed7$export$ecd4e1ccab6ed6d = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , virtualRef: virtualRef , ...anchorProps } = props;
    const context = $7b6292e260c70ed7$var$usePopperContext($7b6292e260c70ed7$var$ANCHOR_NAME, __scopePopper);
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $exYeM.useEffect(()=>{
        context.onAnchorChange(virtualRef?.current || ref.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$7b6292e260c70ed7$export$ecd4e1ccab6ed6d.displayName = $7b6292e260c70ed7$var$ANCHOR_NAME;
var $7b6292e260c70ed7$var$CONTENT_NAME = "PopperContent";
var [$7b6292e260c70ed7$var$PopperContentProvider, $7b6292e260c70ed7$var$useContentContext] = $7b6292e260c70ed7$var$createPopperContext($7b6292e260c70ed7$var$CONTENT_NAME);
var $7b6292e260c70ed7$export$bc4ae5855d3c4fc = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper , side: side = "bottom" , sideOffset: sideOffset = 0 , align: align = "center" , alignOffset: alignOffset = 0 , arrowPadding: arrowPadding = 0 , avoidCollisions: avoidCollisions = true , collisionBoundary: collisionBoundary = [] , collisionPadding: collisionPaddingProp = 0 , sticky: sticky = "partial" , hideWhenDetached: hideWhenDetached = false , updatePositionStrategy: updatePositionStrategy = "optimized" , onPlaced: onPlaced , ...contentProps } = props;
    const context = $7b6292e260c70ed7$var$usePopperContext($7b6292e260c70ed7$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $exYeM.useState(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $exYeM.useState(null);
    const arrowSize = (0, $e3071ccbaf099f7e$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($7b6292e260c70ed7$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs , floatingStyles: floatingStyles , placement: placement , isPositioned: isPositioned , middlewareData: middlewareData  } = (0, $jiVm5.useFloating)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $9Q6OH.autoUpdate)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $jiVm5.offset)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $jiVm5.shift)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $jiVm5.limitShift)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $jiVm5.flip)({
                ...detectOverflowOptions
            }),
            (0, $jiVm5.size)({
                ...detectOverflowOptions,
                apply: ({ elements: elements , rects: rects , availableWidth: availableWidth , availableHeight: availableHeight  })=>{
                    const { width: anchorWidth , height: anchorHeight  } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $jiVm5.arrow)({
                element: arrow,
                padding: arrowPadding
            }),
            $7b6292e260c70ed7$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $jiVm5.hide)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $7b6292e260c70ed7$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onPlaced);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $exYeM.useState();
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($7b6292e260c70ed7$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$7b6292e260c70ed7$export$bc4ae5855d3c4fc.displayName = $7b6292e260c70ed7$var$CONTENT_NAME;
var $7b6292e260c70ed7$var$ARROW_NAME = "PopperArrow";
var $7b6292e260c70ed7$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $7b6292e260c70ed7$export$79d62cd4e10a3fd0 = $exYeM.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper , ...arrowProps } = props;
    const contentContext = $7b6292e260c70ed7$var$useContentContext($7b6292e260c70ed7$var$ARROW_NAME, __scopePopper);
    const baseSide = $7b6292e260c70ed7$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($51f35d4f6c07a0fd$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$7b6292e260c70ed7$export$79d62cd4e10a3fd0.displayName = $7b6292e260c70ed7$var$ARROW_NAME;
function $7b6292e260c70ed7$var$isNotNull(value) {
    return value !== null;
}
var $7b6292e260c70ed7$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement , rects: rects , middlewareData: middlewareData  } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $7b6292e260c70ed7$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $7b6292e260c70ed7$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $7b6292e260c70ed7$export$be92b6f5f03c0fe9 = $7b6292e260c70ed7$export$badac9ada3a0bdf9;
var $7b6292e260c70ed7$export$b688253958b8dfe7 = $7b6292e260c70ed7$export$ecd4e1ccab6ed6d;
var $7b6292e260c70ed7$export$7c6e2c02157bb7d2 = $7b6292e260c70ed7$export$bc4ae5855d3c4fc;
var $7b6292e260c70ed7$export$21b07c8f274aebd5 = $7b6292e260c70ed7$export$79d62cd4e10a3fd0;








// packages/react/use-previous/src/usePrevious.tsx

var $exYeM = parcelRequire("exYeM");
function $e863f772c7a65c44$export$5cae361ad82dce8b(value) {
    const ref = $exYeM.useRef({
        value: value,
        previous: value
    });
    return $exYeM.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}


// packages/react/visually-hidden/src/VisuallyHidden.tsx

var $exYeM = parcelRequire("exYeM");


var $4ed20962d3818fe0$var$NAME = "VisuallyHidden";
var $4ed20962d3818fe0$export$439d29a4e110a164 = $exYeM.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, {
        ...props,
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    });
});
$4ed20962d3818fe0$export$439d29a4e110a164.displayName = $4ed20962d3818fe0$var$NAME;
var $4ed20962d3818fe0$export$be92b6f5f03c0fe9 = $4ed20962d3818fe0$export$439d29a4e110a164;





"use client";
var $e552a3fd37fc9fd9$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
var $e552a3fd37fc9fd9$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
var $e552a3fd37fc9fd9$var$SELECT_NAME = "Select";
var [$e552a3fd37fc9fd9$var$Collection, $e552a3fd37fc9fd9$var$useCollection, $e552a3fd37fc9fd9$var$createCollectionScope] = (0, $ac7c84a01af4e06e$export$c74125a8e3af6bb2)($e552a3fd37fc9fd9$var$SELECT_NAME);
var [$e552a3fd37fc9fd9$var$createSelectContext, $e552a3fd37fc9fd9$export$286727a75dc039bd] = (0, $e1a745ecb8941240$export$50c7b4e9d9f19c1)($e552a3fd37fc9fd9$var$SELECT_NAME, [
    $e552a3fd37fc9fd9$var$createCollectionScope,
    (0, $7b6292e260c70ed7$export$722aac194ae923)
]);
var $e552a3fd37fc9fd9$var$usePopperScope = (0, $7b6292e260c70ed7$export$722aac194ae923)();
var [$e552a3fd37fc9fd9$var$SelectProvider, $e552a3fd37fc9fd9$var$useSelectContext] = $e552a3fd37fc9fd9$var$createSelectContext($e552a3fd37fc9fd9$var$SELECT_NAME);
var [$e552a3fd37fc9fd9$var$SelectNativeOptionsProvider, $e552a3fd37fc9fd9$var$useSelectNativeOptionsContext] = $e552a3fd37fc9fd9$var$createSelectContext($e552a3fd37fc9fd9$var$SELECT_NAME);
var $e552a3fd37fc9fd9$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect , children: children , open: openProp , defaultOpen: defaultOpen , onOpenChange: onOpenChange , value: valueProp , defaultValue: defaultValue , onValueChange: onValueChange , dir: dir , name: name , autoComplete: autoComplete , disabled: disabled , required: required  } = props;
    const popperScope = $e552a3fd37fc9fd9$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = $exYeM.useState(null);
    const [valueNode, setValueNode] = $exYeM.useState(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = $exYeM.useState(false);
    const direction = (0, $9cee77c98b858c29$export$b39126d51d94e6f3)(dir);
    const [open = false, setOpen] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const [value, setValue] = (0, $ceaa710ce91b202b$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const triggerPointerDownPosRef = $exYeM.useRef(null);
    const isFormControl = trigger ? Boolean(trigger.closest("form")) : true;
    const [nativeOptionsSet, setNativeOptionsSet] = $exYeM.useState(/* @__PURE__ */ new Set());
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($7b6292e260c70ed7$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsxs)($e552a3fd37fc9fd9$var$SelectProvider, {
            required: required,
            scope: __scopeSelect,
            trigger: trigger,
            onTriggerChange: setTrigger,
            valueNode: valueNode,
            onValueNodeChange: setValueNode,
            valueNodeHasChildren: valueNodeHasChildren,
            onValueNodeHasChildrenChange: setValueNodeHasChildren,
            contentId: (0, $6e53b15deb1e14e9$export$f680877a34711e37)(),
            value: value,
            onValueChange: setValue,
            open: open,
            onOpenChange: setOpen,
            dir: direction,
            triggerPointerDownPosRef: triggerPointerDownPosRef,
            disabled: disabled,
            children: [
                /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$Collection.Provider, {
                    scope: __scopeSelect,
                    children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$SelectNativeOptionsProvider, {
                        scope: props.__scopeSelect,
                        onNativeOptionAdd: $exYeM.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>new Set(prev).add(option));
                        }, []),
                        onNativeOptionRemove: $exYeM.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>{
                                const optionsSet = new Set(prev);
                                optionsSet.delete(option);
                                return optionsSet;
                            });
                        }, []),
                        children: children
                    })
                }),
                isFormControl ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsxs)($e552a3fd37fc9fd9$var$BubbleSelect, {
                    "aria-hidden": true,
                    required: required,
                    tabIndex: -1,
                    name: name,
                    autoComplete: autoComplete,
                    value: value,
                    onChange: (event)=>setValue(event.target.value),
                    disabled: disabled,
                    children: [
                        value === void 0 ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)("option", {
                            value: ""
                        }) : null,
                        Array.from(nativeOptionsSet)
                    ]
                }, nativeSelectKey) : null
            ]
        })
    });
};
$e552a3fd37fc9fd9$export$ef9b1a59e592288f.displayName = $e552a3fd37fc9fd9$var$SELECT_NAME;
var $e552a3fd37fc9fd9$var$TRIGGER_NAME = "SelectTrigger";
var $e552a3fd37fc9fd9$export$3ac1e88a1c0b9f1 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , disabled: disabled = false , ...triggerProps } = props;
    const popperScope = $e552a3fd37fc9fd9$var$usePopperScope(__scopeSelect);
    const context = $e552a3fd37fc9fd9$var$useSelectContext($e552a3fd37fc9fd9$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $e552a3fd37fc9fd9$var$useCollection(__scopeSelect);
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $e552a3fd37fc9fd9$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $e552a3fd37fc9fd9$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== void 0) context.onValueChange(nextItem.value);
    });
    const handleOpen = ()=>{
        if (!isDisabled) {
            context.onOpenChange(true);
            resetTypeahead();
        }
    };
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($7b6292e260c70ed7$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).button, {
            type: "button",
            role: "combobox",
            "aria-controls": context.contentId,
            "aria-expanded": context.open,
            "aria-required": context.required,
            "aria-autocomplete": "none",
            dir: context.dir,
            "data-state": context.open ? "open" : "closed",
            disabled: isDisabled,
            "data-disabled": isDisabled ? "" : void 0,
            "data-placeholder": $e552a3fd37fc9fd9$var$shouldShowPlaceholder(context.value) ? "" : void 0,
            ...triggerProps,
            ref: composedRefs,
            onClick: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
                event.currentTarget.focus();
            }),
            onPointerDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
                const target = event.target;
                if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
                if (event.button === 0 && event.ctrlKey === false) {
                    handleOpen();
                    context.triggerPointerDownPosRef.current = {
                        x: Math.round(event.pageX),
                        y: Math.round(event.pageY)
                    };
                    event.preventDefault();
                }
            }),
            onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
                const isTypingAhead = searchRef.current !== "";
                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                if (isTypingAhead && event.key === " ") return;
                if ($e552a3fd37fc9fd9$var$OPEN_KEYS.includes(event.key)) {
                    handleOpen();
                    event.preventDefault();
                }
            })
        })
    });
});
$e552a3fd37fc9fd9$export$3ac1e88a1c0b9f1.displayName = $e552a3fd37fc9fd9$var$TRIGGER_NAME;
var $e552a3fd37fc9fd9$var$VALUE_NAME = "SelectValue";
var $e552a3fd37fc9fd9$export$e288731fd71264f0 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , className: className , style: style , children: children , placeholder: placeholder = "" , ...valueProps } = props;
    const context = $e552a3fd37fc9fd9$var$useSelectContext($e552a3fd37fc9fd9$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange  } = context;
    const hasChildren = children !== void 0;
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, {
        ...valueProps,
        ref: composedRefs,
        style: {
            pointerEvents: "none"
        },
        children: $e552a3fd37fc9fd9$var$shouldShowPlaceholder(context.value) ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
            children: placeholder
        }) : children
    });
});
$e552a3fd37fc9fd9$export$e288731fd71264f0.displayName = $e552a3fd37fc9fd9$var$VALUE_NAME;
var $e552a3fd37fc9fd9$var$ICON_NAME = "SelectIcon";
var $e552a3fd37fc9fd9$export$99b400cabb58c515 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , children: children , ...iconProps } = props;
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, {
        "aria-hidden": true,
        ...iconProps,
        ref: forwardedRef,
        children: children || "▼"
    });
});
$e552a3fd37fc9fd9$export$99b400cabb58c515.displayName = $e552a3fd37fc9fd9$var$ICON_NAME;
var $e552a3fd37fc9fd9$var$PORTAL_NAME = "SelectPortal";
var $e552a3fd37fc9fd9$export$b2af6c9944296213 = (props)=>{
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $965ca2171585ad7a$export$602eac185826482c), {
        asChild: true,
        ...props
    });
};
$e552a3fd37fc9fd9$export$b2af6c9944296213.displayName = $e552a3fd37fc9fd9$var$PORTAL_NAME;
var $e552a3fd37fc9fd9$var$CONTENT_NAME = "SelectContent";
var $e552a3fd37fc9fd9$export$c973a4b3cb86a03d = $exYeM.forwardRef((props, forwardedRef)=>{
    const context = $e552a3fd37fc9fd9$var$useSelectContext($e552a3fd37fc9fd9$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = $exYeM.useState();
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? $d2lNW.createPortal(/* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$SelectContentProvider, {
            scope: props.__scopeSelect,
            children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$Collection.Slot, {
                scope: props.__scopeSelect,
                children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    children: props.children
                })
            })
        }), frag) : null;
    }
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$SelectContentImpl, {
        ...props,
        ref: forwardedRef
    });
});
$e552a3fd37fc9fd9$export$c973a4b3cb86a03d.displayName = $e552a3fd37fc9fd9$var$CONTENT_NAME;
var $e552a3fd37fc9fd9$var$CONTENT_MARGIN = 10;
var [$e552a3fd37fc9fd9$var$SelectContentProvider, $e552a3fd37fc9fd9$var$useSelectContentContext] = $e552a3fd37fc9fd9$var$createSelectContext($e552a3fd37fc9fd9$var$CONTENT_NAME);
var $e552a3fd37fc9fd9$var$CONTENT_IMPL_NAME = "SelectContentImpl";
var $e552a3fd37fc9fd9$var$SelectContentImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , position: position = "item-aligned" , onCloseAutoFocus: onCloseAutoFocus , onEscapeKeyDown: onEscapeKeyDown , onPointerDownOutside: onPointerDownOutside , side: //
    // PopperContent props
    side , sideOffset: sideOffset , align: align , alignOffset: alignOffset , arrowPadding: arrowPadding , collisionBoundary: collisionBoundary , collisionPadding: collisionPadding , sticky: sticky , hideWhenDetached: hideWhenDetached , avoidCollisions: avoidCollisions , //
    ...contentProps } = props;
    const context = $e552a3fd37fc9fd9$var$useSelectContext($e552a3fd37fc9fd9$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = $exYeM.useState(null);
    const [viewport, setViewport] = $exYeM.useState(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = $exYeM.useState(null);
    const [selectedItemText, setSelectedItemText] = $exYeM.useState(null);
    const getItems = $e552a3fd37fc9fd9$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = $exYeM.useState(false);
    const firstValidItemFoundRef = $exYeM.useRef(false);
    $exYeM.useEffect(()=>{
        if (content) return (0, $ed7fbe99f365bc63$export$6e33d16126ed003c)(content);
    }, [
        content
    ]);
    (0, $c12fde423b091e9b$export$b7ece24a22aeda8c)();
    const focusFirst = $exYeM.useCallback((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate?.scrollIntoView({
                block: "nearest"
            });
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate?.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = $exYeM.useCallback(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]);
    $exYeM.useEffect(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]);
    const { onOpenChange: onOpenChange , triggerPointerDownPosRef: triggerPointerDownPosRef  } = context;
    $exYeM.useEffect(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - (triggerPointerDownPosRef.current?.x ?? 0)),
                    y: Math.abs(Math.round(event.pageY) - (triggerPointerDownPosRef.current?.y ?? 0))
                };
            };
            const handlePointerUp = (event)=>{
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    $exYeM.useEffect(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $e552a3fd37fc9fd9$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $e552a3fd37fc9fd9$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = $exYeM.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = $exYeM.useCallback(()=>content?.focus(), [
        content
    ]);
    const itemTextRefCallback = $exYeM.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $e552a3fd37fc9fd9$var$SelectPopperPosition : $e552a3fd37fc9fd9$var$SelectItemAlignedPosition;
    const popperContentProps = SelectPosition === $e552a3fd37fc9fd9$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $471317fac98e876e$export$2e2bcd8739ae039), {
            as: (0, $8d4dfd758f40b63f$export$8c6ed5c666ac1360),
            allowPinchZoom: true,
            children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $0d95d7873b2aecf3$export$20e40289641fbbb6), {
                asChild: true,
                trapped: context.open,
                onMountAutoFocus: (event)=>{
                    event.preventDefault();
                },
                onUnmountAutoFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
                    context.trigger?.focus({
                        preventScroll: true
                    });
                    event.preventDefault();
                }),
                children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $0516f19b588c56c0$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: true,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: (event)=>event.preventDefault(),
                    onDismiss: ()=>context.onOpenChange(false),
                    children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)(SelectPosition, {
                        role: "listbox",
                        id: context.contentId,
                        "data-state": context.open ? "open" : "closed",
                        dir: context.dir,
                        onContextMenu: (event)=>event.preventDefault(),
                        ...contentProps,
                        ...popperContentProps,
                        onPlaced: ()=>setIsPositioned(true),
                        ref: composedRefs,
                        style: {
                            // flex layout so we can place the scroll buttons properly
                            display: "flex",
                            flexDirection: "column",
                            // reset the outline by default as the content MAY get focused
                            outline: "none",
                            ...contentProps.style
                        },
                        onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                            if (event.key === "Tab") event.preventDefault();
                            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                            if ([
                                "ArrowUp",
                                "ArrowDown",
                                "Home",
                                "End"
                            ].includes(event.key)) {
                                const items = getItems().filter((item)=>!item.disabled);
                                let candidateNodes = items.map((item)=>item.ref.current);
                                if ([
                                    "ArrowUp",
                                    "End"
                                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                                if ([
                                    "ArrowUp",
                                    "ArrowDown"
                                ].includes(event.key)) {
                                    const currentElement = event.target;
                                    const currentIndex = candidateNodes.indexOf(currentElement);
                                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                                }
                                setTimeout(()=>focusFirst(candidateNodes));
                                event.preventDefault();
                            }
                        })
                    })
                })
            })
        })
    });
});
$e552a3fd37fc9fd9$var$SelectContentImpl.displayName = $e552a3fd37fc9fd9$var$CONTENT_IMPL_NAME;
var $e552a3fd37fc9fd9$var$ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
var $e552a3fd37fc9fd9$var$SelectItemAlignedPosition = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , onPlaced: onPlaced , ...popperProps } = props;
    const context = $e552a3fd37fc9fd9$var$useSelectContext($e552a3fd37fc9fd9$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$useSelectContentContext($e552a3fd37fc9fd9$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = $exYeM.useState(null);
    const [content, setContent] = $exYeM.useState(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const getItems = $e552a3fd37fc9fd9$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = $exYeM.useRef(false);
    const shouldRepositionRef = $exYeM.useRef(true);
    const { viewport: viewport , selectedItem: selectedItem , selectedItemText: selectedItemText , focusSelectedItem: focusSelectedItem  } = contentContext;
    const position = $exYeM.useCallback(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $e552a3fd37fc9fd9$var$CONTENT_MARGIN;
                const clampedLeft = (0, $a24d3ee4d7110eb6$export$7d15b64cf5a3a4c4)(left, [
                    $e552a3fd37fc9fd9$var$CONTENT_MARGIN,
                    rightEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $e552a3fd37fc9fd9$var$CONTENT_MARGIN;
                const clampedRight = (0, $a24d3ee4d7110eb6$export$7d15b64cf5a3a4c4)(right, [
                    $e552a3fd37fc9fd9$var$CONTENT_MARGIN,
                    leftEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            }
            const items = getItems();
            const availableHeight = window.innerHeight - $e552a3fd37fc9fd9$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $e552a3fd37fc9fd9$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + // viewport might have padding bottom, include it to avoid a scrollable viewport
                (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
                (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$e552a3fd37fc9fd9$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px";
            onPlaced?.();
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]);
    const [contentZIndex, setContentZIndex] = $exYeM.useState();
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const handleScrollButtonChange = $exYeM.useCallback((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem?.();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)("div", {
            ref: setContentWrapper,
            style: {
                display: "flex",
                flexDirection: "column",
                position: "fixed",
                zIndex: contentZIndex
            },
            children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
                ...popperProps,
                ref: composedRefs,
                style: {
                    // When we get the height of the content, it includes borders. If we were to set
                    // the height without having `boxSizing: 'border-box'` it would be too big.
                    boxSizing: "border-box",
                    // We need to ensure the content doesn't get taller than the wrapper
                    maxHeight: "100%",
                    ...popperProps.style
                }
            })
        })
    });
});
$e552a3fd37fc9fd9$var$SelectItemAlignedPosition.displayName = $e552a3fd37fc9fd9$var$ITEM_ALIGNED_POSITION_NAME;
var $e552a3fd37fc9fd9$var$POPPER_POSITION_NAME = "SelectPopperPosition";
var $e552a3fd37fc9fd9$var$SelectPopperPosition = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , align: align = "start" , collisionPadding: collisionPadding = $e552a3fd37fc9fd9$var$CONTENT_MARGIN , ...popperProps } = props;
    const popperScope = $e552a3fd37fc9fd9$var$usePopperScope(__scopeSelect);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($7b6292e260c70ed7$export$7c6e2c02157bb7d2, {
        ...popperScope,
        ...popperProps,
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$e552a3fd37fc9fd9$var$SelectPopperPosition.displayName = $e552a3fd37fc9fd9$var$POPPER_POSITION_NAME;
var [$e552a3fd37fc9fd9$var$SelectViewportProvider, $e552a3fd37fc9fd9$var$useSelectViewportContext] = $e552a3fd37fc9fd9$var$createSelectContext($e552a3fd37fc9fd9$var$CONTENT_NAME, {});
var $e552a3fd37fc9fd9$var$VIEWPORT_NAME = "SelectViewport";
var $e552a3fd37fc9fd9$export$9ed6e7b40248d36d = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , nonce: nonce , ...viewportProps } = props;
    const contentContext = $e552a3fd37fc9fd9$var$useSelectContentContext($e552a3fd37fc9fd9$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $e552a3fd37fc9fd9$var$useSelectViewportContext($e552a3fd37fc9fd9$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = $exYeM.useRef(0);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
                },
                nonce: nonce
            }),
            /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$Collection.Slot, {
                scope: __scopeSelect,
                children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
                    "data-radix-select-viewport": "",
                    role: "presentation",
                    ...viewportProps,
                    ref: composedRefs,
                    style: {
                        // we use position: 'relative' here on the `viewport` so that when we call
                        // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
                        // (independent of the scrollUpButton).
                        position: "relative",
                        flex: 1,
                        overflow: "auto",
                        ...viewportProps.style
                    },
                    onScroll: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
                        const viewport = event.currentTarget;
                        const { contentWrapper: contentWrapper , shouldExpandOnScrollRef: shouldExpandOnScrollRef  } = viewportContext;
                        if (shouldExpandOnScrollRef?.current && contentWrapper) {
                            const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                            if (scrolledBy > 0) {
                                const availableHeight = window.innerHeight - $e552a3fd37fc9fd9$var$CONTENT_MARGIN * 2;
                                const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                                const cssHeight = parseFloat(contentWrapper.style.height);
                                const prevHeight = Math.max(cssMinHeight, cssHeight);
                                if (prevHeight < availableHeight) {
                                    const nextHeight = prevHeight + scrolledBy;
                                    const clampedNextHeight = Math.min(availableHeight, nextHeight);
                                    const heightDiff = nextHeight - clampedNextHeight;
                                    contentWrapper.style.height = clampedNextHeight + "px";
                                    if (contentWrapper.style.bottom === "0px") {
                                        viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
                                        contentWrapper.style.justifyContent = "flex-end";
                                    }
                                }
                            }
                        }
                        prevScrollTopRef.current = viewport.scrollTop;
                    })
                })
            })
        ]
    });
});
$e552a3fd37fc9fd9$export$9ed6e7b40248d36d.displayName = $e552a3fd37fc9fd9$var$VIEWPORT_NAME;
var $e552a3fd37fc9fd9$var$GROUP_NAME = "SelectGroup";
var [$e552a3fd37fc9fd9$var$SelectGroupContextProvider, $e552a3fd37fc9fd9$var$useSelectGroupContext] = $e552a3fd37fc9fd9$var$createSelectContext($e552a3fd37fc9fd9$var$GROUP_NAME);
var $e552a3fd37fc9fd9$export$ee25a334c55de1f4 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...groupProps } = props;
    const groupId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
            role: "group",
            "aria-labelledby": groupId,
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$e552a3fd37fc9fd9$export$ee25a334c55de1f4.displayName = $e552a3fd37fc9fd9$var$GROUP_NAME;
var $e552a3fd37fc9fd9$var$LABEL_NAME = "SelectLabel";
var $e552a3fd37fc9fd9$export$f67338d29bd972f8 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...labelProps } = props;
    const groupContext = $e552a3fd37fc9fd9$var$useSelectGroupContext($e552a3fd37fc9fd9$var$LABEL_NAME, __scopeSelect);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        id: groupContext.id,
        ...labelProps,
        ref: forwardedRef
    });
});
$e552a3fd37fc9fd9$export$f67338d29bd972f8.displayName = $e552a3fd37fc9fd9$var$LABEL_NAME;
var $e552a3fd37fc9fd9$var$ITEM_NAME = "SelectItem";
var [$e552a3fd37fc9fd9$var$SelectItemContextProvider, $e552a3fd37fc9fd9$var$useSelectItemContext] = $e552a3fd37fc9fd9$var$createSelectContext($e552a3fd37fc9fd9$var$ITEM_NAME);
var $e552a3fd37fc9fd9$export$13ef48a934230896 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , value: value , disabled: disabled = false , textValue: textValueProp , ...itemProps } = props;
    const context = $e552a3fd37fc9fd9$var$useSelectContext($e552a3fd37fc9fd9$var$ITEM_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$useSelectContentContext($e552a3fd37fc9fd9$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = $exYeM.useState(textValueProp ?? "");
    const [isFocused, setIsFocused] = $exYeM.useState(false);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>contentContext.itemRefCallback?.(node, value, disabled));
    const textId = (0, $6e53b15deb1e14e9$export$f680877a34711e37)();
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: $exYeM.useCallback((node)=>{
            setTextValue((prevTextValue)=>prevTextValue || (node?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$Collection.ItemSlot, {
            scope: __scopeSelect,
            value: value,
            disabled: disabled,
            textValue: textValue,
            children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
                role: "option",
                "aria-labelledby": textId,
                "data-highlighted": isFocused ? "" : void 0,
                "aria-selected": isSelected && isFocused,
                "data-state": isSelected ? "checked" : "unchecked",
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                tabIndex: disabled ? void 0 : -1,
                ...itemProps,
                ref: composedRefs,
                onFocus: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
                onPointerUp: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onPointerUp, handleSelect),
                onPointerMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
                    if (disabled) contentContext.onItemLeave?.();
                    else event.currentTarget.focus({
                        preventScroll: true
                    });
                }),
                onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
                    if (event.currentTarget === document.activeElement) contentContext.onItemLeave?.();
                }),
                onKeyDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
                    const isTypingAhead = contentContext.searchRef?.current !== "";
                    if (isTypingAhead && event.key === " ") return;
                    if ($e552a3fd37fc9fd9$var$SELECTION_KEYS.includes(event.key)) handleSelect();
                    if (event.key === " ") event.preventDefault();
                })
            })
        })
    });
});
$e552a3fd37fc9fd9$export$13ef48a934230896.displayName = $e552a3fd37fc9fd9$var$ITEM_NAME;
var $e552a3fd37fc9fd9$var$ITEM_TEXT_NAME = "SelectItemText";
var $e552a3fd37fc9fd9$export$3572fb0fb821ff49 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , className: className , style: style , ...itemTextProps } = props;
    const context = $e552a3fd37fc9fd9$var$useSelectContext($e552a3fd37fc9fd9$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$useSelectContentContext($e552a3fd37fc9fd9$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $e552a3fd37fc9fd9$var$useSelectItemContext($e552a3fd37fc9fd9$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $e552a3fd37fc9fd9$var$useSelectNativeOptionsContext($e552a3fd37fc9fd9$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = $exYeM.useState(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>contentContext.itemTextRefCallback?.(node, itemContext.value, itemContext.disabled));
    const textContent = itemTextNode?.textContent;
    const nativeOption = $exYeM.useMemo(()=>/* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)("option", {
            value: itemContext.value,
            disabled: itemContext.disabled,
            children: textContent
        }, itemContext.value), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd , onNativeOptionRemove: onNativeOptionRemove  } = nativeOptionsContext;
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, {
                id: itemContext.textId,
                ...itemTextProps,
                ref: composedRefs
            }),
            itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? $d2lNW.createPortal(itemTextProps.children, context.valueNode) : null
        ]
    });
});
$e552a3fd37fc9fd9$export$3572fb0fb821ff49.displayName = $e552a3fd37fc9fd9$var$ITEM_TEXT_NAME;
var $e552a3fd37fc9fd9$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
var $e552a3fd37fc9fd9$export$6b9198de19accfe6 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...itemIndicatorProps } = props;
    const itemContext = $e552a3fd37fc9fd9$var$useSelectItemContext($e552a3fd37fc9fd9$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).span, {
        "aria-hidden": true,
        ...itemIndicatorProps,
        ref: forwardedRef
    }) : null;
});
$e552a3fd37fc9fd9$export$6b9198de19accfe6.displayName = $e552a3fd37fc9fd9$var$ITEM_INDICATOR_NAME;
var $e552a3fd37fc9fd9$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var $e552a3fd37fc9fd9$export$d8117927658af6d7 = $exYeM.forwardRef((props, forwardedRef)=>{
    const contentContext = $e552a3fd37fc9fd9$var$useSelectContentContext($e552a3fd37fc9fd9$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $e552a3fd37fc9fd9$var$useSelectViewportContext($e552a3fd37fc9fd9$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp, setCanScrollUp] = $exYeM.useState(false);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const canScrollUp2 = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport , selectedItem: selectedItem  } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    }) : null;
});
$e552a3fd37fc9fd9$export$d8117927658af6d7.displayName = $e552a3fd37fc9fd9$var$SCROLL_UP_BUTTON_NAME;
var $e552a3fd37fc9fd9$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var $e552a3fd37fc9fd9$export$ff951e476c12189 = $exYeM.forwardRef((props, forwardedRef)=>{
    const contentContext = $e552a3fd37fc9fd9$var$useSelectContentContext($e552a3fd37fc9fd9$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $e552a3fd37fc9fd9$var$useSelectViewportContext($e552a3fd37fc9fd9$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown, setCanScrollDown] = $exYeM.useState(false);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight;
                const canScrollDown2 = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport , selectedItem: selectedItem  } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    }) : null;
});
$e552a3fd37fc9fd9$export$ff951e476c12189.displayName = $e552a3fd37fc9fd9$var$SCROLL_DOWN_BUTTON_NAME;
var $e552a3fd37fc9fd9$var$SelectScrollButtonImpl = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , onAutoScroll: onAutoScroll , ...scrollIndicatorProps } = props;
    const contentContext = $e552a3fd37fc9fd9$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = $exYeM.useRef(null);
    const getItems = $e552a3fd37fc9fd9$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = $exYeM.useCallback(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    $exYeM.useEffect(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]);
    (0, $96a334e7374a91f2$export$e5c5a5f917a5871c)(()=>{
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem?.ref.current?.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        ...scrollIndicatorProps,
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            contentContext.onItemLeave?.();
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $a20bcd1655f7f422$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    });
});
var $e552a3fd37fc9fd9$var$SEPARATOR_NAME = "SelectSeparator";
var $e552a3fd37fc9fd9$export$eba4b1df07cb1d3 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...separatorProps } = props;
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $9b1158d53fe98b0a$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        ...separatorProps,
        ref: forwardedRef
    });
});
$e552a3fd37fc9fd9$export$eba4b1df07cb1d3.displayName = $e552a3fd37fc9fd9$var$SEPARATOR_NAME;
var $e552a3fd37fc9fd9$var$ARROW_NAME = "SelectArrow";
var $e552a3fd37fc9fd9$export$314f4cb8f8099628 = $exYeM.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect , ...arrowProps } = props;
    const popperScope = $e552a3fd37fc9fd9$var$usePopperScope(__scopeSelect);
    const context = $e552a3fd37fc9fd9$var$useSelectContext($e552a3fd37fc9fd9$var$ARROW_NAME, __scopeSelect);
    const contentContext = $e552a3fd37fc9fd9$var$useSelectContentContext($e552a3fd37fc9fd9$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)($7b6292e260c70ed7$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    }) : null;
});
$e552a3fd37fc9fd9$export$314f4cb8f8099628.displayName = $e552a3fd37fc9fd9$var$ARROW_NAME;
function $e552a3fd37fc9fd9$var$shouldShowPlaceholder(value) {
    return value === "" || value === void 0;
}
var $e552a3fd37fc9fd9$var$BubbleSelect = $exYeM.forwardRef((props, forwardedRef)=>{
    const { value: value , ...selectProps } = props;
    const ref = $exYeM.useRef(null);
    const composedRefs = (0, $a0301a3b12ffad9c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const prevValue = (0, $e863f772c7a65c44$export$5cae361ad82dce8b)(value);
    $exYeM.useEffect(()=>{
        const select = ref.current;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    return /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)((0, $4ed20962d3818fe0$export$439d29a4e110a164), {
        asChild: true,
        children: /* @__PURE__ */ (0, $7ead0b1397a835ed$exports.jsx)("select", {
            ...selectProps,
            ref: composedRefs,
            defaultValue: value
        })
    });
});
$e552a3fd37fc9fd9$var$BubbleSelect.displayName = "BubbleSelect";
function $e552a3fd37fc9fd9$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $cec6513cd2787f04$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = $exYeM.useRef("");
    const timerRef = $exYeM.useRef(0);
    const handleTypeaheadSearch = $exYeM.useCallback((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = $exYeM.useCallback(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    $exYeM.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
function $e552a3fd37fc9fd9$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $e552a3fd37fc9fd9$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : void 0;
}
function $e552a3fd37fc9fd9$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $e552a3fd37fc9fd9$export$be92b6f5f03c0fe9 = $e552a3fd37fc9fd9$export$ef9b1a59e592288f;
var $e552a3fd37fc9fd9$export$41fb9f06171c75f4 = $e552a3fd37fc9fd9$export$3ac1e88a1c0b9f1;
var $e552a3fd37fc9fd9$export$4c8d1a57a761ef94 = $e552a3fd37fc9fd9$export$e288731fd71264f0;
var $e552a3fd37fc9fd9$export$f04a61298a47a40f = $e552a3fd37fc9fd9$export$99b400cabb58c515;
var $e552a3fd37fc9fd9$export$602eac185826482c = $e552a3fd37fc9fd9$export$b2af6c9944296213;
var $e552a3fd37fc9fd9$export$7c6e2c02157bb7d2 = $e552a3fd37fc9fd9$export$c973a4b3cb86a03d;
var $e552a3fd37fc9fd9$export$d5c6c08dc2d3ca7 = $e552a3fd37fc9fd9$export$9ed6e7b40248d36d;
var $e552a3fd37fc9fd9$export$eb2fcfdbd7ba97d4 = $e552a3fd37fc9fd9$export$ee25a334c55de1f4;
var $e552a3fd37fc9fd9$export$b04be29aa201d4f5 = $e552a3fd37fc9fd9$export$f67338d29bd972f8;
var $e552a3fd37fc9fd9$export$6d08773d2e66f8f2 = $e552a3fd37fc9fd9$export$13ef48a934230896;
var $e552a3fd37fc9fd9$export$d6e5bf9c43ea9319 = $e552a3fd37fc9fd9$export$3572fb0fb821ff49;
var $e552a3fd37fc9fd9$export$c3468e2714d175fa = $e552a3fd37fc9fd9$export$6b9198de19accfe6;
var $e552a3fd37fc9fd9$export$2f60d3ec9ad468f2 = $e552a3fd37fc9fd9$export$d8117927658af6d7;
var $e552a3fd37fc9fd9$export$bf1aedc3039c8d63 = $e552a3fd37fc9fd9$export$ff951e476c12189;
var $e552a3fd37fc9fd9$export$1ff3c3f08ae963c0 = $e552a3fd37fc9fd9$export$eba4b1df07cb1d3;
var $e552a3fd37fc9fd9$export$21b07c8f274aebd5 = $e552a3fd37fc9fd9$export$314f4cb8f8099628;



const $c8a78df7f7f7bba3$var$ProjectDropdown = ({ selectFollowUp: selectFollowUp  })=>{
    const { projectsList: projectsList , projects: projects  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    const [selectedProject, setSelectedProject] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("all");
    // const { token } = React.useContext(UserContext);
    function handleSelectValue(selection) {
        selectFollowUp(selection);
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($e552a3fd37fc9fd9$export$be92b6f5f03c0fe9, {
        value: projects,
        onValueChange: (selection)=>handleSelectValue(selection),
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($e552a3fd37fc9fd9$export$41fb9f06171c75f4, {
                className: $34e4c9f69f0b056f$export$3ac1e88a1c0b9f1,
                "aria-label": "Sequences",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$4c8d1a57a761ef94, {
                        placeholder: projects,
                        "aria-label": projects,
                        children: selectedProject
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$f04a61298a47a40f, {
                        className: $34e4c9f69f0b056f$export$99b400cabb58c515,
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c12e32cf04d921d4$export$4857d3f3f5f8319b), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$602eac185826482c, {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($e552a3fd37fc9fd9$export$7c6e2c02157bb7d2, {
                    className: $34e4c9f69f0b056f$export$c973a4b3cb86a03d,
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$2f60d3ec9ad468f2, {
                            className: $34e4c9f69f0b056f$export$536bd91ba45f6b0a,
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c12e32cf04d921d4$export$7f01a6cbee61a0f2), {})
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$d5c6c08dc2d3ca7, {
                            className: $34e4c9f69f0b056f$export$9ed6e7b40248d36d,
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($e552a3fd37fc9fd9$export$eb2fcfdbd7ba97d4, {
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$b04be29aa201d4f5, {
                                        className: $34e4c9f69f0b056f$export$f67338d29bd972f8,
                                        children: "Project"
                                    }, "grouplabel"),
                                    projectsList.map((item)=>{
                                        return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($c8a78df7f7f7bba3$var$SelectItem, {
                                            value: item,
                                            children: item
                                        }, item);
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$bf1aedc3039c8d63, {
                            className: $34e4c9f69f0b056f$export$536bd91ba45f6b0a,
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c12e32cf04d921d4$export$4857d3f3f5f8319b), {})
                        })
                    ]
                })
            })
        ]
    });
};
const $c8a78df7f7f7bba3$var$SelectItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(({ children: children , className: className , ...props }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($e552a3fd37fc9fd9$export$6d08773d2e66f8f2, {
        className: "SelectItem",
        ...props,
        ref: forwardedRef,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$d6e5bf9c43ea9319, {
                children: children
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($e552a3fd37fc9fd9$export$c3468e2714d175fa, {
                className: $34e4c9f69f0b056f$export$6b9198de19accfe6,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c12e32cf04d921d4$export$7dd004358974b05d), {})
            })
        ]
    });
});
var $c8a78df7f7f7bba3$export$2e2bcd8739ae039 = $c8a78df7f7f7bba3$var$ProjectDropdown;




function $89e428441ac6e5f2$var$NavBar() {
    const { isAuthenticated: isAuthenticated , handleLogout: handleLogout  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const { setProjects: setProjects , setProjectTasksWereRequested: setProjectTasksWereRequested , setProjectTasksWereFetched: setProjectTasksWereFetched  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    function handleSelectValue(selection) {
        setProjects((oldValue)=>oldValue.includes(selection) ? oldValue : [
                ...oldValue,
                selection
            ]);
        setProjectTasksWereRequested(true);
        setProjectTasksWereFetched(false);
    }
    const LoginLogout = isAuthenticated ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($89e428441ac6e5f2$var$NavItem, {
        onClick: handleLogout,
        children: "Logout"
    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($89e428441ac6e5f2$var$NavItem, {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bd57f7f38adb375b$export$2e2bcd8739ae039), {})
    });
    const AddProject = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($89e428441ac6e5f2$var$NavItem, {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $28f7e5886da50bd4$export$2e2bcd8739ae039), {})
    });
    const settingsSVG = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-settings",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    });
    const volumeMutedSVG = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-volume",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polygon", {
            points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
        })
    });
    const volumeOnSVG = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "lucide lucide-volume-2",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polygon", {
                points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M15.54 8.46a5 5 0 0 1 0 7.07"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                d: "M19.07 4.93a10 10 0 0 1 0 14.14"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($89e428441ac6e5f2$var$FlexWrapper, {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($89e428441ac6e5f2$var$NavItem, {
                children: volumeOnSVG
            }),
            LoginLogout,
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($89e428441ac6e5f2$var$NavItem, {
                children: "About"
            }),
            AddProject,
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c8a78df7f7f7bba3$export$2e2bcd8739ae039), {
                selectFollowUp: handleSelectValue
            })
        ]
    });
}
var $89e428441ac6e5f2$export$2e2bcd8739ae039 = $89e428441ac6e5f2$var$NavBar;
const $89e428441ac6e5f2$var$FlexWrapper = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  gap: 10px;
`;
const $89e428441ac6e5f2$var$NavItem = (0, $93948c98236af5c1$export$2e2bcd8739ae039).button`
  &:hover {
    color: red;
  }
  display: flex;
  padding: 2px 6px;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #f0f0f0;

  a {
    text-decoration: none;
  }
`; // --number-box-hover-background-color: hsl(240, 10%, 85%);
 // --matrix-cell-background-color: hsl(240, 50%, 93%);
 // --action-box-background-color: hsl(240 10% 95% / 50%);
 // --action-box-hover-background-color: hsl(240 10% 85% / 50%);
 // --action-box-hover-font-color: hsl(240 90% 50% / 50%);
 // --action-box-font-color: hsl(240 65% 40% / 50%);
 // --action-box-border-color: hsl(240 65% 65% / 50%);
 // --bubble-hover-background-color: hsl(240, 100%, 50%);
 // --number-box-hover-font-color: hsl(240, 100%, 50%);
 // --bubble-hover-border-color: hsl(240, 100%, 90%);
 // --number-box-border-radius: 8px;
 // --header-color: hsl(240, 85%, 35%);
 // --active-button-color: hsl(240, 85%, 35%);
 // --hover-button-color: hsl(240, 60%, 55%);
 // --mode-button-selected: hsl(240, 85%, 35%);






var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
function $438ae88f4b206ba2$export$2e2bcd8739ae039(t, e) {
    return $438ae88f4b206ba2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $438ae88f4b206ba2$export$2e2bcd8739ae039(t, e);
}


function $6ace560ed589c934$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $438ae88f4b206ba2$export$2e2bcd8739ae039)(t, o);
}


function $7d07ba38ace95d14$export$2e2bcd8739ae039() {
    return $7d07ba38ace95d14$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7d07ba38ace95d14$export$2e2bcd8739ae039.apply(null, arguments);
}


function $78d3e8b7d5e47526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $78d3e8b7d5e47526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78d3e8b7d5e47526$export$2e2bcd8739ae039(o);
}



function $bbd5d0b4a89d436f$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $99406aaafdabc25e$export$2e2bcd8739ae039(t) {
    var i = (0, $bbd5d0b4a89d436f$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $fb931f60d8d226d8$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $99406aaafdabc25e$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $58cc252a946b2efc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $58cc252a946b2efc$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $58cc252a946b2efc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fb931f60d8d226d8$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $58cc252a946b2efc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $30ea8dc1329995fa$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $30ea8dc1329995fa$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $30ea8dc1329995fa$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $30ea8dc1329995fa$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $30ea8dc1329995fa$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $30ea8dc1329995fa$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $30ea8dc1329995fa$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $30ea8dc1329995fa$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $30ea8dc1329995fa$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($30ea8dc1329995fa$var$isDate(val)) return "date";
    if ($30ea8dc1329995fa$var$isError(val)) return "error";
    var constructorName = $30ea8dc1329995fa$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $30ea8dc1329995fa$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $30ea8dc1329995fa$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $30ea8dc1329995fa$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $30ea8dc1329995fa$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $30ea8dc1329995fa$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(1));
        return enhancer($30ea8dc1329995fa$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$30ea8dc1329995fa$var$isPlainObject(action)) throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $30ea8dc1329995fa$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$30ea8dc1329995fa$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $30ea8dc1329995fa$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$30ea8dc1329995fa$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $30ea8dc1329995fa$export$8928921ea2d3b126 = $30ea8dc1329995fa$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $30ea8dc1329995fa$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $30ea8dc1329995fa$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $30ea8dc1329995fa$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$30ea8dc1329995fa$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $30ea8dc1329995fa$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $30ea8dc1329995fa$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $30ea8dc1329995fa$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $30ea8dc1329995fa$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $30ea8dc1329995fa$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $30ea8dc1329995fa$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $30ea8dc1329995fa$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $30ea8dc1329995fa$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $30ea8dc1329995fa$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $30ea8dc1329995fa$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $30ea8dc1329995fa$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $30ea8dc1329995fa$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $30ea8dc1329995fa$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($30ea8dc1329995fa$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $30ea8dc1329995fa$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $58cc252a946b2efc$export$2e2bcd8739ae039)((0, $58cc252a946b2efc$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}



var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
var $292c47c15d8911dd$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
var $292c47c15d8911dd$export$2e2bcd8739ae039 = $292c47c15d8911dd$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $a3f537480c29870f$var$defaultNoopBatch(callback) {
    callback();
}
var $a3f537480c29870f$var$batch = $a3f537480c29870f$var$defaultNoopBatch; // Allow injecting another batching function later
var $a3f537480c29870f$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $a3f537480c29870f$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $a3f537480c29870f$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $a3f537480c29870f$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $8e3e7e58cc06d162$var$createListenerCollection() {
    var batch = (0, $a3f537480c29870f$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $8e3e7e58cc06d162$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $8e3e7e58cc06d162$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $8e3e7e58cc06d162$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $8e3e7e58cc06d162$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $8e3e7e58cc06d162$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $exYeM = parcelRequire("exYeM");
var $6dc04eb7cb81b757$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);


function $8d25bb9acaebfb73$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $exYeM.useMemo)(function() {
        var subscription = (0, $8e3e7e58cc06d162$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $exYeM.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $6dc04eb7cb81b757$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $292c47c15d8911dd$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $8d25bb9acaebfb73$export$2e2bcd8739ae039 = $8d25bb9acaebfb73$var$Provider;



function $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}


var $3e937fab5d08b2fc$exports = {};
"use strict";
var $8a650a96b5a43f0f$exports = {};
"use strict";

$8a650a96b5a43f0f$exports = (parcelRequire("beWdq"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3e937fab5d08b2fc$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3e937fab5d08b2fc$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3e937fab5d08b2fc$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3e937fab5d08b2fc$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3e937fab5d08b2fc$var$TYPE_STATICS = {};
$3e937fab5d08b2fc$var$TYPE_STATICS[$8a650a96b5a43f0f$exports.ForwardRef] = $3e937fab5d08b2fc$var$FORWARD_REF_STATICS;
$3e937fab5d08b2fc$var$TYPE_STATICS[$8a650a96b5a43f0f$exports.Memo] = $3e937fab5d08b2fc$var$MEMO_STATICS;
function $3e937fab5d08b2fc$var$getStatics(component) {
    // React v16.11 and below
    if ($8a650a96b5a43f0f$exports.isMemo(component)) return $3e937fab5d08b2fc$var$MEMO_STATICS;
     // React v16.12 and above
    return $3e937fab5d08b2fc$var$TYPE_STATICS[component["$$typeof"]] || $3e937fab5d08b2fc$var$REACT_STATICS;
}
var $3e937fab5d08b2fc$var$defineProperty = Object.defineProperty;
var $3e937fab5d08b2fc$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3e937fab5d08b2fc$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3e937fab5d08b2fc$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3e937fab5d08b2fc$var$getPrototypeOf = Object.getPrototypeOf;
var $3e937fab5d08b2fc$var$objectPrototype = Object.prototype;
function $3e937fab5d08b2fc$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($3e937fab5d08b2fc$var$objectPrototype) {
            var inheritedComponent = $3e937fab5d08b2fc$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3e937fab5d08b2fc$var$objectPrototype) $3e937fab5d08b2fc$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3e937fab5d08b2fc$var$getOwnPropertyNames(sourceComponent);
        if ($3e937fab5d08b2fc$var$getOwnPropertySymbols) keys = keys.concat($3e937fab5d08b2fc$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3e937fab5d08b2fc$var$getStatics(targetComponent);
        var sourceStatics = $3e937fab5d08b2fc$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3e937fab5d08b2fc$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3e937fab5d08b2fc$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3e937fab5d08b2fc$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$3e937fab5d08b2fc$exports = $3e937fab5d08b2fc$var$hoistNonReactStatics;



var $exYeM = parcelRequire("exYeM");
var $aa9dedd1f28deda1$exports = {};
"use strict";

$aa9dedd1f28deda1$exports = (parcelRequire("956g0"));





var $da73e17b7bf0cbec$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $da73e17b7bf0cbec$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $da73e17b7bf0cbec$var$EMPTY_ARRAY = [];
var $da73e17b7bf0cbec$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $da73e17b7bf0cbec$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $da73e17b7bf0cbec$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $da73e17b7bf0cbec$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $6dc04eb7cb81b757$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $da73e17b7bf0cbec$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $da73e17b7bf0cbec$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $da73e17b7bf0cbec$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $da73e17b7bf0cbec$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $292c47c15d8911dd$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039)(_ref2, $da73e17b7bf0cbec$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $exYeM.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $exYeM.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039)(props, $da73e17b7bf0cbec$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $exYeM.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $aa9dedd1f28deda1$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $exYeM.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $exYeM.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $exYeM.useMemo)(function() {
                if (!shouldHandleStateChanges) return $da73e17b7bf0cbec$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $8e3e7e58cc06d162$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $exYeM.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $exYeM.useReducer)($da73e17b7bf0cbec$var$storeStateUpdatesReducer, $da73e17b7bf0cbec$var$EMPTY_ARRAY, $da73e17b7bf0cbec$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $exYeM.useRef)();
            var lastWrapperProps = (0, $exYeM.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $exYeM.useRef)();
            var renderIsScheduled = (0, $exYeM.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $da73e17b7bf0cbec$var$useIsomorphicLayoutEffectWithArgs($da73e17b7bf0cbec$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $da73e17b7bf0cbec$var$useIsomorphicLayoutEffectWithArgs($da73e17b7bf0cbec$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $exYeM.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(WrappedComponent, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $exYeM.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Connect, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3e937fab5d08b2fc$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($3e937fab5d08b2fc$exports)))(Connect, WrappedComponent);
    };
}






function $79186b1347e0837d$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $79186b1347e0837d$export$2e2bcd8739ae039(objA, objB) {
    if ($79186b1347e0837d$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$79186b1347e0837d$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $3385aa56bff79008$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $e4386092954ceb4d$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f369395a3e846656$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $74dba1a05737752c$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $e4386092954ceb4d$export$2e2bcd8739ae039)(value)) (0, $f369395a3e846656$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $246b7e3866b09a5b$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $246b7e3866b09a5b$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $246b7e3866b09a5b$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $246b7e3866b09a5b$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $246b7e3866b09a5b$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $7d03cc2d807c81ef$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $246b7e3866b09a5b$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $7d03cc2d807c81ef$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $246b7e3866b09a5b$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $7d03cc2d807c81ef$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $246b7e3866b09a5b$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $3385aa56bff79008$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $7d03cc2d807c81ef$export$2e2bcd8739ae039 = [
    $7d03cc2d807c81ef$export$a9f27b4b187c1166,
    $7d03cc2d807c81ef$export$ba20d1a7aa0c4a90,
    $7d03cc2d807c81ef$export$94a6e55709d4d961
];



function $2a4d7ff6e7583c58$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $246b7e3866b09a5b$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : undefined;
}
function $2a4d7ff6e7583c58$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $246b7e3866b09a5b$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $2a4d7ff6e7583c58$export$2e2bcd8739ae039 = [
    $2a4d7ff6e7583c58$export$23fc470827b14aa,
    $2a4d7ff6e7583c58$export$514bc8c1a53c1d66
];




function $0be756095ffc76a7$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $0be756095ffc76a7$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $0be756095ffc76a7$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $0be756095ffc76a7$export$5b105939c84b5234(mergeProps) : undefined;
}
function $0be756095ffc76a7$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $0be756095ffc76a7$export$691c327fc30bc857;
    } : undefined;
}
var $0be756095ffc76a7$export$2e2bcd8739ae039 = [
    $0be756095ffc76a7$export$d61b680184bc3f00,
    $0be756095ffc76a7$export$a13ba70ef50dda6d
];




function $1d6831890964b57c$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $f369395a3e846656$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $1d6831890964b57c$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $1d6831890964b57c$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $1d6831890964b57c$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $1d6831890964b57c$var$verify(mergeProps, "mergeProps", displayName);
}


var $2c6ddf438287c610$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2c6ddf438287c610$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $2c6ddf438287c610$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $2c6ddf438287c610$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039)(_ref2, $2c6ddf438287c610$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $2c6ddf438287c610$export$d20c0c2ca6eb2b6f : $2c6ddf438287c610$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $0fab209944de0d1d$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $0fab209944de0d1d$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $0fab209944de0d1d$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $0fab209944de0d1d$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $da73e17b7bf0cbec$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $2a4d7ff6e7583c58$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $7d03cc2d807c81ef$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $0be756095ffc76a7$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $2c6ddf438287c610$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $0fab209944de0d1d$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $79186b1347e0837d$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $79186b1347e0837d$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $79186b1347e0837d$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039)(_ref3, $0fab209944de0d1d$var$_excluded);
        var initMapStateToProps = $0fab209944de0d1d$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $0fab209944de0d1d$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $0fab209944de0d1d$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $0fab209944de0d1d$export$2e2bcd8739ae039 = /*#__PURE__*/ $0fab209944de0d1d$export$9f9feb656dec1fc4();




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");

function $663244e6dd221645$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $exYeM.useContext)((0, $292c47c15d8911dd$export$cc80c08dc91f1c00));
    return contextValue;
}


function $583572886c074592$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $292c47c15d8911dd$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $292c47c15d8911dd$export$cc80c08dc91f1c00) ? (0, $663244e6dd221645$export$c1275ca9a6fd3ec5) : function() {
        return (0, $exYeM.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $583572886c074592$export$6ccbb43953eebf8 = /*#__PURE__*/ $583572886c074592$export$671dba69185d0304();


function $7d04a6771caa808b$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $292c47c15d8911dd$export$cc80c08dc91f1c00);
    var useStore = context === (0, $292c47c15d8911dd$export$cc80c08dc91f1c00) ? (0, $583572886c074592$export$6ccbb43953eebf8) : (0, $583572886c074592$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $7d04a6771caa808b$export$8ad76b76a4c905f8 = /*#__PURE__*/ $7d04a6771caa808b$export$bc9b55530897c558();



var $exYeM = parcelRequire("exYeM");




var $3f612f68535b3c24$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $3f612f68535b3c24$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $exYeM.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $exYeM.useMemo)(function() {
        return (0, $8e3e7e58cc06d162$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $exYeM.useRef)();
    var latestSelector = (0, $exYeM.useRef)();
    var latestStoreState = (0, $exYeM.useRef)();
    var latestSelectedState = (0, $exYeM.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $6dc04eb7cb81b757$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $6dc04eb7cb81b757$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $3f612f68535b3c24$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $292c47c15d8911dd$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $292c47c15d8911dd$export$cc80c08dc91f1c00) ? (0, $663244e6dd221645$export$c1275ca9a6fd3ec5) : function() {
        return (0, $exYeM.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $3f612f68535b3c24$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $3f612f68535b3c24$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $exYeM.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $3f612f68535b3c24$export$2105062e25df4afe = /*#__PURE__*/ $3f612f68535b3c24$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 
var $d2lNW = parcelRequire("d2lNW");


var $d2lNW = parcelRequire("d2lNW");

// with standard React renderers (ReactDOM, React Native)
(0, $a3f537480c29870f$export$4b9874722d0da7bc)((0, $d2lNW.unstable_batchedUpdates));



var $exYeM = parcelRequire("exYeM");
function $807e4fcd8ea6bc37$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $807e4fcd8ea6bc37$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $exYeM.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $exYeM.useRef)(true);
    var committed = (0, $exYeM.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $807e4fcd8ea6bc37$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $exYeM.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $807e4fcd8ea6bc37$export$33752cf3ee811995(callback, inputs) {
    return $807e4fcd8ea6bc37$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $807e4fcd8ea6bc37$export$1538c33de8887b59 = $807e4fcd8ea6bc37$export$b6feb8998cd9b342;
var $807e4fcd8ea6bc37$export$35808ee640e87ca7 = $807e4fcd8ea6bc37$export$33752cf3ee811995;


var $fe67decbbaf76e78$var$isProduction = true;
var $fe67decbbaf76e78$var$prefix = "Invariant failed";
function $fe67decbbaf76e78$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($fe67decbbaf76e78$var$isProduction) throw new Error($fe67decbbaf76e78$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($fe67decbbaf76e78$var$prefix, ": ").concat(provided) : $fe67decbbaf76e78$var$prefix;
    throw new Error(value);
}


var $55b9228df7b71ef4$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $55b9228df7b71ef4$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $55b9228df7b71ef4$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $55b9228df7b71ef4$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $55b9228df7b71ef4$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $55b9228df7b71ef4$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $55b9228df7b71ef4$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $55b9228df7b71ef4$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $55b9228df7b71ef4$var$noSpacing : _ref2$padding;
    var marginBox = $55b9228df7b71ef4$export$4b834cebd9e5cebe($55b9228df7b71ef4$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $55b9228df7b71ef4$export$4b834cebd9e5cebe($55b9228df7b71ef4$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $55b9228df7b71ef4$export$4b834cebd9e5cebe($55b9228df7b71ef4$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $55b9228df7b71ef4$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $55b9228df7b71ef4$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== "px") return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $fe67decbbaf76e78$export$2e2bcd8739ae039)(false);
    return result;
};
var $55b9228df7b71ef4$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $55b9228df7b71ef4$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $55b9228df7b71ef4$var$shift(borderBox, change);
    return $55b9228df7b71ef4$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $55b9228df7b71ef4$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $55b9228df7b71ef4$var$getWindowScroll();
    return $55b9228df7b71ef4$export$cc800923e997bb8(original, scroll);
};
var $55b9228df7b71ef4$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $55b9228df7b71ef4$var$parse(styles.marginTop),
        right: $55b9228df7b71ef4$var$parse(styles.marginRight),
        bottom: $55b9228df7b71ef4$var$parse(styles.marginBottom),
        left: $55b9228df7b71ef4$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $55b9228df7b71ef4$var$parse(styles.paddingTop),
        right: $55b9228df7b71ef4$var$parse(styles.paddingRight),
        bottom: $55b9228df7b71ef4$var$parse(styles.paddingBottom),
        left: $55b9228df7b71ef4$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $55b9228df7b71ef4$var$parse(styles.borderTopWidth),
        right: $55b9228df7b71ef4$var$parse(styles.borderRightWidth),
        bottom: $55b9228df7b71ef4$var$parse(styles.borderBottomWidth),
        left: $55b9228df7b71ef4$var$parse(styles.borderLeftWidth)
    };
    return $55b9228df7b71ef4$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $55b9228df7b71ef4$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $55b9228df7b71ef4$export$b8dfc5d4e552b8e1(borderBox, styles);
};


var $e66b69e563b626e6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e66b69e563b626e6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e66b69e563b626e6$var$safeIsNaN(first) && $e66b69e563b626e6$var$safeIsNaN(second)) return true;
    return false;
}
function $e66b69e563b626e6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e66b69e563b626e6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e66b69e563b626e6$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e66b69e563b626e6$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e66b69e563b626e6$export$2e2bcd8739ae039 = $e66b69e563b626e6$var$memoizeOne;


var $a88b6ea6b7ba9cc8$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $a88b6ea6b7ba9cc8$export$2e2bcd8739ae039 = $a88b6ea6b7ba9cc8$var$rafSchd;



var $d2lNW = parcelRequire("d2lNW");
var $c19d47723720dd4a$var$isProduction = true;
var $c19d47723720dd4a$var$spacesAndTabs = /[ \t]{2,}/g;
var $c19d47723720dd4a$var$lineStartWithSpaces = /^[ \t]*/gm;
var $c19d47723720dd4a$var$clean = function clean(value) {
    return value.replace($c19d47723720dd4a$var$spacesAndTabs, " ").replace($c19d47723720dd4a$var$lineStartWithSpaces, "").trim();
};
var $c19d47723720dd4a$var$getDevMessage = function getDevMessage(message) {
    return $c19d47723720dd4a$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $c19d47723720dd4a$var$clean(message) + "\n\n  %c\uD83D\uDC77‍ This is a development only message. It will be removed in production builds.\n");
};
var $c19d47723720dd4a$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $c19d47723720dd4a$var$getDevMessage(message),
        "color: #00C584; font-size: 1.2em; font-weight: bold;",
        "line-height: 1.5",
        "color: #723874;"
    ];
};
var $c19d47723720dd4a$var$isDisabledFlag = "__react-beautiful-dnd-disable-dev-warnings";
function $c19d47723720dd4a$var$log(type, message) {
    var _console;
    if ($c19d47723720dd4a$var$isProduction) return;
    if (typeof window !== "undefined" && window[$c19d47723720dd4a$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $c19d47723720dd4a$var$getFormattedMessage(message));
}
var $c19d47723720dd4a$var$warning = $c19d47723720dd4a$var$log.bind(null, "warn");
var $c19d47723720dd4a$var$error = $c19d47723720dd4a$var$log.bind(null, "error");
function $c19d47723720dd4a$var$noop() {}
function $c19d47723720dd4a$var$getOptions(shared, fromBinding) {
    return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, shared, {}, fromBinding);
}
function $c19d47723720dd4a$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $c19d47723720dd4a$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $c19d47723720dd4a$var$isProduction$1 = true;
var $c19d47723720dd4a$var$prefix = "Invariant failed";
function $c19d47723720dd4a$var$RbdInvariant(message) {
    this.message = message;
}
$c19d47723720dd4a$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $c19d47723720dd4a$var$invariant(condition, message) {
    if (condition) return;
    if ($c19d47723720dd4a$var$isProduction$1) throw new $c19d47723720dd4a$var$RbdInvariant($c19d47723720dd4a$var$prefix);
    else throw new $c19d47723720dd4a$var$RbdInvariant($c19d47723720dd4a$var$prefix + ": " + (message || ""));
}
var $c19d47723720dd4a$var$ErrorBoundary = function(_React$Component) {
    (0, $6ace560ed589c934$export$2e2bcd8739ae039)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $c19d47723720dd4a$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $c19d47723720dd4a$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $c19d47723720dd4a$var$bindEvents(window, [
            {
                eventName: "error",
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $c19d47723720dd4a$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Component);
var $c19d47723720dd4a$var$dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var $c19d47723720dd4a$var$position = function position(index) {
    return index + 1;
};
var $c19d47723720dd4a$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $c19d47723720dd4a$var$position(start.source.index) + "\n";
};
var $c19d47723720dd4a$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $c19d47723720dd4a$var$position(source.index);
    var endPosition = $c19d47723720dd4a$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $c19d47723720dd4a$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $c19d47723720dd4a$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $c19d47723720dd4a$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $c19d47723720dd4a$var$withCombine(update.draggableId, update.source, combine);
    return "You are over an area that cannot be dropped on";
};
var $c19d47723720dd4a$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $c19d47723720dd4a$var$position(source.index) + "\n";
};
var $c19d47723720dd4a$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === "CANCEL") return "\n      Movement cancelled.\n      " + $c19d47723720dd4a$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $c19d47723720dd4a$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $c19d47723720dd4a$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $c19d47723720dd4a$var$returnedToStart(result.source) + "\n  ";
};
var $c19d47723720dd4a$var$preset = {
    dragHandleUsageInstructions: $c19d47723720dd4a$var$dragHandleUsageInstructions,
    onDragStart: $c19d47723720dd4a$var$onDragStart,
    onDragUpdate: $c19d47723720dd4a$var$onDragUpdate,
    onDragEnd: $c19d47723720dd4a$var$onDragEnd
};
var $c19d47723720dd4a$var$origin = {
    x: 0,
    y: 0
};
var $c19d47723720dd4a$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $c19d47723720dd4a$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $c19d47723720dd4a$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $c19d47723720dd4a$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $c19d47723720dd4a$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === "x" ? "y" : "x"] = otherValue, _ref;
};
var $c19d47723720dd4a$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $c19d47723720dd4a$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $c19d47723720dd4a$var$distance(target, point);
    }));
};
var $c19d47723720dd4a$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $c19d47723720dd4a$var$executeClip = function(frame, subject) {
    var result = (0, $55b9228df7b71ef4$export$4b834cebd9e5cebe)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $c19d47723720dd4a$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $c19d47723720dd4a$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $c19d47723720dd4a$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $c19d47723720dd4a$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $c19d47723720dd4a$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $c19d47723720dd4a$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $c19d47723720dd4a$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $c19d47723720dd4a$var$executeClip(frame.pageMarginBox, target);
    return (0, $55b9228df7b71ef4$export$4b834cebd9e5cebe)(target);
};
var $c19d47723720dd4a$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $c19d47723720dd4a$var$scroll(page.marginBox, frame);
    var increased = $c19d47723720dd4a$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $c19d47723720dd4a$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $c19d47723720dd4a$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $c19d47723720dd4a$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $c19d47723720dd4a$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $c19d47723720dd4a$var$negate(scrollDiff);
    var frame = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $c19d47723720dd4a$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $c19d47723720dd4a$var$isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function $c19d47723720dd4a$var$values(map) {
    if (Object.values) return Object.values(map);
    return Object.keys(map).map(function(key) {
        return map[key];
    });
}
function $c19d47723720dd4a$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $c19d47723720dd4a$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $c19d47723720dd4a$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $c19d47723720dd4a$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $c19d47723720dd4a$var$toDroppableMap = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $c19d47723720dd4a$var$toDraggableMap = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $c19d47723720dd4a$var$toDroppableList = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(droppables) {
    return $c19d47723720dd4a$var$values(droppables);
});
var $c19d47723720dd4a$var$toDraggableList = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(draggables) {
    return $c19d47723720dd4a$var$values(draggables);
});
var $c19d47723720dd4a$var$getDraggablesInsideDroppable = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(droppableId, draggables) {
    var result = $c19d47723720dd4a$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $c19d47723720dd4a$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === "REORDER") return impact.at.destination;
    return null;
}
function $c19d47723720dd4a$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === "COMBINE") return impact.at.combine;
    return null;
}
var $c19d47723720dd4a$var$removeDraggableFromList = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $c19d47723720dd4a$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $c19d47723720dd4a$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: "COMBINE",
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $c19d47723720dd4a$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $c19d47723720dd4a$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $c19d47723720dd4a$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $c19d47723720dd4a$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $c19d47723720dd4a$var$noDisplacedBy = {
    point: $c19d47723720dd4a$var$origin,
    value: 0
};
var $c19d47723720dd4a$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $c19d47723720dd4a$var$noImpact = {
    displaced: $c19d47723720dd4a$var$emptyGroups,
    displacedBy: $c19d47723720dd4a$var$noDisplacedBy,
    at: null
};
var $c19d47723720dd4a$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $c19d47723720dd4a$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $c19d47723720dd4a$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $c19d47723720dd4a$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $c19d47723720dd4a$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $c19d47723720dd4a$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $c19d47723720dd4a$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $c19d47723720dd4a$var$vertical = {
    direction: "vertical",
    line: "y",
    crossAxisLine: "x",
    start: "top",
    end: "bottom",
    size: "height",
    crossAxisStart: "left",
    crossAxisEnd: "right",
    crossAxisSize: "width"
};
var $c19d47723720dd4a$var$horizontal = {
    direction: "horizontal",
    line: "x",
    crossAxisLine: "y",
    start: "left",
    end: "right",
    size: "width",
    crossAxisStart: "top",
    crossAxisEnd: "bottom",
    crossAxisSize: "height"
};
var $c19d47723720dd4a$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $c19d47723720dd4a$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $c19d47723720dd4a$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $c19d47723720dd4a$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $c19d47723720dd4a$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $c19d47723720dd4a$var$origin;
    return $c19d47723720dd4a$var$offsetByPosition(target, displacement);
};
var $c19d47723720dd4a$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $c19d47723720dd4a$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $c19d47723720dd4a$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $c19d47723720dd4a$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $c19d47723720dd4a$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $c19d47723720dd4a$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $c19d47723720dd4a$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $c19d47723720dd4a$var$isVisible((0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $c19d47723720dd4a$var$isPartiallyVisibleThroughFrame
    }));
};
var $c19d47723720dd4a$var$isTotallyVisible = function isTotallyVisible(args) {
    return $c19d47723720dd4a$var$isVisible((0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $c19d47723720dd4a$var$isTotallyVisibleThroughFrame
    }));
};
var $c19d47723720dd4a$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $c19d47723720dd4a$var$isVisible((0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $c19d47723720dd4a$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $c19d47723720dd4a$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === "boolean") return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $c19d47723720dd4a$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $55b9228df7b71ef4$export$4b834cebd9e5cebe)((0, $55b9228df7b71ef4$export$9f77e0932fb78f72)(marginBox, expandBy));
}
function $c19d47723720dd4a$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $c19d47723720dd4a$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $c19d47723720dd4a$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $c19d47723720dd4a$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $c19d47723720dd4a$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $c19d47723720dd4a$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $c19d47723720dd4a$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $c19d47723720dd4a$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $c19d47723720dd4a$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $c19d47723720dd4a$var$isHomeOf(draggable, destination);
    if (index == null) return $c19d47723720dd4a$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $c19d47723720dd4a$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $c19d47723720dd4a$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $c19d47723720dd4a$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $c19d47723720dd4a$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $c19d47723720dd4a$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $c19d47723720dd4a$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $c19d47723720dd4a$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $c19d47723720dd4a$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $c19d47723720dd4a$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $c19d47723720dd4a$var$invariant(false);
    if (wasAt.type === "REORDER") {
        var _newIndex = $c19d47723720dd4a$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $c19d47723720dd4a$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $c19d47723720dd4a$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $c19d47723720dd4a$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $c19d47723720dd4a$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($c19d47723720dd4a$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $c19d47723720dd4a$var$origin : $c19d47723720dd4a$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $c19d47723720dd4a$var$origin;
};
var $c19d47723720dd4a$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $c19d47723720dd4a$var$tryGetCombine(impact);
    !combine && $c19d47723720dd4a$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $c19d47723720dd4a$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $c19d47723720dd4a$var$add(center, displaceBy);
};
var $c19d47723720dd4a$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $c19d47723720dd4a$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $c19d47723720dd4a$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $c19d47723720dd4a$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $c19d47723720dd4a$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $c19d47723720dd4a$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $c19d47723720dd4a$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $c19d47723720dd4a$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $c19d47723720dd4a$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $c19d47723720dd4a$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $c19d47723720dd4a$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $c19d47723720dd4a$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $c19d47723720dd4a$var$patch(axis.line, moveInto.contentBox[axis.start] + $c19d47723720dd4a$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $c19d47723720dd4a$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $c19d47723720dd4a$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $c19d47723720dd4a$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $c19d47723720dd4a$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($c19d47723720dd4a$var$didStartAfterCritical(closestAfter, afterCritical)) return $c19d47723720dd4a$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $55b9228df7b71ef4$export$cc800923e997bb8)(closest.page, displacedBy.point);
        return $c19d47723720dd4a$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($c19d47723720dd4a$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $55b9228df7b71ef4$export$cc800923e997bb8)(last.page, $c19d47723720dd4a$var$negate(afterCritical.displacedBy.point));
        return $c19d47723720dd4a$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $c19d47723720dd4a$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $c19d47723720dd4a$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $c19d47723720dd4a$var$add(point, frame.scroll.diff.displacement);
};
var $c19d47723720dd4a$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === "REORDER") return $c19d47723720dd4a$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $c19d47723720dd4a$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $c19d47723720dd4a$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $c19d47723720dd4a$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $c19d47723720dd4a$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $c19d47723720dd4a$var$scrollViewport = function(viewport, newScroll) {
    var diff = $c19d47723720dd4a$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $c19d47723720dd4a$var$negate(diff);
    var frame = (0, $55b9228df7b71ef4$export$4b834cebd9e5cebe)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $c19d47723720dd4a$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $c19d47723720dd4a$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $c19d47723720dd4a$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $c19d47723720dd4a$var$scrollViewport(viewport, $c19d47723720dd4a$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $c19d47723720dd4a$var$scrollDroppable(destination, $c19d47723720dd4a$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $c19d47723720dd4a$var$getDisplacementGroups({
        afterDragging: $c19d47723720dd4a$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $c19d47723720dd4a$var$getDisplacementGroups({
        afterDragging: $c19d47723720dd4a$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $c19d47723720dd4a$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $c19d47723720dd4a$var$withViewportDisplacement = function(viewport, point) {
    return $c19d47723720dd4a$var$add(viewport.scroll.diff.displacement, point);
};
var $c19d47723720dd4a$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $c19d47723720dd4a$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $c19d47723720dd4a$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $c19d47723720dd4a$var$add(draggable.client.borderBox.center, offset);
};
var $c19d47723720dd4a$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $c19d47723720dd4a$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $c19d47723720dd4a$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $c19d47723720dd4a$var$isTotallyVisibleOnAxis(args) : $c19d47723720dd4a$var$isTotallyVisible(args);
};
var $c19d47723720dd4a$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $c19d47723720dd4a$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $c19d47723720dd4a$var$isHomeOf(draggable, destination);
    var impact = $c19d47723720dd4a$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $c19d47723720dd4a$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $c19d47723720dd4a$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $c19d47723720dd4a$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $c19d47723720dd4a$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $c19d47723720dd4a$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $c19d47723720dd4a$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $c19d47723720dd4a$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $c19d47723720dd4a$var$invariant(false);
    return rect;
};
var $c19d47723720dd4a$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $c19d47723720dd4a$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $c19d47723720dd4a$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $c19d47723720dd4a$var$isPartiallyVisibleThroughFrame(viewport.frame)($c19d47723720dd4a$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $c19d47723720dd4a$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $c19d47723720dd4a$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $c19d47723720dd4a$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $c19d47723720dd4a$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $c19d47723720dd4a$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $c19d47723720dd4a$var$getKnownActive(droppable)[axis.crossAxisStart] === $c19d47723720dd4a$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $c19d47723720dd4a$var$isWithin($c19d47723720dd4a$var$getKnownActive(droppable)[axis.start], $c19d47723720dd4a$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $c19d47723720dd4a$var$getKnownActive(a)[axis.start] - $c19d47723720dd4a$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $c19d47723720dd4a$var$closest(pageBorderBoxCenter, $c19d47723720dd4a$var$getCorners($c19d47723720dd4a$var$getKnownActive(a)));
        var second = $c19d47723720dd4a$var$closest(pageBorderBoxCenter, $c19d47723720dd4a$var$getCorners($c19d47723720dd4a$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $c19d47723720dd4a$var$getKnownActive(a)[axis.start] - $c19d47723720dd4a$var$getKnownActive(b)[axis.start];
    })[0];
};
var $c19d47723720dd4a$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $c19d47723720dd4a$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $c19d47723720dd4a$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $c19d47723720dd4a$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $c19d47723720dd4a$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $c19d47723720dd4a$var$offsetByPosition(original, $c19d47723720dd4a$var$negate(afterCritical.displacedBy.point)) : original;
};
var $c19d47723720dd4a$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $c19d47723720dd4a$var$isTotallyVisible({
            target: $c19d47723720dd4a$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $c19d47723720dd4a$var$distance(pageBorderBoxCenter, $c19d47723720dd4a$var$withDroppableDisplacement(destination, $c19d47723720dd4a$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $c19d47723720dd4a$var$distance(pageBorderBoxCenter, $c19d47723720dd4a$var$withDroppableDisplacement(destination, $c19d47723720dd4a$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $c19d47723720dd4a$var$getDisplacedBy = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $c19d47723720dd4a$var$patch(axis.line, displacement)
    };
});
var $c19d47723720dd4a$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === "virtual") return $c19d47723720dd4a$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $c19d47723720dd4a$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $c19d47723720dd4a$var$patch(axis.line, needsToGrowBy);
};
var $c19d47723720dd4a$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, frame, {
        scroll: (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, frame.scroll, {
            max: max
        })
    });
};
var $c19d47723720dd4a$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$c19d47723720dd4a$var$isHomeOf(draggable, droppable) && $c19d47723720dd4a$var$invariant(false);
    !!droppable.subject.withPlaceholder && $c19d47723720dd4a$var$invariant(false);
    var placeholderSize = $c19d47723720dd4a$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $c19d47723720dd4a$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $c19d47723720dd4a$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $c19d47723720dd4a$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $c19d47723720dd4a$var$withMaxScroll(frame, maxScroll);
    var subject = $c19d47723720dd4a$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $c19d47723720dd4a$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $c19d47723720dd4a$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $c19d47723720dd4a$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $c19d47723720dd4a$var$invariant(false);
    var newFrame = $c19d47723720dd4a$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $c19d47723720dd4a$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $c19d47723720dd4a$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $c19d47723720dd4a$var$emptyGroups,
            displacedBy: $c19d47723720dd4a$var$noDisplacedBy,
            at: {
                type: "REORDER",
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $c19d47723720dd4a$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $c19d47723720dd4a$var$isHomeOf(draggable, destination) ? destination : $c19d47723720dd4a$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $c19d47723720dd4a$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $c19d47723720dd4a$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $c19d47723720dd4a$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $c19d47723720dd4a$var$emptyGroups,
        index: proposedIndex
    });
};
var $c19d47723720dd4a$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $c19d47723720dd4a$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $c19d47723720dd4a$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $c19d47723720dd4a$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $c19d47723720dd4a$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $c19d47723720dd4a$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $c19d47723720dd4a$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $c19d47723720dd4a$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === "REORDER") return at.destination.droppableId;
    return at.combine.droppableId;
};
var $c19d47723720dd4a$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $c19d47723720dd4a$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $c19d47723720dd4a$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $c19d47723720dd4a$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $c19d47723720dd4a$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $c19d47723720dd4a$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $c19d47723720dd4a$var$isMovementAllowed(state) {
    return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function $c19d47723720dd4a$var$isPositionInFrame(frame) {
    var isWithinVertical = $c19d47723720dd4a$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $c19d47723720dd4a$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $c19d47723720dd4a$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $c19d47723720dd4a$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $c19d47723720dd4a$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $c19d47723720dd4a$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $c19d47723720dd4a$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $c19d47723720dd4a$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$c19d47723720dd4a$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($c19d47723720dd4a$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $c19d47723720dd4a$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $c19d47723720dd4a$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $c19d47723720dd4a$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $55b9228df7b71ef4$export$4b834cebd9e5cebe)($c19d47723720dd4a$var$offsetByPosition(rect, point));
};
var $c19d47723720dd4a$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $c19d47723720dd4a$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $c19d47723720dd4a$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $c19d47723720dd4a$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $c19d47723720dd4a$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $c19d47723720dd4a$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $c19d47723720dd4a$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $c19d47723720dd4a$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $c19d47723720dd4a$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $c19d47723720dd4a$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $c19d47723720dd4a$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $c19d47723720dd4a$var$isHomeOf(draggable, destination)
    });
    return $c19d47723720dd4a$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $c19d47723720dd4a$var$combineThresholdDivisor = 4;
var $c19d47723720dd4a$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $c19d47723720dd4a$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $c19d47723720dd4a$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $c19d47723720dd4a$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $c19d47723720dd4a$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $c19d47723720dd4a$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $c19d47723720dd4a$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: "COMBINE",
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $c19d47723720dd4a$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $c19d47723720dd4a$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $c19d47723720dd4a$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $c19d47723720dd4a$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $c19d47723720dd4a$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $c19d47723720dd4a$var$withDroppableScroll(destination, pageBorderBox);
    return $c19d47723720dd4a$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $c19d47723720dd4a$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $c19d47723720dd4a$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $c19d47723720dd4a$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $c19d47723720dd4a$var$whatIsDraggedOver(previousImpact);
    var now = $c19d47723720dd4a$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $c19d47723720dd4a$var$removePlaceholder(lastDroppable);
    return $c19d47723720dd4a$var$patchDroppableMap(droppables, updated);
};
var $c19d47723720dd4a$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $c19d47723720dd4a$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $c19d47723720dd4a$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($c19d47723720dd4a$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $c19d47723720dd4a$var$addPlaceholder(droppable, draggable, draggables);
    return $c19d47723720dd4a$var$patchDroppableMap(cleaned, patched);
};
var $c19d47723720dd4a$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $c19d47723720dd4a$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $c19d47723720dd4a$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $c19d47723720dd4a$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $c19d47723720dd4a$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $c19d47723720dd4a$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === "COLLECTING") return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        phase: "COLLECTING"
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $c19d47723720dd4a$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $c19d47723720dd4a$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $c19d47723720dd4a$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $c19d47723720dd4a$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $c19d47723720dd4a$var$getDraggables$1(last.all, draggables);
    var displaced = $c19d47723720dd4a$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, impact, {
        displaced: displaced
    });
};
var $c19d47723720dd4a$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $c19d47723720dd4a$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $c19d47723720dd4a$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $c19d47723720dd4a$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === "SNAP") && $c19d47723720dd4a$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $c19d47723720dd4a$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $c19d47723720dd4a$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $c19d47723720dd4a$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $c19d47723720dd4a$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $c19d47723720dd4a$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $c19d47723720dd4a$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $c19d47723720dd4a$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $c19d47723720dd4a$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $c19d47723720dd4a$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $c19d47723720dd4a$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === "virtual",
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $c19d47723720dd4a$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: $c19d47723720dd4a$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $c19d47723720dd4a$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $c19d47723720dd4a$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $c19d47723720dd4a$var$start = function start(key) {};
var $c19d47723720dd4a$var$finish = function finish(key) {};
var $c19d47723720dd4a$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $55b9228df7b71ef4$export$cc800923e997bb8)(draggable.client, offset$1);
    var page = (0, $55b9228df7b71ef4$export$1d0caec378d7d0ae)(client, initialWindowScroll);
    var moved = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, draggable, {
        placeholder: (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $c19d47723720dd4a$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $c19d47723720dd4a$var$invariant(false);
    return frame;
};
var $c19d47723720dd4a$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $c19d47723720dd4a$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $c19d47723720dd4a$var$add(windowScrollChange, droppableScrollChange);
        var moved = $c19d47723720dd4a$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $c19d47723720dd4a$var$publishWhileDraggingInVirtual = function(_ref) {
    var state = _ref.state, published = _ref.published;
    $c19d47723720dd4a$var$start();
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $c19d47723720dd4a$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, state.dimensions.droppables, {}, $c19d47723720dd4a$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $c19d47723720dd4a$var$toDraggableMap($c19d47723720dd4a$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, state.dimensions.draggables, {}, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $c19d47723720dd4a$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $c19d47723720dd4a$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $c19d47723720dd4a$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $c19d47723720dd4a$var$finish();
    var draggingState = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        phase: "DRAGGING"
    }, state, {
        phase: "DRAGGING",
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    });
    if (state.phase === "COLLECTING") return draggingState;
    var dropPending = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        phase: "DROP_PENDING"
    }, draggingState, {
        phase: "DROP_PENDING",
        reason: state.reason,
        isWaiting: false
    });
    return dropPending;
};
var $c19d47723720dd4a$var$isSnapping = function isSnapping(state) {
    return state.movementMode === "SNAP";
};
var $c19d47723720dd4a$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $c19d47723720dd4a$var$patchDimensionMap(state.dimensions, updated);
    if (!$c19d47723720dd4a$var$isSnapping(state) || isEnabledChanging) return $c19d47723720dd4a$var$update({
        state: state,
        dimensions: dimensions
    });
    return $c19d47723720dd4a$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $c19d47723720dd4a$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === "SNAP") return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
        phase: "DRAGGING"
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $c19d47723720dd4a$var$idle = {
    phase: "IDLE",
    completed: null,
    shouldFlush: false
};
var $c19d47723720dd4a$var$reducer = function(state, action) {
    if (state === void 0) state = $c19d47723720dd4a$var$idle;
    if (action.type === "FLUSH") return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, $c19d47723720dd4a$var$idle, {
        shouldFlush: true
    });
    if (action.type === "INITIAL_PUBLISH") {
        !(state.phase === "IDLE") && $c19d47723720dd4a$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $c19d47723720dd4a$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $c19d47723720dd4a$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $c19d47723720dd4a$var$add(client.selection, viewport.scroll.initial),
                offset: $c19d47723720dd4a$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $c19d47723720dd4a$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $c19d47723720dd4a$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: "DRAGGING",
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === "COLLECTION_STARTING") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $c19d47723720dd4a$var$invariant(false);
        var _result = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
            phase: "COLLECTING"
        }, state, {
            phase: "COLLECTING"
        });
        return _result;
    }
    if (action.type === "PUBLISH_WHILE_DRAGGING") {
        !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") && $c19d47723720dd4a$var$invariant(false);
        return $c19d47723720dd4a$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === "MOVE") {
        if (state.phase === "DROP_PENDING") return state;
        !$c19d47723720dd4a$var$isMovementAllowed(state) && $c19d47723720dd4a$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($c19d47723720dd4a$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $c19d47723720dd4a$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $c19d47723720dd4a$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === "UPDATE_DROPPABLE_SCROLL") {
        if (state.phase === "DROP_PENDING") return $c19d47723720dd4a$var$removeScrollJumpRequest(state);
        if (state.phase === "COLLECTING") return $c19d47723720dd4a$var$removeScrollJumpRequest(state);
        !$c19d47723720dd4a$var$isMovementAllowed(state) && $c19d47723720dd4a$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $c19d47723720dd4a$var$scrollDroppable(target, newScroll);
        return $c19d47723720dd4a$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$c19d47723720dd4a$var$isMovementAllowed(state) && $c19d47723720dd4a$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $c19d47723720dd4a$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $c19d47723720dd4a$var$invariant(false);
        var updated = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, _target, {
            isEnabled: isEnabled
        });
        return $c19d47723720dd4a$var$postDroppableChange(state, updated, true);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$c19d47723720dd4a$var$isMovementAllowed(state) && $c19d47723720dd4a$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $c19d47723720dd4a$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $c19d47723720dd4a$var$invariant(false);
        var _updated = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $c19d47723720dd4a$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === "MOVE_BY_WINDOW_SCROLL") {
        if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") return state;
        !$c19d47723720dd4a$var$isMovementAllowed(state) && $c19d47723720dd4a$var$invariant(false);
        !state.isWindowScrollAllowed && $c19d47723720dd4a$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($c19d47723720dd4a$var$isEqual(state.viewport.scroll.current, _newScroll)) return $c19d47723720dd4a$var$removeScrollJumpRequest(state);
        var _viewport = $c19d47723720dd4a$var$scrollViewport(state.viewport, _newScroll);
        if ($c19d47723720dd4a$var$isSnapping(state)) return $c19d47723720dd4a$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $c19d47723720dd4a$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
        if (!$c19d47723720dd4a$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($c19d47723720dd4a$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, state.viewport, {
            scroll: (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
            phase: "DRAGGING"
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $c19d47723720dd4a$var$invariant(false);
        var _result2 = $c19d47723720dd4a$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $c19d47723720dd4a$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === "DROP_PENDING") {
        var reason = action.payload.reason;
        !(state.phase === "COLLECTING") && $c19d47723720dd4a$var$invariant(false);
        var newState = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
            phase: "DROP_PENDING"
        }, state, {
            phase: "DROP_PENDING",
            isWaiting: true,
            reason: reason
        });
        return newState;
    }
    if (action.type === "DROP_ANIMATE") {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $c19d47723720dd4a$var$invariant(false);
        var _result3 = {
            phase: "DROP_ANIMATING",
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === "DROP_COMPLETE") {
        var _completed = action.payload.completed;
        return {
            phase: "IDLE",
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $c19d47723720dd4a$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: "BEFORE_INITIAL_CAPTURE",
        payload: args
    };
};
var $c19d47723720dd4a$var$lift = function lift(args) {
    return {
        type: "LIFT",
        payload: args
    };
};
var $c19d47723720dd4a$var$initialPublish = function initialPublish(args) {
    return {
        type: "INITIAL_PUBLISH",
        payload: args
    };
};
var $c19d47723720dd4a$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: "PUBLISH_WHILE_DRAGGING",
        payload: args
    };
};
var $c19d47723720dd4a$var$collectionStarting = function collectionStarting() {
    return {
        type: "COLLECTION_STARTING",
        payload: null
    };
};
var $c19d47723720dd4a$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: "UPDATE_DROPPABLE_SCROLL",
        payload: args
    };
};
var $c19d47723720dd4a$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_ENABLED",
        payload: args
    };
};
var $c19d47723720dd4a$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
        payload: args
    };
};
var $c19d47723720dd4a$var$move = function move(args) {
    return {
        type: "MOVE",
        payload: args
    };
};
var $c19d47723720dd4a$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: "MOVE_BY_WINDOW_SCROLL",
        payload: args
    };
};
var $c19d47723720dd4a$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: "UPDATE_VIEWPORT_MAX_SCROLL",
        payload: args
    };
};
var $c19d47723720dd4a$var$moveUp = function moveUp() {
    return {
        type: "MOVE_UP",
        payload: null
    };
};
var $c19d47723720dd4a$var$moveDown = function moveDown() {
    return {
        type: "MOVE_DOWN",
        payload: null
    };
};
var $c19d47723720dd4a$var$moveRight = function moveRight() {
    return {
        type: "MOVE_RIGHT",
        payload: null
    };
};
var $c19d47723720dd4a$var$moveLeft = function moveLeft() {
    return {
        type: "MOVE_LEFT",
        payload: null
    };
};
var $c19d47723720dd4a$var$flush = function flush() {
    return {
        type: "FLUSH",
        payload: null
    };
};
var $c19d47723720dd4a$var$animateDrop = function animateDrop(args) {
    return {
        type: "DROP_ANIMATE",
        payload: args
    };
};
var $c19d47723720dd4a$var$completeDrop = function completeDrop(args) {
    return {
        type: "DROP_COMPLETE",
        payload: args
    };
};
var $c19d47723720dd4a$var$drop = function drop(args) {
    return {
        type: "DROP",
        payload: args
    };
};
var $c19d47723720dd4a$var$dropPending = function dropPending(args) {
    return {
        type: "DROP_PENDING",
        payload: args
    };
};
var $c19d47723720dd4a$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: "DROP_ANIMATION_FINISHED",
        payload: null
    };
};
function $c19d47723720dd4a$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(", ");
}
function $c19d47723720dd4a$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $c19d47723720dd4a$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== "LIFT") {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === "DROP_ANIMATING") dispatch($c19d47723720dd4a$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === "IDLE") && $c19d47723720dd4a$var$invariant(false);
                dispatch($c19d47723720dd4a$var$flush());
                dispatch($c19d47723720dd4a$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === "SNAP"
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $c19d47723720dd4a$var$validateDimensions(critical, dimensions);
                dispatch($c19d47723720dd4a$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $c19d47723720dd4a$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") marshal.dragging();
                if (action.type === "DROP_ANIMATE") marshal.dropping(action.payload.completed.result.reason);
                if (action.type === "FLUSH" || action.type === "DROP_COMPLETE") marshal.resting();
                next(action);
            };
        };
    };
};
var $c19d47723720dd4a$var$curves = {
    outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
    drop: "cubic-bezier(.2,1,.1,1)"
};
var $c19d47723720dd4a$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $c19d47723720dd4a$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $c19d47723720dd4a$var$outOfTheWayTiming = $c19d47723720dd4a$var$timings.outOfTheWay + "s " + $c19d47723720dd4a$var$curves.outOfTheWay;
var $c19d47723720dd4a$var$transitions = {
    fluid: "opacity " + $c19d47723720dd4a$var$outOfTheWayTiming,
    snap: "transform " + $c19d47723720dd4a$var$outOfTheWayTiming + ", opacity " + $c19d47723720dd4a$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $c19d47723720dd4a$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $c19d47723720dd4a$var$outOfTheWayTiming,
    placeholder: "height " + $c19d47723720dd4a$var$outOfTheWayTiming + ", width " + $c19d47723720dd4a$var$outOfTheWayTiming + ", margin " + $c19d47723720dd4a$var$outOfTheWayTiming
};
var $c19d47723720dd4a$var$moveTo = function moveTo(offset) {
    return $c19d47723720dd4a$var$isEqual(offset, $c19d47723720dd4a$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $c19d47723720dd4a$var$transforms = {
    moveTo: $c19d47723720dd4a$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $c19d47723720dd4a$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $c19d47723720dd4a$var$combine.scale.drop + ")";
    }
};
var $c19d47723720dd4a$var$minDropTime = $c19d47723720dd4a$var$timings.minDropTime, $c19d47723720dd4a$var$maxDropTime = $c19d47723720dd4a$var$timings.maxDropTime;
var $c19d47723720dd4a$var$dropTimeRange = $c19d47723720dd4a$var$maxDropTime - $c19d47723720dd4a$var$minDropTime;
var $c19d47723720dd4a$var$maxDropTimeAtDistance = 1500;
var $c19d47723720dd4a$var$cancelDropModifier = 0.6;
var $c19d47723720dd4a$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $c19d47723720dd4a$var$distance(current, destination);
    if (distance$1 <= 0) return $c19d47723720dd4a$var$minDropTime;
    if (distance$1 >= $c19d47723720dd4a$var$maxDropTimeAtDistance) return $c19d47723720dd4a$var$maxDropTime;
    var percentage = distance$1 / $c19d47723720dd4a$var$maxDropTimeAtDistance;
    var duration = $c19d47723720dd4a$var$minDropTime + $c19d47723720dd4a$var$dropTimeRange * percentage;
    var withDuration = reason === "CANCEL" ? duration * $c19d47723720dd4a$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $c19d47723720dd4a$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $c19d47723720dd4a$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $c19d47723720dd4a$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $c19d47723720dd4a$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $c19d47723720dd4a$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== "DROP") {
        var recomputedHomeImpact = $c19d47723720dd4a$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === "REORDER") return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, lastImpact, {
        displaced: $c19d47723720dd4a$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $c19d47723720dd4a$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== "DROP") {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === "COLLECTING") {
                dispatch($c19d47723720dd4a$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === "IDLE") return;
            var isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
            !!isWaitingForDrop && $c19d47723720dd4a$var$invariant(false);
            !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $c19d47723720dd4a$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $c19d47723720dd4a$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $c19d47723720dd4a$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $c19d47723720dd4a$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $c19d47723720dd4a$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$c19d47723720dd4a$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($c19d47723720dd4a$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $c19d47723720dd4a$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($c19d47723720dd4a$var$animateDrop(args));
        };
    };
};
var $c19d47723720dd4a$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $c19d47723720dd4a$var$getWindowScrollBinding(update) {
    return {
        eventName: "scroll",
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $c19d47723720dd4a$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($c19d47723720dd4a$var$getWindowScroll());
    }
    var scheduled = (0, $a88b6ea6b7ba9cc8$export$2e2bcd8739ae039)(updateScroll);
    var binding = $c19d47723720dd4a$var$getWindowScrollBinding(scheduled);
    var unbind = $c19d47723720dd4a$var$noop;
    function isActive() {
        return unbind !== $c19d47723720dd4a$var$noop;
    }
    function start() {
        !!isActive() && $c19d47723720dd4a$var$invariant(false);
        unbind = $c19d47723720dd4a$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $c19d47723720dd4a$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $c19d47723720dd4a$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $c19d47723720dd4a$var$shouldEnd = function shouldEnd(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $c19d47723720dd4a$var$scrollListener = function(store) {
    var listener = $c19d47723720dd4a$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($c19d47723720dd4a$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === "INITIAL_PUBLISH") listener.start();
            if (listener.isActive() && $c19d47723720dd4a$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $c19d47723720dd4a$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $c19d47723720dd4a$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $c19d47723720dd4a$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $c19d47723720dd4a$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $c19d47723720dd4a$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $c19d47723720dd4a$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $c19d47723720dd4a$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $c19d47723720dd4a$var$withTimings = function withTimings(key, fn) {
    $c19d47723720dd4a$var$start();
    fn();
    $c19d47723720dd4a$var$finish();
};
var $c19d47723720dd4a$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $c19d47723720dd4a$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $c19d47723720dd4a$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $c19d47723720dd4a$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $c19d47723720dd4a$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $c19d47723720dd4a$var$invariant(false);
        $c19d47723720dd4a$var$withTimings("onBeforeCapture", function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $c19d47723720dd4a$var$invariant(false);
        $c19d47723720dd4a$var$withTimings("onBeforeDragStart", function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($c19d47723720dd4a$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $c19d47723720dd4a$var$invariant(false);
        var data = $c19d47723720dd4a$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $c19d47723720dd4a$var$withTimings("onDragStart", function() {
                return $c19d47723720dd4a$var$execute(getResponders().onDragStart, data, announce, $c19d47723720dd4a$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $c19d47723720dd4a$var$tryGetDestination(impact);
        var combine = $c19d47723720dd4a$var$tryGetCombine(impact);
        !dragging && $c19d47723720dd4a$var$invariant(false);
        var hasCriticalChanged = !$c19d47723720dd4a$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$c19d47723720dd4a$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$c19d47723720dd4a$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, $c19d47723720dd4a$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $c19d47723720dd4a$var$withTimings("onDragUpdate", function() {
                return $c19d47723720dd4a$var$execute(getResponders().onDragUpdate, data, announce, $c19d47723720dd4a$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $c19d47723720dd4a$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $c19d47723720dd4a$var$invariant(false);
        dragging = null;
        $c19d47723720dd4a$var$withTimings("onDragEnd", function() {
            return $c19d47723720dd4a$var$execute(getResponders().onDragEnd, result, announce, $c19d47723720dd4a$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, $c19d47723720dd4a$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: "CANCEL"
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $c19d47723720dd4a$var$responders = function(getResponders, announce) {
    var publisher = $c19d47723720dd4a$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === "BEFORE_INITIAL_CAPTURE") {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === "FLUSH") {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === "DRAGGING") publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $c19d47723720dd4a$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== "DROP_ANIMATION_FINISHED") {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === "DROP_ANIMATING") && $c19d47723720dd4a$var$invariant(false);
            store.dispatch($c19d47723720dd4a$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $c19d47723720dd4a$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === "FLUSH" || action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATION_FINISHED") clear();
            next(action);
            if (action.type !== "DROP_ANIMATE") return;
            var binding = {
                eventName: "scroll",
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === "DROP_ANIMATING") store.dispatch($c19d47723720dd4a$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $c19d47723720dd4a$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $c19d47723720dd4a$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "DROP_COMPLETE" || action.type === "FLUSH" || action.type === "DROP_ANIMATE") marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $c19d47723720dd4a$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === "FLUSH") {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $c19d47723720dd4a$var$shouldStop = function shouldStop(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $c19d47723720dd4a$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($c19d47723720dd4a$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    next(action);
                    var state = store.getState();
                    !(state.phase === "DRAGGING") && $c19d47723720dd4a$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $c19d47723720dd4a$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== "PUBLISH_WHILE_DRAGGING") return;
            var postActionState = store.getState();
            if (postActionState.phase !== "DROP_PENDING") return;
            if (postActionState.isWaiting) return;
            store.dispatch($c19d47723720dd4a$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $c19d47723720dd4a$var$composeEnhancers = (0, $30ea8dc1329995fa$export$f672e0b6f7222cd7);
var $c19d47723720dd4a$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $30ea8dc1329995fa$export$f51a9068ac82ea43)($c19d47723720dd4a$var$reducer, $c19d47723720dd4a$var$composeEnhancers((0, $30ea8dc1329995fa$export$9ff26e0402cc7b7)($c19d47723720dd4a$var$style(styleMarshal), $c19d47723720dd4a$var$dimensionMarshalStopper(dimensionMarshal), $c19d47723720dd4a$var$lift$1(dimensionMarshal), $c19d47723720dd4a$var$drop$1, $c19d47723720dd4a$var$dropAnimationFinish, $c19d47723720dd4a$var$dropAnimationFlushOnScroll, $c19d47723720dd4a$var$pendingDrop, $c19d47723720dd4a$var$autoScroll(autoScroller), $c19d47723720dd4a$var$scrollListener, $c19d47723720dd4a$var$focus(focusMarshal), $c19d47723720dd4a$var$responders(getResponders, announce))));
};
var $c19d47723720dd4a$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
function $c19d47723720dd4a$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $c19d47723720dd4a$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $c19d47723720dd4a$var$start();
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = Object.keys(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($c19d47723720dd4a$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = Object.keys(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $c19d47723720dd4a$var$clean$1();
            $c19d47723720dd4a$var$finish();
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $c19d47723720dd4a$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $c19d47723720dd4a$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $c19d47723720dd4a$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $c19d47723720dd4a$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $c19d47723720dd4a$var$invariant(false);
    return doc;
};
var $c19d47723720dd4a$var$getMaxWindowScroll = function() {
    var doc = $c19d47723720dd4a$var$getDocumentElement();
    var maxScroll = $c19d47723720dd4a$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $c19d47723720dd4a$var$getViewport = function() {
    var scroll = $c19d47723720dd4a$var$getWindowScroll();
    var maxScroll = $c19d47723720dd4a$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $c19d47723720dd4a$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $55b9228df7b71ef4$export$4b834cebd9e5cebe)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $c19d47723720dd4a$var$origin,
                displacement: $c19d47723720dd4a$var$origin
            }
        }
    };
    return viewport;
};
var $c19d47723720dd4a$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    $c19d47723720dd4a$var$start();
    var viewport = $c19d47723720dd4a$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $c19d47723720dd4a$var$toDraggableMap(draggables),
        droppables: $c19d47723720dd4a$var$toDroppableMap(droppables)
    };
    $c19d47723720dd4a$var$finish();
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $c19d47723720dd4a$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== "virtual") return false;
    return true;
}
var $c19d47723720dd4a$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $c19d47723720dd4a$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $c19d47723720dd4a$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $c19d47723720dd4a$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $c19d47723720dd4a$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $c19d47723720dd4a$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === "ADDITION") {
            if ($c19d47723720dd4a$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === "REMOVAL") {
            if ($c19d47723720dd4a$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $c19d47723720dd4a$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $c19d47723720dd4a$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $c19d47723720dd4a$var$canStartDrag = function(state, id) {
    if (state.phase === "IDLE") return true;
    if (state.phase !== "DROP_ANIMATING") return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === "DROP";
};
var $c19d47723720dd4a$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $c19d47723720dd4a$var$getScrollableDroppables = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(droppables) {
    return $c19d47723720dd4a$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $c19d47723720dd4a$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $c19d47723720dd4a$var$find($c19d47723720dd4a$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $c19d47723720dd4a$var$invariant(false);
        return $c19d47723720dd4a$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $c19d47723720dd4a$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $c19d47723720dd4a$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $c19d47723720dd4a$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $c19d47723720dd4a$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $c19d47723720dd4a$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $c19d47723720dd4a$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $c19d47723720dd4a$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $c19d47723720dd4a$var$minScroll = 1;
var $c19d47723720dd4a$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $c19d47723720dd4a$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $c19d47723720dd4a$var$minScroll;
    var percentageFromMaxScrollValueAt = $c19d47723720dd4a$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $c19d47723720dd4a$var$config.maxPixelScroll * $c19d47723720dd4a$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $c19d47723720dd4a$var$accelerateAt = $c19d47723720dd4a$var$config.durationDampening.accelerateAt;
var $c19d47723720dd4a$var$stopAt = $c19d47723720dd4a$var$config.durationDampening.stopDampeningAt;
var $c19d47723720dd4a$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $c19d47723720dd4a$var$stopAt;
    var now = Date.now();
    var runTime = now - startOfRange;
    if (runTime >= $c19d47723720dd4a$var$stopAt) return proposedScroll;
    if (runTime < $c19d47723720dd4a$var$accelerateAt) return $c19d47723720dd4a$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $c19d47723720dd4a$var$getPercentage({
        startOfRange: $c19d47723720dd4a$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $c19d47723720dd4a$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $c19d47723720dd4a$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $c19d47723720dd4a$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($c19d47723720dd4a$var$dampenValueByTime(scroll, dragStartTime), $c19d47723720dd4a$var$minScroll);
};
var $c19d47723720dd4a$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $c19d47723720dd4a$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $c19d47723720dd4a$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $c19d47723720dd4a$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $c19d47723720dd4a$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $c19d47723720dd4a$var$clean$2 = $c19d47723720dd4a$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $c19d47723720dd4a$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $c19d47723720dd4a$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $c19d47723720dd4a$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $c19d47723720dd4a$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $c19d47723720dd4a$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $c19d47723720dd4a$var$clean$2({
        x: x,
        y: y
    });
    if ($c19d47723720dd4a$var$isEqual(required, $c19d47723720dd4a$var$origin)) return null;
    var limited = $c19d47723720dd4a$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $c19d47723720dd4a$var$isEqual(limited, $c19d47723720dd4a$var$origin) ? null : limited;
};
var $c19d47723720dd4a$var$smallestSigned = $c19d47723720dd4a$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $c19d47723720dd4a$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $c19d47723720dd4a$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($c19d47723720dd4a$var$isEqual(overlap, $c19d47723720dd4a$var$origin)) return null;
        return overlap;
    };
}();
var $c19d47723720dd4a$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $c19d47723720dd4a$var$smallestSigned(change);
    var overlap = $c19d47723720dd4a$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $c19d47723720dd4a$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $c19d47723720dd4a$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $c19d47723720dd4a$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$c19d47723720dd4a$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $c19d47723720dd4a$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $c19d47723720dd4a$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $c19d47723720dd4a$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $c19d47723720dd4a$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$c19d47723720dd4a$var$canScrollDroppable(droppable, change)) return null;
    return $c19d47723720dd4a$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $c19d47723720dd4a$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $c19d47723720dd4a$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $c19d47723720dd4a$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $c19d47723720dd4a$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $c19d47723720dd4a$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $c19d47723720dd4a$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $c19d47723720dd4a$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $c19d47723720dd4a$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $c19d47723720dd4a$var$getBestScrollableDroppable({
        center: center,
        destination: $c19d47723720dd4a$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $c19d47723720dd4a$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $c19d47723720dd4a$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $a88b6ea6b7ba9cc8$export$2e2bcd8739ae039)(scrollWindow);
    var scheduleDroppableScroll = (0, $a88b6ea6b7ba9cc8$export$2e2bcd8739ae039)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $c19d47723720dd4a$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $c19d47723720dd4a$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $c19d47723720dd4a$var$start();
        !!dragging && $c19d47723720dd4a$var$invariant(false);
        var dragStartTime = Date.now();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $c19d47723720dd4a$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $c19d47723720dd4a$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $c19d47723720dd4a$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $c19d47723720dd4a$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$c19d47723720dd4a$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $c19d47723720dd4a$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $c19d47723720dd4a$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $c19d47723720dd4a$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$c19d47723720dd4a$var$canScrollWindow(viewport, change)) return change;
        var overlap = $c19d47723720dd4a$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $c19d47723720dd4a$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $c19d47723720dd4a$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $c19d47723720dd4a$var$whatIsDraggedOver(state.impact);
        !destination && $c19d47723720dd4a$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $c19d47723720dd4a$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $c19d47723720dd4a$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $c19d47723720dd4a$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== "DRAGGING") return;
        if (state.movementMode === "FLUID") {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $c19d47723720dd4a$var$prefix$1 = "data-rbd";
var $c19d47723720dd4a$var$dragHandle = function() {
    var base = $c19d47723720dd4a$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $c19d47723720dd4a$var$draggable = function() {
    var base = $c19d47723720dd4a$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $c19d47723720dd4a$var$droppable = function() {
    var base = $c19d47723720dd4a$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $c19d47723720dd4a$var$scrollContainer = {
    contextId: $c19d47723720dd4a$var$prefix$1 + "-scroll-container-context-id"
};
var $c19d47723720dd4a$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + '="' + context + '"]';
    };
};
var $c19d47723720dd4a$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return "";
        return rule.selector + " { " + value + " }";
    }).join(" ");
};
var $c19d47723720dd4a$var$noPointerEvents = "pointer-events: none;";
var $c19d47723720dd4a$var$getStyles$1 = function(contextId) {
    var getSelector = $c19d47723720dd4a$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($c19d47723720dd4a$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $c19d47723720dd4a$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $c19d47723720dd4a$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($c19d47723720dd4a$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($c19d47723720dd4a$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: "body",
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $c19d47723720dd4a$var$getStyles(rules, "always"),
        resting: $c19d47723720dd4a$var$getStyles(rules, "resting"),
        dragging: $c19d47723720dd4a$var$getStyles(rules, "dragging"),
        dropAnimating: $c19d47723720dd4a$var$getStyles(rules, "dropAnimating"),
        userCancel: $c19d47723720dd4a$var$getStyles(rules, "userCancel")
    };
};
var $c19d47723720dd4a$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
var $c19d47723720dd4a$var$getHead = function getHead() {
    var head = document.querySelector("head");
    !head && $c19d47723720dd4a$var$invariant(false);
    return head;
};
var $c19d47723720dd4a$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.type = "text/css";
    return el;
};
function $c19d47723720dd4a$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return $c19d47723720dd4a$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $exYeM.useRef)(null);
    var dynamicRef = (0, $exYeM.useRef)(null);
    var setDynamicStyle = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)((0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(proposed) {
        var el = dynamicRef.current;
        !el && $c19d47723720dd4a$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(proposed) {
        var el = alwaysRef.current;
        !el && $c19d47723720dd4a$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $c19d47723720dd4a$var$invariant(false);
        var always = $c19d47723720dd4a$var$createStyleEl(nonce);
        var dynamic = $c19d47723720dd4a$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($c19d47723720dd4a$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($c19d47723720dd4a$var$prefix$1 + "-dynamic", contextId);
        $c19d47723720dd4a$var$getHead().appendChild(always);
        $c19d47723720dd4a$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $c19d47723720dd4a$var$invariant(false);
                $c19d47723720dd4a$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(reason) {
        if (reason === "DROP") {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $c19d47723720dd4a$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $c19d47723720dd4a$var$isHtmlElement(el) {
    return el instanceof $c19d47723720dd4a$var$getWindowFromEl(el).HTMLElement;
}
function $c19d47723720dd4a$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $c19d47723720dd4a$var$dragHandle.contextId + '="' + contextId + '"]';
    var possible = $c19d47723720dd4a$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $c19d47723720dd4a$var$find(possible, function(el) {
        return el.getAttribute($c19d47723720dd4a$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$c19d47723720dd4a$var$isHtmlElement(handle)) return null;
    return handle;
}
function $c19d47723720dd4a$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $exYeM.useRef)({});
    var recordRef = (0, $exYeM.useRef)(null);
    var restoreFocusFrameRef = (0, $exYeM.useRef)(null);
    var isMountedRef = (0, $exYeM.useRef)(false);
    var register = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $c19d47723720dd4a$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($c19d47723720dd4a$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $c19d47723720dd4a$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $c19d47723720dd4a$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: "ADDITION",
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: "REMOVAL",
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $c19d47723720dd4a$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $c19d47723720dd4a$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $c19d47723720dd4a$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $c19d47723720dd4a$var$useRegistry() {
    var registry = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)($c19d47723720dd4a$var$createRegistry, []);
    (0, $exYeM.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $c19d47723720dd4a$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
var $c19d47723720dd4a$var$getBodyElement = function() {
    var body = document.body;
    !body && $c19d47723720dd4a$var$invariant(false);
    return body;
};
var $c19d47723720dd4a$var$visuallyHidden = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: "0",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    "clip-path": "inset(100%)"
};
var $c19d47723720dd4a$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $c19d47723720dd4a$var$useAnnouncer(contextId) {
    var id = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return $c19d47723720dd4a$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $exYeM.useRef)(null);
    (0, $exYeM.useEffect)(function setup() {
        var el = document.createElement("div");
        ref.current = el;
        el.id = id;
        el.setAttribute("aria-live", "assertive");
        el.setAttribute("aria-atomic", "true");
        (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)(el.style, $c19d47723720dd4a$var$visuallyHidden);
        $c19d47723720dd4a$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                var body = $c19d47723720dd4a$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $c19d47723720dd4a$var$count = 0;
var $c19d47723720dd4a$var$defaults = {
    separator: "::"
};
function $c19d47723720dd4a$var$reset() {
    $c19d47723720dd4a$var$count = 0;
}
function $c19d47723720dd4a$var$useUniqueId(prefix, options) {
    if (options === void 0) options = $c19d47723720dd4a$var$defaults;
    return (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return "" + prefix + options.separator + $c19d47723720dd4a$var$count++;
    }, [
        options.separator,
        prefix
    ]);
}
function $c19d47723720dd4a$var$getElementId(_ref) {
    var contextId = _ref.contextId, uniqueId = _ref.uniqueId;
    return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function $c19d47723720dd4a$var$useHiddenTextElement(_ref2) {
    var contextId = _ref2.contextId, text = _ref2.text;
    var uniqueId = $c19d47723720dd4a$var$useUniqueId("hidden-text", {
        separator: "-"
    });
    var id = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return $c19d47723720dd4a$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        });
    }, [
        uniqueId,
        contextId
    ]);
    (0, $exYeM.useEffect)(function mount() {
        var el = document.createElement("div");
        el.id = id;
        el.textContent = text;
        el.style.display = "none";
        $c19d47723720dd4a$var$getBodyElement().appendChild(el);
        return function unmount() {
            var body = $c19d47723720dd4a$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $c19d47723720dd4a$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
var $c19d47723720dd4a$var$peerDependencies = {
    react: "^16.8.5 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
var $c19d47723720dd4a$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $c19d47723720dd4a$var$getVersion = function getVersion(value) {
    var result = $c19d47723720dd4a$var$semver.exec(value);
    !(result != null) && $c19d47723720dd4a$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $c19d47723720dd4a$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $c19d47723720dd4a$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $c19d47723720dd4a$var$getVersion(peerDepValue);
    var actual = $c19d47723720dd4a$var$getVersion(actualValue);
    if ($c19d47723720dd4a$var$isSatisfied(peerDep, actual)) return;
};
var $c19d47723720dd4a$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $c19d47723720dd4a$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $c19d47723720dd4a$var$useDev(useHook) {}
function $c19d47723720dd4a$var$useDevSetupWarning(fn, inputs) {
    $c19d47723720dd4a$var$useDev(function() {
        (0, $exYeM.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $c19d47723720dd4a$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $c19d47723720dd4a$var$useStartupValidation() {
    $c19d47723720dd4a$var$useDevSetupWarning(function() {
        $c19d47723720dd4a$var$checkReactVersion($c19d47723720dd4a$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).version);
        $c19d47723720dd4a$var$checkDoctype(document);
    }, []);
}
function $c19d47723720dd4a$var$usePrevious(current) {
    var ref = (0, $exYeM.useRef)(current);
    (0, $exYeM.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $c19d47723720dd4a$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $c19d47723720dd4a$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $c19d47723720dd4a$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $c19d47723720dd4a$var$tab = 9;
var $c19d47723720dd4a$var$enter = 13;
var $c19d47723720dd4a$var$escape = 27;
var $c19d47723720dd4a$var$space = 32;
var $c19d47723720dd4a$var$pageUp = 33;
var $c19d47723720dd4a$var$pageDown = 34;
var $c19d47723720dd4a$var$end = 35;
var $c19d47723720dd4a$var$home = 36;
var $c19d47723720dd4a$var$arrowLeft = 37;
var $c19d47723720dd4a$var$arrowUp = 38;
var $c19d47723720dd4a$var$arrowRight = 39;
var $c19d47723720dd4a$var$arrowDown = 40;
var $c19d47723720dd4a$var$_preventedKeys;
var $c19d47723720dd4a$var$preventedKeys = ($c19d47723720dd4a$var$_preventedKeys = {}, $c19d47723720dd4a$var$_preventedKeys[$c19d47723720dd4a$var$enter] = true, $c19d47723720dd4a$var$_preventedKeys[$c19d47723720dd4a$var$tab] = true, $c19d47723720dd4a$var$_preventedKeys);
var $c19d47723720dd4a$var$preventStandardKeyEvents = function(event) {
    if ($c19d47723720dd4a$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $c19d47723720dd4a$var$supportedEventName = function() {
    var base = "visibilitychange";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $c19d47723720dd4a$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $c19d47723720dd4a$var$primaryButton = 0;
var $c19d47723720dd4a$var$sloppyClickThreshold = 5;
function $c19d47723720dd4a$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $c19d47723720dd4a$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $c19d47723720dd4a$var$sloppyClickThreshold;
}
var $c19d47723720dd4a$var$idle$1 = {
    type: "IDLE"
};
function $c19d47723720dd4a$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: "mousemove",
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $c19d47723720dd4a$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === "DRAGGING") {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === "PENDING") && $c19d47723720dd4a$var$invariant(false);
                var pending = phase.point;
                if (!$c19d47723720dd4a$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: "DRAGGING",
                    actions: actions
                });
            }
        },
        {
            eventName: "mouseup",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "mousedown",
            fn: function fn(event) {
                if (getPhase().type === "DRAGGING") event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === "PENDING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $c19d47723720dd4a$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $c19d47723720dd4a$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "scroll",
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === "PENDING") cancel();
            }
        },
        {
            eventName: "webkitmouseforcedown",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $c19d47723720dd4a$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $c19d47723720dd4a$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $c19d47723720dd4a$export$2f59cd992b42195a(api) {
    var phaseRef = (0, $exYeM.useRef)($c19d47723720dd4a$var$idle$1);
    var unbindEventsRef = (0, $exYeM.useRef)($c19d47723720dd4a$var$noop);
    var startCaptureBinding = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            eventName: "mousedown",
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $c19d47723720dd4a$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            eventName: "webkitmouseforcewillbegin",
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $c19d47723720dd4a$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        phaseRef.current = $c19d47723720dd4a$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $c19d47723720dd4a$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $c19d47723720dd4a$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === "IDLE") && $c19d47723720dd4a$var$invariant(false);
        phaseRef.current = {
            type: "PENDING",
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $c19d47723720dd4a$var$_scrollJumpKeys;
function $c19d47723720dd4a$var$noop$1() {}
var $c19d47723720dd4a$var$scrollJumpKeys = ($c19d47723720dd4a$var$_scrollJumpKeys = {}, $c19d47723720dd4a$var$_scrollJumpKeys[$c19d47723720dd4a$var$pageDown] = true, $c19d47723720dd4a$var$_scrollJumpKeys[$c19d47723720dd4a$var$pageUp] = true, $c19d47723720dd4a$var$_scrollJumpKeys[$c19d47723720dd4a$var$home] = true, $c19d47723720dd4a$var$_scrollJumpKeys[$c19d47723720dd4a$var$end] = true, $c19d47723720dd4a$var$_scrollJumpKeys);
function $c19d47723720dd4a$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (event.keyCode === $c19d47723720dd4a$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $c19d47723720dd4a$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $c19d47723720dd4a$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $c19d47723720dd4a$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $c19d47723720dd4a$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $c19d47723720dd4a$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($c19d47723720dd4a$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $c19d47723720dd4a$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "mousedown",
            fn: cancel
        },
        {
            eventName: "mouseup",
            fn: cancel
        },
        {
            eventName: "click",
            fn: cancel
        },
        {
            eventName: "touchstart",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "wheel",
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $c19d47723720dd4a$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $c19d47723720dd4a$export$42b74264faad0714(api) {
    var unbindEventsRef = (0, $exYeM.useRef)($c19d47723720dd4a$var$noop$1);
    var startCaptureBinding = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            eventName: "keydown",
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $c19d47723720dd4a$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $c19d47723720dd4a$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $c19d47723720dd4a$var$bindEvents(window, $c19d47723720dd4a$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $c19d47723720dd4a$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $c19d47723720dd4a$var$idle$2 = {
    type: "IDLE"
};
var $c19d47723720dd4a$var$timeForLongPress = 120;
var $c19d47723720dd4a$var$forcePressThreshold = 0.15;
function $c19d47723720dd4a$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: "orientationchange",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "contextmenu",
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $c19d47723720dd4a$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $c19d47723720dd4a$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $c19d47723720dd4a$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: "touchmove",
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: "touchend",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "touchcancel",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "touchforcechange",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $c19d47723720dd4a$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $c19d47723720dd4a$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === "PENDING") {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $c19d47723720dd4a$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $c19d47723720dd4a$export$ac235fd3a7bcf7b4(api) {
    var phaseRef = (0, $exYeM.useRef)($c19d47723720dd4a$var$idle$2);
    var unbindEventsRef = (0, $exYeM.useRef)($c19d47723720dd4a$var$noop);
    var getPhase = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            eventName: "touchstart",
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $c19d47723720dd4a$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        if (current.type === "PENDING") clearTimeout(current.longPressTimerId);
        setPhase($c19d47723720dd4a$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $c19d47723720dd4a$var$bindEvents(window, $c19d47723720dd4a$var$getHandleBindings(args), options);
        var unbindWindow = $c19d47723720dd4a$var$bindEvents(window, $c19d47723720dd4a$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function startDragging() {
        var phase = getPhase();
        !(phase.type === "PENDING") && $c19d47723720dd4a$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: "DRAGGING",
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(getPhase().type === "IDLE") && $c19d47723720dd4a$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $c19d47723720dd4a$var$timeForLongPress);
        setPhase({
            type: "PENDING",
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === "PENDING") {
                clearTimeout(phase.longPressTimerId);
                setPhase($c19d47723720dd4a$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $c19d47723720dd4a$var$bindEvents(window, [
            {
                eventName: "touchmove",
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $c19d47723720dd4a$var$useValidateSensorHooks(sensorHooks) {
    $c19d47723720dd4a$var$useDev(function() {
        var previousRef = $c19d47723720dd4a$var$usePrevious(sensorHooks);
        $c19d47723720dd4a$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $c19d47723720dd4a$var$invariant(false);
        });
    });
}
var $c19d47723720dd4a$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $c19d47723720dd4a$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($c19d47723720dd4a$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute("contenteditable");
    if (attribute === "true" || attribute === "") return true;
    if (current === parent) return false;
    return $c19d47723720dd4a$var$isAnInteractiveElement(parent, current.parentElement);
}
function $c19d47723720dd4a$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$c19d47723720dd4a$var$isHtmlElement(target)) return false;
    return $c19d47723720dd4a$var$isAnInteractiveElement(draggable, target);
}
var $c19d47723720dd4a$var$getBorderBoxCenterPosition = function(el) {
    return (0, $55b9228df7b71ef4$export$4b834cebd9e5cebe)(el.getBoundingClientRect()).center;
};
function $c19d47723720dd4a$var$isElement(el) {
    return el instanceof $c19d47723720dd4a$var$getWindowFromEl(el).Element;
}
var $c19d47723720dd4a$var$supportedMatchesName = function() {
    var base = "matches";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "msMatchesSelector",
        "webkitMatchesSelector"
    ];
    var value = $c19d47723720dd4a$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $c19d47723720dd4a$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$c19d47723720dd4a$var$supportedMatchesName](selector)) return el;
    return $c19d47723720dd4a$var$closestPonyfill(el.parentElement, selector);
}
function $c19d47723720dd4a$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $c19d47723720dd4a$var$closestPonyfill(el, selector);
}
function $c19d47723720dd4a$var$getSelector(contextId) {
    return "[" + $c19d47723720dd4a$var$dragHandle.contextId + '="' + contextId + '"]';
}
function $c19d47723720dd4a$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$c19d47723720dd4a$var$isElement(target)) return null;
    var selector = $c19d47723720dd4a$var$getSelector(contextId);
    var handle = $c19d47723720dd4a$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$c19d47723720dd4a$var$isHtmlElement(handle)) return null;
    return handle;
}
function $c19d47723720dd4a$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $c19d47723720dd4a$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($c19d47723720dd4a$var$dragHandle.draggableId);
}
function $c19d47723720dd4a$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $c19d47723720dd4a$var$draggable.contextId + '="' + contextId + '"]';
    var possible = $c19d47723720dd4a$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $c19d47723720dd4a$var$find(possible, function(el) {
        return el.getAttribute($c19d47723720dd4a$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$c19d47723720dd4a$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $c19d47723720dd4a$var$preventDefault(event) {
    event.preventDefault();
}
function $c19d47723720dd4a$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $c19d47723720dd4a$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$c19d47723720dd4a$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $c19d47723720dd4a$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $c19d47723720dd4a$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $c19d47723720dd4a$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $c19d47723720dd4a$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $c19d47723720dd4a$var$noop);
    var phase = "PRE_DRAG";
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($c19d47723720dd4a$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(null, "DRAGGING");
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = "COMPLETED";
        }
        if (phase !== "PRE_DRAG") {
            completed();
            !(phase === "PRE_DRAG") && $c19d47723720dd4a$var$invariant(false);
        }
        store.dispatch($c19d47723720dd4a$var$lift(args.liftActionArgs));
        phase = "DRAGGING";
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $c19d47723720dd4a$var$bindEvents(window, [
                    {
                        eventName: "click",
                        fn: $c19d47723720dd4a$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($c19d47723720dd4a$var$drop({
                reason: reason
            }));
        }
        return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
            isActive: function isActive() {
                return $c19d47723720dd4a$var$_isActive({
                    expected: "DRAGGING",
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish("DROP", options);
            },
            cancel: function cancel(options) {
                return finish("CANCEL", options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $a88b6ea6b7ba9cc8$export$2e2bcd8739ae039)(function(client) {
            tryDispatchWhenDragging(function() {
                return $c19d47723720dd4a$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: "FLUID"
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($c19d47723720dd4a$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($c19d47723720dd4a$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($c19d47723720dd4a$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($c19d47723720dd4a$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $c19d47723720dd4a$var$getBorderBoxCenterPosition(el),
                movementMode: "SNAP"
            },
            cleanup: $c19d47723720dd4a$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $c19d47723720dd4a$var$_isActive({
            expected: "PRE_DRAG",
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $c19d47723720dd4a$var$_isActive({
                expected: "PRE_DRAG",
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $c19d47723720dd4a$var$defaultSensors = [
    $c19d47723720dd4a$export$2f59cd992b42195a,
    $c19d47723720dd4a$export$42b74264faad0714,
    $c19d47723720dd4a$export$ac235fd3a7bcf7b4
];
function $c19d47723720dd4a$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $c19d47723720dd4a$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $exYeM.useState)(function() {
        return $c19d47723720dd4a$var$create();
    })[0];
    var tryAbandonLock = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(draggableId) {
        return $c19d47723720dd4a$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(draggableId, forceStop, options) {
        return $c19d47723720dd4a$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(event) {
        return $c19d47723720dd4a$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== "IDLE") store.dispatch($c19d47723720dd4a$var$flush());
    }, [
        lockAPI,
        store
    ]);
    var isLockClaimed = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $c19d47723720dd4a$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $c19d47723720dd4a$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $c19d47723720dd4a$var$getStore(lazyRef) {
    !lazyRef.current && $c19d47723720dd4a$var$invariant(false);
    return lazyRef.current;
}
function $c19d47723720dd4a$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, dragHandleUsageInstructions = props.dragHandleUsageInstructions;
    var lazyStoreRef = (0, $exYeM.useRef)(null);
    $c19d47723720dd4a$var$useStartupValidation();
    var lastPropsRef = $c19d47723720dd4a$var$usePrevious(props);
    var getResponders = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        return $c19d47723720dd4a$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $c19d47723720dd4a$var$useAnnouncer(contextId);
    var dragHandleUsageInstructionsId = $c19d47723720dd4a$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    var styleMarshal = $c19d47723720dd4a$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(action) {
        $c19d47723720dd4a$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return (0, $30ea8dc1329995fa$export$aea084d96e84da92)({
            publishWhileDragging: $c19d47723720dd4a$var$publishWhileDragging,
            updateDroppableScroll: $c19d47723720dd4a$var$updateDroppableScroll,
            updateDroppableIsEnabled: $c19d47723720dd4a$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $c19d47723720dd4a$var$updateDroppableIsCombineEnabled,
            collectionStarting: $c19d47723720dd4a$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $c19d47723720dd4a$var$useRegistry();
    var dimensionMarshal = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return $c19d47723720dd4a$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return $c19d47723720dd4a$var$createAutoScroller((0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({
            scrollWindow: $c19d47723720dd4a$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $30ea8dc1329995fa$export$aea084d96e84da92)({
            move: $c19d47723720dd4a$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $c19d47723720dd4a$var$useFocusMarshal(contextId);
    var store = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return $c19d47723720dd4a$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var current = $c19d47723720dd4a$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== "IDLE") current.dispatch($c19d47723720dd4a$var$flush());
    }, []);
    var isDragging = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var state = $c19d47723720dd4a$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === "DROP_ANIMATING";
    }, []);
    var appCallbacks = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(id) {
        return $c19d47723720dd4a$var$canStartDrag($c19d47723720dd4a$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        return $c19d47723720dd4a$var$isMovementAllowed($c19d47723720dd4a$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $c19d47723720dd4a$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $exYeM.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c19d47723720dd4a$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $8d25bb9acaebfb73$export$2e2bcd8739ae039), {
        context: $c19d47723720dd4a$var$StoreContext,
        store: store
    }, props.children));
}
var $c19d47723720dd4a$var$count$1 = 0;
function $c19d47723720dd4a$var$reset$1() {
    $c19d47723720dd4a$var$count$1 = 0;
}
function $c19d47723720dd4a$var$useInstanceCount() {
    return (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return "" + $c19d47723720dd4a$var$count$1++;
    }, []);
}
function $c19d47723720dd4a$export$2bfe52350fc0150d() {
    $c19d47723720dd4a$var$reset$1();
    $c19d47723720dd4a$var$reset();
}
function $c19d47723720dd4a$export$237bd83162c14364(props) {
    var contextId = $c19d47723720dd4a$var$useInstanceCount();
    var dragHandleUsageInstructions = props.dragHandleUsageInstructions || $c19d47723720dd4a$var$preset.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c19d47723720dd4a$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c19d47723720dd4a$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $c19d47723720dd4a$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $c19d47723720dd4a$var$isScroll = $c19d47723720dd4a$var$isEqual$1("scroll");
var $c19d47723720dd4a$var$isAuto = $c19d47723720dd4a$var$isEqual$1("auto");
var $c19d47723720dd4a$var$isVisible$1 = $c19d47723720dd4a$var$isEqual$1("visible");
var $c19d47723720dd4a$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $c19d47723720dd4a$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $c19d47723720dd4a$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $c19d47723720dd4a$var$isEither(overflow, $c19d47723720dd4a$var$isScroll) || $c19d47723720dd4a$var$isEither(overflow, $c19d47723720dd4a$var$isAuto);
};
var $c19d47723720dd4a$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $c19d47723720dd4a$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $c19d47723720dd4a$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$c19d47723720dd4a$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $c19d47723720dd4a$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $c19d47723720dd4a$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $c19d47723720dd4a$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $c19d47723720dd4a$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === "fixed") return true;
    return getIsFixed(el.parentElement);
};
var $c19d47723720dd4a$var$getEnv = function(start) {
    var closestScrollable = $c19d47723720dd4a$var$getClosestScrollable(start);
    var isFixedOnPage = $c19d47723720dd4a$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $c19d47723720dd4a$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $c19d47723720dd4a$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $c19d47723720dd4a$var$origin,
                    displacement: $c19d47723720dd4a$var$origin
                }
            }
        };
    }();
    var axis = direction === "vertical" ? $c19d47723720dd4a$var$vertical : $c19d47723720dd4a$var$horizontal;
    var subject = $c19d47723720dd4a$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $c19d47723720dd4a$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $55b9228df7b71ef4$export$34928e660d2a8702)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $55b9228df7b71ef4$export$9f77e0932fb78f72)(paddingBox, base.border);
    var client = (0, $55b9228df7b71ef4$export$6459fc9e86be362e)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $c19d47723720dd4a$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $c19d47723720dd4a$var$getClient(ref, closestScrollable);
    var page = (0, $55b9228df7b71ef4$export$1d0caec378d7d0ae)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $55b9228df7b71ef4$export$34928e660d2a8702)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $55b9228df7b71ef4$export$1d0caec378d7d0ae)(frameClient, windowScroll),
            scroll: $c19d47723720dd4a$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $c19d47723720dd4a$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $c19d47723720dd4a$var$immediate = {
    passive: false
};
var $c19d47723720dd4a$var$delayed = {
    passive: true
};
var $c19d47723720dd4a$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $c19d47723720dd4a$var$immediate : $c19d47723720dd4a$var$delayed;
};
function $c19d47723720dd4a$var$useRequiredContext(Context) {
    var result = (0, $exYeM.useContext)(Context);
    !result && $c19d47723720dd4a$var$invariant(false);
    return result;
}
var $c19d47723720dd4a$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $c19d47723720dd4a$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $exYeM.useRef)(null);
    var appContext = $c19d47723720dd4a$var$useRequiredContext($c19d47723720dd4a$var$AppContext);
    var uniqueId = $c19d47723720dd4a$var$useUniqueId("droppable");
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $c19d47723720dd4a$var$usePrevious(args);
    var descriptor = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $exYeM.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(x, y) {
            !whileDraggingRef.current && $c19d47723720dd4a$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $c19d47723720dd4a$var$origin;
        return $c19d47723720dd4a$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return (0, $a88b6ea6b7ba9cc8$export$2e2bcd8739ae039)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $c19d47723720dd4a$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $c19d47723720dd4a$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(windowScroll, options) {
        !!whileDraggingRef.current && $c19d47723720dd4a$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $c19d47723720dd4a$var$invariant(false);
        var env = $c19d47723720dd4a$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $c19d47723720dd4a$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($c19d47723720dd4a$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener("scroll", onClosestScroll, $c19d47723720dd4a$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $c19d47723720dd4a$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $c19d47723720dd4a$var$invariant(false);
        return $c19d47723720dd4a$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $c19d47723720dd4a$var$invariant(false);
        var closest = $c19d47723720dd4a$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($c19d47723720dd4a$var$scrollContainer.contextId);
        closest.removeEventListener("scroll", onClosestScroll, $c19d47723720dd4a$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $c19d47723720dd4a$var$invariant(false);
        var closest = $c19d47723720dd4a$var$getClosestScrollableFromDrag(dragging);
        !closest && $c19d47723720dd4a$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $c19d47723720dd4a$var$noop$2() {}
var $c19d47723720dd4a$var$empty = {
    width: 0,
    height: 0,
    margin: $c19d47723720dd4a$var$noSpacing
};
var $c19d47723720dd4a$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $c19d47723720dd4a$var$empty;
    if (animate === "close") return $c19d47723720dd4a$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $c19d47723720dd4a$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $c19d47723720dd4a$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: "border-box",
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: "0",
        flexGrow: "0",
        pointerEvents: "none",
        transition: animate !== "none" ? $c19d47723720dd4a$var$transitions.placeholder : null
    };
};
function $c19d47723720dd4a$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $exYeM.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $exYeM.useState)(props.animate === "open"), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $exYeM.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $c19d47723720dd4a$var$noop$2;
        if (animate !== "open") {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $c19d47723720dd4a$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $c19d47723720dd4a$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(event) {
        if (event.propertyName !== "height") return;
        onTransitionEnd();
        if (animate === "close") onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $c19d47723720dd4a$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(props.placeholder.tagName, {
        style: style,
        "data-rbd-placeholder-context-id": contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $c19d47723720dd4a$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).memo($c19d47723720dd4a$var$Placeholder);
var $c19d47723720dd4a$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $c19d47723720dd4a$var$checkIsValidInnerRef(el) {
    !(el && $c19d47723720dd4a$var$isHtmlElement(el)) && $c19d47723720dd4a$var$invariant(false);
}
function $c19d47723720dd4a$var$isBoolean(value) {
    return typeof value === "boolean";
}
function $c19d47723720dd4a$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $c19d47723720dd4a$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $c19d47723720dd4a$var$invariant(false);
        !(typeof props.droppableId === "string") && $c19d47723720dd4a$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$c19d47723720dd4a$var$isBoolean(props.isDropDisabled) && $c19d47723720dd4a$var$invariant(false);
        !$c19d47723720dd4a$var$isBoolean(props.isCombineEnabled) && $c19d47723720dd4a$var$invariant(false);
        !$c19d47723720dd4a$var$isBoolean(props.ignoreContainerClipping) && $c19d47723720dd4a$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $c19d47723720dd4a$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $c19d47723720dd4a$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $c19d47723720dd4a$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $c19d47723720dd4a$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $c19d47723720dd4a$var$invariant(false);
    }
];
function $c19d47723720dd4a$var$useValidation(args) {
    $c19d47723720dd4a$var$useDevSetupWarning(function() {
        $c19d47723720dd4a$var$runChecks(args, $c19d47723720dd4a$var$shared);
        if (args.props.mode === "standard") $c19d47723720dd4a$var$runChecks(args, $c19d47723720dd4a$var$standard);
        if (args.props.mode === "virtual") $c19d47723720dd4a$var$runChecks(args, $c19d47723720dd4a$var$virtual);
    });
}
var $c19d47723720dd4a$var$AnimateInOut = function(_React$PureComponent) {
    (0, $6ace560ed589c934$export$2e2bcd8739ae039)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? "open" : "none"
        };
        _this.onClose = function() {
            if (_this.state.animate !== "close") return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: "none"
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: "open"
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: "close"
        };
        return {
            isVisible: false,
            animate: "close",
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).PureComponent);
var $c19d47723720dd4a$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $c19d47723720dd4a$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $c19d47723720dd4a$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $c19d47723720dd4a$var$transitions.snap;
    return $c19d47723720dd4a$var$transitions.fluid;
};
var $c19d47723720dd4a$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $c19d47723720dd4a$var$combine.opacity.drop : $c19d47723720dd4a$var$combine.opacity.combining;
};
var $c19d47723720dd4a$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === "SNAP";
};
function $c19d47723720dd4a$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $c19d47723720dd4a$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $c19d47723720dd4a$var$transforms.drop(offset, isCombining) : $c19d47723720dd4a$var$transforms.moveTo(offset);
    var style = {
        position: "fixed",
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: "border-box",
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $c19d47723720dd4a$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $c19d47723720dd4a$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $c19d47723720dd4a$var$zIndexOptions.dropAnimating : $c19d47723720dd4a$var$zIndexOptions.dragging,
        pointerEvents: "none"
    };
    return style;
}
function $c19d47723720dd4a$var$getSecondaryStyle(secondary) {
    return {
        transform: $c19d47723720dd4a$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : "none"
    };
}
function $c19d47723720dd4a$var$getStyle$1(mapped) {
    return mapped.type === "DRAGGING" ? $c19d47723720dd4a$var$getDraggingStyle(mapped) : $c19d47723720dd4a$var$getSecondaryStyle(mapped);
}
function $c19d47723720dd4a$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $c19d47723720dd4a$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $55b9228df7b71ef4$export$b8dfc5d4e552b8e1)(borderBox, computedStyles);
    var page = (0, $55b9228df7b71ef4$export$1d0caec378d7d0ae)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $c19d47723720dd4a$var$useDraggablePublisher(args) {
    var uniqueId = $c19d47723720dd4a$var$useUniqueId("draggable");
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $c19d47723720dd4a$var$invariant(false);
        return $c19d47723720dd4a$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $exYeM.useRef)(entry);
    var isFirstPublishRef = (0, $exYeM.useRef)(true);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $c19d47723720dd4a$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $c19d47723720dd4a$var$useValidation$1(props, contextId, getRef) {
    $c19d47723720dd4a$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $c19d47723720dd4a$var$invariant(false);
        !(typeof id === "string") && $c19d47723720dd4a$var$invariant(false);
        !$c19d47723720dd4a$var$isInteger(props.index) && $c19d47723720dd4a$var$invariant(false);
        if (props.mapped.type === "DRAGGING") return;
        $c19d47723720dd4a$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$c19d47723720dd4a$var$findDragHandle(contextId, id) && $c19d47723720dd4a$var$invariant(false);
    });
}
function $c19d47723720dd4a$var$useClonePropValidation(isClone) {
    $c19d47723720dd4a$var$useDev(function() {
        var initialRef = (0, $exYeM.useRef)(isClone);
        $c19d47723720dd4a$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $c19d47723720dd4a$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $c19d47723720dd4a$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $c19d47723720dd4a$var$Draggable(props) {
    var ref = (0, $exYeM.useRef)(null);
    var setRef = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $c19d47723720dd4a$var$useRequiredContext($c19d47723720dd4a$var$AppContext), contextId = _useRequiredContext.contextId, dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $c19d47723720dd4a$var$useRequiredContext($c19d47723720dd4a$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $c19d47723720dd4a$var$useValidation$1(props, contextId, getRef);
    $c19d47723720dd4a$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $c19d47723720dd4a$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return isEnabled ? {
            tabIndex: 0,
            role: "button",
            "aria-describedby": dragHandleUsageInstructionsId,
            "data-rbd-drag-handle-draggable-id": draggableId,
            "data-rbd-drag-handle-context-id": contextId,
            draggable: false,
            onDragStart: $c19d47723720dd4a$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    var onMoveEnd = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(event) {
        if (mapped.type !== "DRAGGING") return;
        if (!mapped.dropping) return;
        if (event.propertyName !== "transform") return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        var style = $c19d47723720dd4a$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                "data-rbd-draggable-context-id": contextId,
                "data-rbd-draggable-id": draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $c19d47723720dd4a$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $c19d47723720dd4a$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $c19d47723720dd4a$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $c19d47723720dd4a$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function $c19d47723720dd4a$var$getDraggableSelector() {
    var memoizedOffset = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: "DRAGGING",
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $c19d47723720dd4a$var$whatIsDraggedOver(state.impact);
            var combineWith = $c19d47723720dd4a$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $c19d47723720dd4a$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $c19d47723720dd4a$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $c19d47723720dd4a$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $c19d47723720dd4a$var$combine.opacity.drop : null,
                scale: _combineWith ? $c19d47723720dd4a$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: "DRAGGING",
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $c19d47723720dd4a$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $c19d47723720dd4a$var$atRest = {
    mapped: {
        type: "SECONDARY",
        offset: $c19d47723720dd4a$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $c19d47723720dd4a$var$getSecondarySnapshot(null)
    }
};
function $c19d47723720dd4a$var$getSecondarySelector() {
    var memoizedOffset = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)($c19d47723720dd4a$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: "SECONDARY",
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($c19d47723720dd4a$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $c19d47723720dd4a$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $c19d47723720dd4a$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $c19d47723720dd4a$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $c19d47723720dd4a$var$getDraggableSelector();
    var secondarySelector = $c19d47723720dd4a$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $c19d47723720dd4a$var$atRest;
    };
    return selector;
};
var $c19d47723720dd4a$var$mapDispatchToProps = {
    dropAnimationFinished: $c19d47723720dd4a$var$dropAnimationFinished
};
var $c19d47723720dd4a$var$ConnectedDraggable = (0, $0fab209944de0d1d$export$2e2bcd8739ae039)($c19d47723720dd4a$var$makeMapStateToProps, $c19d47723720dd4a$var$mapDispatchToProps, null, {
    context: $c19d47723720dd4a$var$StoreContext,
    pure: true,
    areStatePropsEqual: $c19d47723720dd4a$var$isStrictEqual
})($c19d47723720dd4a$var$Draggable);
function $c19d47723720dd4a$var$PrivateDraggable(props) {
    var droppableContext = $c19d47723720dd4a$var$useRequiredContext($c19d47723720dd4a$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c19d47723720dd4a$var$ConnectedDraggable, props);
}
function $c19d47723720dd4a$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c19d47723720dd4a$var$PrivateDraggable, (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $c19d47723720dd4a$var$Droppable(props) {
    var appContext = (0, $exYeM.useContext)($c19d47723720dd4a$var$AppContext);
    !appContext && $c19d47723720dd4a$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $exYeM.useRef)(null);
    var placeholderRef = (0, $exYeM.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function(value) {
        placeholderRef.current = value;
    }, []);
    $c19d47723720dd4a$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $807e4fcd8ea6bc37$export$35808ee640e87ca7)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $c19d47723720dd4a$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $c19d47723720dd4a$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c19d47723720dd4a$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c19d47723720dd4a$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                "data-rbd-droppable-id": droppableId,
                "data-rbd-droppable-context-id": contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $807e4fcd8ea6bc37$export$1538c33de8887b59)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c19d47723720dd4a$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($c19d47723720dd4a$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $c19d47723720dd4a$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $c19d47723720dd4a$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $c19d47723720dd4a$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $7d07ba38ace95d14$export$2e2bcd8739ae039)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $e66b69e563b626e6$export$2e2bcd8739ae039)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$c19d47723720dd4a$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $c19d47723720dd4a$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $c19d47723720dd4a$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (!$c19d47723720dd4a$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $c19d47723720dd4a$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $c19d47723720dd4a$var$whatIsDraggedOverFromResult(completed.result) === id, $c19d47723720dd4a$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$c19d47723720dd4a$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $c19d47723720dd4a$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === "COMBINE");
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $c19d47723720dd4a$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $c19d47723720dd4a$var$updateViewportMaxScroll
};
function $c19d47723720dd4a$var$getBody() {
    !document.body && $c19d47723720dd4a$var$invariant(false);
    return document.body;
}
var $c19d47723720dd4a$var$defaultProps = {
    mode: "standard",
    type: "DEFAULT",
    direction: "vertical",
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $c19d47723720dd4a$var$getBody
};
var $c19d47723720dd4a$export$423ec2075359570a = (0, $0fab209944de0d1d$export$2e2bcd8739ae039)($c19d47723720dd4a$var$makeMapStateToProps$1, $c19d47723720dd4a$var$mapDispatchToProps$1, null, {
    context: $c19d47723720dd4a$var$StoreContext,
    pure: true,
    areStatePropsEqual: $c19d47723720dd4a$var$isStrictEqual
})($c19d47723720dd4a$var$Droppable);
$c19d47723720dd4a$export$423ec2075359570a.defaultProps = $c19d47723720dd4a$var$defaultProps;





var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");




const $f6745ab07405201d$var$AUTH_ENDPOINT = "https://mn28cogtk2.execute-api.us-east-1.amazonaws.com/dev/";
const $f6745ab07405201d$export$4812e460280c6ef2 = (arr)=>{
    return arr[Math.floor(Math.random() * arr.length)];
};
const $f6745ab07405201d$export$d02631cccf789723 = (start, end, step = 1)=>{
    let output = [];
    if (typeof end === "undefined") {
        end = start;
        start = 0;
    }
    for(let i = start; i < end; i += step)output.push(i);
    return output;
};
const $f6745ab07405201d$export$4385e60b38654f68 = (min, max)=>Math.floor(Math.random() * (max - min)) + min;
const $f6745ab07405201d$export$f3602613885b0b7b = (projectTitle, tasks)=>{
    for(const columnId in tasks.columns){
        if (tasks.columns[columnId].title === projectTitle) return tasks.columns[columnId];
    }
    return null;
};
const $f6745ab07405201d$export$7a1b6d9817951cb = (taskId, tasks)=>{
    for(const taskIdKey in tasks.tasks){
        if (taskIdKey === taskId) return tasks.tasks[taskIdKey];
    }
    return null;
};
const $f6745ab07405201d$export$f793410d809938cd = ()=>{
    const date = new Date();
    const pad = (num)=>String(num).padStart(2, "0");
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    const timezoneOffset = -date.getTimezoneOffset();
    const sign = timezoneOffset >= 0 ? "+" : "-";
    const offsetHours = pad(Math.floor(Math.abs(timezoneOffset) / 60));
    const offsetMinutes = pad(Math.abs(timezoneOffset) % 60);
    const formattedString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
    return formattedString;
};
const $f6745ab07405201d$export$53e589c0d6eae463 = async (project, taskSequence, token)=>{
    const URL = $f6745ab07405201d$var$AUTH_ENDPOINT + `task-sequence?project=${project}`;
    const HEADERS = {
        "Content-Type": "application/json",
        Authorization: token
    };
    const BODY = JSON.stringify(taskSequence);
    const request = new Request(URL, {
        method: "PUT",
        headers: HEADERS,
        body: BODY,
        timeout: 100000
    });
    fetch(request);
};
const $f6745ab07405201d$export$e8e0154b7bb02be4 = async (task, token)=>{
    const taskData = {
        ...task
    };
    if (task.project === "habits") taskData["habit_rating"] = Math.max(task.habit_rating - 1, 0).toString();
    if (task.status === "COMPLETE") taskData["completed_time"] = $f6745ab07405201d$export$f793410d809938cd();
    const URL = $f6745ab07405201d$var$AUTH_ENDPOINT + `task`;
    const HEADERS = {
        "Content-Type": "application/json",
        Authorization: token
    };
    const BODY = JSON.stringify(taskData);
    const request = new Request(URL, {
        method: "PUT",
        headers: HEADERS,
        body: BODY,
        timeout: 100000
    });
    fetch(request);
};




var $exYeM = parcelRequire("exYeM");



function $3fceb5e73707524c$var$createError(message) {
    var err = new Error(message);
    err.source = "ulid";
    return err;
}
// These values should NEVER change. If
// they do, we're no longer making ulids!
var $3fceb5e73707524c$var$ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford's Base32
var $3fceb5e73707524c$var$ENCODING_LEN = $3fceb5e73707524c$var$ENCODING.length;
var $3fceb5e73707524c$var$TIME_MAX = Math.pow(2, 48) - 1;
var $3fceb5e73707524c$var$TIME_LEN = 10;
var $3fceb5e73707524c$var$RANDOM_LEN = 16;
function $3fceb5e73707524c$export$40d117de9a146510(str, index, char) {
    if (index > str.length - 1) return str;
    return str.substr(0, index) + char + str.substr(index + 1);
}
function $3fceb5e73707524c$export$b089ba7ec6b543fc(str) {
    var done = undefined;
    var index = str.length;
    var char = void 0;
    var charIndex = void 0;
    var maxCharIndex = $3fceb5e73707524c$var$ENCODING_LEN - 1;
    while(!done && index-- >= 0){
        char = str[index];
        charIndex = $3fceb5e73707524c$var$ENCODING.indexOf(char);
        if (charIndex === -1) throw $3fceb5e73707524c$var$createError("incorrectly encoded string");
        if (charIndex === maxCharIndex) {
            str = $3fceb5e73707524c$export$40d117de9a146510(str, index, $3fceb5e73707524c$var$ENCODING[0]);
            continue;
        }
        done = $3fceb5e73707524c$export$40d117de9a146510(str, index, $3fceb5e73707524c$var$ENCODING[charIndex + 1]);
    }
    if (typeof done === "string") return done;
    throw $3fceb5e73707524c$var$createError("cannot increment this string");
}
function $3fceb5e73707524c$export$56a5088d7e2cd06f(prng) {
    var rand = Math.floor(prng() * $3fceb5e73707524c$var$ENCODING_LEN);
    if (rand === $3fceb5e73707524c$var$ENCODING_LEN) rand = $3fceb5e73707524c$var$ENCODING_LEN - 1;
    return $3fceb5e73707524c$var$ENCODING.charAt(rand);
}
function $3fceb5e73707524c$export$91c76fd67c04a444(now, len) {
    if (isNaN(now)) throw new Error(now + " must be a number");
    if (now > $3fceb5e73707524c$var$TIME_MAX) throw $3fceb5e73707524c$var$createError("cannot encode time greater than " + $3fceb5e73707524c$var$TIME_MAX);
    if (now < 0) throw $3fceb5e73707524c$var$createError("time must be positive");
    if (Number.isInteger(now) === false) throw $3fceb5e73707524c$var$createError("time must be an integer");
    var mod = void 0;
    var str = "";
    for(; len > 0; len--){
        mod = now % $3fceb5e73707524c$var$ENCODING_LEN;
        str = $3fceb5e73707524c$var$ENCODING.charAt(mod) + str;
        now = (now - mod) / $3fceb5e73707524c$var$ENCODING_LEN;
    }
    return str;
}
function $3fceb5e73707524c$export$d96791a95d181796(len, prng) {
    var str = "";
    for(; len > 0; len--)str = $3fceb5e73707524c$export$56a5088d7e2cd06f(prng) + str;
    return str;
}
function $3fceb5e73707524c$export$76a67a2fca092822(id) {
    if (id.length !== $3fceb5e73707524c$var$TIME_LEN + $3fceb5e73707524c$var$RANDOM_LEN) throw $3fceb5e73707524c$var$createError("malformed ulid");
    var time = id.substr(0, $3fceb5e73707524c$var$TIME_LEN).split("").reverse().reduce(function(carry, char, index) {
        var encodingIndex = $3fceb5e73707524c$var$ENCODING.indexOf(char);
        if (encodingIndex === -1) throw $3fceb5e73707524c$var$createError("invalid character found: " + char);
        return carry += encodingIndex * Math.pow($3fceb5e73707524c$var$ENCODING_LEN, index);
    }, 0);
    if (time > $3fceb5e73707524c$var$TIME_MAX) throw $3fceb5e73707524c$var$createError("malformed ulid, timestamp too large");
    return time;
}

function $3fceb5e73707524c$export$5dcc08b8fc2f5e10() {
    var allowInsecure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var root = arguments[1];
    if (!root) root = typeof window !== "undefined" ? window : null;
    var browserCrypto = root && (root.crypto || root.msCrypto);
    if (browserCrypto) return function() {
        var buffer = new Uint8Array(1);
        browserCrypto.getRandomValues(buffer);
        return buffer[0] / 0xff;
    };
    else try {
        var nodeCrypto = (parcelRequire("8SHLH"));
        return function() {
            return nodeCrypto.randomBytes(1).readUInt8() / 0xff;
        };
    } catch (e) {}
    if (allowInsecure) {
        try {
            console.error("secure crypto unusable, falling back to insecure Math.random()!");
        } catch (e) {}
        return function() {
            return Math.random();
        };
    }
    throw $3fceb5e73707524c$var$createError("secure crypto unusable, insecure Math.random not allowed");
}
function $3fceb5e73707524c$export$e9008f2713103c6c(currPrng) {
    if (!currPrng) currPrng = $3fceb5e73707524c$export$5dcc08b8fc2f5e10();
    return function ulid(seedTime) {
        if (isNaN(seedTime)) seedTime = Date.now();
        return $3fceb5e73707524c$export$91c76fd67c04a444(seedTime, $3fceb5e73707524c$var$TIME_LEN) + $3fceb5e73707524c$export$d96791a95d181796($3fceb5e73707524c$var$RANDOM_LEN, currPrng);
    };
}
function $3fceb5e73707524c$export$bfbf0de1a73cdfc7(currPrng) {
    if (!currPrng) currPrng = $3fceb5e73707524c$export$5dcc08b8fc2f5e10();
    var lastTime = 0;
    var lastRandom = void 0;
    return function ulid(seedTime) {
        if (isNaN(seedTime)) seedTime = Date.now();
        if (seedTime <= lastTime) {
            var incrementedRandom = lastRandom = $3fceb5e73707524c$export$b089ba7ec6b543fc(lastRandom);
            return $3fceb5e73707524c$export$91c76fd67c04a444(lastTime, $3fceb5e73707524c$var$TIME_LEN) + incrementedRandom;
        }
        lastTime = seedTime;
        var newRandom = lastRandom = $3fceb5e73707524c$export$d96791a95d181796($3fceb5e73707524c$var$RANDOM_LEN, currPrng);
        return $3fceb5e73707524c$export$91c76fd67c04a444(seedTime, $3fceb5e73707524c$var$TIME_LEN) + newRandom;
    };
}
var $3fceb5e73707524c$export$c34778236461ea95 = $3fceb5e73707524c$export$e9008f2713103c6c();




var $3145b66931dcae2b$exports = {};
"use strict";
var $17570a72be3c5543$exports = {};

$parcel$export($17570a72be3c5543$exports, "add", function () { return $17570a72be3c5543$export$e16d8520af44a096; }, function (v) { return $17570a72be3c5543$export$e16d8520af44a096 = v; });
var $17570a72be3c5543$export$e16d8520af44a096;
"use strict";
$17570a72be3c5543$export$e16d8520af44a096 = $17570a72be3c5543$var$add;

var $9wlqC = parcelRequire("9wlqC");

var $eTI3m = parcelRequire("eTI3m");

var $cHwnM = parcelRequire("cHwnM");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function $17570a72be3c5543$var$add(date, duration) {
    const { years: years = 0 , months: months = 0 , weeks: weeks = 0 , days: days = 0 , hours: hours = 0 , minutes: minutes = 0 , seconds: seconds = 0  } = duration;
    // Add years and months
    const _date = (0, $hC8hz.toDate)(date);
    const dateWithMonths = months || years ? (0, $eTI3m.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $9wlqC.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $cHwnM.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}


Object.keys($17570a72be3c5543$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $17570a72be3c5543$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $17570a72be3c5543$exports[key];
        }
    });
});
var $e95504abc91aa353$exports = {};

$parcel$export($e95504abc91aa353$exports, "addBusinessDays", function () { return $e95504abc91aa353$export$f087b9ada3136ae9; }, function (v) { return $e95504abc91aa353$export$f087b9ada3136ae9 = v; });
var $e95504abc91aa353$export$f087b9ada3136ae9;
"use strict";
$e95504abc91aa353$export$f087b9ada3136ae9 = $e95504abc91aa353$var$addBusinessDays;

var $cHwnM = parcelRequire("cHwnM");
var $65c56ab9e14d389e$exports = {};

$parcel$export($65c56ab9e14d389e$exports, "isSaturday", function () { return $65c56ab9e14d389e$export$def9f260655b3a76; }, function (v) { return $65c56ab9e14d389e$export$def9f260655b3a76 = v; });
var $65c56ab9e14d389e$export$def9f260655b3a76;
"use strict";
$65c56ab9e14d389e$export$def9f260655b3a76 = $65c56ab9e14d389e$var$isSaturday;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */ function $65c56ab9e14d389e$var$isSaturday(date) {
    return (0, $hC8hz.toDate)(date).getDay() === 6;
}


var $089d279f7e48db36$exports = {};

$parcel$export($089d279f7e48db36$exports, "isSunday", function () { return $089d279f7e48db36$export$70f720dfc6028987; }, function (v) { return $089d279f7e48db36$export$70f720dfc6028987 = v; });
var $089d279f7e48db36$export$70f720dfc6028987;
"use strict";
$089d279f7e48db36$export$70f720dfc6028987 = $089d279f7e48db36$var$isSunday;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */ function $089d279f7e48db36$var$isSunday(date) {
    return (0, $hC8hz.toDate)(date).getDay() === 0;
}


var $55f8493c71ba43e1$exports = {};

$parcel$export($55f8493c71ba43e1$exports, "isWeekend", function () { return $55f8493c71ba43e1$export$618d60ea299da42; }, function (v) { return $55f8493c71ba43e1$export$618d60ea299da42 = v; });
var $55f8493c71ba43e1$export$618d60ea299da42;
"use strict";
$55f8493c71ba43e1$export$618d60ea299da42 = $55f8493c71ba43e1$var$isWeekend;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */ function $55f8493c71ba43e1$var$isWeekend(date) {
    const day = (0, $hC8hz.toDate)(date).getDay();
    return day === 0 || day === 6;
}



var $hC8hz = parcelRequire("hC8hz");
/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */ function $e95504abc91aa353$var$addBusinessDays(date, amount) {
    const _date = (0, $hC8hz.toDate)(date);
    const startedOnWeekend = (0, $55f8493c71ba43e1$export$618d60ea299da42)(_date);
    if (isNaN(amount)) return (0, $cHwnM.constructFrom)(date, NaN);
    const hours = _date.getHours();
    const sign = amount < 0 ? -1 : 1;
    const fullWeeks = Math.trunc(amount / 5);
    _date.setDate(_date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    let restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        _date.setDate(_date.getDate() + sign);
        if (!(0, $55f8493c71ba43e1$export$618d60ea299da42)(_date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, $55f8493c71ba43e1$export$618d60ea299da42)(_date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, $65c56ab9e14d389e$export$def9f260655b3a76)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, $089d279f7e48db36$export$70f720dfc6028987)(_date)) _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    _date.setHours(hours);
    return _date;
}


Object.keys($e95504abc91aa353$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $e95504abc91aa353$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $e95504abc91aa353$exports[key];
        }
    });
});

var $9wlqC = parcelRequire("9wlqC");
Object.keys($9wlqC).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9wlqC[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9wlqC[key];
        }
    });
});

var $1Q0sb = parcelRequire("1Q0sb");
Object.keys($1Q0sb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $1Q0sb[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $1Q0sb[key];
        }
    });
});
var $e4847f20e9949776$exports = {};

$parcel$export($e4847f20e9949776$exports, "addISOWeekYears", function () { return $e4847f20e9949776$export$c8240694da10d5f; }, function (v) { return $e4847f20e9949776$export$c8240694da10d5f = v; });
var $e4847f20e9949776$export$c8240694da10d5f;
"use strict";
$e4847f20e9949776$export$c8240694da10d5f = $e4847f20e9949776$var$addISOWeekYears;

var $ctBkT = parcelRequire("ctBkT");
var $bbc6c5b73e0d3fd0$exports = {};

$parcel$export($bbc6c5b73e0d3fd0$exports, "setISOWeekYear", function () { return $bbc6c5b73e0d3fd0$export$814397aabf10ab77; }, function (v) { return $bbc6c5b73e0d3fd0$export$814397aabf10ab77 = v; });
var $bbc6c5b73e0d3fd0$export$814397aabf10ab77;
"use strict";
$bbc6c5b73e0d3fd0$export$814397aabf10ab77 = $bbc6c5b73e0d3fd0$var$setISOWeekYear;

var $cHwnM = parcelRequire("cHwnM");

var $doy2h = parcelRequire("doy2h");

var $gIGHk = parcelRequire("gIGHk");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */ function $bbc6c5b73e0d3fd0$var$setISOWeekYear(date, weekYear) {
    let _date = (0, $hC8hz.toDate)(date);
    const diff = (0, $doy2h.differenceInCalendarDays)(_date, (0, $gIGHk.startOfISOWeekYear)(_date));
    const fourthOfJanuary = (0, $cHwnM.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(weekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    _date = (0, $gIGHk.startOfISOWeekYear)(fourthOfJanuary);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */ function $e4847f20e9949776$var$addISOWeekYears(date, amount) {
    return (0, $bbc6c5b73e0d3fd0$export$814397aabf10ab77)(date, (0, $ctBkT.getISOWeekYear)(date) + amount);
}


Object.keys($e4847f20e9949776$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $e4847f20e9949776$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $e4847f20e9949776$exports[key];
        }
    });
});

var $be89H = parcelRequire("be89H");
Object.keys($be89H).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $be89H[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $be89H[key];
        }
    });
});

var $lmA75 = parcelRequire("lmA75");
Object.keys($lmA75).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $lmA75[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $lmA75[key];
        }
    });
});

var $eTI3m = parcelRequire("eTI3m");
Object.keys($eTI3m).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $eTI3m[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $eTI3m[key];
        }
    });
});

var $9S1sJ = parcelRequire("9S1sJ");
Object.keys($9S1sJ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9S1sJ[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9S1sJ[key];
        }
    });
});

var $cqvn6 = parcelRequire("cqvn6");
Object.keys($cqvn6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cqvn6[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cqvn6[key];
        }
    });
});

var $zLu4w = parcelRequire("zLu4w");
Object.keys($zLu4w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $zLu4w[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $zLu4w[key];
        }
    });
});

var $l1Mmy = parcelRequire("l1Mmy");
Object.keys($l1Mmy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $l1Mmy[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $l1Mmy[key];
        }
    });
});
var $14ddd95597c31ea4$exports = {};

$parcel$export($14ddd95597c31ea4$exports, "areIntervalsOverlapping", function () { return $14ddd95597c31ea4$export$2bf3385645436101; }, function (v) { return $14ddd95597c31ea4$export$2bf3385645436101 = v; });
var $14ddd95597c31ea4$export$2bf3385645436101;
"use strict";
$14ddd95597c31ea4$export$2bf3385645436101 = $14ddd95597c31ea4$var$areIntervalsOverlapping;

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link areIntervalsOverlapping} function options.
 */ /**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */ function $14ddd95597c31ea4$var$areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    const [leftStartTime, leftEndTime] = [
        +(0, $hC8hz.toDate)(intervalLeft.start),
        +(0, $hC8hz.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStartTime, rightEndTime] = [
        +(0, $hC8hz.toDate)(intervalRight.start),
        +(0, $hC8hz.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    if (options?.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}


Object.keys($14ddd95597c31ea4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $14ddd95597c31ea4$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $14ddd95597c31ea4$exports[key];
        }
    });
});
var $6face9474a289f86$exports = {};

$parcel$export($6face9474a289f86$exports, "clamp", function () { return $6face9474a289f86$export$7d15b64cf5a3a4c4; }, function (v) { return $6face9474a289f86$export$7d15b64cf5a3a4c4 = v; });
var $6face9474a289f86$export$7d15b64cf5a3a4c4;
"use strict";
$6face9474a289f86$export$7d15b64cf5a3a4c4 = $6face9474a289f86$var$clamp;

var $7DYAE = parcelRequire("7DYAE");

var $3al5W = parcelRequire("3al5W");
/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */ function $6face9474a289f86$var$clamp(date, interval) {
    return (0, $3al5W.min)([
        (0, $7DYAE.max)([
            date,
            interval.start
        ]),
        interval.end
    ]);
}


Object.keys($6face9474a289f86$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6face9474a289f86$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6face9474a289f86$exports[key];
        }
    });
});
var $9bbd10cf76972404$exports = {};

$parcel$export($9bbd10cf76972404$exports, "closestIndexTo", function () { return $9bbd10cf76972404$export$42127b72a9d091c7; }, function (v) { return $9bbd10cf76972404$export$42127b72a9d091c7 = v; });
var $9bbd10cf76972404$export$42127b72a9d091c7;
"use strict";
$9bbd10cf76972404$export$42127b72a9d091c7 = $9bbd10cf76972404$var$closestIndexTo;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */ function $9bbd10cf76972404$var$closestIndexTo(dateToCompare, dates) {
    const date = (0, $hC8hz.toDate)(dateToCompare);
    if (isNaN(Number(date))) return NaN;
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach(function(dirtyDate, index) {
        const currentDate = (0, $hC8hz.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}


Object.keys($9bbd10cf76972404$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9bbd10cf76972404$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9bbd10cf76972404$exports[key];
        }
    });
});
var $654faba259e54687$exports = {};

$parcel$export($654faba259e54687$exports, "closestTo", function () { return $654faba259e54687$export$73858b464497125a; }, function (v) { return $654faba259e54687$export$73858b464497125a = v; });
var $654faba259e54687$export$73858b464497125a;
"use strict";
$654faba259e54687$export$73858b464497125a = $654faba259e54687$var$closestTo;

var $cHwnM = parcelRequire("cHwnM");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */ function $654faba259e54687$var$closestTo(dateToCompare, dates) {
    const date = (0, $hC8hz.toDate)(dateToCompare);
    if (isNaN(Number(date))) return (0, $cHwnM.constructFrom)(dateToCompare, NaN);
    const timeToCompare = date.getTime();
    let result;
    let minDistance;
    dates.forEach((dirtyDate)=>{
        const currentDate = (0, $hC8hz.toDate)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = (0, $cHwnM.constructFrom)(dateToCompare, NaN);
            minDistance = NaN;
            return;
        }
        const distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}


Object.keys($654faba259e54687$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $654faba259e54687$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $654faba259e54687$exports[key];
        }
    });
});
var $6bade57e19ef514b$exports = {};

$parcel$export($6bade57e19ef514b$exports, "compareAsc", function () { return $6bade57e19ef514b$export$fe114145ae75d197; }, function (v) { return $6bade57e19ef514b$export$fe114145ae75d197 = v; });
var $6bade57e19ef514b$export$fe114145ae75d197;
"use strict";
$6bade57e19ef514b$export$fe114145ae75d197 = $6bade57e19ef514b$var$compareAsc;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $6bade57e19ef514b$var$compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


Object.keys($6bade57e19ef514b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6bade57e19ef514b$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6bade57e19ef514b$exports[key];
        }
    });
});
var $9a1c4d928670b671$exports = {};

$parcel$export($9a1c4d928670b671$exports, "compareDesc", function () { return $9a1c4d928670b671$export$ed84005ac9356f7a; }, function (v) { return $9a1c4d928670b671$export$ed84005ac9356f7a = v; });
var $9a1c4d928670b671$export$ed84005ac9356f7a;
"use strict";
$9a1c4d928670b671$export$ed84005ac9356f7a = $9a1c4d928670b671$var$compareDesc;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */ function $9a1c4d928670b671$var$compareDesc(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}


Object.keys($9a1c4d928670b671$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9a1c4d928670b671$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9a1c4d928670b671$exports[key];
        }
    });
});

var $cHwnM = parcelRequire("cHwnM");
Object.keys($cHwnM).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cHwnM[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cHwnM[key];
        }
    });
});
var $9e33fb844b62c4b5$exports = {};

$parcel$export($9e33fb844b62c4b5$exports, "constructNow", function () { return $9e33fb844b62c4b5$export$18c3c6510fb97afc; }, function (v) { return $9e33fb844b62c4b5$export$18c3c6510fb97afc = v; });
var $9e33fb844b62c4b5$export$18c3c6510fb97afc;
"use strict";
$9e33fb844b62c4b5$export$18c3c6510fb97afc = $9e33fb844b62c4b5$var$constructNow;

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ function $9e33fb844b62c4b5$var$constructNow(date) {
    return (0, $cHwnM.constructFrom)(date, Date.now());
}


Object.keys($9e33fb844b62c4b5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9e33fb844b62c4b5$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9e33fb844b62c4b5$exports[key];
        }
    });
});
var $6e30c799a1a77112$exports = {};

$parcel$export($6e30c799a1a77112$exports, "daysToWeeks", function () { return $6e30c799a1a77112$export$66d8b66cbb6006a8; }, function (v) { return $6e30c799a1a77112$export$66d8b66cbb6006a8 = v; });
var $6e30c799a1a77112$export$66d8b66cbb6006a8;
"use strict";
$6e30c799a1a77112$export$66d8b66cbb6006a8 = $6e30c799a1a77112$var$daysToWeeks;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */ function $6e30c799a1a77112$var$daysToWeeks(days) {
    const weeks = days / $5K4u1.daysInWeek;
    const result = Math.trunc(weeks);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($6e30c799a1a77112$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6e30c799a1a77112$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6e30c799a1a77112$exports[key];
        }
    });
});
var $53761edf344904fb$exports = {};

$parcel$export($53761edf344904fb$exports, "differenceInBusinessDays", function () { return $53761edf344904fb$export$f30d3269a6c53cb9; }, function (v) { return $53761edf344904fb$export$f30d3269a6c53cb9 = v; });
var $53761edf344904fb$export$f30d3269a6c53cb9;
"use strict";
$53761edf344904fb$export$f30d3269a6c53cb9 = $53761edf344904fb$var$differenceInBusinessDays;

var $9wlqC = parcelRequire("9wlqC");

var $doy2h = parcelRequire("doy2h");

var $hVwiy = parcelRequire("hVwiy");

var $bJrOu = parcelRequire("bJrOu");


var $hC8hz = parcelRequire("hC8hz");
/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */ function $53761edf344904fb$var$differenceInBusinessDays(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    let _dateRight = (0, $hC8hz.toDate)(dateRight);
    if (!(0, $bJrOu.isValid)(_dateLeft) || !(0, $bJrOu.isValid)(_dateRight)) return NaN;
    const calendarDifference = (0, $doy2h.differenceInCalendarDays)(_dateLeft, _dateRight);
    const sign = calendarDifference < 0 ? -1 : 1;
    const weeks = Math.trunc(calendarDifference / 7);
    let result = weeks * 5;
    _dateRight = (0, $9wlqC.addDays)(_dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, $hVwiy.isSameDay)(_dateLeft, _dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, $55f8493c71ba43e1$export$618d60ea299da42)(_dateRight) ? 0 : sign;
        _dateRight = (0, $9wlqC.addDays)(_dateRight, sign);
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($53761edf344904fb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $53761edf344904fb$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $53761edf344904fb$exports[key];
        }
    });
});

var $doy2h = parcelRequire("doy2h");
Object.keys($doy2h).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $doy2h[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $doy2h[key];
        }
    });
});
var $07a4699e5e6b432f$exports = {};

$parcel$export($07a4699e5e6b432f$exports, "differenceInCalendarISOWeekYears", function () { return $07a4699e5e6b432f$export$7f8a73dc2e50a070; }, function (v) { return $07a4699e5e6b432f$export$7f8a73dc2e50a070 = v; });
var $07a4699e5e6b432f$export$7f8a73dc2e50a070;
"use strict";
$07a4699e5e6b432f$export$7f8a73dc2e50a070 = $07a4699e5e6b432f$var$differenceInCalendarISOWeekYears;

var $ctBkT = parcelRequire("ctBkT");
/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */ function $07a4699e5e6b432f$var$differenceInCalendarISOWeekYears(dateLeft, dateRight) {
    return (0, $ctBkT.getISOWeekYear)(dateLeft) - (0, $ctBkT.getISOWeekYear)(dateRight);
}


Object.keys($07a4699e5e6b432f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $07a4699e5e6b432f$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $07a4699e5e6b432f$exports[key];
        }
    });
});
var $8b5309bc23113abc$exports = {};

$parcel$export($8b5309bc23113abc$exports, "differenceInCalendarISOWeeks", function () { return $8b5309bc23113abc$export$28df1cb58b17e450; }, function (v) { return $8b5309bc23113abc$export$28df1cb58b17e450 = v; });
var $8b5309bc23113abc$export$28df1cb58b17e450;
"use strict";
$8b5309bc23113abc$export$28df1cb58b17e450 = $8b5309bc23113abc$var$differenceInCalendarISOWeeks;

var $5K4u1 = parcelRequire("5K4u1");

var $6nmfz = parcelRequire("6nmfz");

var $gORYf = parcelRequire("gORYf");
/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */ function $8b5309bc23113abc$var$differenceInCalendarISOWeeks(dateLeft, dateRight) {
    const startOfISOWeekLeft = (0, $6nmfz.startOfISOWeek)(dateLeft);
    const startOfISOWeekRight = (0, $6nmfz.startOfISOWeek)(dateRight);
    const timestampLeft = +startOfISOWeekLeft - (0, $gORYf.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
    const timestampRight = +startOfISOWeekRight - (0, $gORYf.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $5K4u1.millisecondsInWeek);
}


Object.keys($8b5309bc23113abc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $8b5309bc23113abc$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $8b5309bc23113abc$exports[key];
        }
    });
});

var $dPrzz = parcelRequire("dPrzz");
Object.keys($dPrzz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $dPrzz[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $dPrzz[key];
        }
    });
});

var $lTSPY = parcelRequire("lTSPY");
Object.keys($lTSPY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $lTSPY[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $lTSPY[key];
        }
    });
});
var $c872708eb28b1aa7$exports = {};

$parcel$export($c872708eb28b1aa7$exports, "differenceInCalendarWeeks", function () { return $c872708eb28b1aa7$export$6ed034ce62348e4; }, function (v) { return $c872708eb28b1aa7$export$6ed034ce62348e4 = v; });
var $c872708eb28b1aa7$export$6ed034ce62348e4;
"use strict";
$c872708eb28b1aa7$export$6ed034ce62348e4 = $c872708eb28b1aa7$var$differenceInCalendarWeeks;

var $5K4u1 = parcelRequire("5K4u1");

var $5Wrs3 = parcelRequire("5Wrs3");

var $gORYf = parcelRequire("gORYf");
/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ function $c872708eb28b1aa7$var$differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, $5Wrs3.startOfWeek)(dateLeft, options);
    const startOfWeekRight = (0, $5Wrs3.startOfWeek)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, $gORYf.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, $gORYf.getTimezoneOffsetInMilliseconds)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $5K4u1.millisecondsInWeek);
}


Object.keys($c872708eb28b1aa7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $c872708eb28b1aa7$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $c872708eb28b1aa7$exports[key];
        }
    });
});

var $9LexO = parcelRequire("9LexO");
Object.keys($9LexO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9LexO[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9LexO[key];
        }
    });
});
var $1dfc41ca2d6afd82$exports = {};

$parcel$export($1dfc41ca2d6afd82$exports, "differenceInDays", function () { return $1dfc41ca2d6afd82$export$86415ebf4eb36b8c; }, function (v) { return $1dfc41ca2d6afd82$export$86415ebf4eb36b8c = v; });
var $1dfc41ca2d6afd82$export$86415ebf4eb36b8c;
"use strict";
$1dfc41ca2d6afd82$export$86415ebf4eb36b8c = $1dfc41ca2d6afd82$var$differenceInDays;

var $doy2h = parcelRequire("doy2h");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $1dfc41ca2d6afd82$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    const sign = $1dfc41ca2d6afd82$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $doy2h.differenceInCalendarDays)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($1dfc41ca2d6afd82$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $1dfc41ca2d6afd82$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


Object.keys($1dfc41ca2d6afd82$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $1dfc41ca2d6afd82$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $1dfc41ca2d6afd82$exports[key];
        }
    });
});
var $fb56b180c02a7c32$exports = {};

$parcel$export($fb56b180c02a7c32$exports, "differenceInHours", function () { return $fb56b180c02a7c32$export$5436ca250d4d6872; }, function (v) { return $fb56b180c02a7c32$export$5436ca250d4d6872 = v; });
var $fb56b180c02a7c32$export$5436ca250d4d6872;
"use strict";
$fb56b180c02a7c32$export$5436ca250d4d6872 = $fb56b180c02a7c32$var$differenceInHours;
var $cb1c16b2156d3745$export$b6474a47258c1211;
"use strict";
$cb1c16b2156d3745$export$b6474a47258c1211 = $cb1c16b2156d3745$var$getRoundingMethod;
function $cb1c16b2156d3745$var$getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



var $5K4u1 = parcelRequire("5K4u1");
var $ac288c84d00d6e0d$exports = {};

$parcel$export($ac288c84d00d6e0d$exports, "differenceInMilliseconds", function () { return $ac288c84d00d6e0d$export$7be94d13716b4bf6; }, function (v) { return $ac288c84d00d6e0d$export$7be94d13716b4bf6 = v; });
var $ac288c84d00d6e0d$export$7be94d13716b4bf6;
"use strict";
$ac288c84d00d6e0d$export$7be94d13716b4bf6 = $ac288c84d00d6e0d$var$differenceInMilliseconds;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ function $ac288c84d00d6e0d$var$differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, $hC8hz.toDate)(dateLeft) - +(0, $hC8hz.toDate)(dateRight);
}


/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ function $fb56b180c02a7c32$var$differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, $ac288c84d00d6e0d$export$7be94d13716b4bf6)(dateLeft, dateRight) / $5K4u1.millisecondsInHour;
    return (0, $cb1c16b2156d3745$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($fb56b180c02a7c32$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $fb56b180c02a7c32$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $fb56b180c02a7c32$exports[key];
        }
    });
});
var $8274c8110ed321f8$exports = {};

$parcel$export($8274c8110ed321f8$exports, "differenceInISOWeekYears", function () { return $8274c8110ed321f8$export$bf7bde0b3bf8913a; }, function (v) { return $8274c8110ed321f8$export$bf7bde0b3bf8913a = v; });
var $8274c8110ed321f8$export$bf7bde0b3bf8913a;
"use strict";
$8274c8110ed321f8$export$bf7bde0b3bf8913a = $8274c8110ed321f8$var$differenceInISOWeekYears;


var $e9bed0583bac449b$exports = {};

$parcel$export($e9bed0583bac449b$exports, "subISOWeekYears", function () { return $e9bed0583bac449b$export$4f7d47b952f4a0aa; }, function (v) { return $e9bed0583bac449b$export$4f7d47b952f4a0aa = v; });
var $e9bed0583bac449b$export$4f7d47b952f4a0aa;
"use strict";
$e9bed0583bac449b$export$4f7d47b952f4a0aa = $e9bed0583bac449b$var$subISOWeekYears;

/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */ function $e9bed0583bac449b$var$subISOWeekYears(date, amount) {
    return (0, $e4847f20e9949776$export$c8240694da10d5f)(date, -amount);
}



var $hC8hz = parcelRequire("hC8hz");
/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */ function $8274c8110ed321f8$var$differenceInISOWeekYears(dateLeft, dateRight) {
    let _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    const sign = (0, $6bade57e19ef514b$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $07a4699e5e6b432f$export$7f8a73dc2e50a070)(_dateLeft, _dateRight));
    _dateLeft = (0, $e9bed0583bac449b$export$4f7d47b952f4a0aa)(_dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastISOWeekYearNotFull = Number((0, $6bade57e19ef514b$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($8274c8110ed321f8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $8274c8110ed321f8$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $8274c8110ed321f8$exports[key];
        }
    });
});

Object.keys($ac288c84d00d6e0d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $ac288c84d00d6e0d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $ac288c84d00d6e0d$exports[key];
        }
    });
});
var $3300a1978d30cdad$exports = {};

$parcel$export($3300a1978d30cdad$exports, "differenceInMinutes", function () { return $3300a1978d30cdad$export$d904251335be481a; }, function (v) { return $3300a1978d30cdad$export$d904251335be481a = v; });
var $3300a1978d30cdad$export$d904251335be481a;
"use strict";
$3300a1978d30cdad$export$d904251335be481a = $3300a1978d30cdad$var$differenceInMinutes;


var $5K4u1 = parcelRequire("5K4u1");

/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ function $3300a1978d30cdad$var$differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, $ac288c84d00d6e0d$export$7be94d13716b4bf6)(dateLeft, dateRight) / $5K4u1.millisecondsInMinute;
    return (0, $cb1c16b2156d3745$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($3300a1978d30cdad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3300a1978d30cdad$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3300a1978d30cdad$exports[key];
        }
    });
});
var $309acf37e27a50ec$exports = {};

$parcel$export($309acf37e27a50ec$exports, "differenceInMonths", function () { return $309acf37e27a50ec$export$fc1ed482c2861792; }, function (v) { return $309acf37e27a50ec$export$fc1ed482c2861792 = v; });
var $309acf37e27a50ec$export$fc1ed482c2861792;
"use strict";
$309acf37e27a50ec$export$fc1ed482c2861792 = $309acf37e27a50ec$var$differenceInMonths;


var $dPrzz = parcelRequire("dPrzz");
var $b196969b73db0a4d$exports = {};

$parcel$export($b196969b73db0a4d$exports, "isLastDayOfMonth", function () { return $b196969b73db0a4d$export$c817d0312007ea5e; }, function (v) { return $b196969b73db0a4d$export$c817d0312007ea5e = v; });
var $b196969b73db0a4d$export$c817d0312007ea5e;
"use strict";
$b196969b73db0a4d$export$c817d0312007ea5e = $b196969b73db0a4d$var$isLastDayOfMonth;

var $6i4iy = parcelRequire("6i4iy");

var $6VZPY = parcelRequire("6VZPY");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */ function $b196969b73db0a4d$var$isLastDayOfMonth(date) {
    const _date = (0, $hC8hz.toDate)(date);
    return +(0, $6i4iy.endOfDay)(_date) === +(0, $6VZPY.endOfMonth)(_date);
}



var $hC8hz = parcelRequire("hC8hz");
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */ function $309acf37e27a50ec$var$differenceInMonths(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    const sign = (0, $6bade57e19ef514b$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $dPrzz.differenceInCalendarMonths)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $6bade57e19ef514b$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $b196969b73db0a4d$export$c817d0312007ea5e)((0, $hC8hz.toDate)(dateLeft)) && difference === 1 && (0, $6bade57e19ef514b$export$fe114145ae75d197)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($309acf37e27a50ec$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $309acf37e27a50ec$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $309acf37e27a50ec$exports[key];
        }
    });
});
var $162bde27b52ab04d$exports = {};

$parcel$export($162bde27b52ab04d$exports, "differenceInQuarters", function () { return $162bde27b52ab04d$export$74b5c4055a405552; }, function (v) { return $162bde27b52ab04d$export$74b5c4055a405552 = v; });
var $162bde27b52ab04d$export$74b5c4055a405552;
"use strict";
$162bde27b52ab04d$export$74b5c4055a405552 = $162bde27b52ab04d$var$differenceInQuarters;


/**
 * The {@link differenceInQuarters} function options.
 */ /**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */ function $162bde27b52ab04d$var$differenceInQuarters(dateLeft, dateRight, options) {
    const diff = (0, $309acf37e27a50ec$export$fc1ed482c2861792)(dateLeft, dateRight) / 3;
    return (0, $cb1c16b2156d3745$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($162bde27b52ab04d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $162bde27b52ab04d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $162bde27b52ab04d$exports[key];
        }
    });
});
var $c36d452554d463c1$exports = {};

$parcel$export($c36d452554d463c1$exports, "differenceInSeconds", function () { return $c36d452554d463c1$export$c1889aec51783710; }, function (v) { return $c36d452554d463c1$export$c1889aec51783710 = v; });
var $c36d452554d463c1$export$c1889aec51783710;
"use strict";
$c36d452554d463c1$export$c1889aec51783710 = $c36d452554d463c1$var$differenceInSeconds;


/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ function $c36d452554d463c1$var$differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, $ac288c84d00d6e0d$export$7be94d13716b4bf6)(dateLeft, dateRight) / 1000;
    return (0, $cb1c16b2156d3745$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($c36d452554d463c1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $c36d452554d463c1$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $c36d452554d463c1$exports[key];
        }
    });
});
var $ee2c9eb61260efe0$exports = {};

$parcel$export($ee2c9eb61260efe0$exports, "differenceInWeeks", function () { return $ee2c9eb61260efe0$export$b5147a91dc40ddb7; }, function (v) { return $ee2c9eb61260efe0$export$b5147a91dc40ddb7 = v; });
var $ee2c9eb61260efe0$export$b5147a91dc40ddb7;
"use strict";
$ee2c9eb61260efe0$export$b5147a91dc40ddb7 = $ee2c9eb61260efe0$var$differenceInWeeks;


/**
 * The {@link differenceInWeeks} function options.
 */ /**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */ function $ee2c9eb61260efe0$var$differenceInWeeks(dateLeft, dateRight, options) {
    const diff = (0, $1dfc41ca2d6afd82$export$86415ebf4eb36b8c)(dateLeft, dateRight) / 7;
    return (0, $cb1c16b2156d3745$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}


Object.keys($ee2c9eb61260efe0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $ee2c9eb61260efe0$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $ee2c9eb61260efe0$exports[key];
        }
    });
});
var $c27bf56b58832b1d$exports = {};

$parcel$export($c27bf56b58832b1d$exports, "differenceInYears", function () { return $c27bf56b58832b1d$export$ed6bf486f68899ca; }, function (v) { return $c27bf56b58832b1d$export$ed6bf486f68899ca = v; });
var $c27bf56b58832b1d$export$ed6bf486f68899ca;
"use strict";
$c27bf56b58832b1d$export$ed6bf486f68899ca = $c27bf56b58832b1d$var$differenceInYears;


var $9LexO = parcelRequire("9LexO");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */ function $c27bf56b58832b1d$var$differenceInYears(dateLeft, dateRight) {
    const _dateLeft = (0, $hC8hz.toDate)(dateLeft);
    const _dateRight = (0, $hC8hz.toDate)(dateRight);
    const sign = (0, $6bade57e19ef514b$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $9LexO.differenceInCalendarYears)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $6bade57e19ef514b$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


Object.keys($c27bf56b58832b1d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $c27bf56b58832b1d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $c27bf56b58832b1d$exports[key];
        }
    });
});
var $b695cdd735fc84d2$exports = {};

$parcel$export($b695cdd735fc84d2$exports, "eachDayOfInterval", function () { return $b695cdd735fc84d2$export$7a337e5923c7ceb5; }, function (v) { return $b695cdd735fc84d2$export$7a337e5923c7ceb5 = v; });
var $b695cdd735fc84d2$export$7a337e5923c7ceb5;
"use strict";
$b695cdd735fc84d2$export$7a337e5923c7ceb5 = $b695cdd735fc84d2$var$eachDayOfInterval;

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link eachDayOfInterval} function options.
 */ /**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */ function $b695cdd735fc84d2$var$eachDayOfInterval(interval, options) {
    const startDate = (0, $hC8hz.toDate)(interval.start);
    const endDate = (0, $hC8hz.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $hC8hz.toDate)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($b695cdd735fc84d2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b695cdd735fc84d2$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b695cdd735fc84d2$exports[key];
        }
    });
});
var $c98d1683426fb1b5$exports = {};

$parcel$export($c98d1683426fb1b5$exports, "eachHourOfInterval", function () { return $c98d1683426fb1b5$export$bb4f48fee90ea86e; }, function (v) { return $c98d1683426fb1b5$export$bb4f48fee90ea86e = v; });
var $c98d1683426fb1b5$export$bb4f48fee90ea86e;
"use strict";
$c98d1683426fb1b5$export$bb4f48fee90ea86e = $c98d1683426fb1b5$var$eachHourOfInterval;

var $1Q0sb = parcelRequire("1Q0sb");

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link eachHourOfInterval} function options.
 */ /**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */ function $c98d1683426fb1b5$var$eachHourOfInterval(interval, options) {
    const startDate = (0, $hC8hz.toDate)(interval.start);
    const endDate = (0, $hC8hz.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $hC8hz.toDate)(currentDate));
        currentDate = (0, $1Q0sb.addHours)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($c98d1683426fb1b5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $c98d1683426fb1b5$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $c98d1683426fb1b5$exports[key];
        }
    });
});
var $ebe377bd5d9afeaf$exports = {};

$parcel$export($ebe377bd5d9afeaf$exports, "eachMinuteOfInterval", function () { return $ebe377bd5d9afeaf$export$82e17d693ce9eb6c; }, function (v) { return $ebe377bd5d9afeaf$export$82e17d693ce9eb6c = v; });
var $ebe377bd5d9afeaf$export$82e17d693ce9eb6c;
"use strict";
$ebe377bd5d9afeaf$export$82e17d693ce9eb6c = $ebe377bd5d9afeaf$var$eachMinuteOfInterval;

var $lmA75 = parcelRequire("lmA75");
var $d89ec25e3b89d68b$exports = {};

$parcel$export($d89ec25e3b89d68b$exports, "startOfMinute", function () { return $d89ec25e3b89d68b$export$c66440458c6aa793; }, function (v) { return $d89ec25e3b89d68b$export$c66440458c6aa793 = v; });
var $d89ec25e3b89d68b$export$c66440458c6aa793;
"use strict";
$d89ec25e3b89d68b$export$c66440458c6aa793 = $d89ec25e3b89d68b$var$startOfMinute;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */ function $d89ec25e3b89d68b$var$startOfMinute(date) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setSeconds(0, 0);
    return _date;
}



var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link eachMinuteOfInterval} function options.
 */ /**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */ function $ebe377bd5d9afeaf$var$eachMinuteOfInterval(interval, options) {
    const startDate = (0, $d89ec25e3b89d68b$export$c66440458c6aa793)((0, $hC8hz.toDate)(interval.start));
    const endDate = (0, $hC8hz.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $hC8hz.toDate)(currentDate));
        currentDate = (0, $lmA75.addMinutes)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($ebe377bd5d9afeaf$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $ebe377bd5d9afeaf$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $ebe377bd5d9afeaf$exports[key];
        }
    });
});
var $3424affc30e3f6eb$exports = {};

$parcel$export($3424affc30e3f6eb$exports, "eachMonthOfInterval", function () { return $3424affc30e3f6eb$export$1c9322f2d2a5eed3; }, function (v) { return $3424affc30e3f6eb$export$1c9322f2d2a5eed3 = v; });
var $3424affc30e3f6eb$export$1c9322f2d2a5eed3;
"use strict";
$3424affc30e3f6eb$export$1c9322f2d2a5eed3 = $3424affc30e3f6eb$var$eachMonthOfInterval;

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link eachMonthOfInterval} function options.
 */ /**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */ function $3424affc30e3f6eb$var$eachMonthOfInterval(interval, options) {
    const startDate = (0, $hC8hz.toDate)(interval.start);
    const endDate = (0, $hC8hz.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $hC8hz.toDate)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($3424affc30e3f6eb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3424affc30e3f6eb$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3424affc30e3f6eb$exports[key];
        }
    });
});
var $90002452383abf5c$exports = {};

$parcel$export($90002452383abf5c$exports, "eachQuarterOfInterval", function () { return $90002452383abf5c$export$96790a0abfab0078; }, function (v) { return $90002452383abf5c$export$96790a0abfab0078 = v; });
var $90002452383abf5c$export$96790a0abfab0078;
"use strict";
$90002452383abf5c$export$96790a0abfab0078 = $90002452383abf5c$var$eachQuarterOfInterval;

var $9S1sJ = parcelRequire("9S1sJ");

var $iNa3w = parcelRequire("iNa3w");

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link eachQuarterOfInterval} function options.
 */ /**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */ function $90002452383abf5c$var$eachQuarterOfInterval(interval, options) {
    const startDate = (0, $hC8hz.toDate)(interval.start);
    const endDate = (0, $hC8hz.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +(0, $iNa3w.startOfQuarter)(startDate) : +(0, $iNa3w.startOfQuarter)(endDate);
    let currentDate = reversed ? (0, $iNa3w.startOfQuarter)(endDate) : (0, $iNa3w.startOfQuarter)(startDate);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $hC8hz.toDate)(currentDate));
        currentDate = (0, $9S1sJ.addQuarters)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($90002452383abf5c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $90002452383abf5c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $90002452383abf5c$exports[key];
        }
    });
});
var $cc3b5d6d85f183e1$exports = {};

$parcel$export($cc3b5d6d85f183e1$exports, "eachWeekOfInterval", function () { return $cc3b5d6d85f183e1$export$d31a8caec75fa456; }, function (v) { return $cc3b5d6d85f183e1$export$d31a8caec75fa456 = v; });
var $cc3b5d6d85f183e1$export$d31a8caec75fa456;
"use strict";
$cc3b5d6d85f183e1$export$d31a8caec75fa456 = $cc3b5d6d85f183e1$var$eachWeekOfInterval;

var $zLu4w = parcelRequire("zLu4w");

var $5Wrs3 = parcelRequire("5Wrs3");

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link eachWeekOfInterval} function options.
 */ /**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */ function $cc3b5d6d85f183e1$var$eachWeekOfInterval(interval, options) {
    const startDate = (0, $hC8hz.toDate)(interval.start);
    const endDate = (0, $hC8hz.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $5Wrs3.startOfWeek)(endDate, options) : (0, $5Wrs3.startOfWeek)(startDate, options);
    const endDateWeek = reversed ? (0, $5Wrs3.startOfWeek)(startDate, options) : (0, $5Wrs3.startOfWeek)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $hC8hz.toDate)(currentDate));
        currentDate = (0, $zLu4w.addWeeks)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($cc3b5d6d85f183e1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cc3b5d6d85f183e1$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cc3b5d6d85f183e1$exports[key];
        }
    });
});
var $7e20c8977a370386$exports = {};

$parcel$export($7e20c8977a370386$exports, "eachWeekendOfInterval", function () { return $7e20c8977a370386$export$a2ae85dd849354a8; }, function (v) { return $7e20c8977a370386$export$a2ae85dd849354a8 = v; });
var $7e20c8977a370386$export$a2ae85dd849354a8;
"use strict";
$7e20c8977a370386$export$a2ae85dd849354a8 = $7e20c8977a370386$var$eachWeekendOfInterval;


/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */ function $7e20c8977a370386$var$eachWeekendOfInterval(interval) {
    const dateInterval = (0, $b695cdd735fc84d2$export$7a337e5923c7ceb5)(interval);
    const weekends = [];
    let index = 0;
    while(index < dateInterval.length){
        const date = dateInterval[index++];
        if ((0, $55f8493c71ba43e1$export$618d60ea299da42)(date)) weekends.push(date);
    }
    return weekends;
}


Object.keys($7e20c8977a370386$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $7e20c8977a370386$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $7e20c8977a370386$exports[key];
        }
    });
});
var $92159cb6145d23ab$exports = {};

$parcel$export($92159cb6145d23ab$exports, "eachWeekendOfMonth", function () { return $92159cb6145d23ab$export$f9a185d0ad232d17; }, function (v) { return $92159cb6145d23ab$export$f9a185d0ad232d17 = v; });
var $92159cb6145d23ab$export$f9a185d0ad232d17;
"use strict";
$92159cb6145d23ab$export$f9a185d0ad232d17 = $92159cb6145d23ab$var$eachWeekendOfMonth;


var $6VZPY = parcelRequire("6VZPY");

var $laco2 = parcelRequire("laco2");
/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */ function $92159cb6145d23ab$var$eachWeekendOfMonth(date) {
    const start = (0, $laco2.startOfMonth)(date);
    const end = (0, $6VZPY.endOfMonth)(date);
    return (0, $7e20c8977a370386$export$a2ae85dd849354a8)({
        start: start,
        end: end
    });
}


Object.keys($92159cb6145d23ab$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $92159cb6145d23ab$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $92159cb6145d23ab$exports[key];
        }
    });
});
var $5890fefe5b34dd40$exports = {};

$parcel$export($5890fefe5b34dd40$exports, "eachWeekendOfYear", function () { return $5890fefe5b34dd40$export$d4a9e5efc1ddceb9; }, function (v) { return $5890fefe5b34dd40$export$d4a9e5efc1ddceb9 = v; });
var $5890fefe5b34dd40$export$d4a9e5efc1ddceb9;
"use strict";
$5890fefe5b34dd40$export$d4a9e5efc1ddceb9 = $5890fefe5b34dd40$var$eachWeekendOfYear;


var $bAgeX = parcelRequire("bAgeX");

var $4Gfnp = parcelRequire("4Gfnp");
/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */ function $5890fefe5b34dd40$var$eachWeekendOfYear(date) {
    const start = (0, $4Gfnp.startOfYear)(date);
    const end = (0, $bAgeX.endOfYear)(date);
    return (0, $7e20c8977a370386$export$a2ae85dd849354a8)({
        start: start,
        end: end
    });
}


Object.keys($5890fefe5b34dd40$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $5890fefe5b34dd40$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $5890fefe5b34dd40$exports[key];
        }
    });
});
var $0d62665b724495b2$exports = {};

$parcel$export($0d62665b724495b2$exports, "eachYearOfInterval", function () { return $0d62665b724495b2$export$9b7f165f0a71d2a5; }, function (v) { return $0d62665b724495b2$export$9b7f165f0a71d2a5 = v; });
var $0d62665b724495b2$export$9b7f165f0a71d2a5;
"use strict";
$0d62665b724495b2$export$9b7f165f0a71d2a5 = $0d62665b724495b2$var$eachYearOfInterval;

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link eachYearOfInterval} function options.
 */ /**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */ function $0d62665b724495b2$var$eachYearOfInterval(interval, options) {
    const startDate = (0, $hC8hz.toDate)(interval.start);
    const endDate = (0, $hC8hz.toDate)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $hC8hz.toDate)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}


Object.keys($0d62665b724495b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $0d62665b724495b2$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $0d62665b724495b2$exports[key];
        }
    });
});

var $6i4iy = parcelRequire("6i4iy");
Object.keys($6i4iy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6i4iy[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6i4iy[key];
        }
    });
});
var $9fd159230635f445$exports = {};

$parcel$export($9fd159230635f445$exports, "endOfDecade", function () { return $9fd159230635f445$export$b922ac31d5bbe7a6; }, function (v) { return $9fd159230635f445$export$b922ac31d5bbe7a6 = v; });
var $9fd159230635f445$export$b922ac31d5bbe7a6;
"use strict";
$9fd159230635f445$export$b922ac31d5bbe7a6 = $9fd159230635f445$var$endOfDecade;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */ function $9fd159230635f445$var$endOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 11, 31);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


Object.keys($9fd159230635f445$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9fd159230635f445$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9fd159230635f445$exports[key];
        }
    });
});
var $4f805980c331de22$exports = {};

$parcel$export($4f805980c331de22$exports, "endOfHour", function () { return $4f805980c331de22$export$95ae95d2176c5f0; }, function (v) { return $4f805980c331de22$export$95ae95d2176c5f0 = v; });
var $4f805980c331de22$export$95ae95d2176c5f0;
"use strict";
$4f805980c331de22$export$95ae95d2176c5f0 = $4f805980c331de22$var$endOfHour;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */ function $4f805980c331de22$var$endOfHour(date) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setMinutes(59, 59, 999);
    return _date;
}


Object.keys($4f805980c331de22$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $4f805980c331de22$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $4f805980c331de22$exports[key];
        }
    });
});
var $0e913a2dbc1c2588$exports = {};

$parcel$export($0e913a2dbc1c2588$exports, "endOfISOWeek", function () { return $0e913a2dbc1c2588$export$186cd934f32084be; }, function (v) { return $0e913a2dbc1c2588$export$186cd934f32084be = v; });
var $0e913a2dbc1c2588$export$186cd934f32084be;
"use strict";
$0e913a2dbc1c2588$export$186cd934f32084be = $0e913a2dbc1c2588$var$endOfISOWeek;

var $dSpZL = parcelRequire("dSpZL");
/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */ function $0e913a2dbc1c2588$var$endOfISOWeek(date) {
    return (0, $dSpZL.endOfWeek)(date, {
        weekStartsOn: 1
    });
}


Object.keys($0e913a2dbc1c2588$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $0e913a2dbc1c2588$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $0e913a2dbc1c2588$exports[key];
        }
    });
});
var $80615b13a0208c71$exports = {};

$parcel$export($80615b13a0208c71$exports, "endOfISOWeekYear", function () { return $80615b13a0208c71$export$73068f3824c9c1d; }, function (v) { return $80615b13a0208c71$export$73068f3824c9c1d = v; });
var $80615b13a0208c71$export$73068f3824c9c1d;
"use strict";
$80615b13a0208c71$export$73068f3824c9c1d = $80615b13a0208c71$var$endOfISOWeekYear;

var $ctBkT = parcelRequire("ctBkT");

var $6nmfz = parcelRequire("6nmfz");

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */ function $80615b13a0208c71$var$endOfISOWeekYear(date) {
    const year = (0, $ctBkT.getISOWeekYear)(date);
    const fourthOfJanuaryOfNextYear = (0, $cHwnM.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const _date = (0, $6nmfz.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    _date.setMilliseconds(_date.getMilliseconds() - 1);
    return _date;
}


Object.keys($80615b13a0208c71$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $80615b13a0208c71$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $80615b13a0208c71$exports[key];
        }
    });
});
var $0d487f0a87b047d6$exports = {};

$parcel$export($0d487f0a87b047d6$exports, "endOfMinute", function () { return $0d487f0a87b047d6$export$a06a772fc63bff07; }, function (v) { return $0d487f0a87b047d6$export$a06a772fc63bff07 = v; });
var $0d487f0a87b047d6$export$a06a772fc63bff07;
"use strict";
$0d487f0a87b047d6$export$a06a772fc63bff07 = $0d487f0a87b047d6$var$endOfMinute;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */ function $0d487f0a87b047d6$var$endOfMinute(date) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setSeconds(59, 999);
    return _date;
}


Object.keys($0d487f0a87b047d6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $0d487f0a87b047d6$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $0d487f0a87b047d6$exports[key];
        }
    });
});

var $6VZPY = parcelRequire("6VZPY");
Object.keys($6VZPY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6VZPY[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6VZPY[key];
        }
    });
});
var $88226996b2aef3a8$exports = {};

$parcel$export($88226996b2aef3a8$exports, "endOfQuarter", function () { return $88226996b2aef3a8$export$5f53493861eef879; }, function (v) { return $88226996b2aef3a8$export$5f53493861eef879 = v; });
var $88226996b2aef3a8$export$5f53493861eef879;
"use strict";
$88226996b2aef3a8$export$5f53493861eef879 = $88226996b2aef3a8$var$endOfQuarter;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */ function $88226996b2aef3a8$var$endOfQuarter(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}


Object.keys($88226996b2aef3a8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $88226996b2aef3a8$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $88226996b2aef3a8$exports[key];
        }
    });
});
var $dd06262e97181953$exports = {};

$parcel$export($dd06262e97181953$exports, "endOfSecond", function () { return $dd06262e97181953$export$ef560ab2fa7b52a2; }, function (v) { return $dd06262e97181953$export$ef560ab2fa7b52a2 = v; });
var $dd06262e97181953$export$ef560ab2fa7b52a2;
"use strict";
$dd06262e97181953$export$ef560ab2fa7b52a2 = $dd06262e97181953$var$endOfSecond;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */ function $dd06262e97181953$var$endOfSecond(date) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setMilliseconds(999);
    return _date;
}


Object.keys($dd06262e97181953$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $dd06262e97181953$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $dd06262e97181953$exports[key];
        }
    });
});
var $6d8f4e04df07ab1c$exports = {};

$parcel$export($6d8f4e04df07ab1c$exports, "endOfToday", function () { return $6d8f4e04df07ab1c$export$1b7031a80bd92a6e; }, function (v) { return $6d8f4e04df07ab1c$export$1b7031a80bd92a6e = v; });
var $6d8f4e04df07ab1c$export$1b7031a80bd92a6e;
"use strict";
$6d8f4e04df07ab1c$export$1b7031a80bd92a6e = $6d8f4e04df07ab1c$var$endOfToday;

var $6i4iy = parcelRequire("6i4iy");
/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */ function $6d8f4e04df07ab1c$var$endOfToday() {
    return (0, $6i4iy.endOfDay)(Date.now());
}


Object.keys($6d8f4e04df07ab1c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6d8f4e04df07ab1c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6d8f4e04df07ab1c$exports[key];
        }
    });
});
var $8a3a8c733b2ba88f$exports = {};

$parcel$export($8a3a8c733b2ba88f$exports, "endOfTomorrow", function () { return $8a3a8c733b2ba88f$export$d788ac27ae2a54ea; }, function (v) { return $8a3a8c733b2ba88f$export$d788ac27ae2a54ea = v; });
var $8a3a8c733b2ba88f$export$d788ac27ae2a54ea;
"use strict";
$8a3a8c733b2ba88f$export$d788ac27ae2a54ea = $8a3a8c733b2ba88f$var$endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ 
function $8a3a8c733b2ba88f$var$endOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}


Object.keys($8a3a8c733b2ba88f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $8a3a8c733b2ba88f$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $8a3a8c733b2ba88f$exports[key];
        }
    });
});

var $dSpZL = parcelRequire("dSpZL");
Object.keys($dSpZL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $dSpZL[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $dSpZL[key];
        }
    });
});

var $bAgeX = parcelRequire("bAgeX");
Object.keys($bAgeX).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $bAgeX[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $bAgeX[key];
        }
    });
});
var $d46dab15f24f57b3$exports = {};

$parcel$export($d46dab15f24f57b3$exports, "endOfYesterday", function () { return $d46dab15f24f57b3$export$45190faf1024f97a; }, function (v) { return $d46dab15f24f57b3$export$45190faf1024f97a = v; });
var $d46dab15f24f57b3$export$45190faf1024f97a;
"use strict";
$d46dab15f24f57b3$export$45190faf1024f97a = $d46dab15f24f57b3$var$endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ 
function $d46dab15f24f57b3$var$endOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}


Object.keys($d46dab15f24f57b3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $d46dab15f24f57b3$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $d46dab15f24f57b3$exports[key];
        }
    });
});

var $kutcQ = parcelRequire("kutcQ");
Object.keys($kutcQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $kutcQ[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $kutcQ[key];
        }
    });
});
var $8a48ad2f93572958$exports = {};

$parcel$export($8a48ad2f93572958$exports, "formatDistance", function () { return $8a48ad2f93572958$export$2c14ff85d6318973; }, function (v) { return $8a48ad2f93572958$export$2c14ff85d6318973 = v; });
var $8a48ad2f93572958$export$2c14ff85d6318973;
"use strict";
$8a48ad2f93572958$export$2c14ff85d6318973 = $8a48ad2f93572958$var$formatDistance;


var $5K4u1 = parcelRequire("5K4u1");



var $hC8hz = parcelRequire("hC8hz");

var $eEdOT = parcelRequire("eEdOT");

var $3Om6B = parcelRequire("3Om6B");

var $gORYf = parcelRequire("gORYf");
/**
 * The {@link formatDistance} function options.
 */ /**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */ function $8a48ad2f93572958$var$formatDistance(date, baseDate, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $eEdOT.defaultLocale;
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $6bade57e19ef514b$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $hC8hz.toDate)(baseDate);
        dateRight = (0, $hC8hz.toDate)(date);
    } else {
        dateLeft = (0, $hC8hz.toDate)(date);
        dateRight = (0, $hC8hz.toDate)(baseDate);
    }
    const seconds = (0, $c36d452554d463c1$export$c1889aec51783710)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $gORYf.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $gORYf.getTimezoneOffsetInMilliseconds)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $5K4u1.minutesInDay) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $5K4u1.minutesInMonth) {
        const days = Math.round(minutes / $5K4u1.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $5K4u1.minutesInMonth * 2) {
        months = Math.round(minutes / $5K4u1.minutesInMonth);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $309acf37e27a50ec$export$fc1ed482c2861792)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / $5K4u1.minutesInMonth);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}


Object.keys($8a48ad2f93572958$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $8a48ad2f93572958$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $8a48ad2f93572958$exports[key];
        }
    });
});
var $6cc398260619a295$exports = {};

$parcel$export($6cc398260619a295$exports, "formatDistanceStrict", function () { return $6cc398260619a295$export$e4be225b8ee0a759; }, function (v) { return $6cc398260619a295$export$e4be225b8ee0a759 = v; });
var $6cc398260619a295$export$e4be225b8ee0a759;
"use strict";
$6cc398260619a295$export$e4be225b8ee0a759 = $6cc398260619a295$var$formatDistanceStrict;

var $eEdOT = parcelRequire("eEdOT");

var $3Om6B = parcelRequire("3Om6B");


var $gORYf = parcelRequire("gORYf");


var $5K4u1 = parcelRequire("5K4u1");

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ function $6cc398260619a295$var$formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $eEdOT.defaultLocale;
    const comparison = (0, $6bade57e19ef514b$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $hC8hz.toDate)(baseDate);
        dateRight = (0, $hC8hz.toDate)(date);
    } else {
        dateLeft = (0, $hC8hz.toDate)(date);
        dateRight = (0, $hC8hz.toDate)(baseDate);
    }
    const roundingMethod = (0, $cb1c16b2156d3745$export$b6474a47258c1211)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / $5K4u1.millisecondsInMinute;
    const timezoneOffset = (0, $gORYf.getTimezoneOffsetInMilliseconds)(dateRight) - (0, $gORYf.getTimezoneOffsetInMilliseconds)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / $5K4u1.millisecondsInMinute;
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $5K4u1.minutesInDay) unit = "hour";
        else if (dstNormalizedMinutes < $5K4u1.minutesInMonth) unit = "day";
        else if (dstNormalizedMinutes < $5K4u1.minutesInYear) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / $5K4u1.minutesInDay);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / $5K4u1.minutesInMonth);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / $5K4u1.minutesInYear);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}


Object.keys($6cc398260619a295$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6cc398260619a295$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6cc398260619a295$exports[key];
        }
    });
});
var $b1693866de6b276a$exports = {};

$parcel$export($b1693866de6b276a$exports, "formatDistanceToNow", function () { return $b1693866de6b276a$export$d130c20a256f8817; }, function (v) { return $b1693866de6b276a$export$d130c20a256f8817 = v; });
var $b1693866de6b276a$export$d130c20a256f8817;
"use strict";
$b1693866de6b276a$export$d130c20a256f8817 = $b1693866de6b276a$var$formatDistanceToNow;


/**
 * The {@link formatDistanceToNow} function options.
 */ /**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */ function $b1693866de6b276a$var$formatDistanceToNow(date, options) {
    return (0, $8a48ad2f93572958$export$2c14ff85d6318973)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date), options);
}


Object.keys($b1693866de6b276a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b1693866de6b276a$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b1693866de6b276a$exports[key];
        }
    });
});
var $4659c3658bbc8549$exports = {};

$parcel$export($4659c3658bbc8549$exports, "formatDistanceToNowStrict", function () { return $4659c3658bbc8549$export$d0e02d4eb1ad1e32; }, function (v) { return $4659c3658bbc8549$export$d0e02d4eb1ad1e32 = v; });
var $4659c3658bbc8549$export$d0e02d4eb1ad1e32;
"use strict";
$4659c3658bbc8549$export$d0e02d4eb1ad1e32 = $4659c3658bbc8549$var$formatDistanceToNowStrict;


/**
 * The {@link formatDistanceToNowStrict} function options.
 */ /**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */ function $4659c3658bbc8549$var$formatDistanceToNowStrict(date, options) {
    return (0, $6cc398260619a295$export$e4be225b8ee0a759)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date), options);
}


Object.keys($4659c3658bbc8549$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $4659c3658bbc8549$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $4659c3658bbc8549$exports[key];
        }
    });
});
var $cf3e9424df454e6c$exports = {};

$parcel$export($cf3e9424df454e6c$exports, "formatDuration", function () { return $cf3e9424df454e6c$export$bc733b0c5cbb3e8a; }, function (v) { return $cf3e9424df454e6c$export$bc733b0c5cbb3e8a = v; });
var $cf3e9424df454e6c$export$bc733b0c5cbb3e8a;
"use strict";
$cf3e9424df454e6c$export$bc733b0c5cbb3e8a = $cf3e9424df454e6c$var$formatDuration;

var $eEdOT = parcelRequire("eEdOT");

var $3Om6B = parcelRequire("3Om6B");
/**
 * The {@link formatDuration} function options.
 */ const $cf3e9424df454e6c$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */ function $cf3e9424df454e6c$var$formatDuration(duration, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $eEdOT.defaultLocale;
    const format = options?.format ?? $cf3e9424df454e6c$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}


Object.keys($cf3e9424df454e6c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cf3e9424df454e6c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cf3e9424df454e6c$exports[key];
        }
    });
});
var $85dfe3a25cf5d97e$exports = {};

$parcel$export($85dfe3a25cf5d97e$exports, "formatISO", function () { return $85dfe3a25cf5d97e$export$3c826ac3ab9da76c; }, function (v) { return $85dfe3a25cf5d97e$export$3c826ac3ab9da76c = v; });
var $85dfe3a25cf5d97e$export$3c826ac3ab9da76c;
"use strict";
$85dfe3a25cf5d97e$export$3c826ac3ab9da76c = $85dfe3a25cf5d97e$var$formatISO;

var $hC8hz = parcelRequire("hC8hz");

var $iR4RJ = parcelRequire("iR4RJ");
/**
 * The {@link formatISO} function options.
 */ /**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */ function $85dfe3a25cf5d97e$var$formatISO(date, options) {
    const _date = (0, $hC8hz.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $iR4RJ.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $iR4RJ.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $iR4RJ.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $iR4RJ.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $iR4RJ.addLeadingZeros)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $iR4RJ.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $iR4RJ.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $iR4RJ.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}


Object.keys($85dfe3a25cf5d97e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $85dfe3a25cf5d97e$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $85dfe3a25cf5d97e$exports[key];
        }
    });
});
var $dea3499ad41e5ce7$exports = {};

$parcel$export($dea3499ad41e5ce7$exports, "formatISO9075", function () { return $dea3499ad41e5ce7$export$a673944250043fa4; }, function (v) { return $dea3499ad41e5ce7$export$a673944250043fa4 = v; });
var $dea3499ad41e5ce7$export$a673944250043fa4;
"use strict";
$dea3499ad41e5ce7$export$a673944250043fa4 = $dea3499ad41e5ce7$var$formatISO9075;

var $bJrOu = parcelRequire("bJrOu");

var $hC8hz = parcelRequire("hC8hz");

var $iR4RJ = parcelRequire("iR4RJ");
/**
 * The {@link formatISO9075} function options.
 */ /**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */ function $dea3499ad41e5ce7$var$formatISO9075(date, options) {
    const _date = (0, $hC8hz.toDate)(date);
    if (!(0, $bJrOu.isValid)(_date)) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $iR4RJ.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $iR4RJ.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $iR4RJ.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        const hour = (0, $iR4RJ.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $iR4RJ.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $iR4RJ.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        const separator = result === "" ? "" : " ";
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
    }
    return result;
}


Object.keys($dea3499ad41e5ce7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $dea3499ad41e5ce7$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $dea3499ad41e5ce7$exports[key];
        }
    });
});
var $85f4ed9af46cc22f$exports = {};

$parcel$export($85f4ed9af46cc22f$exports, "formatISODuration", function () { return $85f4ed9af46cc22f$export$437c31ab743f6b26; }, function (v) { return $85f4ed9af46cc22f$export$437c31ab743f6b26 = v; });
var $85f4ed9af46cc22f$export$437c31ab743f6b26;
"use strict";
$85f4ed9af46cc22f$export$437c31ab743f6b26 = $85f4ed9af46cc22f$var$formatISODuration;
/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */ function $85f4ed9af46cc22f$var$formatISODuration(duration) {
    const { years: years = 0 , months: months = 0 , days: days = 0 , hours: hours = 0 , minutes: minutes = 0 , seconds: seconds = 0  } = duration;
    return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}


Object.keys($85f4ed9af46cc22f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $85f4ed9af46cc22f$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $85f4ed9af46cc22f$exports[key];
        }
    });
});
var $455bab73d479f7ed$exports = {};

$parcel$export($455bab73d479f7ed$exports, "formatRFC3339", function () { return $455bab73d479f7ed$export$6d441bffeec6bd6c; }, function (v) { return $455bab73d479f7ed$export$6d441bffeec6bd6c = v; });
var $455bab73d479f7ed$export$6d441bffeec6bd6c;
"use strict";
$455bab73d479f7ed$export$6d441bffeec6bd6c = $455bab73d479f7ed$var$formatRFC3339;

var $bJrOu = parcelRequire("bJrOu");

var $hC8hz = parcelRequire("hC8hz");

var $iR4RJ = parcelRequire("iR4RJ");
/**
 * The {@link formatRFC3339} function options.
 */ /**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */ function $455bab73d479f7ed$var$formatRFC3339(date, options) {
    const _date = (0, $hC8hz.toDate)(date);
    if (!(0, $bJrOu.isValid)(_date)) throw new RangeError("Invalid time value");
    const fractionDigits = options?.fractionDigits ?? 0;
    const day = (0, $iR4RJ.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, $iR4RJ.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = _date.getFullYear();
    const hour = (0, $iR4RJ.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, $iR4RJ.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, $iR4RJ.addLeadingZeros)(_date.getSeconds(), 2);
    let fractionalSecond = "";
    if (fractionDigits > 0) {
        const milliseconds = _date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $iR4RJ.addLeadingZeros)(fractionalSeconds, fractionDigits);
    }
    let offset = "";
    const tzOffset = _date.getTimezoneOffset();
    if (tzOffset !== 0) {
        const absoluteOffset = Math.abs(tzOffset);
        const hourOffset = (0, $iR4RJ.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
        const minuteOffset = (0, $iR4RJ.addLeadingZeros)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        const sign = tzOffset < 0 ? "+" : "-";
        offset = `${sign}${hourOffset}:${minuteOffset}`;
    } else offset = "Z";
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}


Object.keys($455bab73d479f7ed$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $455bab73d479f7ed$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $455bab73d479f7ed$exports[key];
        }
    });
});
var $7e4f51014fce4ddc$exports = {};

$parcel$export($7e4f51014fce4ddc$exports, "formatRFC7231", function () { return $7e4f51014fce4ddc$export$7add2e4539ce658a; }, function (v) { return $7e4f51014fce4ddc$export$7add2e4539ce658a = v; });
var $7e4f51014fce4ddc$export$7add2e4539ce658a;
"use strict";
$7e4f51014fce4ddc$export$7add2e4539ce658a = $7e4f51014fce4ddc$var$formatRFC7231;

var $bJrOu = parcelRequire("bJrOu");

var $hC8hz = parcelRequire("hC8hz");

var $iR4RJ = parcelRequire("iR4RJ");
const $7e4f51014fce4ddc$var$days = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $7e4f51014fce4ddc$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */ function $7e4f51014fce4ddc$var$formatRFC7231(date) {
    const _date = (0, $hC8hz.toDate)(date);
    if (!(0, $bJrOu.isValid)(_date)) throw new RangeError("Invalid time value");
    const dayName = $7e4f51014fce4ddc$var$days[_date.getUTCDay()];
    const dayOfMonth = (0, $iR4RJ.addLeadingZeros)(_date.getUTCDate(), 2);
    const monthName = $7e4f51014fce4ddc$var$months[_date.getUTCMonth()];
    const year = _date.getUTCFullYear();
    const hour = (0, $iR4RJ.addLeadingZeros)(_date.getUTCHours(), 2);
    const minute = (0, $iR4RJ.addLeadingZeros)(_date.getUTCMinutes(), 2);
    const second = (0, $iR4RJ.addLeadingZeros)(_date.getUTCSeconds(), 2);
    // Result variables.
    return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}


Object.keys($7e4f51014fce4ddc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $7e4f51014fce4ddc$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $7e4f51014fce4ddc$exports[key];
        }
    });
});
var $87fa560c3e922eac$exports = {};

$parcel$export($87fa560c3e922eac$exports, "formatRelative", function () { return $87fa560c3e922eac$export$8fbbfd65594f46a0; }, function (v) { return $87fa560c3e922eac$export$8fbbfd65594f46a0 = v; });
var $87fa560c3e922eac$export$8fbbfd65594f46a0;
"use strict";
$87fa560c3e922eac$export$8fbbfd65594f46a0 = $87fa560c3e922eac$var$formatRelative;

var $doy2h = parcelRequire("doy2h");

var $kutcQ = parcelRequire("kutcQ");

var $hC8hz = parcelRequire("hC8hz");

var $eEdOT = parcelRequire("eEdOT");

var $3Om6B = parcelRequire("3Om6B");
/**
 * The {@link formatRelative} function options.
 */ /**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */ function $87fa560c3e922eac$var$formatRelative(date, baseDate, options) {
    const _date = (0, $hC8hz.toDate)(date);
    const _baseDate = (0, $hC8hz.toDate)(baseDate);
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? $eEdOT.defaultLocale;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $doy2h.differenceInCalendarDays)(_date, _baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, _date, _baseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $kutcQ.format)(_date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}


Object.keys($87fa560c3e922eac$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $87fa560c3e922eac$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $87fa560c3e922eac$exports[key];
        }
    });
});
var $b6353aee8a61553e$exports = {};

$parcel$export($b6353aee8a61553e$exports, "fromUnixTime", function () { return $b6353aee8a61553e$export$3664df8597731ed4; }, function (v) { return $b6353aee8a61553e$export$3664df8597731ed4 = v; });
var $b6353aee8a61553e$export$3664df8597731ed4;
"use strict";
$b6353aee8a61553e$export$3664df8597731ed4 = $b6353aee8a61553e$var$fromUnixTime;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */ function $b6353aee8a61553e$var$fromUnixTime(unixTime) {
    return (0, $hC8hz.toDate)(unixTime * 1000);
}


Object.keys($b6353aee8a61553e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b6353aee8a61553e$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b6353aee8a61553e$exports[key];
        }
    });
});

var $i8QYr = parcelRequire("i8QYr");
Object.keys($i8QYr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $i8QYr[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $i8QYr[key];
        }
    });
});

var $6UKPj = parcelRequire("6UKPj");
Object.keys($6UKPj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6UKPj[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6UKPj[key];
        }
    });
});

var $jnaCb = parcelRequire("jnaCb");
Object.keys($jnaCb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $jnaCb[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $jnaCb[key];
        }
    });
});

var $l7LG5 = parcelRequire("l7LG5");
Object.keys($l7LG5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $l7LG5[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $l7LG5[key];
        }
    });
});
var $e5f52a70c230b0e5$exports = {};

$parcel$export($e5f52a70c230b0e5$exports, "getDaysInYear", function () { return $e5f52a70c230b0e5$export$63a4a9fc49e3550e; }, function (v) { return $e5f52a70c230b0e5$export$63a4a9fc49e3550e = v; });
var $e5f52a70c230b0e5$export$63a4a9fc49e3550e;
"use strict";
$e5f52a70c230b0e5$export$63a4a9fc49e3550e = $e5f52a70c230b0e5$var$getDaysInYear;
var $06e653d0efa56091$exports = {};

$parcel$export($06e653d0efa56091$exports, "isLeapYear", function () { return $06e653d0efa56091$export$553d7fa8e3805fc0; }, function (v) { return $06e653d0efa56091$export$553d7fa8e3805fc0 = v; });
var $06e653d0efa56091$export$553d7fa8e3805fc0;
"use strict";
$06e653d0efa56091$export$553d7fa8e3805fc0 = $06e653d0efa56091$var$isLeapYear;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */ function $06e653d0efa56091$var$isLeapYear(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}



var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */ function $e5f52a70c230b0e5$var$getDaysInYear(date) {
    const _date = (0, $hC8hz.toDate)(date);
    if (String(new Date(_date)) === "Invalid Date") return NaN;
    return (0, $06e653d0efa56091$export$553d7fa8e3805fc0)(_date) ? 366 : 365;
}


Object.keys($e5f52a70c230b0e5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $e5f52a70c230b0e5$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $e5f52a70c230b0e5$exports[key];
        }
    });
});
var $b7c108d29d3dad83$exports = {};

$parcel$export($b7c108d29d3dad83$exports, "getDecade", function () { return $b7c108d29d3dad83$export$5bc0f4decfc52b64; }, function (v) { return $b7c108d29d3dad83$export$5bc0f4decfc52b64 = v; });
var $b7c108d29d3dad83$export$5bc0f4decfc52b64;
"use strict";
$b7c108d29d3dad83$export$5bc0f4decfc52b64 = $b7c108d29d3dad83$var$getDecade;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */ function $b7c108d29d3dad83$var$getDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    return decade;
}


Object.keys($b7c108d29d3dad83$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b7c108d29d3dad83$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b7c108d29d3dad83$exports[key];
        }
    });
});

var $76zm5 = parcelRequire("76zm5");
Object.keys($76zm5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $76zm5[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $76zm5[key];
        }
    });
});

var $cGh60 = parcelRequire("cGh60");
Object.keys($cGh60).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cGh60[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cGh60[key];
        }
    });
});

var $6siAL = parcelRequire("6siAL");
Object.keys($6siAL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6siAL[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6siAL[key];
        }
    });
});

var $4Csci = parcelRequire("4Csci");
Object.keys($4Csci).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $4Csci[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $4Csci[key];
        }
    });
});

var $ctBkT = parcelRequire("ctBkT");
Object.keys($ctBkT).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $ctBkT[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $ctBkT[key];
        }
    });
});
var $617c0b1a8140a97e$exports = {};

$parcel$export($617c0b1a8140a97e$exports, "getISOWeeksInYear", function () { return $617c0b1a8140a97e$export$822983242a16750f; }, function (v) { return $617c0b1a8140a97e$export$822983242a16750f = v; });
var $617c0b1a8140a97e$export$822983242a16750f;
"use strict";
$617c0b1a8140a97e$export$822983242a16750f = $617c0b1a8140a97e$var$getISOWeeksInYear;

var $zLu4w = parcelRequire("zLu4w");

var $5K4u1 = parcelRequire("5K4u1");

var $gIGHk = parcelRequire("gIGHk");
/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */ function $617c0b1a8140a97e$var$getISOWeeksInYear(date) {
    const thisYear = (0, $gIGHk.startOfISOWeekYear)(date);
    const nextYear = (0, $gIGHk.startOfISOWeekYear)((0, $zLu4w.addWeeks)(thisYear, 60));
    const diff = +nextYear - +thisYear;
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $5K4u1.millisecondsInWeek);
}


Object.keys($617c0b1a8140a97e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $617c0b1a8140a97e$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $617c0b1a8140a97e$exports[key];
        }
    });
});
var $8a9288dcf07a3550$exports = {};

$parcel$export($8a9288dcf07a3550$exports, "getMilliseconds", function () { return $8a9288dcf07a3550$export$b8e4380f312797af; }, function (v) { return $8a9288dcf07a3550$export$b8e4380f312797af = v; });
var $8a9288dcf07a3550$export$b8e4380f312797af;
"use strict";
$8a9288dcf07a3550$export$b8e4380f312797af = $8a9288dcf07a3550$var$getMilliseconds;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */ function $8a9288dcf07a3550$var$getMilliseconds(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}


Object.keys($8a9288dcf07a3550$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $8a9288dcf07a3550$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $8a9288dcf07a3550$exports[key];
        }
    });
});

var $eoANb = parcelRequire("eoANb");
Object.keys($eoANb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $eoANb[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $eoANb[key];
        }
    });
});

var $4O1bq = parcelRequire("4O1bq");
Object.keys($4O1bq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $4O1bq[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $4O1bq[key];
        }
    });
});
var $94c63f3278bc5818$exports = {};

$parcel$export($94c63f3278bc5818$exports, "getOverlappingDaysInIntervals", function () { return $94c63f3278bc5818$export$baae148532bd1d46; }, function (v) { return $94c63f3278bc5818$export$baae148532bd1d46 = v; });
var $94c63f3278bc5818$export$baae148532bd1d46;
"use strict";
$94c63f3278bc5818$export$baae148532bd1d46 = $94c63f3278bc5818$var$getOverlappingDaysInIntervals;

var $gORYf = parcelRequire("gORYf");

var $5K4u1 = parcelRequire("5K4u1");

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */ function $94c63f3278bc5818$var$getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
    const [leftStart, leftEnd] = [
        +(0, $hC8hz.toDate)(intervalLeft.start),
        +(0, $hC8hz.toDate)(intervalLeft.end)
    ].sort((a, b)=>a - b);
    const [rightStart, rightEnd] = [
        +(0, $hC8hz.toDate)(intervalRight.start),
        +(0, $hC8hz.toDate)(intervalRight.end)
    ].sort((a, b)=>a - b);
    // Prevent NaN result if intervals don't overlap at all.
    const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
    if (!isOverlapping) return 0;
    // Remove the timezone offset to negate the DST effect on calculations.
    const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
    const left = overlapLeft - (0, $gORYf.getTimezoneOffsetInMilliseconds)(overlapLeft);
    const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
    const right = overlapRight - (0, $gORYf.getTimezoneOffsetInMilliseconds)(overlapRight);
    // Ceil the number to include partial days too.
    return Math.ceil((right - left) / $5K4u1.millisecondsInDay);
}


Object.keys($94c63f3278bc5818$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $94c63f3278bc5818$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $94c63f3278bc5818$exports[key];
        }
    });
});

var $bqOt8 = parcelRequire("bqOt8");
Object.keys($bqOt8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $bqOt8[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $bqOt8[key];
        }
    });
});

var $olqzY = parcelRequire("olqzY");
Object.keys($olqzY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $olqzY[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $olqzY[key];
        }
    });
});

var $rRcG9 = parcelRequire("rRcG9");
Object.keys($rRcG9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $rRcG9[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $rRcG9[key];
        }
    });
});
var $a86851054ad3c9e9$exports = {};

$parcel$export($a86851054ad3c9e9$exports, "getUnixTime", function () { return $a86851054ad3c9e9$export$1f77c0008d16313; }, function (v) { return $a86851054ad3c9e9$export$1f77c0008d16313 = v; });
var $a86851054ad3c9e9$export$1f77c0008d16313;
"use strict";
$a86851054ad3c9e9$export$1f77c0008d16313 = $a86851054ad3c9e9$var$getUnixTime;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */ function $a86851054ad3c9e9$var$getUnixTime(date) {
    return Math.trunc(+(0, $hC8hz.toDate)(date) / 1000);
}


Object.keys($a86851054ad3c9e9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $a86851054ad3c9e9$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $a86851054ad3c9e9$exports[key];
        }
    });
});

var $8qqRl = parcelRequire("8qqRl");
Object.keys($8qqRl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $8qqRl[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $8qqRl[key];
        }
    });
});
var $c1f40a757096820c$exports = {};

$parcel$export($c1f40a757096820c$exports, "getWeekOfMonth", function () { return $c1f40a757096820c$export$59fb9b85a4d8d027; }, function (v) { return $c1f40a757096820c$export$59fb9b85a4d8d027 = v; });
var $c1f40a757096820c$export$59fb9b85a4d8d027;
"use strict";
$c1f40a757096820c$export$59fb9b85a4d8d027 = $c1f40a757096820c$var$getWeekOfMonth;

var $i8QYr = parcelRequire("i8QYr");

var $6UKPj = parcelRequire("6UKPj");

var $laco2 = parcelRequire("laco2");

var $3Om6B = parcelRequire("3Om6B");
/**
 * The {@link getWeekOfMonth} function options.
 */ /**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */ function $c1f40a757096820c$var$getWeekOfMonth(date, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const currentDayOfMonth = (0, $i8QYr.getDate)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    const startWeekDay = (0, $6UKPj.getDay)((0, $laco2.startOfMonth)(date));
    let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}


Object.keys($c1f40a757096820c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $c1f40a757096820c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $c1f40a757096820c$exports[key];
        }
    });
});

var $jvZLi = parcelRequire("jvZLi");
Object.keys($jvZLi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $jvZLi[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $jvZLi[key];
        }
    });
});
var $9708e0700e8b9ce9$exports = {};

$parcel$export($9708e0700e8b9ce9$exports, "getWeeksInMonth", function () { return $9708e0700e8b9ce9$export$ccc1b2479e7dd654; }, function (v) { return $9708e0700e8b9ce9$export$ccc1b2479e7dd654 = v; });
var $9708e0700e8b9ce9$export$ccc1b2479e7dd654;
"use strict";
$9708e0700e8b9ce9$export$ccc1b2479e7dd654 = $9708e0700e8b9ce9$var$getWeeksInMonth;

var $7c6145febc2114e8$exports = {};

$parcel$export($7c6145febc2114e8$exports, "lastDayOfMonth", function () { return $7c6145febc2114e8$export$36818250d6c87922; }, function (v) { return $7c6145febc2114e8$export$36818250d6c87922 = v; });
var $7c6145febc2114e8$export$36818250d6c87922;
"use strict";
$7c6145febc2114e8$export$36818250d6c87922 = $7c6145febc2114e8$var$lastDayOfMonth;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $7c6145febc2114e8$var$lastDayOfMonth(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



var $laco2 = parcelRequire("laco2");
/**
 * The {@link getWeeksInMonth} function options.
 */ /**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */ function $9708e0700e8b9ce9$var$getWeeksInMonth(date, options) {
    return (0, $c872708eb28b1aa7$export$6ed034ce62348e4)((0, $7c6145febc2114e8$export$36818250d6c87922)(date), (0, $laco2.startOfMonth)(date), options) + 1;
}


Object.keys($9708e0700e8b9ce9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9708e0700e8b9ce9$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9708e0700e8b9ce9$exports[key];
        }
    });
});

var $54r2S = parcelRequire("54r2S");
Object.keys($54r2S).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $54r2S[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $54r2S[key];
        }
    });
});
var $be16d38d5c1d909e$exports = {};

$parcel$export($be16d38d5c1d909e$exports, "hoursToMilliseconds", function () { return $be16d38d5c1d909e$export$5b42ab7a22898b69; }, function (v) { return $be16d38d5c1d909e$export$5b42ab7a22898b69 = v; });
var $be16d38d5c1d909e$export$5b42ab7a22898b69;
"use strict";
$be16d38d5c1d909e$export$5b42ab7a22898b69 = $be16d38d5c1d909e$var$hoursToMilliseconds;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */ function $be16d38d5c1d909e$var$hoursToMilliseconds(hours) {
    return Math.trunc(hours * $5K4u1.millisecondsInHour);
}


Object.keys($be16d38d5c1d909e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $be16d38d5c1d909e$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $be16d38d5c1d909e$exports[key];
        }
    });
});
var $9eb518522dff03e6$exports = {};

$parcel$export($9eb518522dff03e6$exports, "hoursToMinutes", function () { return $9eb518522dff03e6$export$83bfc73cdf89a4d8; }, function (v) { return $9eb518522dff03e6$export$83bfc73cdf89a4d8 = v; });
var $9eb518522dff03e6$export$83bfc73cdf89a4d8;
"use strict";
$9eb518522dff03e6$export$83bfc73cdf89a4d8 = $9eb518522dff03e6$var$hoursToMinutes;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */ function $9eb518522dff03e6$var$hoursToMinutes(hours) {
    return Math.trunc(hours * $5K4u1.minutesInHour);
}


Object.keys($9eb518522dff03e6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9eb518522dff03e6$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9eb518522dff03e6$exports[key];
        }
    });
});
var $223fbf212ac39189$exports = {};

$parcel$export($223fbf212ac39189$exports, "hoursToSeconds", function () { return $223fbf212ac39189$export$59b1396ccbd5a4e1; }, function (v) { return $223fbf212ac39189$export$59b1396ccbd5a4e1 = v; });
var $223fbf212ac39189$export$59b1396ccbd5a4e1;
"use strict";
$223fbf212ac39189$export$59b1396ccbd5a4e1 = $223fbf212ac39189$var$hoursToSeconds;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */ function $223fbf212ac39189$var$hoursToSeconds(hours) {
    return Math.trunc(hours * $5K4u1.secondsInHour);
}


Object.keys($223fbf212ac39189$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $223fbf212ac39189$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $223fbf212ac39189$exports[key];
        }
    });
});
var $452b52822ae6bbb4$exports = {};

$parcel$export($452b52822ae6bbb4$exports, "interval", function () { return $452b52822ae6bbb4$export$3174cdbf0a0cbc84; }, function (v) { return $452b52822ae6bbb4$export$3174cdbf0a0cbc84 = v; });
var $452b52822ae6bbb4$export$3174cdbf0a0cbc84;
"use strict";
$452b52822ae6bbb4$export$3174cdbf0a0cbc84 = $452b52822ae6bbb4$var$interval;

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link interval} function options.
 */ /**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */ function $452b52822ae6bbb4$var$interval(start, end, options) {
    const _start = (0, $hC8hz.toDate)(start);
    if (isNaN(+_start)) throw new TypeError("Start date is invalid");
    const _end = (0, $hC8hz.toDate)(end);
    if (isNaN(+_end)) throw new TypeError("End date is invalid");
    if (options?.assertPositive && +_start > +_end) throw new TypeError("End date must be after start date");
    return {
        start: _start,
        end: _end
    };
}


Object.keys($452b52822ae6bbb4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $452b52822ae6bbb4$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $452b52822ae6bbb4$exports[key];
        }
    });
});
var $a06ca8ca65775db8$exports = {};

$parcel$export($a06ca8ca65775db8$exports, "intervalToDuration", function () { return $a06ca8ca65775db8$export$7b6c9a626316863; }, function (v) { return $a06ca8ca65775db8$export$7b6c9a626316863 = v; });
var $a06ca8ca65775db8$export$7b6c9a626316863;
"use strict";
$a06ca8ca65775db8$export$7b6c9a626316863 = $a06ca8ca65775db8$var$intervalToDuration;








var $hC8hz = parcelRequire("hC8hz");
/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */ function $a06ca8ca65775db8$var$intervalToDuration(interval) {
    const start = (0, $hC8hz.toDate)(interval.start);
    const end = (0, $hC8hz.toDate)(interval.end);
    const duration = {};
    const years = (0, $c27bf56b58832b1d$export$ed6bf486f68899ca)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $17570a72be3c5543$export$e16d8520af44a096)(start, {
        years: duration.years
    });
    const months = (0, $309acf37e27a50ec$export$fc1ed482c2861792)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $17570a72be3c5543$export$e16d8520af44a096)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $1dfc41ca2d6afd82$export$86415ebf4eb36b8c)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $17570a72be3c5543$export$e16d8520af44a096)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $fb56b180c02a7c32$export$5436ca250d4d6872)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $17570a72be3c5543$export$e16d8520af44a096)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $3300a1978d30cdad$export$d904251335be481a)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $17570a72be3c5543$export$e16d8520af44a096)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $c36d452554d463c1$export$c1889aec51783710)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}


Object.keys($a06ca8ca65775db8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $a06ca8ca65775db8$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $a06ca8ca65775db8$exports[key];
        }
    });
});
var $6a3894fe189e16fa$exports = {};

$parcel$export($6a3894fe189e16fa$exports, "intlFormat", function () { return $6a3894fe189e16fa$export$f58f1234eed71f82; }, function (v) { return $6a3894fe189e16fa$export$f58f1234eed71f82 = v; });
var $6a3894fe189e16fa$export$f58f1234eed71f82;
"use strict";
$6a3894fe189e16fa$export$f58f1234eed71f82 = $6a3894fe189e16fa$var$intlFormat;

var $hC8hz = parcelRequire("hC8hz");
/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */ /**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */ /**
 * The locale options.
 */ /**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */ /**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */ function $6a3894fe189e16fa$var$intlFormat(date, formatOrLocale, localeOptions) {
    let formatOptions;
    if ($6a3894fe189e16fa$var$isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format((0, $hC8hz.toDate)(date));
}
function $6a3894fe189e16fa$var$isFormatOptions(opts) {
    return opts !== undefined && !("locale" in opts);
}


Object.keys($6a3894fe189e16fa$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6a3894fe189e16fa$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6a3894fe189e16fa$exports[key];
        }
    });
});
var $7caeff849bfc4627$exports = {};

$parcel$export($7caeff849bfc4627$exports, "intlFormatDistance", function () { return $7caeff849bfc4627$export$a110a4020280fd5; }, function (v) { return $7caeff849bfc4627$export$a110a4020280fd5 = v; });
var $7caeff849bfc4627$export$a110a4020280fd5;
"use strict";
$7caeff849bfc4627$export$a110a4020280fd5 = $7caeff849bfc4627$var$intlFormatDistance;

var $5K4u1 = parcelRequire("5K4u1");

var $doy2h = parcelRequire("doy2h");

var $dPrzz = parcelRequire("dPrzz");

var $lTSPY = parcelRequire("lTSPY");


var $9LexO = parcelRequire("9LexO");




var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ function $7caeff849bfc4627$var$intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, $hC8hz.toDate)(date);
    const dateRight = (0, $hC8hz.toDate)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, $c36d452554d463c1$export$c1889aec51783710)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < $5K4u1.secondsInMinute) {
            value = (0, $c36d452554d463c1$export$c1889aec51783710)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < $5K4u1.secondsInHour) {
            value = (0, $3300a1978d30cdad$export$d904251335be481a)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < $5K4u1.secondsInDay && Math.abs((0, $doy2h.differenceInCalendarDays)(dateLeft, dateRight)) < 1) {
            value = (0, $fb56b180c02a7c32$export$5436ca250d4d6872)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < $5K4u1.secondsInWeek && (value = (0, $doy2h.differenceInCalendarDays)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < $5K4u1.secondsInMonth) {
            value = (0, $c872708eb28b1aa7$export$6ed034ce62348e4)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < $5K4u1.secondsInQuarter) {
            value = (0, $dPrzz.differenceInCalendarMonths)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < $5K4u1.secondsInYear) {
            if ((0, $lTSPY.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, $lTSPY.differenceInCalendarQuarters)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, $9LexO.differenceInCalendarYears)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, $9LexO.differenceInCalendarYears)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, $c36d452554d463c1$export$c1889aec51783710)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, $3300a1978d30cdad$export$d904251335be481a)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, $fb56b180c02a7c32$export$5436ca250d4d6872)(dateLeft, dateRight);
        else if (unit === "day") value = (0, $doy2h.differenceInCalendarDays)(dateLeft, dateRight);
        else if (unit === "week") value = (0, $c872708eb28b1aa7$export$6ed034ce62348e4)(dateLeft, dateRight);
        else if (unit === "month") value = (0, $dPrzz.differenceInCalendarMonths)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, $lTSPY.differenceInCalendarQuarters)(dateLeft, dateRight);
        else if (unit === "year") value = (0, $9LexO.differenceInCalendarYears)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}


Object.keys($7caeff849bfc4627$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $7caeff849bfc4627$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $7caeff849bfc4627$exports[key];
        }
    });
});

var $ar9gY = parcelRequire("ar9gY");
Object.keys($ar9gY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $ar9gY[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $ar9gY[key];
        }
    });
});

var $i4Id9 = parcelRequire("i4Id9");
Object.keys($i4Id9).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $i4Id9[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $i4Id9[key];
        }
    });
});

var $c2iD1 = parcelRequire("c2iD1");
Object.keys($c2iD1).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $c2iD1[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $c2iD1[key];
        }
    });
});

var $cl3rs = parcelRequire("cl3rs");
Object.keys($cl3rs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cl3rs[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cl3rs[key];
        }
    });
});
var $b0dcba4e9f665007$exports = {};

$parcel$export($b0dcba4e9f665007$exports, "isExists", function () { return $b0dcba4e9f665007$export$127519e0edcdc58b; }, function (v) { return $b0dcba4e9f665007$export$127519e0edcdc58b = v; });
var $b0dcba4e9f665007$export$127519e0edcdc58b;
"use strict";
$b0dcba4e9f665007$export$127519e0edcdc58b = $b0dcba4e9f665007$var$isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ 
function $b0dcba4e9f665007$var$isExists(year, month, day) {
    const date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}


Object.keys($b0dcba4e9f665007$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b0dcba4e9f665007$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b0dcba4e9f665007$exports[key];
        }
    });
});
var $3d11c05f36d89fb3$exports = {};

$parcel$export($3d11c05f36d89fb3$exports, "isFirstDayOfMonth", function () { return $3d11c05f36d89fb3$export$2716a425049f51dd; }, function (v) { return $3d11c05f36d89fb3$export$2716a425049f51dd = v; });
var $3d11c05f36d89fb3$export$2716a425049f51dd;
"use strict";
$3d11c05f36d89fb3$export$2716a425049f51dd = $3d11c05f36d89fb3$var$isFirstDayOfMonth;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */ function $3d11c05f36d89fb3$var$isFirstDayOfMonth(date) {
    return (0, $hC8hz.toDate)(date).getDate() === 1;
}


Object.keys($3d11c05f36d89fb3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3d11c05f36d89fb3$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3d11c05f36d89fb3$exports[key];
        }
    });
});
var $07e0db385497bdeb$exports = {};

$parcel$export($07e0db385497bdeb$exports, "isFriday", function () { return $07e0db385497bdeb$export$3b7d89f127884993; }, function (v) { return $07e0db385497bdeb$export$3b7d89f127884993 = v; });
var $07e0db385497bdeb$export$3b7d89f127884993;
"use strict";
$07e0db385497bdeb$export$3b7d89f127884993 = $07e0db385497bdeb$var$isFriday;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */ function $07e0db385497bdeb$var$isFriday(date) {
    return (0, $hC8hz.toDate)(date).getDay() === 5;
}


Object.keys($07e0db385497bdeb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $07e0db385497bdeb$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $07e0db385497bdeb$exports[key];
        }
    });
});
var $cb8458ca8d15cd80$exports = {};

$parcel$export($cb8458ca8d15cd80$exports, "isFuture", function () { return $cb8458ca8d15cd80$export$2baac2df6018cd7; }, function (v) { return $cb8458ca8d15cd80$export$2baac2df6018cd7 = v; });
var $cb8458ca8d15cd80$export$2baac2df6018cd7;
"use strict";
$cb8458ca8d15cd80$export$2baac2df6018cd7 = $cb8458ca8d15cd80$var$isFuture;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ function $cb8458ca8d15cd80$var$isFuture(date) {
    return +(0, $hC8hz.toDate)(date) > Date.now();
}


Object.keys($cb8458ca8d15cd80$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cb8458ca8d15cd80$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cb8458ca8d15cd80$exports[key];
        }
    });
});

Object.keys($b196969b73db0a4d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b196969b73db0a4d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b196969b73db0a4d$exports[key];
        }
    });
});

Object.keys($06e653d0efa56091$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $06e653d0efa56091$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $06e653d0efa56091$exports[key];
        }
    });
});
var $0c88f24855c5bfe3$exports = {};

$parcel$export($0c88f24855c5bfe3$exports, "isMatch", function () { return $0c88f24855c5bfe3$export$b74c33566721f70f; }, function (v) { return $0c88f24855c5bfe3$export$b74c33566721f70f = v; });
var $0c88f24855c5bfe3$export$b74c33566721f70f;
"use strict";
$0c88f24855c5bfe3$export$b74c33566721f70f = $0c88f24855c5bfe3$var$isMatch;

var $bJrOu = parcelRequire("bJrOu");

var $56yXI = parcelRequire("56yXI");
/**
 * The {@link isMatch} function options.
 */ /**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */ function $0c88f24855c5bfe3$var$isMatch(dateStr, formatStr, options) {
    return (0, $bJrOu.isValid)((0, $56yXI.parse)(dateStr, formatStr, new Date(), options));
}


Object.keys($0c88f24855c5bfe3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $0c88f24855c5bfe3$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $0c88f24855c5bfe3$exports[key];
        }
    });
});
var $b1b6811eea94c411$exports = {};

$parcel$export($b1b6811eea94c411$exports, "isMonday", function () { return $b1b6811eea94c411$export$9573fe9b7c9ac3f5; }, function (v) { return $b1b6811eea94c411$export$9573fe9b7c9ac3f5 = v; });
var $b1b6811eea94c411$export$9573fe9b7c9ac3f5;
"use strict";
$b1b6811eea94c411$export$9573fe9b7c9ac3f5 = $b1b6811eea94c411$var$isMonday;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */ function $b1b6811eea94c411$var$isMonday(date) {
    return (0, $hC8hz.toDate)(date).getDay() === 1;
}


Object.keys($b1b6811eea94c411$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b1b6811eea94c411$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b1b6811eea94c411$exports[key];
        }
    });
});
var $1d879d01cdf0e5b7$exports = {};

$parcel$export($1d879d01cdf0e5b7$exports, "isPast", function () { return $1d879d01cdf0e5b7$export$fc5014aa3db48558; }, function (v) { return $1d879d01cdf0e5b7$export$fc5014aa3db48558 = v; });
var $1d879d01cdf0e5b7$export$fc5014aa3db48558;
"use strict";
$1d879d01cdf0e5b7$export$fc5014aa3db48558 = $1d879d01cdf0e5b7$var$isPast;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ function $1d879d01cdf0e5b7$var$isPast(date) {
    return +(0, $hC8hz.toDate)(date) < Date.now();
}


Object.keys($1d879d01cdf0e5b7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $1d879d01cdf0e5b7$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $1d879d01cdf0e5b7$exports[key];
        }
    });
});

var $hVwiy = parcelRequire("hVwiy");
Object.keys($hVwiy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $hVwiy[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $hVwiy[key];
        }
    });
});
var $bedc509eafa73237$exports = {};

$parcel$export($bedc509eafa73237$exports, "isSameHour", function () { return $bedc509eafa73237$export$f9f3a94a0371013; }, function (v) { return $bedc509eafa73237$export$f9f3a94a0371013 = v; });
var $bedc509eafa73237$export$f9f3a94a0371013;
"use strict";
$bedc509eafa73237$export$f9f3a94a0371013 = $bedc509eafa73237$var$isSameHour;
var $49e2cdb50a926fb6$exports = {};

$parcel$export($49e2cdb50a926fb6$exports, "startOfHour", function () { return $49e2cdb50a926fb6$export$24f91f68e7c9d9d5; }, function (v) { return $49e2cdb50a926fb6$export$24f91f68e7c9d9d5 = v; });
var $49e2cdb50a926fb6$export$24f91f68e7c9d9d5;
"use strict";
$49e2cdb50a926fb6$export$24f91f68e7c9d9d5 = $49e2cdb50a926fb6$var$startOfHour;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ function $49e2cdb50a926fb6$var$startOfHour(date) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}


/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */ function $bedc509eafa73237$var$isSameHour(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $49e2cdb50a926fb6$export$24f91f68e7c9d9d5)(dateLeft);
    const dateRightStartOfHour = (0, $49e2cdb50a926fb6$export$24f91f68e7c9d9d5)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}


Object.keys($bedc509eafa73237$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $bedc509eafa73237$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $bedc509eafa73237$exports[key];
        }
    });
});
var $d9441ff164889915$exports = {};

$parcel$export($d9441ff164889915$exports, "isSameISOWeek", function () { return $d9441ff164889915$export$1c6e74e3c7b27764; }, function (v) { return $d9441ff164889915$export$1c6e74e3c7b27764 = v; });
var $d9441ff164889915$export$1c6e74e3c7b27764;
"use strict";
$d9441ff164889915$export$1c6e74e3c7b27764 = $d9441ff164889915$var$isSameISOWeek;
var $a22892900b84c154$exports = {};

$parcel$export($a22892900b84c154$exports, "isSameWeek", function () { return $a22892900b84c154$export$6ea683876c36b8d2; }, function (v) { return $a22892900b84c154$export$6ea683876c36b8d2 = v; });
var $a22892900b84c154$export$6ea683876c36b8d2;
"use strict";
$a22892900b84c154$export$6ea683876c36b8d2 = $a22892900b84c154$var$isSameWeek;

var $5Wrs3 = parcelRequire("5Wrs3");
/**
 * The {@link isSameWeek} function options.
 */ /**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */ function $a22892900b84c154$var$isSameWeek(dateLeft, dateRight, options) {
    const dateLeftStartOfWeek = (0, $5Wrs3.startOfWeek)(dateLeft, options);
    const dateRightStartOfWeek = (0, $5Wrs3.startOfWeek)(dateRight, options);
    return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}


/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */ function $d9441ff164889915$var$isSameISOWeek(dateLeft, dateRight) {
    return (0, $a22892900b84c154$export$6ea683876c36b8d2)(dateLeft, dateRight, {
        weekStartsOn: 1
    });
}


Object.keys($d9441ff164889915$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $d9441ff164889915$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $d9441ff164889915$exports[key];
        }
    });
});
var $a53d3f0d277c4e95$exports = {};

$parcel$export($a53d3f0d277c4e95$exports, "isSameISOWeekYear", function () { return $a53d3f0d277c4e95$export$5f55dbf38a1aee81; }, function (v) { return $a53d3f0d277c4e95$export$5f55dbf38a1aee81 = v; });
var $a53d3f0d277c4e95$export$5f55dbf38a1aee81;
"use strict";
$a53d3f0d277c4e95$export$5f55dbf38a1aee81 = $a53d3f0d277c4e95$var$isSameISOWeekYear;

var $gIGHk = parcelRequire("gIGHk");
/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */ function $a53d3f0d277c4e95$var$isSameISOWeekYear(dateLeft, dateRight) {
    const dateLeftStartOfYear = (0, $gIGHk.startOfISOWeekYear)(dateLeft);
    const dateRightStartOfYear = (0, $gIGHk.startOfISOWeekYear)(dateRight);
    return +dateLeftStartOfYear === +dateRightStartOfYear;
}


Object.keys($a53d3f0d277c4e95$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $a53d3f0d277c4e95$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $a53d3f0d277c4e95$exports[key];
        }
    });
});
var $6057e56959b2ed4d$exports = {};

$parcel$export($6057e56959b2ed4d$exports, "isSameMinute", function () { return $6057e56959b2ed4d$export$5d274bf63c8705cb; }, function (v) { return $6057e56959b2ed4d$export$5d274bf63c8705cb = v; });
var $6057e56959b2ed4d$export$5d274bf63c8705cb;
"use strict";
$6057e56959b2ed4d$export$5d274bf63c8705cb = $6057e56959b2ed4d$var$isSameMinute;

/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */ function $6057e56959b2ed4d$var$isSameMinute(dateLeft, dateRight) {
    const dateLeftStartOfMinute = (0, $d89ec25e3b89d68b$export$c66440458c6aa793)(dateLeft);
    const dateRightStartOfMinute = (0, $d89ec25e3b89d68b$export$c66440458c6aa793)(dateRight);
    return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}


Object.keys($6057e56959b2ed4d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6057e56959b2ed4d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6057e56959b2ed4d$exports[key];
        }
    });
});

var $jHVEe = parcelRequire("jHVEe");
Object.keys($jHVEe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $jHVEe[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $jHVEe[key];
        }
    });
});

var $fTF2B = parcelRequire("fTF2B");
Object.keys($fTF2B).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $fTF2B[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $fTF2B[key];
        }
    });
});
var $5f4eeebd2a567669$exports = {};

$parcel$export($5f4eeebd2a567669$exports, "isSameSecond", function () { return $5f4eeebd2a567669$export$b88fbcfe038f3498; }, function (v) { return $5f4eeebd2a567669$export$b88fbcfe038f3498 = v; });
var $5f4eeebd2a567669$export$b88fbcfe038f3498;
"use strict";
$5f4eeebd2a567669$export$b88fbcfe038f3498 = $5f4eeebd2a567669$var$isSameSecond;
var $3d89ab97462a86ad$exports = {};

$parcel$export($3d89ab97462a86ad$exports, "startOfSecond", function () { return $3d89ab97462a86ad$export$66c51f9715fdbff5; }, function (v) { return $3d89ab97462a86ad$export$66c51f9715fdbff5 = v; });
var $3d89ab97462a86ad$export$66c51f9715fdbff5;
"use strict";
$3d89ab97462a86ad$export$66c51f9715fdbff5 = $3d89ab97462a86ad$var$startOfSecond;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */ function $3d89ab97462a86ad$var$startOfSecond(date) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setMilliseconds(0);
    return _date;
}


/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */ function $5f4eeebd2a567669$var$isSameSecond(dateLeft, dateRight) {
    const dateLeftStartOfSecond = (0, $3d89ab97462a86ad$export$66c51f9715fdbff5)(dateLeft);
    const dateRightStartOfSecond = (0, $3d89ab97462a86ad$export$66c51f9715fdbff5)(dateRight);
    return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}


Object.keys($5f4eeebd2a567669$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $5f4eeebd2a567669$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $5f4eeebd2a567669$exports[key];
        }
    });
});

Object.keys($a22892900b84c154$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $a22892900b84c154$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $a22892900b84c154$exports[key];
        }
    });
});

var $cHSNE = parcelRequire("cHSNE");
Object.keys($cHSNE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cHSNE[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cHSNE[key];
        }
    });
});

Object.keys($65c56ab9e14d389e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $65c56ab9e14d389e$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $65c56ab9e14d389e$exports[key];
        }
    });
});

Object.keys($089d279f7e48db36$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $089d279f7e48db36$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $089d279f7e48db36$exports[key];
        }
    });
});
var $7a3d158de9bd17e6$exports = {};

$parcel$export($7a3d158de9bd17e6$exports, "isThisHour", function () { return $7a3d158de9bd17e6$export$5d41bdc7172839b9; }, function (v) { return $7a3d158de9bd17e6$export$5d41bdc7172839b9 = v; });
var $7a3d158de9bd17e6$export$5d41bdc7172839b9;
"use strict";
$7a3d158de9bd17e6$export$5d41bdc7172839b9 = $7a3d158de9bd17e6$var$isThisHour;


/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */ function $7a3d158de9bd17e6$var$isThisHour(date) {
    return (0, $bedc509eafa73237$export$f9f3a94a0371013)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date));
}


Object.keys($7a3d158de9bd17e6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $7a3d158de9bd17e6$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $7a3d158de9bd17e6$exports[key];
        }
    });
});
var $3c608fae90fc5f93$exports = {};

$parcel$export($3c608fae90fc5f93$exports, "isThisISOWeek", function () { return $3c608fae90fc5f93$export$4e987896c721f753; }, function (v) { return $3c608fae90fc5f93$export$4e987896c721f753 = v; });
var $3c608fae90fc5f93$export$4e987896c721f753;
"use strict";
$3c608fae90fc5f93$export$4e987896c721f753 = $3c608fae90fc5f93$var$isThisISOWeek;


/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */ function $3c608fae90fc5f93$var$isThisISOWeek(date) {
    return (0, $d9441ff164889915$export$1c6e74e3c7b27764)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date));
}


Object.keys($3c608fae90fc5f93$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3c608fae90fc5f93$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3c608fae90fc5f93$exports[key];
        }
    });
});
var $abb72c3860348fc9$exports = {};

$parcel$export($abb72c3860348fc9$exports, "isThisMinute", function () { return $abb72c3860348fc9$export$fa55b7d29d8d957a; }, function (v) { return $abb72c3860348fc9$export$fa55b7d29d8d957a = v; });
var $abb72c3860348fc9$export$fa55b7d29d8d957a;
"use strict";
$abb72c3860348fc9$export$fa55b7d29d8d957a = $abb72c3860348fc9$var$isThisMinute;


/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */ function $abb72c3860348fc9$var$isThisMinute(date) {
    return (0, $6057e56959b2ed4d$export$5d274bf63c8705cb)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date));
}


Object.keys($abb72c3860348fc9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $abb72c3860348fc9$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $abb72c3860348fc9$exports[key];
        }
    });
});
var $3b5c20e02b4e1ebb$exports = {};

$parcel$export($3b5c20e02b4e1ebb$exports, "isThisMonth", function () { return $3b5c20e02b4e1ebb$export$173f1e1d92847276; }, function (v) { return $3b5c20e02b4e1ebb$export$173f1e1d92847276 = v; });
var $3b5c20e02b4e1ebb$export$173f1e1d92847276;
"use strict";
$3b5c20e02b4e1ebb$export$173f1e1d92847276 = $3b5c20e02b4e1ebb$var$isThisMonth;


var $jHVEe = parcelRequire("jHVEe");
/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */ function $3b5c20e02b4e1ebb$var$isThisMonth(date) {
    return (0, $jHVEe.isSameMonth)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date));
}


Object.keys($3b5c20e02b4e1ebb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3b5c20e02b4e1ebb$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3b5c20e02b4e1ebb$exports[key];
        }
    });
});
var $b657f24b02ca7ab5$exports = {};

$parcel$export($b657f24b02ca7ab5$exports, "isThisQuarter", function () { return $b657f24b02ca7ab5$export$3d88fd18ab599ccc; }, function (v) { return $b657f24b02ca7ab5$export$3d88fd18ab599ccc = v; });
var $b657f24b02ca7ab5$export$3d88fd18ab599ccc;
"use strict";
$b657f24b02ca7ab5$export$3d88fd18ab599ccc = $b657f24b02ca7ab5$var$isThisQuarter;


var $fTF2B = parcelRequire("fTF2B");
/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */ function $b657f24b02ca7ab5$var$isThisQuarter(date) {
    return (0, $fTF2B.isSameQuarter)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date));
}


Object.keys($b657f24b02ca7ab5$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b657f24b02ca7ab5$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b657f24b02ca7ab5$exports[key];
        }
    });
});
var $c8b20e858612b0b8$exports = {};

$parcel$export($c8b20e858612b0b8$exports, "isThisSecond", function () { return $c8b20e858612b0b8$export$8d7059b5bca087e6; }, function (v) { return $c8b20e858612b0b8$export$8d7059b5bca087e6 = v; });
var $c8b20e858612b0b8$export$8d7059b5bca087e6;
"use strict";
$c8b20e858612b0b8$export$8d7059b5bca087e6 = $c8b20e858612b0b8$var$isThisSecond;


/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */ function $c8b20e858612b0b8$var$isThisSecond(date) {
    return (0, $5f4eeebd2a567669$export$b88fbcfe038f3498)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date));
}


Object.keys($c8b20e858612b0b8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $c8b20e858612b0b8$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $c8b20e858612b0b8$exports[key];
        }
    });
});
var $b09069f62a4b781d$exports = {};

$parcel$export($b09069f62a4b781d$exports, "isThisWeek", function () { return $b09069f62a4b781d$export$cfe4b66a69cdd8a; }, function (v) { return $b09069f62a4b781d$export$cfe4b66a69cdd8a = v; });
var $b09069f62a4b781d$export$cfe4b66a69cdd8a;
"use strict";
$b09069f62a4b781d$export$cfe4b66a69cdd8a = $b09069f62a4b781d$var$isThisWeek;


/**
 * The {@link isThisWeek} function options.
 */ /**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */ function $b09069f62a4b781d$var$isThisWeek(date, options) {
    return (0, $a22892900b84c154$export$6ea683876c36b8d2)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date), options);
}


Object.keys($b09069f62a4b781d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b09069f62a4b781d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b09069f62a4b781d$exports[key];
        }
    });
});
var $96969e80de20077c$exports = {};

$parcel$export($96969e80de20077c$exports, "isThisYear", function () { return $96969e80de20077c$export$a28c94941893a5ac; }, function (v) { return $96969e80de20077c$export$a28c94941893a5ac = v; });
var $96969e80de20077c$export$a28c94941893a5ac;
"use strict";
$96969e80de20077c$export$a28c94941893a5ac = $96969e80de20077c$var$isThisYear;


var $cHSNE = parcelRequire("cHSNE");
/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */ function $96969e80de20077c$var$isThisYear(date) {
    return (0, $cHSNE.isSameYear)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date));
}


Object.keys($96969e80de20077c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $96969e80de20077c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $96969e80de20077c$exports[key];
        }
    });
});
var $1011b4309df4ba59$exports = {};

$parcel$export($1011b4309df4ba59$exports, "isThursday", function () { return $1011b4309df4ba59$export$c8e7c906983ea347; }, function (v) { return $1011b4309df4ba59$export$c8e7c906983ea347 = v; });
var $1011b4309df4ba59$export$c8e7c906983ea347;
"use strict";
$1011b4309df4ba59$export$c8e7c906983ea347 = $1011b4309df4ba59$var$isThursday;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */ function $1011b4309df4ba59$var$isThursday(date) {
    return (0, $hC8hz.toDate)(date).getDay() === 4;
}


Object.keys($1011b4309df4ba59$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $1011b4309df4ba59$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $1011b4309df4ba59$exports[key];
        }
    });
});
var $1e46fbd23f5fd8d0$exports = {};

$parcel$export($1e46fbd23f5fd8d0$exports, "isToday", function () { return $1e46fbd23f5fd8d0$export$629b0a497aa65267; }, function (v) { return $1e46fbd23f5fd8d0$export$629b0a497aa65267 = v; });
var $1e46fbd23f5fd8d0$export$629b0a497aa65267;
"use strict";
$1e46fbd23f5fd8d0$export$629b0a497aa65267 = $1e46fbd23f5fd8d0$var$isToday;


var $hVwiy = parcelRequire("hVwiy");
/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ function $1e46fbd23f5fd8d0$var$isToday(date) {
    return (0, $hVwiy.isSameDay)(date, (0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date));
}


Object.keys($1e46fbd23f5fd8d0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $1e46fbd23f5fd8d0$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $1e46fbd23f5fd8d0$exports[key];
        }
    });
});
var $7e492bd1e4cf7c0b$exports = {};

$parcel$export($7e492bd1e4cf7c0b$exports, "isTomorrow", function () { return $7e492bd1e4cf7c0b$export$d6365ba92f0647f1; }, function (v) { return $7e492bd1e4cf7c0b$export$d6365ba92f0647f1 = v; });
var $7e492bd1e4cf7c0b$export$d6365ba92f0647f1;
"use strict";
$7e492bd1e4cf7c0b$export$d6365ba92f0647f1 = $7e492bd1e4cf7c0b$var$isTomorrow;

var $9wlqC = parcelRequire("9wlqC");


var $hVwiy = parcelRequire("hVwiy");
/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */ function $7e492bd1e4cf7c0b$var$isTomorrow(date) {
    return (0, $hVwiy.isSameDay)(date, (0, $9wlqC.addDays)((0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date), 1));
}


Object.keys($7e492bd1e4cf7c0b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $7e492bd1e4cf7c0b$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $7e492bd1e4cf7c0b$exports[key];
        }
    });
});
var $a8725696233b7d28$exports = {};

$parcel$export($a8725696233b7d28$exports, "isTuesday", function () { return $a8725696233b7d28$export$90d50b8f209f5ac3; }, function (v) { return $a8725696233b7d28$export$90d50b8f209f5ac3 = v; });
var $a8725696233b7d28$export$90d50b8f209f5ac3;
"use strict";
$a8725696233b7d28$export$90d50b8f209f5ac3 = $a8725696233b7d28$var$isTuesday;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */ function $a8725696233b7d28$var$isTuesday(date) {
    return (0, $hC8hz.toDate)(date).getDay() === 2;
}


Object.keys($a8725696233b7d28$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $a8725696233b7d28$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $a8725696233b7d28$exports[key];
        }
    });
});

var $bJrOu = parcelRequire("bJrOu");
Object.keys($bJrOu).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $bJrOu[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $bJrOu[key];
        }
    });
});
var $c20724aa4410662c$exports = {};

$parcel$export($c20724aa4410662c$exports, "isWednesday", function () { return $c20724aa4410662c$export$ec9de642cdd62944; }, function (v) { return $c20724aa4410662c$export$ec9de642cdd62944 = v; });
var $c20724aa4410662c$export$ec9de642cdd62944;
"use strict";
$c20724aa4410662c$export$ec9de642cdd62944 = $c20724aa4410662c$var$isWednesday;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */ function $c20724aa4410662c$var$isWednesday(date) {
    return (0, $hC8hz.toDate)(date).getDay() === 3;
}


Object.keys($c20724aa4410662c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $c20724aa4410662c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $c20724aa4410662c$exports[key];
        }
    });
});

Object.keys($55f8493c71ba43e1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $55f8493c71ba43e1$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $55f8493c71ba43e1$exports[key];
        }
    });
});

var $k7NE3 = parcelRequire("k7NE3");
Object.keys($k7NE3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $k7NE3[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $k7NE3[key];
        }
    });
});
var $33db3b63028cba57$exports = {};

$parcel$export($33db3b63028cba57$exports, "isYesterday", function () { return $33db3b63028cba57$export$221990270ebfe867; }, function (v) { return $33db3b63028cba57$export$221990270ebfe867 = v; });
var $33db3b63028cba57$export$221990270ebfe867;
"use strict";
$33db3b63028cba57$export$221990270ebfe867 = $33db3b63028cba57$var$isYesterday;


var $hVwiy = parcelRequire("hVwiy");

var $6nsOA = parcelRequire("6nsOA");
/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */ function $33db3b63028cba57$var$isYesterday(date) {
    return (0, $hVwiy.isSameDay)(date, (0, $6nsOA.subDays)((0, $9e33fb844b62c4b5$export$18c3c6510fb97afc)(date), 1));
}


Object.keys($33db3b63028cba57$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $33db3b63028cba57$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $33db3b63028cba57$exports[key];
        }
    });
});
var $f5264fd0f9463348$exports = {};

$parcel$export($f5264fd0f9463348$exports, "lastDayOfDecade", function () { return $f5264fd0f9463348$export$2aaf6241f57dd605; }, function (v) { return $f5264fd0f9463348$export$2aaf6241f57dd605 = v; });
var $f5264fd0f9463348$export$2aaf6241f57dd605;
"use strict";
$f5264fd0f9463348$export$2aaf6241f57dd605 = $f5264fd0f9463348$var$lastDayOfDecade;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */ function $f5264fd0f9463348$var$lastDayOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    const decade = 9 + Math.floor(year / 10) * 10;
    _date.setFullYear(decade + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($f5264fd0f9463348$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $f5264fd0f9463348$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $f5264fd0f9463348$exports[key];
        }
    });
});
var $5bc4bd58c0958a2a$exports = {};

$parcel$export($5bc4bd58c0958a2a$exports, "lastDayOfISOWeek", function () { return $5bc4bd58c0958a2a$export$b08a8fc26ae6d94b; }, function (v) { return $5bc4bd58c0958a2a$export$b08a8fc26ae6d94b = v; });
var $5bc4bd58c0958a2a$export$b08a8fc26ae6d94b;
"use strict";
$5bc4bd58c0958a2a$export$b08a8fc26ae6d94b = $5bc4bd58c0958a2a$var$lastDayOfISOWeek;
var $52a7ccaa093d31b2$exports = {};

$parcel$export($52a7ccaa093d31b2$exports, "lastDayOfWeek", function () { return $52a7ccaa093d31b2$export$b73502c35a293b0a; }, function (v) { return $52a7ccaa093d31b2$export$b73502c35a293b0a = v; });
var $52a7ccaa093d31b2$export$b73502c35a293b0a;
"use strict";
$52a7ccaa093d31b2$export$b73502c35a293b0a = $52a7ccaa093d31b2$var$lastDayOfWeek;

var $hC8hz = parcelRequire("hC8hz");

var $3Om6B = parcelRequire("3Om6B");
/**
 * The {@link lastDayOfWeek} function options.
 */ /**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ function $52a7ccaa093d31b2$var$lastDayOfWeek(date, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $hC8hz.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setHours(0, 0, 0, 0);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */ function $5bc4bd58c0958a2a$var$lastDayOfISOWeek(date) {
    return (0, $52a7ccaa093d31b2$export$b73502c35a293b0a)(date, {
        weekStartsOn: 1
    });
}


Object.keys($5bc4bd58c0958a2a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $5bc4bd58c0958a2a$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $5bc4bd58c0958a2a$exports[key];
        }
    });
});
var $7b8235cfe6dbc75d$exports = {};

$parcel$export($7b8235cfe6dbc75d$exports, "lastDayOfISOWeekYear", function () { return $7b8235cfe6dbc75d$export$1810bada8cd02ee1; }, function (v) { return $7b8235cfe6dbc75d$export$1810bada8cd02ee1 = v; });
var $7b8235cfe6dbc75d$export$1810bada8cd02ee1;
"use strict";
$7b8235cfe6dbc75d$export$1810bada8cd02ee1 = $7b8235cfe6dbc75d$var$lastDayOfISOWeekYear;

var $ctBkT = parcelRequire("ctBkT");

var $6nmfz = parcelRequire("6nmfz");

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */ function $7b8235cfe6dbc75d$var$lastDayOfISOWeekYear(date) {
    const year = (0, $ctBkT.getISOWeekYear)(date);
    const fourthOfJanuary = (0, $cHwnM.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    const _date = (0, $6nmfz.startOfISOWeek)(fourthOfJanuary);
    _date.setDate(_date.getDate() - 1);
    return _date;
}


Object.keys($7b8235cfe6dbc75d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $7b8235cfe6dbc75d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $7b8235cfe6dbc75d$exports[key];
        }
    });
});

Object.keys($7c6145febc2114e8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $7c6145febc2114e8$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $7c6145febc2114e8$exports[key];
        }
    });
});
var $dc9feed1e488a0f2$exports = {};

$parcel$export($dc9feed1e488a0f2$exports, "lastDayOfQuarter", function () { return $dc9feed1e488a0f2$export$8693c04228304c7; }, function (v) { return $dc9feed1e488a0f2$export$8693c04228304c7 = v; });
var $dc9feed1e488a0f2$export$8693c04228304c7;
"use strict";
$dc9feed1e488a0f2$export$8693c04228304c7 = $dc9feed1e488a0f2$var$lastDayOfQuarter;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */ function $dc9feed1e488a0f2$var$lastDayOfQuarter(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($dc9feed1e488a0f2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $dc9feed1e488a0f2$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $dc9feed1e488a0f2$exports[key];
        }
    });
});

Object.keys($52a7ccaa093d31b2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $52a7ccaa093d31b2$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $52a7ccaa093d31b2$exports[key];
        }
    });
});
var $48e3bd5a30a970f8$exports = {};

$parcel$export($48e3bd5a30a970f8$exports, "lastDayOfYear", function () { return $48e3bd5a30a970f8$export$323f7bc07b828bed; }, function (v) { return $48e3bd5a30a970f8$export$323f7bc07b828bed = v; });
var $48e3bd5a30a970f8$export$323f7bc07b828bed;
"use strict";
$48e3bd5a30a970f8$export$323f7bc07b828bed = $48e3bd5a30a970f8$var$lastDayOfYear;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */ function $48e3bd5a30a970f8$var$lastDayOfYear(date) {
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($48e3bd5a30a970f8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $48e3bd5a30a970f8$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $48e3bd5a30a970f8$exports[key];
        }
    });
});
var $2a25ef50900e6ad0$exports = {};
"use strict";
$2a25ef50900e6ad0$exports.lightFormat = $2a25ef50900e6ad0$var$lightFormat;
Object.defineProperty($2a25ef50900e6ad0$exports, "lightFormatters", {
    enumerable: true,
    get: function() {
        return $gdN1B.lightFormatters;
    }
});

var $bJrOu = parcelRequire("bJrOu");

var $hC8hz = parcelRequire("hC8hz");

var $gdN1B = parcelRequire("gdN1B");
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $2a25ef50900e6ad0$var$formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
const $2a25ef50900e6ad0$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $2a25ef50900e6ad0$var$doubleQuoteRegExp = /''/g;
const $2a25ef50900e6ad0$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @private
 */ /**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */ function $2a25ef50900e6ad0$var$lightFormat(date, formatStr) {
    const _date = (0, $hC8hz.toDate)(date);
    if (!(0, $bJrOu.isValid)(_date)) throw new RangeError("Invalid time value");
    const tokens = formatStr.match($2a25ef50900e6ad0$var$formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return "";
    const result = tokens.map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return $2a25ef50900e6ad0$var$cleanEscapedString(substring);
        const formatter = $gdN1B.lightFormatters[firstCharacter];
        if (formatter) return formatter(_date, substring);
        if (firstCharacter.match($2a25ef50900e6ad0$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $2a25ef50900e6ad0$var$cleanEscapedString(input) {
    const matches = input.match($2a25ef50900e6ad0$var$escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace($2a25ef50900e6ad0$var$doubleQuoteRegExp, "'");
}


Object.keys($2a25ef50900e6ad0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $2a25ef50900e6ad0$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $2a25ef50900e6ad0$exports[key];
        }
    });
});

var $7DYAE = parcelRequire("7DYAE");
Object.keys($7DYAE).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $7DYAE[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $7DYAE[key];
        }
    });
});
var $e35ef8a2ab75232a$exports = {};

$parcel$export($e35ef8a2ab75232a$exports, "milliseconds", function () { return $e35ef8a2ab75232a$export$9a27fac83d67afd3; }, function (v) { return $e35ef8a2ab75232a$export$9a27fac83d67afd3 = v; });
var $e35ef8a2ab75232a$export$9a27fac83d67afd3;
"use strict";
$e35ef8a2ab75232a$export$9a27fac83d67afd3 = $e35ef8a2ab75232a$var$milliseconds;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */ function $e35ef8a2ab75232a$var$milliseconds({ years: years , months: months , weeks: weeks , days: days , hours: hours , minutes: minutes , seconds: seconds  }) {
    let totalDays = 0;
    if (years) totalDays += years * $5K4u1.daysInYear;
    if (months) totalDays += months * ($5K4u1.daysInYear / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    let totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.trunc(totalSeconds * 1000);
}


Object.keys($e35ef8a2ab75232a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $e35ef8a2ab75232a$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $e35ef8a2ab75232a$exports[key];
        }
    });
});
var $00004c19095c935c$exports = {};

$parcel$export($00004c19095c935c$exports, "millisecondsToHours", function () { return $00004c19095c935c$export$689a412b29fa9ed5; }, function (v) { return $00004c19095c935c$export$689a412b29fa9ed5 = v; });
var $00004c19095c935c$export$689a412b29fa9ed5;
"use strict";
$00004c19095c935c$export$689a412b29fa9ed5 = $00004c19095c935c$var$millisecondsToHours;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */ function $00004c19095c935c$var$millisecondsToHours(milliseconds) {
    const hours = milliseconds / $5K4u1.millisecondsInHour;
    return Math.trunc(hours);
}


Object.keys($00004c19095c935c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $00004c19095c935c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $00004c19095c935c$exports[key];
        }
    });
});
var $668e256f73341ce1$exports = {};

$parcel$export($668e256f73341ce1$exports, "millisecondsToMinutes", function () { return $668e256f73341ce1$export$a5f974e81e48cfc0; }, function (v) { return $668e256f73341ce1$export$a5f974e81e48cfc0 = v; });
var $668e256f73341ce1$export$a5f974e81e48cfc0;
"use strict";
$668e256f73341ce1$export$a5f974e81e48cfc0 = $668e256f73341ce1$var$millisecondsToMinutes;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */ function $668e256f73341ce1$var$millisecondsToMinutes(milliseconds) {
    const minutes = milliseconds / $5K4u1.millisecondsInMinute;
    return Math.trunc(minutes);
}


Object.keys($668e256f73341ce1$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $668e256f73341ce1$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $668e256f73341ce1$exports[key];
        }
    });
});
var $d06de32496024e7e$exports = {};

$parcel$export($d06de32496024e7e$exports, "millisecondsToSeconds", function () { return $d06de32496024e7e$export$f64c3bfbc58eec0f; }, function (v) { return $d06de32496024e7e$export$f64c3bfbc58eec0f = v; });
var $d06de32496024e7e$export$f64c3bfbc58eec0f;
"use strict";
$d06de32496024e7e$export$f64c3bfbc58eec0f = $d06de32496024e7e$var$millisecondsToSeconds;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */ function $d06de32496024e7e$var$millisecondsToSeconds(milliseconds) {
    const seconds = milliseconds / $5K4u1.millisecondsInSecond;
    return Math.trunc(seconds);
}


Object.keys($d06de32496024e7e$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $d06de32496024e7e$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $d06de32496024e7e$exports[key];
        }
    });
});

var $3al5W = parcelRequire("3al5W");
Object.keys($3al5W).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3al5W[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3al5W[key];
        }
    });
});
var $5a2da80dd77813dc$exports = {};

$parcel$export($5a2da80dd77813dc$exports, "minutesToHours", function () { return $5a2da80dd77813dc$export$815164eb42530ae7; }, function (v) { return $5a2da80dd77813dc$export$815164eb42530ae7 = v; });
var $5a2da80dd77813dc$export$815164eb42530ae7;
"use strict";
$5a2da80dd77813dc$export$815164eb42530ae7 = $5a2da80dd77813dc$var$minutesToHours;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */ function $5a2da80dd77813dc$var$minutesToHours(minutes) {
    const hours = minutes / $5K4u1.minutesInHour;
    return Math.trunc(hours);
}


Object.keys($5a2da80dd77813dc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $5a2da80dd77813dc$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $5a2da80dd77813dc$exports[key];
        }
    });
});
var $35b8edd6ee130ab3$exports = {};

$parcel$export($35b8edd6ee130ab3$exports, "minutesToMilliseconds", function () { return $35b8edd6ee130ab3$export$f6b9795ef9056e3d; }, function (v) { return $35b8edd6ee130ab3$export$f6b9795ef9056e3d = v; });
var $35b8edd6ee130ab3$export$f6b9795ef9056e3d;
"use strict";
$35b8edd6ee130ab3$export$f6b9795ef9056e3d = $35b8edd6ee130ab3$var$minutesToMilliseconds;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */ function $35b8edd6ee130ab3$var$minutesToMilliseconds(minutes) {
    return Math.trunc(minutes * $5K4u1.millisecondsInMinute);
}


Object.keys($35b8edd6ee130ab3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $35b8edd6ee130ab3$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $35b8edd6ee130ab3$exports[key];
        }
    });
});
var $15c5f3a41822933d$exports = {};

$parcel$export($15c5f3a41822933d$exports, "minutesToSeconds", function () { return $15c5f3a41822933d$export$81ded4628c655103; }, function (v) { return $15c5f3a41822933d$export$81ded4628c655103 = v; });
var $15c5f3a41822933d$export$81ded4628c655103;
"use strict";
$15c5f3a41822933d$export$81ded4628c655103 = $15c5f3a41822933d$var$minutesToSeconds;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */ function $15c5f3a41822933d$var$minutesToSeconds(minutes) {
    return Math.trunc(minutes * $5K4u1.secondsInMinute);
}


Object.keys($15c5f3a41822933d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $15c5f3a41822933d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $15c5f3a41822933d$exports[key];
        }
    });
});
var $e2dc96b13a1825e4$exports = {};

$parcel$export($e2dc96b13a1825e4$exports, "monthsToQuarters", function () { return $e2dc96b13a1825e4$export$1932fa2a2068c849; }, function (v) { return $e2dc96b13a1825e4$export$1932fa2a2068c849 = v; });
var $e2dc96b13a1825e4$export$1932fa2a2068c849;
"use strict";
$e2dc96b13a1825e4$export$1932fa2a2068c849 = $e2dc96b13a1825e4$var$monthsToQuarters;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */ function $e2dc96b13a1825e4$var$monthsToQuarters(months) {
    const quarters = months / $5K4u1.monthsInQuarter;
    return Math.trunc(quarters);
}


Object.keys($e2dc96b13a1825e4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $e2dc96b13a1825e4$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $e2dc96b13a1825e4$exports[key];
        }
    });
});
var $b6a6ccc5254bb87d$exports = {};

$parcel$export($b6a6ccc5254bb87d$exports, "monthsToYears", function () { return $b6a6ccc5254bb87d$export$7489026ed27fc925; }, function (v) { return $b6a6ccc5254bb87d$export$7489026ed27fc925 = v; });
var $b6a6ccc5254bb87d$export$7489026ed27fc925;
"use strict";
$b6a6ccc5254bb87d$export$7489026ed27fc925 = $b6a6ccc5254bb87d$var$monthsToYears;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */ function $b6a6ccc5254bb87d$var$monthsToYears(months) {
    const years = months / $5K4u1.monthsInYear;
    return Math.trunc(years);
}


Object.keys($b6a6ccc5254bb87d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b6a6ccc5254bb87d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b6a6ccc5254bb87d$exports[key];
        }
    });
});
var $5ff3ebe7e7e9355c$exports = {};

$parcel$export($5ff3ebe7e7e9355c$exports, "nextDay", function () { return $5ff3ebe7e7e9355c$export$992728922317ffc8; }, function (v) { return $5ff3ebe7e7e9355c$export$992728922317ffc8 = v; });
var $5ff3ebe7e7e9355c$export$992728922317ffc8;
"use strict";
$5ff3ebe7e7e9355c$export$992728922317ffc8 = $5ff3ebe7e7e9355c$var$nextDay;

var $9wlqC = parcelRequire("9wlqC");

var $6UKPj = parcelRequire("6UKPj");
/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */ function $5ff3ebe7e7e9355c$var$nextDay(date, day) {
    let delta = day - (0, $6UKPj.getDay)(date);
    if (delta <= 0) delta += 7;
    return (0, $9wlqC.addDays)(date, delta);
}


Object.keys($5ff3ebe7e7e9355c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $5ff3ebe7e7e9355c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $5ff3ebe7e7e9355c$exports[key];
        }
    });
});
var $3ff16984fb35033c$exports = {};

$parcel$export($3ff16984fb35033c$exports, "nextFriday", function () { return $3ff16984fb35033c$export$21d76934fce76327; }, function (v) { return $3ff16984fb35033c$export$21d76934fce76327 = v; });
var $3ff16984fb35033c$export$21d76934fce76327;
"use strict";
$3ff16984fb35033c$export$21d76934fce76327 = $3ff16984fb35033c$var$nextFriday;

/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */ function $3ff16984fb35033c$var$nextFriday(date) {
    return (0, $5ff3ebe7e7e9355c$export$992728922317ffc8)(date, 5);
}


Object.keys($3ff16984fb35033c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3ff16984fb35033c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3ff16984fb35033c$exports[key];
        }
    });
});
var $ecf101fa6f65fee9$exports = {};

$parcel$export($ecf101fa6f65fee9$exports, "nextMonday", function () { return $ecf101fa6f65fee9$export$a20373bb0df6efdd; }, function (v) { return $ecf101fa6f65fee9$export$a20373bb0df6efdd = v; });
var $ecf101fa6f65fee9$export$a20373bb0df6efdd;
"use strict";
$ecf101fa6f65fee9$export$a20373bb0df6efdd = $ecf101fa6f65fee9$var$nextMonday;

/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */ function $ecf101fa6f65fee9$var$nextMonday(date) {
    return (0, $5ff3ebe7e7e9355c$export$992728922317ffc8)(date, 1);
}


Object.keys($ecf101fa6f65fee9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $ecf101fa6f65fee9$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $ecf101fa6f65fee9$exports[key];
        }
    });
});
var $8470c1cabd1b3b9c$exports = {};

$parcel$export($8470c1cabd1b3b9c$exports, "nextSaturday", function () { return $8470c1cabd1b3b9c$export$c52f069246f7b032; }, function (v) { return $8470c1cabd1b3b9c$export$c52f069246f7b032 = v; });
var $8470c1cabd1b3b9c$export$c52f069246f7b032;
"use strict";
$8470c1cabd1b3b9c$export$c52f069246f7b032 = $8470c1cabd1b3b9c$var$nextSaturday;

/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */ function $8470c1cabd1b3b9c$var$nextSaturday(date) {
    return (0, $5ff3ebe7e7e9355c$export$992728922317ffc8)(date, 6);
}


Object.keys($8470c1cabd1b3b9c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $8470c1cabd1b3b9c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $8470c1cabd1b3b9c$exports[key];
        }
    });
});
var $dfec7baaa293942b$exports = {};

$parcel$export($dfec7baaa293942b$exports, "nextSunday", function () { return $dfec7baaa293942b$export$a30adaa3ef47f854; }, function (v) { return $dfec7baaa293942b$export$a30adaa3ef47f854 = v; });
var $dfec7baaa293942b$export$a30adaa3ef47f854;
"use strict";
$dfec7baaa293942b$export$a30adaa3ef47f854 = $dfec7baaa293942b$var$nextSunday;

/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */ function $dfec7baaa293942b$var$nextSunday(date) {
    return (0, $5ff3ebe7e7e9355c$export$992728922317ffc8)(date, 0);
}


Object.keys($dfec7baaa293942b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $dfec7baaa293942b$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $dfec7baaa293942b$exports[key];
        }
    });
});
var $71a0fafe10393b43$exports = {};

$parcel$export($71a0fafe10393b43$exports, "nextThursday", function () { return $71a0fafe10393b43$export$36d9a8523a98d5a4; }, function (v) { return $71a0fafe10393b43$export$36d9a8523a98d5a4 = v; });
var $71a0fafe10393b43$export$36d9a8523a98d5a4;
"use strict";
$71a0fafe10393b43$export$36d9a8523a98d5a4 = $71a0fafe10393b43$var$nextThursday;

/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */ function $71a0fafe10393b43$var$nextThursday(date) {
    return (0, $5ff3ebe7e7e9355c$export$992728922317ffc8)(date, 4);
}


Object.keys($71a0fafe10393b43$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $71a0fafe10393b43$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $71a0fafe10393b43$exports[key];
        }
    });
});
var $6fea9598778dc3d3$exports = {};

$parcel$export($6fea9598778dc3d3$exports, "nextTuesday", function () { return $6fea9598778dc3d3$export$391d63ff7dc2f668; }, function (v) { return $6fea9598778dc3d3$export$391d63ff7dc2f668 = v; });
var $6fea9598778dc3d3$export$391d63ff7dc2f668;
"use strict";
$6fea9598778dc3d3$export$391d63ff7dc2f668 = $6fea9598778dc3d3$var$nextTuesday;

/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */ function $6fea9598778dc3d3$var$nextTuesday(date) {
    return (0, $5ff3ebe7e7e9355c$export$992728922317ffc8)(date, 2);
}


Object.keys($6fea9598778dc3d3$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6fea9598778dc3d3$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6fea9598778dc3d3$exports[key];
        }
    });
});
var $5f19eebcce37e12c$exports = {};

$parcel$export($5f19eebcce37e12c$exports, "nextWednesday", function () { return $5f19eebcce37e12c$export$7a895c1ff204304e; }, function (v) { return $5f19eebcce37e12c$export$7a895c1ff204304e = v; });
var $5f19eebcce37e12c$export$7a895c1ff204304e;
"use strict";
$5f19eebcce37e12c$export$7a895c1ff204304e = $5f19eebcce37e12c$var$nextWednesday;

/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */ function $5f19eebcce37e12c$var$nextWednesday(date) {
    return (0, $5ff3ebe7e7e9355c$export$992728922317ffc8)(date, 3);
}


Object.keys($5f19eebcce37e12c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $5f19eebcce37e12c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $5f19eebcce37e12c$exports[key];
        }
    });
});

var $56yXI = parcelRequire("56yXI");
Object.keys($56yXI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $56yXI[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $56yXI[key];
        }
    });
});

var $lgH58 = parcelRequire("lgH58");
Object.keys($lgH58).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $lgH58[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $lgH58[key];
        }
    });
});
var $63384ff3d68b5090$exports = {};

$parcel$export($63384ff3d68b5090$exports, "parseJSON", function () { return $63384ff3d68b5090$export$27924e57e9afff7f; }, function (v) { return $63384ff3d68b5090$export$27924e57e9afff7f = v; });
var $63384ff3d68b5090$export$27924e57e9afff7f;
"use strict";
$63384ff3d68b5090$export$27924e57e9afff7f = $63384ff3d68b5090$var$parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */ 
function $63384ff3d68b5090$var$parseJSON(dateStr) {
    const parts = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) // Group 8 matches the sign
    return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    return new Date(NaN);
}


Object.keys($63384ff3d68b5090$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $63384ff3d68b5090$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $63384ff3d68b5090$exports[key];
        }
    });
});
var $31a8a969b81f0d83$exports = {};

$parcel$export($31a8a969b81f0d83$exports, "previousDay", function () { return $31a8a969b81f0d83$export$4caccb62df4eacc0; }, function (v) { return $31a8a969b81f0d83$export$4caccb62df4eacc0 = v; });
var $31a8a969b81f0d83$export$4caccb62df4eacc0;
"use strict";
$31a8a969b81f0d83$export$4caccb62df4eacc0 = $31a8a969b81f0d83$var$previousDay;

var $6UKPj = parcelRequire("6UKPj");

var $6nsOA = parcelRequire("6nsOA");
/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */ function $31a8a969b81f0d83$var$previousDay(date, day) {
    let delta = (0, $6UKPj.getDay)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, $6nsOA.subDays)(date, delta);
}


Object.keys($31a8a969b81f0d83$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $31a8a969b81f0d83$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $31a8a969b81f0d83$exports[key];
        }
    });
});
var $07ed7a4f34c36125$exports = {};

$parcel$export($07ed7a4f34c36125$exports, "previousFriday", function () { return $07ed7a4f34c36125$export$32d52646c338c11d; }, function (v) { return $07ed7a4f34c36125$export$32d52646c338c11d = v; });
var $07ed7a4f34c36125$export$32d52646c338c11d;
"use strict";
$07ed7a4f34c36125$export$32d52646c338c11d = $07ed7a4f34c36125$var$previousFriday;

/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */ function $07ed7a4f34c36125$var$previousFriday(date) {
    return (0, $31a8a969b81f0d83$export$4caccb62df4eacc0)(date, 5);
}


Object.keys($07ed7a4f34c36125$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $07ed7a4f34c36125$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $07ed7a4f34c36125$exports[key];
        }
    });
});
var $cf357e1144b91c98$exports = {};

$parcel$export($cf357e1144b91c98$exports, "previousMonday", function () { return $cf357e1144b91c98$export$398437ab6f45c582; }, function (v) { return $cf357e1144b91c98$export$398437ab6f45c582 = v; });
var $cf357e1144b91c98$export$398437ab6f45c582;
"use strict";
$cf357e1144b91c98$export$398437ab6f45c582 = $cf357e1144b91c98$var$previousMonday;

/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */ function $cf357e1144b91c98$var$previousMonday(date) {
    return (0, $31a8a969b81f0d83$export$4caccb62df4eacc0)(date, 1);
}


Object.keys($cf357e1144b91c98$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cf357e1144b91c98$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cf357e1144b91c98$exports[key];
        }
    });
});
var $34c534b694b85ee0$exports = {};

$parcel$export($34c534b694b85ee0$exports, "previousSaturday", function () { return $34c534b694b85ee0$export$36767a7e6101ecb0; }, function (v) { return $34c534b694b85ee0$export$36767a7e6101ecb0 = v; });
var $34c534b694b85ee0$export$36767a7e6101ecb0;
"use strict";
$34c534b694b85ee0$export$36767a7e6101ecb0 = $34c534b694b85ee0$var$previousSaturday;

/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */ function $34c534b694b85ee0$var$previousSaturday(date) {
    return (0, $31a8a969b81f0d83$export$4caccb62df4eacc0)(date, 6);
}


Object.keys($34c534b694b85ee0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $34c534b694b85ee0$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $34c534b694b85ee0$exports[key];
        }
    });
});
var $26f0bf0fa2444eb6$exports = {};

$parcel$export($26f0bf0fa2444eb6$exports, "previousSunday", function () { return $26f0bf0fa2444eb6$export$7d3d7d8fc5e81fd4; }, function (v) { return $26f0bf0fa2444eb6$export$7d3d7d8fc5e81fd4 = v; });
var $26f0bf0fa2444eb6$export$7d3d7d8fc5e81fd4;
"use strict";
$26f0bf0fa2444eb6$export$7d3d7d8fc5e81fd4 = $26f0bf0fa2444eb6$var$previousSunday;

/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */ function $26f0bf0fa2444eb6$var$previousSunday(date) {
    return (0, $31a8a969b81f0d83$export$4caccb62df4eacc0)(date, 0);
}


Object.keys($26f0bf0fa2444eb6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $26f0bf0fa2444eb6$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $26f0bf0fa2444eb6$exports[key];
        }
    });
});
var $615e3258d13b1726$exports = {};

$parcel$export($615e3258d13b1726$exports, "previousThursday", function () { return $615e3258d13b1726$export$1975b5b1f6b0e34e; }, function (v) { return $615e3258d13b1726$export$1975b5b1f6b0e34e = v; });
var $615e3258d13b1726$export$1975b5b1f6b0e34e;
"use strict";
$615e3258d13b1726$export$1975b5b1f6b0e34e = $615e3258d13b1726$var$previousThursday;

/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */ function $615e3258d13b1726$var$previousThursday(date) {
    return (0, $31a8a969b81f0d83$export$4caccb62df4eacc0)(date, 4);
}


Object.keys($615e3258d13b1726$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $615e3258d13b1726$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $615e3258d13b1726$exports[key];
        }
    });
});
var $c650cf718440c372$exports = {};

$parcel$export($c650cf718440c372$exports, "previousTuesday", function () { return $c650cf718440c372$export$a034a75f093bcfaf; }, function (v) { return $c650cf718440c372$export$a034a75f093bcfaf = v; });
var $c650cf718440c372$export$a034a75f093bcfaf;
"use strict";
$c650cf718440c372$export$a034a75f093bcfaf = $c650cf718440c372$var$previousTuesday;

/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */ function $c650cf718440c372$var$previousTuesday(date) {
    return (0, $31a8a969b81f0d83$export$4caccb62df4eacc0)(date, 2);
}


Object.keys($c650cf718440c372$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $c650cf718440c372$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $c650cf718440c372$exports[key];
        }
    });
});
var $983e9676e6f0a1e4$exports = {};

$parcel$export($983e9676e6f0a1e4$exports, "previousWednesday", function () { return $983e9676e6f0a1e4$export$26334f591e4ce672; }, function (v) { return $983e9676e6f0a1e4$export$26334f591e4ce672 = v; });
var $983e9676e6f0a1e4$export$26334f591e4ce672;
"use strict";
$983e9676e6f0a1e4$export$26334f591e4ce672 = $983e9676e6f0a1e4$var$previousWednesday;

/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */ function $983e9676e6f0a1e4$var$previousWednesday(date) {
    return (0, $31a8a969b81f0d83$export$4caccb62df4eacc0)(date, 3);
}


Object.keys($983e9676e6f0a1e4$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $983e9676e6f0a1e4$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $983e9676e6f0a1e4$exports[key];
        }
    });
});
var $1a9a4b3119e0a83c$exports = {};

$parcel$export($1a9a4b3119e0a83c$exports, "quartersToMonths", function () { return $1a9a4b3119e0a83c$export$a29d19ce21d74c57; }, function (v) { return $1a9a4b3119e0a83c$export$a29d19ce21d74c57 = v; });
var $1a9a4b3119e0a83c$export$a29d19ce21d74c57;
"use strict";
$1a9a4b3119e0a83c$export$a29d19ce21d74c57 = $1a9a4b3119e0a83c$var$quartersToMonths;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */ function $1a9a4b3119e0a83c$var$quartersToMonths(quarters) {
    return Math.trunc(quarters * $5K4u1.monthsInQuarter);
}


Object.keys($1a9a4b3119e0a83c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $1a9a4b3119e0a83c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $1a9a4b3119e0a83c$exports[key];
        }
    });
});
var $5c8f8fe6bf2c6ed7$exports = {};

$parcel$export($5c8f8fe6bf2c6ed7$exports, "quartersToYears", function () { return $5c8f8fe6bf2c6ed7$export$c309fa8f184b4648; }, function (v) { return $5c8f8fe6bf2c6ed7$export$c309fa8f184b4648 = v; });
var $5c8f8fe6bf2c6ed7$export$c309fa8f184b4648;
"use strict";
$5c8f8fe6bf2c6ed7$export$c309fa8f184b4648 = $5c8f8fe6bf2c6ed7$var$quartersToYears;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */ function $5c8f8fe6bf2c6ed7$var$quartersToYears(quarters) {
    const years = quarters / $5K4u1.quartersInYear;
    return Math.trunc(years);
}


Object.keys($5c8f8fe6bf2c6ed7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $5c8f8fe6bf2c6ed7$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $5c8f8fe6bf2c6ed7$exports[key];
        }
    });
});
var $cade01d5eb9b1208$exports = {};

$parcel$export($cade01d5eb9b1208$exports, "roundToNearestHours", function () { return $cade01d5eb9b1208$export$a8b87649ebc0e3c2; }, function (v) { return $cade01d5eb9b1208$export$a8b87649ebc0e3c2 = v; });
var $cade01d5eb9b1208$export$a8b87649ebc0e3c2;
"use strict";
$cade01d5eb9b1208$export$a8b87649ebc0e3c2 = $cade01d5eb9b1208$var$roundToNearestHours;


var $cHwnM = parcelRequire("cHwnM");

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link roundToNearestHours} function options.
 */ /**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */ function $cade01d5eb9b1208$var$roundToNearestHours(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 12) return (0, $cHwnM.constructFrom)(date, NaN);
    const _date = (0, $hC8hz.toDate)(date);
    const fractionalMinutes = _date.getMinutes() / 60;
    const fractionalSeconds = _date.getSeconds() / 60 / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
    const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $cb1c16b2156d3745$export$b6474a47258c1211)(method);
    // nearestTo option does not care daylight savings time
    const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
    const result = (0, $cHwnM.constructFrom)(date, _date);
    result.setHours(roundedHours, 0, 0, 0);
    return result;
}


Object.keys($cade01d5eb9b1208$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cade01d5eb9b1208$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cade01d5eb9b1208$exports[key];
        }
    });
});
var $771881c2d1863c1c$exports = {};

$parcel$export($771881c2d1863c1c$exports, "roundToNearestMinutes", function () { return $771881c2d1863c1c$export$d97410bb8cd0dff; }, function (v) { return $771881c2d1863c1c$export$d97410bb8cd0dff = v; });
var $771881c2d1863c1c$export$d97410bb8cd0dff;
"use strict";
$771881c2d1863c1c$export$d97410bb8cd0dff = $771881c2d1863c1c$var$roundToNearestMinutes;


var $cHwnM = parcelRequire("cHwnM");

var $hC8hz = parcelRequire("hC8hz");
/**
 * The {@link roundToNearestMinutes} function options.
 */ /**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */ function $771881c2d1863c1c$var$roundToNearestMinutes(date, options) {
    const nearestTo = options?.nearestTo ?? 1;
    if (nearestTo < 1 || nearestTo > 30) return (0, $cHwnM.constructFrom)(date, NaN);
    const _date = (0, $hC8hz.toDate)(date);
    const fractionalSeconds = _date.getSeconds() / 60;
    const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
    const minutes = _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;
    // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
    const method = options?.roundingMethod ?? "round";
    const roundingMethod = (0, $cb1c16b2156d3745$export$b6474a47258c1211)(method);
    const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    const result = (0, $cHwnM.constructFrom)(date, _date);
    result.setMinutes(roundedMinutes, 0, 0);
    return result;
}


Object.keys($771881c2d1863c1c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $771881c2d1863c1c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $771881c2d1863c1c$exports[key];
        }
    });
});
var $5ec0c95731e63815$exports = {};

$parcel$export($5ec0c95731e63815$exports, "secondsToHours", function () { return $5ec0c95731e63815$export$47d555ff5354096f; }, function (v) { return $5ec0c95731e63815$export$47d555ff5354096f = v; });
var $5ec0c95731e63815$export$47d555ff5354096f;
"use strict";
$5ec0c95731e63815$export$47d555ff5354096f = $5ec0c95731e63815$var$secondsToHours;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */ function $5ec0c95731e63815$var$secondsToHours(seconds) {
    const hours = seconds / $5K4u1.secondsInHour;
    return Math.trunc(hours);
}


Object.keys($5ec0c95731e63815$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $5ec0c95731e63815$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $5ec0c95731e63815$exports[key];
        }
    });
});
var $b6448f9fcdaf2915$exports = {};

$parcel$export($b6448f9fcdaf2915$exports, "secondsToMilliseconds", function () { return $b6448f9fcdaf2915$export$fc3e7e8557f8c8c7; }, function (v) { return $b6448f9fcdaf2915$export$fc3e7e8557f8c8c7 = v; });
var $b6448f9fcdaf2915$export$fc3e7e8557f8c8c7;
"use strict";
$b6448f9fcdaf2915$export$fc3e7e8557f8c8c7 = $b6448f9fcdaf2915$var$secondsToMilliseconds;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */ function $b6448f9fcdaf2915$var$secondsToMilliseconds(seconds) {
    return seconds * $5K4u1.millisecondsInSecond;
}


Object.keys($b6448f9fcdaf2915$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b6448f9fcdaf2915$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b6448f9fcdaf2915$exports[key];
        }
    });
});
var $76deee4375701c99$exports = {};

$parcel$export($76deee4375701c99$exports, "secondsToMinutes", function () { return $76deee4375701c99$export$ed657adb62398e99; }, function (v) { return $76deee4375701c99$export$ed657adb62398e99 = v; });
var $76deee4375701c99$export$ed657adb62398e99;
"use strict";
$76deee4375701c99$export$ed657adb62398e99 = $76deee4375701c99$var$secondsToMinutes;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */ function $76deee4375701c99$var$secondsToMinutes(seconds) {
    const minutes = seconds / $5K4u1.secondsInMinute;
    return Math.trunc(minutes);
}


Object.keys($76deee4375701c99$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $76deee4375701c99$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $76deee4375701c99$exports[key];
        }
    });
});

var $9pNHm = parcelRequire("9pNHm");
Object.keys($9pNHm).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9pNHm[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9pNHm[key];
        }
    });
});
var $901a6ce82c37cd2f$exports = {};

$parcel$export($901a6ce82c37cd2f$exports, "setDate", function () { return $901a6ce82c37cd2f$export$566174fa40823587; }, function (v) { return $901a6ce82c37cd2f$export$566174fa40823587 = v; });
var $901a6ce82c37cd2f$export$566174fa40823587;
"use strict";
$901a6ce82c37cd2f$export$566174fa40823587 = $901a6ce82c37cd2f$var$setDate;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */ function $901a6ce82c37cd2f$var$setDate(date, dayOfMonth) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}


Object.keys($901a6ce82c37cd2f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $901a6ce82c37cd2f$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $901a6ce82c37cd2f$exports[key];
        }
    });
});

var $dU6Qg = parcelRequire("dU6Qg");
Object.keys($dU6Qg).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $dU6Qg[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $dU6Qg[key];
        }
    });
});
var $2ac62d3ba6ffefa8$exports = {};

$parcel$export($2ac62d3ba6ffefa8$exports, "setDayOfYear", function () { return $2ac62d3ba6ffefa8$export$2af590ffc7e7d7c5; }, function (v) { return $2ac62d3ba6ffefa8$export$2af590ffc7e7d7c5 = v; });
var $2ac62d3ba6ffefa8$export$2af590ffc7e7d7c5;
"use strict";
$2ac62d3ba6ffefa8$export$2af590ffc7e7d7c5 = $2ac62d3ba6ffefa8$var$setDayOfYear;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $2ac62d3ba6ffefa8$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}


Object.keys($2ac62d3ba6ffefa8$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $2ac62d3ba6ffefa8$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $2ac62d3ba6ffefa8$exports[key];
        }
    });
});
var $dad4bfb2cfe72878$exports = {};

$parcel$export($dad4bfb2cfe72878$exports, "setDefaultOptions", function () { return $dad4bfb2cfe72878$export$95365be1b0704abc; }, function (v) { return $dad4bfb2cfe72878$export$95365be1b0704abc = v; });
var $dad4bfb2cfe72878$export$95365be1b0704abc;
"use strict";
$dad4bfb2cfe72878$export$95365be1b0704abc = $dad4bfb2cfe72878$var$setDefaultOptions;

var $3Om6B = parcelRequire("3Om6B");
/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */ function $dad4bfb2cfe72878$var$setDefaultOptions(options) {
    const result = {};
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    for(const property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    result[property] = defaultOptions[property];
    for(const property in options)if (Object.prototype.hasOwnProperty.call(options, property)) {
        if (options[property] === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
    }
    (0, $3Om6B.setDefaultOptions)(result);
}


Object.keys($dad4bfb2cfe72878$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $dad4bfb2cfe72878$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $dad4bfb2cfe72878$exports[key];
        }
    });
});

var $547sc = parcelRequire("547sc");
Object.keys($547sc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $547sc[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $547sc[key];
        }
    });
});

var $2VCfD = parcelRequire("2VCfD");
Object.keys($2VCfD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $2VCfD[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $2VCfD[key];
        }
    });
});

var $i6h69 = parcelRequire("i6h69");
Object.keys($i6h69).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $i6h69[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $i6h69[key];
        }
    });
});

Object.keys($bbc6c5b73e0d3fd0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $bbc6c5b73e0d3fd0$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $bbc6c5b73e0d3fd0$exports[key];
        }
    });
});
var $9da1e8330a4591a9$exports = {};

$parcel$export($9da1e8330a4591a9$exports, "setMilliseconds", function () { return $9da1e8330a4591a9$export$de5664029b35e06d; }, function (v) { return $9da1e8330a4591a9$export$de5664029b35e06d = v; });
var $9da1e8330a4591a9$export$de5664029b35e06d;
"use strict";
$9da1e8330a4591a9$export$de5664029b35e06d = $9da1e8330a4591a9$var$setMilliseconds;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */ function $9da1e8330a4591a9$var$setMilliseconds(date, milliseconds) {
    const _date = (0, $hC8hz.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}


Object.keys($9da1e8330a4591a9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9da1e8330a4591a9$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9da1e8330a4591a9$exports[key];
        }
    });
});

var $ghUWP = parcelRequire("ghUWP");
Object.keys($ghUWP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $ghUWP[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $ghUWP[key];
        }
    });
});

var $1q78y = parcelRequire("1q78y");
Object.keys($1q78y).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $1q78y[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $1q78y[key];
        }
    });
});

var $cU7p8 = parcelRequire("cU7p8");
Object.keys($cU7p8).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $cU7p8[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $cU7p8[key];
        }
    });
});

var $uUUNl = parcelRequire("uUUNl");
Object.keys($uUUNl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $uUUNl[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $uUUNl[key];
        }
    });
});

var $i1aSz = parcelRequire("i1aSz");
Object.keys($i1aSz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $i1aSz[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $i1aSz[key];
        }
    });
});
var $7acfe95100d62193$exports = {};

$parcel$export($7acfe95100d62193$exports, "setWeekYear", function () { return $7acfe95100d62193$export$4340968d5939835e; }, function (v) { return $7acfe95100d62193$export$4340968d5939835e = v; });
var $7acfe95100d62193$export$4340968d5939835e;
"use strict";
$7acfe95100d62193$export$4340968d5939835e = $7acfe95100d62193$var$setWeekYear;

var $cHwnM = parcelRequire("cHwnM");

var $doy2h = parcelRequire("doy2h");

var $9pItP = parcelRequire("9pItP");

var $hC8hz = parcelRequire("hC8hz");

var $3Om6B = parcelRequire("3Om6B");
/**
 * The {@link setWeekYear} function options.
 */ /**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */ function $7acfe95100d62193$var$setWeekYear(date, weekYear, options) {
    const defaultOptions = (0, $3Om6B.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    let _date = (0, $hC8hz.toDate)(date);
    const diff = (0, $doy2h.differenceInCalendarDays)(_date, (0, $9pItP.startOfWeekYear)(_date, options));
    const firstWeek = (0, $cHwnM.constructFrom)(date, 0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    _date = (0, $9pItP.startOfWeekYear)(firstWeek, options);
    _date.setDate(_date.getDate() + diff);
    return _date;
}


Object.keys($7acfe95100d62193$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $7acfe95100d62193$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $7acfe95100d62193$exports[key];
        }
    });
});

var $l8aUK = parcelRequire("l8aUK");
Object.keys($l8aUK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $l8aUK[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $l8aUK[key];
        }
    });
});

var $kVRe5 = parcelRequire("kVRe5");
Object.keys($kVRe5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $kVRe5[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $kVRe5[key];
        }
    });
});
var $c3c57a6fb137822c$exports = {};

$parcel$export($c3c57a6fb137822c$exports, "startOfDecade", function () { return $c3c57a6fb137822c$export$730492981c634308; }, function (v) { return $c3c57a6fb137822c$export$730492981c634308 = v; });
var $c3c57a6fb137822c$export$730492981c634308;
"use strict";
$c3c57a6fb137822c$export$730492981c634308 = $c3c57a6fb137822c$var$startOfDecade;

var $hC8hz = parcelRequire("hC8hz");
/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */ function $c3c57a6fb137822c$var$startOfDecade(date) {
    // TODO: Switch to more technical definition in of decades that start with 1
    // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
    // change, so it can only be done in 4.0.
    const _date = (0, $hC8hz.toDate)(date);
    const year = _date.getFullYear();
    const decade = Math.floor(year / 10) * 10;
    _date.setFullYear(decade, 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


Object.keys($c3c57a6fb137822c$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $c3c57a6fb137822c$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $c3c57a6fb137822c$exports[key];
        }
    });
});

Object.keys($49e2cdb50a926fb6$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $49e2cdb50a926fb6$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $49e2cdb50a926fb6$exports[key];
        }
    });
});

var $6nmfz = parcelRequire("6nmfz");
Object.keys($6nmfz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6nmfz[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6nmfz[key];
        }
    });
});

var $gIGHk = parcelRequire("gIGHk");
Object.keys($gIGHk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $gIGHk[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $gIGHk[key];
        }
    });
});

Object.keys($d89ec25e3b89d68b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $d89ec25e3b89d68b$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $d89ec25e3b89d68b$exports[key];
        }
    });
});

var $laco2 = parcelRequire("laco2");
Object.keys($laco2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $laco2[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $laco2[key];
        }
    });
});

var $iNa3w = parcelRequire("iNa3w");
Object.keys($iNa3w).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $iNa3w[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $iNa3w[key];
        }
    });
});

Object.keys($3d89ab97462a86ad$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3d89ab97462a86ad$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3d89ab97462a86ad$exports[key];
        }
    });
});
var $e6c57fa4fb57ceea$exports = {};

$parcel$export($e6c57fa4fb57ceea$exports, "startOfToday", function () { return $e6c57fa4fb57ceea$export$444d742fd5a45a57; }, function (v) { return $e6c57fa4fb57ceea$export$444d742fd5a45a57 = v; });
var $e6c57fa4fb57ceea$export$444d742fd5a45a57;
"use strict";
$e6c57fa4fb57ceea$export$444d742fd5a45a57 = $e6c57fa4fb57ceea$var$startOfToday;

var $kVRe5 = parcelRequire("kVRe5");
/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */ function $e6c57fa4fb57ceea$var$startOfToday() {
    return (0, $kVRe5.startOfDay)(Date.now());
}


Object.keys($e6c57fa4fb57ceea$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $e6c57fa4fb57ceea$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $e6c57fa4fb57ceea$exports[key];
        }
    });
});
var $67e3bbd64f45235d$exports = {};

$parcel$export($67e3bbd64f45235d$exports, "startOfTomorrow", function () { return $67e3bbd64f45235d$export$7e8566c79d5bee07; }, function (v) { return $67e3bbd64f45235d$export$7e8566c79d5bee07 = v; });
var $67e3bbd64f45235d$export$7e8566c79d5bee07;
"use strict";
$67e3bbd64f45235d$export$7e8566c79d5bee07 = $67e3bbd64f45235d$var$startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ 
function $67e3bbd64f45235d$var$startOfTomorrow() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


Object.keys($67e3bbd64f45235d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $67e3bbd64f45235d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $67e3bbd64f45235d$exports[key];
        }
    });
});

var $5Wrs3 = parcelRequire("5Wrs3");
Object.keys($5Wrs3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $5Wrs3[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $5Wrs3[key];
        }
    });
});

var $9pItP = parcelRequire("9pItP");
Object.keys($9pItP).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $9pItP[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $9pItP[key];
        }
    });
});

var $4Gfnp = parcelRequire("4Gfnp");
Object.keys($4Gfnp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $4Gfnp[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $4Gfnp[key];
        }
    });
});
var $ffd3a20e284199a7$exports = {};

$parcel$export($ffd3a20e284199a7$exports, "startOfYesterday", function () { return $ffd3a20e284199a7$export$23a16f3c6d143ce9; }, function (v) { return $ffd3a20e284199a7$export$23a16f3c6d143ce9 = v; });
var $ffd3a20e284199a7$export$23a16f3c6d143ce9;
"use strict";
$ffd3a20e284199a7$export$23a16f3c6d143ce9 = $ffd3a20e284199a7$var$startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ 
function $ffd3a20e284199a7$var$startOfYesterday() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


Object.keys($ffd3a20e284199a7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $ffd3a20e284199a7$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $ffd3a20e284199a7$exports[key];
        }
    });
});
var $d79b2fc0e2cf8293$exports = {};

$parcel$export($d79b2fc0e2cf8293$exports, "sub", function () { return $d79b2fc0e2cf8293$export$f93b5905241a7cca; }, function (v) { return $d79b2fc0e2cf8293$export$f93b5905241a7cca = v; });
var $d79b2fc0e2cf8293$export$f93b5905241a7cca;
"use strict";
$d79b2fc0e2cf8293$export$f93b5905241a7cca = $d79b2fc0e2cf8293$var$sub;

var $6nsOA = parcelRequire("6nsOA");

var $3Dc48 = parcelRequire("3Dc48");

var $cHwnM = parcelRequire("cHwnM");
/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */ function $d79b2fc0e2cf8293$var$sub(date, duration) {
    const { years: years = 0 , months: months = 0 , weeks: weeks = 0 , days: days = 0 , hours: hours = 0 , minutes: minutes = 0 , seconds: seconds = 0  } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $3Dc48.subMonths)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $6nsOA.subDays)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $cHwnM.constructFrom)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}


Object.keys($d79b2fc0e2cf8293$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $d79b2fc0e2cf8293$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $d79b2fc0e2cf8293$exports[key];
        }
    });
});
var $2870fae368477ebb$exports = {};

$parcel$export($2870fae368477ebb$exports, "subBusinessDays", function () { return $2870fae368477ebb$export$e5cc51ae28664a93; }, function (v) { return $2870fae368477ebb$export$e5cc51ae28664a93 = v; });
var $2870fae368477ebb$export$e5cc51ae28664a93;
"use strict";
$2870fae368477ebb$export$e5cc51ae28664a93 = $2870fae368477ebb$var$subBusinessDays;

/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */ function $2870fae368477ebb$var$subBusinessDays(date, amount) {
    return (0, $e95504abc91aa353$export$f087b9ada3136ae9)(date, -amount);
}


Object.keys($2870fae368477ebb$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $2870fae368477ebb$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $2870fae368477ebb$exports[key];
        }
    });
});

var $6nsOA = parcelRequire("6nsOA");
Object.keys($6nsOA).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $6nsOA[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $6nsOA[key];
        }
    });
});
var $3bb08c3a9ea37bd0$exports = {};

$parcel$export($3bb08c3a9ea37bd0$exports, "subHours", function () { return $3bb08c3a9ea37bd0$export$5e9fa51cd5bb1e71; }, function (v) { return $3bb08c3a9ea37bd0$export$5e9fa51cd5bb1e71 = v; });
var $3bb08c3a9ea37bd0$export$5e9fa51cd5bb1e71;
"use strict";
$3bb08c3a9ea37bd0$export$5e9fa51cd5bb1e71 = $3bb08c3a9ea37bd0$var$subHours;

var $1Q0sb = parcelRequire("1Q0sb");
/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */ function $3bb08c3a9ea37bd0$var$subHours(date, amount) {
    return (0, $1Q0sb.addHours)(date, -amount);
}


Object.keys($3bb08c3a9ea37bd0$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3bb08c3a9ea37bd0$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3bb08c3a9ea37bd0$exports[key];
        }
    });
});

Object.keys($e9bed0583bac449b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $e9bed0583bac449b$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $e9bed0583bac449b$exports[key];
        }
    });
});
var $4e1b43b6dcbc700f$exports = {};

$parcel$export($4e1b43b6dcbc700f$exports, "subMilliseconds", function () { return $4e1b43b6dcbc700f$export$5abaf57ab8e91640; }, function (v) { return $4e1b43b6dcbc700f$export$5abaf57ab8e91640 = v; });
var $4e1b43b6dcbc700f$export$5abaf57ab8e91640;
"use strict";
$4e1b43b6dcbc700f$export$5abaf57ab8e91640 = $4e1b43b6dcbc700f$var$subMilliseconds;

var $be89H = parcelRequire("be89H");
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $4e1b43b6dcbc700f$var$subMilliseconds(date, amount) {
    return (0, $be89H.addMilliseconds)(date, -amount);
}


Object.keys($4e1b43b6dcbc700f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $4e1b43b6dcbc700f$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $4e1b43b6dcbc700f$exports[key];
        }
    });
});
var $19543dbaa8100c47$exports = {};

$parcel$export($19543dbaa8100c47$exports, "subMinutes", function () { return $19543dbaa8100c47$export$e12a970efb73fce5; }, function (v) { return $19543dbaa8100c47$export$e12a970efb73fce5 = v; });
var $19543dbaa8100c47$export$e12a970efb73fce5;
"use strict";
$19543dbaa8100c47$export$e12a970efb73fce5 = $19543dbaa8100c47$var$subMinutes;

var $lmA75 = parcelRequire("lmA75");
/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ function $19543dbaa8100c47$var$subMinutes(date, amount) {
    return (0, $lmA75.addMinutes)(date, -amount);
}


Object.keys($19543dbaa8100c47$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $19543dbaa8100c47$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $19543dbaa8100c47$exports[key];
        }
    });
});

var $3Dc48 = parcelRequire("3Dc48");
Object.keys($3Dc48).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3Dc48[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3Dc48[key];
        }
    });
});

var $66PGz = parcelRequire("66PGz");
Object.keys($66PGz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $66PGz[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $66PGz[key];
        }
    });
});
var $ccc96634435d7a2d$exports = {};

$parcel$export($ccc96634435d7a2d$exports, "subSeconds", function () { return $ccc96634435d7a2d$export$e95d8ad9981db689; }, function (v) { return $ccc96634435d7a2d$export$e95d8ad9981db689 = v; });
var $ccc96634435d7a2d$export$e95d8ad9981db689;
"use strict";
$ccc96634435d7a2d$export$e95d8ad9981db689 = $ccc96634435d7a2d$var$subSeconds;

var $cqvn6 = parcelRequire("cqvn6");
/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */ function $ccc96634435d7a2d$var$subSeconds(date, amount) {
    return (0, $cqvn6.addSeconds)(date, -amount);
}


Object.keys($ccc96634435d7a2d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $ccc96634435d7a2d$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $ccc96634435d7a2d$exports[key];
        }
    });
});

var $h0WZn = parcelRequire("h0WZn");
Object.keys($h0WZn).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $h0WZn[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $h0WZn[key];
        }
    });
});

var $bPd2N = parcelRequire("bPd2N");
Object.keys($bPd2N).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $bPd2N[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $bPd2N[key];
        }
    });
});

var $hC8hz = parcelRequire("hC8hz");
Object.keys($hC8hz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $hC8hz[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $hC8hz[key];
        }
    });
});

var $b1Lww = parcelRequire("b1Lww");
Object.keys($b1Lww).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $b1Lww[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $b1Lww[key];
        }
    });
});
var $e32a0d8a1472c4f2$exports = {};

$parcel$export($e32a0d8a1472c4f2$exports, "weeksToDays", function () { return $e32a0d8a1472c4f2$export$b696b6eeb89501ad; }, function (v) { return $e32a0d8a1472c4f2$export$b696b6eeb89501ad = v; });
var $e32a0d8a1472c4f2$export$b696b6eeb89501ad;
"use strict";
$e32a0d8a1472c4f2$export$b696b6eeb89501ad = $e32a0d8a1472c4f2$var$weeksToDays;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */ function $e32a0d8a1472c4f2$var$weeksToDays(weeks) {
    return Math.trunc(weeks * $5K4u1.daysInWeek);
}


Object.keys($e32a0d8a1472c4f2$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $e32a0d8a1472c4f2$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $e32a0d8a1472c4f2$exports[key];
        }
    });
});
var $8ae2e4944ca5bb5f$exports = {};

$parcel$export($8ae2e4944ca5bb5f$exports, "yearsToDays", function () { return $8ae2e4944ca5bb5f$export$862cb7b6e45c3b17; }, function (v) { return $8ae2e4944ca5bb5f$export$862cb7b6e45c3b17 = v; });
var $8ae2e4944ca5bb5f$export$862cb7b6e45c3b17;
"use strict";
$8ae2e4944ca5bb5f$export$862cb7b6e45c3b17 = $8ae2e4944ca5bb5f$var$yearsToDays;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */ function $8ae2e4944ca5bb5f$var$yearsToDays(years) {
    return Math.trunc(years * $5K4u1.daysInYear);
}


Object.keys($8ae2e4944ca5bb5f$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $8ae2e4944ca5bb5f$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $8ae2e4944ca5bb5f$exports[key];
        }
    });
});
var $3b7b1fd395cf0543$exports = {};

$parcel$export($3b7b1fd395cf0543$exports, "yearsToMonths", function () { return $3b7b1fd395cf0543$export$894abb0747b9a00; }, function (v) { return $3b7b1fd395cf0543$export$894abb0747b9a00 = v; });
var $3b7b1fd395cf0543$export$894abb0747b9a00;
"use strict";
$3b7b1fd395cf0543$export$894abb0747b9a00 = $3b7b1fd395cf0543$var$yearsToMonths;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */ function $3b7b1fd395cf0543$var$yearsToMonths(years) {
    return Math.trunc(years * $5K4u1.monthsInYear);
}


Object.keys($3b7b1fd395cf0543$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $3b7b1fd395cf0543$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $3b7b1fd395cf0543$exports[key];
        }
    });
});
var $76b1b2a7b3256b01$exports = {};

$parcel$export($76b1b2a7b3256b01$exports, "yearsToQuarters", function () { return $76b1b2a7b3256b01$export$ab26576e5e7379d7; }, function (v) { return $76b1b2a7b3256b01$export$ab26576e5e7379d7 = v; });
var $76b1b2a7b3256b01$export$ab26576e5e7379d7;
"use strict";
$76b1b2a7b3256b01$export$ab26576e5e7379d7 = $76b1b2a7b3256b01$var$yearsToQuarters;

var $5K4u1 = parcelRequire("5K4u1");
/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */ function $76b1b2a7b3256b01$var$yearsToQuarters(years) {
    return Math.trunc(years * $5K4u1.quartersInYear);
}


Object.keys($76b1b2a7b3256b01$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3145b66931dcae2b$exports && $3145b66931dcae2b$exports[key] === $76b1b2a7b3256b01$exports[key]) return;
    Object.defineProperty($3145b66931dcae2b$exports, key, {
        enumerable: true,
        get: function() {
            return $76b1b2a7b3256b01$exports[key];
        }
    });
});



var $0fb815a476526754$exports = {};
/*!
  react-datepicker v7.2.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ 































































!function(e, t) {
    t($0fb815a476526754$exports, (parcelRequire("4qr5a")), (parcelRequire("exYeM")), (parcelRequire("c8yWf")), (parcelRequire("9wlqC")), (parcelRequire("1Q0sb")), (parcelRequire("lmA75")), (parcelRequire("eTI3m")), (parcelRequire("9S1sJ")), (parcelRequire("cqvn6")), (parcelRequire("zLu4w")), (parcelRequire("l1Mmy")), (parcelRequire("doy2h")), (parcelRequire("dPrzz")), (parcelRequire("lTSPY")), (parcelRequire("9LexO")), (parcelRequire("6i4iy")), (parcelRequire("6VZPY")), (parcelRequire("dSpZL")), (parcelRequire("bAgeX")), (parcelRequire("kutcQ")), (parcelRequire("i8QYr")), (parcelRequire("6UKPj")), (parcelRequire("cGh60")), (parcelRequire("4Csci")), (parcelRequire("eoANb")), (parcelRequire("4O1bq")), (parcelRequire("bqOt8")), (parcelRequire("olqzY")), (parcelRequire("rRcG9")), (parcelRequire("54r2S")), (parcelRequire("ar9gY")), (parcelRequire("i4Id9")), (parcelRequire("c2iD1")), (parcelRequire("cl3rs")), (parcelRequire("hVwiy")), (parcelRequire("jHVEe")), (parcelRequire("fTF2B")), (parcelRequire("cHSNE")), (parcelRequire("bJrOu")), (parcelRequire("k7NE3")), (parcelRequire("7DYAE")), (parcelRequire("3al5W")), (parcelRequire("56yXI")), (parcelRequire("lgH58")), (parcelRequire("9pNHm")), (parcelRequire("547sc")), (parcelRequire("ghUWP")), (parcelRequire("1q78y")), (parcelRequire("cU7p8")), (parcelRequire("uUUNl")), (parcelRequire("l8aUK")), (parcelRequire("kVRe5")), (parcelRequire("laco2")), (parcelRequire("iNa3w")), (parcelRequire("5Wrs3")), (parcelRequire("4Gfnp")), (parcelRequire("6nsOA")), (parcelRequire("3Dc48")), (parcelRequire("66PGz")), (parcelRequire("h0WZn")), (parcelRequire("bPd2N")), (parcelRequire("hC8hz")), (parcelRequire("gOpT7")), (parcelRequire("d2lNW")));
}($0fb815a476526754$exports, function(e, t, r, n, a, o, s, i, l, c, p, d, u, f, h, m, v, g, y, D, k, w, S, b, M, _, C, E, Y, P, x, N, O, I, T, R, L, A, F, H, W, Q, q, K, B, V, j, U, $, z, X, G, J, Z, ee, te, re, ne, ae, oe, se, ie, le, ce, pe) {
    "use strict";
    function de(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var ue = de(r), fe = de(n), he = de(pe), me = function(e, t) {
        return me = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(e, t) {
            e.__proto__ = t;
        } || function(e, t) {
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }, me(e, t);
    };
    function ve(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
        function r() {
            this.constructor = e;
        }
        me(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
    }
    var ge = function() {
        return ge = Object.assign || function(e) {
            for(var t, r = 1, n = arguments.length; r < n; r++)for(var a in t = arguments[r])Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
        }, ge.apply(this, arguments);
    };
    function ye(e, t, r) {
        if (r || 2 === arguments.length) for(var n, a = 0, o = t.length; a < o; a++)!n && a in t || (n || (n = Array.prototype.slice.call(t, 0, a)), n[a] = t[a]);
        return e.concat(n || Array.prototype.slice.call(t));
    }
    "function" == typeof SuppressedError && SuppressedError;
    var De, ke = function(e) {
        var t = e.showTimeSelectOnly, r = void 0 !== t && t, n = e.showTime, a = void 0 !== n && n, o = e.className, s = e.children, i = r ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
        return ue.default.createElement("div", {
            className: o,
            role: "dialog",
            "aria-label": i,
            "aria-modal": "true"
        }, s);
    };
    function we() {
        return "undefined" != typeof window ? window : globalThis;
    }
    !function(e) {
        e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Home = "Home", e.End = "End", e.Enter = "Enter", e.Space = " ", e.Tab = "Tab", e.Escape = "Escape", e.Backspace = "Backspace", e.X = "x";
    }(De || (De = {}));
    var Se = 12, be = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Me(e) {
        if (null == e) return new Date;
        var t = "string" == typeof e ? B.parseISO(e) : le.toDate(e);
        return _e(t) ? t : new Date;
    }
    function _e(e, t) {
        return H.isValid(e) && !O.isBefore(e, null != t ? t : new Date("1/1/1800"));
    }
    function Ce(e, t, r) {
        if ("en" === r) return k.format(e, t, {
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
        var n = r ? Ke(r) : void 0;
        return r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !n && qe() && Ke(qe()) && (n = Ke(qe())), k.format(e, t, {
            locale: n,
            useAdditionalWeekYearTokens: !0,
            useAdditionalDayOfYearTokens: !0
        });
    }
    function Ee(e, t) {
        var r = t.dateFormat, n = t.locale, a = Array.isArray(r) && r.length > 0 ? r[0] : r;
        return e && Ce(e, a, n) || "";
    }
    function Ye(e, t) {
        var r = t.hour, n = void 0 === r ? 0 : r, a = t.minute, o = void 0 === a ? 0 : a, s = t.second, i = void 0 === s ? 0 : s;
        return j.setHours(U.setMinutes(X.setSeconds(e, i), o), n);
    }
    function Pe(e) {
        return J.startOfDay(e);
    }
    function xe(e, t, r) {
        var n = Ke(t || qe());
        return te.startOfWeek(e, {
            locale: n,
            weekStartsOn: r
        });
    }
    function Ne(e) {
        return Z.startOfMonth(e);
    }
    function Oe(e) {
        return re.startOfYear(e);
    }
    function Ie(e) {
        return ee.startOfQuarter(e);
    }
    function Te() {
        return J.startOfDay(Me());
    }
    function Re(e) {
        return v.endOfDay(e);
    }
    function Le(e, t) {
        return e && t ? F.isSameYear(e, t) : !e && !t;
    }
    function Ae(e, t) {
        return e && t ? L.isSameMonth(e, t) : !e && !t;
    }
    function Fe(e, t) {
        return e && t ? A.isSameQuarter(e, t) : !e && !t;
    }
    function He(e, t) {
        return e && t ? R.isSameDay(e, t) : !e && !t;
    }
    function We(e, t) {
        return e && t ? T.isEqual(e, t) : !e && !t;
    }
    function Qe(e, t, r) {
        var n, a = J.startOfDay(t), o = v.endOfDay(r);
        try {
            n = W.isWithinInterval(e, {
                start: a,
                end: o
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function qe() {
        return we().__localeId__;
    }
    function Ke(e) {
        if ("string" == typeof e) {
            var t = we();
            return t.__localeData__ ? t.__localeData__[e] : void 0;
        }
        return e;
    }
    function Be(e, t) {
        return Ce($.setMonth(Me(), e), "LLLL", t);
    }
    function Ve(e, t) {
        return Ce($.setMonth(Me(), e), "LLL", t);
    }
    function je(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.excludeDateIntervals, i = r.includeDates, l = r.includeDateIntervals, c = r.filterDate;
        return tt(e, {
            minDate: n,
            maxDate: a
        }) || o && o.some(function(t) {
            var r;
            return t instanceof Date ? He(e, t) : He(e, null !== (r = t.date) && void 0 !== r ? r : new Date);
        }) || s && s.some(function(t) {
            var r = t.start, n = t.end;
            return W.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || i && !i.some(function(t) {
            return He(e, t);
        }) || l && !l.some(function(t) {
            var r = t.start, n = t.end;
            return W.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) || c && !c(Me(e)) || !1;
    }
    function Ue(e, t) {
        var r = void 0 === t ? {} : t, n = r.excludeDates, a = r.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, n = t.end;
            return W.isWithinInterval(e, {
                start: r,
                end: n
            });
        }) : n && n.some(function(t) {
            var r;
            return t instanceof Date ? He(e, t) : He(e, null !== (r = t.date) && void 0 !== r ? r : new Date);
        }) || !1;
    }
    function $e(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates, i = r.filterDate;
        return tt(e, {
            minDate: n ? Z.startOfMonth(n) : void 0,
            maxDate: a ? g.endOfMonth(a) : void 0
        }) || (null == o ? void 0 : o.some(function(t) {
            return Ae(e, t instanceof Date ? t : t.date);
        })) || s && !s.some(function(t) {
            return Ae(e, t);
        }) || i && !i(Me(e)) || !1;
    }
    function ze(e, t, r, n) {
        var a = x.getYear(e), o = C.getMonth(e), s = x.getYear(t), i = C.getMonth(t), l = x.getYear(n);
        return a === s && a === l ? o <= r && r <= i : a < s && (l === a && o <= r || l === s && i >= r || l < s && l > a);
    }
    function Xe(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates;
        return tt(e, {
            minDate: n,
            maxDate: a
        }) || o && o.some(function(t) {
            return Ae(t instanceof Date ? t : t.date, e);
        }) || s && !s.some(function(t) {
            return Ae(t, e);
        }) || !1;
    }
    function Ge(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates, i = r.filterDate;
        return tt(e, {
            minDate: n,
            maxDate: a
        }) || (null == o ? void 0 : o.some(function(t) {
            return Fe(e, t instanceof Date ? t : t.date);
        })) || s && !s.some(function(t) {
            return Fe(e, t);
        }) || i && !i(Me(e)) || !1;
    }
    function Je(e, t, r) {
        if (!t || !r) return !1;
        if (!H.isValid(t) || !H.isValid(r)) return !1;
        var n = x.getYear(t), a = x.getYear(r);
        return n <= e && a >= e;
    }
    function Ze(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.maxDate, o = r.excludeDates, s = r.includeDates, i = r.filterDate, l = new Date(e, 0, 1);
        return tt(l, {
            minDate: n ? re.startOfYear(n) : void 0,
            maxDate: a ? D.endOfYear(a) : void 0
        }) || (null == o ? void 0 : o.some(function(e) {
            return Le(l, e instanceof Date ? e : e.date);
        })) || s && !s.some(function(e) {
            return Le(l, e);
        }) || i && !i(Me(l)) || !1;
    }
    function et(e, t, r, n) {
        var a = x.getYear(e), o = E.getQuarter(e), s = x.getYear(t), i = E.getQuarter(t), l = x.getYear(n);
        return a === s && a === l ? o <= r && r <= i : a < s && (l === a && o <= r || l === s && i >= r || l < s && l > a);
    }
    function tt(e, t) {
        var r, n = void 0 === t ? {} : t, a = n.minDate, o = n.maxDate;
        return null !== (r = a && u.differenceInCalendarDays(e, a) < 0 || o && u.differenceInCalendarDays(e, o) > 0) && void 0 !== r && r;
    }
    function rt(e, t) {
        return t.some(function(t) {
            return b.getHours(t) === b.getHours(e) && _.getMinutes(t) === _.getMinutes(e) && Y.getSeconds(t) === Y.getSeconds(e);
        });
    }
    function nt(e, t) {
        var r = void 0 === t ? {} : t, n = r.excludeTimes, a = r.includeTimes, o = r.filterTime;
        return n && rt(e, n) || a && !rt(e, a) || o && !o(e) || !1;
    }
    function at(e, t) {
        var r = t.minTime, n = t.maxTime;
        if (!r || !n) throw new Error("Both minTime and maxTime props required");
        var a = Me();
        a = j.setHours(a, b.getHours(e)), a = U.setMinutes(a, _.getMinutes(e)), a = X.setSeconds(a, Y.getSeconds(e));
        var o = Me();
        o = j.setHours(o, b.getHours(r)), o = U.setMinutes(o, _.getMinutes(r)), o = X.setSeconds(o, Y.getSeconds(r));
        var s, i = Me();
        i = j.setHours(i, b.getHours(n)), i = U.setMinutes(i, _.getMinutes(n)), i = X.setSeconds(i, Y.getSeconds(n));
        try {
            s = !W.isWithinInterval(a, {
                start: o,
                end: i
            });
        } catch (e) {
            s = !1;
        }
        return s;
    }
    function ot(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.includeDates, o = ae.subMonths(e, 1);
        return n && f.differenceInCalendarMonths(n, o) > 0 || a && a.every(function(e) {
            return f.differenceInCalendarMonths(e, o) > 0;
        }) || !1;
    }
    function st(e, t) {
        var r = void 0 === t ? {} : t, n = r.maxDate, a = r.includeDates, o = i.addMonths(e, 1);
        return n && f.differenceInCalendarMonths(o, n) > 0 || a && a.every(function(e) {
            return f.differenceInCalendarMonths(o, e) > 0;
        }) || !1;
    }
    function it(e, t) {
        var r = void 0 === t ? {} : t, n = r.minDate, a = r.includeDates, o = ie.subYears(e, 1);
        return n && m.differenceInCalendarYears(n, o) > 0 || a && a.every(function(e) {
            return m.differenceInCalendarYears(e, o) > 0;
        }) || !1;
    }
    function lt(e, t) {
        var r = void 0 === t ? {} : t, n = r.maxDate, a = r.includeDates, o = d.addYears(e, 1);
        return n && m.differenceInCalendarYears(o, n) > 0 || a && a.every(function(e) {
            return m.differenceInCalendarYears(o, e) > 0;
        }) || !1;
    }
    function ct(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return u.differenceInCalendarDays(e, t) >= 0;
            });
            return q.min(n);
        }
        return r ? q.min(r) : t;
    }
    function pt(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return u.differenceInCalendarDays(e, t) <= 0;
            });
            return Q.max(n);
        }
        return r ? Q.max(r) : t;
    }
    function dt(e, t) {
        var r;
        void 0 === e && (e = []), void 0 === t && (t = "react-datepicker__day--highlighted");
        for(var n = new Map, a = 0, o = e.length; a < o; a++){
            var s = e[a];
            if (I.isDate(s)) {
                var i = Ce(s, "MM.dd.yyyy");
                (f = n.get(i) || []).includes(t) || (f.push(t), n.set(i, f));
            } else if ("object" == typeof s) {
                var l = null !== (r = Object.keys(s)[0]) && void 0 !== r ? r : "", c = s[l];
                if ("string" == typeof l && Array.isArray(c)) for(var p = 0, d = c.length; p < d; p++){
                    var u = c[p];
                    if (u) {
                        var f;
                        i = Ce(u, "MM.dd.yyyy");
                        (f = n.get(i) || []).includes(l) || (f.push(l), n.set(i, f));
                    }
                }
            }
        }
        return n;
    }
    function ut(e, t) {
        void 0 === e && (e = []), void 0 === t && (t = "react-datepicker__day--holidays");
        var r = new Map;
        return e.forEach(function(e) {
            var n = e.date, a = e.holidayName;
            if (I.isDate(n)) {
                var o = Ce(n, "MM.dd.yyyy"), s = r.get(o) || {
                    className: "",
                    holidayNames: []
                };
                if (!("className" in s) || s.className !== t || (i = s.holidayNames, l = [
                    a
                ], i.length !== l.length || !i.every(function(e, t) {
                    return e === l[t];
                }))) {
                    var i, l;
                    s.className = t;
                    var c = s.holidayNames;
                    s.holidayNames = c ? ye(ye([], c, !0), [
                        a
                    ], !1) : [
                        a
                    ], r.set(o, s);
                }
            }
        }), r;
    }
    function ft(e, t, r, n, a) {
        for(var i = a.length, l = [], p = 0; p < i; p++){
            var d = e, u = a[p];
            u && (d = o.addHours(d, b.getHours(u)), d = s.addMinutes(d, _.getMinutes(u)), d = c.addSeconds(d, Y.getSeconds(u)));
            var f = s.addMinutes(e, (r + 1) * n);
            N.isAfter(d, t) && O.isBefore(d, f) && null != u && l.push(u);
        }
        return l;
    }
    function ht(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function mt(e, t) {
        void 0 === t && (t = Se);
        var r = Math.ceil(x.getYear(e) / t) * t;
        return {
            startPeriod: r - (t - 1),
            endPeriod: r
        };
    }
    function vt(e) {
        var t = e.getSeconds(), r = e.getMilliseconds();
        return le.toDate(e.getTime() - 1e3 * t - r);
    }
    function gt(e) {
        if (!I.isDate(e)) throw new Error("Invalid date");
        var t = new Date(e);
        return t.setHours(0, 0, 0, 0), t;
    }
    function yt(e, t) {
        if (!I.isDate(e) || !I.isDate(t)) throw new Error("Invalid date received");
        var r = gt(e), n = gt(t);
        return O.isBefore(r, n);
    }
    function Dt(e) {
        return e.key === De.Space;
    }
    var kt, wt = function(e) {
        function t(t) {
            var n = e.call(this, t) || this;
            return n.onTimeChange = function(e) {
                var t, r;
                n.setState({
                    time: e
                });
                var a = n.props.date, o = a instanceof Date && !isNaN(+a) ? a : new Date;
                if (null == e ? void 0 : e.includes(":")) {
                    var s = e.split(":"), i = s[0], l = s[1];
                    o.setHours(Number(i)), o.setMinutes(Number(l));
                }
                null === (r = (t = n.props).onChange) || void 0 === r || r.call(t, o);
            }, n.renderTimeInput = function() {
                var e = n.state.time, t = n.props, a = t.date, o = t.timeString, s = t.customTimeInput;
                return s ? r.cloneElement(s, {
                    date: a,
                    value: e,
                    onChange: n.onTimeChange
                }) : ue.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        n.onTimeChange(e.target.value || o);
                    }
                });
            }, n.state = {
                time: n.props.timeString
            }, n;
        }
        return ve(t, e), t.getDerivedStateFromProps = function(e, t) {
            return e.timeString !== t.time ? {
                time: e.timeString
            } : null;
        }, t.prototype.render = function() {
            return ue.default.createElement("div", {
                className: "react-datepicker__input-time-container"
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__caption"
            }, this.props.timeInputLabel), ue.default.createElement("div", {
                className: "react-datepicker-time__input-container"
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__input"
            }, this.renderTimeInput())));
        }, t;
    }(r.Component), St = function(e) {
        function n() {
            var n = null !== e && e.apply(this, arguments) || this;
            return n.dayEl = r.createRef(), n.handleClick = function(e) {
                !n.isDisabled() && n.props.onClick && n.props.onClick(e);
            }, n.handleMouseEnter = function(e) {
                !n.isDisabled() && n.props.onMouseEnter && n.props.onMouseEnter(e);
            }, n.handleOnKeyDown = function(e) {
                var t, r;
                e.key === De.Space && (e.preventDefault(), e.key = De.Enter), null === (r = (t = n.props).handleOnKeyDown) || void 0 === r || r.call(t, e);
            }, n.isSameDay = function(e) {
                return He(n.props.day, e);
            }, n.isKeyboardSelected = function() {
                var e;
                return !n.props.disabledKeyboardNavigation && !(n.props.selectsMultiple ? null === (e = n.props.selectedDates) || void 0 === e ? void 0 : e.some(function(e) {
                    return n.isSameDayOrWeek(e);
                }) : n.isSameDayOrWeek(n.props.selected)) && n.isSameDayOrWeek(n.props.preSelection);
            }, n.isDisabled = function() {
                return je(n.props.day, {
                    minDate: n.props.minDate,
                    maxDate: n.props.maxDate,
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals,
                    includeDateIntervals: n.props.includeDateIntervals,
                    includeDates: n.props.includeDates,
                    filterDate: n.props.filterDate
                });
            }, n.isExcluded = function() {
                return Ue(n.props.day, {
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals
                });
            }, n.isStartOfWeek = function() {
                return He(n.props.day, xe(n.props.day, n.props.locale, n.props.calendarStartDay));
            }, n.isSameWeek = function(e) {
                return n.props.showWeekPicker && He(e, xe(n.props.day, n.props.locale, n.props.calendarStartDay));
            }, n.isSameDayOrWeek = function(e) {
                return n.isSameDay(e) || n.isSameWeek(e);
            }, n.getHighLightedClass = function() {
                var e = n.props, t = e.day, r = e.highlightDates;
                if (!r) return !1;
                var a = Ce(t, "MM.dd.yyyy");
                return r.get(a);
            }, n.getHolidaysClass = function() {
                var e, t = n.props, r = t.day, a = t.holidays;
                if (!a) return [
                    void 0
                ];
                var o = Ce(r, "MM.dd.yyyy");
                return a.has(o) ? [
                    null === (e = a.get(o)) || void 0 === e ? void 0 : e.className
                ] : [
                    void 0
                ];
            }, n.isInRange = function() {
                var e = n.props, t = e.day, r = e.startDate, a = e.endDate;
                return !(!r || !a) && Qe(t, r, a);
            }, n.isInSelectingRange = function() {
                var e, t = n.props, r = t.day, a = t.selectsStart, o = t.selectsEnd, s = t.selectsRange, i = t.selectsDisabledDaysInRange, l = t.startDate, c = t.endDate, p = null !== (e = n.props.selectingDate) && void 0 !== e ? e : n.props.preSelection;
                return !(!(a || o || s) || !p || !i && n.isDisabled()) && (a && c && (O.isBefore(p, c) || We(p, c)) ? Qe(r, p, c) : (o && l && (N.isAfter(p, l) || We(p, l)) || !(!s || !l || c || !N.isAfter(p, l) && !We(p, l))) && Qe(r, l, p));
            }, n.isSelectingRangeStart = function() {
                var e;
                if (!n.isInSelectingRange()) return !1;
                var t = n.props, r = t.day, a = t.startDate, o = t.selectsStart, s = null !== (e = n.props.selectingDate) && void 0 !== e ? e : n.props.preSelection;
                return He(r, o ? s : a);
            }, n.isSelectingRangeEnd = function() {
                var e;
                if (!n.isInSelectingRange()) return !1;
                var t = n.props, r = t.day, a = t.endDate, o = t.selectsEnd, s = t.selectsRange, i = null !== (e = n.props.selectingDate) && void 0 !== e ? e : n.props.preSelection;
                return He(r, o || s ? i : a);
            }, n.isRangeStart = function() {
                var e = n.props, t = e.day, r = e.startDate, a = e.endDate;
                return !(!r || !a) && He(r, t);
            }, n.isRangeEnd = function() {
                var e = n.props, t = e.day, r = e.startDate, a = e.endDate;
                return !(!r || !a) && He(a, t);
            }, n.isWeekend = function() {
                var e = S.getDay(n.props.day);
                return 0 === e || 6 === e;
            }, n.isAfterMonth = function() {
                return void 0 !== n.props.month && (n.props.month + 1) % 12 === C.getMonth(n.props.day);
            }, n.isBeforeMonth = function() {
                return void 0 !== n.props.month && (C.getMonth(n.props.day) + 1) % 12 === n.props.month;
            }, n.isCurrentDay = function() {
                return n.isSameDay(Me());
            }, n.isSelected = function() {
                var e;
                return n.props.selectsMultiple ? null === (e = n.props.selectedDates) || void 0 === e ? void 0 : e.some(function(e) {
                    return n.isSameDayOrWeek(e);
                }) : n.isSameDayOrWeek(n.props.selected);
            }, n.getClassNames = function(e) {
                var r, a = n.props.dayClassName ? n.props.dayClassName(e) : void 0;
                return t.clsx("react-datepicker__day", a, "react-datepicker__day--" + Ce(n.props.day, "ddd", r), {
                    "react-datepicker__day--disabled": n.isDisabled(),
                    "react-datepicker__day--excluded": n.isExcluded(),
                    "react-datepicker__day--selected": n.isSelected(),
                    "react-datepicker__day--keyboard-selected": n.isKeyboardSelected(),
                    "react-datepicker__day--range-start": n.isRangeStart(),
                    "react-datepicker__day--range-end": n.isRangeEnd(),
                    "react-datepicker__day--in-range": n.isInRange(),
                    "react-datepicker__day--in-selecting-range": n.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": n.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": n.isSelectingRangeEnd(),
                    "react-datepicker__day--today": n.isCurrentDay(),
                    "react-datepicker__day--weekend": n.isWeekend(),
                    "react-datepicker__day--outside-month": n.isAfterMonth() || n.isBeforeMonth()
                }, n.getHighLightedClass(), n.getHolidaysClass());
            }, n.getAriaLabel = function() {
                var e = n.props, t = e.day, r = e.ariaLabelPrefixWhenEnabled, a = void 0 === r ? "Choose" : r, o = e.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = n.isDisabled() || n.isExcluded() ? s : a;
                return "".concat(i, " ").concat(Ce(t, "PPPP", n.props.locale));
            }, n.getTitle = function() {
                var e = n.props, t = e.day, r = e.holidays, a = void 0 === r ? new Map : r, o = e.excludeDates, s = Ce(t, "MM.dd.yyyy"), i = [];
                return a.has(s) && i.push.apply(i, a.get(s).holidayNames), n.isExcluded() && i.push(null == o ? void 0 : o.filter(function(e) {
                    return e instanceof Date ? He(e, t) : He(null == e ? void 0 : e.date, t);
                }).map(function(e) {
                    if (!(e instanceof Date)) return null == e ? void 0 : e.message;
                })), i.join(", ");
            }, n.getTabIndex = function() {
                var e = n.props.selected, t = n.props.preSelection;
                return (!n.props.showWeekPicker || !n.props.showWeekNumber && n.isStartOfWeek()) && (n.isKeyboardSelected() || n.isSameDay(e) && He(t, e)) ? 0 : -1;
            }, n.handleFocusDay = function() {
                var e;
                n.shouldFocusDay() && (null === (e = n.dayEl.current) || void 0 === e || e.focus({
                    preventScroll: !0
                }));
            }, n.renderDayContents = function() {
                return n.props.monthShowsDuplicateDaysEnd && n.isAfterMonth() || n.props.monthShowsDuplicateDaysStart && n.isBeforeMonth() ? null : n.props.renderDayContents ? n.props.renderDayContents(w.getDate(n.props.day), n.props.day) : w.getDate(n.props.day);
            }, n.render = function() {
                return ue.default.createElement("div", {
                    ref: n.dayEl,
                    className: n.getClassNames(n.props.day),
                    onKeyDown: n.handleOnKeyDown,
                    onClick: n.handleClick,
                    onMouseEnter: n.props.usePointerEvent ? void 0 : n.handleMouseEnter,
                    onPointerEnter: n.props.usePointerEvent ? n.handleMouseEnter : void 0,
                    tabIndex: n.getTabIndex(),
                    "aria-label": n.getAriaLabel(),
                    role: "option",
                    title: n.getTitle(),
                    "aria-disabled": n.isDisabled(),
                    "aria-current": n.isCurrentDay() ? "date" : void 0,
                    "aria-selected": n.isSelected() || n.isInRange()
                }, n.renderDayContents(), "" !== n.getTitle() && ue.default.createElement("span", {
                    className: "overlay"
                }, n.getTitle()));
            }, n;
        }
        return ve(n, e), n.prototype.componentDidMount = function() {
            this.handleFocusDay();
        }, n.prototype.componentDidUpdate = function() {
            this.handleFocusDay();
        }, n.prototype.shouldFocusDay = function() {
            var e = !1;
            return 0 === this.getTabIndex() && this.isSameDay(this.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (e = !0), this.props.inline && !this.props.shouldFocusDayInline && (e = !1), this.isDayActiveElement() && (e = !0), this.isDuplicateDay() && (e = !1)), e;
        }, n.prototype.isDayActiveElement = function() {
            var e, t, r;
            return (null === (t = null === (e = this.props.containerRef) || void 0 === e ? void 0 : e.current) || void 0 === t ? void 0 : t.contains(document.activeElement)) && (null === (r = document.activeElement) || void 0 === r ? void 0 : r.classList.contains("react-datepicker__day"));
        }, n.prototype.isDuplicateDay = function() {
            return this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth();
        }, n;
    }(r.Component), bt = function(e) {
        function n() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.weekNumberEl = r.createRef(), t.handleClick = function(e) {
                t.props.onClick && t.props.onClick(e);
            }, t.handleOnKeyDown = function(e) {
                var r, n;
                e.key === De.Space && (e.preventDefault(), e.key = De.Enter), null === (n = (r = t.props).handleOnKeyDown) || void 0 === n || n.call(r, e);
            }, t.isKeyboardSelected = function() {
                return !t.props.disabledKeyboardNavigation && !He(t.props.date, t.props.selected) && He(t.props.date, t.props.preSelection);
            }, t.getTabIndex = function() {
                return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || He(t.props.date, t.props.selected) && He(t.props.preSelection, t.props.selected)) ? 0 : -1;
            }, t.handleFocusWeekNumber = function(e) {
                var r = !1;
                0 === t.getTabIndex() && !(null == e ? void 0 : e.isInputFocused) && He(t.props.date, t.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), t.props.inline && !t.props.shouldFocusDayInline && (r = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && t.weekNumberEl.current && t.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }, t;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    ariaLabelPrefix: "week "
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            this.handleFocusWeekNumber();
        }, n.prototype.componentDidUpdate = function(e) {
            this.handleFocusWeekNumber(e);
        }, n.prototype.render = function() {
            var e = this.props, r = e.weekNumber, a = e.ariaLabelPrefix, o = void 0 === a ? n.defaultProps.ariaLabelPrefix : a, s = e.onClick, i = {
                "react-datepicker__week-number": !0,
                "react-datepicker__week-number--clickable": !!s,
                "react-datepicker__week-number--selected": !!s && He(this.props.date, this.props.selected),
                "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
            };
            return ue.default.createElement("div", {
                ref: this.weekNumberEl,
                className: t.clsx(i),
                "aria-label": "".concat(o, " ").concat(this.props.weekNumber),
                onClick: this.handleClick,
                onKeyDown: this.handleOnKeyDown,
                tabIndex: this.getTabIndex()
            }, r);
        }, n;
    }(r.Component), Mt = function(e) {
        function r() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.isDisabled = function(e) {
                return je(e, {
                    minDate: t.props.minDate,
                    maxDate: t.props.maxDate,
                    excludeDates: t.props.excludeDates,
                    excludeDateIntervals: t.props.excludeDateIntervals,
                    includeDateIntervals: t.props.includeDateIntervals,
                    includeDates: t.props.includeDates,
                    filterDate: t.props.filterDate
                });
            }, t.handleDayClick = function(e, r) {
                t.props.onDayClick && t.props.onDayClick(e, r);
            }, t.handleDayMouseEnter = function(e) {
                t.props.onDayMouseEnter && t.props.onDayMouseEnter(e);
            }, t.handleWeekClick = function(e, n, a) {
                for(var o, s, i, l = new Date(e), c = 0; c < 7; c++){
                    var p = new Date(e);
                    if (p.setDate(p.getDate() + c), !t.isDisabled(p)) {
                        l = p;
                        break;
                    }
                }
                "function" == typeof t.props.onWeekSelect && t.props.onWeekSelect(l, n, a), t.props.showWeekPicker && t.handleDayClick(l, a), (null !== (o = t.props.shouldCloseOnSelect) && void 0 !== o ? o : r.defaultProps.shouldCloseOnSelect) && (null === (i = (s = t.props).setOpen) || void 0 === i || i.call(s, !1));
            }, t.formatWeekNumber = function(e) {
                return t.props.formatWeekNumber ? t.props.formatWeekNumber(e) : function(e) {
                    return M.getISOWeek(e);
                }(e);
            }, t.renderDays = function() {
                var e = t.startOfWeek(), n = [], o = t.formatWeekNumber(e);
                if (t.props.showWeekNumber) {
                    var s = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, e, o) : void 0;
                    n.push(ue.default.createElement(bt, ge({
                        key: "W"
                    }, r.defaultProps, t.props, {
                        weekNumber: o,
                        date: e,
                        onClick: s
                    })));
                }
                return n.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(n) {
                    var o = a.addDays(e, n);
                    return ue.default.createElement(St, ge({}, r.defaultProps, t.props, {
                        ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix,
                        key: o.valueOf(),
                        day: o,
                        onClick: t.handleDayClick.bind(t, o),
                        onMouseEnter: t.handleDayMouseEnter.bind(t, o)
                    }));
                }));
            }, t.startOfWeek = function() {
                return xe(t.props.day, t.props.locale, t.props.calendarStartDay);
            }, t.isKeyboardSelected = function() {
                return !t.props.disabledKeyboardNavigation && !He(t.startOfWeek(), t.props.selected) && He(t.startOfWeek(), t.props.preSelection);
            }, t;
        }
        return ve(r, e), Object.defineProperty(r, "defaultProps", {
            get: function() {
                return {
                    shouldCloseOnSelect: !0
                };
            },
            enumerable: !1,
            configurable: !0
        }), r.prototype.render = function() {
            var e = {
                "react-datepicker__week": !0,
                "react-datepicker__week--selected": He(this.startOfWeek(), this.props.selected),
                "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
            };
            return ue.default.createElement("div", {
                className: t.clsx(e)
            }, this.renderDays());
        }, r;
    }(r.Component), _t = "two_columns", Ct = "three_columns", Et = "four_columns", Yt = ((kt = {})[_t] = {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }, kt[Ct] = {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }, kt[Et] = {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    }, kt);
    function Pt(e, t) {
        return e ? Et : t ? _t : Ct;
    }
    var xt = function(e) {
        function n() {
            var n = null !== e && e.apply(this, arguments) || this;
            return n.MONTH_REFS = ye([], Array(12), !0).map(function() {
                return r.createRef();
            }), n.QUARTER_REFS = ye([], Array(4), !0).map(function() {
                return r.createRef();
            }), n.isDisabled = function(e) {
                return je(e, {
                    minDate: n.props.minDate,
                    maxDate: n.props.maxDate,
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals,
                    includeDateIntervals: n.props.includeDateIntervals,
                    includeDates: n.props.includeDates,
                    filterDate: n.props.filterDate
                });
            }, n.isExcluded = function(e) {
                return Ue(e, {
                    excludeDates: n.props.excludeDates,
                    excludeDateIntervals: n.props.excludeDateIntervals
                });
            }, n.handleDayClick = function(e, t) {
                var r, a;
                null === (a = (r = n.props).onDayClick) || void 0 === a || a.call(r, e, t, n.props.orderInDisplay);
            }, n.handleDayMouseEnter = function(e) {
                var t, r;
                null === (r = (t = n.props).onDayMouseEnter) || void 0 === r || r.call(t, e);
            }, n.handleMouseLeave = function() {
                var e, t;
                null === (t = (e = n.props).onMouseLeave) || void 0 === t || t.call(e);
            }, n.isRangeStartMonth = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Ae($.setMonth(r, e), a);
            }, n.isRangeStartQuarter = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Fe(z.setQuarter(r, e), a);
            }, n.isRangeEndMonth = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Ae($.setMonth(r, e), o);
            }, n.isRangeEndQuarter = function(e) {
                var t = n.props, r = t.day, a = t.startDate, o = t.endDate;
                return !(!a || !o) && Fe(z.setQuarter(r, e), o);
            }, n.isInSelectingRangeMonth = function(e) {
                var t, r = n.props, a = r.day, o = r.selectsStart, s = r.selectsEnd, i = r.selectsRange, l = r.startDate, c = r.endDate, p = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return !(!(o || s || i) || !p) && (o && c ? ze(p, c, e, a) : (s && l || !(!i || !l || c)) && ze(l, p, e, a));
            }, n.isSelectingMonthRangeStart = function(e) {
                var t;
                if (!n.isInSelectingRangeMonth(e)) return !1;
                var r = n.props, a = r.day, o = r.startDate, s = r.selectsStart, i = $.setMonth(a, e), l = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return Ae(i, s ? l : o);
            }, n.isSelectingMonthRangeEnd = function(e) {
                var t;
                if (!n.isInSelectingRangeMonth(e)) return !1;
                var r = n.props, a = r.day, o = r.endDate, s = r.selectsEnd, i = r.selectsRange, l = $.setMonth(a, e), c = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return Ae(l, s || i ? c : o);
            }, n.isInSelectingRangeQuarter = function(e) {
                var t, r = n.props, a = r.day, o = r.selectsStart, s = r.selectsEnd, i = r.selectsRange, l = r.startDate, c = r.endDate, p = null !== (t = n.props.selectingDate) && void 0 !== t ? t : n.props.preSelection;
                return !(!(o || s || i) || !p) && (o && c ? et(p, c, e, a) : (s && l || !(!i || !l || c)) && et(l, p, e, a));
            }, n.isWeekInMonth = function(e) {
                var t = n.props.day, r = a.addDays(e, 6);
                return Ae(e, t) || Ae(r, t);
            }, n.isCurrentMonth = function(e, t) {
                return x.getYear(e) === x.getYear(Me()) && t === C.getMonth(Me());
            }, n.isCurrentQuarter = function(e, t) {
                return x.getYear(e) === x.getYear(Me()) && t === E.getQuarter(Me());
            }, n.isSelectedMonth = function(e, t, r) {
                return C.getMonth(r) === t && x.getYear(e) === x.getYear(r);
            }, n.isSelectedQuarter = function(e, t, r) {
                return E.getQuarter(e) === t && x.getYear(e) === x.getYear(r);
            }, n.renderWeeks = function() {
                for(var e = [], t = n.props.fixedHeight, r = 0, a = !1, o = xe(Ne(n.props.day), n.props.locale, n.props.calendarStartDay), s = n.props.selected ? function(e) {
                    return n.props.showWeekPicker ? xe(e, n.props.locale, n.props.calendarStartDay) : n.props.selected;
                }(n.props.selected) : void 0, i = n.props.preSelection ? function(e) {
                    return n.props.showWeekPicker ? xe(e, n.props.locale, n.props.calendarStartDay) : n.props.preSelection;
                }(n.props.preSelection) : void 0; e.push(ue.default.createElement(Mt, ge({}, n.props, {
                    ariaLabelPrefix: n.props.weekAriaLabelPrefix,
                    key: r,
                    day: o,
                    month: C.getMonth(n.props.day),
                    onDayClick: n.handleDayClick,
                    onDayMouseEnter: n.handleDayMouseEnter,
                    selected: s,
                    preSelection: i,
                    showWeekNumber: n.props.showWeekNumbers
                }))), !a;){
                    r++, o = p.addWeeks(o, 1);
                    var l = t && r >= 6, c = !t && !n.isWeekInMonth(o);
                    if (l || c) {
                        if (!n.props.peekNextMonth) break;
                        a = !0;
                    }
                }
                return e;
            }, n.onMonthClick = function(e, t) {
                var r = n.isMonthDisabledForLabelDate(t), a = r.isDisabled, o = r.labelDate;
                a || n.handleDayClick(Ne(o), e);
            }, n.onMonthMouseEnter = function(e) {
                var t = n.isMonthDisabledForLabelDate(e), r = t.isDisabled, a = t.labelDate;
                r || n.handleDayMouseEnter(Ne(a));
            }, n.handleMonthNavigation = function(e, t) {
                var r, a, o, s;
                null === (a = (r = n.props).setPreSelection) || void 0 === a || a.call(r, t), null === (s = null === (o = n.MONTH_REFS[e]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus();
            }, n.handleKeyboardNavigation = function(e, t, r) {
                var a, o = n.props, s = o.selected, l = o.preSelection, c = o.setPreSelection, p = o.minDate, d = o.maxDate, u = o.showFourColumnMonthYearPicker, f = o.showTwoColumnMonthYearPicker;
                if (l) {
                    var h = Pt(u, f), m = n.getVerticalOffset(h), v = null === (a = Yt[h]) || void 0 === a ? void 0 : a.grid, g = function(e, t, r) {
                        var n, a, o = t, s = r;
                        switch(e){
                            case De.ArrowRight:
                                o = i.addMonths(t, 1), s = 11 === r ? 0 : r + 1;
                                break;
                            case De.ArrowLeft:
                                o = ae.subMonths(t, 1), s = 0 === r ? 11 : r - 1;
                                break;
                            case De.ArrowUp:
                                o = ae.subMonths(t, m), s = (null === (n = null == v ? void 0 : v[0]) || void 0 === n ? void 0 : n.includes(r)) ? r + 12 - m : r - m;
                                break;
                            case De.ArrowDown:
                                o = i.addMonths(t, m), s = (null === (a = null == v ? void 0 : v[v.length - 1]) || void 0 === a ? void 0 : a.includes(r)) ? r - 12 + m : r + m;
                        }
                        return {
                            newCalculatedDate: o,
                            newCalculatedMonth: s
                        };
                    };
                    if (t !== De.Enter) {
                        var y = function(e, t, r) {
                            for(var a = e, o = !1, s = 0, i = g(a, t, r), l = i.newCalculatedDate, c = i.newCalculatedMonth; !o;){
                                if (s >= 40) {
                                    l = t, c = r;
                                    break;
                                }
                                var u;
                                if (p && l < p) a = De.ArrowRight, l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                if (d && l > d) a = De.ArrowLeft, l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                if (Xe(l, n.props)) l = (u = g(a, l, c)).newCalculatedDate, c = u.newCalculatedMonth;
                                else o = !0;
                                s++;
                            }
                            return {
                                newCalculatedDate: l,
                                newCalculatedMonth: c
                            };
                        }(t, l, r), D = y.newCalculatedDate, k = y.newCalculatedMonth;
                        switch(t){
                            case De.ArrowRight:
                            case De.ArrowLeft:
                            case De.ArrowUp:
                            case De.ArrowDown:
                                n.handleMonthNavigation(k, D);
                        }
                    } else n.isMonthDisabled(r) || (n.onMonthClick(e, r), null == c || c(s));
                }
            }, n.getVerticalOffset = function(e) {
                var t, r;
                return null !== (r = null === (t = Yt[e]) || void 0 === t ? void 0 : t.verticalNavigationOffset) && void 0 !== r ? r : 0;
            }, n.onMonthKeyDown = function(e, t) {
                var r = n.props, a = r.disabledKeyboardNavigation, o = r.handleOnMonthKeyDown, s = e.key;
                s !== De.Tab && e.preventDefault(), a || n.handleKeyboardNavigation(e, s, t), o && o(e);
            }, n.onQuarterClick = function(e, t) {
                var r = z.setQuarter(n.props.day, t);
                Ge(r, n.props) || n.handleDayClick(Ie(r), e);
            }, n.onQuarterMouseEnter = function(e) {
                var t = z.setQuarter(n.props.day, e);
                Ge(t, n.props) || n.handleDayMouseEnter(Ie(t));
            }, n.handleQuarterNavigation = function(e, t) {
                var r, a, o, s;
                n.isDisabled(t) || n.isExcluded(t) || (null === (a = (r = n.props).setPreSelection) || void 0 === a || a.call(r, t), null === (s = null === (o = n.QUARTER_REFS[e - 1]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus());
            }, n.onQuarterKeyDown = function(e, t) {
                var r, a, o = e.key;
                if (!n.props.disabledKeyboardNavigation) switch(o){
                    case De.Enter:
                        n.onQuarterClick(e, t), null === (a = (r = n.props).setPreSelection) || void 0 === a || a.call(r, n.props.selected);
                        break;
                    case De.ArrowRight:
                        if (!n.props.preSelection) break;
                        n.handleQuarterNavigation(4 === t ? 1 : t + 1, l.addQuarters(n.props.preSelection, 1));
                        break;
                    case De.ArrowLeft:
                        if (!n.props.preSelection) break;
                        n.handleQuarterNavigation(1 === t ? 4 : t - 1, oe.subQuarters(n.props.preSelection, 1));
                }
            }, n.isMonthDisabledForLabelDate = function(e) {
                var t, r = n.props, a = r.day, o = r.minDate, s = r.maxDate, i = r.excludeDates, l = r.includeDates, c = $.setMonth(a, e);
                return {
                    isDisabled: null !== (t = (o || s || i || l) && $e(c, n.props)) && void 0 !== t && t,
                    labelDate: c
                };
            }, n.isMonthDisabled = function(e) {
                return n.isMonthDisabledForLabelDate(e).isDisabled;
            }, n.getMonthClassNames = function(e) {
                var r = n.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, l = r.preSelection, c = r.monthClassName, p = c ? c($.setMonth(a, e)) : void 0;
                return t.clsx("react-datepicker__month-text", "react-datepicker__month-".concat(e), p, {
                    "react-datepicker__month-text--disabled": n.isMonthDisabled(e),
                    "react-datepicker__month-text--selected": i ? n.isSelectedMonth(a, e, i) : void 0,
                    "react-datepicker__month-text--keyboard-selected": !n.props.disabledKeyboardNavigation && l && n.isSelectedMonth(a, e, l),
                    "react-datepicker__month-text--in-selecting-range": n.isInSelectingRangeMonth(e),
                    "react-datepicker__month-text--in-range": o && s ? ze(o, s, e, a) : void 0,
                    "react-datepicker__month-text--range-start": n.isRangeStartMonth(e),
                    "react-datepicker__month-text--range-end": n.isRangeEndMonth(e),
                    "react-datepicker__month-text--selecting-range-start": n.isSelectingMonthRangeStart(e),
                    "react-datepicker__month-text--selecting-range-end": n.isSelectingMonthRangeEnd(e),
                    "react-datepicker__month-text--today": n.isCurrentMonth(a, e)
                });
            }, n.getTabIndex = function(e) {
                if (null == n.props.preSelection) return "-1";
                var t = C.getMonth(n.props.preSelection);
                return n.props.disabledKeyboardNavigation || e !== t ? "-1" : "0";
            }, n.getQuarterTabIndex = function(e) {
                if (null == n.props.preSelection) return "-1";
                var t = E.getQuarter(n.props.preSelection);
                return n.props.disabledKeyboardNavigation || e !== t ? "-1" : "0";
            }, n.getAriaLabel = function(e) {
                var t = n.props, r = t.chooseDayAriaLabelPrefix, a = void 0 === r ? "Choose" : r, o = t.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = t.day, l = t.locale, c = $.setMonth(i, e), p = n.isDisabled(c) || n.isExcluded(c) ? s : a;
                return "".concat(p, " ").concat(Ce(c, "MMMM yyyy", l));
            }, n.getQuarterClassNames = function(e) {
                var r = n.props, a = r.day, o = r.startDate, s = r.endDate, i = r.selected, l = r.minDate, c = r.maxDate, p = r.preSelection, d = r.disabledKeyboardNavigation;
                return t.clsx("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e), {
                    "react-datepicker__quarter-text--disabled": (l || c) && Ge(z.setQuarter(a, e), n.props),
                    "react-datepicker__quarter-text--selected": i ? n.isSelectedQuarter(a, e, i) : void 0,
                    "react-datepicker__quarter-text--keyboard-selected": !d && p && n.isSelectedQuarter(a, e, p),
                    "react-datepicker__quarter-text--in-selecting-range": n.isInSelectingRangeQuarter(e),
                    "react-datepicker__quarter-text--in-range": o && s ? et(o, s, e, a) : void 0,
                    "react-datepicker__quarter-text--range-start": n.isRangeStartQuarter(e),
                    "react-datepicker__quarter-text--range-end": n.isRangeEndQuarter(e)
                });
            }, n.getMonthContent = function(e) {
                var t = n.props, r = t.showFullMonthYearPicker, a = t.renderMonthContent, o = t.locale, s = t.day, i = Ve(e, o), l = Be(e, o);
                return a ? a(e, i, l, s) : r ? l : i;
            }, n.getQuarterContent = function(e) {
                var t, r = n.props, a = r.renderQuarterContent, o = function(e, t) {
                    return Ce(z.setQuarter(Me(), e), "QQQ", t);
                }(e, r.locale);
                return null !== (t = null == a ? void 0 : a(e, o)) && void 0 !== t ? t : o;
            }, n.renderMonths = function() {
                var e, t = n.props, r = t.showTwoColumnMonthYearPicker, a = t.showFourColumnMonthYearPicker, o = t.day, s = t.selected, i = null === (e = Yt[Pt(a, r)]) || void 0 === e ? void 0 : e.grid;
                return null == i ? void 0 : i.map(function(e, t) {
                    return ue.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: t
                    }, e.map(function(e, t) {
                        return ue.default.createElement("div", {
                            ref: n.MONTH_REFS[e],
                            key: t,
                            onClick: function(t) {
                                n.onMonthClick(t, e);
                            },
                            onKeyDown: function(t) {
                                Dt(t) && (t.preventDefault(), t.key = De.Enter), n.onMonthKeyDown(t, e);
                            },
                            onMouseEnter: n.props.usePointerEvent ? void 0 : function() {
                                return n.onMonthMouseEnter(e);
                            },
                            onPointerEnter: n.props.usePointerEvent ? function() {
                                return n.onMonthMouseEnter(e);
                            } : void 0,
                            tabIndex: Number(n.getTabIndex(e)),
                            className: n.getMonthClassNames(e),
                            "aria-disabled": n.isMonthDisabled(e),
                            role: "option",
                            "aria-label": n.getAriaLabel(e),
                            "aria-current": n.isCurrentMonth(o, e) ? "date" : void 0,
                            "aria-selected": s ? n.isSelectedMonth(o, e, s) : void 0
                        }, n.getMonthContent(e));
                    }));
                });
            }, n.renderQuarters = function() {
                var e = n.props, t = e.day, r = e.selected;
                return ue.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(e, a) {
                    return ue.default.createElement("div", {
                        key: a,
                        ref: n.QUARTER_REFS[a],
                        role: "option",
                        onClick: function(t) {
                            n.onQuarterClick(t, e);
                        },
                        onKeyDown: function(t) {
                            n.onQuarterKeyDown(t, e);
                        },
                        onMouseEnter: n.props.usePointerEvent ? void 0 : function() {
                            return n.onQuarterMouseEnter(e);
                        },
                        onPointerEnter: n.props.usePointerEvent ? function() {
                            return n.onQuarterMouseEnter(e);
                        } : void 0,
                        className: n.getQuarterClassNames(e),
                        "aria-selected": r ? n.isSelectedQuarter(t, e, r) : void 0,
                        tabIndex: Number(n.getQuarterTabIndex(e)),
                        "aria-current": n.isCurrentQuarter(t, e) ? "date" : void 0
                    }, n.getQuarterContent(e));
                }));
            }, n.getClassNames = function() {
                var e = n.props, r = e.selectingDate, a = e.selectsStart, o = e.selectsEnd, s = e.showMonthYearPicker, i = e.showQuarterYearPicker, l = e.showWeekPicker;
                return t.clsx("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || o)
                }, {
                    "react-datepicker__monthPicker": s
                }, {
                    "react-datepicker__quarterPicker": i
                }, {
                    "react-datepicker__weekPicker": l
                });
            }, n;
        }
        return ve(n, e), n.prototype.render = function() {
            var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, n = e.day, a = e.ariaLabelPrefix, o = void 0 === a ? "Month " : a, s = o ? o.trim() + " " : "";
            return ue.default.createElement("div", {
                className: this.getClassNames(),
                onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
                onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
                "aria-label": "".concat(s).concat(Ce(n, "MMMM, yyyy", this.props.locale)),
                role: "listbox"
            }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
        }, n;
    }(r.Component), Nt = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.isSelectedMonth = function(e) {
                return t.props.month === e;
            }, t.renderOptions = function() {
                return t.props.monthNames.map(function(e, r) {
                    return ue.default.createElement("div", {
                        className: t.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: e,
                        onClick: t.onChange.bind(t, r),
                        "aria-selected": t.isSelectedMonth(r) ? "true" : void 0
                    }, t.isSelectedMonth(r) ? ue.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "✓") : "", e);
                });
            }, t.onChange = function(e) {
                return t.props.onChange(e);
            }, t.handleClickOutside = function() {
                return t.props.onCancel();
            }, t;
        }
        return ve(t, e), t.prototype.render = function() {
            return ue.default.createElement("div", {
                className: "react-datepicker__month-dropdown"
            }, this.renderOptions());
        }, t;
    }(r.Component), Ot = fe.default(Nt), It = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.state = {
                dropdownVisible: !1
            }, t.renderSelectOptions = function(e) {
                return e.map(function(e, t) {
                    return ue.default.createElement("option", {
                        key: e,
                        value: t
                    }, e);
                });
            }, t.renderSelectMode = function(e) {
                return ue.default.createElement("select", {
                    value: t.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(e) {
                        return t.onChange(parseInt(e.target.value));
                    }
                }, t.renderSelectOptions(e));
            }, t.renderReadView = function(e, r) {
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: t.toggleDropdown
                }, ue.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[t.props.month]));
            }, t.renderDropdown = function(e) {
                return ue.default.createElement(Ot, ge({
                    key: "dropdown"
                }, t.props, {
                    monthNames: e,
                    onChange: t.onChange,
                    onCancel: t.toggleDropdown
                }));
            }, t.renderScrollMode = function(e) {
                var r = t.state.dropdownVisible, n = [
                    t.renderReadView(!r, e)
                ];
                return r && n.unshift(t.renderDropdown(e)), n;
            }, t.onChange = function(e) {
                t.toggleDropdown(), e !== t.props.month && t.props.onChange(e);
            }, t.toggleDropdown = function() {
                return t.setState({
                    dropdownVisible: !t.state.dropdownVisible
                });
            }, t;
        }
        return ve(t, e), t.prototype.render = function() {
            var e, t = this, r = [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map(this.props.useShortMonthInDropdown ? function(e) {
                return Ve(e, t.props.locale);
            } : function(e) {
                return Be(e, t.props.locale);
            });
            switch(this.props.dropdownMode){
                case "scroll":
                    e = this.renderScrollMode(r);
                    break;
                case "select":
                    e = this.renderSelectMode(r);
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
            }, e);
        }, t;
    }(r.Component);
    function Tt(e, t) {
        for(var r = [], n = Ne(e), a = Ne(t); !N.isAfter(n, a);)r.push(Me(n)), n = i.addMonths(n, 1);
        return r;
    }
    var Rt = function(e) {
        function r(t) {
            var r = e.call(this, t) || this;
            return r.renderOptions = function() {
                return r.state.monthYearsList.map(function(e) {
                    var t = P.getTime(e), n = Le(r.props.date, e) && Ae(r.props.date, e);
                    return ue.default.createElement("div", {
                        className: n ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: r.onChange.bind(r, t),
                        "aria-selected": n ? "true" : void 0
                    }, n ? ue.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "✓") : "", Ce(e, r.props.dateFormat, r.props.locale));
                });
            }, r.onChange = function(e) {
                return r.props.onChange(e);
            }, r.handleClickOutside = function() {
                r.props.onCancel();
            }, r.state = {
                monthYearsList: Tt(r.props.minDate, r.props.maxDate)
            }, r;
        }
        return ve(r, e), r.prototype.render = function() {
            var e = t.clsx({
                "react-datepicker__month-year-dropdown": !0,
                "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
            });
            return ue.default.createElement("div", {
                className: e
            }, this.renderOptions());
        }, r;
    }(r.Component), Lt = fe.default(Rt), At = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.state = {
                dropdownVisible: !1
            }, t.renderSelectOptions = function() {
                for(var e = Ne(t.props.minDate), r = Ne(t.props.maxDate), n = []; !N.isAfter(e, r);){
                    var a = P.getTime(e);
                    n.push(ue.default.createElement("option", {
                        key: a,
                        value: a
                    }, Ce(e, t.props.dateFormat, t.props.locale))), e = i.addMonths(e, 1);
                }
                return n;
            }, t.onSelectChange = function(e) {
                t.onChange(parseInt(e.target.value));
            }, t.renderSelectMode = function() {
                return ue.default.createElement("select", {
                    value: P.getTime(Ne(t.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: t.onSelectChange
                }, t.renderSelectOptions());
            }, t.renderReadView = function(e) {
                var r = Ce(t.props.date, t.props.dateFormat, t.props.locale);
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: t.toggleDropdown
                }, ue.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }, t.renderDropdown = function() {
                return ue.default.createElement(Lt, ge({
                    key: "dropdown"
                }, t.props, {
                    onChange: t.onChange,
                    onCancel: t.toggleDropdown
                }));
            }, t.renderScrollMode = function() {
                var e = t.state.dropdownVisible, r = [
                    t.renderReadView(!e)
                ];
                return e && r.unshift(t.renderDropdown()), r;
            }, t.onChange = function(e) {
                t.toggleDropdown();
                var r = Me(e);
                Le(t.props.date, r) && Ae(t.props.date, r) || t.props.onChange(r);
            }, t.toggleDropdown = function() {
                return t.setState({
                    dropdownVisible: !t.state.dropdownVisible
                });
            }, t;
        }
        return ve(t, e), t.prototype.render = function() {
            var e;
            switch(this.props.dropdownMode){
                case "scroll":
                    e = this.renderScrollMode();
                    break;
                case "select":
                    e = this.renderSelectMode();
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
            }, e);
        }, t;
    }(r.Component), Ft = function(e) {
        function t() {
            var r = null !== e && e.apply(this, arguments) || this;
            return r.state = {
                height: null
            }, r.scrollToTheSelectedTime = function() {
                requestAnimationFrame(function() {
                    var e, n, a;
                    r.list && (r.list.scrollTop = null !== (a = r.centerLi && t.calcCenterPosition(r.props.monthRef ? r.props.monthRef.clientHeight - (null !== (n = null === (e = r.header) || void 0 === e ? void 0 : e.clientHeight) && void 0 !== n ? n : 0) : r.list.clientHeight, r.centerLi)) && void 0 !== a ? a : 0);
                });
            }, r.handleClick = function(e) {
                var t, n;
                (r.props.minTime || r.props.maxTime) && at(e, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && nt(e, r.props) || null === (n = (t = r.props).onChange) || void 0 === n || n.call(t, e);
            }, r.isSelectedTime = function(e) {
                var t, n;
                return r.props.selected && (t = r.props.selected, n = e, vt(t).getTime() === vt(n).getTime());
            }, r.isDisabledTime = function(e) {
                return (r.props.minTime || r.props.maxTime) && at(e, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && nt(e, r.props);
            }, r.liClasses = function(e) {
                var n, a = [
                    "react-datepicker__time-list-item",
                    r.props.timeClassName ? r.props.timeClassName(e) : void 0
                ];
                return r.isSelectedTime(e) && a.push("react-datepicker__time-list-item--selected"), r.isDisabledTime(e) && a.push("react-datepicker__time-list-item--disabled"), r.props.injectTimes && (3600 * b.getHours(e) + 60 * _.getMinutes(e) + Y.getSeconds(e)) % (60 * (null !== (n = r.props.intervals) && void 0 !== n ? n : t.defaultProps.intervals)) != 0 && a.push("react-datepicker__time-list-item--injected"), a.join(" ");
            }, r.handleOnKeyDown = function(e, t) {
                var n, a;
                e.key === De.Space && (e.preventDefault(), e.key = De.Enter), (e.key === De.ArrowUp || e.key === De.ArrowLeft) && e.target instanceof HTMLElement && e.target.previousSibling && (e.preventDefault(), e.target.previousSibling instanceof HTMLElement && e.target.previousSibling.focus()), (e.key === De.ArrowDown || e.key === De.ArrowRight) && e.target instanceof HTMLElement && e.target.nextSibling && (e.preventDefault(), e.target.nextSibling instanceof HTMLElement && e.target.nextSibling.focus()), e.key === De.Enter && r.handleClick(t), null === (a = (n = r.props).handleOnKeyDown) || void 0 === a || a.call(n, e);
            }, r.renderTimes = function() {
                for(var e, n = [], a = r.props.format ? r.props.format : "p", o = null !== (e = r.props.intervals) && void 0 !== e ? e : t.defaultProps.intervals, i = r.props.selected || r.props.openToDate || Me(), l = Pe(i), c = r.props.injectTimes && r.props.injectTimes.sort(function(e, t) {
                    return e.getTime() - t.getTime();
                }), p = 60 * function(e) {
                    var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+r - +t) / 36e5);
                }(i), d = p / o, u = 0; u < d; u++){
                    var f = s.addMinutes(l, u * o);
                    if (n.push(f), c) {
                        var h = ft(l, f, u, o, c);
                        n = n.concat(h);
                    }
                }
                var m = n.reduce(function(e, t) {
                    return t.getTime() <= i.getTime() ? t : e;
                }, n[0]);
                return n.map(function(e) {
                    return ue.default.createElement("li", {
                        key: e.valueOf(),
                        onClick: r.handleClick.bind(r, e),
                        className: r.liClasses(e),
                        ref: function(t) {
                            e === m && (r.centerLi = t);
                        },
                        onKeyDown: function(t) {
                            r.handleOnKeyDown(t, e);
                        },
                        tabIndex: e === m ? 0 : -1,
                        role: "option",
                        "aria-selected": r.isSelectedTime(e) ? "true" : void 0,
                        "aria-disabled": r.isDisabledTime(e) ? "true" : void 0
                    }, Ce(e, a, r.props.locale));
                });
            }, r;
        }
        return ve(t, e), Object.defineProperty(t, "defaultProps", {
            get: function() {
                return {
                    intervals: 30,
                    todayButton: null,
                    timeCaption: "Time"
                };
            },
            enumerable: !1,
            configurable: !0
        }), t.prototype.componentDidMount = function() {
            this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                height: this.props.monthRef.clientHeight - this.header.clientHeight
            });
        }, t.prototype.render = function() {
            var e, r = this, n = this.state.height;
            return ue.default.createElement("div", {
                className: "react-datepicker__time-container ".concat((null !== (e = this.props.todayButton) && void 0 !== e ? e : t.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
            }, ue.default.createElement("div", {
                className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                ref: function(e) {
                    r.header = e;
                }
            }, ue.default.createElement("div", {
                className: "react-datepicker-time__header"
            }, this.props.timeCaption)), ue.default.createElement("div", {
                className: "react-datepicker__time"
            }, ue.default.createElement("div", {
                className: "react-datepicker__time-box"
            }, ue.default.createElement("ul", {
                className: "react-datepicker__time-list",
                ref: function(e) {
                    r.list = e;
                },
                style: n ? {
                    height: n
                } : {},
                role: "listbox",
                "aria-label": this.props.timeCaption
            }, this.renderTimes()))));
        }, t.calcCenterPosition = function(e, t) {
            return t.offsetTop - (e / 2 - t.clientHeight / 2);
        }, t;
    }(r.Component), Ht = function(e) {
        function n(n) {
            var a = e.call(this, n) || this;
            return a.YEAR_REFS = ye([], Array(a.props.yearItemNumber), !0).map(function() {
                return r.createRef();
            }), a.isDisabled = function(e) {
                return je(e, {
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    excludeDates: a.props.excludeDates,
                    includeDates: a.props.includeDates,
                    filterDate: a.props.filterDate
                });
            }, a.isExcluded = function(e) {
                return Ue(e, {
                    excludeDates: a.props.excludeDates
                });
            }, a.selectingDate = function() {
                var e;
                return null !== (e = a.props.selectingDate) && void 0 !== e ? e : a.props.preSelection;
            }, a.updateFocusOnPaginate = function(e) {
                window.requestAnimationFrame(function() {
                    var t, r;
                    null === (r = null === (t = a.YEAR_REFS[e]) || void 0 === t ? void 0 : t.current) || void 0 === r || r.focus();
                });
            }, a.handleYearClick = function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }, a.handleYearNavigation = function(e, t) {
                var r, n, o, s, i = a.props, l = i.date, c = i.yearItemNumber;
                if (void 0 !== l && void 0 !== c) {
                    var p = mt(l, c).startPeriod;
                    a.isDisabled(t) || a.isExcluded(t) || (null === (n = (r = a.props).setPreSelection) || void 0 === n || n.call(r, t), e - p < 0 ? a.updateFocusOnPaginate(c - (p - e)) : e - p >= c ? a.updateFocusOnPaginate(Math.abs(c - (e - p))) : null === (s = null === (o = a.YEAR_REFS[e - p]) || void 0 === o ? void 0 : o.current) || void 0 === s || s.focus());
                }
            }, a.isSameDay = function(e, t) {
                return He(e, t);
            }, a.isCurrentYear = function(e) {
                return e === x.getYear(Me());
            }, a.isRangeStart = function(e) {
                return a.props.startDate && a.props.endDate && Le(G.setYear(Me(), e), a.props.startDate);
            }, a.isRangeEnd = function(e) {
                return a.props.startDate && a.props.endDate && Le(G.setYear(Me(), e), a.props.endDate);
            }, a.isInRange = function(e) {
                return Je(e, a.props.startDate, a.props.endDate);
            }, a.isInSelectingRange = function(e) {
                var t = a.props, r = t.selectsStart, n = t.selectsEnd, o = t.selectsRange, s = t.startDate, i = t.endDate;
                return !(!(r || n || o) || !a.selectingDate()) && (r && i ? Je(e, a.selectingDate(), i) : (n && s || !(!o || !s || i)) && Je(e, s, a.selectingDate()));
            }, a.isSelectingRangeStart = function(e) {
                var t;
                if (!a.isInSelectingRange(e)) return !1;
                var r = a.props, n = r.startDate, o = r.selectsStart, s = G.setYear(Me(), e);
                return Le(s, o ? null !== (t = a.selectingDate()) && void 0 !== t ? t : null : null != n ? n : null);
            }, a.isSelectingRangeEnd = function(e) {
                var t;
                if (!a.isInSelectingRange(e)) return !1;
                var r = a.props, n = r.endDate, o = r.selectsEnd, s = r.selectsRange, i = G.setYear(Me(), e);
                return Le(i, o || s ? null !== (t = a.selectingDate()) && void 0 !== t ? t : null : null != n ? n : null);
            }, a.isKeyboardSelected = function(e) {
                if (void 0 !== a.props.date && null != a.props.selected && null != a.props.preSelection) {
                    var t = Oe(G.setYear(a.props.date, e));
                    return !a.props.disabledKeyboardNavigation && !a.props.inline && !He(t, Oe(a.props.selected)) && He(t, Oe(a.props.preSelection));
                }
            }, a.onYearClick = function(e, t) {
                var r = a.props.date;
                void 0 !== r && a.handleYearClick(Oe(G.setYear(r, t)), e);
            }, a.onYearKeyDown = function(e, t) {
                var r, n, o = e.key, s = a.props, i = s.date, l = s.yearItemNumber, c = s.handleOnKeyDown;
                if (o !== De.Tab && e.preventDefault(), !a.props.disabledKeyboardNavigation) switch(o){
                    case De.Enter:
                        if (null == a.props.selected) break;
                        a.onYearClick(e, t), null === (n = (r = a.props).setPreSelection) || void 0 === n || n.call(r, a.props.selected);
                        break;
                    case De.ArrowRight:
                        if (null == a.props.preSelection) break;
                        a.handleYearNavigation(t + 1, d.addYears(a.props.preSelection, 1));
                        break;
                    case De.ArrowLeft:
                        if (null == a.props.preSelection) break;
                        a.handleYearNavigation(t - 1, ie.subYears(a.props.preSelection, 1));
                        break;
                    case De.ArrowUp:
                        if (void 0 === i || void 0 === l || null == a.props.preSelection) break;
                        var p = mt(i, l).startPeriod;
                        if ((h = t - (f = 3)) < p) {
                            var u = l % f;
                            t >= p && t < p + u ? f = u : f += u, h = t - f;
                        }
                        a.handleYearNavigation(h, ie.subYears(a.props.preSelection, f));
                        break;
                    case De.ArrowDown:
                        if (void 0 === i || void 0 === l || null == a.props.preSelection) break;
                        var f, h, m = mt(i, l).endPeriod;
                        if ((h = t + (f = 3)) > m) {
                            u = l % f;
                            t <= m && t > m - u ? f = u : f += u, h = t + f;
                        }
                        a.handleYearNavigation(h, d.addYears(a.props.preSelection, f));
                }
                c && c(e);
            }, a.getYearClassNames = function(e) {
                var r = a.props, n = r.date, o = r.minDate, s = r.maxDate, i = r.selected, l = r.excludeDates, c = r.includeDates, p = r.filterDate, d = r.yearClassName;
                return t.clsx("react-datepicker__year-text", "react-datepicker__year-".concat(e), n ? null == d ? void 0 : d(G.setYear(n, e)) : void 0, {
                    "react-datepicker__year-text--selected": i ? e === x.getYear(i) : void 0,
                    "react-datepicker__year-text--disabled": (o || s || l || c || p) && Ze(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": a.isRangeStart(e),
                    "react-datepicker__year-text--range-end": a.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": a.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": a.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": a.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": a.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }, a.getYearTabIndex = function(e) {
                return a.props.disabledKeyboardNavigation || null == a.props.preSelection ? "-1" : e === x.getYear(a.props.preSelection) ? "0" : "-1";
            }, a.getYearContainerClassNames = function() {
                var e = a.props, r = e.selectingDate, n = e.selectsStart, o = e.selectsEnd, s = e.selectsRange;
                return t.clsx("react-datepicker__year", {
                    "react-datepicker__year--selecting-range": r && (n || o || s)
                });
            }, a.getYearContent = function(e) {
                return a.props.renderYearContent ? a.props.renderYearContent(e) : e;
            }, a;
        }
        return ve(n, e), n.prototype.render = function() {
            var e = this, t = [], r = this.props, n = r.date, a = r.yearItemNumber, o = r.onYearMouseEnter, s = r.onYearMouseLeave;
            if (void 0 === n) return null;
            for(var i = mt(n, a), l = i.startPeriod, c = i.endPeriod, p = function(r) {
                t.push(ue.default.createElement("div", {
                    ref: d.YEAR_REFS[r - l],
                    onClick: function(t) {
                        e.onYearClick(t, r);
                    },
                    onKeyDown: function(t) {
                        Dt(t) && (t.preventDefault(), t.key = De.Enter), e.onYearKeyDown(t, r);
                    },
                    tabIndex: Number(d.getYearTabIndex(r)),
                    className: d.getYearClassNames(r),
                    onMouseEnter: d.props.usePointerEvent ? void 0 : function(e) {
                        return o(e, r);
                    },
                    onPointerEnter: d.props.usePointerEvent ? function(e) {
                        return o(e, r);
                    } : void 0,
                    onMouseLeave: d.props.usePointerEvent ? void 0 : function(e) {
                        return s(e, r);
                    },
                    onPointerLeave: d.props.usePointerEvent ? function(e) {
                        return s(e, r);
                    } : void 0,
                    key: r,
                    "aria-current": d.isCurrentYear(r) ? "date" : void 0
                }, d.getYearContent(r)));
            }, d = this, u = l; u <= c; u++)p(u);
            return ue.default.createElement("div", {
                className: this.getYearContainerClassNames()
            }, ue.default.createElement("div", {
                className: "react-datepicker__year-wrapper",
                onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
                onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
            }, t));
        }, n;
    }(r.Component);
    function Wt(e, t, r, n) {
        for(var a = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = x.getYear(r) <= s), n && i && (i = x.getYear(n) >= s), i && a.push(s);
        }
        return a;
    }
    var Qt = function(e) {
        function n(t) {
            var n = e.call(this, t) || this;
            n.renderOptions = function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return ue.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(n, t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? ue.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "✓") : "", t);
                }), r = n.props.minDate ? x.getYear(n.props.minDate) : null, a = n.props.maxDate ? x.getYear(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(ue.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, ue.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(ue.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, ue.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }, n.onChange = function(e) {
                n.props.onChange(e);
            }, n.handleClickOutside = function() {
                n.props.onCancel();
            }, n.shiftYears = function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }, n.incrementYears = function() {
                return n.shiftYears(1);
            }, n.decrementYears = function() {
                return n.shiftYears(-1);
            };
            var a = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, s = a || (o ? 10 : 5);
            return n.state = {
                yearsList: Wt(n.props.year, s, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = r.createRef(), n;
        }
        return ve(n, e), n.prototype.componentDidMount = function() {
            var e = this.dropdownRef.current;
            if (e) {
                var t = e.children ? Array.from(e.children) : null, r = t ? t.find(function(e) {
                    return e.ariaSelected;
                }) : null;
                e.scrollTop = r && r instanceof HTMLElement ? r.offsetTop + (r.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
            }
        }, n.prototype.render = function() {
            var e = t.clsx({
                "react-datepicker__year-dropdown": !0,
                "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
            });
            return ue.default.createElement("div", {
                className: e,
                ref: this.dropdownRef
            }, this.renderOptions());
        }, n;
    }(r.Component), qt = fe.default(Qt), Kt = function(e) {
        function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.state = {
                dropdownVisible: !1
            }, t.renderSelectOptions = function() {
                for(var e = t.props.minDate ? x.getYear(t.props.minDate) : 1900, r = t.props.maxDate ? x.getYear(t.props.maxDate) : 2100, n = [], a = e; a <= r; a++)n.push(ue.default.createElement("option", {
                    key: a,
                    value: a
                }, a));
                return n;
            }, t.onSelectChange = function(e) {
                t.onChange(parseInt(e.target.value));
            }, t.renderSelectMode = function() {
                return ue.default.createElement("select", {
                    value: t.props.year,
                    className: "react-datepicker__year-select",
                    onChange: t.onSelectChange
                }, t.renderSelectOptions());
            }, t.renderReadView = function(e) {
                return ue.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(e) {
                        return t.toggleDropdown(e);
                    }
                }, ue.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), ue.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, t.props.year));
            }, t.renderDropdown = function() {
                return ue.default.createElement(qt, ge({
                    key: "dropdown"
                }, t.props, {
                    onChange: t.onChange,
                    onCancel: t.toggleDropdown
                }));
            }, t.renderScrollMode = function() {
                var e = t.state.dropdownVisible, r = [
                    t.renderReadView(!e)
                ];
                return e && r.unshift(t.renderDropdown()), r;
            }, t.onChange = function(e) {
                t.toggleDropdown(), e !== t.props.year && t.props.onChange(e);
            }, t.toggleDropdown = function(e) {
                t.setState({
                    dropdownVisible: !t.state.dropdownVisible
                }, function() {
                    t.props.adjustDateOnChange && t.handleYearChange(t.props.date, e);
                });
            }, t.handleYearChange = function(e, r) {
                t.onSelect(e, r), t.setOpen();
            }, t.onSelect = function(e, r) {
                t.props.onSelect && t.props.onSelect(e, r);
            }, t.setOpen = function() {
                t.props.setOpen && t.props.setOpen(!0);
            }, t;
        }
        return ve(t, e), t.prototype.render = function() {
            var e;
            switch(this.props.dropdownMode){
                case "scroll":
                    e = this.renderScrollMode();
                    break;
                case "select":
                    e = this.renderSelectMode();
            }
            return ue.default.createElement("div", {
                className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
            }, e);
        }, t;
    }(r.Component), Bt = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Vt = function(e) {
        function n(o) {
            var s = e.call(this, o) || this;
            return s.monthContainer = void 0, s.handleClickOutside = function(e) {
                s.props.onClickOutside(e);
            }, s.setClickOutsideRef = function() {
                return s.containerRef.current;
            }, s.handleDropdownFocus = function(e) {
                var t, r, n, a;
                n = e.target, a = (n.className || "").split(/\s+/), Bt.some(function(e) {
                    return a.indexOf(e) >= 0;
                }) && (null === (r = (t = s.props).onDropdownFocus) || void 0 === r || r.call(t, e));
            }, s.getDateInView = function() {
                var e = s.props, t = e.preSelection, r = e.selected, n = e.openToDate, a = ct(s.props), o = pt(s.props), i = Me(), l = n || r || t;
                return l || (a && O.isBefore(i, a) ? a : o && N.isAfter(i, o) ? o : i);
            }, s.increaseMonth = function() {
                s.setState(function(e) {
                    var t = e.date;
                    return {
                        date: i.addMonths(t, 1)
                    };
                }, function() {
                    return s.handleMonthChange(s.state.date);
                });
            }, s.decreaseMonth = function() {
                s.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ae.subMonths(t, 1)
                    };
                }, function() {
                    return s.handleMonthChange(s.state.date);
                });
            }, s.handleDayClick = function(e, t, r) {
                s.props.onSelect(e, t, r), s.props.setPreSelection && s.props.setPreSelection(e);
            }, s.handleDayMouseEnter = function(e) {
                s.setState({
                    selectingDate: e
                }), s.props.onDayMouseEnter && s.props.onDayMouseEnter(e);
            }, s.handleMonthMouseLeave = function() {
                s.setState({
                    selectingDate: void 0
                }), s.props.onMonthMouseLeave && s.props.onMonthMouseLeave();
            }, s.handleYearMouseEnter = function(e, t) {
                s.setState({
                    selectingDate: G.setYear(Me(), t)
                }), s.props.onYearMouseEnter && s.props.onYearMouseEnter(e, t);
            }, s.handleYearMouseLeave = function(e, t) {
                s.props.onYearMouseLeave && s.props.onYearMouseLeave(e, t);
            }, s.handleYearChange = function(e) {
                s.props.onYearChange && (s.props.onYearChange(e), s.setState({
                    isRenderAriaLiveMessage: !0
                })), s.props.adjustDateOnChange && (s.props.onSelect && s.props.onSelect(e), s.props.setOpen && s.props.setOpen(!0)), s.props.setPreSelection && s.props.setPreSelection(e);
            }, s.handleMonthChange = function(e) {
                s.handleCustomMonthChange(e), s.props.adjustDateOnChange && (s.props.onSelect && s.props.onSelect(e), s.props.setOpen && s.props.setOpen(!0)), s.props.setPreSelection && s.props.setPreSelection(e);
            }, s.handleCustomMonthChange = function(e) {
                s.props.onMonthChange && (s.props.onMonthChange(e), s.setState({
                    isRenderAriaLiveMessage: !0
                }));
            }, s.handleMonthYearChange = function(e) {
                s.handleYearChange(e), s.handleMonthChange(e);
            }, s.changeYear = function(e) {
                s.setState(function(t) {
                    var r = t.date;
                    return {
                        date: G.setYear(r, Number(e))
                    };
                }, function() {
                    return s.handleYearChange(s.state.date);
                });
            }, s.changeMonth = function(e) {
                s.setState(function(t) {
                    var r = t.date;
                    return {
                        date: $.setMonth(r, Number(e))
                    };
                }, function() {
                    return s.handleMonthChange(s.state.date);
                });
            }, s.changeMonthYear = function(e) {
                s.setState(function(t) {
                    var r = t.date;
                    return {
                        date: G.setYear($.setMonth(r, C.getMonth(e)), x.getYear(e))
                    };
                }, function() {
                    return s.handleMonthYearChange(s.state.date);
                });
            }, s.header = function(e) {
                void 0 === e && (e = s.state.date);
                var r = xe(e, s.props.locale, s.props.calendarStartDay), n = [];
                return s.props.showWeekNumbers && n.push(ue.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, s.props.weekLabel || "#")), n.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var n = a.addDays(r, e), o = s.formatWeekday(n, s.props.locale), i = s.props.weekDayClassName ? s.props.weekDayClassName(n) : void 0;
                    return ue.default.createElement("div", {
                        key: e,
                        "aria-label": Ce(n, "EEEE", s.props.locale),
                        className: t.clsx("react-datepicker__day-name", i)
                    }, o);
                }));
            }, s.formatWeekday = function(e, t) {
                return s.props.formatWeekDay ? function(e, t, r) {
                    return t(Ce(e, "EEEE", r));
                }(e, s.props.formatWeekDay, t) : s.props.useWeekdaysShort ? function(e, t) {
                    return Ce(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Ce(e, "EEEEEE", t);
                }(e, t);
            }, s.decreaseYear = function() {
                s.setState(function(e) {
                    var t, r = e.date;
                    return {
                        date: ie.subYears(r, s.props.showYearPicker ? null !== (t = s.props.yearItemNumber) && void 0 !== t ? t : n.defaultProps.yearItemNumber : 1)
                    };
                }, function() {
                    return s.handleYearChange(s.state.date);
                });
            }, s.clearSelectingDate = function() {
                s.setState({
                    selectingDate: void 0
                });
            }, s.renderPreviousButton = function() {
                var e;
                if (!s.props.renderCustomHeader) {
                    var t;
                    switch(!0){
                        case s.props.showMonthYearPicker:
                            t = it(s.state.date, s.props);
                            break;
                        case s.props.showYearPicker:
                            t = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.minDate, a = r.yearItemNumber, o = void 0 === a ? Se : a, s = mt(Oe(ie.subYears(e, o)), o).endPeriod, i = n && x.getYear(n);
                                return i && i > s || !1;
                            }(s.state.date, s.props);
                            break;
                        case s.props.showQuarterYearPicker:
                            t = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.minDate, a = r.includeDates, o = re.startOfYear(e), s = oe.subQuarters(o, 1);
                                return n && h.differenceInCalendarQuarters(n, s) > 0 || a && a.every(function(e) {
                                    return h.differenceInCalendarQuarters(e, s) > 0;
                                }) || !1;
                            }(s.state.date, s.props);
                            break;
                        default:
                            t = ot(s.state.date, s.props);
                    }
                    if (((null !== (e = s.props.forceShowMonthNavigation) && void 0 !== e ? e : n.defaultProps.forceShowMonthNavigation) || s.props.showDisabledMonthNavigation || !t) && !s.props.showTimeSelectOnly) {
                        var r = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], a = s.decreaseMonth;
                        (s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker) && (a = s.decreaseYear), t && s.props.showDisabledMonthNavigation && (r.push("react-datepicker__navigation--previous--disabled"), a = void 0);
                        var o = s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker, i = s.props, l = i.previousMonthButtonLabel, c = void 0 === l ? n.defaultProps.previousMonthButtonLabel : l, p = i.previousYearButtonLabel, d = void 0 === p ? n.defaultProps.previousYearButtonLabel : p, u = s.props, f = u.previousMonthAriaLabel, m = void 0 === f ? "string" == typeof c ? c : "Previous Month" : f, v = u.previousYearAriaLabel, g = void 0 === v ? "string" == typeof d ? d : "Previous Year" : v;
                        return ue.default.createElement("button", {
                            type: "button",
                            className: r.join(" "),
                            onClick: a,
                            onKeyDown: s.props.handleOnKeyDown,
                            "aria-label": o ? g : m
                        }, ue.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, o ? d : c));
                    }
                }
            }, s.increaseYear = function() {
                s.setState(function(e) {
                    var t, r = e.date;
                    return {
                        date: d.addYears(r, s.props.showYearPicker ? null !== (t = s.props.yearItemNumber) && void 0 !== t ? t : n.defaultProps.yearItemNumber : 1)
                    };
                }, function() {
                    return s.handleYearChange(s.state.date);
                });
            }, s.renderNextButton = function() {
                var e;
                if (!s.props.renderCustomHeader) {
                    var t;
                    switch(!0){
                        case s.props.showMonthYearPicker:
                            t = lt(s.state.date, s.props);
                            break;
                        case s.props.showYearPicker:
                            t = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.maxDate, a = r.yearItemNumber, o = void 0 === a ? Se : a, s = mt(d.addYears(e, o), o).startPeriod, i = n && x.getYear(n);
                                return i && i < s || !1;
                            }(s.state.date, s.props);
                            break;
                        case s.props.showQuarterYearPicker:
                            t = function(e, t) {
                                var r = void 0 === t ? {} : t, n = r.maxDate, a = r.includeDates, o = D.endOfYear(e), s = l.addQuarters(o, 1);
                                return n && h.differenceInCalendarQuarters(s, n) > 0 || a && a.every(function(e) {
                                    return h.differenceInCalendarQuarters(s, e) > 0;
                                }) || !1;
                            }(s.state.date, s.props);
                            break;
                        default:
                            t = st(s.state.date, s.props);
                    }
                    if (((null !== (e = s.props.forceShowMonthNavigation) && void 0 !== e ? e : n.defaultProps.forceShowMonthNavigation) || s.props.showDisabledMonthNavigation || !t) && !s.props.showTimeSelectOnly) {
                        var r = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        s.props.showTimeSelect && r.push("react-datepicker__navigation--next--with-time"), s.props.todayButton && r.push("react-datepicker__navigation--next--with-today-button");
                        var a = s.increaseMonth;
                        (s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker) && (a = s.increaseYear), t && s.props.showDisabledMonthNavigation && (r.push("react-datepicker__navigation--next--disabled"), a = void 0);
                        var o = s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker, i = s.props, c = i.nextMonthButtonLabel, p = void 0 === c ? n.defaultProps.nextMonthButtonLabel : c, u = i.nextYearButtonLabel, f = void 0 === u ? n.defaultProps.nextYearButtonLabel : u, m = s.props, v = m.nextMonthAriaLabel, g = void 0 === v ? "string" == typeof p ? p : "Next Month" : v, y = m.nextYearAriaLabel, k = void 0 === y ? "string" == typeof f ? f : "Next Year" : y;
                        return ue.default.createElement("button", {
                            type: "button",
                            className: r.join(" "),
                            onClick: a,
                            onKeyDown: s.props.handleOnKeyDown,
                            "aria-label": o ? k : g
                        }, ue.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, o ? f : p));
                    }
                }
            }, s.renderCurrentMonth = function(e) {
                void 0 === e && (e = s.state.date);
                var t = [
                    "react-datepicker__current-month"
                ];
                return s.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), s.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), s.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), ue.default.createElement("h2", {
                    className: t.join(" ")
                }, Ce(e, s.props.dateFormat, s.props.locale));
            }, s.renderYearDropdown = function(e) {
                if (void 0 === e && (e = !1), s.props.showYearDropdown && !e) return ue.default.createElement(Kt, ge({}, n.defaultProps, s.props, {
                    date: s.state.date,
                    onChange: s.changeYear,
                    year: x.getYear(s.state.date)
                }));
            }, s.renderMonthDropdown = function(e) {
                if (void 0 === e && (e = !1), s.props.showMonthDropdown && !e) return ue.default.createElement(It, ge({}, n.defaultProps, s.props, {
                    month: C.getMonth(s.state.date),
                    onChange: s.changeMonth
                }));
            }, s.renderMonthYearDropdown = function(e) {
                if (void 0 === e && (e = !1), s.props.showMonthYearDropdown && !e) return ue.default.createElement(At, ge({}, n.defaultProps, s.props, {
                    date: s.state.date,
                    onChange: s.changeMonthYear
                }));
            }, s.handleTodayButtonClick = function(e) {
                s.props.onSelect(Te(), e), s.props.setPreSelection && s.props.setPreSelection(Te());
            }, s.renderTodayButton = function() {
                if (s.props.todayButton && !s.props.showTimeSelectOnly) return ue.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: s.handleTodayButtonClick
                }, s.props.todayButton);
            }, s.renderDefaultHeader = function(e) {
                var t = e.monthDate, r = e.i;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header ".concat(s.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, s.renderCurrentMonth(t), ue.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(s.props.dropdownMode),
                    onFocus: s.handleDropdownFocus
                }, s.renderMonthDropdown(0 !== r), s.renderMonthYearDropdown(0 !== r), s.renderYearDropdown(0 !== r)), ue.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, s.header(t)));
            }, s.renderCustomHeader = function(e) {
                var t, r, n = e.monthDate, a = e.i;
                if (s.props.showTimeSelect && !s.state.monthContainer || s.props.showTimeSelectOnly) return null;
                var o = ot(s.state.date, s.props), i = st(s.state.date, s.props), l = it(s.state.date, s.props), c = lt(s.state.date, s.props), p = !s.props.showMonthYearPicker && !s.props.showQuarterYearPicker && !s.props.showYearPicker;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: s.props.onDropdownFocus
                }, null === (r = (t = s.props).renderCustomHeader) || void 0 === r ? void 0 : r.call(t, ge(ge({}, s.state), {
                    customHeaderCount: a,
                    monthDate: n,
                    changeMonth: s.changeMonth,
                    changeYear: s.changeYear,
                    decreaseMonth: s.decreaseMonth,
                    increaseMonth: s.increaseMonth,
                    decreaseYear: s.decreaseYear,
                    increaseYear: s.increaseYear,
                    prevMonthButtonDisabled: o,
                    nextMonthButtonDisabled: i,
                    prevYearButtonDisabled: l,
                    nextYearButtonDisabled: c
                })), p && ue.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, s.header(n)));
            }, s.renderYearHeader = function(e) {
                var t = e.monthDate, r = s.props, a = r.showYearPicker, o = r.yearItemNumber, i = mt(t, void 0 === o ? n.defaultProps.yearItemNumber : o), l = i.startPeriod, c = i.endPeriod;
                return ue.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, a ? "".concat(l, " - ").concat(c) : x.getYear(t));
            }, s.renderHeader = function(e) {
                var t = e.monthDate, r = e.i, n = {
                    monthDate: t,
                    i: void 0 === r ? 0 : r
                };
                switch(!0){
                    case void 0 !== s.props.renderCustomHeader:
                        return s.renderCustomHeader(n);
                    case s.props.showMonthYearPicker || s.props.showQuarterYearPicker || s.props.showYearPicker:
                        return s.renderYearHeader(n);
                    default:
                        return s.renderDefaultHeader(n);
                }
            }, s.renderMonths = function() {
                var e, t;
                if (!s.props.showTimeSelectOnly && !s.props.showYearPicker) {
                    for(var r = [], a = null !== (e = s.props.monthsShown) && void 0 !== e ? e : n.defaultProps.monthsShown, o = s.props.showPreviousMonths ? a - 1 : 0, l = s.props.showMonthYearPicker || s.props.showQuarterYearPicker ? d.addYears(s.state.date, o) : ae.subMonths(s.state.date, o), c = null !== (t = s.props.monthSelectedIn) && void 0 !== t ? t : o, p = 0; p < a; ++p){
                        var u = p - c + o, f = s.props.showMonthYearPicker || s.props.showQuarterYearPicker ? d.addYears(l, u) : i.addMonths(l, u), h = "month-".concat(p), m = p < a - 1, v = p > 0;
                        r.push(ue.default.createElement("div", {
                            key: h,
                            ref: function(e) {
                                s.monthContainer = null != e ? e : void 0;
                            },
                            className: "react-datepicker__month-container"
                        }, s.renderHeader({
                            monthDate: f,
                            i: p
                        }), ue.default.createElement(xt, ge({}, n.defaultProps, s.props, {
                            ariaLabelPrefix: s.props.monthAriaLabelPrefix,
                            day: f,
                            onDayClick: s.handleDayClick,
                            handleOnKeyDown: s.props.handleOnDayKeyDown,
                            handleOnMonthKeyDown: s.props.handleOnKeyDown,
                            onDayMouseEnter: s.handleDayMouseEnter,
                            onMouseLeave: s.handleMonthMouseLeave,
                            orderInDisplay: p,
                            selectingDate: s.state.selectingDate,
                            monthShowsDuplicateDaysEnd: m,
                            monthShowsDuplicateDaysStart: v
                        }))));
                    }
                    return r;
                }
            }, s.renderYears = function() {
                if (!s.props.showTimeSelectOnly) return s.props.showYearPicker ? ue.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, s.renderHeader({
                    monthDate: s.state.date
                }), ue.default.createElement(Ht, ge({}, n.defaultProps, s.props, {
                    selectingDate: s.state.selectingDate,
                    date: s.state.date,
                    onDayClick: s.handleDayClick,
                    clearSelectingDate: s.clearSelectingDate,
                    onYearMouseEnter: s.handleYearMouseEnter,
                    onYearMouseLeave: s.handleYearMouseLeave
                }))) : void 0;
            }, s.renderTimeSection = function() {
                if (s.props.showTimeSelect && (s.state.monthContainer || s.props.showTimeSelectOnly)) return ue.default.createElement(Ft, ge({}, n.defaultProps, s.props, {
                    onChange: s.props.onTimeChange,
                    format: s.props.timeFormat,
                    intervals: s.props.timeIntervals,
                    monthRef: s.state.monthContainer
                }));
            }, s.renderInputTimeSection = function() {
                var e = s.props.selected ? new Date(s.props.selected) : void 0, t = e && _e(e) && Boolean(s.props.selected) ? "".concat(ht(e.getHours()), ":").concat(ht(e.getMinutes())) : "";
                if (s.props.showTimeInput) return ue.default.createElement(wt, ge({}, n.defaultProps, s.props, {
                    date: e,
                    timeString: t,
                    onChange: s.props.onTimeChange
                }));
            }, s.renderAriaLiveRegion = function() {
                var e, t, r = mt(s.state.date, null !== (e = s.props.yearItemNumber) && void 0 !== e ? e : n.defaultProps.yearItemNumber), a = r.startPeriod, o = r.endPeriod;
                return t = s.props.showYearPicker ? "".concat(a, " - ").concat(o) : s.props.showMonthYearPicker || s.props.showQuarterYearPicker ? x.getYear(s.state.date) : "".concat(Be(C.getMonth(s.state.date), s.props.locale), " ").concat(x.getYear(s.state.date)), ue.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, s.state.isRenderAriaLiveMessage && t);
            }, s.renderChildren = function() {
                if (s.props.children) return ue.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, s.props.children);
            }, s.containerRef = r.createRef(), s.state = {
                date: s.getDateInView(),
                selectingDate: void 0,
                monthContainer: void 0,
                isRenderAriaLiveMessage: !1
            }, s;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    monthsShown: 1,
                    forceShowMonthNavigation: !1,
                    timeCaption: "Time",
                    previousYearButtonLabel: "Previous Year",
                    nextYearButtonLabel: "Next Year",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthButtonLabel: "Next Month",
                    yearItemNumber: Se
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            var e = this;
            this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                monthContainer: e.monthContainer
            }));
        }, n.prototype.componentDidUpdate = function(e) {
            var t = this;
            if (!this.props.preSelection || He(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !He(this.props.openToDate, e.openToDate) && this.setState({
                date: this.props.openToDate
            });
            else {
                var r = !Ae(this.state.date, this.props.preSelection);
                this.setState({
                    date: this.props.preSelection
                }, function() {
                    return r && t.handleCustomMonthChange(t.state.date);
                });
            }
        }, n.prototype.render = function() {
            var e = this.props.container || ke;
            return ue.default.createElement("div", {
                style: {
                    display: "contents"
                },
                ref: this.containerRef
            }, ue.default.createElement(e, {
                className: t.clsx("react-datepicker", this.props.className, {
                    "react-datepicker--time-only": this.props.showTimeSelectOnly
                }),
                showTime: this.props.showTimeSelect || this.props.showTimeInput,
                showTimeSelectOnly: this.props.showTimeSelectOnly
            }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
        }, n;
    }(r.Component), jt = function(e) {
        var t = e.icon, r = e.className, n = void 0 === r ? "" : r, a = e.onClick, o = "react-datepicker__calendar-icon";
        return "string" == typeof t ? ue.default.createElement("i", {
            className: "".concat(o, " ").concat(t, " ").concat(n),
            "aria-hidden": "true",
            onClick: a
        }) : ue.default.isValidElement(t) ? ue.default.cloneElement(t, {
            className: "".concat(t.props.className || "", " ").concat(o, " ").concat(n),
            onClick: function(e) {
                "function" == typeof t.props.onClick && t.props.onClick(e), "function" == typeof a && a(e);
            }
        }) : ue.default.createElement("svg", {
            className: "".concat(o, " ").concat(n),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: a
        }, ue.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, Ut = function(e) {
        function t(t) {
            var r = e.call(this, t) || this;
            return r.portalRoot = null, r.el = document.createElement("div"), r;
        }
        return ve(t, e), t.prototype.componentDidMount = function() {
            this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
        }, t.prototype.componentWillUnmount = function() {
            this.portalRoot && this.portalRoot.removeChild(this.el);
        }, t.prototype.render = function() {
            return he.default.createPortal(this.props.children, this.el);
        }, t;
    }(r.Component), $t = function(e) {
        return (e instanceof HTMLAnchorElement || !e.disabled) && -1 !== e.tabIndex;
    }, zt = function(e) {
        function t(t) {
            var n = e.call(this, t) || this;
            return n.getTabChildren = function() {
                var e;
                return Array.prototype.slice.call(null === (e = n.tabLoopRef.current) || void 0 === e ? void 0 : e.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter($t);
            }, n.handleFocusStart = function() {
                var e = n.getTabChildren();
                e && e.length > 1 && e[e.length - 1].focus();
            }, n.handleFocusEnd = function() {
                var e = n.getTabChildren();
                e && e.length > 1 && e[0].focus();
            }, n.tabLoopRef = r.createRef(), n;
        }
        return ve(t, e), t.prototype.render = function() {
            var e;
            return (null !== (e = this.props.enableTabLoop) && void 0 !== e ? e : t.defaultProps.enableTabLoop) ? ue.default.createElement("div", {
                className: "react-datepicker__tab-loop",
                ref: this.tabLoopRef
            }, ue.default.createElement("div", {
                className: "react-datepicker__tab-loop__start",
                tabIndex: 0,
                onFocus: this.handleFocusStart
            }), this.props.children, ue.default.createElement("div", {
                className: "react-datepicker__tab-loop__end",
                tabIndex: 0,
                onFocus: this.handleFocusEnd
            })) : this.props.children;
        }, t.defaultProps = {
            enableTabLoop: !0
        }, t;
    }(r.Component);
    var Xt, Gt = function(e) {
        function n() {
            return null !== e && e.apply(this, arguments) || this;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    hidePopper: !0
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.render = function() {
            var e = this.props, a = e.className, o = e.wrapperClassName, s = e.hidePopper, i = void 0 === s ? n.defaultProps.hidePopper : s, l = e.popperComponent, c = e.targetComponent, p = e.enableTabLoop, d = e.popperOnKeyDown, u = e.portalId, f = e.portalHost, h = e.popperProps, m = e.showArrow, v = void 0;
            if (!i) {
                var g = t.clsx("react-datepicker-popper", a);
                v = ue.default.createElement(zt, {
                    enableTabLoop: p
                }, ue.default.createElement("div", {
                    ref: h.refs.setFloating,
                    style: h.floatingStyles,
                    className: g,
                    "data-placement": h.placement,
                    onKeyDown: d
                }, l, m && ue.default.createElement(ce.FloatingArrow, {
                    ref: h.arrowRef,
                    context: h.context,
                    fill: "currentColor",
                    strokeWidth: 1,
                    height: 8,
                    width: 16,
                    style: {
                        transform: "translateY(-1px)"
                    },
                    className: "react-datepicker__triangle"
                })));
            }
            this.props.popperContainer && (v = r.createElement(this.props.popperContainer, {}, v)), u && !i && (v = ue.default.createElement(Ut, {
                portalId: u,
                portalHost: f
            }, v));
            var y = t.clsx("react-datepicker-wrapper", o);
            return ue.default.createElement(ue.default.Fragment, null, ue.default.createElement("div", {
                ref: h.refs.setReference,
                className: y
            }, c), v);
        }, n;
    }(r.Component), Jt = (Xt = Gt, function(e) {
        var t, n = "boolean" != typeof e.hidePopper || e.hidePopper, a = r.useRef(null), o = ce.useFloating(ge({
            open: !n,
            whileElementsMounted: ce.autoUpdate,
            placement: e.popperPlacement,
            middleware: ye([
                ce.flip({
                    padding: 15
                }),
                ce.offset(10),
                ce.arrow({
                    element: a
                })
            ], null !== (t = e.popperModifiers) && void 0 !== t ? t : [], !0)
        }, e.popperProps)), s = ge(ge({}, e), {
            hidePopper: n,
            popperProps: ge(ge({}, o), {
                arrowRef: a
            })
        });
        return ue.default.createElement(Xt, ge({}, s));
    }), Zt = "react-datepicker-ignore-onclickoutside", er = fe.default(Vt);
    var tr = "Date input not valid.", rr = function(e) {
        function n(o) {
            var s = e.call(this, o) || this;
            return s.calendar = null, s.input = null, s.getPreSelection = function() {
                return s.props.openToDate ? s.props.openToDate : s.props.selectsEnd && s.props.startDate ? s.props.startDate : s.props.selectsStart && s.props.endDate ? s.props.endDate : Me();
            }, s.modifyHolidays = function() {
                var e;
                return null === (e = s.props.holidays) || void 0 === e ? void 0 : e.reduce(function(e, t) {
                    var r = new Date(t.date);
                    return _e(r) ? ye(ye([], e, !0), [
                        ge(ge({}, t), {
                            date: r
                        })
                    ], !1) : e;
                }, []);
            }, s.calcInitialState = function() {
                var e, t = s.getPreSelection(), r = ct(s.props), n = pt(s.props), a = r && O.isBefore(t, Pe(r)) ? r : n && N.isAfter(t, Re(n)) ? n : t;
                return {
                    open: s.props.startOpen || !1,
                    preventFocus: !1,
                    inputValue: null,
                    preSelection: null !== (e = s.props.selectsRange ? s.props.startDate : s.props.selected) && void 0 !== e ? e : a,
                    highlightDates: dt(s.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1,
                    wasHidden: !1
                };
            }, s.resetHiddenStatus = function() {
                s.setState(ge(ge({}, s.state), {
                    wasHidden: !1
                }));
            }, s.setHiddenStatus = function() {
                s.setState(ge(ge({}, s.state), {
                    wasHidden: !0
                }));
            }, s.setHiddenStateOnVisibilityHidden = function() {
                "hidden" === document.visibilityState && s.setHiddenStatus();
            }, s.clearPreventFocusTimeout = function() {
                s.preventFocusTimeout && clearTimeout(s.preventFocusTimeout);
            }, s.setFocus = function() {
                s.input && s.input.focus && s.input.focus({
                    preventScroll: !0
                });
            }, s.setBlur = function() {
                s.input && s.input.blur && s.input.blur(), s.cancelFocusInput();
            }, s.setOpen = function(e, t) {
                void 0 === t && (t = !1), s.setState({
                    open: e,
                    preSelection: e && s.state.open ? s.state.preSelection : s.calcInitialState().preSelection,
                    lastPreSelectChange: ar
                }, function() {
                    e || s.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && s.setBlur(), s.setState({
                            inputValue: null
                        });
                    });
                });
            }, s.inputOk = function() {
                return I.isDate(s.state.preSelection);
            }, s.isCalendarOpen = function() {
                return void 0 === s.props.open ? s.state.open && !s.props.disabled && !s.props.readOnly : s.props.open;
            }, s.handleFocus = function(e) {
                var t, r, n = s.state.wasHidden, a = !n || s.state.open;
                n && s.resetHiddenStatus(), !s.state.preventFocus && a && (null === (r = (t = s.props).onFocus) || void 0 === r || r.call(t, e), s.props.preventOpenOnFocus || s.props.readOnly || s.setOpen(!0)), s.setState({
                    focused: !0
                });
            }, s.sendFocusBackToInput = function() {
                s.preventFocusTimeout && s.clearPreventFocusTimeout(), s.setState({
                    preventFocus: !0
                }, function() {
                    s.preventFocusTimeout = setTimeout(function() {
                        s.setFocus(), s.setState({
                            preventFocus: !1
                        });
                    });
                });
            }, s.cancelFocusInput = function() {
                clearTimeout(s.inputFocusTimeout), s.inputFocusTimeout = void 0;
            }, s.deferFocusInput = function() {
                s.cancelFocusInput(), s.inputFocusTimeout = setTimeout(function() {
                    return s.setFocus();
                }, 1);
            }, s.handleDropdownFocus = function() {
                s.cancelFocusInput();
            }, s.handleBlur = function(e) {
                var t, r;
                (!s.state.open || s.props.withPortal || s.props.showTimeInput) && (null === (r = (t = s.props).onBlur) || void 0 === r || r.call(t, e)), s.setState({
                    focused: !1
                });
            }, s.handleCalendarClickOutside = function(e) {
                var t, r;
                s.props.inline || s.setOpen(!1), null === (r = (t = s.props).onClickOutside) || void 0 === r || r.call(t, e), s.props.withPortal && e.preventDefault();
            }, s.handleChange = function() {
                for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
                var r = e[0];
                if (!s.props.onChangeRaw || (s.props.onChangeRaw.apply(s, e), r && "function" == typeof r.isDefaultPrevented && !r.isDefaultPrevented())) {
                    s.setState({
                        inputValue: (null == r ? void 0 : r.target) instanceof HTMLInputElement ? r.target.value : null,
                        lastPreSelectChange: nr
                    });
                    var a = s.props, o = a.dateFormat, i = void 0 === o ? n.defaultProps.dateFormat : o, l = a.strictParsing, c = void 0 === l ? n.defaultProps.strictParsing : l, p = function(e, t, r, n, a) {
                        var o, s = null, i = Ke(r) || Ke(qe()), l = !0;
                        if (Array.isArray(t)) return t.forEach(function(t) {
                            var o = K.parse(e, t, new Date, {
                                locale: i,
                                useAdditionalWeekYearTokens: !0,
                                useAdditionalDayOfYearTokens: !0
                            });
                            n && (l = _e(o, a) && e === Ce(o, t, r)), _e(o, a) && l && (s = o);
                        }), s;
                        if (s = K.parse(e, t, new Date, {
                            locale: i,
                            useAdditionalWeekYearTokens: !0,
                            useAdditionalDayOfYearTokens: !0
                        }), n) l = _e(s) && e === Ce(s, t, r);
                        else if (!_e(s)) {
                            var c = (null !== (o = t.match(be)) && void 0 !== o ? o : []).map(function(e) {
                                var t = e[0];
                                if ("p" === t || "P" === t) {
                                    var r = k.longFormatters[t];
                                    return i ? r(e, i.formatLong) : t;
                                }
                                return e;
                            }).join("");
                            e.length > 0 && (s = K.parse(e, c.slice(0, e.length), new Date, {
                                useAdditionalWeekYearTokens: !0,
                                useAdditionalDayOfYearTokens: !0
                            })), _e(s) || (s = new Date(e));
                        }
                        return _e(s) && l ? s : null;
                    }((null == r ? void 0 : r.target) instanceof HTMLInputElement ? r.target.value : "", i, s.props.locale, c, s.props.minDate);
                    s.props.showTimeSelectOnly && s.props.selected && p && !He(p, s.props.selected) && (p = V.set(s.props.selected, {
                        hours: b.getHours(p),
                        minutes: _.getMinutes(p),
                        seconds: Y.getSeconds(p)
                    })), !p && (null == r ? void 0 : r.target) instanceof HTMLInputElement && (null == r ? void 0 : r.target.value) || s.setSelected(p, r, !0);
                }
            }, s.handleSelect = function(e, t, r) {
                if (s.props.shouldCloseOnSelect && !s.props.showTimeSelect && s.sendFocusBackToInput(), s.props.onChangeRaw && s.props.onChangeRaw(t), s.setSelected(e, t, !1, r), s.props.showDateSelect && s.setState({
                    isRenderAriaLiveMessage: !0
                }), !s.props.shouldCloseOnSelect || s.props.showTimeSelect) s.setPreSelection(e);
                else if (!s.props.inline) {
                    s.props.selectsRange || s.setOpen(!1);
                    var n = s.props, a = n.startDate, o = n.endDate;
                    !a || o || !s.props.swapRange && yt(e, a) || s.setOpen(!1);
                }
            }, s.setSelected = function(e, t, r, n) {
                var a = e;
                if (s.props.showYearPicker) {
                    if (null !== a && Ze(x.getYear(a), s.props)) return;
                } else if (s.props.showMonthYearPicker) {
                    if (null !== a && $e(a, s.props)) return;
                } else if (null !== a && je(a, s.props)) return;
                var o = s.props, i = o.onChange, l = o.selectsRange, c = o.startDate, p = o.endDate, d = o.selectsMultiple, u = o.selectedDates, f = o.minTime, h = o.swapRange;
                if (!We(s.props.selected, a) || s.props.allowSameDay || l || d) {
                    if (null !== a && (!s.props.selected || r && (s.props.showTimeSelect || s.props.showTimeSelectOnly || s.props.showTimeInput) || (a = Ye(a, {
                        hour: b.getHours(s.props.selected),
                        minute: _.getMinutes(s.props.selected),
                        second: Y.getSeconds(s.props.selected)
                    })), r || !s.props.showTimeSelect && !s.props.showTimeSelectOnly || f && (a = Ye(a, {
                        hour: f.getHours(),
                        minute: f.getMinutes(),
                        second: f.getSeconds()
                    })), s.props.inline || s.setState({
                        preSelection: a
                    }), s.props.focusSelectedMonth || s.setState({
                        monthSelectedIn: n
                    })), l) {
                        var m = c && !p, v = c && p;
                        !c && !p ? i([
                            a,
                            null
                        ], t) : m && (null === a ? i([
                            null,
                            null
                        ], t) : yt(a, c) ? i(h ? [
                            a,
                            c
                        ] : [
                            a,
                            null
                        ], t) : i([
                            c,
                            a
                        ], t)), v && i([
                            a,
                            null
                        ], t);
                    } else if (d) {
                        if (null !== a) {
                            if (null == u ? void 0 : u.length) {
                                if (u.some(function(e) {
                                    return He(e, a);
                                })) i(u.filter(function(e) {
                                    return !He(e, a);
                                }), t);
                                else i(ye(ye([], u, !0), [
                                    a
                                ], !1), t);
                            } else i([
                                a
                            ], t);
                        }
                    } else i(a, t);
                }
                r || (s.props.onSelect(a, t), s.setState({
                    inputValue: null
                }));
            }, s.setPreSelection = function(e) {
                var t = I.isDate(s.props.minDate), r = I.isDate(s.props.maxDate), n = !0;
                if (e) {
                    var a = Pe(e);
                    if (t && r) n = Qe(e, s.props.minDate, s.props.maxDate);
                    else if (t) {
                        var o = Pe(s.props.minDate);
                        n = N.isAfter(e, o) || We(a, o);
                    } else if (r) {
                        var i = Re(s.props.maxDate);
                        n = O.isBefore(e, i) || We(a, i);
                    }
                }
                n && s.setState({
                    preSelection: e
                });
            }, s.toggleCalendar = function() {
                s.setOpen(!s.state.open);
            }, s.handleTimeChange = function(e) {
                if (!s.props.selectsRange && !s.props.selectsMultiple) {
                    var t = s.props.selected ? s.props.selected : s.getPreSelection(), r = s.props.selected ? e : Ye(t, {
                        hour: b.getHours(e),
                        minute: _.getMinutes(e)
                    });
                    s.setState({
                        preSelection: r
                    }), s.props.onChange(r), s.props.shouldCloseOnSelect && !s.props.showTimeInput && (s.sendFocusBackToInput(), s.setOpen(!1)), s.props.showTimeInput && s.setOpen(!0), (s.props.showTimeSelectOnly || s.props.showTimeSelect) && s.setState({
                        isRenderAriaLiveMessage: !0
                    }), s.setState({
                        inputValue: null
                    });
                }
            }, s.onInputClick = function() {
                var e, t;
                s.props.disabled || s.props.readOnly || s.setOpen(!0), null === (t = (e = s.props).onInputClick) || void 0 === t || t.call(e);
            }, s.onInputKeyDown = function(e) {
                var t, r, n, a, o;
                null === (r = (t = s.props).onKeyDown) || void 0 === r || r.call(t, e);
                var i = e.key;
                if (s.state.open || s.props.inline || s.props.preventOpenOnFocus) {
                    if (s.state.open) {
                        if (i === De.ArrowDown || i === De.ArrowUp) {
                            e.preventDefault();
                            var l = s.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : s.props.showWeekPicker && s.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : s.props.showFullMonthYearPicker || s.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', c = (null === (n = s.calendar) || void 0 === n ? void 0 : n.componentNode) instanceof Element && s.calendar.componentNode.querySelector(l);
                            return void (c instanceof HTMLElement && c.focus({
                                preventScroll: !0
                            }));
                        }
                        var p = Me(s.state.preSelection);
                        i === De.Enter ? (e.preventDefault(), s.inputOk() && s.state.lastPreSelectChange === ar ? (s.handleSelect(p, e), !s.props.shouldCloseOnSelect && s.setPreSelection(p)) : s.setOpen(!1)) : i === De.Escape ? (e.preventDefault(), s.sendFocusBackToInput(), s.setOpen(!1)) : i === De.Tab && s.setOpen(!1), s.inputOk() || null === (o = (a = s.props).onInputError) || void 0 === o || o.call(a, {
                            code: 1,
                            msg: tr
                        });
                    }
                } else i !== De.ArrowDown && i !== De.ArrowUp && i !== De.Enter || s.onInputClick();
            }, s.onPortalKeyDown = function(e) {
                e.key === De.Escape && (e.preventDefault(), s.setState({
                    preventFocus: !0
                }, function() {
                    s.setOpen(!1), setTimeout(function() {
                        s.setFocus(), s.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }, s.onDayKeyDown = function(e) {
                var t, r, n, o, l = s.props, c = l.minDate, u = l.maxDate, f = l.disabledKeyboardNavigation, h = l.showWeekPicker, m = l.shouldCloseOnSelect, v = l.locale, g = l.calendarStartDay, D = l.adjustDateOnChange, k = l.inline;
                if (null === (r = (t = s.props).onKeyDown) || void 0 === r || r.call(t, e), !f) {
                    var w = e.key, S = e.shiftKey, b = Me(s.state.preSelection), M = function(e, t) {
                        var r = t;
                        switch(e){
                            case De.ArrowRight:
                                r = h ? p.addWeeks(t, 1) : a.addDays(t, 1);
                                break;
                            case De.ArrowLeft:
                                r = h ? se.subWeeks(t, 1) : ne.subDays(t, 1);
                                break;
                            case De.ArrowUp:
                                r = se.subWeeks(t, 1);
                                break;
                            case De.ArrowDown:
                                r = p.addWeeks(t, 1);
                                break;
                            case De.PageUp:
                                r = S ? ie.subYears(t, 1) : ae.subMonths(t, 1);
                                break;
                            case De.PageDown:
                                r = S ? d.addYears(t, 1) : i.addMonths(t, 1);
                                break;
                            case De.Home:
                                r = xe(t, v, g);
                                break;
                            case De.End:
                                r = function(e) {
                                    return y.endOfWeek(e);
                                }(t);
                        }
                        return r;
                    };
                    if (w === De.Enter) return e.preventDefault(), s.handleSelect(b, e), void (!m && s.setPreSelection(b));
                    if (w === De.Escape) return e.preventDefault(), s.setOpen(!1), void (s.inputOk() || null === (o = (n = s.props).onInputError) || void 0 === o || o.call(n, {
                        code: 1,
                        msg: tr
                    }));
                    var _ = null;
                    switch(w){
                        case De.ArrowLeft:
                        case De.ArrowRight:
                        case De.ArrowUp:
                        case De.ArrowDown:
                        case De.PageUp:
                        case De.PageDown:
                        case De.Home:
                        case De.End:
                            _ = function(e, t) {
                                for(var r = e, n = !1, a = 0, o = M(e, t); !n;){
                                    if (a >= 40) {
                                        o = t;
                                        break;
                                    }
                                    c && o < c && (r = De.ArrowRight, o = je(c, s.props) ? M(r, o) : c), u && o > u && (r = De.ArrowLeft, o = je(u, s.props) ? M(r, o) : u), je(o, s.props) ? (r !== De.PageUp && r !== De.Home || (r = De.ArrowRight), r !== De.PageDown && r !== De.End || (r = De.ArrowLeft), o = M(r, o)) : n = !0, a++;
                                }
                                return o;
                            }(w, b);
                    }
                    if (_) {
                        if (e.preventDefault(), s.setState({
                            lastPreSelectChange: ar
                        }), D && s.setSelected(_), s.setPreSelection(_), k) {
                            var E = C.getMonth(b), Y = C.getMonth(_), P = x.getYear(b), N = x.getYear(_);
                            E !== Y || P !== N ? s.setState({
                                shouldFocusDayInline: !0
                            }) : s.setState({
                                shouldFocusDayInline: !1
                            });
                        }
                    } else s.props.onInputError && s.props.onInputError({
                        code: 1,
                        msg: tr
                    });
                }
            }, s.onPopperKeyDown = function(e) {
                e.key === De.Escape && (e.preventDefault(), s.sendFocusBackToInput());
            }, s.onClearClick = function(e) {
                e && e.preventDefault && e.preventDefault(), s.sendFocusBackToInput();
                var t = s.props, r = t.selectsRange, n = t.onChange;
                n(r ? [
                    null,
                    null
                ] : null, e), s.props.selectsRange ? s.props.onChange([
                    null,
                    null
                ], e) : s.props.onChange(null, e), s.setState({
                    inputValue: null
                });
            }, s.clear = function() {
                s.onClearClick();
            }, s.onScroll = function(e) {
                "boolean" == typeof s.props.closeOnScroll && s.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || s.setOpen(!1) : "function" == typeof s.props.closeOnScroll && s.props.closeOnScroll(e) && s.setOpen(!1);
            }, s.renderCalendar = function() {
                var e, t;
                return s.props.inline || s.isCalendarOpen() ? ue.default.createElement(er, ge({
                    ref: function(e) {
                        s.calendar = e;
                    }
                }, s.props, s.state, {
                    setOpen: s.setOpen,
                    dateFormat: null !== (e = s.props.dateFormatCalendar) && void 0 !== e ? e : n.defaultProps.dateFormatCalendar,
                    onSelect: s.handleSelect,
                    onClickOutside: s.handleCalendarClickOutside,
                    holidays: ut(s.modifyHolidays()),
                    outsideClickIgnoreClass: Zt,
                    onDropdownFocus: s.handleDropdownFocus,
                    onTimeChange: s.handleTimeChange,
                    className: s.props.calendarClassName,
                    container: s.props.calendarContainer,
                    handleOnKeyDown: s.props.onKeyDown,
                    handleOnDayKeyDown: s.onDayKeyDown,
                    setPreSelection: s.setPreSelection,
                    dropdownMode: null !== (t = s.props.dropdownMode) && void 0 !== t ? t : n.defaultProps.dropdownMode
                }), s.props.children) : null;
            }, s.renderAriaLiveRegion = function() {
                var e, t = s.props, r = t.dateFormat, a = void 0 === r ? n.defaultProps.dateFormat : r, o = t.locale, i = s.props.showTimeInput || s.props.showTimeSelect ? "PPPPp" : "PPPP";
                return e = s.props.selectsRange ? "Selected start date: ".concat(Ee(s.props.startDate, {
                    dateFormat: i,
                    locale: o
                }), ". ").concat(s.props.endDate ? "End date: " + Ee(s.props.endDate, {
                    dateFormat: i,
                    locale: o
                }) : "") : s.props.showTimeSelectOnly ? "Selected time: ".concat(Ee(s.props.selected, {
                    dateFormat: a,
                    locale: o
                })) : s.props.showYearPicker ? "Selected year: ".concat(Ee(s.props.selected, {
                    dateFormat: "yyyy",
                    locale: o
                })) : s.props.showMonthYearPicker ? "Selected month: ".concat(Ee(s.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: o
                })) : s.props.showQuarterYearPicker ? "Selected quarter: ".concat(Ee(s.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: o
                })) : "Selected date: ".concat(Ee(s.props.selected, {
                    dateFormat: i,
                    locale: o
                })), ue.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, e);
            }, s.renderDateInput = function() {
                var e, a, o, i = t.clsx(s.props.className, ((e = {})[Zt] = s.state.open, e)), l = s.props.customInput || ue.default.createElement("input", {
                    type: "text"
                }), c = s.props.customInputRef || "ref", p = s.props, d = p.dateFormat, u = void 0 === d ? n.defaultProps.dateFormat : d, f = p.locale, h = "string" == typeof s.props.value ? s.props.value : "string" == typeof s.state.inputValue ? s.state.inputValue : s.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var n = Ee(e, r), a = t ? Ee(t, r) : "";
                    return "".concat(n, " - ").concat(a);
                }(s.props.startDate, s.props.endDate, {
                    dateFormat: u,
                    locale: f
                }) : s.props.selectsMultiple ? function(e, t) {
                    if (!(null == e ? void 0 : e.length)) return "";
                    var r = e[0] ? Ee(e[0], t) : "";
                    if (1 === e.length) return r;
                    if (2 === e.length && e[1]) {
                        var n = Ee(e[1], t);
                        return "".concat(r, ", ").concat(n);
                    }
                    var a = e.length - 1;
                    return "".concat(r, " (+").concat(a, ")");
                }(null !== (o = s.props.selectedDates) && void 0 !== o ? o : [], {
                    dateFormat: u,
                    locale: f
                }) : Ee(s.props.selected, {
                    dateFormat: u,
                    locale: f
                });
                return r.cloneElement(l, ((a = {})[c] = function(e) {
                    s.input = e;
                }, a.value = h, a.onBlur = s.handleBlur, a.onChange = s.handleChange, a.onClick = s.onInputClick, a.onFocus = s.handleFocus, a.onKeyDown = s.onInputKeyDown, a.id = s.props.id, a.name = s.props.name, a.form = s.props.form, a.autoFocus = s.props.autoFocus, a.placeholder = s.props.placeholderText, a.disabled = s.props.disabled, a.autoComplete = s.props.autoComplete, a.className = t.clsx(l.props.className, i), a.title = s.props.title, a.readOnly = s.props.readOnly, a.required = s.props.required, a.tabIndex = s.props.tabIndex, a["aria-describedby"] = s.props.ariaDescribedBy, a["aria-invalid"] = s.props.ariaInvalid, a["aria-labelledby"] = s.props.ariaLabelledBy, a["aria-required"] = s.props.ariaRequired, a));
            }, s.renderClearButton = function() {
                var e = s.props, r = e.isClearable, n = e.disabled, a = e.selected, o = e.startDate, i = e.endDate, l = e.clearButtonTitle, c = e.clearButtonClassName, p = void 0 === c ? "" : c, d = e.ariaLabelClose, u = void 0 === d ? "Close" : d, f = e.selectedDates;
                return r && (null != a || null != o || null != i || (null == f ? void 0 : f.length)) ? ue.default.createElement("button", {
                    type: "button",
                    className: t.clsx("react-datepicker__close-icon", p, {
                        "react-datepicker__close-icon--disabled": n
                    }),
                    disabled: n,
                    "aria-label": u,
                    onClick: s.onClearClick,
                    title: l,
                    tabIndex: -1
                }) : null;
            }, s.state = s.calcInitialState(), s.preventFocusTimeout = void 0, s;
        }
        return ve(n, e), Object.defineProperty(n, "defaultProps", {
            get: function() {
                return {
                    allowSameDay: !1,
                    dateFormat: "MM/dd/yyyy",
                    dateFormatCalendar: "LLLL yyyy",
                    onChange: function() {},
                    disabled: !1,
                    disabledKeyboardNavigation: !1,
                    dropdownMode: "scroll",
                    onFocus: function() {},
                    onBlur: function() {},
                    onKeyDown: function() {},
                    onInputClick: function() {},
                    onSelect: function() {},
                    onClickOutside: function() {},
                    onMonthChange: function() {},
                    onCalendarOpen: function() {},
                    onCalendarClose: function() {},
                    preventOpenOnFocus: !1,
                    onYearChange: function() {},
                    onInputError: function() {},
                    monthsShown: 1,
                    readOnly: !1,
                    withPortal: !1,
                    selectsDisabledDaysInRange: !1,
                    shouldCloseOnSelect: !0,
                    showTimeSelect: !1,
                    showTimeInput: !1,
                    showPreviousMonths: !1,
                    showMonthYearPicker: !1,
                    showFullMonthYearPicker: !1,
                    showTwoColumnMonthYearPicker: !1,
                    showFourColumnMonthYearPicker: !1,
                    showYearPicker: !1,
                    showQuarterYearPicker: !1,
                    showWeekPicker: !1,
                    strictParsing: !1,
                    swapRange: !1,
                    timeIntervals: 30,
                    timeCaption: "Time",
                    previousMonthAriaLabel: "Previous Month",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthAriaLabel: "Next Month",
                    nextMonthButtonLabel: "Next Month",
                    previousYearAriaLabel: "Previous Year",
                    previousYearButtonLabel: "Previous Year",
                    nextYearAriaLabel: "Next Year",
                    nextYearButtonLabel: "Next Year",
                    timeInputLabel: "Time",
                    enableTabLoop: !0,
                    yearItemNumber: Se,
                    focusSelectedMonth: !1,
                    showPopperArrow: !0,
                    excludeScrollbar: !0,
                    customTimeInput: null,
                    calendarStartDay: void 0,
                    toggleCalendarOnIconClick: !1,
                    usePointerEvent: !1
                };
            },
            enumerable: !1,
            configurable: !0
        }), n.prototype.componentDidMount = function() {
            window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
        }, n.prototype.componentDidUpdate = function(e, t) {
            var r, n, a, o, s, i;
            e.inline && (s = e.selected, i = this.props.selected, s && i ? C.getMonth(s) !== C.getMonth(i) || x.getYear(s) !== x.getYear(i) : s !== i) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                monthSelectedIn: 0
            }), e.highlightDates !== this.props.highlightDates && this.setState({
                highlightDates: dt(this.props.highlightDates)
            }), t.focused || We(e.selected, this.props.selected) || this.setState({
                inputValue: null
            }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && (null === (n = (r = this.props).onCalendarOpen) || void 0 === n || n.call(r)), !0 === t.open && !1 === this.state.open && (null === (o = (a = this.props).onCalendarClose) || void 0 === o || o.call(a)));
        }, n.prototype.componentWillUnmount = function() {
            this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
        }, n.prototype.renderInputContainer = function() {
            var e = this.props, r = e.showIcon, n = e.icon, a = e.calendarIconClassname, o = e.calendarIconClassName, s = e.toggleCalendarOnIconClick, i = this.state.open;
            return a && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), ue.default.createElement("div", {
                className: "react-datepicker__input-container".concat(r ? " react-datepicker__view-calendar-icon" : "")
            }, r && ue.default.createElement(jt, ge({
                icon: n,
                className: t.clsx(o, !o && a, i && "react-datepicker-ignore-onclickoutside")
            }, s ? {
                onClick: this.toggleCalendar
            } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
        }, n.prototype.render = function() {
            var e = this.renderCalendar();
            if (this.props.inline) return e;
            if (this.props.withPortal) {
                var t = this.state.open ? ue.default.createElement(zt, {
                    enableTabLoop: this.props.enableTabLoop
                }, ue.default.createElement("div", {
                    className: "react-datepicker__portal",
                    tabIndex: -1,
                    onKeyDown: this.onPortalKeyDown
                }, e)) : null;
                return this.state.open && this.props.portalId && (t = ue.default.createElement(Ut, ge({
                    portalId: this.props.portalId
                }, this.props), t)), ue.default.createElement("div", null, this.renderInputContainer(), t);
            }
            return ue.default.createElement(Jt, ge({}, this.props, {
                className: this.props.popperClassName,
                hidePopper: !this.isCalendarOpen(),
                targetComponent: this.renderInputContainer(),
                popperComponent: e,
                popperOnKeyDown: this.onPopperKeyDown,
                showArrow: this.props.showPopperArrow
            }));
        }, n;
    }(r.Component), nr = "input", ar = "navigate";
    e.CalendarContainer = ke, e.default = rr, e.getDefaultLocale = qe, e.registerLocale = function(e, t) {
        var r = we();
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        we().__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});



const $f96e2303f33af170$var$AUTH_ENDPOINT = "https://mn28cogtk2.execute-api.us-east-1.amazonaws.com/dev/";
const $f96e2303f33af170$var$SubTaskDialog = ({ project: project , taskId: taskId  })=>{
    // const AuthDialog = () => {
    const [subTask, setSubTask] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [showDatepicker, setShowDatepicker] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [intervalType, setIntervalType] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("REGULAR");
    const { tasks: tasks , setTasks: setTasks , setSubTasks: setSubTasks  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    const [startDate, setStartDate] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState((0, $3145b66931dcae2b$exports.setHours)((0, $3145b66931dcae2b$exports.setMinutes)(new Date(), 59), 23));
    const [estimatedTime, setEstimatedTime] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const handleClose = ()=>{
        setSubTask("");
        setShowDatepicker(false);
        setStartDate((0, $3145b66931dcae2b$exports.setHours)((0, $3145b66931dcae2b$exports.setMinutes)(new Date(), 59), 23));
        setEstimatedTime("");
    };
    const { token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const createSubTask = async ()=>{
        const URL = $f96e2303f33af170$var$AUTH_ENDPOINT + `subtask`;
        const column = (0, $f6745ab07405201d$export$f3602613885b0b7b)(project, tasks);
        const task = (0, $f6745ab07405201d$export$7a1b6d9817951cb)(taskId, tasks);
        const subTaskUlid = (0, $3fceb5e73707524c$export$c34778236461ea95)();
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const formattedStartDate = (0, $3145b66931dcae2b$exports.formatISO)(startDate);
        const BODY = JSON.stringify({
            content: subTask,
            taskId: taskId,
            // project: project,
            id: subTaskUlid,
            ...showDatepicker && {
                deadline: startDate
            },
            ...estimatedTime && {
                estimatedTime: parseInt(estimatedTime, 10)
            }
        });
        const request = new Request(URL, {
            method: "POST",
            headers: HEADERS,
            body: BODY,
            timeout: 100000
        });
        const result = fetch(request);
        setSubTasks((oldSubTasks)=>{
            const newSubTask = {
                id: subTaskUlid,
                content: subTask,
                task: task,
                status: "INCOMPLETE"
            };
            const newData = {
                ...oldSubTasks,
                [subTaskUlid]: newSubTask
            };
            return newData;
        });
        setTasks((oldTasks)=>{
            const newSubTasks = [
                ...task.subtasks,
                subTaskUlid
            ];
            const newTask = {
                id: taskId,
                content: task.content,
                project: project,
                status: "INCOMPLETE",
                subtasks: newSubTasks
            };
            const allTasks = {
                ...oldTasks.tasks,
                [taskId]: newTask
            };
            const oldColumn = (0, $f6745ab07405201d$export$f3602613885b0b7b)(project, oldTasks);
            const oldColumnId = column["id"];
            const newData = {
                ...oldTasks,
                tasks: allTasks,
                ...tasks.columns
            };
            return newData;
        });
        setSubTask("");
    };
    function handleAddAttempt() {
        createSubTask();
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9, {
        onOpenChange: handleClose,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                    className: "SubTaskButton violet",
                    children: $f96e2303f33af170$var$plusIcon
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$602eac185826482c, {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$c6fdb837b070b4ff, {
                        className: "SubTaskDialogOverlay"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2, {
                        className: "SubTaskDialogContent",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$f99233281efd08a0, {
                                className: "SubTaskDialogTitle",
                                children: "Add SubTask"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "SubTaskFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "SubTaskLabel",
                                        htmlFor: "task",
                                        children: "SubTask"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                        value: subTask,
                                        onChange: (e)=>setSubTask(e.target.value),
                                        className: "SubTaskInput",
                                        id: "subtask"
                                    })
                                ]
                            }),
                            !showDatepicker && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "SubTaskFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "SubTaskLabel",
                                        htmlFor: "addDeadline",
                                        children: "+ Deadline"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: "addDeadline",
                                        className: "CheckboxInput",
                                        checked: showDatepicker,
                                        onChange: ()=>setShowDatepicker(!showDatepicker)
                                    })
                                ]
                            }),
                            showDatepicker && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "SubTaskFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "SubTaskLabel",
                                        htmlFor: "deadline",
                                        children: "Deadline"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0fb815a476526754$exports))), {
                                        selected: startDate,
                                        onChange: (date)=>setStartDate(date),
                                        showTimeSelect: true,
                                        timeIntervals: 5,
                                        dateFormat: "MMMM d, yyyy h:mm aa",
                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                            style: {
                                                width: "24px",
                                                height: "24px",
                                                backgroundColor: "red"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                        onClick: ()=>setShowDatepicker(false),
                                        className: "CloseButton",
                                        children: $f96e2303f33af170$var$closeIcon
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "SubTaskFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "SubTaskLabel",
                                        htmlFor: "estimatedTime",
                                        children: "Est. Time"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                        type: "text",
                                        value: estimatedTime,
                                        onChange: (e)=>setEstimatedTime(e.target.value),
                                        className: "SubTaskInput",
                                        id: "estimatedTime",
                                        style: {
                                            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="lucide lucide-m"><text x="0" y="20" font-family="Arial" font-size="20">m</text></svg>')`,
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "right center",
                                            paddingRight: "30px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    marginTop: 25,
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$f39c2d165cd861fe, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                        onClick: handleAddAttempt,
                                        className: "SubTaskButton green",
                                        children: "Submit"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$f39c2d165cd861fe, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                    className: "SubTaskIconButton",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c12e32cf04d921d4$export$b7fa469a3cb3cd4f), {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $f96e2303f33af170$export$2e2bcd8739ae039 = $f96e2303f33af170$var$SubTaskDialog;
const $f96e2303f33af170$var$closeIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-circle-x",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "10"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m15 9-6 6"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m9 9 6 6"
        })
    ]
});
const $f96e2303f33af170$var$plusIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
        transform: "translateY(3px)",
        marginRight: "5px"
    },
    className: "lucide lucide-circle-plus",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
            cx: "10",
            cy: "10",
            r: "8.34"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M6.66 10h6.675"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M10 6.66v6.675"
        })
    ]
});






var $exYeM = parcelRequire("exYeM");




const $085fa8fd22a3403c$var$AUTH_ENDPOINT = "https://mn28cogtk2.execute-api.us-east-1.amazonaws.com/dev/";
function $085fa8fd22a3403c$var$SubTask({ subTaskId: subTaskId , taskId: taskId  }) {
    const { subTasks: subTasks , setSubTasks: setSubTasks , setTasks: setTasks , tasks: tasks , deleteSubTask: deleteSubTask  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    const { token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const subTask = subTasks[subTaskId];
    const isComplete = subTask.status === "COMPLETE";
    const handleDelete = (item)=>{
        setTasks((oldTasks)=>{
            // const column = getColumnByProjectTitle(item.project, oldTasks);
            const task = (0, $f6745ab07405201d$export$7a1b6d9817951cb)(taskId, oldTasks);
            const newSubTasks = task.subtasks.filter((subtask)=>subtask !== item.id);
            const newTask = {
                ...task,
                subtasks: newSubTasks
            };
            const updatedTasks = {
                ...oldTasks.tasks,
                [taskId]: {
                    ...newTask
                }
            };
            const newData = {
                ...oldTasks,
                tasks: updatedTasks,
                columns: {
                    ...tasks.columns
                }
            };
            return newData;
        });
        deleteSubTask(item.id, taskId);
    };
    const updateSubTask = async (item, taskId, token)=>{
        const itemData = {
            ...item
        };
        if (item.status === "COMPLETE") itemData["completed_time"] = (0, $f6745ab07405201d$export$f793410d809938cd)();
        const URL = $085fa8fd22a3403c$var$AUTH_ENDPOINT + `subtask`;
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const BODY = JSON.stringify(itemData);
        const request = new Request(URL, {
            method: "PUT",
            headers: HEADERS,
            body: BODY,
            timeout: 100000
        });
        fetch(request);
    };
    const handleComplete = (item, taskId)=>{
        console.log("handling complete!");
        setSubTasks((oldTasks)=>{
            const currentStatus = oldTasks[item.id].status;
            var newStatus = currentStatus === "COMPLETE" ? "INCOMPLETE" : "COMPLETE";
            const newItem = oldTasks[item.id];
            newItem.status = newStatus;
            const updatedTasks = {
                ...oldTasks,
                [item.id]: newItem
            };
            updateSubTask(newItem, taskId, token);
            // Grab task (or pass in as arg, maybe the latter)
            // Iterate through subtasks
            // Find index of first subtask
            // set new subtask order
            // const taskIds = oldTasks.columns[columnId].taskIds;
            // if (newStatus === 'COMPLETE') {
            //   const firstCompleteIndex = taskIds.findIndex(
            //     (taskId) =>
            //       taskId !== item.id && updatedTasks[taskId].status === 'COMPLETE'
            //   );
            //   const currentIndex = taskIds.indexOf(item.id);
            //   if (firstCompleteIndex === -1) {
            //     taskIds.splice(currentIndex, 1);
            //     taskIds.push(item.id);
            //   } else if (currentIndex < firstCompleteIndex) {
            //     taskIds.splice(currentIndex, 1);
            //     taskIds.splice(firstCompleteIndex - 1, 0, item.id);
            //   }
            //   updateOrder(item.project, taskIds, token);
            // }
            return updatedTasks;
        });
    //updateSubTask(newItem, token);
    // const column = getColumnByProjectTitle(item.project, oldTasks);
    // const columnId = column['id'];
    // const taskIds = oldTasks.columns[columnId].taskIds;
    // if (newStatus === 'COMPLETE') {
    //   const firstCompleteIndex = taskIds.findIndex(
    //     (taskId) =>
    //       taskId !== item.id && updatedTasks[taskId].status === 'COMPLETE'
    //   );
    //   const currentIndex = taskIds.indexOf(item.id);
    //   if (firstCompleteIndex === -1) {
    //     taskIds.splice(currentIndex, 1);
    //     taskIds.push(item.id);
    //   } else if (currentIndex < firstCompleteIndex) {
    //     taskIds.splice(currentIndex, 1);
    //     taskIds.splice(firstCompleteIndex - 1, 0, item.id);
    //   }
    //   updateOrder(item.project, taskIds, token);
    // }
    // return {
    //   tasks: updatedTasks,
    //   columns: {
    //     ...oldTasks.columns,
    //     [columnId]: {
    //       ...oldTasks.columns[columnId],
    //       taskIds: taskIds,
    //     },
    //   },
    //   columnOrder: oldTasks.columnOrder,
    // };
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($085fa8fd22a3403c$var$Container, {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                style: {
                    width: "20px",
                    height: "20px",
                    display: "inline-block",
                    marginRight: "5px",
                    cursor: "pointer"
                },
                onClick: ()=>handleComplete(subTask, taskId),
                children: isComplete ? $085fa8fd22a3403c$var$dollarIcon : $085fa8fd22a3403c$var$boxIcon
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                style: {
                    width: "20px",
                    height: "20px",
                    display: "inline-block",
                    marginRight: "5px",
                    cursor: "pointer"
                },
                onClick: ()=>handleComplete(subTask),
                children: $085fa8fd22a3403c$var$upArrow
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                style: {
                    width: "20px",
                    height: "20px",
                    display: "inline-block",
                    marginRight: "5px",
                    cursor: "pointer"
                },
                onClick: ()=>handleDelete(subTask),
                children: $085fa8fd22a3403c$var$trashcanIcon
            }),
            subTask.content
        ]
    });
}
const $085fa8fd22a3403c$var$Container = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  border: 1px solid lightgrey;
  padding: 8px;
  margin-bottom: 8px;
  border-radius: 12px;
  background-color: #f6f8f6;
  color: #464646;
  /* padding: 5px; */
`;
const $085fa8fd22a3403c$var$trashcanIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-trash-2",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M3 6h18"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("line", {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("line", {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17"
        })
    ]
});
const $085fa8fd22a3403c$var$dollarIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-check",
    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
        d: "M20 6 9 17l-5-5"
    })
});
const $085fa8fd22a3403c$var$boxIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-box-select",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M5 3a2 2 0 0 0-2 2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M19 3a2 2 0 0 1 2 2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M21 19a2 2 0 0 1-2 2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M5 21a2 2 0 0 1-2-2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M9 3h1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M9 21h1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M14 3h1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M14 21h1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M3 9v1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M21 9v1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M3 14v1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M21 14v1"
        })
    ]
});
const $085fa8fd22a3403c$var$upArrow = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-square-arrow-up",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m16 12-4-4-4 4"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M12 16V8"
        })
    ]
});
var $085fa8fd22a3403c$export$2e2bcd8739ae039 = $085fa8fd22a3403c$var$SubTask;





parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
function $db3c6c8b218bd178$export$2e2bcd8739ae039(deadline) {
    const [countdown, setCountdown] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const targetDate = new Date(deadline);
        const intervalId = window.setInterval(()=>{
            const now = new Date();
            const timeLeft = targetDate - now;
            if (timeLeft <= 0) {
                setCountdown(0);
                window.clearInterval(intervalId);
            } else setCountdown(timeLeft);
        }, 67);
        return ()=>{
            window.clearInterval(intervalId);
        };
    }, [
        deadline
    ]);
    return [
        countdown
    ];
}


const $0197b383b8cced23$var$ONE_HOUR_SECONDS = 3600;
const $0197b383b8cced23$var$ONE_SECOND_MILLIS = 1000;
function $0197b383b8cced23$var$formatTimeLeft(timeLeft) {
    const days = Math.floor(timeLeft / 86400000);
    const hours = String(Math.floor(timeLeft / 3600000 % 24)).padStart(2, "0");
    const minutes = String(Math.floor(timeLeft / 60000 % 60)).padStart(2, "0");
    const seconds = String(Math.floor(timeLeft / 1000 % 60)).padStart(2, "0");
    const hundredths = String(Math.floor(timeLeft % 1000 / 10)).padStart(2, "0");
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0197b383b8cced23$var$Number, {
                children: days
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0197b383b8cced23$var$Unit, {
                children: "d:"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0197b383b8cced23$var$Number, {
                children: hours
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0197b383b8cced23$var$Unit, {
                children: "h:"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0197b383b8cced23$var$Number, {
                children: minutes
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0197b383b8cced23$var$Unit, {
                children: "m:"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0197b383b8cced23$var$Number, {
                children: seconds
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0197b383b8cced23$var$Unit, {
                children: "s:"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($0197b383b8cced23$var$Number, {
                children: hundredths
            })
        ]
    });
}
function $0197b383b8cced23$var$Countdown({ deadline: deadline  }) {
    const [countdown] = (0, $db3c6c8b218bd178$export$2e2bcd8739ae039)(deadline);
    const timeLeft = $0197b383b8cced23$var$formatTimeLeft(countdown);
    var fontColor = "white";
    if (countdown < $0197b383b8cced23$var$ONE_HOUR_SECONDS * 12 * $0197b383b8cced23$var$ONE_SECOND_MILLIS) fontColor = "yellow";
    if (countdown < $0197b383b8cced23$var$ONE_HOUR_SECONDS * 2 * $0197b383b8cced23$var$ONE_SECOND_MILLIS) fontColor = "red";
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                style: {
                    minWidth: "10px",
                    display: "inline-block"
                }
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                style: {
                    backgroundColor: "black",
                    padding: "2px"
                },
                children: timeLeft
            })
        ]
    });
}
const $0197b383b8cced23$var$Number = (0, $93948c98236af5c1$export$2e2bcd8739ae039).span`
  color: yellow;
  /* color: hsl(100, 50%, 50%); */
`;
const $0197b383b8cced23$var$Unit = (0, $93948c98236af5c1$export$2e2bcd8739ae039).span`
  color: white;
`;
var $0197b383b8cced23$export$2e2bcd8739ae039 = $0197b383b8cced23$var$Countdown;




function $d7dad46e028b4719$var$Task({ task: task , index: index  }) {
    const { setTasks: setTasks , deleteTask: deleteTask , tasks: tasks  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    const [habitRating, setHabitRating] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(parseInt(task.habit_rating) + 1);
    const { token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const isComplete = task.status === "COMPLETE";
    const textColor = isComplete ? "#a0a0a0" : "#f0f0f0";
    const textDecoration = isComplete ? "line-through" : "none";
    const hasDeadline = task.deadline !== undefined && task.deadline !== null;
    const isHabit = task.project !== undefined && task.project !== null && task.project === "habits";
    const provideHabitRating = (rating, item)=>{
        setHabitRating(rating);
        handleComplete(item, rating);
    };
    const handleDelete = (item)=>{
        setTasks((oldTasks)=>{
            const column = (0, $f6745ab07405201d$export$f3602613885b0b7b)(item.project, oldTasks);
            const columnId = column["id"];
            delete tasks[item.id];
            const updatedTaskIds = oldTasks.columns[columnId].taskIds.filter((taskId)=>taskId !== item.id);
            const newColumn = {
                ...column,
                taskIds: updatedTaskIds
            };
            const newData = {
                ...tasks,
                columns: {
                    ...tasks.columns,
                    [newColumn.id]: newColumn
                }
            };
            return newData;
        });
        deleteTask(item.id);
    };
    const handleComplete = (item, rating = null)=>{
        setTasks((oldTasks)=>{
            const updatedTasks = {
                ...oldTasks.tasks
            };
            const currentStatus = updatedTasks[item.id].status;
            var newStatus = currentStatus === "COMPLETE" ? "INCOMPLETE" : "COMPLETE";
            if (rating) newStatus = "COMPLETE";
            updatedTasks[item.id].status = newStatus;
            if (item.project === "habits") updatedTasks[item.id].habit_rating = rating;
            const newItem = updatedTasks[item.id];
            (0, $f6745ab07405201d$export$e8e0154b7bb02be4)(newItem, token);
            const column = (0, $f6745ab07405201d$export$f3602613885b0b7b)(item.project, oldTasks);
            const columnId = column["id"];
            const taskIds = oldTasks.columns[columnId].taskIds;
            if (newStatus === "COMPLETE") {
                const firstCompleteIndex = taskIds.findIndex((taskId)=>taskId !== item.id && updatedTasks[taskId].status === "COMPLETE");
                const currentIndex = taskIds.indexOf(item.id);
                if (firstCompleteIndex === -1) {
                    taskIds.splice(currentIndex, 1);
                    taskIds.push(item.id);
                } else if (currentIndex < firstCompleteIndex) {
                    taskIds.splice(currentIndex, 1);
                    taskIds.splice(firstCompleteIndex - 1, 0, item.id);
                }
                (0, $f6745ab07405201d$export$53e589c0d6eae463)(item.project, taskIds, token);
            }
            return {
                tasks: updatedTasks,
                columns: {
                    ...oldTasks.columns,
                    [columnId]: {
                        ...oldTasks.columns[columnId],
                        taskIds: taskIds
                    }
                },
                columnOrder: oldTasks.columnOrder
            };
        });
    };
    const handleMoveToTop = (item)=>{
        setTasks((oldTasks)=>{
            const updatedTasks = {
                ...oldTasks.tasks
            };
            const column = (0, $f6745ab07405201d$export$f3602613885b0b7b)(item.project, oldTasks);
            const columnId = column["id"];
            const taskIds = oldTasks.columns[columnId].taskIds;
            const currentIndex = taskIds.indexOf(item.id);
            if (currentIndex > 0) {
                taskIds.splice(currentIndex, 1);
                taskIds.unshift(item.id);
                (0, $f6745ab07405201d$export$53e589c0d6eae463)(item.project, taskIds, token);
            }
            return {
                tasks: updatedTasks,
                columns: {
                    ...oldTasks.columns,
                    [columnId]: {
                        ...oldTasks.columns[columnId],
                        taskIds: taskIds
                    }
                },
                columnOrder: oldTasks.columnOrder
            };
        });
    };
    const renderContentWithLinks = (content)=>{
        if (!content) return null;
        const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]|\bwww\.\S+\.\S+)/gi;
        return content.split(urlRegex).filter(Boolean).map((part, index)=>{
            if (urlRegex.test(part)) {
                const url = part.startsWith("http") ? part : `http://${part}`;
                const displayText = part.length > 45 ? `${part.slice(0, 42)}...` : part;
                const finalDisplayText = displayText.replace(/^(https?:\/\/)?(www\.)?/, "");
                return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d7dad46e028b4719$var$StyledLink, {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: finalDisplayText
                }, index);
            }
            return part === "https" ? "" : part;
        });
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c19d47723720dd4a$export$f2a139e5d18b9882), {
        draggableId: task.id,
        index: index,
        children: (provided)=>{
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d7dad46e028b4719$var$Container, {
                ...provided.draggableProps,
                ref: provided.innerRef,
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        ...provided.dragHandleProps,
                        style: {
                            width: "20px",
                            height: "20px",
                            display: "inline-block",
                            marginRight: "5px"
                        },
                        children: $d7dad46e028b4719$var$moveableIcon
                    }),
                    !isHabit && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        style: {
                            width: "20px",
                            height: "20px",
                            display: "inline-block",
                            marginRight: "5px",
                            cursor: "pointer"
                        },
                        onClick: ()=>handleComplete(task),
                        children: isComplete ? $d7dad46e028b4719$var$dollarIcon : $d7dad46e028b4719$var$boxIcon
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        style: {
                            width: "20px",
                            height: "20px",
                            display: "inline-block",
                            marginRight: "5px",
                            cursor: "pointer"
                        },
                        onClick: ()=>handleMoveToTop(task),
                        children: $d7dad46e028b4719$var$upArrow
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        style: {
                            width: "20px",
                            height: "20px",
                            display: "inline-block",
                            marginRight: "5px",
                            cursor: "pointer"
                        },
                        onClick: ()=>handleDelete(task),
                        children: $d7dad46e028b4719$var$trashcanIcon
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $f96e2303f33af170$export$2e2bcd8739ae039), {
                            project: task.project,
                            taskId: task.id
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        style: {
                            color: textColor,
                            textDecoration: textDecoration,
                            fontWeight: "400",
                            fontFamily: "Poppins, sans-serif"
                        },
                        children: renderContentWithLinks(task.content)
                    }),
                    isHabit && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d7dad46e028b4719$var$HabitRatingContainer, {
                        children: [
                            1,
                            2,
                            3,
                            4,
                            5
                        ].map((num)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d7dad46e028b4719$var$HabitRatingButton, {
                                onClick: ()=>provideHabitRating(num, task),
                                active: habitRating >= num,
                                children: num
                            }, num))
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        children: hasDeadline && !isHabit && !isComplete ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $0197b383b8cced23$export$2e2bcd8739ae039), {
                            deadline: task.deadline
                        }) : ""
                    }),
                    task.subtasks.length > 0 && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        style: {
                            paddingTop: "10px"
                        },
                        children: task.subtasks.map((subTaskId)=>{
                            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $085fa8fd22a3403c$export$2e2bcd8739ae039), {
                                taskId: task.id,
                                subTaskId: subTaskId
                            }, subTaskId);
                        })
                    })
                ]
            });
        }
    });
}
const $d7dad46e028b4719$var$StyledLink = (0, $93948c98236af5c1$export$2e2bcd8739ae039).a`
  color: #ffea28;
  &:visited {
    color: #ffea28;
  }
`;
const $d7dad46e028b4719$var$Container = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  border: 1px solid lightgrey;
  padding: 8px;
  margin-bottom: 8px;
  border-radius: 12px;
  background-color: #5061ff;
  /* padding: 5px; */
`;
const $d7dad46e028b4719$var$trashcanIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-trash-2",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M3 6h18"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("line", {
            x1: "10",
            x2: "10",
            y1: "11",
            y2: "17"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("line", {
            x1: "14",
            x2: "14",
            y1: "11",
            y2: "17"
        })
    ]
});
const $d7dad46e028b4719$var$moveableIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    flexgrow: "2",
    className: "lucide lucide-align-justify",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("line", {
            x1: "3",
            x2: "21",
            y1: "6",
            y2: "6"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("line", {
            x1: "3",
            x2: "21",
            y1: "12",
            y2: "12"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("line", {
            x1: "3",
            x2: "21",
            y1: "18",
            y2: "18"
        })
    ]
});
// const dollarIcon = (
//   <svg
//     xmlns='http://www.w3.org/2000/svg'
//     width='24'
//     height='24'
//     viewBox='0 0 24 24'
//     fill='none'
//     // stroke='currentColor'
//     stroke='hsl(120, 50%, 25%)'
//     strokeWidth='2'
//     strokeLinecap='round'
//     strokeLinejoin='round'
//     className='lucide lucide-badge-dollar-sign'
//   >
//     <path d='M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z' />
//     <path d='M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8' />
//     <path d='M12 18V6' />
//   </svg>
// );
const $d7dad46e028b4719$var$dollarIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-check",
    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
        d: "M20 6 9 17l-5-5"
    })
});
const $d7dad46e028b4719$var$boxIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-box-select",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M5 3a2 2 0 0 0-2 2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M19 3a2 2 0 0 1 2 2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M21 19a2 2 0 0 1-2 2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M5 21a2 2 0 0 1-2-2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M9 3h1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M9 21h1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M14 3h1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M14 21h1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M3 9v1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M21 9v1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M3 14v1"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M21 14v1"
        })
    ]
});
const $d7dad46e028b4719$var$upArrow = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-square-arrow-up",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("rect", {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m16 12-4-4-4 4"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M12 16V8"
        })
    ]
});
var $d7dad46e028b4719$export$2e2bcd8739ae039 = $d7dad46e028b4719$var$Task;
const $d7dad46e028b4719$var$HabitRatingButton = (0, $93948c98236af5c1$export$2e2bcd8739ae039).span`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 2px solid black;
  margin-right: 0.5rem;
  background-color: ${(props)=>props.active ? "#007EE5" : "F8F9FA"};
  color: ${(props)=>props.active ? "white" : "black"};

  /* Centering the text */
  display: inline-block; /* Makes it an inline element with block-like properties */
  text-align: center; /* Centers the text horizontally */
  line-height: 2rem; /* Vertically centers the text */
  cursor: pointer;
`;
const $d7dad46e028b4719$var$HabitRatingContainer = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  margin-left: 55px;
  margin-top: 7px;
`; // const HabitRatingButton = styled.button`
 //   width: 2rem;
 //   height: 2rem;
 //   border-radius: 50%;
 //   margin-right: 0.5rem;
 //   background-color: ${(props) => (props.active ? 'blue' : 'gray')};
 //   color: ${(props) => (props.active ? 'white' : 'black')};
 //   display: flex;
 //   align-items: center;
 //   justify-content: center;
 // `;









var $exYeM = parcelRequire("exYeM");










const $146efb2f8550c44a$var$AUTH_ENDPOINT = "https://mn28cogtk2.execute-api.us-east-1.amazonaws.com/dev/";
const $146efb2f8550c44a$var$TaskDialog = ({ project: project  })=>{
    // const AuthDialog = () => {
    const [task, setTask] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [showDatepicker, setShowDatepicker] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [showRecurring, setShowRecurring] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [intervalType, setIntervalType] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("REGULAR");
    const { tasks: tasks , setTasks: setTasks  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    const [startDate, setStartDate] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState((0, $3145b66931dcae2b$exports.setHours)((0, $3145b66931dcae2b$exports.setMinutes)(new Date(), 59), 23));
    const [estimatedTime, setEstimatedTime] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const handleClose = ()=>{
        setTask("");
        setShowDatepicker(false);
        setShowRecurring(false);
        setStartDate((0, $3145b66931dcae2b$exports.setHours)((0, $3145b66931dcae2b$exports.setMinutes)(new Date(), 59), 23));
        setEstimatedTime("");
    };
    const { token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const createTask = async ()=>{
        const URL = $146efb2f8550c44a$var$AUTH_ENDPOINT + `task`;
        const column = (0, $f6745ab07405201d$export$f3602613885b0b7b)(project, tasks);
        const taskUlid = (0, $3fceb5e73707524c$export$c34778236461ea95)();
        const HEADERS = {
            "Content-Type": "application/json",
            Authorization: token
        };
        const formattedStartDate = (0, $3145b66931dcae2b$exports.formatISO)(startDate);
        const BODY = JSON.stringify({
            project: project,
            content: task,
            id: taskUlid,
            ...showDatepicker && {
                deadline: startDate
            },
            ...estimatedTime && {
                estimatedTime: parseInt(estimatedTime, 10)
            }
        });
        const request = new Request(URL, {
            method: "POST",
            headers: HEADERS,
            body: BODY,
            timeout: 100000
        });
        const result = fetch(request);
        setTasks((oldTasks)=>{
            const newTask = {
                id: taskUlid,
                content: task,
                project: project,
                status: "INCOMPLETE",
                subtasks: []
            };
            const allTasks = {
                ...oldTasks.tasks,
                [taskUlid]: newTask
            };
            const oldColumn = (0, $f6745ab07405201d$export$f3602613885b0b7b)(project, oldTasks);
            const oldColumnId = column["id"];
            const updatedTaskIds = [
                taskUlid,
                ...oldTasks.columns[oldColumnId].taskIds
            ];
            const newColumn = {
                ...oldColumn,
                taskIds: updatedTaskIds
            };
            const newData = {
                ...oldTasks,
                tasks: allTasks,
                columns: {
                    ...tasks.columns,
                    [newColumn.id]: newColumn
                }
            };
            return newData;
        });
        setTask("");
    };
    function handleAddAttempt() {
        createTask();
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$be92b6f5f03c0fe9, {
        onOpenChange: handleClose,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$41fb9f06171c75f4, {
                asChild: true,
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                    className: "TaskButton violet",
                    children: $146efb2f8550c44a$var$plusIcon
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$602eac185826482c, {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$c6fdb837b070b4ff, {
                        className: "TaskDialogOverlay"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($d624d4ffa9e1ab8a$export$7c6e2c02157bb7d2, {
                        className: "TaskDialogContent",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$f99233281efd08a0, {
                                className: "TaskDialogTitle",
                                children: "Add Task"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "TaskFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "TaskLabel",
                                        htmlFor: "task",
                                        children: "Task"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                        value: task,
                                        onChange: (e)=>setTask(e.target.value),
                                        className: "TaskInput",
                                        id: "task"
                                    })
                                ]
                            }),
                            !showDatepicker && !showRecurring && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "TaskFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "TaskLabel",
                                        htmlFor: "addDeadline",
                                        children: "+ Deadline"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: "addDeadline",
                                        className: "CheckboxInput",
                                        checked: showDatepicker,
                                        onChange: ()=>setShowDatepicker(!showDatepicker)
                                    })
                                ]
                            }),
                            showDatepicker && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "TaskFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "TaskLabel",
                                        htmlFor: "deadline",
                                        children: "Deadline"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0fb815a476526754$exports))), {
                                        selected: startDate,
                                        onChange: (date)=>setStartDate(date),
                                        showTimeSelect: true,
                                        timeIntervals: 5,
                                        dateFormat: "MMMM d, yyyy h:mm aa",
                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                            style: {
                                                width: "24px",
                                                height: "24px",
                                                backgroundColor: "red"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                        onClick: ()=>setShowDatepicker(false),
                                        className: "CloseButton",
                                        children: $146efb2f8550c44a$var$closeIcon
                                    })
                                ]
                            }),
                            !showRecurring && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "TaskFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "TaskLabel",
                                        htmlFor: "addDeadline",
                                        children: "Recurring?"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: "addDeadline",
                                        className: "CheckboxInput",
                                        checked: showRecurring,
                                        onChange: ()=>{
                                            setShowRecurring(!showRecurring);
                                            setShowDatepicker(false);
                                        }
                                    })
                                ]
                            }),
                            showRecurring && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "TaskFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "TaskLabel",
                                        htmlFor: "intervalType",
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("select", {
                                        value: intervalType,
                                        onChange: (e)=>setIntervalType(e.target.value),
                                        className: "TaskInput",
                                        id: "intervalType",
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("option", {
                                                value: "REGULAR",
                                                children: "Recurring"
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("option", {
                                                value: "CRON",
                                                children: "Cron"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                className: "TaskFieldset",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                        className: "TaskLabel",
                                        htmlFor: "estimatedTime",
                                        children: "Est. Time"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                        type: "text",
                                        value: estimatedTime,
                                        onChange: (e)=>setEstimatedTime(e.target.value),
                                        className: "TaskInput",
                                        id: "estimatedTime",
                                        style: {
                                            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="lucide lucide-m"><text x="0" y="20" font-family="Arial" font-size="20">m</text></svg>')`,
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "right center",
                                            paddingRight: "30px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    marginTop: 25,
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$f39c2d165cd861fe, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                        onClick: handleAddAttempt,
                                        className: "TaskButton green",
                                        children: "Submit"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($d624d4ffa9e1ab8a$export$f39c2d165cd861fe, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                    className: "TaskIconButton",
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c12e32cf04d921d4$export$b7fa469a3cb3cd4f), {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $146efb2f8550c44a$export$2e2bcd8739ae039 = $146efb2f8550c44a$var$TaskDialog;
const $146efb2f8550c44a$var$closeIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-circle-x",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "10"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m15 9-6 6"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m9 9 6 6"
        })
    ]
});
const $146efb2f8550c44a$var$plusIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-circle-plus",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "10"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M8 12h8"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M12 8v8"
        })
    ]
});






const $96b687b93a893eaf$var$Container = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  margin: 8px;
  border: 1px solid rgba(68, 71, 156, 0.718);
  border-radius: 24px;
  max-width: 31%;
  padding: 20px;
  display: inline-block;
  background-color: #1a2246;
`;
// color: #f0f0f0;
const $96b687b93a893eaf$var$TaskList = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  padding: 8px;
`;
const $96b687b93a893eaf$var$AUTH_ENDPOINT = "https://mn28cogtk2.execute-api.us-east-1.amazonaws.com/dev/";
const $96b687b93a893eaf$var$updateProjectList = async (updatedProjects, token)=>{
    const projectsString = updatedProjects.join(",");
    const URL = $96b687b93a893eaf$var$AUTH_ENDPOINT + `project-list?projects=${projectsString}`;
    const HEADERS = {
        "Content-Type": "application/json",
        Authorization: token
    };
    const request = new Request(URL, {
        method: "PUT",
        headers: HEADERS,
        timeout: 100000
    });
    fetch(request);
};
function $96b687b93a893eaf$var$Column({ column: column , columnTasks: columnTasks  }) {
    const [searchTerm, setSearchTerm] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const { tasks: tasks , setTasks: setTasks , projects: projects , setProjects: setProjects  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    const { token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const filteredTasks = columnTasks.filter((task)=>searchTerm.split(" ").every((term)=>task.content.toLowerCase().includes(term.toLowerCase())));
    function deleteColumn(columnId, tasks) {
        const projectToDelete = tasks.columns[columnId].title;
        setTasks((prevTasks)=>{
            const newColumns = {
                ...prevTasks.columns
            };
            delete newColumns[columnId];
            const newColumnOrder = prevTasks.columnOrder.filter((id)=>id !== columnId);
            return {
                ...prevTasks,
                columns: newColumns,
                columnOrder: newColumnOrder
            };
        });
        const updatedProjects = projects.filter((project)=>project !== projectToDelete);
        setProjects(updatedProjects);
        $96b687b93a893eaf$var$updateProjectList(updatedProjects, token);
    }
    function shiftColumnLeft(columnId) {
        var newData = {};
        setTasks((prevTasks)=>{
            const columnIndex = prevTasks.columnOrder.indexOf(columnId);
            const leftColumnId = prevTasks.columnOrder[columnIndex - 1];
            const newLeftColumn = {
                ...prevTasks.columns[columnId],
                id: leftColumnId
            };
            const newRightColumn = {
                ...prevTasks.columns[leftColumnId],
                id: columnId
            };
            const newColumns = {
                ...prevTasks.columns,
                [columnId]: newRightColumn,
                [leftColumnId]: newLeftColumn
            };
            newData = {
                ...prevTasks,
                columns: newColumns
            };
            return newData;
        });
        const updatedProjects = newData.columnOrder.map((columnId)=>{
            return newData.columns[columnId].title;
        });
        setProjects(updatedProjects);
        $96b687b93a893eaf$var$updateProjectList(updatedProjects, token);
    }
    function getMidnightTonightET() {
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        const midnightET = new Date(midnight.toLocaleString("en-US", {
            timeZone: "America/New_York"
        }));
        return midnightET.toISOString();
    }
    const tonightDeadline = getMidnightTonightET();
    const incompleteTaskCount = columnTasks.filter((task)=>task.status !== "COMPLETE").length;
    const allTasksComplete = columnTasks.length > 0 && incompleteTaskCount === 0;
    // Check or uncheck every task in this list at once. If everything is
    // already complete we clear the list, otherwise we complete it.
    function toggleAllTasks() {
        const targetStatus = allTasksComplete ? "INCOMPLETE" : "COMPLETE";
        setTasks((oldTasks)=>{
            const updatedTasks = {
                ...oldTasks.tasks
            };
            column.taskIds.forEach((taskId)=>{
                updatedTasks[taskId] = {
                    ...updatedTasks[taskId],
                    status: targetStatus
                };
            });
            return {
                ...oldTasks,
                tasks: updatedTasks
            };
        });
        column.taskIds.forEach((taskId)=>{
            (0, $f6745ab07405201d$export$e8e0154b7bb02be4)({
                ...tasks.tasks[taskId],
                status: targetStatus
            }, token);
        });
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($96b687b93a893eaf$var$Container, {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($96b687b93a893eaf$var$TitleContainer, {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                        children: [
                            `${column.title} (${incompleteTaskCount})`,
                            (column.title, "")
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                        children: [
                            column.title !== "habits" && columnTasks.length > 0 && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                onClick: toggleAllTasks,
                                title: allTasksComplete ? "Uncheck all items" : "Check all items",
                                children: allTasksComplete ? $96b687b93a893eaf$var$uncheckAllIcon : $96b687b93a893eaf$var$checkAllIcon
                            }),
                            column.id !== "column-1" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                onClick: ()=>shiftColumnLeft(column.id, tasks),
                                children: $96b687b93a893eaf$var$leftIcon
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $146efb2f8550c44a$export$2e2bcd8739ae039), {
                                    project: column.title
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                onClick: ()=>deleteColumn(column.id, tasks),
                                children: $96b687b93a893eaf$var$closeIcon
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($96b687b93a893eaf$var$SearchContainer, {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                    type: "text",
                    value: searchTerm,
                    onChange: (e)=>setSearchTerm(e.target.value),
                    style: {
                        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="lucide lucide-search"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>')`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "left center",
                        paddingLeft: "30px"
                    }
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c19d47723720dd4a$export$423ec2075359570a), {
                droppableId: column.id,
                children: (provided, snapshot)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)($96b687b93a893eaf$var$TaskList, {
                        ref: provided.innerRef,
                        ...provided.droppableProps,
                        children: [
                            filteredTasks.map((task, index)=>{
                                return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d7dad46e028b4719$export$2e2bcd8739ae039), {
                                    task: task,
                                    index: index
                                }, task.id);
                            }),
                            provided.placeholder
                        ]
                    })
            })
        ]
    });
}
var $96b687b93a893eaf$export$2e2bcd8739ae039 = $96b687b93a893eaf$var$Column;
const $96b687b93a893eaf$var$leftIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-circle-arrow-left",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "10"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M16 12H8"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m12 8-4 4 4 4"
        })
    ]
});
const $96b687b93a893eaf$var$closeIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-circle-x",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "10"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m15 9-6 6"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m9 9 6 6"
        })
    ]
});
const $96b687b93a893eaf$var$checkAllIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-list-checks",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m3 17 2 2 4-4"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m3 7 2 2 4-4"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M13 6h8"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M13 12h8"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M13 18h8"
        })
    ]
});
const $96b687b93a893eaf$var$uncheckAllIcon = /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-list-x",
    children: [
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M11 12H3"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M16 6H3"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "M16 18H3"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m19 10-4 4"
        }),
        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
            d: "m15 10 4 4"
        })
    ]
});
const $96b687b93a893eaf$var$TitleContainer = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  font-size: 1.17em;
  font-weight: bold;
  color: #f0f0f0;
`;
const $96b687b93a893eaf$var$SearchContainer = (0, $93948c98236af5c1$export$2e2bcd8739ae039).span`
  margin-left: 10px;
  border: 1px solid black;
  padding: 5px;
`;







const $0b9808a1a8781f02$var$AUTH_ENDPOINT = "https://mn28cogtk2.execute-api.us-east-1.amazonaws.com/dev/";
function $0b9808a1a8781f02$export$2e2bcd8739ae039() {
    const { tasks: tasks , setTasks: setTasks  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $b0893505d0f7ae16$export$58d75f9829cbe158));
    const { token: token  } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useContext((0, $5d80ae41f2d7c184$export$38ee920e59704589));
    const onDragEnd = (result)=>{
        // dropped outside the list
        if (!result.destination) return;
        const { source: source , destination: destination  } = result;
        const start = tasks.columns[source.droppableId];
        const finish = tasks.columns[destination.droppableId];
        const startId = source.droppableId;
        const finishId = destination.droppableId;
        if (startId !== finishId) {
            const newStartTaskIds = Array.from(start.taskIds);
            newStartTaskIds.splice(source.index, 1);
            const newFinishTaskIds = Array.from(finish.taskIds);
            newFinishTaskIds.splice(destination.index, 0, result.draggableId);
            const newStartColumn = {
                ...start,
                taskIds: newStartTaskIds
            };
            const newFinishColumn = {
                ...finish,
                taskIds: newFinishTaskIds
            };
            const newData = {
                ...tasks,
                columns: {
                    ...tasks.columns,
                    [newStartColumn.id]: newStartColumn,
                    [newFinishColumn.id]: newFinishColumn
                },
                tasks: {
                    ...tasks.tasks,
                    [result.draggableId]: {
                        ...tasks.tasks[result.draggableId],
                        project: newFinishColumn.title
                    }
                }
            };
            const startProject = newStartColumn.title;
            const finishProject = newFinishColumn.title;
            (0, $f6745ab07405201d$export$53e589c0d6eae463)(startProject, newStartTaskIds, token);
            (0, $f6745ab07405201d$export$53e589c0d6eae463)(finishProject, newFinishTaskIds, token);
            setTasks(newData);
            return;
        }
        // if (startId !== finishId) {
        //   const newStartTaskIds = Array.from(start.taskIds);
        //   newStartTaskIds.splice(source.index, 1);
        //   const newFinishTaskIds = Array.from(finish.taskIds);
        //   newFinishTaskIds.splice(destination.index, 0, result.draggableId);
        //   const newStartColumn = {
        //     ...start,
        //     taskIds: newStartTaskIds,
        //   };
        //   const newFinishColumn = {
        //     ...finish,
        //     taskIds: newFinishTaskIds,
        //   };
        //   const newData = {
        //     ...tasks,
        //     columns: {
        //       ...tasks.columns,
        //       [newStartColumn.id]: newStartColumn,
        //       [newFinishColumn.id]: newFinishColumn,
        //     },
        //   };
        //   const startProject = newStartColumn.title;
        //   const finishProject = newFinishColumn.title;
        //   updateOrder(startProject, newStartTaskIds, token);
        //   updateOrder(finishProject, newFinishTaskIds, token);
        //   setTasks(newData);
        //   return;
        //   // newStartTaskIds.splice(destination.index, 0, result.draggableId);
        // }
        if (startId === finishId) {
            const newTaskIds = Array.from(start.taskIds);
            newTaskIds.splice(source.index, 1);
            newTaskIds.splice(destination.index, 0, result.draggableId);
            const newTaskTexts = newTaskIds.map((id)=>{
                return `${id}: ${tasks.tasks[id].content}`;
            });
            const newColumn = {
                ...start,
                taskIds: newTaskIds
            };
            const newData = {
                ...tasks,
                columns: {
                    ...tasks.columns,
                    [newColumn.id]: newColumn
                }
            };
            const project = newColumn.title;
            (0, $f6745ab07405201d$export$53e589c0d6eae463)(project, newTaskIds, token);
            setTasks(newData);
            return;
        }
    };
    // const data = tasks.sort((a, b) => a.order - b.order);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c19d47723720dd4a$export$237bd83162c14364), {
        // onDragStart={}
        // onDragUpdate={}
        onDragEnd: onDragEnd,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
            style: {
                display: "flex",
                alignItems: "flex-start"
            },
            children: tasks.columnOrder.map((columnId)=>{
                const column = tasks.columns[columnId];
                const columnTasks = column.taskIds.map((taskId)=>{
                    return tasks.tasks[taskId];
                });
                return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $96b687b93a893eaf$export$2e2bcd8739ae039), {
                    column: column,
                    columnTasks: columnTasks
                }, column.id);
            })
        })
    });
}





parcelRequire("exYeM");

function $3b34cb2da5c70dab$var$Wrapper({ children: children  }) {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($3b34cb2da5c70dab$var$Div, {
        children: children
    });
}
var $3b34cb2da5c70dab$export$2e2bcd8739ae039 = $3b34cb2da5c70dab$var$Wrapper;
const $3b34cb2da5c70dab$var$Div = (0, $93948c98236af5c1$export$2e2bcd8739ae039).div``;





const $adee9df12d2c2787$var$GlobalStyle = (0, $93948c98236af5c1$export$f0f03736edb61697)`
  body {
    font-family: 'Poppins', sans-serif;
  }
`;
function $adee9df12d2c2787$var$App() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5d80ae41f2d7c184$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $b0893505d0f7ae16$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($adee9df12d2c2787$var$GlobalStyle, {}),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: "wrapper",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $3b34cb2da5c70dab$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $89e428441ac6e5f2$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $0b9808a1a8781f02$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            ]
        })
    });
}
var $adee9df12d2c2787$export$2e2bcd8739ae039 = $adee9df12d2c2787$var$App;






const $b8f9b7833fa37166$var$root = (0, $7bd215913159ea08$export$882461b6382ed46c)(document.querySelector("#root"));
$b8f9b7833fa37166$var$root.render(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adee9df12d2c2787$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.a264f03e.js.map
